(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree41b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree41b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1IdZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("89wqa"));

});
parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
'use strict';

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $dd934af551f44020$export$3ba232387fd5d6dd, (v) => $dd934af551f44020$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$3ba232387fd5d6dd;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
'use strict';
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
function $dd934af551f44020$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$3ba232387fd5d6dd = $dd934af551f44020$var$X;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = $dd934af551f44020$var$X;
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("6T1J1", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $503937b663c395c4$export$882461b6382ed46c, (v) => $503937b663c395c4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $503937b663c395c4$export$757ceba2d55c277e, (v) => $503937b663c395c4$export$757ceba2d55c277e = v);
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
'use strict';

var $2pmb0 = parcelRequire("2pmb0");
var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $2pmb0.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $2pmb0.hydrateRoot;

});
parcelRegister("2pmb0", function(module, exports) {
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("23wBm"));

});
parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
'use strict';

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$Lg(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$Lg(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$Sg(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Ug = $17f526922e4a857c$var$Og(!0), $17f526922e4a857c$var$Vg = $17f526922e4a857c$var$Og(!1), $17f526922e4a857c$var$Wg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Xg = null, $17f526922e4a857c$var$Yg = null, $17f526922e4a857c$var$Zg = null;
function $17f526922e4a857c$var$$g() {
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Xg = null;
}
function $17f526922e4a857c$var$ah(a) {
    var b = $17f526922e4a857c$var$Wg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$ch(a, b) {
    $17f526922e4a857c$var$Xg = a;
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$dh = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$eh(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Yg) {
            if (null === $17f526922e4a857c$var$Xg) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Yg = a;
            $17f526922e4a857c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Yg.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$fh = null;
function $17f526922e4a857c$var$gh(a) {
    null === $17f526922e4a857c$var$fh ? $17f526922e4a857c$var$fh = [
        a
    ] : $17f526922e4a857c$var$fh.push(a);
}
function $17f526922e4a857c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$ih(a, d);
}
function $17f526922e4a857c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$jh = !1;
function $17f526922e4a857c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$ih(a, c);
}
function $17f526922e4a857c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$th = {}, $17f526922e4a857c$var$uh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$vh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$wh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th);
function $17f526922e4a857c$var$xh(a) {
    if (a === $17f526922e4a857c$var$th) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$yh(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$wh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, $17f526922e4a857c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, b);
}
function $17f526922e4a857c$var$zh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$vh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$wh);
}
function $17f526922e4a857c$var$Ah(a) {
    $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
    var b = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, c));
}
function $17f526922e4a857c$var$Bh(a) {
    $17f526922e4a857c$var$vh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$uh), $17f526922e4a857c$var$E($17f526922e4a857c$var$vh));
}
var $17f526922e4a857c$var$L = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Dh = [];
function $17f526922e4a857c$var$Eh() {
    for(var a = 0; a < $17f526922e4a857c$var$Dh.length; a++)$17f526922e4a857c$var$Dh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Dh.length = 0;
}
var $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Hh = 0, $17f526922e4a857c$var$M = null, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$Ih = !1, $17f526922e4a857c$var$Jh = !1, $17f526922e4a857c$var$Kh = 0, $17f526922e4a857c$var$Lh = 0;
function $17f526922e4a857c$var$P() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Nh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Hh = f;
    $17f526922e4a857c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Fh.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Oh : $17f526922e4a857c$var$Ph;
    a = c(d, e);
    if ($17f526922e4a857c$var$Jh) {
        f = 0;
        do {
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Qh;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Jh);
    }
    $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
    b = null !== $17f526922e4a857c$var$N && null !== $17f526922e4a857c$var$N.next;
    $17f526922e4a857c$var$Hh = 0;
    $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
    $17f526922e4a857c$var$Ih = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$Sh() {
    var a = 0 !== $17f526922e4a857c$var$Kh;
    $17f526922e4a857c$var$Kh = 0;
    return a;
}
function $17f526922e4a857c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Uh() {
    if (null === $17f526922e4a857c$var$N) {
        var a = $17f526922e4a857c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$N.next;
    var b = null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState : $17f526922e4a857c$var$O.next;
    if (null !== b) $17f526922e4a857c$var$O = b, $17f526922e4a857c$var$N = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$N = a;
        a = {
            memoizedState: $17f526922e4a857c$var$N.memoizedState,
            baseState: $17f526922e4a857c$var$N.baseState,
            baseQueue: $17f526922e4a857c$var$N.baseQueue,
            queue: $17f526922e4a857c$var$N.queue,
            next: null
        };
        null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    }
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$Wh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$M.lanes |= m;
                $17f526922e4a857c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$M.lanes |= f, $17f526922e4a857c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$Xh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$Yh() {}
function $17f526922e4a857c$var$Zh(a, b) {
    var c = $17f526922e4a857c$var$M, d = $17f526922e4a857c$var$Uh(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$dh = !0);
    d = d.queue;
    $17f526922e4a857c$var$$h($17f526922e4a857c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$O && $17f526922e4a857c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
}
function $17f526922e4a857c$var$ai(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
    });
}
function $17f526922e4a857c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$ih(a, 1);
    null !== b && $17f526922e4a857c$var$gi(b, a, 1, -1);
}
function $17f526922e4a857c$var$hi(a) {
    var b = $17f526922e4a857c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ii.bind(null, $17f526922e4a857c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$ji() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$ki(a, b, c, d) {
    var e = $17f526922e4a857c$var$Th();
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    var e = $17f526922e4a857c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$N) {
        var g = $17f526922e4a857c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Mh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$bi(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, f, d);
}
function $17f526922e4a857c$var$mi(a, b) {
    return $17f526922e4a857c$var$ki(8390656, 8, a, b);
}
function $17f526922e4a857c$var$$h(a, b) {
    return $17f526922e4a857c$var$li(2048, 8, a, b);
}
function $17f526922e4a857c$var$ni(a, b) {
    return $17f526922e4a857c$var$li(4, 2, a, b);
}
function $17f526922e4a857c$var$oi(a, b) {
    return $17f526922e4a857c$var$li(4, 4, a, b);
}
function $17f526922e4a857c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$li(4, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$ri() {}
function $17f526922e4a857c$var$si(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ti(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ui(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$dh = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$M.lanes |= c, $17f526922e4a857c$var$rh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$vi(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Gh.transition;
    $17f526922e4a857c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Gh.transition = d;
    }
}
function $17f526922e4a857c$var$wi() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$xi(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, c);
    else if (c = $17f526922e4a857c$var$hh(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$R();
        $17f526922e4a857c$var$gi(c, a, d, e);
        $17f526922e4a857c$var$Bi(c, b, d);
    }
}
function $17f526922e4a857c$var$ii(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$hh(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$R(), $17f526922e4a857c$var$gi(c, a, d, e), $17f526922e4a857c$var$Bi(c, b, d));
    }
}
function $17f526922e4a857c$var$zi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$M || null !== b && b === $17f526922e4a857c$var$M;
}
function $17f526922e4a857c$var$Ai(a, b) {
    $17f526922e4a857c$var$Jh = $17f526922e4a857c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$Rh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$P,
    useContext: $17f526922e4a857c$var$P,
    useEffect: $17f526922e4a857c$var$P,
    useImperativeHandle: $17f526922e4a857c$var$P,
    useInsertionEffect: $17f526922e4a857c$var$P,
    useLayoutEffect: $17f526922e4a857c$var$P,
    useMemo: $17f526922e4a857c$var$P,
    useReducer: $17f526922e4a857c$var$P,
    useRef: $17f526922e4a857c$var$P,
    useState: $17f526922e4a857c$var$P,
    useDebugValue: $17f526922e4a857c$var$P,
    useDeferredValue: $17f526922e4a857c$var$P,
    useTransition: $17f526922e4a857c$var$P,
    useMutableSource: $17f526922e4a857c$var$P,
    useSyncExternalStore: $17f526922e4a857c$var$P,
    useId: $17f526922e4a857c$var$P,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Oh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ki(4194308, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$xi.bind(null, $17f526922e4a857c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$hi,
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$hi(!1), b = a[0];
        a = $17f526922e4a857c$var$vi.bind(null, a[1]);
        $17f526922e4a857c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$M, e = $17f526922e4a857c$var$Th();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$mi($17f526922e4a857c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$Th(), b = $17f526922e4a857c$var$Q.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Ph = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Wh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Qh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Xh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return null === $17f526922e4a857c$var$N ? b.memoizedState = a : $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $17f526922e4a857c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$R(), d = $17f526922e4a857c$var$yi(a), e = $17f526922e4a857c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$nh(a, e, d);
        null !== b && ($17f526922e4a857c$var$gi(b, a, d, c), $17f526922e4a857c$var$oh(b, a, d));
    }
};
function $17f526922e4a857c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$eh(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $17f526922e4a857c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$eh(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$Ei.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Ni(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Oi || ($17f526922e4a857c$var$Oi = !0, $17f526922e4a857c$var$Pi = d);
        $17f526922e4a857c$var$Li(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Qi(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Li(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Ri ? $17f526922e4a857c$var$Ri = new Set([
            this
        ]) : $17f526922e4a857c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$mh(-1, 1), b.tag = 2, $17f526922e4a857c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Wi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$dh = !1;
function $17f526922e4a857c$var$Xi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Vg(b, null, c, d) : $17f526922e4a857c$var$Ug(b, a.child, c, d);
}
function $17f526922e4a857c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$ch(b, e);
    d = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$bj(a, b, f, d, e);
        a = $17f526922e4a857c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$dh = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$Zi(a, b, e);
        }
    }
    return $17f526922e4a857c$var$cj(a, b, c, d, e);
}
function $17f526922e4a857c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj);
            $17f526922e4a857c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= d;
    $17f526922e4a857c$var$Xi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$ch(b, e);
    c = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$ch(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$ij(a, b), $17f526922e4a857c$var$Gi(b, c, d), $17f526922e4a857c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$eh(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$Hi(b, g, d, l);
        $17f526922e4a857c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof m && ($17f526922e4a857c$var$Di(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$eh(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$Hi(b, g, d, k);
        $17f526922e4a857c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof y && ($17f526922e4a857c$var$Di(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$jj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$jj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$Zi(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Ug(b, a.child, null, f), b.child = $17f526922e4a857c$var$Ug(b, null, h, f)) : $17f526922e4a857c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$yh(a, b.containerInfo);
}
function $17f526922e4a857c$var$lj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Xi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$pj(g, d, 0, null), a = $17f526922e4a857c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$nj(c), b.memoizedState = $17f526922e4a857c$var$mj, a) : $17f526922e4a857c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$Pg(h, f) : (f = $17f526922e4a857c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$qj(a, b) {
    b = $17f526922e4a857c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$sj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Ug(b, a.child, null, c);
    a = $17f526922e4a857c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$nj(g);
        b.memoizedState = $17f526922e4a857c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Ki(f, d, void 0);
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$dh || h) {
        d = $17f526922e4a857c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$ih(a, e), $17f526922e4a857c$var$gi(d, a, e, -1));
        }
        $17f526922e4a857c$var$tj();
        d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$bh(a.return, b, c);
}
function $17f526922e4a857c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Xi(a, b, d.children, c);
    d = $17f526922e4a857c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$vj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$kj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Ah(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$oj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
                a = $17f526922e4a857c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$dj(a, b, c);
    }
    return $17f526922e4a857c$var$Zi(a, b, c);
}
var $17f526922e4a857c$var$zj, $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj;
$17f526922e4a857c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Aj = function() {};
$17f526922e4a857c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Dj(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$zh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Aj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Bh(b);
            var e = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
                $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$L.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$Aj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Dj(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Gj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$L.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$fj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Ij(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Bh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$L), null;
        case 4:
            return $17f526922e4a857c$var$zh(), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Jj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Nj = !1;
function $17f526922e4a857c$var$Oj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Nj;
    $17f526922e4a857c$var$Nj = !1;
    return n;
}
function $17f526922e4a857c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Vj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Vj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Xj = !1;
function $17f526922e4a857c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$Zj(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$Zj(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Lj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Xj = !0;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Mj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Yj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Yj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Yj(a, b, c);
    }
}
function $17f526922e4a857c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Kj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Xj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$Zj(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$dk(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Pj(3, a, a.return), $17f526922e4a857c$var$Qj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Pj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            break;
        case 13:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$fk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$ek(a);
    }
}
function $17f526922e4a857c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$hk(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$ik(a, b, c);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Jj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Jj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$jk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$jk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$ik(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Jj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$kk(a, b, c);
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Rj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$gk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$jk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Qj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$lk = Math.ceil, $17f526922e4a857c$var$mk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$fj = 0, $17f526922e4a857c$var$ej = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$pk = null, $17f526922e4a857c$var$rh = 0, $17f526922e4a857c$var$qk = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = null, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$fk = 0, $17f526922e4a857c$var$Gj = Infinity, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Oi = !1, $17f526922e4a857c$var$Pi = null, $17f526922e4a857c$var$Ri = null, $17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = null, $17f526922e4a857c$var$xk = 0, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, $17f526922e4a857c$var$Ak = -1, $17f526922e4a857c$var$Bk = 0;
function $17f526922e4a857c$var$R() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$Ak : $17f526922e4a857c$var$Ak = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Bk && ($17f526922e4a857c$var$Bk = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Bk;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$gi(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$yk) throw $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$Q) a === $17f526922e4a857c$var$Q && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$qk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Ck(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Dk(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Dk(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Ek.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Ek.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Fk(c, $17f526922e4a857c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Gk(a, b) {
    $17f526922e4a857c$var$Ak = -1;
    $17f526922e4a857c$var$Bk = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Hk() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Ik(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Jk();
        if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Kk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Lk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Mk(a, h);
        }
        $17f526922e4a857c$var$$g();
        $17f526922e4a857c$var$mk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Nk(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Ok(e) && (b = $17f526922e4a857c$var$Ik(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Nk(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$fk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Gk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Nk(a, b) {
    var c = $17f526922e4a857c$var$sk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Kk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Ik(a, b);
    2 !== a && (b = $17f526922e4a857c$var$tk, $17f526922e4a857c$var$tk = c, null !== b && $17f526922e4a857c$var$Fj(b));
    return a;
}
function $17f526922e4a857c$var$Fj(a) {
    null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = a : $17f526922e4a857c$var$tk.push.apply($17f526922e4a857c$var$tk, a);
}
function $17f526922e4a857c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Ck(a, b) {
    b &= ~$17f526922e4a857c$var$rk;
    b &= ~$17f526922e4a857c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Ek(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Nk(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, b), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Qk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Rk(a) {
    null !== $17f526922e4a857c$var$wk && 0 === $17f526922e4a857c$var$wk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$ok.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$ok.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Hj() {
    $17f526922e4a857c$var$fj = $17f526922e4a857c$var$ej.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$ej);
}
function $17f526922e4a857c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$zh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Eh();
                break;
            case 5:
                $17f526922e4a857c$var$Bh(d);
                break;
            case 4:
                $17f526922e4a857c$var$zh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 10:
                $17f526922e4a857c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Hj();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$Q = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$Pg(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$fj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$pk = null;
    $17f526922e4a857c$var$rk = $17f526922e4a857c$var$qk = $17f526922e4a857c$var$rh = 0;
    $17f526922e4a857c$var$tk = $17f526922e4a857c$var$sk = null;
    if (null !== $17f526922e4a857c$var$fh) {
        for(b = 0; b < $17f526922e4a857c$var$fh.length; b++)if (c = $17f526922e4a857c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$fh = null;
    }
    return a;
}
function $17f526922e4a857c$var$Mk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$$g();
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
            if ($17f526922e4a857c$var$Ih) {
                for(var d = $17f526922e4a857c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Ih = !1;
            }
            $17f526922e4a857c$var$Hh = 0;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            $17f526922e4a857c$var$nk.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$pk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Si(f, l, b);
                            $17f526922e4a857c$var$tj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Vi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ji(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$sk ? $17f526922e4a857c$var$sk = [
                    f
                ] : $17f526922e4a857c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Ni(f, k, b);
                            $17f526922e4a857c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Qi(f, h, b);
                                $17f526922e4a857c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Sk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Jk() {
    var a = $17f526922e4a857c$var$mk.current;
    $17f526922e4a857c$var$mk.current = $17f526922e4a857c$var$Rh;
    return null === a ? $17f526922e4a857c$var$Rh : a;
}
function $17f526922e4a857c$var$tj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$Q || 0 === ($17f526922e4a857c$var$rh & 268435455) && 0 === ($17f526922e4a857c$var$qk & 268435455) || $17f526922e4a857c$var$Ck($17f526922e4a857c$var$Q, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Ik(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Jk();
    if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Kk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Tk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Mk(a, e);
    }
    $17f526922e4a857c$var$$g();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$mk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$Q = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Tk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Lk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Uk(a) {
    var b = $17f526922e4a857c$var$Vk(a.alternate, a, $17f526922e4a857c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Sk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$nk.current = null;
}
function $17f526922e4a857c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Ej(c, b, $17f526922e4a857c$var$fj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Pk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$ok.transition;
    try {
        $17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Wk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$ok.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Wk(a, b, c, d) {
    do $17f526922e4a857c$var$Hk();
    while (null !== $17f526922e4a857c$var$wk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$Q && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$vk || ($17f526922e4a857c$var$vk = !0, $17f526922e4a857c$var$Fk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$ok.transition;
        $17f526922e4a857c$var$ok.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$nk.current = null;
        $17f526922e4a857c$var$Oj(a, c);
        $17f526922e4a857c$var$dk(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$hk(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$ok.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$vk && ($17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = a, $17f526922e4a857c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Ri = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Oi) throw $17f526922e4a857c$var$Oi = !1, a = $17f526922e4a857c$var$Pi, $17f526922e4a857c$var$Pi = null, a;
    0 !== ($17f526922e4a857c$var$xk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$zk ? $17f526922e4a857c$var$yk++ : ($17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = a) : $17f526922e4a857c$var$yk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Hk() {
    if (null !== $17f526922e4a857c$var$wk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$xk), b = $17f526922e4a857c$var$ok.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$ok.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$wk) var d = !1;
            else {
                a = $17f526922e4a857c$var$wk;
                $17f526922e4a857c$var$wk = null;
                $17f526922e4a857c$var$xk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Sj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$ok.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Xk(a, b, c) {
    b = $17f526922e4a857c$var$Ji(c, b);
    b = $17f526922e4a857c$var$Ni(a, b, 1);
    a = $17f526922e4a857c$var$nh(a, b, 1);
    b = $17f526922e4a857c$var$R();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Dk(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(d))) {
                a = $17f526922e4a857c$var$Ji(c, a);
                a = $17f526922e4a857c$var$Qi(b, a, 1);
                b = $17f526922e4a857c$var$nh(b, a, 1);
                a = $17f526922e4a857c$var$R();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$Q === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$fk ? $17f526922e4a857c$var$Kk(a, 0) : $17f526922e4a857c$var$rk |= c);
    $17f526922e4a857c$var$Dk(a, b);
}
function $17f526922e4a857c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$R();
    a = $17f526922e4a857c$var$ih(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Dk(a, c));
}
function $17f526922e4a857c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Yk(a, c);
}
function $17f526922e4a857c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Yk(a, c);
}
var $17f526922e4a857c$var$Vk;
$17f526922e4a857c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$yj(a, b, c);
            $17f526922e4a857c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$ij(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$ch(b, c);
            e = $17f526922e4a857c$var$Nh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$kh(b), e.updater = $17f526922e4a857c$var$Ei, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$Ii(b, d, a, c), b = $17f526922e4a857c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$Zk(d);
                a = $17f526922e4a857c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$$i(null, b, d, $17f526922e4a857c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$kj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$lh(a, b);
                $17f526922e4a857c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$Zi(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Ah(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$gj(a, b), $17f526922e4a857c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$oj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Ug(b, null, d, c) : $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$Yi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$ch(b, c), e = $17f526922e4a857c$var$eh(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Ci(d, b.pendingProps), e = $17f526922e4a857c$var$Ci(d.type, e), $17f526922e4a857c$var$$i(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$ij(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$ch(b, c), $17f526922e4a857c$var$Gi(b, d, e), $17f526922e4a857c$var$Ii(b, d, e, c), $17f526922e4a857c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$xj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$dj(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Fk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$$k(a, b, c, d);
}
function $17f526922e4a857c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$Zk(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Tg(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Tg(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$pj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$Qg(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$kh(f);
    return a;
}
function $17f526922e4a857c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$dl(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$dl(null);
    c = a.current;
    d = $17f526922e4a857c$var$R();
    e = $17f526922e4a857c$var$yi(c);
    f = $17f526922e4a857c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$nh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Dk(a, d);
    return a;
}
function $17f526922e4a857c$var$fl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$R(), g = $17f526922e4a857c$var$yi(e);
    c = $17f526922e4a857c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$nh(e, b, g);
    null !== a && ($17f526922e4a857c$var$gi(a, e, g, f), $17f526922e4a857c$var$oh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    $17f526922e4a857c$var$hl(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$hl(a, b);
}
function $17f526922e4a857c$var$jl() {
    return null;
}
var $17f526922e4a857c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ll(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.render = $17f526922e4a857c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$fl(a, b, null, null);
};
$17f526922e4a857c$var$ml.prototype.unmount = $17f526922e4a857c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Rk(function() {
            $17f526922e4a857c$var$fl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$pl() {}
function $17f526922e4a857c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$gl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$el(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$pl);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$gl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$bl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$pl);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$fl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$gl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$fl(b, g, a, e);
    } else g = $17f526922e4a857c$var$ql(c, b, a, e, d);
    return $17f526922e4a857c$var$gl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Dk(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Rk(function() {
                var b = $17f526922e4a857c$var$ih(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$R();
                    $17f526922e4a857c$var$gi(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$il(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$il(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$yi(a), c = $17f526922e4a857c$var$ih(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(c, a, b, d);
        }
        $17f526922e4a857c$var$il(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Rk;
var $17f526922e4a857c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Qk
    ]
}, $17f526922e4a857c$var$tl = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$ul = {
    bundleType: $17f526922e4a857c$var$tl.bundleType,
    version: $17f526922e4a857c$var$tl.version,
    rendererPackageName: $17f526922e4a857c$var$tl.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$tl.findFiberByHostInstance || $17f526922e4a857c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$vl.isDisabled && $17f526922e4a857c$var$vl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$vl.inject($17f526922e4a857c$var$ul), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$vl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$sl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$nl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$cl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ll(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Rk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$ol(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$rl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
'use strict';
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});





parcelRegister("1C3B7", function(module, exports) {

$parcel$export(module.exports, "default", () => $12cc217fca0e390d$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $6VHgs = parcelRequire("6VHgs");

var $55x1G = parcelRequire("55x1G");

var $22IaK = parcelRequire("22IaK");

var $aJP2U = parcelRequire("aJP2U");

var $5iyJu = parcelRequire("5iyJu");

var $il24A = parcelRequire("il24A");

var $9X7vN = parcelRequire("9X7vN");

var $f8Sxl = parcelRequire("f8Sxl");

var $hXnYU = parcelRequire("hXnYU");

var $eSSxd = parcelRequire("eSSxd");

var $dIr4T = parcelRequire("dIr4T");

var $7FxWL = parcelRequire("7FxWL");

var $kQJD6 = parcelRequire("kQJD6");
function $12cc217fca0e390d$export$2e2bcd8739ae039(props) {
    const [key, setKey] = (0, $8NFma.useState)(0);
    const reloadApp = ()=>setKey((key)=>key + 1);
    const { ref: ref, isVisible: isVisible } = (0, $9X7vN.useVisibility)();
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "trial",
        ref: ref,
        children: isVisible && /*#__PURE__*/ (0, $1IdZj.jsx)($12cc217fca0e390d$var$Trial, {
            ...props,
            reloadApp: reloadApp
        }, key)
    });
}
function $12cc217fca0e390d$var$Trial({ dataUrl: dataUrl, isMobile: isMobile, onStatusChange: onStatusChange = ()=>{}, reloadApp: reloadApp, setSceneData: setSceneData = ()=>{} }) {
    const { setError: setError, errorMessage: errorMessage } = (0, $55x1G.useError)(getLabel);
    const { data: data, loading: loading } = (0, $6VHgs.useData)(dataUrl, setError);
    const { getRecaptchaToken: getRecaptchaToken } = (0, $5iyJu.useRecaptcha)(data?.recaptchaSiteKey);
    const { region: region } = (0, $aJP2U.useLocation)(data?.apiRoutes.region);
    const { hasExistingTrial: hasExistingTrial, forgetTrialSystem: forgetTrialSystem, rememberTrialSystem: rememberTrialSystem } = (0, $22IaK.useExistingTrial)();
    const { clearTrialState: clearTrialState, onCompleteCustomization: onCompleteCustomization, onRegistrationFormSubmit: onRegistrationFormSubmit, resendActivationEmail: resendActivationEmail, trialActivationCode: trialActivationCode, trialEmailAddress: trialEmailAddress, trialLoading: trialLoading, trialSystemId: trialSystemId } = (0, $il24A.useTrial)({
        data: data,
        getLabel: getLabel,
        getRecaptchaToken: getRecaptchaToken,
        isMobile: isMobile,
        onStatusChange: onStatusChange,
        rememberTrialSystem: rememberTrialSystem
    });
    const reload = ()=>{
        clearTrialState();
        reloadApp();
    };
    function getLabel(key) {
        return data?.labels[key] || '';
    }
    if (loading) return null;
    if (errorMessage) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $hXnYU.default), {
        data: data,
        getLabel: getLabel,
        message: errorMessage,
        reload: reload,
        setSceneData: setSceneData
    });
    if (trialLoading) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dIr4T.default), {
        data: data,
        getLabel: getLabel,
        predictedLoadTime: data.predictedLoadTime
    });
    if (hasExistingTrial && data.apiRoutes.appLogin) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eSSxd.default), {
        apiRoutes: data.apiRoutes,
        forgetTrialSystem: forgetTrialSystem,
        getLabel: getLabel,
        reload: reload
    });
    if (!trialSystemId) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7FxWL.default), {
        data: data,
        getLabel: getLabel,
        getRecaptchaToken: getRecaptchaToken,
        isMobile: isMobile,
        onFormSubmit: onRegistrationFormSubmit,
        region: region,
        setError: setError,
        setSceneData: setSceneData
    });
    if (!trialActivationCode) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kQJD6.default), {
        data: data,
        emailAddress: trialEmailAddress,
        getLabel: getLabel,
        isMobile: isMobile,
        reload: reload,
        resendActivationEmail: resendActivationEmail,
        setSceneData: setSceneData
    });
    else return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $f8Sxl.default), {
        data: data,
        getLabel: getLabel,
        onCompleteCustomization: onCompleteCustomization,
        setSceneData: setSceneData
    });
}
$12cc217fca0e390d$var$Trial.propTypes = {
    dataUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    isMobile: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired,
    onStatusChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    reloadApp: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    setSceneData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func
};

});
parcelRegister("fb0st", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6DzO8"))();

});
parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d840288929500773$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});



parcelRegister("6VHgs", function(module, exports) {

$parcel$export(module.exports, "useData", () => $50b9a05bd2cd96f1$export$c1cf1cf4c5d51937);
parcelRequire("1zKtH");
var $81tj9 = parcelRequire("81tj9");

var $8NFma = parcelRequire("8NFma");
const $50b9a05bd2cd96f1$export$c1cf1cf4c5d51937 = (url, setError)=>{
    const [data, setData] = (0, $8NFma.useState)(null);
    const [loading, setLoading] = (0, $8NFma.useState)(true);
    (0, $8NFma.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const response = await (0, $81tj9.default).get(url);
                setData(response.data);
            } catch (err) {
                console.error('Error fetching app data:', err);
                // TODO: Make sure to handle the error without accessing properties of undefined
                setError('loading_app_data');
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    return {
        data: data,
        loading: loading
    };
};

});
parcelRegister("1zKtH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Axios", () => $125d1ceb57662f9a$export$1c00760e9e5a4e95);
$parcel$export(module.exports, "AxiosError", () => $125d1ceb57662f9a$export$c1fbed17c2f6a328);
$parcel$export(module.exports, "CanceledError", () => $125d1ceb57662f9a$export$1ab0c6b20d94fa14);
$parcel$export(module.exports, "isCancel", () => $125d1ceb57662f9a$export$3b22524397b493c6);
$parcel$export(module.exports, "CancelToken", () => $125d1ceb57662f9a$export$fd08e3cb425f0d61);
$parcel$export(module.exports, "VERSION", () => $125d1ceb57662f9a$export$a4ad2735b021c132);
$parcel$export(module.exports, "all", () => $125d1ceb57662f9a$export$84bf76cd7afc7469);
$parcel$export(module.exports, "Cancel", () => $125d1ceb57662f9a$export$848c9b7ead0df967);
$parcel$export(module.exports, "isAxiosError", () => $125d1ceb57662f9a$export$fbafdbe06a5b5a9a);
$parcel$export(module.exports, "spread", () => $125d1ceb57662f9a$export$3ae0fd4797ed47c8);
$parcel$export(module.exports, "toFormData", () => $125d1ceb57662f9a$export$10ae0d317ea97f8b);
$parcel$export(module.exports, "AxiosHeaders", () => $125d1ceb57662f9a$export$4e7d6ff0f3e6520);
$parcel$export(module.exports, "HttpStatusCode", () => $125d1ceb57662f9a$export$a972f69c851492b3);
$parcel$export(module.exports, "formToJSON", () => $125d1ceb57662f9a$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "getAdapter", () => $125d1ceb57662f9a$export$17ddc20a97d669e2);
$parcel$export(module.exports, "mergeConfig", () => $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a);
$parcel$export(module.exports, "default", () => (parcelRequire("81tj9")).default);

var $81tj9 = parcelRequire("81tj9");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $81tj9.default);

});
parcelRegister("81tj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $2PhsF = parcelRequire("2PhsF");

var $juuss = parcelRequire("juuss");

var $htyv1 = parcelRequire("htyv1");

var $8yOyy = parcelRequire("8yOyy");

var $4iFhx = parcelRequire("4iFhx");

var $lCgfr = parcelRequire("lCgfr");

var $6yYtd = parcelRequire("6yYtd");

var $lISaw = parcelRequire("lISaw");

var $6wIUo = parcelRequire("6wIUo");

var $albzn = parcelRequire("albzn");

var $1YbHN = parcelRequire("1YbHN");

var $7hTsj = parcelRequire("7hTsj");

var $ik8Aj = parcelRequire("ik8Aj");

var $kq2bQ = parcelRequire("kq2bQ");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $hBrVA.default)(defaultConfig);
    const instance = (0, $cG9HX.default)((0, $hBrVA.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $eFc3n.default).extend(instance, (0, $hBrVA.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $eFc3n.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $2PhsF.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $juuss.default));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $hBrVA.default);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $8yOyy.default);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $4iFhx.default);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $lCgfr.default);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $6yYtd.VERSION);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $lISaw.default);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $6wIUo.default);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $albzn.default);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $1YbHN.default);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $2PhsF.default);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $7hTsj.default);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $htyv1.default)((0, $eFc3n.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $ik8Aj.default).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $kq2bQ.default);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $aace3e920a0f1e4d$export$2e2bcd8739ae039);

var $cG9HX = parcelRequire("cG9HX");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const { iterator: $aace3e920a0f1e4d$var$iterator, toStringTag: $aace3e920a0f1e4d$var$toStringTag } = Symbol;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== 'object') return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($aace3e920a0f1e4d$var$toStringTag in val) && !($aace3e920a0f1e4d$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest('URLSearchParams');
const [$aace3e920a0f1e4d$var$isReadableStream, $aace3e920a0f1e4d$var$isRequest, $aace3e920a0f1e4d$var$isResponse, $aace3e920a0f1e4d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($aace3e920a0f1e4d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $cG9HX.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$aace3e920a0f1e4d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest('HTMLFormElement');
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest('RegExp');
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[$aace3e920a0f1e4d$var$toStringTag] === 'FormData' && thing[$aace3e920a0f1e4d$var$iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest('AsyncFunction');
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $aace3e920a0f1e4d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $aace3e920a0f1e4d$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $aace3e920a0f1e4d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $aace3e920a0f1e4d$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $aace3e920a0f1e4d$var$isFunction($aace3e920a0f1e4d$var$_global.postMessage));
const $aace3e920a0f1e4d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($aace3e920a0f1e4d$var$_global) : $aace3e920a0f1e4d$var$_setImmediate;
// *********************
const $aace3e920a0f1e4d$var$isIterable = (thing)=>thing != null && $aace3e920a0f1e4d$var$isFunction(thing[$aace3e920a0f1e4d$var$iterator]);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isReadableStream: $aace3e920a0f1e4d$var$isReadableStream,
    isRequest: $aace3e920a0f1e4d$var$isRequest,
    isResponse: $aace3e920a0f1e4d$var$isResponse,
    isHeaders: $aace3e920a0f1e4d$var$isHeaders,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable,
    setImmediate: $aace3e920a0f1e4d$var$_setImmediate,
    asap: $aace3e920a0f1e4d$var$asap,
    isIterable: $aace3e920a0f1e4d$var$isIterable
};

});
parcelRegister("cG9HX", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b0f01b05e2607a$export$2e2bcd8739ae039);
'use strict';
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("hBrVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd0b8e3cbef64068$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $iOHZJ = parcelRequire("iOHZJ");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");

var $2PhsF = parcelRequire("2PhsF");

var $cgfHI = parcelRequire("cgfHI");

var $8zXsW = parcelRequire("8zXsW");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
const $cd0b8e3cbef64068$var$validators = (0, $8zXsW.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $9ltoJ.default)(),
            response: new (0, $9ltoJ.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $2PhsF.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $8zXsW.default).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $eFc3n.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $8zXsW.default).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $8zXsW.default).assertOptions(config, {
            baseUrl: $cd0b8e3cbef64068$var$validators.spelling('baseURL'),
            withXsrfToken: $cd0b8e3cbef64068$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $eFc3n.default).merge(headers.common, headers[config.method]);
        headers && (0, $eFc3n.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $7hTsj.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $cUzFg.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $cUzFg.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $2PhsF.default)(this.defaults, config);
        const fullPath = (0, $cgfHI.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $iOHZJ.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $eFc3n.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $2PhsF.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $eFc3n.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $2PhsF.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("iOHZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2f05ec923f2ee7$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $4uovm = parcelRequire("4uovm");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    if ((0, $eFc3n.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $eFc3n.default).isURLSearchParams(params) ? params.toString() : new (0, $4uovm.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("4uovm", function(module, exports) {

$parcel$export(module.exports, "default", () => $344cf8e4292137b6$export$2e2bcd8739ae039);

var $lISaw = parcelRequire("lISaw");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $lISaw.default)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;

});
parcelRegister("lISaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd07b9cb0132c1f6$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $bAbs8 = parcelRequire("bAbs8");

var $N0o3H = parcelRequire("N0o3H");
var $fd07b9cb0132c1f6$require$Buffer = $N0o3H.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $eFc3n.default).isPlainObject(thing) || (0, $eFc3n.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $eFc3n.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $eFc3n.default).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $eFc3n.default).toFlatObject((0, $eFc3n.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $eFc3n.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $bAbs8.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $eFc3n.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $eFc3n.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $eFc3n.default).isSpecCompliantForm(formData);
    if (!(0, $eFc3n.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $eFc3n.default).isDate(value)) return value.toISOString();
        if ((0, $eFc3n.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $eFc3n.default).isBlob(value)) throw new (0, $6wIUo.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $eFc3n.default).isArrayBuffer(value) || (0, $eFc3n.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $eFc3n.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $eFc3n.default).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $eFc3n.default).isFileList(value) || (0, $eFc3n.default).endsWith(key, '[]')) && (arr = (0, $eFc3n.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $eFc3n.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $eFc3n.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $eFc3n.default).forEach(value, function each(el, key) {
            const result = !((0, $eFc3n.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $eFc3n.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $eFc3n.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;

});
parcelRegister("6wIUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0139f1d30f4d6bd5$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $eFc3n.default).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $eFc3n.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $eFc3n.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;

});

parcelRegister("bAbs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ebf0c810395e29$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;

});

parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("9ltoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c17f80085c95b1$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $eFc3n.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $96666136aaccd2e5$export$2e2bcd8739ae039);

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $juuss = parcelRequire("juuss");

var $8yOyy = parcelRequire("8yOyy");

var $7hTsj = parcelRequire("7hTsj");

var $ik8Aj = parcelRequire("ik8Aj");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $8yOyy.default)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $7hTsj.default).from(config.headers);
    // Transform request data
    config.data = (0, $kgh03.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $ik8Aj.default).getAdapter(config.adapter || (0, $juuss.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $kgh03.default).call(config, config.transformResponse, response);
        response.headers = (0, $7hTsj.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $lCgfr.default)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $kgh03.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $7hTsj.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("kgh03", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec027d10dfede142$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $juuss = parcelRequire("juuss");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $juuss.default);
    const context = response || config;
    const headers = (0, $7hTsj.default).from(context.headers);
    let data = context.data;
    (0, $eFc3n.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("juuss", function(module, exports) {

$parcel$export(module.exports, "default", () => $e30871f78dcd7f19$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $49WWV = parcelRequire("49WWV");

var $lISaw = parcelRequire("lISaw");

var $eAUco = parcelRequire("eAUco");

var $bqN51 = parcelRequire("bqN51");

var $htyv1 = parcelRequire("htyv1");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $eFc3n.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $eFc3n.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $49WWV.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $eFc3n.default).isObject(data);
            if (isObjectPayload && (0, $eFc3n.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $eFc3n.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $htyv1.default)(data)) : data;
            if ((0, $eFc3n.default).isArrayBuffer(data) || (0, $eFc3n.default).isBuffer(data) || (0, $eFc3n.default).isStream(data) || (0, $eFc3n.default).isFile(data) || (0, $eFc3n.default).isBlob(data) || (0, $eFc3n.default).isReadableStream(data)) return data;
            if ((0, $eFc3n.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $eFc3n.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $eAUco.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $eFc3n.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $lISaw.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $eFc3n.default).isResponse(data) || (0, $eFc3n.default).isReadableStream(data)) return data;
            if (data && (0, $eFc3n.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6wIUo.default).from(e, (0, $6wIUo.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bqN51.default).classes.FormData,
        Blob: (0, $bqN51.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $eFc3n.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;

});
parcelRegister("49WWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3075bac9f30e7782$export$2e2bcd8739ae039);
'use strict';
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("eAUco", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa000567d8bb5ae2$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $lISaw = parcelRequire("lISaw");

var $bqN51 = parcelRequire("bqN51");
'use strict';
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $lISaw.default)(data, new (0, $bqN51.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bqN51.default).isNode && (0, $eFc3n.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("bqN51", function(module, exports) {

$parcel$export(module.exports, "default", () => $852831b4a152a7ad$export$2e2bcd8739ae039);

var $lyPzr = parcelRequire("lyPzr");

var $31g1y = parcelRequire("31g1y");
var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$31g1y,
    ...(0, $lyPzr.default)
};

});
parcelRegister("lyPzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb24c6d0b2a74508$export$2e2bcd8739ae039);

var $esdLz = parcelRequire("esdLz");

var $64i7Q = parcelRequire("64i7Q");

var $3YeiC = parcelRequire("3YeiC");
var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $esdLz.default,
        FormData: $64i7Q.default,
        Blob: $3YeiC.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("esdLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85e5bed82430d61$export$2e2bcd8739ae039);

var $4uovm = parcelRequire("4uovm");
'use strict';
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $4uovm.default);

});

parcelRegister("64i7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b12d255f217052$export$2e2bcd8739ae039);
'use strict';
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("3YeiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4211376cea43e6$export$2e2bcd8739ae039);
'use strict';
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("31g1y", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $232de52881daaba8$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $232de52881daaba8$export$f710a83a91838a36);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $232de52881daaba8$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = $232de52881daaba8$export$c4996c4b7b93b0bf && (!$232de52881daaba8$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($232de52881daaba8$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $232de52881daaba8$export$f710a83a91838a36 = $232de52881daaba8$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("htyv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8fe7f388dc4432$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $eFc3n.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $eFc3n.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $eFc3n.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $eFc3n.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $eFc3n.default).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $eFc3n.default).isFormData(formData) && (0, $eFc3n.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $eFc3n.default).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;

});


parcelRegister("7hTsj", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e5234108b8e954$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $4Ik1V = parcelRequire("4Ik1V");
'use strict';
const $54e5234108b8e954$var$$internals = Symbol('internals');
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $eFc3n.default).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $eFc3n.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $eFc3n.default).isString(value)) return;
    if ((0, $eFc3n.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $eFc3n.default).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $eFc3n.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $eFc3n.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $eFc3n.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $eFc3n.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $eFc3n.default).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $4Ik1V.default)(header), valueOrRewrite);
        else if ((0, $eFc3n.default).isObject(header) && (0, $eFc3n.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $eFc3n.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $eFc3n.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eFc3n.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $eFc3n.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $eFc3n.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eFc3n.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $eFc3n.default).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $eFc3n.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $eFc3n.default).forEach(this, (value, header)=>{
            const key = (0, $eFc3n.default).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $eFc3n.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $eFc3n.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $eFc3n.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $eFc3n.default).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $eFc3n.default).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;

});
parcelRegister("4Ik1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $36eacf0f5ae88424$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $eFc3n.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("lCgfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
'use strict';
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("8yOyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b8b72909769bf2$export$2e2bcd8739ae039);

var $6wIUo = parcelRequire("6wIUo");

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $6wIUo.default).call(this, message == null ? 'canceled' : message, (0, $6wIUo.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $eFc3n.default).inherits($63b8b72909769bf2$var$CanceledError, (0, $6wIUo.default), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;

});

parcelRegister("ik8Aj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d570c100e0cb7a05$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bAbs8 = parcelRequire("bAbs8");

var $8nTSD = parcelRequire("8nTSD");

var $6uoyO = parcelRequire("6uoyO");

var $6wIUo = parcelRequire("6wIUo");
const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $bAbs8.default),
    xhr: (0, $8nTSD.default),
    fetch: (0, $6uoyO.default)
};
(0, $eFc3n.default).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $eFc3n.default).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $eFc3n.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $6wIUo.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($d570c100e0cb7a05$var$renderReason).join('\n') : ' ' + $d570c100e0cb7a05$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $6wIUo.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};

});
parcelRegister("8nTSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $61abd1574bd1dd32$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $49WWV = parcelRequire("49WWV");

var $6wIUo = parcelRequire("6wIUo");

var $8yOyy = parcelRequire("8yOyy");

var $drWk7 = parcelRequire("drWk7");

var $bqN51 = parcelRequire("bqN51");

var $7hTsj = parcelRequire("7hTsj");

var $dKk3V = parcelRequire("dKk3V");

var $l7Q05 = parcelRequire("l7Q05");
const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $l7Q05.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $7hTsj.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $7hTsj.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $gyIfz.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6wIUo.default)('Request aborted', (0, $6wIUo.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $6wIUo.default)('Network Error', (0, $6wIUo.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $49WWV.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6wIUo.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6wIUo.default).ETIMEDOUT : (0, $6wIUo.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $eFc3n.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $eFc3n.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $dKk3V.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $dKk3V.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $8yOyy.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $drWk7.default)(_config.url);
        if (protocol && (0, $bqN51.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6wIUo.default)('Unsupported protocol ' + protocol + ':', (0, $6wIUo.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e22576f74b8071$export$2e2bcd8739ae039);

var $6wIUo = parcelRequire("6wIUo");
'use strict';
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6wIUo.default)('Request failed with status code ' + response.status, [
        (0, $6wIUo.default).ERR_BAD_REQUEST,
        (0, $6wIUo.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("drWk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cab09d0d089fc0e$export$2e2bcd8739ae039);
'use strict';
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("dKk3V", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $a01f222f203440ec$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $a01f222f203440ec$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $a01f222f203440ec$export$5d35863c355a22a9);

var $6eLe3 = parcelRequire("6eLe3");

var $g1MZz = parcelRequire("g1MZz");

var $eFc3n = parcelRequire("eFc3n");
const $a01f222f203440ec$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6eLe3.default)(50, 250);
    return (0, $g1MZz.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $a01f222f203440ec$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $a01f222f203440ec$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $eFc3n.default).asap(()=>fn(...args));

});
parcelRegister("6eLe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a8aeed25ee768a$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;

});

parcelRegister("g1MZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab2be24834f7155$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $bab2be24834f7155$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $bab2be24834f7155$export$2e2bcd8739ae039 = $bab2be24834f7155$var$throttle;

});


parcelRegister("l7Q05", function(module, exports) {

$parcel$export(module.exports, "default", () => $f612969e780f42a0$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");

var $eFc3n = parcelRequire("eFc3n");

var $4YUSN = parcelRequire("4YUSN");

var $6D8uh = parcelRequire("6D8uh");

var $cgfHI = parcelRequire("cgfHI");

var $2PhsF = parcelRequire("2PhsF");

var $7hTsj = parcelRequire("7hTsj");

var $iOHZJ = parcelRequire("iOHZJ");
var $f612969e780f42a0$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $2PhsF.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $7hTsj.default).from(headers);
    newConfig.url = (0, $iOHZJ.default)((0, $cgfHI.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $eFc3n.default).isFormData(data)) {
        if ((0, $bqN51.default).hasStandardBrowserEnv || (0, $bqN51.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bqN51.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $eFc3n.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $4YUSN.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $6D8uh.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("4YUSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a08e3bf7b3045fa$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");
var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $bqN51.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bqN51.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bqN51.default).origin), (0, $bqN51.default).navigator && /(msie|trident)/i.test((0, $bqN51.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("6D8uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3cf801f7fd4dc6$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bqN51 = parcelRequire("bqN51");
var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $bqN51.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $eFc3n.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $eFc3n.default).isString(path) && cookie.push('path=' + path);
        (0, $eFc3n.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("cgfHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed3292b1f9dccb5$export$2e2bcd8739ae039);

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
'use strict';
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $uAxSn.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $aFAjA.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("uAxSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $05bf269bfca011f3$export$2e2bcd8739ae039);
'use strict';
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("aFAjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c49e720f6231ba2$export$2e2bcd8739ae039);
'use strict';
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("2PhsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ede3a7e8b675d4$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $7hTsj.default) ? {
        ...thing
    } : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $eFc3n.default).isPlainObject(target) && (0, $eFc3n.default).isPlainObject(source)) return (0, $eFc3n.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $eFc3n.default).isPlainObject(source)) return (0, $eFc3n.default).merge({}, source);
        else if ((0, $eFc3n.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $eFc3n.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $eFc3n.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), prop, true)
    };
    (0, $eFc3n.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $eFc3n.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("6uoyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9898a31eea6843$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $c046u = parcelRequire("c046u");

var $eMAze = parcelRequire("eMAze");

var $7hTsj = parcelRequire("7hTsj");

var $dKk3V = parcelRequire("dKk3V");

var $l7Q05 = parcelRequire("l7Q05");

var $gyIfz = parcelRequire("gyIfz");
const $4b9898a31eea6843$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $4b9898a31eea6843$var$isReadableStreamSupported = $4b9898a31eea6843$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $4b9898a31eea6843$var$encodeText = $4b9898a31eea6843$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $4b9898a31eea6843$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $4b9898a31eea6843$var$supportsRequestStream = $4b9898a31eea6843$var$isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bqN51.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE = 65536;
const $4b9898a31eea6843$var$supportsResponseStream = $4b9898a31eea6843$var$isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>(0, $eFc3n.default).isReadableStream(new Response('').body));
const $4b9898a31eea6843$var$resolvers = {
    stream: $4b9898a31eea6843$var$supportsResponseStream && ((res)=>res.body)
};
$4b9898a31eea6843$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$4b9898a31eea6843$var$resolvers[type] && ($4b9898a31eea6843$var$resolvers[type] = (0, $eFc3n.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $6wIUo.default)(`Response type '${type}' is not supported`, (0, $6wIUo.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $4b9898a31eea6843$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $eFc3n.default).isBlob(body)) return body.size;
    if ((0, $eFc3n.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bqN51.default).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $eFc3n.default).isArrayBufferView(body) || (0, $eFc3n.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $eFc3n.default).isURLSearchParams(body)) body = body + '';
    if ((0, $eFc3n.default).isString(body)) return (await $4b9898a31eea6843$var$encodeText(body)).byteLength;
};
const $4b9898a31eea6843$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $eFc3n.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $4b9898a31eea6843$var$getBodyLength(body) : length;
};
var $4b9898a31eea6843$export$2e2bcd8739ae039 = $4b9898a31eea6843$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $l7Q05.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $c046u.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $4b9898a31eea6843$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $4b9898a31eea6843$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $eFc3n.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $dKk3V.progressEventDecorator)(requestContentLength, (0, $dKk3V.progressEventReducer)((0, $dKk3V.asyncDecorator)(onUploadProgress)));
                data = (0, $eMAze.trackStream)(_request.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $eFc3n.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request, fetchOptions);
        const isStreamResponse = $4b9898a31eea6843$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($4b9898a31eea6843$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $eFc3n.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $dKk3V.progressEventDecorator)(responseContentLength, (0, $dKk3V.progressEventReducer)((0, $dKk3V.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $eMAze.trackStream)(response.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $4b9898a31eea6843$var$resolvers[(0, $eFc3n.default).findKey($4b9898a31eea6843$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $gyIfz.default)(resolve, reject, {
                data: responseData,
                headers: (0, $7hTsj.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $6wIUo.default)('Network Error', (0, $6wIUo.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $6wIUo.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("c046u", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc8ab02f7e95517$export$2e2bcd8739ae039);

var $8yOyy = parcelRequire("8yOyy");

var $6wIUo = parcelRequire("6wIUo");

var $eFc3n = parcelRequire("eFc3n");
const $8bc8ab02f7e95517$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $6wIUo.default) ? err : new (0, $8yOyy.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $6wIUo.default)(`timeout ${timeout} of ms exceeded`, (0, $6wIUo.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $eFc3n.default).asap(unsubscribe);
        return signal;
    }
};
var $8bc8ab02f7e95517$export$2e2bcd8739ae039 = $8bc8ab02f7e95517$var$composeSignals;

});

parcelRegister("eMAze", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $ac31e9e363273572$export$b0119225647bd83);
const $ac31e9e363273572$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ac31e9e363273572$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ac31e9e363273572$var$readStream(iterable))yield* $ac31e9e363273572$export$71b051935044bd5d(chunk, chunkSize);
};
const $ac31e9e363273572$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ac31e9e363273572$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ac31e9e363273572$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("8zXsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63efb8494987aa98$export$2e2bcd8739ae039);

var $6yYtd = parcelRequire("6yYtd");

var $6wIUo = parcelRequire("6wIUo");
'use strict';
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $6yYtd.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6wIUo.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6wIUo.default).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$63efb8494987aa98$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $6wIUo.default)('options must be an object', (0, $6wIUo.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6wIUo.default)('option ' + opt + ' must be ' + result, (0, $6wIUo.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6wIUo.default)('Unknown option ' + opt, (0, $6wIUo.default).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};

});
parcelRegister("6yYtd", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $4c74d331112ba968$export$a4ad2735b021c132);
const $4c74d331112ba968$export$a4ad2735b021c132 = "1.10.0";

});



parcelRegister("4iFhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3218dd97b5460664$export$2e2bcd8739ae039);

var $8yOyy = parcelRequire("8yOyy");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $8yOyy.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7874d702b64e6994$export$2e2bcd8739ae039);
'use strict';
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("1YbHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f479813f4fb9c8$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $eFc3n.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("kq2bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;

});




parcelRegister("55x1G", function(module, exports) {

$parcel$export(module.exports, "useError", () => $3b4709a92d902576$export$5027865de34f9ec6);

var $8NFma = parcelRequire("8NFma");
const $3b4709a92d902576$export$5027865de34f9ec6 = (getLabel)=>{
    const [error, setError] = (0, $8NFma.useState)('');
    const [errorMessage, setErrorMessage] = (0, $8NFma.useState)('');
    (0, $8NFma.useEffect)(()=>{
        if (error && getLabel) {
            const errorMessages = getLabel('errors');
            setErrorMessage(errorMessages[error] || errorMessages['unknown'] || 'An unknown error occurred');
        }
    }, [
        error,
        getLabel
    ]);
    return {
        errorMessage: errorMessage,
        setError: setError
    };
};

});

parcelRegister("22IaK", function(module, exports) {

$parcel$export(module.exports, "useExistingTrial", () => $17ce0862823c667c$export$5f3ca62da6c5f33f);

var $8NFma = parcelRequire("8NFma");
const $17ce0862823c667c$var$storageKey = 'mpTrialSystemId';
const $17ce0862823c667c$export$5f3ca62da6c5f33f = ()=>{
    const [hasExistingTrial, setHasExistingTrial] = (0, $8NFma.useState)(()=>!!localStorage.getItem($17ce0862823c667c$var$storageKey));
    const rememberTrialSystem = (id)=>{
        localStorage.setItem($17ce0862823c667c$var$storageKey, id);
    };
    const forgetTrialSystem = ()=>{
        localStorage.removeItem($17ce0862823c667c$var$storageKey);
        setHasExistingTrial(false);
    };
    return {
        hasExistingTrial: hasExistingTrial,
        forgetTrialSystem: forgetTrialSystem,
        rememberTrialSystem: rememberTrialSystem
    };
};

});

parcelRegister("aJP2U", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $7d15b40296814625$export$45d76561a5302f2b);
parcelRequire("1zKtH");
var $81tj9 = parcelRequire("81tj9");

var $8NFma = parcelRequire("8NFma");
const $7d15b40296814625$var$storageKeys = {
    region: 'visitorRegion',
    country: 'visitorCountry'
};
const $7d15b40296814625$var$getParam = (key)=>{
    try {
        const url = new URL(window.location);
        return url.searchParams.get(key)?.toLowerCase() || '';
    } catch  {
        return '';
    }
};
const $7d15b40296814625$export$45d76561a5302f2b = (regionUrl)=>{
    const [region, setRegion] = (0, $8NFma.useState)($7d15b40296814625$var$getParam('region') || localStorage.getItem($7d15b40296814625$var$storageKeys.region) || '');
    const [country, setCountry] = (0, $8NFma.useState)($7d15b40296814625$var$getParam('country') || localStorage.getItem($7d15b40296814625$var$storageKeys.country) || '');
    (0, $8NFma.useEffect)(()=>{
        if (!regionUrl) return;
        if (region && country) return;
        let cancelled = false;
        const fetchLocation = async ()=>{
            try {
                const { data: data } = await (0, $81tj9.default).get(regionUrl);
                if (!cancelled) {
                    setRegion(data.region.toLowerCase());
                    setCountry(data.country.toLowerCase());
                }
            } catch  {
                if (!cancelled) {
                    setRegion('');
                    setCountry('');
                }
            }
        };
        fetchLocation();
        return ()=>{
            cancelled = true;
        };
    }, [
        regionUrl
    ]);
    // Store region and country in localStorage whenever they change
    (0, $8NFma.useEffect)(()=>{
        region && localStorage.setItem($7d15b40296814625$var$storageKeys.region, region);
        country && localStorage.setItem($7d15b40296814625$var$storageKeys.country, country);
    }, [
        region,
        country
    ]);
    return {
        region: region,
        country: country
    };
};

});

parcelRegister("5iyJu", function(module, exports) {

$parcel$export(module.exports, "useRecaptcha", () => $3db9935cf38c45c3$export$f7242fdfba1703e8);

var $8NFma = parcelRequire("8NFma");
const $3db9935cf38c45c3$export$f7242fdfba1703e8 = (siteKey)=>{
    (0, $8NFma.useEffect)(()=>{
        if (!siteKey) return;
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }, [
        siteKey
    ]);
    const getRecaptchaToken = async ()=>{
        const url = new URL(window.location);
        if (url.searchParams.has('reCaptcha')) return url.searchParams.get('reCaptcha');
        if (!window.grecaptcha) {
            console.warn('The Google reCAPTCHA script could not be executed, so no token was generated.');
            return '';
        }
        return new Promise((resolve, reject)=>{
            window.grecaptcha.ready(()=>{
                window.grecaptcha.execute(siteKey, {
                    action: 'trial'
                }).then(resolve).catch(reject);
            });
        });
    };
    return {
        getRecaptchaToken: getRecaptchaToken
    };
};

});

parcelRegister("il24A", function(module, exports) {

$parcel$export(module.exports, "useTrial", () => $d59bcbcfde2d6d4b$export$fd692dd30d1cbacd);
parcelRequire("1zKtH");
var $81tj9 = parcelRequire("81tj9");

var $7isa4 = parcelRequire("7isa4");

var $8NFma = parcelRequire("8NFma");

var $ch3jL = parcelRequire("ch3jL");

var $ct3n1 = parcelRequire("ct3n1");

var $fBiHk = parcelRequire("fBiHk");

var $lI8Kb = parcelRequire("lI8Kb");

var $83l5B = parcelRequire("83l5B");

var $buJ37 = parcelRequire("buJ37");

var $aJP2U = parcelRequire("aJP2U");

var $dF99X = parcelRequire("dF99X");
const $d59bcbcfde2d6d4b$var$getUserOrigin = (email, regexPatterns)=>(0, $buJ37.isInternalEmailAddress)(email, regexPatterns) ? 'internal' : 'external';
const $d59bcbcfde2d6d4b$var$requestTrialRegistration = async ({ formData: formData, locale: locale, recaptchaToken: recaptchaToken, region: region, url: url })=>{
    const body = {
        ...formData,
        reCaptchaCode: recaptchaToken,
        locale: locale,
        region: region.toUpperCase(),
        systemName: (0, $ch3jL.generateSystemName)()
    };
    if ((0, $fBiHk.getGoogleAnalyticsClientId)()) body.gaClientId = (0, $fBiHk.getGoogleAnalyticsClientId)();
    try {
        const { data: data } = await (0, $81tj9.default).post(url, body);
        return data;
    } catch (error) {
        const status = error.response?.status;
        const messages = {
            400: 'Validation error on provided fields',
            409: 'Selected system name already exists',
            500: 'Request failed with an unexpected reason'
        };
        throw new Error(messages[status] || `Unknown status code exception: ${status}`);
    }
};
const $d59bcbcfde2d6d4b$var$requestTrialActivation = async ({ activationCode: activationCode, customJson: customJson, region: region, systemId: systemId, templateName: templateName, url: url })=>{
    try {
        const { data: data } = await (0, $81tj9.default).post(url, {
            activationCode: activationCode,
            customJson: customJson,
            region: region.toUpperCase(),
            systemId: systemId,
            templateName: templateName
        });
        return data;
    } catch (error) {
        const status = error.response?.status;
        const messages = {
            400: 'Validation error on provided fields',
            403: 'Provided activation code was invalid for the supplied system',
            404: 'No system with the id was found',
            422: 'No template with the name was found',
            500: 'Request failed with an unexpected reason'
        };
        throw new Error(messages[status] || `Unknown status code exception: ${status}`);
    }
};
const $d59bcbcfde2d6d4b$var$requestActivationEmailResend = async ({ region: region, systemId: systemId, url: url })=>{
    try {
        await (0, $81tj9.default).post(url, {
            region: region.toUpperCase(),
            systemId: systemId
        });
    } catch (error) {
        const status = error.response?.status;
        const messages = {
            400: 'Validation error on provided fields',
            500: 'Request failed with an unexpected reason'
        };
        throw new Error(messages[status] || `Unknown status code exception: ${status}`);
    }
};
const $d59bcbcfde2d6d4b$export$fd692dd30d1cbacd = ({ data: data, getLabel: getLabel, getRecaptchaToken: getRecaptchaToken, isMobile: isMobile, onStatusChange: onStatusChange, rememberTrialSystem: rememberTrialSystem })=>{
    const { country: country, region: region } = (0, $aJP2U.useLocation)(data?.apiRoutes.region);
    const { getPersistedValue: getPersistedValue, persistState: persistState, clearPersistedState: clearPersistedState } = (0, $dF99X.useTrialPersistence)();
    // Consume search params once
    const initialActivationCode = (0, $83l5B.consumeSearchParam)('activationCode') || '';
    const initialEmail = (0, $83l5B.consumeSearchParam)('email') || '';
    const initialSystemId = (0, $83l5B.consumeSearchParam)('systemId') || '';
    const initialTrialRegistrationMethod = (0, $83l5B.consumeSearchParam)('sso') || 'email';
    // Initialize state with search params prioritized over persisted state
    const [trialActivationCode, setTrialActivationCode] = (0, $8NFma.useState)(initialActivationCode || getPersistedValue('trialActivationCode') || '');
    const [trialEmailAddress, setTrialEmailAddress] = (0, $8NFma.useState)(initialEmail || getPersistedValue('trialEmailAddress') || '');
    const [trialLoading, setTrialLoading] = (0, $8NFma.useState)(false);
    const [trialSystemId, setTrialSystemId] = (0, $8NFma.useState)(initialSystemId || getPersistedValue('trialSystemId') || '');
    const [trialSystemUrl, setTrialSystemUrl] = (0, $8NFma.useState)('');
    const [trialTrusted, setTrialTrusted] = (0, $8NFma.useState)(!!initialActivationCode || getPersistedValue('trialTrusted') || false);
    const [trialRegistrationMethod] = (0, $8NFma.useState)(initialTrialRegistrationMethod);
    const [hasRegisteredSSO, setHasRegisteredSSO] = (0, $8NFma.useState)(false);
    const minLoadingTime = 3000; // Minimum loading time in milliseconds
    // Persist state changes to sessionStorage
    (0, $8NFma.useEffect)(()=>{
        persistState({
            trialActivationCode: trialActivationCode,
            trialEmailAddress: trialEmailAddress,
            trialSystemId: trialSystemId,
            trialTrusted: trialTrusted
        });
    }, [
        trialActivationCode,
        trialEmailAddress,
        trialSystemId,
        trialTrusted,
        persistState
    ]);
    // Clear persisted state (useful for reload)
    const clearTrialState = ()=>clearPersistedState();
    (0, $8NFma.useEffect)(()=>{
        if (trialSystemId) {
            if (trialActivationCode) {
                if (trialSystemUrl) onStatusChange('activated');
                else onStatusChange('customization');
            } else onStatusChange('registered');
        }
    }, [
        trialSystemId,
        trialActivationCode,
        trialSystemUrl
    ]);
    const sendRegisterTrialEvent = (loadStartDate = null, eventData = {})=>{
        (0, $fBiHk.gtmEventRegisterTrial)({
            trusted: eventData.trusted ?? trialTrusted,
            userOrigin: $d59bcbcfde2d6d4b$var$getUserOrigin(eventData.email ?? trialEmailAddress, data.internalEmailRegexPatterns),
            region: region,
            systemId: eventData.systemId ?? trialSystemId,
            registrationMethod: trialRegistrationMethod,
            ...loadStartDate ? {
                timeToLoad: (0, $7isa4.differenceInSeconds)(new Date(), loadStartDate)
            } : {}
        });
    };
    const doHubSpotFormSubmission = async (formData)=>{
        await (0, $lI8Kb.submitHubSpotForm)({
            consentText: (0, $ct3n1.stripHtmlTags)(getLabel('registration_consent_text')),
            country: country,
            formData: formData,
            hubspotData: data.hubspot,
            region: region,
            trialRegistrationMethod: trialRegistrationMethod,
            url: data.apiRoutes?.hubspot.submitForm
        });
    };
    // Send GTM event and data to HubSpot when the user has registered for a trial via SSO
    (0, $8NFma.useEffect)(()=>{
        if (hasRegisteredSSO || !data || trialRegistrationMethod === 'email') return;
        setHasRegisteredSSO(true);
        (async ()=>{
            await doHubSpotFormSubmission([
                {
                    name: 'email',
                    value: trialEmailAddress
                }
            ]);
            sendRegisterTrialEvent();
        })();
    }, [
        data
    ]);
    const onRegistrationFormSubmit = async ({ getFormData: getFormData, getHubspotFormData: getHubspotFormData })=>{
        setTrialLoading(true);
        const formData = getFormData();
        setTrialEmailAddress(formData.email);
        const loadingStartTime = Date.now();
        try {
            const recaptchaToken = isMobile ? '' : await getRecaptchaToken();
            const { status: status, systemId: systemId, activationCode: activationCode } = await $d59bcbcfde2d6d4b$var$requestTrialRegistration({
                formData: formData,
                locale: data?.locale,
                recaptchaToken: recaptchaToken,
                region: region,
                url: data?.apiRoutes.start
            });
            await doHubSpotFormSubmission(getHubspotFormData());
            sendRegisterTrialEvent(loadingStartTime, {
                trusted: status === 'TRUSTED',
                email: formData.email,
                systemId: systemId
            });
            setTrialSystemId(systemId);
            setTrialTrusted(status === 'TRUSTED');
            setTrialActivationCode(activationCode);
        } catch (error) {
            console.error('Error registering trial:', error);
        // TODO: Handle error appropriately, e.g., show a notification to the user
        } finally{
            const elapsedTime = Date.now() - loadingStartTime;
            if (elapsedTime < minLoadingTime) setTimeout(()=>setTrialLoading(false), minLoadingTime - elapsedTime);
            else setTrialLoading(false);
        }
    };
    const onCompleteCustomization = async ({ selection: selection, trialTemplate: trialTemplate, skipped: skipped })=>{
        try {
            const { redirectUrl: redirectUrl, email: email } = await $d59bcbcfde2d6d4b$var$requestTrialActivation({
                activationCode: trialActivationCode,
                customJson: skipped ? {} : {
                    trialUserGoal: selection[0].value,
                    trialUserRole: selection[1].value
                },
                region: region,
                systemId: trialSystemId,
                templateName: trialTemplate,
                url: data.apiRoutes.activate
            });
            setTrialEmailAddress(email);
            setTrialSystemUrl(redirectUrl);
            rememberTrialSystem(trialSystemId);
            // Update HubSpot contact
            await (0, $lI8Kb.updateHubSpotContact)({
                url: data.apiRoutes.hubspot.updateContact,
                email: email,
                properties: {
                    trial_template: trialTemplate,
                    ...!skipped && {
                        trial_goal: selection[0].label,
                        trial_role: selection[1].label
                    }
                }
            });
            // Send GTM event for trial customization
            skipped ? (0, $fBiHk.gtmEventCustomizationSkipped)(trialTemplate) : (0, $fBiHk.gtmEventCustomizedTrial)({
                selection: selection,
                trialTemplate: trialTemplate
            });
            // Redirect the user to the trial system URL
            window.location.assign(redirectUrl);
        } catch (error) {
            console.error('An error occurred while trying to activate the trial:', error);
        // TODO: Handle error appropriately, e.g., show a notification to the user
        }
    };
    const resendActivationEmail = async ()=>{
        try {
            await $d59bcbcfde2d6d4b$var$requestActivationEmailResend({
                region: region,
                systemId: trialSystemId,
                url: data.apiRoutes.resendActivateMail
            });
            // Show a toast or notification to inform the user that the email has been resent
            window.showToast?.(getLabel('verification_toast_new_email_success'), 'success');
        } catch (error) {
            console.error('An error occurred while trying to resend the activation email:', error);
            // Show a toast or notification to inform the user that there was an error
            window.showToast?.(getLabel('verification_toast_new_email_error'), 'error', {
                autoHide: false
            });
        }
    };
    return {
        clearTrialState: clearTrialState,
        onCompleteCustomization: onCompleteCustomization,
        onRegistrationFormSubmit: onRegistrationFormSubmit,
        resendActivationEmail: resendActivationEmail,
        trialActivationCode: trialActivationCode,
        trialEmailAddress: trialEmailAddress,
        trialLoading: trialLoading,
        trialSystemId: trialSystemId
    };
};

});
parcelRegister("7isa4", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", () => $55000f1a72ca0916$export$c1889aec51783710);

var $kHvlI = parcelRequire("kHvlI");

var $b3r9H = parcelRequire("b3r9H");
function $55000f1a72ca0916$export$c1889aec51783710(laterDate, earlierDate, options) {
    const diff = (0, $b3r9H.differenceInMilliseconds)(laterDate, earlierDate) / 1000;
    return (0, $kHvlI.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$55000f1a72ca0916$export$2e2bcd8739ae039 = $55000f1a72ca0916$export$c1889aec51783710;

});
parcelRegister("kHvlI", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $f120241e5fda9f45$export$b6474a47258c1211);
function $f120241e5fda9f45$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("b3r9H", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", () => $80c50a0a80ea8dc0$export$7be94d13716b4bf6);

var $7yyQt = parcelRequire("7yyQt");
function $80c50a0a80ea8dc0$export$7be94d13716b4bf6(laterDate, earlierDate) {
    return +(0, $7yyQt.toDate)(laterDate) - +(0, $7yyQt.toDate)(earlierDate);
}
var // Fallback for modularized imports:
$80c50a0a80ea8dc0$export$2e2bcd8739ae039 = $80c50a0a80ea8dc0$export$7be94d13716b4bf6;

});
parcelRegister("7yyQt", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $5806bcec89744c32$export$e67a095c620b86fe);

var $cMvsU = parcelRequire("cMvsU");
function $5806bcec89744c32$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $cMvsU.constructFrom)(context || argument, argument);
}
var // Fallback for modularized imports:
$5806bcec89744c32$export$2e2bcd8739ae039 = $5806bcec89744c32$export$e67a095c620b86fe;

});
parcelRegister("cMvsU", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $94e2600e6614cc67$export$ead8a1812b171991);

var $9uNOU = parcelRequire("9uNOU");
function $94e2600e6614cc67$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $9uNOU.constructFromSymbol) in date) return date[0, $9uNOU.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$94e2600e6614cc67$export$2e2bcd8739ae039 = $94e2600e6614cc67$export$ead8a1812b171991;

});
parcelRegister("9uNOU", function(module, exports) {

$parcel$export(module.exports, "millisecondsInDay", () => $6e9d8fa85a388a89$export$b76b1809a2898f9a);
$parcel$export(module.exports, "constructFromSymbol", () => $6e9d8fa85a388a89$export$2a7b97929c48d47d);
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $6e9d8fa85a388a89$export$dfd9b671c89acc8e = 7;
const $6e9d8fa85a388a89$export$3913210603d8e9ae = 365.2425;
const $6e9d8fa85a388a89$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $6e9d8fa85a388a89$export$4dec998e48f9c246 = -$6e9d8fa85a388a89$export$81caae6e1cc7a622;
const $6e9d8fa85a388a89$export$4fad13613e88edc8 = 604800000;
const $6e9d8fa85a388a89$export$b76b1809a2898f9a = 86400000;
const $6e9d8fa85a388a89$export$91246f0b9bd9beff = 60000;
const $6e9d8fa85a388a89$export$7f72910d6dfd237a = 3600000;
const $6e9d8fa85a388a89$export$397c2d5776aa9055 = 1000;
const $6e9d8fa85a388a89$export$3633035e63cee86a = 525600;
const $6e9d8fa85a388a89$export$ab7da2ccd1075c38 = 43200;
const $6e9d8fa85a388a89$export$2423174df8cd3cd2 = 1440;
const $6e9d8fa85a388a89$export$f2f5ae5a8e2d8f9f = 60;
const $6e9d8fa85a388a89$export$3c58128db900d44e = 3;
const $6e9d8fa85a388a89$export$80d7e435f744f319 = 12;
const $6e9d8fa85a388a89$export$4db7641526e3241f = 4;
const $6e9d8fa85a388a89$export$698aec755e92c695 = 3600;
const $6e9d8fa85a388a89$export$a77c1a7ebebe2a5a = 60;
const $6e9d8fa85a388a89$export$815a9362476d2fe3 = $6e9d8fa85a388a89$export$698aec755e92c695 * 24;
const $6e9d8fa85a388a89$export$34804a017b31e2fe = $6e9d8fa85a388a89$export$815a9362476d2fe3 * 7;
const $6e9d8fa85a388a89$export$7271e9e3478110d1 = $6e9d8fa85a388a89$export$815a9362476d2fe3 * $6e9d8fa85a388a89$export$3913210603d8e9ae;
const $6e9d8fa85a388a89$export$8e6600bbdee7dabb = $6e9d8fa85a388a89$export$7271e9e3478110d1 / 12;
const $6e9d8fa85a388a89$export$be1dccf2de902d31 = $6e9d8fa85a388a89$export$8e6600bbdee7dabb * 3;
const $6e9d8fa85a388a89$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");

});





parcelRegister("ch3jL", function(module, exports) {

$parcel$export(module.exports, "generateSystemName", () => $8ef9a56a61819052$export$db98e2531f619faf);

var $k9W3x = parcelRequire("k9W3x");

var $i400O = parcelRequire("i400O");
const $8ef9a56a61819052$export$db98e2531f619faf = ()=>{
    const url = new URL(window.location);
    const paramValue = url.searchParams.get('systemName');
    if (paramValue && paramValue.length > 0) return paramValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($k9W3x)))(`${Date.now()}-${(0, $i400O.nanoid)()}`);
};

});
parcelRegister("k9W3x", function(module, exports) {
(function() {
    'use strict';
    var table = [], poly = 0xEDB88320; // reverse polynomial
    // build the table
    function makeTable() {
        var c, n, k;
        for(n = 0; n < 256; n += 1){
            c = n;
            for(k = 0; k < 8; k += 1)if (c & 1) c = poly ^ c >>> 1;
            else c = c >>> 1;
            table[n] = c >>> 0;
        }
    }
    function strToArr(str) {
        // sweet hack to turn string into a 'byte' array
        return Array.prototype.map.call(str, function(c) {
            return c.charCodeAt(0);
        });
    }
    /*
	 * Compute CRC of array directly.
	 *
	 * This is slower for repeated calls, so append mode is not supported.
	 */ function crcDirect(arr) {
        var crc = -1, i, j, l, temp;
        for(i = 0, l = arr.length; i < l; i += 1){
            temp = (crc ^ arr[i]) & 0xff;
            // read 8 bits one at a time
            for(j = 0; j < 8; j += 1)if ((temp & 1) === 1) temp = temp >>> 1 ^ poly;
            else temp = temp >>> 1;
            crc = crc >>> 8 ^ temp;
        }
        // flip bits
        return crc ^ -1;
    }
    /*
	 * Compute CRC with the help of a pre-calculated table.
	 *
	 * This supports append mode, if the second parameter is set.
	 */ function crcTable(arr, append) {
        var crc, i, l;
        // if we're in append mode, don't reset crc
        // if arr is null or undefined, reset table and return
        if (typeof crcTable.crc === 'undefined' || !append || !arr) {
            crcTable.crc = -1;
            if (!arr) return;
        }
        // store in temp variable for minor speed gain
        crc = crcTable.crc;
        for(i = 0, l = arr.length; i < l; i += 1)crc = crc >>> 8 ^ table[(crc ^ arr[i]) & 0xff];
        crcTable.crc = crc;
        return crc ^ -1;
    }
    // build the table
    // this isn't that costly, and most uses will be for table assisted mode
    makeTable();
    module.exports = function(val, direct) {
        var val = typeof val === 'string' ? strToArr(val) : val, ret = direct ? crcDirect(val) : crcTable(val);
        // convert to 2's complement hex
        return (ret >>> 0).toString(16);
    };
    module.exports.direct = crcDirect;
    module.exports.table = crcTable;
})();

});

parcelRegister("i400O", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $d2689c1b6ccbb1f5$export$ac4959f4f1338dfc);
/* @ts-self-types="./index.d.ts" */ let $d2689c1b6ccbb1f5$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $d2689c1b6ccbb1f5$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $d2689c1b6ccbb1f5$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i--)id += $d2689c1b6ccbb1f5$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};

});


parcelRegister("ct3n1", function(module, exports) {

$parcel$export(module.exports, "stripHtmlTags", () => $913acec21d61b623$export$983f343ccff49d27);
const $913acec21d61b623$export$983f343ccff49d27 = (value)=>{
    // Remove HTML tags from string
    return value.replace(/<[^>]*>/g, '');
};

});

parcelRegister("fBiHk", function(module, exports) {

$parcel$export(module.exports, "getGoogleAnalyticsClientId", () => $b5b8d0b65be31aac$export$108b704ce5c937fe);
$parcel$export(module.exports, "gtmEventRegisterTrial", () => $b5b8d0b65be31aac$export$a800ee8309099f78);
$parcel$export(module.exports, "gtmEventCustomizedTrial", () => $b5b8d0b65be31aac$export$b5672325c0871a83);
$parcel$export(module.exports, "gtmEventCustomizationSkipped", () => $b5b8d0b65be31aac$export$288c01c13d4ce7df);

var $i9Wfi = parcelRequire("i9Wfi");
const $b5b8d0b65be31aac$export$108b704ce5c937fe = ()=>{
    const cookies = (0, $i9Wfi.getAllCookies)();
    return cookies['_ga'] ? cookies['_ga'] : false;
};
const $b5b8d0b65be31aac$var$pushDataLayerEvent = (eventData)=>{
    if ('event' in eventData) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventData);
    }
};
const $b5b8d0b65be31aac$export$a800ee8309099f78 = (trialData)=>{
    $b5b8d0b65be31aac$var$pushDataLayerEvent({
        event: 'trial_register',
        trial: trialData
    });
};
const $b5b8d0b65be31aac$export$b5672325c0871a83 = ({ selection: selection, trialTemplate: trialTemplate })=>{
    $b5b8d0b65be31aac$var$pushDataLayerEvent({
        event: 'trial_customized',
        trialCustomization: {
            template: trialTemplate,
            goal: selection[0].value,
            role: selection[1].value
        }
    });
};
const $b5b8d0b65be31aac$export$288c01c13d4ce7df = (template)=>{
    $b5b8d0b65be31aac$var$pushDataLayerEvent({
        event: 'trial_customization_skipped',
        trialCustomization: {
            template: template
        }
    });
};

});
parcelRegister("i9Wfi", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", () => $d3863fab02d7ba8d$export$1191989ae3ee4c15);
const $d3863fab02d7ba8d$export$1191989ae3ee4c15 = ()=>{
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    const allCookies = {};
    cookies.forEach((cookie)=>{
        const [key, ...rest] = cookie.split('=');
        allCookies[key] = decodeURIComponent(rest.join('='));
    });
    return allCookies;
};

});


parcelRegister("lI8Kb", function(module, exports) {

$parcel$export(module.exports, "submitHubSpotForm", () => $fce47d6774a36f85$export$4ccf9d7485b06dba);
$parcel$export(module.exports, "updateHubSpotContact", () => $fce47d6774a36f85$export$ec57a235ccfab9d);
parcelRequire("1zKtH");
var $81tj9 = parcelRequire("81tj9");

var $i9Wfi = parcelRequire("i9Wfi");

var $fBiHk = parcelRequire("fBiHk");
const $fce47d6774a36f85$var$getContextData = ()=>{
    const context = {
        pageUri: window.location.href,
        pageName: document.title
    };
    const cookies = (0, $i9Wfi.getAllCookies)();
    if (cookies['hubspotutk']) context.hutk = cookies['hubspotutk'];
    return context;
};
const $fce47d6774a36f85$var$getLegalConsentData = ({ consentText: consentText, country: country, hubspotData: hubspotData, region: region })=>{
    // Subscriptions
    const communications = [];
    hubspotData.subscriptions.forEach((subscription)=>{
        // If the user's region matches the target region in the current subscription data
        let subscribe = true;
        if (subscription.filter) switch(subscription.filter.type){
            case 'region':
                subscribe = subscription.filter.value === region; // Filter value is a string.
                break;
            case 'country':
                subscribe = subscription.filter.value.includes(country); // Filter value is an array.
                break;
        }
        subscribe && communications.push({
            value: true,
            subscriptionTypeId: subscription.subscription_type_id,
            text: subscription.consent_text
        });
    });
    return {
        consent: {
            consentToProcess: true,
            text: consentText,
            communications: communications
        }
    };
};
const $fce47d6774a36f85$export$4ccf9d7485b06dba = async ({ consentText: consentText, country: country, formData: formData, hubspotData: hubspotData, region: region, trialRegistrationMethod: trialRegistrationMethod, url: url })=>{
    // Enrich formData with additional fields
    formData.push({
        name: 'trial_registration_method',
        value: trialRegistrationMethod
    });
    const gaClientId = (0, $fBiHk.getGoogleAnalyticsClientId)();
    if (gaClientId) formData.push({
        name: 'ga_client_id',
        value: gaClientId
    });
    const data = {
        context: $fce47d6774a36f85$var$getContextData(),
        fields: formData,
        legalConsentOptions: $fce47d6774a36f85$var$getLegalConsentData({
            consentText: consentText,
            country: country,
            hubspotData: hubspotData,
            region: region
        })
    };
    try {
        await (0, $81tj9.default).post(url, {
            hs_route: hubspotData.formSubmissionUrl,
            hs_data: JSON.stringify(data)
        });
    } catch (error) {
        console.error('Error submitting HubSpot form:', error);
    }
};
const $fce47d6774a36f85$export$ec57a235ccfab9d = async ({ email: email, properties: properties, url: url })=>{
    try {
        const formData = new FormData();
        formData.append('email', email);
        formData.append('properties', JSON.stringify(properties));
        await (0, $81tj9.default).post(url, formData);
    } catch (error) {
        console.error('Error updating HubSpot contact:', error);
    }
};

});

parcelRegister("83l5B", function(module, exports) {

$parcel$export(module.exports, "consumeSearchParam", () => $5dcef6737f37fe05$export$8ed4a19cbfe116ef);
const $5dcef6737f37fe05$var$deleteSearchParam = (name)=>{
    const url = new URL(window.location.href);
    if (url.searchParams.has(name)) {
        url.searchParams.delete(name);
        window.history.replaceState({}, '', url.toString());
    }
};
const $5dcef6737f37fe05$export$cea57e52bbb16e9c = (name)=>{
    const url = new URL(window.location.href);
    const paramValue = url.searchParams.get(name);
    return paramValue ? decodeURIComponent(paramValue) : '';
};
const $5dcef6737f37fe05$export$8ed4a19cbfe116ef = (name)=>{
    const param = $5dcef6737f37fe05$export$cea57e52bbb16e9c(name);
    param && $5dcef6737f37fe05$var$deleteSearchParam(name);
    return param;
};

});

parcelRegister("buJ37", function(module, exports) {

$parcel$export(module.exports, "isNotEmpty", () => $85e570ea2b280422$export$a079a83b07f794bf);
$parcel$export(module.exports, "isChecked", () => $85e570ea2b280422$export$ecc98dea0bb74423);
$parcel$export(module.exports, "hasMinimumPasswordLength", () => $85e570ea2b280422$export$e968c60c18578e62);
$parcel$export(module.exports, "hasLowerCaseCharacter", () => $85e570ea2b280422$export$816afc96b9658c7);
$parcel$export(module.exports, "hasUpperCaseCharacter", () => $85e570ea2b280422$export$6329d20e904c7026);
$parcel$export(module.exports, "isValidEmailFormat", () => $85e570ea2b280422$export$f85afd79e5172509);
$parcel$export(module.exports, "isEmailDomainAllowed", () => $85e570ea2b280422$export$9d32587527170990);
$parcel$export(module.exports, "isInternalEmailAddress", () => $85e570ea2b280422$export$da42d54f7de6598);
const $85e570ea2b280422$export$a079a83b07f794bf = ({ value: value })=>{
    return value.trim().length > 0;
};
const $85e570ea2b280422$export$ecc98dea0bb74423 = ({ checked: checked })=>{
    return checked === true;
};
const $85e570ea2b280422$export$e968c60c18578e62 = ({ value: value })=>{
    return new RegExp(/.{12,}/).exec(value) ? true : false;
};
const $85e570ea2b280422$export$816afc96b9658c7 = ({ value: value })=>{
    return new RegExp(/[a-zßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]{1,}/).exec(value) ? true : false;
};
const $85e570ea2b280422$export$6329d20e904c7026 = ({ value: value })=>{
    return new RegExp(/[A-ZÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞ]{1,}/).exec(value) ? true : false;
};
const $85e570ea2b280422$export$f85afd79e5172509 = ({ value: value })=>{
    return new RegExp(/^[^\s@]+@[^\s@.,]+\.+[^\s@,]{2,}$/).exec(value) ? true : false;
};
const $85e570ea2b280422$export$9d32587527170990 = ({ value: value, blacklist: blacklist })=>{
    const parts = value.split('@');
    if (parts.length < 2 || !parts[1]) return false;
    const domain = parts[1].toLowerCase();
    return !blacklist.includes(domain);
};
const $85e570ea2b280422$export$da42d54f7de6598 = (emailAddress, regexPatterns)=>{
    return regexPatterns.some((regEx)=>emailAddress.match(regEx));
};

});

parcelRegister("dF99X", function(module, exports) {

$parcel$export(module.exports, "useTrialPersistence", () => $9f26359d0031c6ba$export$77774e0b9bd07495);
const $9f26359d0031c6ba$var$TRIAL_STATE_KEY = 'trial_state';
function $9f26359d0031c6ba$export$77774e0b9bd07495() {
    const getPersistedState = ()=>{
        try {
            const saved = sessionStorage.getItem($9f26359d0031c6ba$var$TRIAL_STATE_KEY);
            return saved ? JSON.parse(saved) : {};
        } catch  {
            return {};
        }
    };
    const getPersistedValue = (key)=>{
        const persistedState = getPersistedState();
        return persistedState[key];
    };
    const persistState = (stateObject)=>{
        try {
            sessionStorage.setItem($9f26359d0031c6ba$var$TRIAL_STATE_KEY, JSON.stringify(stateObject));
        } catch (error) {
            console.warn('Error persisting trial state:', error);
        }
    };
    const clearPersistedState = ()=>{
        sessionStorage.removeItem($9f26359d0031c6ba$var$TRIAL_STATE_KEY);
    };
    return {
        getPersistedValue: getPersistedValue,
        persistState: persistState,
        clearPersistedState: clearPersistedState
    };
}

});


parcelRegister("9X7vN", function(module, exports) {

$parcel$export(module.exports, "useVisibility", () => $73ef7372db762aa7$export$83920e874200e13a);

var $8NFma = parcelRequire("8NFma");
const $73ef7372db762aa7$export$83920e874200e13a = ()=>{
    const ref = (0, $8NFma.useRef)(null);
    const [isVisible, setIsVisible] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        const onCheckVisibility = ()=>setIsVisible(ref.current && ref.current.checkVisibility());
        onCheckVisibility();
        window.addEventListener('resize', onCheckVisibility);
        return ()=>window.removeEventListener('resize', onCheckVisibility);
    }, []);
    return {
        ref: ref,
        isVisible: isVisible
    };
};

});

parcelRegister("f8Sxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b061e84018658a02$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");
parcelRequire("20KBz");
var $9ucXG = parcelRequire("9ucXG");

var $87IXO = parcelRequire("87IXO");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $geZyD = parcelRequire("geZyD");

var $f8BWH = parcelRequire("f8BWH");

var $kUEQf = parcelRequire("kUEQf");

var $3GPK4 = parcelRequire("3GPK4");

var $jGN5E = parcelRequire("jGN5E");

var $3ZMdc = parcelRequire("3ZMdc");

var $5xIc7 = parcelRequire("5xIc7");

var $b3BVG = parcelRequire("b3BVG");
function $b061e84018658a02$var$SelectionControls({ step: step, customizationOptions: customizationOptions, selection: selection, onChangeOption: onChangeOption, getLabel: getLabel }) {
    const mappedOptions = (0, $8NFma.useMemo)(()=>customizationOptions.map(({ id: id, name: name })=>({
                value: id,
                label: name
            })), [
        customizationOptions
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "selection__controls",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $b3BVG.default), {
                label: getLabel(step === 0 ? 'customization_select_goal_label' : 'customization_select_role_label'),
                onChange: onChangeOption,
                options: mappedOptions,
                testId: "trial-option-select",
                value: selection[step].value
            }),
            customizationOptions.map((option)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $5xIc7.default), {
                    name: step.toString(),
                    id: option.id,
                    value: option.id,
                    checked: option.id === selection[step].value,
                    callback: onChangeOption,
                    label: option.name,
                    testId: "trial-option-radio"
                }, `option-${step}-${option.id}`))
        ]
    });
}
$b061e84018658a02$var$SelectionControls.propTypes = {
    step: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired,
    customizationOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array.isRequired,
    selection: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array.isRequired,
    onChangeOption: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};
function $b061e84018658a02$export$2e2bcd8739ae039({ data: data, getLabel: getLabel, onCompleteCustomization: onCompleteCustomization, setSceneData: setSceneData }) {
    const { customizationOptions: customizationOptions, finishCustomization: finishCustomization, goToFirstStep: goToFirstStep, goToNextStep: goToNextStep, onChangeOption: onChangeOption, onCustomInputChange: onCustomInputChange, selection: selection, skipCustomization: skipCustomization, step: step, totalSteps: totalSteps } = (0, $geZyD.useCustomization)({
        data: data.customization,
        onCompleteCustomization: onCompleteCustomization
    });
    const { showParticles: showParticles, particleOptions: particleOptions, particlesLoaded: particlesLoaded } = (0, $f8BWH.useParticles)(step);
    (0, $kUEQf.useScene)(step < 2 ? 'customization' : 'completion', {
        data: data,
        setSceneData: setSceneData
    });
    // Map step to heading content for readability
    const headingMap = [
        {
            title: getLabel('customization_heading_goal_selection'),
            subtitle: getLabel('customization_subtitle_goal_selection')
        },
        {
            title: getLabel('customization_heading_role_selection'),
            subtitle: getLabel('customization_subtitle_role_selection')
        },
        {
            title: getLabel('customization_heading_completion'),
            subtitle: ''
        }
    ];
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jGN5E.default), {
                title: headingMap[step].title,
                subtitle: headingMap[step].subtitle
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "trial__customization",
                children: [
                    step < 2 ? /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                className: "customization__selection",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)($b061e84018658a02$var$SelectionControls, {
                                        step: step,
                                        customizationOptions: customizationOptions,
                                        selection: selection,
                                        onChangeOption: onChangeOption,
                                        getLabel: getLabel
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        className: "selection__visual",
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3GPK4.default), {
                                            data: data.customization,
                                            selection: selection,
                                            step: step
                                        })
                                    })
                                ]
                            }),
                            selection[step].value === 'custom' && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3ZMdc.default), {
                                name: "custom",
                                label: getLabel(step === 0 ? 'customization_custom_goal_input_label' : 'customization_custom_role_input_label'),
                                onChange: onCustomInputChange,
                                value: selection[step].label
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "customization__completion",
                        children: [
                            showParticles && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9ucXG.default), {
                                id: "tsparticles",
                                options: particleOptions,
                                particlesLoaded: particlesLoaded
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                                src: data.visuals.completion.full_url,
                                alt: data.visuals.completion.alt,
                                srcSet: data.visuals.completion.srcset
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "customization__navigation",
                        children: [
                            step > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.default), {
                                id: "customization-back",
                                testId: "nav-back",
                                onClick: goToFirstStep,
                                children: getLabel('nav_btn_back')
                            }),
                            step < totalSteps - 1 && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.TertiaryButton), {
                                        id: "customization-skip",
                                        testId: "nav-skip",
                                        onClick: skipCustomization,
                                        children: getLabel('nav_btn_skip')
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.PrimaryButton), {
                                        id: "customization-next",
                                        testId: "nav-continue",
                                        onClick: goToNextStep,
                                        children: getLabel('nav_btn_continue')
                                    })
                                ]
                            }),
                            step === totalSteps - 1 && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.CountdownButton), {
                                id: "customization-finish",
                                testId: "nav-continue",
                                onClick: finishCustomization,
                                duration: 10,
                                children: getLabel('nav_btn_start')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$b061e84018658a02$export$2e2bcd8739ae039.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    onCompleteCustomization: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    setSceneData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};

});
parcelRegister("20KBz", function(module, exports) {

$parcel$export(module.exports, "initParticlesEngine", () => $176fbb9e4b3fae9a$export$972a5b41ed1202df);
$parcel$export(module.exports, "default", () => (parcelRequire("9ucXG")).default);

var $2gXdT = parcelRequire("2gXdT");

var $9ucXG = parcelRequire("9ucXG");
parcelRequire("1IdZj");
parcelRequire("8NFma");
async function $176fbb9e4b3fae9a$export$972a5b41ed1202df(t) {
    await t((0, $2gXdT.tsParticles));
}

});
parcelRegister("2gXdT", function(module, exports) {
$parcel$export(module.exports, "AlterType", () => (parcelRequire("1ruWN")).AlterType);
$parcel$export(module.exports, "AnimatableColor", () => (parcelRequire("jXSVo")).AnimatableColor);
$parcel$export(module.exports, "AnimationStatus", () => (parcelRequire("d8kOl")).AnimationStatus);
$parcel$export(module.exports, "arrayRandomIndex", () => (parcelRequire("eDm3t")).arrayRandomIndex);
$parcel$export(module.exports, "calcPositionOrRandomFromSizeRanged", () => (parcelRequire("yZzCW")).calcPositionOrRandomFromSizeRanged);
$parcel$export(module.exports, "calculateBounds", () => (parcelRequire("eDm3t")).calculateBounds);
$parcel$export(module.exports, "clamp", () => (parcelRequire("yZzCW")).clamp);
$parcel$export(module.exports, "deepExtend", () => (parcelRequire("eDm3t")).deepExtend);
$parcel$export(module.exports, "degToRad", () => (parcelRequire("yZzCW")).degToRad);
$parcel$export(module.exports, "DestroyType", () => (parcelRequire("7ecaf")).DestroyType);
$parcel$export(module.exports, "executeOnSingleOrMultiple", () => (parcelRequire("eDm3t")).executeOnSingleOrMultiple);
$parcel$export(module.exports, "getDistance", () => (parcelRequire("yZzCW")).getDistance);
$parcel$export(module.exports, "getDistances", () => (parcelRequire("yZzCW")).getDistances);
$parcel$export(module.exports, "getHslAnimationFromHsl", () => (parcelRequire("6nx5m")).getHslAnimationFromHsl);
$parcel$export(module.exports, "getRandom", () => (parcelRequire("yZzCW")).getRandom);
$parcel$export(module.exports, "getRangeMax", () => (parcelRequire("yZzCW")).getRangeMax);
$parcel$export(module.exports, "getRangeValue", () => (parcelRequire("yZzCW")).getRangeValue);
$parcel$export(module.exports, "getSize", () => (parcelRequire("eDm3t")).getSize);
$parcel$export(module.exports, "half", () => (parcelRequire("eywbI")).half);
$parcel$export(module.exports, "hslaToRgba", () => (parcelRequire("6nx5m")).hslaToRgba);
$parcel$export(module.exports, "hslToRgb", () => (parcelRequire("6nx5m")).hslToRgb);
$parcel$export(module.exports, "initParticleNumericAnimationValue", () => (parcelRequire("eDm3t")).initParticleNumericAnimationValue);
$parcel$export(module.exports, "isArray", () => (parcelRequire("62pjT")).isArray);
$parcel$export(module.exports, "isInArray", () => (parcelRequire("eDm3t")).isInArray);
$parcel$export(module.exports, "isNull", () => (parcelRequire("62pjT")).isNull);
$parcel$export(module.exports, "isNumber", () => (parcelRequire("62pjT")).isNumber);
$parcel$export(module.exports, "isObject", () => (parcelRequire("62pjT")).isObject);
$parcel$export(module.exports, "isPointInside", () => (parcelRequire("eDm3t")).isPointInside);
$parcel$export(module.exports, "itemFromArray", () => (parcelRequire("eDm3t")).itemFromArray);
$parcel$export(module.exports, "itemFromSingleOrMultiple", () => (parcelRequire("eDm3t")).itemFromSingleOrMultiple);
$parcel$export(module.exports, "millisecondsToSeconds", () => (parcelRequire("eywbI")).millisecondsToSeconds);
$parcel$export(module.exports, "OptionsColor", () => (parcelRequire("hzwm7")).OptionsColor);
$parcel$export(module.exports, "OutMode", () => (parcelRequire("eBPJQ")).OutMode);
$parcel$export(module.exports, "OutModeDirection", () => (parcelRequire("6VMPk")).OutModeDirection);
$parcel$export(module.exports, "parseAlpha", () => (parcelRequire("yZzCW")).parseAlpha);
$parcel$export(module.exports, "ParticleOutType", () => (parcelRequire("3SKQC")).ParticleOutType);
$parcel$export(module.exports, "percentDenominator", () => (parcelRequire("eywbI")).percentDenominator);
$parcel$export(module.exports, "PixelMode", () => (parcelRequire("5r4A4")).PixelMode);
$parcel$export(module.exports, "randomInRange", () => (parcelRequire("yZzCW")).randomInRange);
$parcel$export(module.exports, "rangeColorToHsl", () => (parcelRequire("6nx5m")).rangeColorToHsl);
$parcel$export(module.exports, "RotateDirection", () => (parcelRequire("WiXRo")).RotateDirection);
$parcel$export(module.exports, "safeMatchMedia", () => (parcelRequire("eDm3t")).safeMatchMedia);
$parcel$export(module.exports, "setRangeValue", () => (parcelRequire("yZzCW")).setRangeValue);
$parcel$export(module.exports, "updateAnimation", () => (parcelRequire("eDm3t")).updateAnimation);
$parcel$export(module.exports, "updateColor", () => (parcelRequire("6nx5m")).updateColor);
$parcel$export(module.exports, "ValueWithRandom", () => (parcelRequire("hAZRJ")).ValueWithRandom);
$parcel$export(module.exports, "Vector", () => (parcelRequire("aocC0")).Vector);

$parcel$export(module.exports, "tsParticles", () => $1a7b03dea4740212$export$218c38ca7c058037);

var $kP165 = parcelRequire("kP165");

var $eDm3t = parcelRequire("eDm3t");
parcelRequire("3ZPxj");
parcelRequire("bfrqN");
const $1a7b03dea4740212$export$218c38ca7c058037 = (0, $kP165.init)();
if (!(0, $eDm3t.isSsr)()) window.tsParticles = $1a7b03dea4740212$export$218c38ca7c058037;

});
parcelRegister("kP165", function(module, exports) {

$parcel$export(module.exports, "init", () => $f2896bf5107e6b60$export$2cd8252107eb640b);

var $8RrOV = parcelRequire("8RrOV");
function $f2896bf5107e6b60$export$2cd8252107eb640b() {
    const engine = new (0, $8RrOV.Engine)();
    engine.init();
    return engine;
}

});
parcelRegister("8RrOV", function(module, exports) {

$parcel$export(module.exports, "Engine", () => $6738da88422b2843$export$2c3b404bf3a77a1f);

var $eywbI = parcelRequire("eywbI");

var $eDm3t = parcelRequire("eDm3t");

var $71IWX = parcelRequire("71IWX");

var $63ULI = parcelRequire("63ULI");

var $3ikOd = parcelRequire("3ikOd");

var $yZzCW = parcelRequire("yZzCW");
async function $6738da88422b2843$var$getItemsFromInitializer(container, map, initializers, force = false) {
    let res = map.get(container);
    if (!res || force) {
        res = await Promise.all([
            ...initializers.values()
        ].map((t)=>t(container)));
        map.set(container, res);
    }
    return res;
}
async function $6738da88422b2843$var$getDataFromUrl(data) {
    const url = (0, $eDm3t.itemFromSingleOrMultiple)(data.url, data.index);
    if (!url) return data.fallback;
    const response = await fetch(url);
    if (response.ok) return await response.json();
    (0, $eDm3t.getLogger)().error(`${(0, $eywbI.errorPrefix)} ${response.status} while retrieving config file`);
    return data.fallback;
}
const $6738da88422b2843$var$getCanvasFromContainer = (domContainer)=>{
    let canvasEl;
    if (domContainer instanceof HTMLCanvasElement || domContainer.tagName.toLowerCase() === (0, $eywbI.canvasTag)) {
        canvasEl = domContainer;
        if (!canvasEl.dataset[0, $eywbI.generatedAttribute]) canvasEl.dataset[0, $eywbI.generatedAttribute] = (0, $eywbI.generatedFalse);
    } else {
        const existingCanvases = domContainer.getElementsByTagName((0, $eywbI.canvasTag));
        if (existingCanvases.length) {
            canvasEl = existingCanvases[0, $eywbI.canvasFirstIndex];
            canvasEl.dataset[0, $eywbI.generatedAttribute] = (0, $eywbI.generatedFalse);
        } else {
            canvasEl = document.createElement((0, $eywbI.canvasTag));
            canvasEl.dataset[0, $eywbI.generatedAttribute] = (0, $eywbI.generatedTrue);
            domContainer.appendChild(canvasEl);
        }
    }
    const fullPercent = "100%";
    if (!canvasEl.style.width) canvasEl.style.width = fullPercent;
    if (!canvasEl.style.height) canvasEl.style.height = fullPercent;
    return canvasEl;
}, $6738da88422b2843$var$getDomContainer = (id, source)=>{
    let domContainer = source ?? document.getElementById(id);
    if (domContainer) return domContainer;
    domContainer = document.createElement("div");
    domContainer.id = id;
    domContainer.dataset[0, $eywbI.generatedAttribute] = (0, $eywbI.generatedTrue);
    document.body.append(domContainer);
    return domContainer;
};
class $6738da88422b2843$export$2c3b404bf3a77a1f {
    constructor(){
        this._configs = new Map();
        this._domArray = [];
        this._eventDispatcher = new (0, $63ULI.EventDispatcher)();
        this._initialized = false;
        this.plugins = [];
        this.colorManagers = new Map();
        this.easingFunctions = new Map();
        this._initializers = {
            interactors: new Map(),
            movers: new Map(),
            updaters: new Map()
        };
        this.interactors = new Map();
        this.movers = new Map();
        this.updaters = new Map();
        this.presets = new Map();
        this.effectDrawers = new Map();
        this.shapeDrawers = new Map();
        this.pathGenerators = new Map();
    }
    get configs() {
        const res = {};
        for (const [name, config] of this._configs)res[name] = config;
        return res;
    }
    get items() {
        return this._domArray;
    }
    get version() {
        return "3.8.1";
    }
    async addColorManager(manager, refresh = true) {
        this.colorManagers.set(manager.key, manager);
        await this.refresh(refresh);
    }
    addConfig(config) {
        const key = config.key ?? config.name ?? "default";
        this._configs.set(key, config);
        this._eventDispatcher.dispatchEvent((0, $3ikOd.EventType).configAdded, {
            data: {
                name: key,
                config: config
            }
        });
    }
    async addEasing(name, easing, refresh = true) {
        if (this.getEasing(name)) return;
        this.easingFunctions.set(name, easing);
        await this.refresh(refresh);
    }
    async addEffect(effect, drawer, refresh = true) {
        (0, $eDm3t.executeOnSingleOrMultiple)(effect, (type)=>{
            if (!this.getEffectDrawer(type)) this.effectDrawers.set(type, drawer);
        });
        await this.refresh(refresh);
    }
    addEventListener(type, listener) {
        this._eventDispatcher.addEventListener(type, listener);
    }
    async addInteractor(name, interactorInitializer, refresh = true) {
        this._initializers.interactors.set(name, interactorInitializer);
        await this.refresh(refresh);
    }
    async addMover(name, moverInitializer, refresh = true) {
        this._initializers.movers.set(name, moverInitializer);
        await this.refresh(refresh);
    }
    async addParticleUpdater(name, updaterInitializer, refresh = true) {
        this._initializers.updaters.set(name, updaterInitializer);
        await this.refresh(refresh);
    }
    async addPathGenerator(name, generator, refresh = true) {
        if (!this.getPathGenerator(name)) this.pathGenerators.set(name, generator);
        await this.refresh(refresh);
    }
    async addPlugin(plugin, refresh = true) {
        if (!this.getPlugin(plugin.id)) this.plugins.push(plugin);
        await this.refresh(refresh);
    }
    async addPreset(preset, options, override = false, refresh = true) {
        if (override || !this.getPreset(preset)) this.presets.set(preset, options);
        await this.refresh(refresh);
    }
    async addShape(drawer, refresh = true) {
        for (const validType of drawer.validTypes){
            if (this.getShapeDrawer(validType)) continue;
            this.shapeDrawers.set(validType, drawer);
        }
        await this.refresh(refresh);
    }
    checkVersion(pluginVersion) {
        if (this.version === pluginVersion) return;
        throw new Error(`The tsParticles version is different from the loaded plugins version. Engine version: ${this.version}. Plugin version: ${pluginVersion}`);
    }
    clearPlugins(container) {
        this.updaters.delete(container);
        this.movers.delete(container);
        this.interactors.delete(container);
    }
    dispatchEvent(type, args) {
        this._eventDispatcher.dispatchEvent(type, args);
    }
    dom() {
        return this.items;
    }
    domItem(index) {
        return this.item(index);
    }
    async getAvailablePlugins(container) {
        const res = new Map();
        for (const plugin of this.plugins)if (plugin.needsPlugin(container.actualOptions)) res.set(plugin.id, await plugin.getPlugin(container));
        return res;
    }
    getEasing(name) {
        return this.easingFunctions.get(name) ?? ((value)=>value);
    }
    getEffectDrawer(type) {
        return this.effectDrawers.get(type);
    }
    async getInteractors(container, force = false) {
        return $6738da88422b2843$var$getItemsFromInitializer(container, this.interactors, this._initializers.interactors, force);
    }
    async getMovers(container, force = false) {
        return $6738da88422b2843$var$getItemsFromInitializer(container, this.movers, this._initializers.movers, force);
    }
    getPathGenerator(type) {
        return this.pathGenerators.get(type);
    }
    getPlugin(plugin) {
        return this.plugins.find((t)=>t.id === plugin);
    }
    getPreset(preset) {
        return this.presets.get(preset);
    }
    getShapeDrawer(type) {
        return this.shapeDrawers.get(type);
    }
    getSupportedEffects() {
        return this.effectDrawers.keys();
    }
    getSupportedShapes() {
        return this.shapeDrawers.keys();
    }
    async getUpdaters(container, force = false) {
        return $6738da88422b2843$var$getItemsFromInitializer(container, this.updaters, this._initializers.updaters, force);
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
    }
    item(index) {
        const { items: items } = this, item = items[index];
        if (!item || item.destroyed) {
            items.splice(index, (0, $eywbI.removeDeleteCount));
            return;
        }
        return item;
    }
    async load(params) {
        const id = params.id ?? params.element?.id ?? `tsparticles${Math.floor((0, $yZzCW.getRandom)() * (0, $eywbI.loadRandomFactor))}`, { index: index, url: url } = params, options = url ? await $6738da88422b2843$var$getDataFromUrl({
            fallback: params.options,
            url: url,
            index: index
        }) : params.options;
        const currentOptions = (0, $eDm3t.itemFromSingleOrMultiple)(options, index), { items: items } = this, oldIndex = items.findIndex((v)=>v.id.description === id), newItem = new (0, $71IWX.Container)(this, id, currentOptions);
        if (oldIndex >= (0, $eywbI.loadMinIndex)) {
            const old = this.item(oldIndex), deleteCount = old ? (0, $eywbI.one) : (0, $eywbI.none);
            if (old && !old.destroyed) old.destroy(false);
            items.splice(oldIndex, deleteCount, newItem);
        } else items.push(newItem);
        const domContainer = $6738da88422b2843$var$getDomContainer(id, params.element), canvasEl = $6738da88422b2843$var$getCanvasFromContainer(domContainer);
        newItem.canvas.loadCanvas(canvasEl);
        await newItem.start();
        return newItem;
    }
    loadOptions(options, sourceOptions) {
        this.plugins.forEach((plugin)=>plugin.loadOptions?.(options, sourceOptions));
    }
    loadParticlesOptions(container, options, ...sourceOptions) {
        const updaters = this.updaters.get(container);
        if (!updaters) return;
        updaters.forEach((updater)=>updater.loadOptions?.(options, ...sourceOptions));
    }
    async refresh(refresh = true) {
        if (!refresh) return;
        await Promise.all(this.items.map((t)=>t.refresh()));
    }
    removeEventListener(type, listener) {
        this._eventDispatcher.removeEventListener(type, listener);
    }
    setOnClickHandler(callback) {
        const { items: items } = this;
        if (!items.length) throw new Error(`${(0, $eywbI.errorPrefix)} can only set click handlers after calling tsParticles.load()`);
        items.forEach((item)=>item.addClickHandler(callback));
    }
}

});
parcelRegister("eywbI", function(module, exports) {

$parcel$export(module.exports, "generatedAttribute", () => $a98d35823ce3a97c$export$4a278486528d5cfb);
$parcel$export(module.exports, "mouseDownEvent", () => $a98d35823ce3a97c$export$9ffd73c9a0e32c34);
$parcel$export(module.exports, "mouseUpEvent", () => $a98d35823ce3a97c$export$9fb0268ce1bdbca0);
$parcel$export(module.exports, "mouseLeaveEvent", () => $a98d35823ce3a97c$export$f4b184a85a586f8a);
$parcel$export(module.exports, "mouseOutEvent", () => $a98d35823ce3a97c$export$55cc1d6a692feb2b);
$parcel$export(module.exports, "mouseMoveEvent", () => $a98d35823ce3a97c$export$1ffe551d7d33cd33);
$parcel$export(module.exports, "touchStartEvent", () => $a98d35823ce3a97c$export$d5353b6c79bbcc70);
$parcel$export(module.exports, "touchEndEvent", () => $a98d35823ce3a97c$export$11164630b85c192d);
$parcel$export(module.exports, "touchMoveEvent", () => $a98d35823ce3a97c$export$d28a82874c0e6212);
$parcel$export(module.exports, "touchCancelEvent", () => $a98d35823ce3a97c$export$65db1c69591947a7);
$parcel$export(module.exports, "resizeEvent", () => $a98d35823ce3a97c$export$8b3d73c91cd7cc65);
$parcel$export(module.exports, "visibilityChangeEvent", () => $a98d35823ce3a97c$export$73536144dc68dd0f);
$parcel$export(module.exports, "errorPrefix", () => $a98d35823ce3a97c$export$adea4917e02d93dc);
$parcel$export(module.exports, "percentDenominator", () => $a98d35823ce3a97c$export$9519bca7a9fbeccd);
$parcel$export(module.exports, "half", () => $a98d35823ce3a97c$export$3ced024fb15e6103);
$parcel$export(module.exports, "millisecondsToSeconds", () => $a98d35823ce3a97c$export$f64c3bfbc58eec0f);
$parcel$export(module.exports, "originPoint", () => $a98d35823ce3a97c$export$8a573f14667e8170);
$parcel$export(module.exports, "defaultTransform", () => $a98d35823ce3a97c$export$d8a7bebef127c134);
$parcel$export(module.exports, "randomColorValue", () => $a98d35823ce3a97c$export$2f8238aef5a0a8eb);
$parcel$export(module.exports, "midColorValue", () => $a98d35823ce3a97c$export$7b5f45763ca224ae);
$parcel$export(module.exports, "double", () => $a98d35823ce3a97c$export$7b3cbda67be88f5f);
$parcel$export(module.exports, "doublePI", () => $a98d35823ce3a97c$export$99aad4f300723eb5);
$parcel$export(module.exports, "defaultFps", () => $a98d35823ce3a97c$export$a58a85a1d96b5da5);
$parcel$export(module.exports, "generatedTrue", () => $a98d35823ce3a97c$export$f4379e05d59339d2);
$parcel$export(module.exports, "generatedFalse", () => $a98d35823ce3a97c$export$c392cf7a2bd47e88);
$parcel$export(module.exports, "canvasTag", () => $a98d35823ce3a97c$export$af8f840c6caca708);
$parcel$export(module.exports, "defaultRetryCount", () => $a98d35823ce3a97c$export$b0d937bb246b1db5);
$parcel$export(module.exports, "squareExp", () => $a98d35823ce3a97c$export$69af1894d00750e2);
$parcel$export(module.exports, "qTreeCapacity", () => $a98d35823ce3a97c$export$ff9931f04b025271);
$parcel$export(module.exports, "defaultRemoveQuantity", () => $a98d35823ce3a97c$export$1f93977e73a42602);
$parcel$export(module.exports, "defaultRatio", () => $a98d35823ce3a97c$export$728175ae61348876);
$parcel$export(module.exports, "defaultReduceFactor", () => $a98d35823ce3a97c$export$7e2d520c66b9f331);
$parcel$export(module.exports, "subdivideCount", () => $a98d35823ce3a97c$export$857680dbc0592f23);
$parcel$export(module.exports, "inverseFactorNumerator", () => $a98d35823ce3a97c$export$6a43a0894b8f8dd4);
$parcel$export(module.exports, "rgbMax", () => $a98d35823ce3a97c$export$7bf8bd2b1c3673be);
$parcel$export(module.exports, "hMax", () => $a98d35823ce3a97c$export$80d6dd9687da66fc);
$parcel$export(module.exports, "sMax", () => $a98d35823ce3a97c$export$d6110320394e154a);
$parcel$export(module.exports, "lMax", () => $a98d35823ce3a97c$export$9f8a886f88503d81);
$parcel$export(module.exports, "hMin", () => $a98d35823ce3a97c$export$59af4a43228d42f9);
$parcel$export(module.exports, "sMin", () => $a98d35823ce3a97c$export$6d036dc8238eb540);
$parcel$export(module.exports, "hPhase", () => $a98d35823ce3a97c$export$4639db465b79e483);
$parcel$export(module.exports, "empty", () => $a98d35823ce3a97c$export$6e22c362a0406a2c);
$parcel$export(module.exports, "quarter", () => $a98d35823ce3a97c$export$813f5834b9d5379d);
$parcel$export(module.exports, "threeQuarter", () => $a98d35823ce3a97c$export$9f9801c27507097c);
$parcel$export(module.exports, "minVelocity", () => $a98d35823ce3a97c$export$82701eab16caadaa);
$parcel$export(module.exports, "defaultTransformValue", () => $a98d35823ce3a97c$export$1f10c01143b9f089);
$parcel$export(module.exports, "minimumSize", () => $a98d35823ce3a97c$export$4b0ea52aa81e1ca2);
$parcel$export(module.exports, "minimumLength", () => $a98d35823ce3a97c$export$920ec94752436dad);
$parcel$export(module.exports, "zIndexFactorOffset", () => $a98d35823ce3a97c$export$6ca59ab71c007a1b);
$parcel$export(module.exports, "defaultOpacity", () => $a98d35823ce3a97c$export$7395e4cb572e863b);
$parcel$export(module.exports, "clickRadius", () => $a98d35823ce3a97c$export$ed597c6eb324bc8f);
$parcel$export(module.exports, "touchEndLengthOffset", () => $a98d35823ce3a97c$export$7a917036bd0c18e0);
$parcel$export(module.exports, "minCoordinate", () => $a98d35823ce3a97c$export$17c6bab6aae4c3d);
$parcel$export(module.exports, "removeDeleteCount", () => $a98d35823ce3a97c$export$310c6557edf6330f);
$parcel$export(module.exports, "removeMinIndex", () => $a98d35823ce3a97c$export$6347387141f4c7b9);
$parcel$export(module.exports, "defaultFpsLimit", () => $a98d35823ce3a97c$export$a1db07711c3c21cf);
$parcel$export(module.exports, "minFpsLimit", () => $a98d35823ce3a97c$export$1f9ec247b9f4a442);
$parcel$export(module.exports, "canvasFirstIndex", () => $a98d35823ce3a97c$export$878d5c9fc03f6a6f);
$parcel$export(module.exports, "loadRandomFactor", () => $a98d35823ce3a97c$export$d20f7c11146fd35);
$parcel$export(module.exports, "loadMinIndex", () => $a98d35823ce3a97c$export$a0a8145c86a935c7);
$parcel$export(module.exports, "one", () => $a98d35823ce3a97c$export$80bf7733f1207381);
$parcel$export(module.exports, "none", () => $a98d35823ce3a97c$export$f883a24d5edde77c);
$parcel$export(module.exports, "decayOffset", () => $a98d35823ce3a97c$export$a05b467d53228ab9);
$parcel$export(module.exports, "tryCountIncrement", () => $a98d35823ce3a97c$export$c6a00718c1294b26);
$parcel$export(module.exports, "minRetries", () => $a98d35823ce3a97c$export$9ad4c81d91619fd0);
$parcel$export(module.exports, "rollFactor", () => $a98d35823ce3a97c$export$40d4bf4da5fab6a3);
$parcel$export(module.exports, "minZ", () => $a98d35823ce3a97c$export$ce94e349d95a214c);
$parcel$export(module.exports, "defaultRadius", () => $a98d35823ce3a97c$export$7dab3a147ef97e31);
$parcel$export(module.exports, "posOffset", () => $a98d35823ce3a97c$export$3824525d016aa873);
$parcel$export(module.exports, "sizeFactor", () => $a98d35823ce3a97c$export$59892a8b616aa484);
$parcel$export(module.exports, "minLimit", () => $a98d35823ce3a97c$export$e82fde291e144b99);
$parcel$export(module.exports, "countOffset", () => $a98d35823ce3a97c$export$1fe1264f46963094);
$parcel$export(module.exports, "minCount", () => $a98d35823ce3a97c$export$da4e5697b3441fa1);
$parcel$export(module.exports, "minIndex", () => $a98d35823ce3a97c$export$e410eba367ce792b);
$parcel$export(module.exports, "manualCount", () => $a98d35823ce3a97c$export$1d2b1c0c1b891aba);
$parcel$export(module.exports, "lengthOffset", () => $a98d35823ce3a97c$export$4a5b9680be542cf8);
$parcel$export(module.exports, "defaultDensityFactor", () => $a98d35823ce3a97c$export$9b262e3383f198e7);
$parcel$export(module.exports, "deleteCount", () => $a98d35823ce3a97c$export$346cdd8493ece6c8);
$parcel$export(module.exports, "touchDelay", () => $a98d35823ce3a97c$export$a31a053ae1bfc10e);
$parcel$export(module.exports, "manualDefaultPosition", () => $a98d35823ce3a97c$export$d4e77d4b7e9933c7);
$parcel$export(module.exports, "defaultAngle", () => $a98d35823ce3a97c$export$573f1d3d887db8cc);
$parcel$export(module.exports, "identity", () => $a98d35823ce3a97c$export$f0954fd7d5368655);
$parcel$export(module.exports, "minStrokeWidth", () => $a98d35823ce3a97c$export$1f010363d1c40031);
$parcel$export(module.exports, "lFactor", () => $a98d35823ce3a97c$export$6438bad23c977d39);
$parcel$export(module.exports, "lMin", () => $a98d35823ce3a97c$export$42fd2de68d60a133);
$parcel$export(module.exports, "rgbFactor", () => $a98d35823ce3a97c$export$15b8ea3279320e86);
$parcel$export(module.exports, "triple", () => $a98d35823ce3a97c$export$515818ff8d37c07d);
$parcel$export(module.exports, "sextuple", () => $a98d35823ce3a97c$export$7a7038229fab314f);
$parcel$export(module.exports, "sNormalizedOffset", () => $a98d35823ce3a97c$export$43104ff2632aa202);
$parcel$export(module.exports, "phaseNumerator", () => $a98d35823ce3a97c$export$af5f0fbc6d135058);
$parcel$export(module.exports, "defaultRgbMin", () => $a98d35823ce3a97c$export$d13fc714138cfb02);
$parcel$export(module.exports, "defaultVelocity", () => $a98d35823ce3a97c$export$2d575d8dbe8cd673);
$parcel$export(module.exports, "defaultLoops", () => $a98d35823ce3a97c$export$ac39eb160969ecba);
$parcel$export(module.exports, "defaultTime", () => $a98d35823ce3a97c$export$7c140f4e42af7fd8);
const $a98d35823ce3a97c$export$4a278486528d5cfb = "generated", $a98d35823ce3a97c$export$9ffd73c9a0e32c34 = "pointerdown", $a98d35823ce3a97c$export$9fb0268ce1bdbca0 = "pointerup", $a98d35823ce3a97c$export$f4b184a85a586f8a = "pointerleave", $a98d35823ce3a97c$export$55cc1d6a692feb2b = "pointerout", $a98d35823ce3a97c$export$1ffe551d7d33cd33 = "pointermove", $a98d35823ce3a97c$export$d5353b6c79bbcc70 = "touchstart", $a98d35823ce3a97c$export$11164630b85c192d = "touchend", $a98d35823ce3a97c$export$d28a82874c0e6212 = "touchmove", $a98d35823ce3a97c$export$65db1c69591947a7 = "touchcancel", $a98d35823ce3a97c$export$8b3d73c91cd7cc65 = "resize", $a98d35823ce3a97c$export$73536144dc68dd0f = "visibilitychange", $a98d35823ce3a97c$export$adea4917e02d93dc = "tsParticles - Error", $a98d35823ce3a97c$export$9519bca7a9fbeccd = 100, $a98d35823ce3a97c$export$3ced024fb15e6103 = 0.5, $a98d35823ce3a97c$export$f64c3bfbc58eec0f = 1000, $a98d35823ce3a97c$export$8a573f14667e8170 = {
    x: 0,
    y: 0,
    z: 0
}, $a98d35823ce3a97c$export$d8a7bebef127c134 = {
    a: 1,
    b: 0,
    c: 0,
    d: 1
}, $a98d35823ce3a97c$export$2f8238aef5a0a8eb = "random", $a98d35823ce3a97c$export$7b5f45763ca224ae = "mid", $a98d35823ce3a97c$export$7b3cbda67be88f5f = 2, $a98d35823ce3a97c$export$99aad4f300723eb5 = Math.PI * $a98d35823ce3a97c$export$7b3cbda67be88f5f, $a98d35823ce3a97c$export$a58a85a1d96b5da5 = 60, $a98d35823ce3a97c$export$f13166301dffe8fb = 1, $a98d35823ce3a97c$export$f4379e05d59339d2 = "true", $a98d35823ce3a97c$export$c392cf7a2bd47e88 = "false", $a98d35823ce3a97c$export$af8f840c6caca708 = "canvas", $a98d35823ce3a97c$export$b0d937bb246b1db5 = 0, $a98d35823ce3a97c$export$69af1894d00750e2 = 2, $a98d35823ce3a97c$export$ff9931f04b025271 = 4, $a98d35823ce3a97c$export$1f93977e73a42602 = 1, $a98d35823ce3a97c$export$728175ae61348876 = 1, $a98d35823ce3a97c$export$7e2d520c66b9f331 = 1, $a98d35823ce3a97c$export$857680dbc0592f23 = 4, $a98d35823ce3a97c$export$6a43a0894b8f8dd4 = 1.0, $a98d35823ce3a97c$export$7bf8bd2b1c3673be = 255, $a98d35823ce3a97c$export$80d6dd9687da66fc = 360, $a98d35823ce3a97c$export$d6110320394e154a = 100, $a98d35823ce3a97c$export$9f8a886f88503d81 = 100, $a98d35823ce3a97c$export$59af4a43228d42f9 = 0, $a98d35823ce3a97c$export$6d036dc8238eb540 = 0, $a98d35823ce3a97c$export$4639db465b79e483 = 60, $a98d35823ce3a97c$export$6e22c362a0406a2c = 0, $a98d35823ce3a97c$export$813f5834b9d5379d = 0.25, $a98d35823ce3a97c$export$9f9801c27507097c = $a98d35823ce3a97c$export$3ced024fb15e6103 + $a98d35823ce3a97c$export$813f5834b9d5379d, $a98d35823ce3a97c$export$82701eab16caadaa = 0, $a98d35823ce3a97c$export$1f10c01143b9f089 = 1, $a98d35823ce3a97c$export$4b0ea52aa81e1ca2 = 0, $a98d35823ce3a97c$export$920ec94752436dad = 0, $a98d35823ce3a97c$export$6ca59ab71c007a1b = 1, $a98d35823ce3a97c$export$7395e4cb572e863b = 1, $a98d35823ce3a97c$export$ed597c6eb324bc8f = 1, $a98d35823ce3a97c$export$7a917036bd0c18e0 = 1, $a98d35823ce3a97c$export$17c6bab6aae4c3d = 0, $a98d35823ce3a97c$export$310c6557edf6330f = 1, $a98d35823ce3a97c$export$6347387141f4c7b9 = 0, $a98d35823ce3a97c$export$a1db07711c3c21cf = 120, $a98d35823ce3a97c$export$1f9ec247b9f4a442 = 0, $a98d35823ce3a97c$export$878d5c9fc03f6a6f = 0, $a98d35823ce3a97c$export$d20f7c11146fd35 = 10000, $a98d35823ce3a97c$export$a0a8145c86a935c7 = 0, $a98d35823ce3a97c$export$80bf7733f1207381 = 1, $a98d35823ce3a97c$export$f883a24d5edde77c = 0, $a98d35823ce3a97c$export$a05b467d53228ab9 = 1, $a98d35823ce3a97c$export$c6a00718c1294b26 = 1, $a98d35823ce3a97c$export$9ad4c81d91619fd0 = 0, $a98d35823ce3a97c$export$40d4bf4da5fab6a3 = 1, $a98d35823ce3a97c$export$ce94e349d95a214c = 0, $a98d35823ce3a97c$export$7dab3a147ef97e31 = 0, $a98d35823ce3a97c$export$3824525d016aa873 = -$a98d35823ce3a97c$export$813f5834b9d5379d, $a98d35823ce3a97c$export$59892a8b616aa484 = 1.5, $a98d35823ce3a97c$export$e82fde291e144b99 = 0, $a98d35823ce3a97c$export$1fe1264f46963094 = 1, $a98d35823ce3a97c$export$da4e5697b3441fa1 = 0, $a98d35823ce3a97c$export$e410eba367ce792b = 0, $a98d35823ce3a97c$export$1d2b1c0c1b891aba = 0, $a98d35823ce3a97c$export$4a5b9680be542cf8 = 1, $a98d35823ce3a97c$export$9b262e3383f198e7 = 1, $a98d35823ce3a97c$export$346cdd8493ece6c8 = 1, $a98d35823ce3a97c$export$a31a053ae1bfc10e = 500, $a98d35823ce3a97c$export$d4e77d4b7e9933c7 = 50, $a98d35823ce3a97c$export$573f1d3d887db8cc = 0, $a98d35823ce3a97c$export$f0954fd7d5368655 = 1, $a98d35823ce3a97c$export$1f010363d1c40031 = 0, $a98d35823ce3a97c$export$6438bad23c977d39 = 1, $a98d35823ce3a97c$export$42fd2de68d60a133 = 0, $a98d35823ce3a97c$export$15b8ea3279320e86 = 255, $a98d35823ce3a97c$export$515818ff8d37c07d = 3, $a98d35823ce3a97c$export$7a7038229fab314f = 6, $a98d35823ce3a97c$export$43104ff2632aa202 = 1, $a98d35823ce3a97c$export$af5f0fbc6d135058 = 1, $a98d35823ce3a97c$export$d13fc714138cfb02 = 0, $a98d35823ce3a97c$export$2d575d8dbe8cd673 = 0, $a98d35823ce3a97c$export$ac39eb160969ecba = 0, $a98d35823ce3a97c$export$7c140f4e42af7fd8 = 0;

});

parcelRegister("eDm3t", function(module, exports) {

$parcel$export(module.exports, "getLogger", () => $aa75d0dbbda18362$export$2b1d391cd05230fd);
$parcel$export(module.exports, "executeOnSingleOrMultiple", () => $aa75d0dbbda18362$export$8e5dc47097396754);
$parcel$export(module.exports, "isSsr", () => $aa75d0dbbda18362$export$460b6777813d3d86);
$parcel$export(module.exports, "safeMatchMedia", () => $aa75d0dbbda18362$export$db32b9574e21e00f);
$parcel$export(module.exports, "safeIntersectionObserver", () => $aa75d0dbbda18362$export$d97d2a93dce76cc2);
$parcel$export(module.exports, "safeMutationObserver", () => $aa75d0dbbda18362$export$c2f9084a48da0641);
$parcel$export(module.exports, "isInArray", () => $aa75d0dbbda18362$export$5e9bb4359042e24b);
$parcel$export(module.exports, "arrayRandomIndex", () => $aa75d0dbbda18362$export$aab6d48e027939d7);
$parcel$export(module.exports, "itemFromArray", () => $aa75d0dbbda18362$export$3a5d12ca7137122f);
$parcel$export(module.exports, "isPointInside", () => $aa75d0dbbda18362$export$2ea42ef493c7076c);
$parcel$export(module.exports, "calculateBounds", () => $aa75d0dbbda18362$export$b0a2169b5f9d18d8);
$parcel$export(module.exports, "deepExtend", () => $aa75d0dbbda18362$export$54e9fb29908872fa);
$parcel$export(module.exports, "itemFromSingleOrMultiple", () => $aa75d0dbbda18362$export$3fbf39566d3ee62e);
$parcel$export(module.exports, "initParticleNumericAnimationValue", () => $aa75d0dbbda18362$export$bebd78259cce4fd);
$parcel$export(module.exports, "getPosition", () => $aa75d0dbbda18362$export$1690e12b840569b9);
$parcel$export(module.exports, "getSize", () => $aa75d0dbbda18362$export$31b21d0167753bb4);
$parcel$export(module.exports, "updateAnimation", () => $aa75d0dbbda18362$export$efead17ed5dcfd2);
$parcel$export(module.exports, "cloneStyle", () => $aa75d0dbbda18362$export$667e8f3bfe6278b7);
$parcel$export(module.exports, "getFullScreenStyle", () => $aa75d0dbbda18362$export$10d1829d88c10e6a);

var $yZzCW = parcelRequire("yZzCW");

var $eywbI = parcelRequire("eywbI");

var $62pjT = parcelRequire("62pjT");

var $bTldy = parcelRequire("bTldy");

var $d8kOl = parcelRequire("d8kOl");

var $7ecaf = parcelRequire("7ecaf");

var $6VMPk = parcelRequire("6VMPk");

var $5r4A4 = parcelRequire("5r4A4");

var $84ZEL = parcelRequire("84ZEL");

var $aocC0 = parcelRequire("aocC0");
const $aa75d0dbbda18362$var$_logger = {
    debug: console.debug,
    error: console.error,
    info: console.info,
    log: console.log,
    verbose: console.log,
    warning: console.warn
};
function $aa75d0dbbda18362$export$3abbd92f765bee58(logger) {
    $aa75d0dbbda18362$var$_logger.debug = logger.debug || $aa75d0dbbda18362$var$_logger.debug;
    $aa75d0dbbda18362$var$_logger.error = logger.error || $aa75d0dbbda18362$var$_logger.error;
    $aa75d0dbbda18362$var$_logger.info = logger.info || $aa75d0dbbda18362$var$_logger.info;
    $aa75d0dbbda18362$var$_logger.log = logger.log || $aa75d0dbbda18362$var$_logger.log;
    $aa75d0dbbda18362$var$_logger.verbose = logger.verbose || $aa75d0dbbda18362$var$_logger.verbose;
    $aa75d0dbbda18362$var$_logger.warning = logger.warning || $aa75d0dbbda18362$var$_logger.warning;
}
function $aa75d0dbbda18362$export$2b1d391cd05230fd() {
    return $aa75d0dbbda18362$var$_logger;
}
function $aa75d0dbbda18362$var$memoize(fn) {
    const cache = new Map();
    return (...args)=>{
        const key = JSON.stringify(args);
        if (cache.has(key)) return cache.get(key);
        const result = fn(...args);
        cache.set(key, result);
        return result;
    };
}
function $aa75d0dbbda18362$var$rectSideBounce(data) {
    const res = {
        bounced: false
    }, { pSide: pSide, pOtherSide: pOtherSide, rectSide: rectSide, rectOtherSide: rectOtherSide, velocity: velocity, factor: factor } = data;
    if (pOtherSide.min < rectOtherSide.min || pOtherSide.min > rectOtherSide.max || pOtherSide.max < rectOtherSide.min || pOtherSide.max > rectOtherSide.max) return res;
    if (pSide.max >= rectSide.min && pSide.max <= (rectSide.max + rectSide.min) * (0, $eywbI.half) && velocity > (0, $eywbI.minVelocity) || pSide.min <= rectSide.max && pSide.min > (rectSide.max + rectSide.min) * (0, $eywbI.half) && velocity < (0, $eywbI.minVelocity)) {
        res.velocity = velocity * -factor;
        res.bounced = true;
    }
    return res;
}
function $aa75d0dbbda18362$var$checkSelector(element, selectors) {
    const res = $aa75d0dbbda18362$export$8e5dc47097396754(selectors, (selector)=>{
        return element.matches(selector);
    });
    return (0, $62pjT.isArray)(res) ? res.some((t)=>t) : res;
}
function $aa75d0dbbda18362$export$460b6777813d3d86() {
    return typeof window === "undefined" || !window || typeof window.document === "undefined" || !window.document;
}
function $aa75d0dbbda18362$export$c242851ed0beda6c() {
    return !$aa75d0dbbda18362$export$460b6777813d3d86() && typeof matchMedia !== "undefined";
}
function $aa75d0dbbda18362$export$db32b9574e21e00f(query) {
    if (!$aa75d0dbbda18362$export$c242851ed0beda6c()) return;
    return matchMedia(query);
}
function $aa75d0dbbda18362$export$d97d2a93dce76cc2(callback) {
    if ($aa75d0dbbda18362$export$460b6777813d3d86() || typeof IntersectionObserver === "undefined") return;
    return new IntersectionObserver(callback);
}
function $aa75d0dbbda18362$export$c2f9084a48da0641(callback) {
    if ($aa75d0dbbda18362$export$460b6777813d3d86() || typeof MutationObserver === "undefined") return;
    return new MutationObserver(callback);
}
function $aa75d0dbbda18362$export$5e9bb4359042e24b(value, array) {
    const invalidIndex = -1;
    return value === array || (0, $62pjT.isArray)(array) && array.indexOf(value) > invalidIndex;
}
async function $aa75d0dbbda18362$export$672089c3debc1182(font, weight) {
    try {
        await document.fonts.load(`${weight ?? "400"} 36px '${font ?? "Verdana"}'`);
    } catch  {}
}
function $aa75d0dbbda18362$export$aab6d48e027939d7(array) {
    return Math.floor((0, $yZzCW.getRandom)() * array.length);
}
function $aa75d0dbbda18362$export$3a5d12ca7137122f(array, index, useIndex = true) {
    return array[index !== undefined && useIndex ? index % array.length : $aa75d0dbbda18362$export$aab6d48e027939d7(array)];
}
function $aa75d0dbbda18362$export$2ea42ef493c7076c(point, size, offset, radius, direction) {
    const minRadius = 0;
    return $aa75d0dbbda18362$export$bb47d4799bdb9a4d($aa75d0dbbda18362$export$b0a2169b5f9d18d8(point, radius ?? minRadius), size, offset, direction);
}
function $aa75d0dbbda18362$export$bb47d4799bdb9a4d(bounds, size, offset, direction) {
    let inside = true;
    if (!direction || direction === (0, $6VMPk.OutModeDirection).bottom) inside = bounds.top < size.height + offset.x;
    if (inside && (!direction || direction === (0, $6VMPk.OutModeDirection).left)) inside = bounds.right > offset.x;
    if (inside && (!direction || direction === (0, $6VMPk.OutModeDirection).right)) inside = bounds.left < size.width + offset.y;
    if (inside && (!direction || direction === (0, $6VMPk.OutModeDirection).top)) inside = bounds.bottom > offset.y;
    return inside;
}
function $aa75d0dbbda18362$export$b0a2169b5f9d18d8(point, radius) {
    return {
        bottom: point.y + radius,
        left: point.x - radius,
        right: point.x + radius,
        top: point.y - radius
    };
}
function $aa75d0dbbda18362$export$54e9fb29908872fa(destination, ...sources) {
    for (const source of sources){
        if (source === undefined || source === null) continue;
        if (!(0, $62pjT.isObject)(source)) {
            destination = source;
            continue;
        }
        const sourceIsArray = Array.isArray(source);
        if (sourceIsArray && ((0, $62pjT.isObject)(destination) || !destination || !Array.isArray(destination))) destination = [];
        else if (!sourceIsArray && ((0, $62pjT.isObject)(destination) || !destination || Array.isArray(destination))) destination = {};
        for(const key in source){
            if (key === "__proto__") continue;
            const sourceDict = source, value = sourceDict[key], destDict = destination;
            destDict[key] = (0, $62pjT.isObject)(value) && Array.isArray(value) ? value.map((v)=>$aa75d0dbbda18362$export$54e9fb29908872fa(destDict[key], v)) : $aa75d0dbbda18362$export$54e9fb29908872fa(destDict[key], value);
        }
    }
    return destination;
}
function $aa75d0dbbda18362$export$5d1f020956707f4(mode, divs) {
    return !!$aa75d0dbbda18362$export$bfd133b0f67a5a3a(divs, (t)=>t.enable && $aa75d0dbbda18362$export$5e9bb4359042e24b(mode, t.mode));
}
function $aa75d0dbbda18362$export$194f9554360903fd(mode, divs, callback) {
    $aa75d0dbbda18362$export$8e5dc47097396754(divs, (div)=>{
        const divMode = div.mode, divEnabled = div.enable;
        if (divEnabled && $aa75d0dbbda18362$export$5e9bb4359042e24b(mode, divMode)) $aa75d0dbbda18362$export$921eaa53ee8b79db(div, callback);
    });
}
function $aa75d0dbbda18362$export$921eaa53ee8b79db(div, callback) {
    const selectors = div.selectors;
    $aa75d0dbbda18362$export$8e5dc47097396754(selectors, (selector)=>{
        callback(selector, div);
    });
}
function $aa75d0dbbda18362$export$f7c2b83aad443adb(divs, element) {
    if (!element || !divs) return;
    return $aa75d0dbbda18362$export$bfd133b0f67a5a3a(divs, (div)=>{
        return $aa75d0dbbda18362$var$checkSelector(element, div.selectors);
    });
}
function $aa75d0dbbda18362$export$11ae16f2acc5c3ba(p) {
    return {
        position: p.getPosition(),
        radius: p.getRadius(),
        mass: p.getMass(),
        velocity: p.velocity,
        factor: (0, $aocC0.Vector).create((0, $yZzCW.getRangeValue)(p.options.bounce.horizontal.value), (0, $yZzCW.getRangeValue)(p.options.bounce.vertical.value))
    };
}
function $aa75d0dbbda18362$export$c6e9f28fb57ea828(p1, p2) {
    const { x: xVelocityDiff, y: yVelocityDiff } = p1.velocity.sub(p2.velocity), [pos1, pos2] = [
        p1.position,
        p2.position
    ], { dx: xDist, dy: yDist } = (0, $yZzCW.getDistances)(pos2, pos1), minimumDistance = 0;
    if (xVelocityDiff * xDist + yVelocityDiff * yDist < minimumDistance) return;
    const angle = -Math.atan2(yDist, xDist), m1 = p1.mass, m2 = p2.mass, u1 = p1.velocity.rotate(angle), u2 = p2.velocity.rotate(angle), v1 = (0, $yZzCW.collisionVelocity)(u1, u2, m1, m2), v2 = (0, $yZzCW.collisionVelocity)(u2, u1, m1, m2), vFinal1 = v1.rotate(-angle), vFinal2 = v2.rotate(-angle);
    p1.velocity.x = vFinal1.x * p1.factor.x;
    p1.velocity.y = vFinal1.y * p1.factor.y;
    p2.velocity.x = vFinal2.x * p2.factor.x;
    p2.velocity.y = vFinal2.y * p2.factor.y;
}
function $aa75d0dbbda18362$export$e83851ba31840182(particle, divBounds) {
    const pPos = particle.getPosition(), size = particle.getRadius(), bounds = $aa75d0dbbda18362$export$b0a2169b5f9d18d8(pPos, size), bounceOptions = particle.options.bounce, resH = $aa75d0dbbda18362$var$rectSideBounce({
        pSide: {
            min: bounds.left,
            max: bounds.right
        },
        pOtherSide: {
            min: bounds.top,
            max: bounds.bottom
        },
        rectSide: {
            min: divBounds.left,
            max: divBounds.right
        },
        rectOtherSide: {
            min: divBounds.top,
            max: divBounds.bottom
        },
        velocity: particle.velocity.x,
        factor: (0, $yZzCW.getRangeValue)(bounceOptions.horizontal.value)
    });
    if (resH.bounced) {
        if (resH.velocity !== undefined) particle.velocity.x = resH.velocity;
        if (resH.position !== undefined) particle.position.x = resH.position;
    }
    const resV = $aa75d0dbbda18362$var$rectSideBounce({
        pSide: {
            min: bounds.top,
            max: bounds.bottom
        },
        pOtherSide: {
            min: bounds.left,
            max: bounds.right
        },
        rectSide: {
            min: divBounds.top,
            max: divBounds.bottom
        },
        rectOtherSide: {
            min: divBounds.left,
            max: divBounds.right
        },
        velocity: particle.velocity.y,
        factor: (0, $yZzCW.getRangeValue)(bounceOptions.vertical.value)
    });
    if (resV.bounced) {
        if (resV.velocity !== undefined) particle.velocity.y = resV.velocity;
        if (resV.position !== undefined) particle.position.y = resV.position;
    }
}
function $aa75d0dbbda18362$export$8e5dc47097396754(obj, callback) {
    const defaultIndex = 0;
    return (0, $62pjT.isArray)(obj) ? obj.map((item, index)=>callback(item, index)) : callback(obj, defaultIndex);
}
function $aa75d0dbbda18362$export$3fbf39566d3ee62e(obj, index, useIndex) {
    return (0, $62pjT.isArray)(obj) ? $aa75d0dbbda18362$export$3a5d12ca7137122f(obj, index, useIndex) : obj;
}
function $aa75d0dbbda18362$export$bfd133b0f67a5a3a(obj, callback) {
    if ((0, $62pjT.isArray)(obj)) return obj.find((t, index)=>callback(t, index));
    const defaultIndex = 0;
    return callback(obj, defaultIndex) ? obj : undefined;
}
function $aa75d0dbbda18362$export$bebd78259cce4fd(options, pxRatio) {
    const valueRange = options.value, animationOptions = options.animation, res = {
        delayTime: (0, $yZzCW.getRangeValue)(animationOptions.delay) * (0, $eywbI.millisecondsToSeconds),
        enable: animationOptions.enable,
        value: (0, $yZzCW.getRangeValue)(options.value) * pxRatio,
        max: (0, $yZzCW.getRangeMax)(valueRange) * pxRatio,
        min: (0, $yZzCW.getRangeMin)(valueRange) * pxRatio,
        loops: 0,
        maxLoops: (0, $yZzCW.getRangeValue)(animationOptions.count),
        time: 0
    }, decayOffset = 1;
    if (animationOptions.enable) {
        res.decay = decayOffset - (0, $yZzCW.getRangeValue)(animationOptions.decay);
        switch(animationOptions.mode){
            case (0, $bTldy.AnimationMode).increase:
                res.status = (0, $d8kOl.AnimationStatus).increasing;
                break;
            case (0, $bTldy.AnimationMode).decrease:
                res.status = (0, $d8kOl.AnimationStatus).decreasing;
                break;
            case (0, $bTldy.AnimationMode).random:
                res.status = (0, $yZzCW.getRandom)() >= (0, $eywbI.half) ? (0, $d8kOl.AnimationStatus).increasing : (0, $d8kOl.AnimationStatus).decreasing;
                break;
        }
        const autoStatus = animationOptions.mode === (0, $bTldy.AnimationMode).auto;
        switch(animationOptions.startValue){
            case (0, $84ZEL.StartValueType).min:
                res.value = res.min;
                if (autoStatus) res.status = (0, $d8kOl.AnimationStatus).increasing;
                break;
            case (0, $84ZEL.StartValueType).max:
                res.value = res.max;
                if (autoStatus) res.status = (0, $d8kOl.AnimationStatus).decreasing;
                break;
            case (0, $84ZEL.StartValueType).random:
            default:
                res.value = (0, $yZzCW.randomInRange)(res);
                if (autoStatus) res.status = (0, $yZzCW.getRandom)() >= (0, $eywbI.half) ? (0, $d8kOl.AnimationStatus).increasing : (0, $d8kOl.AnimationStatus).decreasing;
                break;
        }
    }
    res.initialValue = res.value;
    return res;
}
function $aa75d0dbbda18362$var$getPositionOrSize(positionOrSize, canvasSize) {
    const isPercent = positionOrSize.mode === (0, $5r4A4.PixelMode).percent;
    if (!isPercent) {
        const { mode: _, ...rest } = positionOrSize;
        return rest;
    }
    const isPosition = "x" in positionOrSize;
    if (isPosition) return {
        x: positionOrSize.x / (0, $eywbI.percentDenominator) * canvasSize.width,
        y: positionOrSize.y / (0, $eywbI.percentDenominator) * canvasSize.height
    };
    else return {
        width: positionOrSize.width / (0, $eywbI.percentDenominator) * canvasSize.width,
        height: positionOrSize.height / (0, $eywbI.percentDenominator) * canvasSize.height
    };
}
function $aa75d0dbbda18362$export$1690e12b840569b9(position, canvasSize) {
    return $aa75d0dbbda18362$var$getPositionOrSize(position, canvasSize);
}
function $aa75d0dbbda18362$export$31b21d0167753bb4(size, canvasSize) {
    return $aa75d0dbbda18362$var$getPositionOrSize(size, canvasSize);
}
function $aa75d0dbbda18362$var$checkDestroy(particle, destroyType, value, minValue, maxValue) {
    switch(destroyType){
        case (0, $7ecaf.DestroyType).max:
            if (value >= maxValue) particle.destroy();
            break;
        case (0, $7ecaf.DestroyType).min:
            if (value <= minValue) particle.destroy();
            break;
    }
}
function $aa75d0dbbda18362$export$efead17ed5dcfd2(particle, data, changeDirection, destroyType, delta) {
    const minLoops = 0, minDelay = 0, identity = 1, minVelocity = 0, minDecay = 1;
    if (particle.destroyed || !data || !data.enable || (data.maxLoops ?? minLoops) > minLoops && (data.loops ?? minLoops) > (data.maxLoops ?? minLoops)) return;
    const velocity = (data.velocity ?? minVelocity) * delta.factor, minValue = data.min, maxValue = data.max, decay = data.decay ?? minDecay;
    if (!data.time) data.time = 0;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) data.time += delta.value;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) return;
    switch(data.status){
        case (0, $d8kOl.AnimationStatus).increasing:
            if (data.value >= maxValue) {
                if (changeDirection) data.status = (0, $d8kOl.AnimationStatus).decreasing;
                else data.value -= maxValue;
                if (!data.loops) data.loops = minLoops;
                data.loops++;
            } else data.value += velocity;
            break;
        case (0, $d8kOl.AnimationStatus).decreasing:
            if (data.value <= minValue) {
                if (changeDirection) data.status = (0, $d8kOl.AnimationStatus).increasing;
                else data.value += maxValue;
                if (!data.loops) data.loops = minLoops;
                data.loops++;
            } else data.value -= velocity;
    }
    if (data.velocity && decay !== identity) data.velocity *= decay;
    $aa75d0dbbda18362$var$checkDestroy(particle, destroyType, data.value, minValue, maxValue);
    if (!particle.destroyed) data.value = (0, $yZzCW.clamp)(data.value, minValue, maxValue);
}
function $aa75d0dbbda18362$export$667e8f3bfe6278b7(style) {
    const clonedStyle = document.createElement("div").style;
    if (!style) return clonedStyle;
    for(const key in style){
        const styleKey = style[key];
        if (!Object.prototype.hasOwnProperty.call(style, key) || (0, $62pjT.isNull)(styleKey)) continue;
        const styleValue = style.getPropertyValue?.(styleKey);
        if (!styleValue) continue;
        const stylePriority = style.getPropertyPriority?.(styleKey);
        if (!stylePriority) clonedStyle.setProperty?.(styleKey, styleValue);
        else clonedStyle.setProperty?.(styleKey, styleValue, stylePriority);
    }
    return clonedStyle;
}
function $aa75d0dbbda18362$var$computeFullScreenStyle(zIndex) {
    const fullScreenStyle = document.createElement("div").style, radix = 10, style = {
        width: "100%",
        height: "100%",
        margin: "0",
        padding: "0",
        borderWidth: "0",
        position: "fixed",
        zIndex: zIndex.toString(radix),
        "z-index": zIndex.toString(radix),
        top: "0",
        left: "0"
    };
    for(const key in style){
        const value = style[key];
        fullScreenStyle.setProperty(key, value);
    }
    return fullScreenStyle;
}
const $aa75d0dbbda18362$export$10d1829d88c10e6a = $aa75d0dbbda18362$var$memoize($aa75d0dbbda18362$var$computeFullScreenStyle);

});
parcelRegister("yZzCW", function(module, exports) {

$parcel$export(module.exports, "getRandom", () => $0692f054a971f4c6$export$1a76347094524b3b);
$parcel$export(module.exports, "clamp", () => $0692f054a971f4c6$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "animate", () => $0692f054a971f4c6$export$e3607ec2d7a891c4);
$parcel$export(module.exports, "cancelAnimation", () => $0692f054a971f4c6$export$623ab1da75e685de);
$parcel$export(module.exports, "mix", () => $0692f054a971f4c6$export$2c9e8a9632a706b2);
$parcel$export(module.exports, "randomInRange", () => $0692f054a971f4c6$export$8b958c8ecd94a804);
$parcel$export(module.exports, "getRangeMax", () => $0692f054a971f4c6$export$27d2c76f835d583d);
$parcel$export(module.exports, "getRangeMin", () => $0692f054a971f4c6$export$71c94d28c0fa4bfe);
$parcel$export(module.exports, "getRangeValue", () => $0692f054a971f4c6$export$e70c64b68236cb4e);
$parcel$export(module.exports, "setRangeValue", () => $0692f054a971f4c6$export$6dcd5a07b989db7);
$parcel$export(module.exports, "getDistances", () => $0692f054a971f4c6$export$c76b58cfe053f228);
$parcel$export(module.exports, "getDistance", () => $0692f054a971f4c6$export$79376507b09a66f);
$parcel$export(module.exports, "degToRad", () => $0692f054a971f4c6$export$e6bfdeff8bfc94f9);
$parcel$export(module.exports, "getParticleDirectionAngle", () => $0692f054a971f4c6$export$2045f76df51d18c4);
$parcel$export(module.exports, "getParticleBaseVelocity", () => $0692f054a971f4c6$export$cce6f12debc4024a);
$parcel$export(module.exports, "collisionVelocity", () => $0692f054a971f4c6$export$ee2fb97c67882d88);
$parcel$export(module.exports, "calcPositionOrRandomFromSizeRanged", () => $0692f054a971f4c6$export$b6e437e0d75e3d2c);
$parcel$export(module.exports, "calcExactPositionOrRandomFromSize", () => $0692f054a971f4c6$export$a3c87c98a736c457);
$parcel$export(module.exports, "parseAlpha", () => $0692f054a971f4c6$export$988633967de92230);

var $hlFRq = parcelRequire("hlFRq");

var $eywbI = parcelRequire("eywbI");

var $aocC0 = parcelRequire("aocC0");

var $62pjT = parcelRequire("62pjT");
let $0692f054a971f4c6$var$_random = Math.random;
const $0692f054a971f4c6$var$_animationLoop = {
    nextFrame: (cb)=>requestAnimationFrame(cb),
    cancel: (idx)=>cancelAnimationFrame(idx)
};
function $0692f054a971f4c6$export$3ba5cb2c014ef7d5(rnd = Math.random) {
    $0692f054a971f4c6$var$_random = rnd;
}
function $0692f054a971f4c6$export$1a76347094524b3b() {
    const min = 0, max = 1;
    return $0692f054a971f4c6$export$7d15b64cf5a3a4c4($0692f054a971f4c6$var$_random(), min, max - Number.EPSILON);
}
function $0692f054a971f4c6$export$f39283481a75bc14(nextFrame, cancel) {
    $0692f054a971f4c6$var$_animationLoop.nextFrame = (callback)=>nextFrame(callback);
    $0692f054a971f4c6$var$_animationLoop.cancel = (handle)=>cancel(handle);
}
function $0692f054a971f4c6$export$e3607ec2d7a891c4(fn) {
    return $0692f054a971f4c6$var$_animationLoop.nextFrame(fn);
}
function $0692f054a971f4c6$export$623ab1da75e685de(handle) {
    $0692f054a971f4c6$var$_animationLoop.cancel(handle);
}
function $0692f054a971f4c6$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $0692f054a971f4c6$export$2c9e8a9632a706b2(comp1, comp2, weight1, weight2) {
    return Math.floor((comp1 * weight1 + comp2 * weight2) / (weight1 + weight2));
}
function $0692f054a971f4c6$export$8b958c8ecd94a804(r) {
    const max = $0692f054a971f4c6$export$27d2c76f835d583d(r), minOffset = 0;
    let min = $0692f054a971f4c6$export$71c94d28c0fa4bfe(r);
    if (max === min) min = minOffset;
    return $0692f054a971f4c6$export$1a76347094524b3b() * (max - min) + min;
}
function $0692f054a971f4c6$export$e70c64b68236cb4e(value) {
    return (0, $62pjT.isNumber)(value) ? value : $0692f054a971f4c6$export$8b958c8ecd94a804(value);
}
function $0692f054a971f4c6$export$71c94d28c0fa4bfe(value) {
    return (0, $62pjT.isNumber)(value) ? value : value.min;
}
function $0692f054a971f4c6$export$27d2c76f835d583d(value) {
    return (0, $62pjT.isNumber)(value) ? value : value.max;
}
function $0692f054a971f4c6$export$6dcd5a07b989db7(source, value) {
    if (source === value || value === undefined && (0, $62pjT.isNumber)(source)) return source;
    const min = $0692f054a971f4c6$export$71c94d28c0fa4bfe(source), max = $0692f054a971f4c6$export$27d2c76f835d583d(source);
    return value !== undefined ? {
        min: Math.min(min, value),
        max: Math.max(max, value)
    } : $0692f054a971f4c6$export$6dcd5a07b989db7(min, max);
}
function $0692f054a971f4c6$export$c76b58cfe053f228(pointA, pointB) {
    const dx = pointA.x - pointB.x, dy = pointA.y - pointB.y, squareExp = 2;
    return {
        dx: dx,
        dy: dy,
        distance: Math.sqrt(dx ** squareExp + dy ** squareExp)
    };
}
function $0692f054a971f4c6$export$79376507b09a66f(pointA, pointB) {
    return $0692f054a971f4c6$export$c76b58cfe053f228(pointA, pointB).distance;
}
function $0692f054a971f4c6$export$e6bfdeff8bfc94f9(degrees) {
    const PIDeg = 180;
    return degrees * Math.PI / PIDeg;
}
function $0692f054a971f4c6$export$2045f76df51d18c4(direction, position, center) {
    if ((0, $62pjT.isNumber)(direction)) return $0692f054a971f4c6$export$e6bfdeff8bfc94f9(direction);
    switch(direction){
        case (0, $hlFRq.MoveDirection).top:
            return -Math.PI * (0, $eywbI.half);
        case (0, $hlFRq.MoveDirection).topRight:
            return -Math.PI * (0, $eywbI.quarter);
        case (0, $hlFRq.MoveDirection).right:
            return 0, $eywbI.empty;
        case (0, $hlFRq.MoveDirection).bottomRight:
            return Math.PI * (0, $eywbI.quarter);
        case (0, $hlFRq.MoveDirection).bottom:
            return Math.PI * (0, $eywbI.half);
        case (0, $hlFRq.MoveDirection).bottomLeft:
            return Math.PI * (0, $eywbI.threeQuarter);
        case (0, $hlFRq.MoveDirection).left:
            return Math.PI;
        case (0, $hlFRq.MoveDirection).topLeft:
            return -Math.PI * (0, $eywbI.threeQuarter);
        case (0, $hlFRq.MoveDirection).inside:
            return Math.atan2(center.y - position.y, center.x - position.x);
        case (0, $hlFRq.MoveDirection).outside:
            return Math.atan2(position.y - center.y, position.x - center.x);
        default:
            return $0692f054a971f4c6$export$1a76347094524b3b() * (0, $eywbI.doublePI);
    }
}
function $0692f054a971f4c6$export$cce6f12debc4024a(direction) {
    const baseVelocity = (0, $aocC0.Vector).origin;
    baseVelocity.length = 1;
    baseVelocity.angle = direction;
    return baseVelocity;
}
function $0692f054a971f4c6$export$ee2fb97c67882d88(v1, v2, m1, m2) {
    return (0, $aocC0.Vector).create(v1.x * (m1 - m2) / (m1 + m2) + v2.x * (0, $eywbI.double) * m2 / (m1 + m2), v1.y);
}
function $0692f054a971f4c6$export$3cb8a699840fed18(data) {
    return data.position?.x !== undefined && data.position.y !== undefined ? {
        x: data.position.x * data.size.width / (0, $eywbI.percentDenominator),
        y: data.position.y * data.size.height / (0, $eywbI.percentDenominator)
    } : undefined;
}
function $0692f054a971f4c6$export$b19bedb83d642783(data) {
    return {
        x: (data.position?.x ?? $0692f054a971f4c6$export$1a76347094524b3b() * (0, $eywbI.percentDenominator)) * data.size.width / (0, $eywbI.percentDenominator),
        y: (data.position?.y ?? $0692f054a971f4c6$export$1a76347094524b3b() * (0, $eywbI.percentDenominator)) * data.size.height / (0, $eywbI.percentDenominator)
    };
}
function $0692f054a971f4c6$export$b6e437e0d75e3d2c(data) {
    const position = {
        x: data.position?.x !== undefined ? $0692f054a971f4c6$export$e70c64b68236cb4e(data.position.x) : undefined,
        y: data.position?.y !== undefined ? $0692f054a971f4c6$export$e70c64b68236cb4e(data.position.y) : undefined
    };
    return $0692f054a971f4c6$export$b19bedb83d642783({
        size: data.size,
        position: position
    });
}
function $0692f054a971f4c6$export$a3c87c98a736c457(data) {
    return {
        x: data.position?.x ?? $0692f054a971f4c6$export$1a76347094524b3b() * data.size.width,
        y: data.position?.y ?? $0692f054a971f4c6$export$1a76347094524b3b() * data.size.height
    };
}
function $0692f054a971f4c6$export$30970e96ab2e23ee(data) {
    const position = {
        x: data.position?.x !== undefined ? $0692f054a971f4c6$export$e70c64b68236cb4e(data.position.x) : undefined,
        y: data.position?.y !== undefined ? $0692f054a971f4c6$export$e70c64b68236cb4e(data.position.y) : undefined
    };
    return $0692f054a971f4c6$export$a3c87c98a736c457({
        size: data.size,
        position: position
    });
}
function $0692f054a971f4c6$export$988633967de92230(input) {
    const defaultAlpha = 1;
    if (!input) return defaultAlpha;
    return input.endsWith("%") ? parseFloat(input) / (0, $eywbI.percentDenominator) : parseFloat(input);
}

});
parcelRegister("hlFRq", function(module, exports) {

$parcel$export(module.exports, "MoveDirection", () => $ca14de7c93eaef53$export$cc1a246adca07dd4);
var $ca14de7c93eaef53$export$cc1a246adca07dd4;
(function(MoveDirection) {
    MoveDirection["bottom"] = "bottom";
    MoveDirection["bottomLeft"] = "bottom-left";
    MoveDirection["bottomRight"] = "bottom-right";
    MoveDirection["left"] = "left";
    MoveDirection["none"] = "none";
    MoveDirection["right"] = "right";
    MoveDirection["top"] = "top";
    MoveDirection["topLeft"] = "top-left";
    MoveDirection["topRight"] = "top-right";
    MoveDirection["outside"] = "outside";
    MoveDirection["inside"] = "inside";
})($ca14de7c93eaef53$export$cc1a246adca07dd4 || ($ca14de7c93eaef53$export$cc1a246adca07dd4 = {}));

});

parcelRegister("aocC0", function(module, exports) {

$parcel$export(module.exports, "Vector3d", () => $7905edbdc3cf9c10$export$ece015703618ce3d);
$parcel$export(module.exports, "Vector", () => $7905edbdc3cf9c10$export$9b781de7bf37bf48);

var $eywbI = parcelRequire("eywbI");

var $62pjT = parcelRequire("62pjT");
class $7905edbdc3cf9c10$export$ece015703618ce3d {
    constructor(xOrCoords, y, z){
        this._updateFromAngle = (angle, length)=>{
            this.x = Math.cos(angle) * length;
            this.y = Math.sin(angle) * length;
        };
        if (!(0, $62pjT.isNumber)(xOrCoords) && xOrCoords) {
            this.x = xOrCoords.x;
            this.y = xOrCoords.y;
            const coords3d = xOrCoords;
            this.z = coords3d.z ? coords3d.z : (0, $eywbI.originPoint).z;
        } else if (xOrCoords !== undefined && y !== undefined) {
            this.x = xOrCoords;
            this.y = y;
            this.z = z ?? (0, $eywbI.originPoint).z;
        } else throw new Error(`${(0, $eywbI.errorPrefix)} Vector3d not initialized correctly`);
    }
    static get origin() {
        return $7905edbdc3cf9c10$export$ece015703618ce3d.create((0, $eywbI.originPoint).x, (0, $eywbI.originPoint).y, (0, $eywbI.originPoint).z);
    }
    get angle() {
        return Math.atan2(this.y, this.x);
    }
    set angle(angle) {
        this._updateFromAngle(angle, this.length);
    }
    get length() {
        return Math.sqrt(this.getLengthSq());
    }
    set length(length) {
        this._updateFromAngle(this.angle, length);
    }
    static clone(source) {
        return $7905edbdc3cf9c10$export$ece015703618ce3d.create(source.x, source.y, source.z);
    }
    static create(x, y, z) {
        return new $7905edbdc3cf9c10$export$ece015703618ce3d(x, y, z);
    }
    add(v) {
        return $7905edbdc3cf9c10$export$ece015703618ce3d.create(this.x + v.x, this.y + v.y, this.z + v.z);
    }
    addTo(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
    }
    copy() {
        return $7905edbdc3cf9c10$export$ece015703618ce3d.clone(this);
    }
    distanceTo(v) {
        return this.sub(v).length;
    }
    distanceToSq(v) {
        return this.sub(v).getLengthSq();
    }
    div(n) {
        return $7905edbdc3cf9c10$export$ece015703618ce3d.create(this.x / n, this.y / n, this.z / n);
    }
    divTo(n) {
        this.x /= n;
        this.y /= n;
        this.z /= n;
    }
    getLengthSq() {
        return this.x ** (0, $eywbI.squareExp) + this.y ** (0, $eywbI.squareExp);
    }
    mult(n) {
        return $7905edbdc3cf9c10$export$ece015703618ce3d.create(this.x * n, this.y * n, this.z * n);
    }
    multTo(n) {
        this.x *= n;
        this.y *= n;
        this.z *= n;
    }
    normalize() {
        const length = this.length;
        if (length != (0, $eywbI.none)) this.multTo((0, $eywbI.inverseFactorNumerator) / length);
    }
    rotate(angle) {
        return $7905edbdc3cf9c10$export$ece015703618ce3d.create(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle), (0, $eywbI.originPoint).z);
    }
    setTo(c) {
        this.x = c.x;
        this.y = c.y;
        const v3d = c;
        this.z = v3d.z ? v3d.z : (0, $eywbI.originPoint).z;
    }
    sub(v) {
        return $7905edbdc3cf9c10$export$ece015703618ce3d.create(this.x - v.x, this.y - v.y, this.z - v.z);
    }
    subFrom(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
    }
}
class $7905edbdc3cf9c10$export$9b781de7bf37bf48 extends $7905edbdc3cf9c10$export$ece015703618ce3d {
    constructor(xOrCoords, y){
        super(xOrCoords, y, (0, $eywbI.originPoint).z);
    }
    static get origin() {
        return $7905edbdc3cf9c10$export$9b781de7bf37bf48.create((0, $eywbI.originPoint).x, (0, $eywbI.originPoint).y);
    }
    static clone(source) {
        return $7905edbdc3cf9c10$export$9b781de7bf37bf48.create(source.x, source.y);
    }
    static create(x, y) {
        return new $7905edbdc3cf9c10$export$9b781de7bf37bf48(x, y);
    }
}

});
parcelRegister("62pjT", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $465691f8ff0c55f9$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $465691f8ff0c55f9$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $465691f8ff0c55f9$export$7e4aa119212bc614);
$parcel$export(module.exports, "isObject", () => $465691f8ff0c55f9$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isArray", () => $465691f8ff0c55f9$export$43bee75e5e14138e);
$parcel$export(module.exports, "isNull", () => $465691f8ff0c55f9$export$630801d484da15df);
function $465691f8ff0c55f9$export$f9ce7b637dfbe238(arg) {
    return typeof arg === "boolean";
}
function $465691f8ff0c55f9$export$844ec244b1367d54(arg) {
    return typeof arg === "string";
}
function $465691f8ff0c55f9$export$7e4aa119212bc614(arg) {
    return typeof arg === "number";
}
function $465691f8ff0c55f9$export$f6e2535fb5126e54(arg) {
    return typeof arg === "function";
}
function $465691f8ff0c55f9$export$a6cdc56e425d0d0a(arg) {
    return typeof arg === "object" && arg !== null;
}
function $465691f8ff0c55f9$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $465691f8ff0c55f9$export$630801d484da15df(arg) {
    return arg === null || arg === undefined;
}

});



parcelRegister("bTldy", function(module, exports) {

$parcel$export(module.exports, "AnimationMode", () => $8a854a2623d15bee$export$6bf57c7f0219f07d);
var $8a854a2623d15bee$export$6bf57c7f0219f07d;
(function(AnimationMode) {
    AnimationMode["auto"] = "auto";
    AnimationMode["increase"] = "increase";
    AnimationMode["decrease"] = "decrease";
    AnimationMode["random"] = "random";
})($8a854a2623d15bee$export$6bf57c7f0219f07d || ($8a854a2623d15bee$export$6bf57c7f0219f07d = {}));

});

parcelRegister("d8kOl", function(module, exports) {

$parcel$export(module.exports, "AnimationStatus", () => $98fc2a563c9a4f6f$export$a2d3d93c57d16a1a);
var $98fc2a563c9a4f6f$export$a2d3d93c57d16a1a;
(function(AnimationStatus) {
    AnimationStatus["increasing"] = "increasing";
    AnimationStatus["decreasing"] = "decreasing";
})($98fc2a563c9a4f6f$export$a2d3d93c57d16a1a || ($98fc2a563c9a4f6f$export$a2d3d93c57d16a1a = {}));

});

parcelRegister("7ecaf", function(module, exports) {

$parcel$export(module.exports, "DestroyType", () => $543346cbf82f6841$export$41a461248611663e);
var $543346cbf82f6841$export$41a461248611663e;
(function(DestroyType) {
    DestroyType["none"] = "none";
    DestroyType["max"] = "max";
    DestroyType["min"] = "min";
})($543346cbf82f6841$export$41a461248611663e || ($543346cbf82f6841$export$41a461248611663e = {}));

});

parcelRegister("6VMPk", function(module, exports) {

$parcel$export(module.exports, "OutModeDirection", () => $50bdf0f1c4621a59$export$56c1e4693edf08f9);
var $50bdf0f1c4621a59$export$56c1e4693edf08f9;
(function(OutModeDirection) {
    OutModeDirection["bottom"] = "bottom";
    OutModeDirection["left"] = "left";
    OutModeDirection["right"] = "right";
    OutModeDirection["top"] = "top";
})($50bdf0f1c4621a59$export$56c1e4693edf08f9 || ($50bdf0f1c4621a59$export$56c1e4693edf08f9 = {}));

});

parcelRegister("5r4A4", function(module, exports) {

$parcel$export(module.exports, "PixelMode", () => $3f5306fd77b5839d$export$1009f0178778a981);
var $3f5306fd77b5839d$export$1009f0178778a981;
(function(PixelMode) {
    PixelMode["precise"] = "precise";
    PixelMode["percent"] = "percent";
})($3f5306fd77b5839d$export$1009f0178778a981 || ($3f5306fd77b5839d$export$1009f0178778a981 = {}));

});

parcelRegister("84ZEL", function(module, exports) {

$parcel$export(module.exports, "StartValueType", () => $5e1e8620e65eccd9$export$5385b9a82993d2c8);
var $5e1e8620e65eccd9$export$5385b9a82993d2c8;
(function(StartValueType) {
    StartValueType["max"] = "max";
    StartValueType["min"] = "min";
    StartValueType["random"] = "random";
})($5e1e8620e65eccd9$export$5385b9a82993d2c8 || ($5e1e8620e65eccd9$export$5385b9a82993d2c8 = {}));

});


parcelRegister("71IWX", function(module, exports) {

$parcel$export(module.exports, "Container", () => $51db7e85e98c0336$export$42a852a2b6b56249);

var $yZzCW = parcelRequire("yZzCW");

var $eywbI = parcelRequire("eywbI");

var $eDm3t = parcelRequire("eDm3t");

var $dOQ6I = parcelRequire("dOQ6I");

var $lC80j = parcelRequire("lC80j");

var $3ikOd = parcelRequire("3ikOd");

var $ndmgJ = parcelRequire("ndmgJ");

var $hejtK = parcelRequire("hejtK");

var $eL0X5 = parcelRequire("eL0X5");

var $43Hl2 = parcelRequire("43Hl2");
function $51db7e85e98c0336$var$guardCheck(container) {
    return container && !container.destroyed;
}
function $51db7e85e98c0336$var$initDelta(value, fpsLimit = (0, $eywbI.defaultFps), smooth = false) {
    return {
        value: value,
        factor: smooth ? (0, $eywbI.defaultFps) / fpsLimit : (0, $eywbI.defaultFps) * value / (0, $eywbI.millisecondsToSeconds)
    };
}
function $51db7e85e98c0336$var$loadContainerOptions(engine, container, ...sourceOptionsArr) {
    const options = new (0, $ndmgJ.Options)(engine, container);
    (0, $43Hl2.loadOptions)(options, ...sourceOptionsArr);
    return options;
}
class $51db7e85e98c0336$export$42a852a2b6b56249 {
    constructor(engine, id, sourceOptions){
        this._intersectionManager = (entries)=>{
            if (!$51db7e85e98c0336$var$guardCheck(this) || !this.actualOptions.pauseOnOutsideViewport) return;
            for (const entry of entries){
                if (entry.target !== this.interactivity.element) continue;
                if (entry.isIntersecting) this.play();
                else this.pause();
            }
        };
        this._nextFrame = (timestamp)=>{
            try {
                if (!this._smooth && this._lastFrameTime !== undefined && timestamp < this._lastFrameTime + (0, $eywbI.millisecondsToSeconds) / this.fpsLimit) {
                    this.draw(false);
                    return;
                }
                this._lastFrameTime ??= timestamp;
                const delta = $51db7e85e98c0336$var$initDelta(timestamp - this._lastFrameTime, this.fpsLimit, this._smooth);
                this.addLifeTime(delta.value);
                this._lastFrameTime = timestamp;
                if (delta.value > (0, $eywbI.millisecondsToSeconds)) {
                    this.draw(false);
                    return;
                }
                this.particles.draw(delta);
                if (!this.alive()) {
                    this.destroy();
                    return;
                }
                if (this.animationStatus) this.draw(false);
            } catch (e) {
                (0, $eDm3t.getLogger)().error(`${(0, $eywbI.errorPrefix)} in animation loop`, e);
            }
        };
        this._engine = engine;
        this.id = Symbol(id);
        this.fpsLimit = 120;
        this._smooth = false;
        this._delay = 0;
        this._duration = 0;
        this._lifeTime = 0;
        this._firstStart = true;
        this.started = false;
        this.destroyed = false;
        this._paused = true;
        this._lastFrameTime = 0;
        this.zLayers = 100;
        this.pageHidden = false;
        this._clickHandlers = new Map();
        this._sourceOptions = sourceOptions;
        this._initialSourceOptions = sourceOptions;
        this.retina = new (0, $eL0X5.Retina)(this);
        this.canvas = new (0, $dOQ6I.Canvas)(this, this._engine);
        this.particles = new (0, $hejtK.Particles)(this._engine, this);
        this.pathGenerators = new Map();
        this.interactivity = {
            mouse: {
                clicking: false,
                inside: false
            }
        };
        this.plugins = new Map();
        this.effectDrawers = new Map();
        this.shapeDrawers = new Map();
        this._options = $51db7e85e98c0336$var$loadContainerOptions(this._engine, this);
        this.actualOptions = $51db7e85e98c0336$var$loadContainerOptions(this._engine, this);
        this._eventListeners = new (0, $lC80j.EventListeners)(this);
        this._intersectionObserver = (0, $eDm3t.safeIntersectionObserver)((entries)=>this._intersectionManager(entries));
        this._engine.dispatchEvent((0, $3ikOd.EventType).containerBuilt, {
            container: this
        });
    }
    get animationStatus() {
        return !this._paused && !this.pageHidden && $51db7e85e98c0336$var$guardCheck(this);
    }
    get options() {
        return this._options;
    }
    get sourceOptions() {
        return this._sourceOptions;
    }
    addClickHandler(callback) {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        const el = this.interactivity.element;
        if (!el) return;
        const clickOrTouchHandler = (e, pos, radius)=>{
            if (!$51db7e85e98c0336$var$guardCheck(this)) return;
            const pxRatio = this.retina.pixelRatio, posRetina = {
                x: pos.x * pxRatio,
                y: pos.y * pxRatio
            }, particles = this.particles.quadTree.queryCircle(posRetina, radius * pxRatio);
            callback(e, particles);
        }, clickHandler = (e)=>{
            if (!$51db7e85e98c0336$var$guardCheck(this)) return;
            const mouseEvent = e, pos = {
                x: mouseEvent.offsetX || mouseEvent.clientX,
                y: mouseEvent.offsetY || mouseEvent.clientY
            };
            clickOrTouchHandler(e, pos, (0, $eywbI.clickRadius));
        }, touchStartHandler = ()=>{
            if (!$51db7e85e98c0336$var$guardCheck(this)) return;
            touched = true;
            touchMoved = false;
        }, touchMoveHandler = ()=>{
            if (!$51db7e85e98c0336$var$guardCheck(this)) return;
            touchMoved = true;
        }, touchEndHandler = (e)=>{
            if (!$51db7e85e98c0336$var$guardCheck(this)) return;
            if (touched && !touchMoved) {
                const touchEvent = e;
                let lastTouch = touchEvent.touches[touchEvent.touches.length - (0, $eywbI.touchEndLengthOffset)];
                if (!lastTouch) {
                    lastTouch = touchEvent.changedTouches[touchEvent.changedTouches.length - (0, $eywbI.touchEndLengthOffset)];
                    if (!lastTouch) return;
                }
                const element = this.canvas.element, canvasRect = element ? element.getBoundingClientRect() : undefined, pos = {
                    x: lastTouch.clientX - (canvasRect ? canvasRect.left : (0, $eywbI.minCoordinate)),
                    y: lastTouch.clientY - (canvasRect ? canvasRect.top : (0, $eywbI.minCoordinate))
                };
                clickOrTouchHandler(e, pos, Math.max(lastTouch.radiusX, lastTouch.radiusY));
            }
            touched = false;
            touchMoved = false;
        }, touchCancelHandler = ()=>{
            if (!$51db7e85e98c0336$var$guardCheck(this)) return;
            touched = false;
            touchMoved = false;
        };
        let touched = false, touchMoved = false;
        this._clickHandlers.set("click", clickHandler);
        this._clickHandlers.set("touchstart", touchStartHandler);
        this._clickHandlers.set("touchmove", touchMoveHandler);
        this._clickHandlers.set("touchend", touchEndHandler);
        this._clickHandlers.set("touchcancel", touchCancelHandler);
        for (const [key, handler] of this._clickHandlers)el.addEventListener(key, handler);
    }
    addLifeTime(value) {
        this._lifeTime += value;
    }
    addPath(key, generator, override = false) {
        if (!$51db7e85e98c0336$var$guardCheck(this) || !override && this.pathGenerators.has(key)) return false;
        this.pathGenerators.set(key, generator);
        return true;
    }
    alive() {
        return !this._duration || this._lifeTime <= this._duration;
    }
    clearClickHandlers() {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        for (const [key, handler] of this._clickHandlers)this.interactivity.element?.removeEventListener(key, handler);
        this._clickHandlers.clear();
    }
    destroy(remove = true) {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        this.stop();
        this.clearClickHandlers();
        this.particles.destroy();
        this.canvas.destroy();
        for (const effectDrawer of this.effectDrawers.values())effectDrawer.destroy?.(this);
        for (const shapeDrawer of this.shapeDrawers.values())shapeDrawer.destroy?.(this);
        for (const key of this.effectDrawers.keys())this.effectDrawers.delete(key);
        for (const key of this.shapeDrawers.keys())this.shapeDrawers.delete(key);
        this._engine.clearPlugins(this);
        this.destroyed = true;
        if (remove) {
            const mainArr = this._engine.items, idx = mainArr.findIndex((t)=>t === this);
            if (idx >= (0, $eywbI.removeMinIndex)) mainArr.splice(idx, (0, $eywbI.removeDeleteCount));
        }
        this._engine.dispatchEvent((0, $3ikOd.EventType).containerDestroyed, {
            container: this
        });
    }
    draw(force) {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        let refreshTime = force;
        const frame = (timestamp)=>{
            if (refreshTime) {
                this._lastFrameTime = undefined;
                refreshTime = false;
            }
            this._nextFrame(timestamp);
        };
        this._drawAnimationFrame = (0, $yZzCW.animate)((timestamp)=>frame(timestamp));
    }
    async export(type, options = {}) {
        for (const plugin of this.plugins.values()){
            if (!plugin.export) continue;
            const res = await plugin.export(type, options);
            if (!res.supported) continue;
            return res.blob;
        }
        (0, $eDm3t.getLogger)().error(`${(0, $eywbI.errorPrefix)} - Export plugin with type ${type} not found`);
    }
    handleClickMode(mode) {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        this.particles.handleClickMode(mode);
        for (const plugin of this.plugins.values())plugin.handleClickMode?.(mode);
    }
    async init() {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        const effects = this._engine.getSupportedEffects();
        for (const type of effects){
            const drawer = this._engine.getEffectDrawer(type);
            if (drawer) this.effectDrawers.set(type, drawer);
        }
        const shapes = this._engine.getSupportedShapes();
        for (const type of shapes){
            const drawer = this._engine.getShapeDrawer(type);
            if (drawer) this.shapeDrawers.set(type, drawer);
        }
        await this.particles.initPlugins();
        this._options = $51db7e85e98c0336$var$loadContainerOptions(this._engine, this, this._initialSourceOptions, this.sourceOptions);
        this.actualOptions = $51db7e85e98c0336$var$loadContainerOptions(this._engine, this, this._options);
        const availablePlugins = await this._engine.getAvailablePlugins(this);
        for (const [id, plugin] of availablePlugins)this.plugins.set(id, plugin);
        this.retina.init();
        await this.canvas.init();
        this.updateActualOptions();
        this.canvas.initBackground();
        this.canvas.resize();
        const { zLayers: zLayers, duration: duration, delay: delay, fpsLimit: fpsLimit, smooth: smooth } = this.actualOptions;
        this.zLayers = zLayers;
        this._duration = (0, $yZzCW.getRangeValue)(duration) * (0, $eywbI.millisecondsToSeconds);
        this._delay = (0, $yZzCW.getRangeValue)(delay) * (0, $eywbI.millisecondsToSeconds);
        this._lifeTime = 0;
        this.fpsLimit = fpsLimit > (0, $eywbI.minFpsLimit) ? fpsLimit : (0, $eywbI.defaultFpsLimit);
        this._smooth = smooth;
        for (const drawer of this.effectDrawers.values())await drawer.init?.(this);
        for (const drawer of this.shapeDrawers.values())await drawer.init?.(this);
        for (const plugin of this.plugins.values())await plugin.init?.();
        this._engine.dispatchEvent((0, $3ikOd.EventType).containerInit, {
            container: this
        });
        await this.particles.init();
        this.particles.setDensity();
        for (const plugin of this.plugins.values())plugin.particlesSetup?.();
        this._engine.dispatchEvent((0, $3ikOd.EventType).particlesSetup, {
            container: this
        });
    }
    async loadTheme(name) {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        this._currentTheme = name;
        await this.refresh();
    }
    pause() {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        if (this._drawAnimationFrame !== undefined) {
            (0, $yZzCW.cancelAnimation)(this._drawAnimationFrame);
            delete this._drawAnimationFrame;
        }
        if (this._paused) return;
        for (const plugin of this.plugins.values())plugin.pause?.();
        if (!this.pageHidden) this._paused = true;
        this._engine.dispatchEvent((0, $3ikOd.EventType).containerPaused, {
            container: this
        });
    }
    play(force) {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        const needsUpdate = this._paused || force;
        if (this._firstStart && !this.actualOptions.autoPlay) {
            this._firstStart = false;
            return;
        }
        if (this._paused) this._paused = false;
        if (needsUpdate) {
            for (const plugin of this.plugins.values())if (plugin.play) plugin.play();
        }
        this._engine.dispatchEvent((0, $3ikOd.EventType).containerPlay, {
            container: this
        });
        this.draw(needsUpdate ?? false);
    }
    async refresh() {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        this.stop();
        return this.start();
    }
    async reset(sourceOptions) {
        if (!$51db7e85e98c0336$var$guardCheck(this)) return;
        this._initialSourceOptions = sourceOptions;
        this._sourceOptions = sourceOptions;
        this._options = $51db7e85e98c0336$var$loadContainerOptions(this._engine, this, this._initialSourceOptions, this.sourceOptions);
        this.actualOptions = $51db7e85e98c0336$var$loadContainerOptions(this._engine, this, this._options);
        return this.refresh();
    }
    async start() {
        if (!$51db7e85e98c0336$var$guardCheck(this) || this.started) return;
        await this.init();
        this.started = true;
        await new Promise((resolve)=>{
            const start = async ()=>{
                this._eventListeners.addListeners();
                if (this.interactivity.element instanceof HTMLElement && this._intersectionObserver) this._intersectionObserver.observe(this.interactivity.element);
                for (const plugin of this.plugins.values())await plugin.start?.();
                this._engine.dispatchEvent((0, $3ikOd.EventType).containerStarted, {
                    container: this
                });
                this.play();
                resolve();
            };
            this._delayTimeout = setTimeout(()=>void start(), this._delay);
        });
    }
    stop() {
        if (!$51db7e85e98c0336$var$guardCheck(this) || !this.started) return;
        if (this._delayTimeout) {
            clearTimeout(this._delayTimeout);
            delete this._delayTimeout;
        }
        this._firstStart = true;
        this.started = false;
        this._eventListeners.removeListeners();
        this.pause();
        this.particles.clear();
        this.canvas.stop();
        if (this.interactivity.element instanceof HTMLElement && this._intersectionObserver) this._intersectionObserver.unobserve(this.interactivity.element);
        for (const plugin of this.plugins.values())plugin.stop?.();
        for (const key of this.plugins.keys())this.plugins.delete(key);
        this._sourceOptions = this._options;
        this._engine.dispatchEvent((0, $3ikOd.EventType).containerStopped, {
            container: this
        });
    }
    updateActualOptions() {
        this.actualOptions.responsive = [];
        const newMaxWidth = this.actualOptions.setResponsive(this.canvas.size.width, this.retina.pixelRatio, this._options);
        this.actualOptions.setTheme(this._currentTheme);
        if (this._responsiveMaxWidth === newMaxWidth) return false;
        this._responsiveMaxWidth = newMaxWidth;
        return true;
    }
}

});
parcelRegister("dOQ6I", function(module, exports) {

$parcel$export(module.exports, "Canvas", () => $a0f85d4f7e124772$export$8d01c972ee8b14a9);

var $izu9S = parcelRequire("izu9S");

var $eDm3t = parcelRequire("eDm3t");

var $eywbI = parcelRequire("eywbI");

var $6nx5m = parcelRequire("6nx5m");
function $a0f85d4f7e124772$var$setTransformValue(factor, newFactor, key) {
    const newValue = newFactor[key];
    if (newValue !== undefined) factor[key] = (factor[key] ?? (0, $eywbI.defaultTransformValue)) * newValue;
}
function $a0f85d4f7e124772$var$setStyle(canvas, style, important = false) {
    if (!style) return;
    const element = canvas;
    if (!element) return;
    const elementStyle = element.style;
    if (!elementStyle) return;
    const keys = new Set();
    for(const key in elementStyle){
        if (!Object.prototype.hasOwnProperty.call(elementStyle, key)) continue;
        keys.add(elementStyle[key]);
    }
    for(const key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        keys.add(style[key]);
    }
    for (const key of keys){
        const value = style.getPropertyValue(key);
        if (!value) elementStyle.removeProperty(key);
        else elementStyle.setProperty(key, value, important ? "important" : "");
    }
}
class $a0f85d4f7e124772$export$8d01c972ee8b14a9 {
    constructor(container, engine){
        this.container = container;
        this._applyPostDrawUpdaters = (particle)=>{
            for (const updater of this._postDrawUpdaters)updater.afterDraw?.(particle);
        };
        this._applyPreDrawUpdaters = (ctx, particle, radius, zOpacity, colorStyles, transform)=>{
            for (const updater of this._preDrawUpdaters){
                if (updater.getColorStyles) {
                    const { fill: fill, stroke: stroke } = updater.getColorStyles(particle, ctx, radius, zOpacity);
                    if (fill) colorStyles.fill = fill;
                    if (stroke) colorStyles.stroke = stroke;
                }
                if (updater.getTransformValues) {
                    const updaterTransform = updater.getTransformValues(particle);
                    for(const key in updaterTransform)$a0f85d4f7e124772$var$setTransformValue(transform, updaterTransform, key);
                }
                updater.beforeDraw?.(particle);
            }
        };
        this._applyResizePlugins = ()=>{
            for (const plugin of this._resizePlugins)plugin.resize?.();
        };
        this._getPluginParticleColors = (particle)=>{
            let fColor, sColor;
            for (const plugin of this._colorPlugins){
                if (!fColor && plugin.particleFillColor) fColor = (0, $6nx5m.rangeColorToHsl)(this._engine, plugin.particleFillColor(particle));
                if (!sColor && plugin.particleStrokeColor) sColor = (0, $6nx5m.rangeColorToHsl)(this._engine, plugin.particleStrokeColor(particle));
                if (fColor && sColor) break;
            }
            return [
                fColor,
                sColor
            ];
        };
        this._initCover = async ()=>{
            const options = this.container.actualOptions, cover = options.backgroundMask.cover, color = cover.color;
            if (color) {
                const coverRgb = (0, $6nx5m.rangeColorToRgb)(this._engine, color);
                if (coverRgb) {
                    const coverColor = {
                        ...coverRgb,
                        a: cover.opacity
                    };
                    this._coverColorStyle = (0, $6nx5m.getStyleFromRgb)(coverColor, coverColor.a);
                }
            } else await new Promise((resolve, reject)=>{
                if (!cover.image) return;
                const img = document.createElement("img");
                img.addEventListener("load", ()=>{
                    this._coverImage = {
                        image: img,
                        opacity: cover.opacity
                    };
                    resolve();
                });
                img.addEventListener("error", (evt)=>{
                    reject(evt.error);
                });
                img.src = cover.image;
            });
        };
        this._initStyle = ()=>{
            const element = this.element, options = this.container.actualOptions;
            if (!element) return;
            if (this._fullScreen) this._setFullScreenStyle();
            else this._resetOriginalStyle();
            for(const key in options.style){
                if (!key || !options.style || !Object.prototype.hasOwnProperty.call(options.style, key)) continue;
                const value = options.style[key];
                if (!value) continue;
                element.style.setProperty(key, value, "important");
            }
        };
        this._initTrail = async ()=>{
            const options = this.container.actualOptions, trail = options.particles.move.trail, trailFill = trail.fill;
            if (!trail.enable) return;
            const opacity = (0, $eywbI.inverseFactorNumerator) / trail.length;
            if (trailFill.color) {
                const fillColor = (0, $6nx5m.rangeColorToRgb)(this._engine, trailFill.color);
                if (!fillColor) return;
                this._trailFill = {
                    color: {
                        ...fillColor
                    },
                    opacity: opacity
                };
            } else await new Promise((resolve, reject)=>{
                if (!trailFill.image) return;
                const img = document.createElement("img");
                img.addEventListener("load", ()=>{
                    this._trailFill = {
                        image: img,
                        opacity: opacity
                    };
                    resolve();
                });
                img.addEventListener("error", (evt)=>{
                    reject(evt.error);
                });
                img.src = trailFill.image;
            });
        };
        this._paintBase = (baseColor)=>{
            this.draw((ctx)=>(0, $izu9S.paintBase)(ctx, this.size, baseColor));
        };
        this._paintImage = (image, opacity)=>{
            this.draw((ctx)=>(0, $izu9S.paintImage)(ctx, this.size, image, opacity));
        };
        this._repairStyle = ()=>{
            const element = this.element;
            if (!element) return;
            this._safeMutationObserver((observer)=>observer.disconnect());
            this._initStyle();
            this.initBackground();
            this._safeMutationObserver((observer)=>{
                if (!element || !(element instanceof Node)) return;
                observer.observe(element, {
                    attributes: true
                });
            });
        };
        this._resetOriginalStyle = ()=>{
            const element = this.element, originalStyle = this._originalStyle;
            if (!element || !originalStyle) return;
            $a0f85d4f7e124772$var$setStyle(element, originalStyle, true);
        };
        this._safeMutationObserver = (callback)=>{
            if (!this._mutationObserver) return;
            callback(this._mutationObserver);
        };
        this._setFullScreenStyle = ()=>{
            const element = this.element;
            if (!element) return;
            $a0f85d4f7e124772$var$setStyle(element, (0, $eDm3t.getFullScreenStyle)(this.container.actualOptions.fullScreen.zIndex), true);
        };
        this._engine = engine;
        this._standardSize = {
            height: 0,
            width: 0
        };
        const pxRatio = container.retina.pixelRatio, stdSize = this._standardSize;
        this.size = {
            height: stdSize.height * pxRatio,
            width: stdSize.width * pxRatio
        };
        this._context = null;
        this._generated = false;
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        this._resizePlugins = [];
        this._colorPlugins = [];
    }
    get _fullScreen() {
        return this.container.actualOptions.fullScreen.enable;
    }
    clear() {
        const options = this.container.actualOptions, trail = options.particles.move.trail, trailFill = this._trailFill;
        if (options.backgroundMask.enable) this.paint();
        else if (trail.enable && trail.length > (0, $eywbI.minimumLength) && trailFill) {
            if (trailFill.color) this._paintBase((0, $6nx5m.getStyleFromRgb)(trailFill.color, trailFill.opacity));
            else if (trailFill.image) this._paintImage(trailFill.image, trailFill.opacity);
        } else if (options.clear) this.draw((ctx)=>{
            (0, $izu9S.clear)(ctx, this.size);
        });
    }
    destroy() {
        this.stop();
        if (this._generated) {
            const element = this.element;
            element?.remove();
            this.element = undefined;
        } else this._resetOriginalStyle();
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        this._resizePlugins = [];
        this._colorPlugins = [];
    }
    draw(cb) {
        const ctx = this._context;
        if (!ctx) return;
        return cb(ctx);
    }
    drawAsync(cb) {
        const ctx = this._context;
        if (!ctx) return undefined;
        return cb(ctx);
    }
    drawParticle(particle, delta) {
        if (particle.spawning || particle.destroyed) return;
        const radius = particle.getRadius();
        if (radius <= (0, $eywbI.minimumSize)) return;
        const pfColor = particle.getFillColor(), psColor = particle.getStrokeColor() ?? pfColor;
        let [fColor, sColor] = this._getPluginParticleColors(particle);
        if (!fColor) fColor = pfColor;
        if (!sColor) sColor = psColor;
        if (!fColor && !sColor) return;
        this.draw((ctx)=>{
            const container = this.container, options = container.actualOptions, zIndexOptions = particle.options.zIndex, zIndexFactor = (0, $eywbI.zIndexFactorOffset) - particle.zIndexFactor, zOpacityFactor = zIndexFactor ** zIndexOptions.opacityRate, opacity = particle.bubble.opacity ?? particle.opacity?.value ?? (0, $eywbI.defaultOpacity), strokeOpacity = particle.strokeOpacity ?? opacity, zOpacity = opacity * zOpacityFactor, zStrokeOpacity = strokeOpacity * zOpacityFactor, transform = {}, colorStyles = {
                fill: fColor ? (0, $6nx5m.getStyleFromHsl)(fColor, zOpacity) : undefined
            };
            colorStyles.stroke = sColor ? (0, $6nx5m.getStyleFromHsl)(sColor, zStrokeOpacity) : colorStyles.fill;
            this._applyPreDrawUpdaters(ctx, particle, radius, zOpacity, colorStyles, transform);
            (0, $izu9S.drawParticle)({
                container: container,
                context: ctx,
                particle: particle,
                delta: delta,
                colorStyles: colorStyles,
                backgroundMask: options.backgroundMask.enable,
                composite: options.backgroundMask.composite,
                radius: radius * zIndexFactor ** zIndexOptions.sizeRate,
                opacity: zOpacity,
                shadow: particle.options.shadow,
                transform: transform
            });
            this._applyPostDrawUpdaters(particle);
        });
    }
    drawParticlePlugin(plugin, particle, delta) {
        this.draw((ctx)=>(0, $izu9S.drawParticlePlugin)(ctx, plugin, particle, delta));
    }
    drawPlugin(plugin, delta) {
        this.draw((ctx)=>(0, $izu9S.drawPlugin)(ctx, plugin, delta));
    }
    async init() {
        this._safeMutationObserver((obs)=>obs.disconnect());
        this._mutationObserver = (0, $eDm3t.safeMutationObserver)((records)=>{
            for (const record of records)if (record.type === "attributes" && record.attributeName === "style") this._repairStyle();
        });
        this.resize();
        this._initStyle();
        await this._initCover();
        try {
            await this._initTrail();
        } catch (e) {
            (0, $eDm3t.getLogger)().error(e);
        }
        this.initBackground();
        this._safeMutationObserver((obs)=>{
            if (!this.element || !(this.element instanceof Node)) return;
            obs.observe(this.element, {
                attributes: true
            });
        });
        this.initUpdaters();
        this.initPlugins();
        this.paint();
    }
    initBackground() {
        const options = this.container.actualOptions, background = options.background, element = this.element;
        if (!element) return;
        const elementStyle = element.style;
        if (!elementStyle) return;
        if (background.color) {
            const color = (0, $6nx5m.rangeColorToRgb)(this._engine, background.color);
            elementStyle.backgroundColor = color ? (0, $6nx5m.getStyleFromRgb)(color, background.opacity) : "";
        } else elementStyle.backgroundColor = "";
        elementStyle.backgroundImage = background.image || "";
        elementStyle.backgroundPosition = background.position || "";
        elementStyle.backgroundRepeat = background.repeat || "";
        elementStyle.backgroundSize = background.size || "";
    }
    initPlugins() {
        this._resizePlugins = [];
        for (const plugin of this.container.plugins.values()){
            if (plugin.resize) this._resizePlugins.push(plugin);
            if (plugin.particleFillColor ?? plugin.particleStrokeColor) this._colorPlugins.push(plugin);
        }
    }
    initUpdaters() {
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        for (const updater of this.container.particles.updaters){
            if (updater.afterDraw) this._postDrawUpdaters.push(updater);
            if (updater.getColorStyles ?? updater.getTransformValues ?? updater.beforeDraw) this._preDrawUpdaters.push(updater);
        }
    }
    loadCanvas(canvas) {
        if (this._generated && this.element) this.element.remove();
        this._generated = canvas.dataset && (0, $eywbI.generatedAttribute) in canvas.dataset ? canvas.dataset[0, $eywbI.generatedAttribute] === "true" : this._generated;
        this.element = canvas;
        this.element.ariaHidden = "true";
        this._originalStyle = (0, $eDm3t.cloneStyle)(this.element.style);
        const standardSize = this._standardSize;
        standardSize.height = canvas.offsetHeight;
        standardSize.width = canvas.offsetWidth;
        const pxRatio = this.container.retina.pixelRatio, retinaSize = this.size;
        canvas.height = retinaSize.height = standardSize.height * pxRatio;
        canvas.width = retinaSize.width = standardSize.width * pxRatio;
        this._context = this.element.getContext("2d");
        this._safeMutationObserver((obs)=>obs.disconnect());
        this.container.retina.init();
        this.initBackground();
        this._safeMutationObserver((obs)=>{
            if (!this.element || !(this.element instanceof Node)) return;
            obs.observe(this.element, {
                attributes: true
            });
        });
    }
    paint() {
        const options = this.container.actualOptions;
        this.draw((ctx)=>{
            if (options.backgroundMask.enable && options.backgroundMask.cover) {
                (0, $izu9S.clear)(ctx, this.size);
                if (this._coverImage) this._paintImage(this._coverImage.image, this._coverImage.opacity);
                else if (this._coverColorStyle) this._paintBase(this._coverColorStyle);
                else this._paintBase();
            } else this._paintBase();
        });
    }
    resize() {
        if (!this.element) return false;
        const container = this.container, currentSize = container.canvas._standardSize, newSize = {
            width: this.element.offsetWidth,
            height: this.element.offsetHeight
        }, pxRatio = container.retina.pixelRatio, retinaSize = {
            width: newSize.width * pxRatio,
            height: newSize.height * pxRatio
        };
        if (newSize.height === currentSize.height && newSize.width === currentSize.width && retinaSize.height === this.element.height && retinaSize.width === this.element.width) return false;
        const oldSize = {
            ...currentSize
        };
        currentSize.height = newSize.height;
        currentSize.width = newSize.width;
        const canvasSize = this.size;
        this.element.width = canvasSize.width = retinaSize.width;
        this.element.height = canvasSize.height = retinaSize.height;
        if (this.container.started) container.particles.setResizeFactor({
            width: currentSize.width / oldSize.width,
            height: currentSize.height / oldSize.height
        });
        return true;
    }
    stop() {
        this._safeMutationObserver((obs)=>obs.disconnect());
        this._mutationObserver = undefined;
        this.draw((ctx)=>(0, $izu9S.clear)(ctx, this.size));
    }
    async windowResize() {
        if (!this.element || !this.resize()) return;
        const container = this.container, needsRefresh = container.updateActualOptions();
        container.particles.setDensity();
        this._applyResizePlugins();
        if (needsRefresh) await container.refresh();
    }
}

});
parcelRegister("izu9S", function(module, exports) {

$parcel$export(module.exports, "paintBase", () => $d852e3ae8ba285a3$export$2837cdf5427f767e);
$parcel$export(module.exports, "paintImage", () => $d852e3ae8ba285a3$export$a17334b9431a8cb2);
$parcel$export(module.exports, "clear", () => $d852e3ae8ba285a3$export$42ffd38884aecdac);
$parcel$export(module.exports, "drawParticle", () => $d852e3ae8ba285a3$export$fca8f175741ef351);
$parcel$export(module.exports, "drawPlugin", () => $d852e3ae8ba285a3$export$ee9933e1bf4ba142);
$parcel$export(module.exports, "drawParticlePlugin", () => $d852e3ae8ba285a3$export$3493f6d6277d918a);
$parcel$export(module.exports, "alterHsl", () => $d852e3ae8ba285a3$export$fe1d034b0e82666);

var $eywbI = parcelRequire("eywbI");

var $1ruWN = parcelRequire("1ruWN");

var $6nx5m = parcelRequire("6nx5m");
function $d852e3ae8ba285a3$export$819db45aec5fcbe5(context, begin, end) {
    context.beginPath();
    context.moveTo(begin.x, begin.y);
    context.lineTo(end.x, end.y);
    context.closePath();
}
function $d852e3ae8ba285a3$export$2837cdf5427f767e(context, dimension, baseColor) {
    context.fillStyle = baseColor ?? "rgba(0,0,0,0)";
    context.fillRect((0, $eywbI.originPoint).x, (0, $eywbI.originPoint).y, dimension.width, dimension.height);
}
function $d852e3ae8ba285a3$export$a17334b9431a8cb2(context, dimension, image, opacity) {
    if (!image) return;
    context.globalAlpha = opacity;
    context.drawImage(image, (0, $eywbI.originPoint).x, (0, $eywbI.originPoint).y, dimension.width, dimension.height);
    context.globalAlpha = 1;
}
function $d852e3ae8ba285a3$export$42ffd38884aecdac(context, dimension) {
    context.clearRect((0, $eywbI.originPoint).x, (0, $eywbI.originPoint).y, dimension.width, dimension.height);
}
function $d852e3ae8ba285a3$export$fca8f175741ef351(data) {
    const { container: container, context: context, particle: particle, delta: delta, colorStyles: colorStyles, backgroundMask: backgroundMask, composite: composite, radius: radius, opacity: opacity, shadow: shadow, transform: transform } = data, pos = particle.getPosition(), angle = particle.rotation + (particle.pathRotation ? particle.velocity.angle : (0, $eywbI.defaultAngle)), rotateData = {
        sin: Math.sin(angle),
        cos: Math.cos(angle)
    }, rotating = !!angle, transformData = {
        a: rotateData.cos * (transform.a ?? (0, $eywbI.defaultTransform).a),
        b: rotating ? rotateData.sin * (transform.b ?? (0, $eywbI.identity)) : transform.b ?? (0, $eywbI.defaultTransform).b,
        c: rotating ? -rotateData.sin * (transform.c ?? (0, $eywbI.identity)) : transform.c ?? (0, $eywbI.defaultTransform).c,
        d: rotateData.cos * (transform.d ?? (0, $eywbI.defaultTransform).d)
    };
    context.setTransform(transformData.a, transformData.b, transformData.c, transformData.d, pos.x, pos.y);
    if (backgroundMask) context.globalCompositeOperation = composite;
    const shadowColor = particle.shadowColor;
    if (shadow.enable && shadowColor) {
        context.shadowBlur = shadow.blur;
        context.shadowColor = (0, $6nx5m.getStyleFromRgb)(shadowColor);
        context.shadowOffsetX = shadow.offset.x;
        context.shadowOffsetY = shadow.offset.y;
    }
    if (colorStyles.fill) context.fillStyle = colorStyles.fill;
    const strokeWidth = particle.strokeWidth ?? (0, $eywbI.minStrokeWidth);
    context.lineWidth = strokeWidth;
    if (colorStyles.stroke) context.strokeStyle = colorStyles.stroke;
    const drawData = {
        container: container,
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        transformData: transformData,
        strokeWidth: strokeWidth
    };
    $d852e3ae8ba285a3$export$71b514a25c47df50(drawData);
    $d852e3ae8ba285a3$export$2808702213c51f09(drawData);
    $d852e3ae8ba285a3$export$27b58ff3abda0f8e(drawData);
    context.globalCompositeOperation = "source-over";
    context.resetTransform();
}
function $d852e3ae8ba285a3$export$27b58ff3abda0f8e(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, transformData: transformData } = data;
    if (!particle.effect) return;
    const drawer = container.effectDrawers.get(particle.effect);
    if (!drawer) return;
    drawer.draw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
}
function $d852e3ae8ba285a3$export$71b514a25c47df50(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, strokeWidth: strokeWidth, transformData: transformData } = data;
    if (!particle.shape) return;
    const drawer = container.shapeDrawers.get(particle.shape);
    if (!drawer) return;
    context.beginPath();
    drawer.draw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
    if (particle.shapeClose) context.closePath();
    if (strokeWidth > (0, $eywbI.minStrokeWidth)) context.stroke();
    if (particle.shapeFill) context.fill();
}
function $d852e3ae8ba285a3$export$2808702213c51f09(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, transformData: transformData } = data;
    if (!particle.shape) return;
    const drawer = container.shapeDrawers.get(particle.shape);
    if (!drawer?.afterDraw) return;
    drawer.afterDraw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
}
function $d852e3ae8ba285a3$export$ee9933e1bf4ba142(context, plugin, delta) {
    if (!plugin.draw) return;
    plugin.draw(context, delta);
}
function $d852e3ae8ba285a3$export$3493f6d6277d918a(context, plugin, particle, delta) {
    if (!plugin.drawParticle) return;
    plugin.drawParticle(context, particle, delta);
}
function $d852e3ae8ba285a3$export$fe1d034b0e82666(color, type, value) {
    return {
        h: color.h,
        s: color.s,
        l: color.l + (type === (0, $1ruWN.AlterType).darken ? -(0, $eywbI.lFactor) : (0, $eywbI.lFactor)) * value
    };
}

});
parcelRegister("1ruWN", function(module, exports) {

$parcel$export(module.exports, "AlterType", () => $10d05192ed37598e$export$d3c0448523aecc2e);
var $10d05192ed37598e$export$d3c0448523aecc2e;
(function(AlterType) {
    AlterType["darken"] = "darken";
    AlterType["enlighten"] = "enlighten";
})($10d05192ed37598e$export$d3c0448523aecc2e || ($10d05192ed37598e$export$d3c0448523aecc2e = {}));

});

parcelRegister("6nx5m", function(module, exports) {

$parcel$export(module.exports, "rangeColorToRgb", () => $4a4e8e1eaf78a55e$export$fbf0bf3cc1fc0cc4);
$parcel$export(module.exports, "rangeColorToHsl", () => $4a4e8e1eaf78a55e$export$79a89086521c0f12);
$parcel$export(module.exports, "hslToRgb", () => $4a4e8e1eaf78a55e$export$29fb7152bd3f781a);
$parcel$export(module.exports, "hslaToRgba", () => $4a4e8e1eaf78a55e$export$6ae64dbcd6bfc33e);
$parcel$export(module.exports, "getStyleFromRgb", () => $4a4e8e1eaf78a55e$export$2476af37e47fcae2);
$parcel$export(module.exports, "getStyleFromHsl", () => $4a4e8e1eaf78a55e$export$9d057e59c7b0a82d);
$parcel$export(module.exports, "getHslFromAnimation", () => $4a4e8e1eaf78a55e$export$c90768c73bc1d7ab);
$parcel$export(module.exports, "getHslAnimationFromHsl", () => $4a4e8e1eaf78a55e$export$6e8a573710bea117);
$parcel$export(module.exports, "updateColor", () => $4a4e8e1eaf78a55e$export$649b44ac750da8e);

var $yZzCW = parcelRequire("yZzCW");

var $eywbI = parcelRequire("eywbI");

var $62pjT = parcelRequire("62pjT");

var $d8kOl = parcelRequire("d8kOl");

var $eDm3t = parcelRequire("eDm3t");
function $4a4e8e1eaf78a55e$var$stringToRgba(engine, input) {
    if (!input) return;
    for (const manager of engine.colorManagers.values()){
        if (input.startsWith(manager.stringPrefix)) return manager.parseString(input);
    }
}
function $4a4e8e1eaf78a55e$export$fbf0bf3cc1fc0cc4(engine, input, index, useIndex = true) {
    if (!input) return;
    const color = (0, $62pjT.isString)(input) ? {
        value: input
    } : input;
    if ((0, $62pjT.isString)(color.value)) return $4a4e8e1eaf78a55e$export$170d64abcc52d97a(engine, color.value, index, useIndex);
    if ((0, $62pjT.isArray)(color.value)) return $4a4e8e1eaf78a55e$export$fbf0bf3cc1fc0cc4(engine, {
        value: (0, $eDm3t.itemFromArray)(color.value, index, useIndex)
    });
    for (const manager of engine.colorManagers.values()){
        const res = manager.handleRangeColor(color);
        if (res) return res;
    }
}
function $4a4e8e1eaf78a55e$export$170d64abcc52d97a(engine, input, index, useIndex = true) {
    if (!input) return;
    const color = (0, $62pjT.isString)(input) ? {
        value: input
    } : input;
    if ((0, $62pjT.isString)(color.value)) return color.value === (0, $eywbI.randomColorValue) ? $4a4e8e1eaf78a55e$export$ac4fc8e9144a1018() : $4a4e8e1eaf78a55e$export$d2c5ec93815c4391(engine, color.value);
    if ((0, $62pjT.isArray)(color.value)) return $4a4e8e1eaf78a55e$export$170d64abcc52d97a(engine, {
        value: (0, $eDm3t.itemFromArray)(color.value, index, useIndex)
    });
    for (const manager of engine.colorManagers.values()){
        const res = manager.handleColor(color);
        if (res) return res;
    }
}
function $4a4e8e1eaf78a55e$export$5e49d166a305dfce(engine, color, index, useIndex = true) {
    const rgb = $4a4e8e1eaf78a55e$export$170d64abcc52d97a(engine, color, index, useIndex);
    return rgb ? $4a4e8e1eaf78a55e$export$c85ca4f4753af384(rgb) : undefined;
}
function $4a4e8e1eaf78a55e$export$79a89086521c0f12(engine, color, index, useIndex = true) {
    const rgb = $4a4e8e1eaf78a55e$export$fbf0bf3cc1fc0cc4(engine, color, index, useIndex);
    return rgb ? $4a4e8e1eaf78a55e$export$c85ca4f4753af384(rgb) : undefined;
}
function $4a4e8e1eaf78a55e$export$c85ca4f4753af384(color) {
    const r1 = color.r / (0, $eywbI.rgbMax), g1 = color.g / (0, $eywbI.rgbMax), b1 = color.b / (0, $eywbI.rgbMax), max = Math.max(r1, g1, b1), min = Math.min(r1, g1, b1), res = {
        h: (0, $eywbI.hMin),
        l: (max + min) * (0, $eywbI.half),
        s: (0, $eywbI.sMin)
    };
    if (max !== min) {
        res.s = res.l < (0, $eywbI.half) ? (max - min) / (max + min) : (max - min) / ((0, $eywbI.double) - max - min);
        res.h = r1 === max ? (g1 - b1) / (max - min) : res.h = g1 === max ? (0, $eywbI.double) + (b1 - r1) / (max - min) : (0, $eywbI.double) * (0, $eywbI.double) + (r1 - g1) / (max - min);
    }
    res.l *= (0, $eywbI.lMax);
    res.s *= (0, $eywbI.sMax);
    res.h *= (0, $eywbI.hPhase);
    if (res.h < (0, $eywbI.hMin)) res.h += (0, $eywbI.hMax);
    if (res.h >= (0, $eywbI.hMax)) res.h -= (0, $eywbI.hMax);
    return res;
}
function $4a4e8e1eaf78a55e$export$143dda7722fd213d(engine, input) {
    return $4a4e8e1eaf78a55e$var$stringToRgba(engine, input)?.a;
}
function $4a4e8e1eaf78a55e$export$d2c5ec93815c4391(engine, input) {
    return $4a4e8e1eaf78a55e$var$stringToRgba(engine, input);
}
function $4a4e8e1eaf78a55e$export$29fb7152bd3f781a(hsl) {
    const h = (hsl.h % (0, $eywbI.hMax) + (0, $eywbI.hMax)) % (0, $eywbI.hMax), s = Math.max((0, $eywbI.sMin), Math.min((0, $eywbI.sMax), hsl.s)), l = Math.max((0, $eywbI.lMin), Math.min((0, $eywbI.lMax), hsl.l)), hNormalized = h / (0, $eywbI.hMax), sNormalized = s / (0, $eywbI.sMax), lNormalized = l / (0, $eywbI.lMax);
    if (s === (0, $eywbI.sMin)) {
        const grayscaleValue = Math.round(lNormalized * (0, $eywbI.rgbFactor));
        return {
            r: grayscaleValue,
            g: grayscaleValue,
            b: grayscaleValue
        };
    }
    const channel = (temp1, temp2, temp3)=>{
        const temp3Min = 0, temp3Max = 1;
        if (temp3 < temp3Min) temp3++;
        if (temp3 > temp3Max) temp3--;
        if (temp3 * (0, $eywbI.sextuple) < temp3Max) return temp1 + (temp2 - temp1) * (0, $eywbI.sextuple) * temp3;
        if (temp3 * (0, $eywbI.double) < temp3Max) return temp2;
        if (temp3 * (0, $eywbI.triple) < temp3Max * (0, $eywbI.double)) {
            const temp3Offset = (0, $eywbI.double) / (0, $eywbI.triple);
            return temp1 + (temp2 - temp1) * (temp3Offset - temp3) * (0, $eywbI.sextuple);
        }
        return temp1;
    }, temp1 = lNormalized < (0, $eywbI.half) ? lNormalized * ((0, $eywbI.sNormalizedOffset) + sNormalized) : lNormalized + sNormalized - lNormalized * sNormalized, temp2 = (0, $eywbI.double) * lNormalized - temp1, phaseThird = (0, $eywbI.phaseNumerator) / (0, $eywbI.triple), red = Math.min((0, $eywbI.rgbFactor), (0, $eywbI.rgbFactor) * channel(temp2, temp1, hNormalized + phaseThird)), green = Math.min((0, $eywbI.rgbFactor), (0, $eywbI.rgbFactor) * channel(temp2, temp1, hNormalized)), blue = Math.min((0, $eywbI.rgbFactor), (0, $eywbI.rgbFactor) * channel(temp2, temp1, hNormalized - phaseThird));
    return {
        r: Math.round(red),
        g: Math.round(green),
        b: Math.round(blue)
    };
}
function $4a4e8e1eaf78a55e$export$6ae64dbcd6bfc33e(hsla) {
    const rgbResult = $4a4e8e1eaf78a55e$export$29fb7152bd3f781a(hsla);
    return {
        a: hsla.a,
        b: rgbResult.b,
        g: rgbResult.g,
        r: rgbResult.r
    };
}
function $4a4e8e1eaf78a55e$export$ac4fc8e9144a1018(min) {
    const fixedMin = min ?? (0, $eywbI.defaultRgbMin), fixedMax = (0, $eywbI.rgbMax) + (0, $eywbI.identity);
    return {
        b: Math.floor((0, $yZzCW.randomInRange)((0, $yZzCW.setRangeValue)(fixedMin, fixedMax))),
        g: Math.floor((0, $yZzCW.randomInRange)((0, $yZzCW.setRangeValue)(fixedMin, fixedMax))),
        r: Math.floor((0, $yZzCW.randomInRange)((0, $yZzCW.setRangeValue)(fixedMin, fixedMax)))
    };
}
function $4a4e8e1eaf78a55e$export$2476af37e47fcae2(color, opacity) {
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${opacity ?? (0, $eywbI.defaultOpacity)})`;
}
function $4a4e8e1eaf78a55e$export$9d057e59c7b0a82d(color, opacity) {
    return `hsla(${color.h}, ${color.s}%, ${color.l}%, ${opacity ?? (0, $eywbI.defaultOpacity)})`;
}
function $4a4e8e1eaf78a55e$export$9b476054b78b89cd(color1, color2, size1, size2) {
    let rgb1 = color1, rgb2 = color2;
    if (rgb1.r === undefined) rgb1 = $4a4e8e1eaf78a55e$export$29fb7152bd3f781a(color1);
    if (rgb2.r === undefined) rgb2 = $4a4e8e1eaf78a55e$export$29fb7152bd3f781a(color2);
    return {
        b: (0, $yZzCW.mix)(rgb1.b, rgb2.b, size1, size2),
        g: (0, $yZzCW.mix)(rgb1.g, rgb2.g, size1, size2),
        r: (0, $yZzCW.mix)(rgb1.r, rgb2.r, size1, size2)
    };
}
function $4a4e8e1eaf78a55e$export$b676eb46c472d7df(p1, p2, linkColor) {
    if (linkColor === (0, $eywbI.randomColorValue)) return $4a4e8e1eaf78a55e$export$ac4fc8e9144a1018();
    else if (linkColor === (0, $eywbI.midColorValue)) {
        const sourceColor = p1.getFillColor() ?? p1.getStrokeColor(), destColor = p2?.getFillColor() ?? p2?.getStrokeColor();
        if (sourceColor && destColor && p2) return $4a4e8e1eaf78a55e$export$9b476054b78b89cd(sourceColor, destColor, p1.getRadius(), p2.getRadius());
        else {
            const hslColor = sourceColor ?? destColor;
            if (hslColor) return $4a4e8e1eaf78a55e$export$29fb7152bd3f781a(hslColor);
        }
    } else return linkColor;
}
function $4a4e8e1eaf78a55e$export$cf0e5a4ae26bdcdc(engine, optColor, blink, consent) {
    const color = (0, $62pjT.isString)(optColor) ? optColor : optColor.value;
    if (color === (0, $eywbI.randomColorValue)) {
        if (consent) return $4a4e8e1eaf78a55e$export$fbf0bf3cc1fc0cc4(engine, {
            value: color
        });
        if (blink) return 0, $eywbI.randomColorValue;
        return 0, $eywbI.midColorValue;
    } else if (color === (0, $eywbI.midColorValue)) return 0, $eywbI.midColorValue;
    else return $4a4e8e1eaf78a55e$export$fbf0bf3cc1fc0cc4(engine, {
        value: color
    });
}
function $4a4e8e1eaf78a55e$export$c90768c73bc1d7ab(animation) {
    return animation !== undefined ? {
        h: animation.h.value,
        s: animation.s.value,
        l: animation.l.value
    } : undefined;
}
function $4a4e8e1eaf78a55e$export$6e8a573710bea117(hsl, animationOptions, reduceFactor) {
    const resColor = {
        h: {
            enable: false,
            value: hsl.h
        },
        s: {
            enable: false,
            value: hsl.s
        },
        l: {
            enable: false,
            value: hsl.l
        }
    };
    if (animationOptions) {
        $4a4e8e1eaf78a55e$var$setColorAnimation(resColor.h, animationOptions.h, reduceFactor);
        $4a4e8e1eaf78a55e$var$setColorAnimation(resColor.s, animationOptions.s, reduceFactor);
        $4a4e8e1eaf78a55e$var$setColorAnimation(resColor.l, animationOptions.l, reduceFactor);
    }
    return resColor;
}
function $4a4e8e1eaf78a55e$var$setColorAnimation(colorValue, colorAnimation, reduceFactor) {
    colorValue.enable = colorAnimation.enable;
    if (colorValue.enable) {
        colorValue.velocity = (0, $yZzCW.getRangeValue)(colorAnimation.speed) / (0, $eywbI.percentDenominator) * reduceFactor;
        colorValue.decay = (0, $eywbI.decayOffset) - (0, $yZzCW.getRangeValue)(colorAnimation.decay);
        colorValue.status = (0, $d8kOl.AnimationStatus).increasing;
        colorValue.loops = (0, $eywbI.defaultLoops);
        colorValue.maxLoops = (0, $yZzCW.getRangeValue)(colorAnimation.count);
        colorValue.time = (0, $eywbI.defaultTime);
        colorValue.delayTime = (0, $yZzCW.getRangeValue)(colorAnimation.delay) * (0, $eywbI.millisecondsToSeconds);
        if (!colorAnimation.sync) {
            colorValue.velocity *= (0, $yZzCW.getRandom)();
            colorValue.value *= (0, $yZzCW.getRandom)();
        }
        colorValue.initialValue = colorValue.value;
        colorValue.offset = (0, $yZzCW.setRangeValue)(colorAnimation.offset);
    } else colorValue.velocity = (0, $eywbI.defaultVelocity);
}
function $4a4e8e1eaf78a55e$export$a151177c20377190(data, range, decrease, delta) {
    const minLoops = 0, minDelay = 0, identity = 1, minVelocity = 0, minOffset = 0, velocityFactor = 3.6;
    if (!data || !data.enable || (data.maxLoops ?? minLoops) > minLoops && (data.loops ?? minLoops) > (data.maxLoops ?? minLoops)) return;
    if (!data.time) data.time = 0;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) data.time += delta.value;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) return;
    const offset = data.offset ? (0, $yZzCW.randomInRange)(data.offset) : minOffset, velocity = (data.velocity ?? minVelocity) * delta.factor + offset * velocityFactor, decay = data.decay ?? identity, max = (0, $yZzCW.getRangeMax)(range), min = (0, $yZzCW.getRangeMin)(range);
    if (!decrease || data.status === (0, $d8kOl.AnimationStatus).increasing) {
        data.value += velocity;
        if (data.value > max) {
            if (!data.loops) data.loops = 0;
            data.loops++;
            if (decrease) data.status = (0, $d8kOl.AnimationStatus).decreasing;
            else data.value -= max;
        }
    } else {
        data.value -= velocity;
        const minValue = 0;
        if (data.value < minValue) {
            if (!data.loops) data.loops = 0;
            data.loops++;
            data.status = (0, $d8kOl.AnimationStatus).increasing;
        }
    }
    if (data.velocity && decay !== identity) data.velocity *= decay;
    data.value = (0, $yZzCW.clamp)(data.value, min, max);
}
function $4a4e8e1eaf78a55e$export$649b44ac750da8e(color, delta) {
    if (!color) return;
    const { h: h, s: s, l: l } = color, ranges = {
        h: {
            min: 0,
            max: 360
        },
        s: {
            min: 0,
            max: 100
        },
        l: {
            min: 0,
            max: 100
        }
    };
    if (h) $4a4e8e1eaf78a55e$export$a151177c20377190(h, ranges.h, false, delta);
    if (s) $4a4e8e1eaf78a55e$export$a151177c20377190(s, ranges.s, true, delta);
    if (l) $4a4e8e1eaf78a55e$export$a151177c20377190(l, ranges.l, true, delta);
}

});



parcelRegister("lC80j", function(module, exports) {

$parcel$export(module.exports, "EventListeners", () => $fbc35b02381f03fb$export$b20b719ec758a20f);

var $eywbI = parcelRequire("eywbI");

var $eDm3t = parcelRequire("eDm3t");

var $3F4oU = parcelRequire("3F4oU");

var $62pjT = parcelRequire("62pjT");
function $fbc35b02381f03fb$var$manageListener(element, event, handler, add, options) {
    if (add) {
        let addOptions = {
            passive: true
        };
        if ((0, $62pjT.isBoolean)(options)) addOptions.capture = options;
        else if (options !== undefined) addOptions = options;
        element.addEventListener(event, handler, addOptions);
    } else {
        const removeOptions = options;
        element.removeEventListener(event, handler, removeOptions);
    }
}
class $fbc35b02381f03fb$export$b20b719ec758a20f {
    constructor(container){
        this.container = container;
        this._doMouseTouchClick = (e)=>{
            const container = this.container, options = container.actualOptions;
            if (this._canPush) {
                const mouseInteractivity = container.interactivity.mouse, mousePos = mouseInteractivity.position;
                if (!mousePos) return;
                mouseInteractivity.clickPosition = {
                    ...mousePos
                };
                mouseInteractivity.clickTime = new Date().getTime();
                const onClick = options.interactivity.events.onClick;
                (0, $eDm3t.executeOnSingleOrMultiple)(onClick.mode, (mode)=>this.container.handleClickMode(mode));
            }
            if (e.type === "touchend") setTimeout(()=>this._mouseTouchFinish(), (0, $eywbI.touchDelay));
        };
        this._handleThemeChange = (e)=>{
            const mediaEvent = e, container = this.container, options = container.options, defaultThemes = options.defaultThemes, themeName = mediaEvent.matches ? defaultThemes.dark : defaultThemes.light, theme = options.themes.find((theme)=>theme.name === themeName);
            if (theme?.default.auto) container.loadTheme(themeName);
        };
        this._handleVisibilityChange = ()=>{
            const container = this.container, options = container.actualOptions;
            this._mouseTouchFinish();
            if (!options.pauseOnBlur) return;
            if (document?.hidden) {
                container.pageHidden = true;
                container.pause();
            } else {
                container.pageHidden = false;
                if (container.animationStatus) container.play(true);
                else container.draw(true);
            }
        };
        this._handleWindowResize = ()=>{
            if (this._resizeTimeout) {
                clearTimeout(this._resizeTimeout);
                delete this._resizeTimeout;
            }
            const handleResize = async ()=>{
                const canvas = this.container.canvas;
                await canvas?.windowResize();
            };
            this._resizeTimeout = setTimeout(()=>void handleResize(), this.container.actualOptions.interactivity.events.resize.delay * (0, $eywbI.millisecondsToSeconds));
        };
        this._manageInteractivityListeners = (mouseLeaveTmpEvent, add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions, interactivityEl = container.interactivity.element;
            if (!interactivityEl) return;
            const html = interactivityEl, canvasEl = container.canvas.element;
            if (canvasEl) canvasEl.style.pointerEvents = html === canvasEl ? "initial" : "none";
            if (!(options.interactivity.events.onHover.enable || options.interactivity.events.onClick.enable)) return;
            $fbc35b02381f03fb$var$manageListener(interactivityEl, (0, $eywbI.mouseMoveEvent), handlers.mouseMove, add);
            $fbc35b02381f03fb$var$manageListener(interactivityEl, (0, $eywbI.touchStartEvent), handlers.touchStart, add);
            $fbc35b02381f03fb$var$manageListener(interactivityEl, (0, $eywbI.touchMoveEvent), handlers.touchMove, add);
            if (!options.interactivity.events.onClick.enable) $fbc35b02381f03fb$var$manageListener(interactivityEl, (0, $eywbI.touchEndEvent), handlers.touchEnd, add);
            else {
                $fbc35b02381f03fb$var$manageListener(interactivityEl, (0, $eywbI.touchEndEvent), handlers.touchEndClick, add);
                $fbc35b02381f03fb$var$manageListener(interactivityEl, (0, $eywbI.mouseUpEvent), handlers.mouseUp, add);
                $fbc35b02381f03fb$var$manageListener(interactivityEl, (0, $eywbI.mouseDownEvent), handlers.mouseDown, add);
            }
            $fbc35b02381f03fb$var$manageListener(interactivityEl, mouseLeaveTmpEvent, handlers.mouseLeave, add);
            $fbc35b02381f03fb$var$manageListener(interactivityEl, (0, $eywbI.touchCancelEvent), handlers.touchCancel, add);
        };
        this._manageListeners = (add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions, detectType = options.interactivity.detectsOn, canvasEl = container.canvas.element;
            let mouseLeaveTmpEvent = (0, $eywbI.mouseLeaveEvent);
            if (detectType === (0, $3F4oU.InteractivityDetect).window) {
                container.interactivity.element = window;
                mouseLeaveTmpEvent = (0, $eywbI.mouseOutEvent);
            } else if (detectType === (0, $3F4oU.InteractivityDetect).parent && canvasEl) container.interactivity.element = canvasEl.parentElement ?? canvasEl.parentNode;
            else container.interactivity.element = canvasEl;
            this._manageMediaMatch(add);
            this._manageResize(add);
            this._manageInteractivityListeners(mouseLeaveTmpEvent, add);
            if (document) $fbc35b02381f03fb$var$manageListener(document, (0, $eywbI.visibilityChangeEvent), handlers.visibilityChange, add, false);
        };
        this._manageMediaMatch = (add)=>{
            const handlers = this._handlers, mediaMatch = (0, $eDm3t.safeMatchMedia)("(prefers-color-scheme: dark)");
            if (!mediaMatch) return;
            if (mediaMatch.addEventListener !== undefined) {
                $fbc35b02381f03fb$var$manageListener(mediaMatch, "change", handlers.themeChange, add);
                return;
            }
            if (mediaMatch.addListener === undefined) return;
            if (add) mediaMatch.addListener(handlers.oldThemeChange);
            else mediaMatch.removeListener(handlers.oldThemeChange);
        };
        this._manageResize = (add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions;
            if (!options.interactivity.events.resize) return;
            if (typeof ResizeObserver === "undefined") {
                $fbc35b02381f03fb$var$manageListener(window, (0, $eywbI.resizeEvent), handlers.resize, add);
                return;
            }
            const canvasEl = container.canvas.element;
            if (this._resizeObserver && !add) {
                if (canvasEl) this._resizeObserver.unobserve(canvasEl);
                this._resizeObserver.disconnect();
                delete this._resizeObserver;
            } else if (!this._resizeObserver && add && canvasEl) {
                this._resizeObserver = new ResizeObserver((entries)=>{
                    const entry = entries.find((e)=>e.target === canvasEl);
                    if (!entry) return;
                    this._handleWindowResize();
                });
                this._resizeObserver.observe(canvasEl);
            }
        };
        this._mouseDown = ()=>{
            const { interactivity: interactivity } = this.container;
            if (!interactivity) return;
            const { mouse: mouse } = interactivity;
            mouse.clicking = true;
            mouse.downPosition = mouse.position;
        };
        this._mouseTouchClick = (e)=>{
            const container = this.container, options = container.actualOptions, { mouse: mouse } = container.interactivity;
            mouse.inside = true;
            let handled = false;
            const mousePosition = mouse.position;
            if (!mousePosition || !options.interactivity.events.onClick.enable) return;
            for (const plugin of container.plugins.values()){
                if (!plugin.clickPositionValid) continue;
                handled = plugin.clickPositionValid(mousePosition);
                if (handled) break;
            }
            if (!handled) this._doMouseTouchClick(e);
            mouse.clicking = false;
        };
        this._mouseTouchFinish = ()=>{
            const interactivity = this.container.interactivity;
            if (!interactivity) return;
            const mouse = interactivity.mouse;
            delete mouse.position;
            delete mouse.clickPosition;
            delete mouse.downPosition;
            interactivity.status = (0, $eywbI.mouseLeaveEvent);
            mouse.inside = false;
            mouse.clicking = false;
        };
        this._mouseTouchMove = (e)=>{
            const container = this.container, options = container.actualOptions, interactivity = container.interactivity, canvasEl = container.canvas.element;
            if (!interactivity?.element) return;
            interactivity.mouse.inside = true;
            let pos;
            if (e.type.startsWith("pointer")) {
                this._canPush = true;
                const mouseEvent = e;
                if (interactivity.element === window) {
                    if (canvasEl) {
                        const clientRect = canvasEl.getBoundingClientRect();
                        pos = {
                            x: mouseEvent.clientX - clientRect.left,
                            y: mouseEvent.clientY - clientRect.top
                        };
                    }
                } else if (options.interactivity.detectsOn === (0, $3F4oU.InteractivityDetect).parent) {
                    const source = mouseEvent.target, target = mouseEvent.currentTarget;
                    if (source && target && canvasEl) {
                        const sourceRect = source.getBoundingClientRect(), targetRect = target.getBoundingClientRect(), canvasRect = canvasEl.getBoundingClientRect();
                        pos = {
                            x: mouseEvent.offsetX + (0, $eywbI.double) * sourceRect.left - (targetRect.left + canvasRect.left),
                            y: mouseEvent.offsetY + (0, $eywbI.double) * sourceRect.top - (targetRect.top + canvasRect.top)
                        };
                    } else pos = {
                        x: mouseEvent.offsetX ?? mouseEvent.clientX,
                        y: mouseEvent.offsetY ?? mouseEvent.clientY
                    };
                } else if (mouseEvent.target === canvasEl) pos = {
                    x: mouseEvent.offsetX ?? mouseEvent.clientX,
                    y: mouseEvent.offsetY ?? mouseEvent.clientY
                };
            } else {
                this._canPush = e.type !== "touchmove";
                if (canvasEl) {
                    const touchEvent = e, lastTouch = touchEvent.touches[touchEvent.touches.length - (0, $eywbI.lengthOffset)], canvasRect = canvasEl.getBoundingClientRect();
                    pos = {
                        x: lastTouch.clientX - (canvasRect.left ?? (0, $eywbI.minCoordinate)),
                        y: lastTouch.clientY - (canvasRect.top ?? (0, $eywbI.minCoordinate))
                    };
                }
            }
            const pxRatio = container.retina.pixelRatio;
            if (pos) {
                pos.x *= pxRatio;
                pos.y *= pxRatio;
            }
            interactivity.mouse.position = pos;
            interactivity.status = (0, $eywbI.mouseMoveEvent);
        };
        this._touchEnd = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.delete(touch.identifier);
            this._mouseTouchFinish();
        };
        this._touchEndClick = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.delete(touch.identifier);
            this._mouseTouchClick(e);
        };
        this._touchStart = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.set(touch.identifier, performance.now());
            this._mouseTouchMove(e);
        };
        this._canPush = true;
        this._touches = new Map();
        this._handlers = {
            mouseDown: ()=>this._mouseDown(),
            mouseLeave: ()=>this._mouseTouchFinish(),
            mouseMove: (e)=>this._mouseTouchMove(e),
            mouseUp: (e)=>this._mouseTouchClick(e),
            touchStart: (e)=>this._touchStart(e),
            touchMove: (e)=>this._mouseTouchMove(e),
            touchEnd: (e)=>this._touchEnd(e),
            touchCancel: (e)=>this._touchEnd(e),
            touchEndClick: (e)=>this._touchEndClick(e),
            visibilityChange: ()=>this._handleVisibilityChange(),
            themeChange: (e)=>this._handleThemeChange(e),
            oldThemeChange: (e)=>this._handleThemeChange(e),
            resize: ()=>{
                this._handleWindowResize();
            }
        };
    }
    addListeners() {
        this._manageListeners(true);
    }
    removeListeners() {
        this._manageListeners(false);
    }
}

});
parcelRegister("3F4oU", function(module, exports) {

$parcel$export(module.exports, "InteractivityDetect", () => $2aa89d54a98f31d8$export$a061a4a5d124ecc0);
var $2aa89d54a98f31d8$export$a061a4a5d124ecc0;
(function(InteractivityDetect) {
    InteractivityDetect["canvas"] = "canvas";
    InteractivityDetect["parent"] = "parent";
    InteractivityDetect["window"] = "window";
})($2aa89d54a98f31d8$export$a061a4a5d124ecc0 || ($2aa89d54a98f31d8$export$a061a4a5d124ecc0 = {}));

});


parcelRegister("3ikOd", function(module, exports) {

$parcel$export(module.exports, "EventType", () => $266331c13a95acf6$export$3d7865934588d77e);
var $266331c13a95acf6$export$3d7865934588d77e;
(function(EventType) {
    EventType["configAdded"] = "configAdded";
    EventType["containerInit"] = "containerInit";
    EventType["particlesSetup"] = "particlesSetup";
    EventType["containerStarted"] = "containerStarted";
    EventType["containerStopped"] = "containerStopped";
    EventType["containerDestroyed"] = "containerDestroyed";
    EventType["containerPaused"] = "containerPaused";
    EventType["containerPlay"] = "containerPlay";
    EventType["containerBuilt"] = "containerBuilt";
    EventType["particleAdded"] = "particleAdded";
    EventType["particleDestroyed"] = "particleDestroyed";
    EventType["particleRemoved"] = "particleRemoved";
})($266331c13a95acf6$export$3d7865934588d77e || ($266331c13a95acf6$export$3d7865934588d77e = {}));

});

parcelRegister("ndmgJ", function(module, exports) {

$parcel$export(module.exports, "Options", () => $045c82c0910fb119$export$c019608e5b5bb4cb);

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");

var $5wxu6 = parcelRequire("5wxu6");

var $lyXAK = parcelRequire("lyXAK");

var $6VU1S = parcelRequire("6VU1S");

var $gMg5z = parcelRequire("gMg5z");

var $3OW6C = parcelRequire("3OW6C");

var $lSoxJ = parcelRequire("lSoxJ");

var $72ET5 = parcelRequire("72ET5");

var $dLBd8 = parcelRequire("dLBd8");

var $kxwqM = parcelRequire("kxwqM");

var $43Hl2 = parcelRequire("43Hl2");

var $yZzCW = parcelRequire("yZzCW");
class $045c82c0910fb119$export$c019608e5b5bb4cb {
    constructor(engine, container){
        this._findDefaultTheme = (mode)=>{
            return this.themes.find((theme)=>theme.default.value && theme.default.mode === mode) ?? this.themes.find((theme)=>theme.default.value && theme.default.mode === (0, $kxwqM.ThemeMode).any);
        };
        this._importPreset = (preset)=>{
            this.load(this._engine.getPreset(preset));
        };
        this._engine = engine;
        this._container = container;
        this.autoPlay = true;
        this.background = new (0, $5wxu6.Background)();
        this.backgroundMask = new (0, $lyXAK.BackgroundMask)();
        this.clear = true;
        this.defaultThemes = {};
        this.delay = 0;
        this.fullScreen = new (0, $6VU1S.FullScreen)();
        this.detectRetina = true;
        this.duration = 0;
        this.fpsLimit = 120;
        this.interactivity = new (0, $gMg5z.Interactivity)(engine, container);
        this.manualParticles = [];
        this.particles = (0, $43Hl2.loadParticlesOptions)(this._engine, this._container);
        this.pauseOnBlur = true;
        this.pauseOnOutsideViewport = true;
        this.responsive = [];
        this.smooth = false;
        this.style = {};
        this.themes = [];
        this.zLayers = 100;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.preset !== undefined) (0, $eDm3t.executeOnSingleOrMultiple)(data.preset, (preset)=>this._importPreset(preset));
        if (data.autoPlay !== undefined) this.autoPlay = data.autoPlay;
        if (data.clear !== undefined) this.clear = data.clear;
        if (data.key !== undefined) this.key = data.key;
        if (data.name !== undefined) this.name = data.name;
        if (data.delay !== undefined) this.delay = (0, $yZzCW.setRangeValue)(data.delay);
        const detectRetina = data.detectRetina;
        if (detectRetina !== undefined) this.detectRetina = detectRetina;
        if (data.duration !== undefined) this.duration = (0, $yZzCW.setRangeValue)(data.duration);
        const fpsLimit = data.fpsLimit;
        if (fpsLimit !== undefined) this.fpsLimit = fpsLimit;
        if (data.pauseOnBlur !== undefined) this.pauseOnBlur = data.pauseOnBlur;
        if (data.pauseOnOutsideViewport !== undefined) this.pauseOnOutsideViewport = data.pauseOnOutsideViewport;
        if (data.zLayers !== undefined) this.zLayers = data.zLayers;
        this.background.load(data.background);
        const fullScreen = data.fullScreen;
        if ((0, $62pjT.isBoolean)(fullScreen)) this.fullScreen.enable = fullScreen;
        else this.fullScreen.load(fullScreen);
        this.backgroundMask.load(data.backgroundMask);
        this.interactivity.load(data.interactivity);
        if (data.manualParticles) this.manualParticles = data.manualParticles.map((t)=>{
            const tmp = new (0, $3OW6C.ManualParticle)();
            tmp.load(t);
            return tmp;
        });
        this.particles.load(data.particles);
        this.style = (0, $eDm3t.deepExtend)(this.style, data.style);
        this._engine.loadOptions(this, data);
        if (data.smooth !== undefined) this.smooth = data.smooth;
        const interactors = this._engine.interactors.get(this._container);
        if (interactors) {
            for (const interactor of interactors)if (interactor.loadOptions) interactor.loadOptions(this, data);
        }
        if (data.responsive !== undefined) for (const responsive of data.responsive){
            const optResponsive = new (0, $lSoxJ.Responsive)();
            optResponsive.load(responsive);
            this.responsive.push(optResponsive);
        }
        this.responsive.sort((a, b)=>a.maxWidth - b.maxWidth);
        if (data.themes !== undefined) for (const theme of data.themes){
            const existingTheme = this.themes.find((t)=>t.name === theme.name);
            if (!existingTheme) {
                const optTheme = new (0, $dLBd8.Theme)();
                optTheme.load(theme);
                this.themes.push(optTheme);
            } else existingTheme.load(theme);
        }
        this.defaultThemes.dark = this._findDefaultTheme((0, $kxwqM.ThemeMode).dark)?.name;
        this.defaultThemes.light = this._findDefaultTheme((0, $kxwqM.ThemeMode).light)?.name;
    }
    setResponsive(width, pxRatio, defaultOptions) {
        this.load(defaultOptions);
        const responsiveOptions = this.responsive.find((t)=>t.mode === (0, $72ET5.ResponsiveMode).screen && screen ? t.maxWidth > screen.availWidth : t.maxWidth * pxRatio > width);
        this.load(responsiveOptions?.options);
        return responsiveOptions?.maxWidth;
    }
    setTheme(name) {
        if (name) {
            const chosenTheme = this.themes.find((theme)=>theme.name === name);
            if (chosenTheme) this.load(chosenTheme.options);
        } else {
            const mediaMatch = (0, $eDm3t.safeMatchMedia)("(prefers-color-scheme: dark)"), clientDarkMode = mediaMatch?.matches, defaultTheme = this._findDefaultTheme(clientDarkMode ? (0, $kxwqM.ThemeMode).dark : (0, $kxwqM.ThemeMode).light);
            if (defaultTheme) this.load(defaultTheme.options);
        }
    }
}

});
parcelRegister("5wxu6", function(module, exports) {

$parcel$export(module.exports, "Background", () => $4059ea4247164998$export$668799e4797757a8);

var $hzwm7 = parcelRequire("hzwm7");

var $62pjT = parcelRequire("62pjT");
class $4059ea4247164998$export$668799e4797757a8 {
    constructor(){
        this.color = new (0, $hzwm7.OptionsColor)();
        this.color.value = "";
        this.image = "";
        this.position = "";
        this.repeat = "";
        this.size = "";
        this.opacity = 1;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.color !== undefined) this.color = (0, $hzwm7.OptionsColor).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
        if (data.position !== undefined) this.position = data.position;
        if (data.repeat !== undefined) this.repeat = data.repeat;
        if (data.size !== undefined) this.size = data.size;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}

});
parcelRegister("hzwm7", function(module, exports) {

$parcel$export(module.exports, "OptionsColor", () => $ccaecdb9d9dce84d$export$c2b08aa25660fcaa);

var $62pjT = parcelRequire("62pjT");
class $ccaecdb9d9dce84d$export$c2b08aa25660fcaa {
    constructor(){
        this.value = "";
    }
    static create(source, data) {
        const color = new $ccaecdb9d9dce84d$export$c2b08aa25660fcaa();
        color.load(source);
        if (data !== undefined) {
            if ((0, $62pjT.isString)(data) || (0, $62pjT.isArray)(data)) color.load({
                value: data
            });
            else color.load(data);
        }
        return color;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (!(0, $62pjT.isNull)(data.value)) this.value = data.value;
    }
}

});


parcelRegister("lyXAK", function(module, exports) {

$parcel$export(module.exports, "BackgroundMask", () => $fb2aff999bc39ba4$export$36a2fa1e47ffeebc);

var $62pjT = parcelRequire("62pjT");

var $fYrAK = parcelRequire("fYrAK");
class $fb2aff999bc39ba4$export$36a2fa1e47ffeebc {
    constructor(){
        this.composite = "destination-out";
        this.cover = new (0, $fYrAK.BackgroundMaskCover)();
        this.enable = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.composite !== undefined) this.composite = data.composite;
        if (data.cover !== undefined) {
            const cover = data.cover, color = (0, $62pjT.isString)(data.cover) ? {
                color: data.cover
            } : data.cover;
            this.cover.load(cover.color !== undefined || cover.image !== undefined ? cover : {
                color: color
            });
        }
        if (data.enable !== undefined) this.enable = data.enable;
    }
}

});
parcelRegister("fYrAK", function(module, exports) {

$parcel$export(module.exports, "BackgroundMaskCover", () => $ba11dcc17e2ba830$export$83d45d4584162ec0);

var $hzwm7 = parcelRequire("hzwm7");

var $62pjT = parcelRequire("62pjT");
class $ba11dcc17e2ba830$export$83d45d4584162ec0 {
    constructor(){
        this.opacity = 1;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.color !== undefined) this.color = (0, $hzwm7.OptionsColor).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}

});


parcelRegister("6VU1S", function(module, exports) {

$parcel$export(module.exports, "FullScreen", () => $50c3872f9de25336$export$f885b95b3f0be76d);

var $62pjT = parcelRequire("62pjT");
class $50c3872f9de25336$export$f885b95b3f0be76d {
    constructor(){
        this.enable = true;
        this.zIndex = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.zIndex !== undefined) this.zIndex = data.zIndex;
    }
}

});

parcelRegister("gMg5z", function(module, exports) {

$parcel$export(module.exports, "Interactivity", () => $c36d9bf39925aa91$export$865458a3ba269c4a);

var $dzvnt = parcelRequire("dzvnt");

var $3F4oU = parcelRequire("3F4oU");

var $eRvp4 = parcelRequire("eRvp4");

var $62pjT = parcelRequire("62pjT");
class $c36d9bf39925aa91$export$865458a3ba269c4a {
    constructor(engine, container){
        this.detectsOn = (0, $3F4oU.InteractivityDetect).window;
        this.events = new (0, $dzvnt.Events)();
        this.modes = new (0, $eRvp4.Modes)(engine, container);
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        const detectsOn = data.detectsOn;
        if (detectsOn !== undefined) this.detectsOn = detectsOn;
        this.events.load(data.events);
        this.modes.load(data.modes);
    }
}

});
parcelRegister("dzvnt", function(module, exports) {

$parcel$export(module.exports, "Events", () => $9e16e2361de30216$export$ada873a34909da65);

var $lT0qX = parcelRequire("lT0qX");

var $5ZZwW = parcelRequire("5ZZwW");

var $ebFKi = parcelRequire("ebFKi");

var $1OU8M = parcelRequire("1OU8M");

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");
class $9e16e2361de30216$export$ada873a34909da65 {
    constructor(){
        this.onClick = new (0, $lT0qX.ClickEvent)();
        this.onDiv = new (0, $5ZZwW.DivEvent)();
        this.onHover = new (0, $ebFKi.HoverEvent)();
        this.resize = new (0, $1OU8M.ResizeEvent)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        this.onClick.load(data.onClick);
        const onDiv = data.onDiv;
        if (onDiv !== undefined) this.onDiv = (0, $eDm3t.executeOnSingleOrMultiple)(onDiv, (t)=>{
            const tmp = new (0, $5ZZwW.DivEvent)();
            tmp.load(t);
            return tmp;
        });
        this.onHover.load(data.onHover);
        this.resize.load(data.resize);
    }
}

});
parcelRegister("lT0qX", function(module, exports) {

$parcel$export(module.exports, "ClickEvent", () => $feef122d005e8f97$export$8d82f6df2d02cd91);

var $62pjT = parcelRequire("62pjT");
class $feef122d005e8f97$export$8d82f6df2d02cd91 {
    constructor(){
        this.enable = false;
        this.mode = [];
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
    }
}

});

parcelRegister("5ZZwW", function(module, exports) {

$parcel$export(module.exports, "DivEvent", () => $45e260e78e344801$export$54136f11f358067a);

var $5mVMY = parcelRequire("5mVMY");

var $62pjT = parcelRequire("62pjT");
class $45e260e78e344801$export$54136f11f358067a {
    constructor(){
        this.selectors = [];
        this.enable = false;
        this.mode = [];
        this.type = (0, $5mVMY.DivType).circle;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.selectors !== undefined) this.selectors = data.selectors;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.type !== undefined) this.type = data.type;
    }
}

});
parcelRegister("5mVMY", function(module, exports) {

$parcel$export(module.exports, "DivType", () => $3e8bd57c64f468c0$export$9e83d65c7ba90739);
var $3e8bd57c64f468c0$export$9e83d65c7ba90739;
(function(DivType) {
    DivType["circle"] = "circle";
    DivType["rectangle"] = "rectangle";
})($3e8bd57c64f468c0$export$9e83d65c7ba90739 || ($3e8bd57c64f468c0$export$9e83d65c7ba90739 = {}));

});


parcelRegister("ebFKi", function(module, exports) {

$parcel$export(module.exports, "HoverEvent", () => $a542799c67a9bb9e$export$2f13ede603111372);

var $a4yiY = parcelRequire("a4yiY");

var $62pjT = parcelRequire("62pjT");
class $a542799c67a9bb9e$export$2f13ede603111372 {
    constructor(){
        this.enable = false;
        this.mode = [];
        this.parallax = new (0, $a4yiY.Parallax)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
        this.parallax.load(data.parallax);
    }
}

});
parcelRegister("a4yiY", function(module, exports) {

$parcel$export(module.exports, "Parallax", () => $7554e359b27ae940$export$1bc430945f060dd1);

var $62pjT = parcelRequire("62pjT");
class $7554e359b27ae940$export$1bc430945f060dd1 {
    constructor(){
        this.enable = false;
        this.force = 2;
        this.smooth = 10;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.force !== undefined) this.force = data.force;
        if (data.smooth !== undefined) this.smooth = data.smooth;
    }
}

});


parcelRegister("1OU8M", function(module, exports) {

$parcel$export(module.exports, "ResizeEvent", () => $1536024d03acbbff$export$4a407cdeed472cd5);

var $62pjT = parcelRequire("62pjT");
class $1536024d03acbbff$export$4a407cdeed472cd5 {
    constructor(){
        this.delay = 0.5;
        this.enable = true;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.delay !== undefined) this.delay = data.delay;
        if (data.enable !== undefined) this.enable = data.enable;
    }
}

});


parcelRegister("eRvp4", function(module, exports) {

$parcel$export(module.exports, "Modes", () => $ad1e5ff4eccc3ef5$export$43660d87cb080eb);

var $62pjT = parcelRequire("62pjT");
class $ad1e5ff4eccc3ef5$export$43660d87cb080eb {
    constructor(engine, container){
        this._engine = engine;
        this._container = container;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (!this._container) return;
        const interactors = this._engine.interactors.get(this._container);
        if (!interactors) return;
        for (const interactor of interactors){
            if (!interactor.loadModeOptions) continue;
            interactor.loadModeOptions(this, data);
        }
    }
}

});


parcelRegister("3OW6C", function(module, exports) {

$parcel$export(module.exports, "ManualParticle", () => $2c831d2f3eb7bb58$export$4f41a3ab9fa8cdf);

var $5r4A4 = parcelRequire("5r4A4");

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");

var $eywbI = parcelRequire("eywbI");
class $2c831d2f3eb7bb58$export$4f41a3ab9fa8cdf {
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.position) this.position = {
            x: data.position.x ?? (0, $eywbI.manualDefaultPosition),
            y: data.position.y ?? (0, $eywbI.manualDefaultPosition),
            mode: data.position.mode ?? (0, $5r4A4.PixelMode).percent
        };
        if (data.options) this.options = (0, $eDm3t.deepExtend)({}, data.options);
    }
}

});

parcelRegister("lSoxJ", function(module, exports) {

$parcel$export(module.exports, "Responsive", () => $fed1add9f4e8bdb9$export$49b67f1c7ac91d9b);

var $72ET5 = parcelRequire("72ET5");

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");
class $fed1add9f4e8bdb9$export$49b67f1c7ac91d9b {
    constructor(){
        this.maxWidth = Infinity;
        this.options = {};
        this.mode = (0, $72ET5.ResponsiveMode).canvas;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (!(0, $62pjT.isNull)(data.maxWidth)) this.maxWidth = data.maxWidth;
        if (!(0, $62pjT.isNull)(data.mode)) {
            if (data.mode === (0, $72ET5.ResponsiveMode).screen) this.mode = (0, $72ET5.ResponsiveMode).screen;
            else this.mode = (0, $72ET5.ResponsiveMode).canvas;
        }
        if (!(0, $62pjT.isNull)(data.options)) this.options = (0, $eDm3t.deepExtend)({}, data.options);
    }
}

});
parcelRegister("72ET5", function(module, exports) {

$parcel$export(module.exports, "ResponsiveMode", () => $52086fb736055b4f$export$73c2705cb2da08ab);
var $52086fb736055b4f$export$73c2705cb2da08ab;
(function(ResponsiveMode) {
    ResponsiveMode["screen"] = "screen";
    ResponsiveMode["canvas"] = "canvas";
})($52086fb736055b4f$export$73c2705cb2da08ab || ($52086fb736055b4f$export$73c2705cb2da08ab = {}));

});


parcelRegister("dLBd8", function(module, exports) {

$parcel$export(module.exports, "Theme", () => $a05c87730ff75d2a$export$14faa19a0f3bbeb2);

var $iTZAY = parcelRequire("iTZAY");

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");
class $a05c87730ff75d2a$export$14faa19a0f3bbeb2 {
    constructor(){
        this.name = "";
        this.default = new (0, $iTZAY.ThemeDefault)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.name !== undefined) this.name = data.name;
        this.default.load(data.default);
        if (data.options !== undefined) this.options = (0, $eDm3t.deepExtend)({}, data.options);
    }
}

});
parcelRegister("iTZAY", function(module, exports) {

$parcel$export(module.exports, "ThemeDefault", () => $dc2d2499e2c282f6$export$4bc81bcab6354024);

var $kxwqM = parcelRequire("kxwqM");

var $62pjT = parcelRequire("62pjT");
class $dc2d2499e2c282f6$export$4bc81bcab6354024 {
    constructor(){
        this.auto = false;
        this.mode = (0, $kxwqM.ThemeMode).any;
        this.value = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.auto !== undefined) this.auto = data.auto;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.value !== undefined) this.value = data.value;
    }
}

});
parcelRegister("kxwqM", function(module, exports) {

$parcel$export(module.exports, "ThemeMode", () => $ef400bd6d38e32a7$export$cd01a11ba097c64c);
var $ef400bd6d38e32a7$export$cd01a11ba097c64c;
(function(ThemeMode) {
    ThemeMode["any"] = "any";
    ThemeMode["dark"] = "dark";
    ThemeMode["light"] = "light";
})($ef400bd6d38e32a7$export$cd01a11ba097c64c || ($ef400bd6d38e32a7$export$cd01a11ba097c64c = {}));

});



parcelRegister("43Hl2", function(module, exports) {

$parcel$export(module.exports, "loadOptions", () => $2f490f4eb5c45caa$export$cad72087bded938);
$parcel$export(module.exports, "loadParticlesOptions", () => $2f490f4eb5c45caa$export$3e14721506027822);

var $dV7y4 = parcelRequire("dV7y4");
function $2f490f4eb5c45caa$export$cad72087bded938(options, ...sourceOptionsArr) {
    for (const sourceOptions of sourceOptionsArr)options.load(sourceOptions);
}
function $2f490f4eb5c45caa$export$3e14721506027822(engine, container, ...sourceOptionsArr) {
    const options = new (0, $dV7y4.ParticlesOptions)(engine, container);
    $2f490f4eb5c45caa$export$cad72087bded938(options, ...sourceOptionsArr);
    return options;
}

});
parcelRegister("dV7y4", function(module, exports) {

$parcel$export(module.exports, "ParticlesOptions", () => $a226743bc00cf409$export$b4f1619131f0bce9);

var $eDm3t = parcelRequire("eDm3t");

var $jXSVo = parcelRequire("jXSVo");

var $iunVO = parcelRequire("iunVO");

var $27J23 = parcelRequire("27J23");

var $eZpg9 = parcelRequire("eZpg9");

var $vwqkG = parcelRequire("vwqkG");

var $34mxm = parcelRequire("34mxm");

var $ezm0L = parcelRequire("ezm0L");

var $gGCJV = parcelRequire("gGCJV");

var $7alxg = parcelRequire("7alxg");

var $inCyF = parcelRequire("inCyF");

var $jMQW5 = parcelRequire("jMQW5");

var $2pHgR = parcelRequire("2pHgR");

var $62pjT = parcelRequire("62pjT");
class $a226743bc00cf409$export$b4f1619131f0bce9 {
    constructor(engine, container){
        this._engine = engine;
        this._container = container;
        this.bounce = new (0, $34mxm.ParticlesBounce)();
        this.collisions = new (0, $iunVO.Collisions)();
        this.color = new (0, $jXSVo.AnimatableColor)();
        this.color.value = "#fff";
        this.effect = new (0, $27J23.Effect)();
        this.groups = {};
        this.move = new (0, $eZpg9.Move)();
        this.number = new (0, $ezm0L.ParticlesNumber)();
        this.opacity = new (0, $vwqkG.Opacity)();
        this.reduceDuplicates = false;
        this.shadow = new (0, $gGCJV.Shadow)();
        this.shape = new (0, $7alxg.Shape)();
        this.size = new (0, $inCyF.Size)();
        this.stroke = new (0, $jMQW5.Stroke)();
        this.zIndex = new (0, $2pHgR.ZIndex)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.groups !== undefined) for (const group of Object.keys(data.groups)){
            if (!Object.hasOwn(data.groups, group)) continue;
            const item = data.groups[group];
            if (item !== undefined) this.groups[group] = (0, $eDm3t.deepExtend)(this.groups[group] ?? {}, item);
        }
        if (data.reduceDuplicates !== undefined) this.reduceDuplicates = data.reduceDuplicates;
        this.bounce.load(data.bounce);
        this.color.load((0, $jXSVo.AnimatableColor).create(this.color, data.color));
        this.effect.load(data.effect);
        this.move.load(data.move);
        this.number.load(data.number);
        this.opacity.load(data.opacity);
        this.shape.load(data.shape);
        this.size.load(data.size);
        this.shadow.load(data.shadow);
        this.zIndex.load(data.zIndex);
        this.collisions.load(data.collisions);
        if (data.interactivity !== undefined) this.interactivity = (0, $eDm3t.deepExtend)({}, data.interactivity);
        const strokeToLoad = data.stroke;
        if (strokeToLoad) this.stroke = (0, $eDm3t.executeOnSingleOrMultiple)(strokeToLoad, (t)=>{
            const tmp = new (0, $jMQW5.Stroke)();
            tmp.load(t);
            return tmp;
        });
        if (this._container) {
            const updaters = this._engine.updaters.get(this._container);
            if (updaters) {
                for (const updater of updaters)if (updater.loadOptions) updater.loadOptions(this, data);
            }
            const interactors = this._engine.interactors.get(this._container);
            if (interactors) {
                for (const interactor of interactors)if (interactor.loadParticlesOptions) interactor.loadParticlesOptions(this, data);
            }
        }
    }
}

});
parcelRegister("jXSVo", function(module, exports) {

$parcel$export(module.exports, "AnimatableColor", () => $e88e21ed5c481142$export$6f79b6ff75533155);

var $62pjT = parcelRequire("62pjT");

var $87NqF = parcelRequire("87NqF");

var $hzwm7 = parcelRequire("hzwm7");
class $e88e21ed5c481142$export$6f79b6ff75533155 extends (0, $hzwm7.OptionsColor) {
    constructor(){
        super();
        this.animation = new (0, $87NqF.HslAnimation)();
    }
    static create(source, data) {
        const color = new $e88e21ed5c481142$export$6f79b6ff75533155();
        color.load(source);
        if (data !== undefined) {
            if ((0, $62pjT.isString)(data) || (0, $62pjT.isArray)(data)) color.load({
                value: data
            });
            else color.load(data);
        }
        return color;
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        const colorAnimation = data.animation;
        if (colorAnimation !== undefined) {
            if (colorAnimation.enable !== undefined) this.animation.h.load(colorAnimation);
            else this.animation.load(data.animation);
        }
    }
}

});
parcelRegister("87NqF", function(module, exports) {

$parcel$export(module.exports, "HslAnimation", () => $5ea551c00b834094$export$b4c56f18acc5f2f4);

var $chQdy = parcelRequire("chQdy");

var $62pjT = parcelRequire("62pjT");
class $5ea551c00b834094$export$b4c56f18acc5f2f4 {
    constructor(){
        this.h = new (0, $chQdy.ColorAnimation)();
        this.s = new (0, $chQdy.ColorAnimation)();
        this.l = new (0, $chQdy.ColorAnimation)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        this.h.load(data.h);
        this.s.load(data.s);
        this.l.load(data.l);
    }
}

});
parcelRegister("chQdy", function(module, exports) {

$parcel$export(module.exports, "ColorAnimation", () => $8f1f93ec24716e22$export$3cc8aa7a0c621de0);

var $48bX3 = parcelRequire("48bX3");

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $8f1f93ec24716e22$export$3cc8aa7a0c621de0 extends (0, $48bX3.AnimationOptions) {
    constructor(){
        super();
        this.offset = 0;
        this.sync = true;
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        if (data.offset !== undefined) this.offset = (0, $yZzCW.setRangeValue)(data.offset);
    }
}

});
parcelRegister("48bX3", function(module, exports) {

$parcel$export(module.exports, "AnimationOptions", () => $30212e1e933eeac5$export$e293c31e7176ae39);
$parcel$export(module.exports, "RangedAnimationOptions", () => $30212e1e933eeac5$export$664e182a9c83d6f5);

var $bTldy = parcelRequire("bTldy");

var $84ZEL = parcelRequire("84ZEL");

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $30212e1e933eeac5$export$e293c31e7176ae39 {
    constructor(){
        this.count = 0;
        this.enable = false;
        this.speed = 1;
        this.decay = 0;
        this.delay = 0;
        this.sync = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.count !== undefined) this.count = (0, $yZzCW.setRangeValue)(data.count);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $yZzCW.setRangeValue)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $yZzCW.setRangeValue)(data.decay);
        if (data.delay !== undefined) this.delay = (0, $yZzCW.setRangeValue)(data.delay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}
class $30212e1e933eeac5$export$664e182a9c83d6f5 extends $30212e1e933eeac5$export$e293c31e7176ae39 {
    constructor(){
        super();
        this.mode = (0, $bTldy.AnimationMode).auto;
        this.startValue = (0, $84ZEL.StartValueType).random;
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.startValue !== undefined) this.startValue = data.startValue;
    }
}

});




parcelRegister("iunVO", function(module, exports) {

$parcel$export(module.exports, "Collisions", () => $d75d979ff2325c0b$export$97ff58b0eb9a5ed0);

var $jU7Kv = parcelRequire("jU7Kv");

var $kfYsq = parcelRequire("kfYsq");

var $lcKDZ = parcelRequire("lcKDZ");

var $34mxm = parcelRequire("34mxm");

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $d75d979ff2325c0b$export$97ff58b0eb9a5ed0 {
    constructor(){
        this.absorb = new (0, $kfYsq.CollisionsAbsorb)();
        this.bounce = new (0, $34mxm.ParticlesBounce)();
        this.enable = false;
        this.maxSpeed = 50;
        this.mode = (0, $jU7Kv.CollisionMode).bounce;
        this.overlap = new (0, $lcKDZ.CollisionsOverlap)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        this.absorb.load(data.absorb);
        this.bounce.load(data.bounce);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.maxSpeed !== undefined) this.maxSpeed = (0, $yZzCW.setRangeValue)(data.maxSpeed);
        if (data.mode !== undefined) this.mode = data.mode;
        this.overlap.load(data.overlap);
    }
}

});
parcelRegister("jU7Kv", function(module, exports) {

$parcel$export(module.exports, "CollisionMode", () => $e7d942125aadf3ed$export$c17cb29bf4746ec8);
var $e7d942125aadf3ed$export$c17cb29bf4746ec8;
(function(CollisionMode) {
    CollisionMode["absorb"] = "absorb";
    CollisionMode["bounce"] = "bounce";
    CollisionMode["destroy"] = "destroy";
})($e7d942125aadf3ed$export$c17cb29bf4746ec8 || ($e7d942125aadf3ed$export$c17cb29bf4746ec8 = {}));

});

parcelRegister("kfYsq", function(module, exports) {

$parcel$export(module.exports, "CollisionsAbsorb", () => $ebf41af31097aafe$export$dbafb70800ee3f9b);

var $62pjT = parcelRequire("62pjT");
class $ebf41af31097aafe$export$dbafb70800ee3f9b {
    constructor(){
        this.speed = 2;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.speed !== undefined) this.speed = data.speed;
    }
}

});

parcelRegister("lcKDZ", function(module, exports) {

$parcel$export(module.exports, "CollisionsOverlap", () => $f6fee677cd4f0ef2$export$7dac291125fc16da);

var $62pjT = parcelRequire("62pjT");
class $f6fee677cd4f0ef2$export$7dac291125fc16da {
    constructor(){
        this.enable = true;
        this.retries = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.retries !== undefined) this.retries = data.retries;
    }
}

});

parcelRegister("34mxm", function(module, exports) {

$parcel$export(module.exports, "ParticlesBounce", () => $23c33a36cff29b1f$export$e6dd54c89cd6ac88);

var $2jyiK = parcelRequire("2jyiK");

var $62pjT = parcelRequire("62pjT");
class $23c33a36cff29b1f$export$e6dd54c89cd6ac88 {
    constructor(){
        this.horizontal = new (0, $2jyiK.ParticlesBounceFactor)();
        this.vertical = new (0, $2jyiK.ParticlesBounceFactor)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        this.horizontal.load(data.horizontal);
        this.vertical.load(data.vertical);
    }
}

});
parcelRegister("2jyiK", function(module, exports) {

$parcel$export(module.exports, "ParticlesBounceFactor", () => $1af7f6a350328e85$export$855823db9a0085c);

var $hAZRJ = parcelRequire("hAZRJ");
class $1af7f6a350328e85$export$855823db9a0085c extends (0, $hAZRJ.ValueWithRandom) {
    constructor(){
        super();
        this.value = 1;
    }
}

});
parcelRegister("hAZRJ", function(module, exports) {

$parcel$export(module.exports, "ValueWithRandom", () => $ccf5c9b0f9430642$export$2f74c042fca0b66d);
$parcel$export(module.exports, "RangedAnimationValueWithRandom", () => $ccf5c9b0f9430642$export$8d0da1142c209427);

var $48bX3 = parcelRequire("48bX3");

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $ccf5c9b0f9430642$export$2f74c042fca0b66d {
    constructor(){
        this.value = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (!(0, $62pjT.isNull)(data.value)) this.value = (0, $yZzCW.setRangeValue)(data.value);
    }
}
class $ccf5c9b0f9430642$export$a0fda83b6e14e586 extends $ccf5c9b0f9430642$export$2f74c042fca0b66d {
    constructor(){
        super();
        this.animation = new (0, $48bX3.AnimationOptions)();
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}
class $ccf5c9b0f9430642$export$8d0da1142c209427 extends $ccf5c9b0f9430642$export$a0fda83b6e14e586 {
    constructor(){
        super();
        this.animation = new (0, $48bX3.RangedAnimationOptions)();
    }
    load(data) {
        super.load(data);
    }
}

});




parcelRegister("27J23", function(module, exports) {

$parcel$export(module.exports, "Effect", () => $18bf2aaf1eb3584f$export$a32b0b1c1ac59d04);

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");
class $18bf2aaf1eb3584f$export$a32b0b1c1ac59d04 {
    constructor(){
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = [];
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        const options = data.options;
        if (options !== undefined) for(const effect in options){
            const item = options[effect];
            if (item) this.options[effect] = (0, $eDm3t.deepExtend)(this.options[effect] ?? {}, item);
        }
        if (data.close !== undefined) this.close = data.close;
        if (data.fill !== undefined) this.fill = data.fill;
        if (data.type !== undefined) this.type = data.type;
    }
}

});

parcelRegister("eZpg9", function(module, exports) {

$parcel$export(module.exports, "Move", () => $ae9a5b34ac4bd9c7$export$e49a5ad3dd6df925);

var $hlFRq = parcelRequire("hlFRq");

var $62pjT = parcelRequire("62pjT");

var $aZ64x = parcelRequire("aZ64x");

var $15G8Z = parcelRequire("15G8Z");

var $lCbic = parcelRequire("lCbic");

var $9iy6g = parcelRequire("9iy6g");

var $jpnpW = parcelRequire("jpnpW");

var $k78he = parcelRequire("k78he");

var $4r7Vr = parcelRequire("4r7Vr");

var $gjqYa = parcelRequire("gjqYa");

var $yZzCW = parcelRequire("yZzCW");
class $ae9a5b34ac4bd9c7$export$e49a5ad3dd6df925 {
    constructor(){
        this.angle = new (0, $aZ64x.MoveAngle)();
        this.attract = new (0, $15G8Z.MoveAttract)();
        this.center = new (0, $lCbic.MoveCenter)();
        this.decay = 0;
        this.distance = {};
        this.direction = (0, $hlFRq.MoveDirection).none;
        this.drift = 0;
        this.enable = false;
        this.gravity = new (0, $9iy6g.MoveGravity)();
        this.path = new (0, $jpnpW.MovePath)();
        this.outModes = new (0, $4r7Vr.OutModes)();
        this.random = false;
        this.size = false;
        this.speed = 2;
        this.spin = new (0, $gjqYa.Spin)();
        this.straight = false;
        this.trail = new (0, $k78he.MoveTrail)();
        this.vibrate = false;
        this.warp = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        this.angle.load((0, $62pjT.isNumber)(data.angle) ? {
            value: data.angle
        } : data.angle);
        this.attract.load(data.attract);
        this.center.load(data.center);
        if (data.decay !== undefined) this.decay = (0, $yZzCW.setRangeValue)(data.decay);
        if (data.direction !== undefined) this.direction = data.direction;
        if (data.distance !== undefined) this.distance = (0, $62pjT.isNumber)(data.distance) ? {
            horizontal: data.distance,
            vertical: data.distance
        } : {
            ...data.distance
        };
        if (data.drift !== undefined) this.drift = (0, $yZzCW.setRangeValue)(data.drift);
        if (data.enable !== undefined) this.enable = data.enable;
        this.gravity.load(data.gravity);
        const outModes = data.outModes;
        if (outModes !== undefined) {
            if ((0, $62pjT.isObject)(outModes)) this.outModes.load(outModes);
            else this.outModes.load({
                default: outModes
            });
        }
        this.path.load(data.path);
        if (data.random !== undefined) this.random = data.random;
        if (data.size !== undefined) this.size = data.size;
        if (data.speed !== undefined) this.speed = (0, $yZzCW.setRangeValue)(data.speed);
        this.spin.load(data.spin);
        if (data.straight !== undefined) this.straight = data.straight;
        this.trail.load(data.trail);
        if (data.vibrate !== undefined) this.vibrate = data.vibrate;
        if (data.warp !== undefined) this.warp = data.warp;
    }
}

});
parcelRegister("aZ64x", function(module, exports) {

$parcel$export(module.exports, "MoveAngle", () => $7ff44fb667c26b1d$export$128f6c8d329dc399);

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $7ff44fb667c26b1d$export$128f6c8d329dc399 {
    constructor(){
        this.offset = 0;
        this.value = 90;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.offset !== undefined) this.offset = (0, $yZzCW.setRangeValue)(data.offset);
        if (data.value !== undefined) this.value = (0, $yZzCW.setRangeValue)(data.value);
    }
}

});

parcelRegister("15G8Z", function(module, exports) {

$parcel$export(module.exports, "MoveAttract", () => $0cb6f2fc07d72fb0$export$6c54633883102b4b);

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $0cb6f2fc07d72fb0$export$6c54633883102b4b {
    constructor(){
        this.distance = 200;
        this.enable = false;
        this.rotate = {
            x: 3000,
            y: 3000
        };
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.distance !== undefined) this.distance = (0, $yZzCW.setRangeValue)(data.distance);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.rotate) {
            const rotateX = data.rotate.x;
            if (rotateX !== undefined) this.rotate.x = rotateX;
            const rotateY = data.rotate.y;
            if (rotateY !== undefined) this.rotate.y = rotateY;
        }
    }
}

});

parcelRegister("lCbic", function(module, exports) {

$parcel$export(module.exports, "MoveCenter", () => $fbc5e80585f1507c$export$7b60622f06eeec06);

var $5r4A4 = parcelRequire("5r4A4");

var $62pjT = parcelRequire("62pjT");
class $fbc5e80585f1507c$export$7b60622f06eeec06 {
    constructor(){
        this.x = 50;
        this.y = 50;
        this.mode = (0, $5r4A4.PixelMode).percent;
        this.radius = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.x !== undefined) this.x = data.x;
        if (data.y !== undefined) this.y = data.y;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.radius !== undefined) this.radius = data.radius;
    }
}

});

parcelRegister("9iy6g", function(module, exports) {

$parcel$export(module.exports, "MoveGravity", () => $6c503f10e2e34705$export$c6d1f1b3593b164c);

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $6c503f10e2e34705$export$c6d1f1b3593b164c {
    constructor(){
        this.acceleration = 9.81;
        this.enable = false;
        this.inverse = false;
        this.maxSpeed = 50;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.acceleration !== undefined) this.acceleration = (0, $yZzCW.setRangeValue)(data.acceleration);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.inverse !== undefined) this.inverse = data.inverse;
        if (data.maxSpeed !== undefined) this.maxSpeed = (0, $yZzCW.setRangeValue)(data.maxSpeed);
    }
}

});

parcelRegister("jpnpW", function(module, exports) {

$parcel$export(module.exports, "MovePath", () => $e2128457211016f6$export$bcc70636a6a97e73);

var $hAZRJ = parcelRequire("hAZRJ");

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");
class $e2128457211016f6$export$bcc70636a6a97e73 {
    constructor(){
        this.clamp = true;
        this.delay = new (0, $hAZRJ.ValueWithRandom)();
        this.enable = false;
        this.options = {};
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.clamp !== undefined) this.clamp = data.clamp;
        this.delay.load(data.delay);
        if (data.enable !== undefined) this.enable = data.enable;
        this.generator = data.generator;
        if (data.options) this.options = (0, $eDm3t.deepExtend)(this.options, data.options);
    }
}

});

parcelRegister("k78he", function(module, exports) {

$parcel$export(module.exports, "MoveTrail", () => $ea4ae1b4374ef3a6$export$e428bb3fcf53809d);

var $eb9NP = parcelRequire("eb9NP");

var $62pjT = parcelRequire("62pjT");
class $ea4ae1b4374ef3a6$export$e428bb3fcf53809d {
    constructor(){
        this.enable = false;
        this.length = 10;
        this.fill = new (0, $eb9NP.MoveTrailFill)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.fill !== undefined) this.fill.load(data.fill);
        if (data.length !== undefined) this.length = data.length;
    }
}

});
parcelRegister("eb9NP", function(module, exports) {

$parcel$export(module.exports, "MoveTrailFill", () => $a529b260c99f861e$export$7518c5bd39f0f31a);

var $hzwm7 = parcelRequire("hzwm7");

var $62pjT = parcelRequire("62pjT");
class $a529b260c99f861e$export$7518c5bd39f0f31a {
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.color !== undefined) this.color = (0, $hzwm7.OptionsColor).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
    }
}

});


parcelRegister("4r7Vr", function(module, exports) {

$parcel$export(module.exports, "OutModes", () => $33afd4de8fb84908$export$647cf31ffff2d3);

var $eBPJQ = parcelRequire("eBPJQ");

var $62pjT = parcelRequire("62pjT");
class $33afd4de8fb84908$export$647cf31ffff2d3 {
    constructor(){
        this.default = (0, $eBPJQ.OutMode).out;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.default !== undefined) this.default = data.default;
        this.bottom = data.bottom ?? data.default;
        this.left = data.left ?? data.default;
        this.right = data.right ?? data.default;
        this.top = data.top ?? data.default;
    }
}

});
parcelRegister("eBPJQ", function(module, exports) {

$parcel$export(module.exports, "OutMode", () => $aa2ca792db24f7f3$export$cf5942d9a76b7ae2);
var $aa2ca792db24f7f3$export$cf5942d9a76b7ae2;
(function(OutMode) {
    OutMode["bounce"] = "bounce";
    OutMode["none"] = "none";
    OutMode["out"] = "out";
    OutMode["destroy"] = "destroy";
    OutMode["split"] = "split";
})($aa2ca792db24f7f3$export$cf5942d9a76b7ae2 || ($aa2ca792db24f7f3$export$cf5942d9a76b7ae2 = {}));

});


parcelRegister("gjqYa", function(module, exports) {

$parcel$export(module.exports, "Spin", () => $be035747ecc4a7c2$export$fcd783eeafc305c0);

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $be035747ecc4a7c2$export$fcd783eeafc305c0 {
    constructor(){
        this.acceleration = 0;
        this.enable = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.acceleration !== undefined) this.acceleration = (0, $yZzCW.setRangeValue)(data.acceleration);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.position) this.position = (0, $eDm3t.deepExtend)({}, data.position);
    }
}

});


parcelRegister("vwqkG", function(module, exports) {

$parcel$export(module.exports, "Opacity", () => $05ec0c0a4269e857$export$588760baa0f6108e);

var $9RRUY = parcelRequire("9RRUY");

var $hAZRJ = parcelRequire("hAZRJ");

var $62pjT = parcelRequire("62pjT");
class $05ec0c0a4269e857$export$588760baa0f6108e extends (0, $hAZRJ.RangedAnimationValueWithRandom) {
    constructor(){
        super();
        this.animation = new (0, $9RRUY.OpacityAnimation)();
        this.value = 1;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        super.load(data);
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}

});
parcelRegister("9RRUY", function(module, exports) {

$parcel$export(module.exports, "OpacityAnimation", () => $72f2e34b23d5fc38$export$3e55dc49e2356209);

var $7ecaf = parcelRequire("7ecaf");

var $48bX3 = parcelRequire("48bX3");

var $62pjT = parcelRequire("62pjT");
class $72f2e34b23d5fc38$export$3e55dc49e2356209 extends (0, $48bX3.RangedAnimationOptions) {
    constructor(){
        super();
        this.destroy = (0, $7ecaf.DestroyType).none;
        this.speed = 2;
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        if (data.destroy !== undefined) this.destroy = data.destroy;
    }
}

});


parcelRegister("ezm0L", function(module, exports) {

$parcel$export(module.exports, "ParticlesNumber", () => $a9b568954d5327fe$export$2335cf7e85f36cfd);

var $gUwDN = parcelRequire("gUwDN");

var $dExOX = parcelRequire("dExOX");

var $62pjT = parcelRequire("62pjT");
class $a9b568954d5327fe$export$2335cf7e85f36cfd {
    constructor(){
        this.density = new (0, $gUwDN.ParticlesDensity)();
        this.limit = new (0, $dExOX.ParticlesNumberLimit)();
        this.value = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        this.density.load(data.density);
        this.limit.load(data.limit);
        if (data.value !== undefined) this.value = data.value;
    }
}

});
parcelRegister("gUwDN", function(module, exports) {

$parcel$export(module.exports, "ParticlesDensity", () => $c4fb321f2ae8b778$export$c11b1f56b7022ac8);

var $62pjT = parcelRequire("62pjT");
class $c4fb321f2ae8b778$export$c11b1f56b7022ac8 {
    constructor(){
        this.enable = false;
        this.width = 1920;
        this.height = 1080;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        const width = data.width;
        if (width !== undefined) this.width = width;
        const height = data.height;
        if (height !== undefined) this.height = height;
    }
}

});

parcelRegister("dExOX", function(module, exports) {

$parcel$export(module.exports, "ParticlesNumberLimit", () => $9f093ee5ce996ff9$export$924e931bcf950072);

var $bsv3r = parcelRequire("bsv3r");

var $62pjT = parcelRequire("62pjT");
class $9f093ee5ce996ff9$export$924e931bcf950072 {
    constructor(){
        this.mode = (0, $bsv3r.LimitMode).delete;
        this.value = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.value !== undefined) this.value = data.value;
    }
}

});
parcelRegister("bsv3r", function(module, exports) {

$parcel$export(module.exports, "LimitMode", () => $857a66087abe0201$export$e9c6a0495dc4055f);
var $857a66087abe0201$export$e9c6a0495dc4055f;
(function(LimitMode) {
    LimitMode["delete"] = "delete";
    LimitMode["wait"] = "wait";
})($857a66087abe0201$export$e9c6a0495dc4055f || ($857a66087abe0201$export$e9c6a0495dc4055f = {}));

});



parcelRegister("gGCJV", function(module, exports) {

$parcel$export(module.exports, "Shadow", () => $c25e9e7b2a7bb1e0$export$a24c14443968327c);

var $hzwm7 = parcelRequire("hzwm7");

var $62pjT = parcelRequire("62pjT");
class $c25e9e7b2a7bb1e0$export$a24c14443968327c {
    constructor(){
        this.blur = 0;
        this.color = new (0, $hzwm7.OptionsColor)();
        this.enable = false;
        this.offset = {
            x: 0,
            y: 0
        };
        this.color.value = "#000";
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.blur !== undefined) this.blur = data.blur;
        this.color = (0, $hzwm7.OptionsColor).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.offset === undefined) return;
        if (data.offset.x !== undefined) this.offset.x = data.offset.x;
        if (data.offset.y !== undefined) this.offset.y = data.offset.y;
    }
}

});

parcelRegister("7alxg", function(module, exports) {

$parcel$export(module.exports, "Shape", () => $537a2c14e84cf11a$export$6428a7f2611ef1fa);

var $eDm3t = parcelRequire("eDm3t");

var $62pjT = parcelRequire("62pjT");
class $537a2c14e84cf11a$export$6428a7f2611ef1fa {
    constructor(){
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = "circle";
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        const options = data.options;
        if (options !== undefined) for(const shape in options){
            const item = options[shape];
            if (item) this.options[shape] = (0, $eDm3t.deepExtend)(this.options[shape] ?? {}, item);
        }
        if (data.close !== undefined) this.close = data.close;
        if (data.fill !== undefined) this.fill = data.fill;
        if (data.type !== undefined) this.type = data.type;
    }
}

});

parcelRegister("inCyF", function(module, exports) {

$parcel$export(module.exports, "Size", () => $d61848ced9fad643$export$cb6da89c6af1a8ec);

var $hAZRJ = parcelRequire("hAZRJ");

var $7fCIN = parcelRequire("7fCIN");

var $62pjT = parcelRequire("62pjT");
class $d61848ced9fad643$export$cb6da89c6af1a8ec extends (0, $hAZRJ.RangedAnimationValueWithRandom) {
    constructor(){
        super();
        this.animation = new (0, $7fCIN.SizeAnimation)();
        this.value = 3;
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}

});
parcelRegister("7fCIN", function(module, exports) {

$parcel$export(module.exports, "SizeAnimation", () => $5477f8657e302d87$export$231e08f1693c0669);

var $7ecaf = parcelRequire("7ecaf");

var $48bX3 = parcelRequire("48bX3");

var $62pjT = parcelRequire("62pjT");
class $5477f8657e302d87$export$231e08f1693c0669 extends (0, $48bX3.RangedAnimationOptions) {
    constructor(){
        super();
        this.destroy = (0, $7ecaf.DestroyType).none;
        this.speed = 5;
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        if (data.destroy !== undefined) this.destroy = data.destroy;
    }
}

});


parcelRegister("jMQW5", function(module, exports) {

$parcel$export(module.exports, "Stroke", () => $e67b8ff9013fd57e$export$18d19c7a3aa33064);

var $jXSVo = parcelRequire("jXSVo");

var $62pjT = parcelRequire("62pjT");

var $yZzCW = parcelRequire("yZzCW");
class $e67b8ff9013fd57e$export$18d19c7a3aa33064 {
    constructor(){
        this.width = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.color !== undefined) this.color = (0, $jXSVo.AnimatableColor).create(this.color, data.color);
        if (data.width !== undefined) this.width = (0, $yZzCW.setRangeValue)(data.width);
        if (data.opacity !== undefined) this.opacity = (0, $yZzCW.setRangeValue)(data.opacity);
    }
}

});

parcelRegister("2pHgR", function(module, exports) {

$parcel$export(module.exports, "ZIndex", () => $1c1f7b490dd4507d$export$ccb31788083e2069);

var $hAZRJ = parcelRequire("hAZRJ");

var $62pjT = parcelRequire("62pjT");
class $1c1f7b490dd4507d$export$ccb31788083e2069 extends (0, $hAZRJ.ValueWithRandom) {
    constructor(){
        super();
        this.opacityRate = 1;
        this.sizeRate = 1;
        this.velocityRate = 1;
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        if (data.opacityRate !== undefined) this.opacityRate = data.opacityRate;
        if (data.sizeRate !== undefined) this.sizeRate = data.sizeRate;
        if (data.velocityRate !== undefined) this.velocityRate = data.velocityRate;
    }
}

});




parcelRegister("hejtK", function(module, exports) {

$parcel$export(module.exports, "Particles", () => $c8b2da8a46f3d481$export$ec4bceef241d2e36);

var $eywbI = parcelRequire("eywbI");

var $eDm3t = parcelRequire("eDm3t");

var $3ikOd = parcelRequire("3ikOd");

var $iUhfk = parcelRequire("iUhfk");

var $bsv3r = parcelRequire("bsv3r");

var $4PBzI = parcelRequire("4PBzI");

var $akNkp = parcelRequire("akNkp");

var $jTJrx = parcelRequire("jTJrx");

var $lpuyt = parcelRequire("lpuyt");
const $c8b2da8a46f3d481$var$qTreeRectangle = (canvasSize)=>{
    const { height: height, width: width } = canvasSize;
    return new (0, $lpuyt.Rectangle)((0, $eywbI.posOffset) * width, (0, $eywbI.posOffset) * height, (0, $eywbI.sizeFactor) * width, (0, $eywbI.sizeFactor) * height);
};
class $c8b2da8a46f3d481$export$ec4bceef241d2e36 {
    constructor(engine, container){
        this._addToPool = (...particles)=>{
            this._pool.push(...particles);
        };
        this._applyDensity = (options, manualCount, group)=>{
            const numberOptions = options.number;
            if (!options.number.density?.enable) {
                if (group === undefined) this._limit = numberOptions.limit.value;
                else if (numberOptions.limit) this._groupLimits.set(group, numberOptions.limit.value);
                return;
            }
            const densityFactor = this._initDensityFactor(numberOptions.density), optParticlesNumber = numberOptions.value, optParticlesLimit = numberOptions.limit.value > (0, $eywbI.minLimit) ? numberOptions.limit.value : optParticlesNumber, particlesNumber = Math.min(optParticlesNumber, optParticlesLimit) * densityFactor + manualCount, particlesCount = Math.min(this.count, this.filter((t)=>t.group === group).length);
            if (group === undefined) this._limit = numberOptions.limit.value * densityFactor;
            else this._groupLimits.set(group, numberOptions.limit.value * densityFactor);
            if (particlesCount < particlesNumber) this.push(Math.abs(particlesNumber - particlesCount), undefined, options, group);
            else if (particlesCount > particlesNumber) this.removeQuantity(particlesCount - particlesNumber, group);
        };
        this._initDensityFactor = (densityOptions)=>{
            const container = this._container;
            if (!container.canvas.element || !densityOptions.enable) return 0, $eywbI.defaultDensityFactor;
            const canvas = container.canvas.element, pxRatio = container.retina.pixelRatio;
            return canvas.width * canvas.height / (densityOptions.height * densityOptions.width * pxRatio ** (0, $eywbI.squareExp));
        };
        this._pushParticle = (position, overrideOptions, group, initializer)=>{
            try {
                let particle = this._pool.pop();
                if (!particle) particle = new (0, $4PBzI.Particle)(this._engine, this._container);
                particle.init(this._nextId, position, overrideOptions, group);
                let canAdd = true;
                if (initializer) canAdd = initializer(particle);
                if (!canAdd) return;
                this._array.push(particle);
                this._zArray.push(particle);
                this._nextId++;
                this._engine.dispatchEvent((0, $3ikOd.EventType).particleAdded, {
                    container: this._container,
                    data: {
                        particle: particle
                    }
                });
                return particle;
            } catch (e) {
                (0, $eDm3t.getLogger)().warning(`${(0, $eywbI.errorPrefix)} adding particle: ${e}`);
            }
        };
        this._removeParticle = (index, group, override)=>{
            const particle = this._array[index];
            if (!particle || particle.group !== group) return false;
            const zIdx = this._zArray.indexOf(particle);
            this._array.splice(index, (0, $eywbI.deleteCount));
            this._zArray.splice(zIdx, (0, $eywbI.deleteCount));
            particle.destroy(override);
            this._engine.dispatchEvent((0, $3ikOd.EventType).particleRemoved, {
                container: this._container,
                data: {
                    particle: particle
                }
            });
            this._addToPool(particle);
            return true;
        };
        this._engine = engine;
        this._container = container;
        this._nextId = 0;
        this._array = [];
        this._zArray = [];
        this._pool = [];
        this._limit = 0;
        this._groupLimits = new Map();
        this._needsSort = false;
        this._lastZIndex = 0;
        this._interactionManager = new (0, $iUhfk.InteractionManager)(engine, container);
        this._pluginsInitialized = false;
        const canvasSize = container.canvas.size;
        this.quadTree = new (0, $jTJrx.QuadTree)($c8b2da8a46f3d481$var$qTreeRectangle(canvasSize), (0, $eywbI.qTreeCapacity));
        this.movers = [];
        this.updaters = [];
    }
    get count() {
        return this._array.length;
    }
    addManualParticles() {
        const container = this._container, options = container.actualOptions;
        options.manualParticles.forEach((p)=>this.addParticle(p.position ? (0, $eDm3t.getPosition)(p.position, container.canvas.size) : undefined, p.options));
    }
    addParticle(position, overrideOptions, group, initializer) {
        const limitMode = this._container.actualOptions.particles.number.limit.mode, limit = group === undefined ? this._limit : this._groupLimits.get(group) ?? this._limit, currentCount = this.count;
        if (limit > (0, $eywbI.minLimit)) switch(limitMode){
            case (0, $bsv3r.LimitMode).delete:
                {
                    const countToRemove = currentCount + (0, $eywbI.countOffset) - limit;
                    if (countToRemove > (0, $eywbI.minCount)) this.removeQuantity(countToRemove);
                    break;
                }
            case (0, $bsv3r.LimitMode).wait:
                if (currentCount >= limit) return;
                break;
        }
        return this._pushParticle(position, overrideOptions, group, initializer);
    }
    clear() {
        this._array = [];
        this._zArray = [];
        this._pluginsInitialized = false;
    }
    destroy() {
        this._array = [];
        this._zArray = [];
        this.movers = [];
        this.updaters = [];
    }
    draw(delta) {
        const container = this._container, canvas = container.canvas;
        canvas.clear();
        this.update(delta);
        for (const plugin of container.plugins.values())canvas.drawPlugin(plugin, delta);
        for (const p of this._zArray)p.draw(delta);
    }
    filter(condition) {
        return this._array.filter(condition);
    }
    find(condition) {
        return this._array.find(condition);
    }
    get(index) {
        return this._array[index];
    }
    handleClickMode(mode) {
        this._interactionManager.handleClickMode(mode);
    }
    async init() {
        const container = this._container, options = container.actualOptions;
        this._lastZIndex = 0;
        this._needsSort = false;
        await this.initPlugins();
        let handled = false;
        for (const plugin of container.plugins.values()){
            handled = plugin.particlesInitialization?.() ?? handled;
            if (handled) break;
        }
        this.addManualParticles();
        if (!handled) {
            const particlesOptions = options.particles, groups = particlesOptions.groups;
            for(const group in groups){
                const groupOptions = groups[group];
                for(let i = this.count, j = 0; j < groupOptions.number?.value && i < particlesOptions.number.value; i++, j++)this.addParticle(undefined, groupOptions, group);
            }
            for(let i = this.count; i < particlesOptions.number.value; i++)this.addParticle();
        }
    }
    async initPlugins() {
        if (this._pluginsInitialized) return;
        const container = this._container;
        this.movers = await this._engine.getMovers(container, true);
        this.updaters = await this._engine.getUpdaters(container, true);
        await this._interactionManager.init();
        for (const pathGenerator of container.pathGenerators.values())pathGenerator.init(container);
    }
    push(nb, mouse, overrideOptions, group) {
        for(let i = 0; i < nb; i++)this.addParticle(mouse?.position, overrideOptions, group);
    }
    async redraw() {
        this.clear();
        await this.init();
        this.draw({
            value: 0,
            factor: 0
        });
    }
    remove(particle, group, override) {
        this.removeAt(this._array.indexOf(particle), undefined, group, override);
    }
    removeAt(index, quantity = (0, $eywbI.defaultRemoveQuantity), group, override) {
        if (index < (0, $eywbI.minIndex) || index > this.count) return;
        let deleted = 0;
        for(let i = index; deleted < quantity && i < this.count; i++)if (this._removeParticle(i, group, override)) {
            i--;
            deleted++;
        }
    }
    removeQuantity(quantity, group) {
        this.removeAt((0, $eywbI.minIndex), quantity, group);
    }
    setDensity() {
        const options = this._container.actualOptions, groups = options.particles.groups;
        for(const group in groups)this._applyDensity(groups[group], (0, $eywbI.manualCount), group);
        this._applyDensity(options.particles, options.manualParticles.length);
    }
    setLastZIndex(zIndex) {
        this._lastZIndex = zIndex;
        this._needsSort = this._needsSort || this._lastZIndex < zIndex;
    }
    setResizeFactor(factor) {
        this._resizeFactor = factor;
    }
    update(delta) {
        const container = this._container, particlesToDelete = new Set();
        this.quadTree = new (0, $jTJrx.QuadTree)($c8b2da8a46f3d481$var$qTreeRectangle(container.canvas.size), (0, $eywbI.qTreeCapacity));
        for (const pathGenerator of container.pathGenerators.values())pathGenerator.update();
        for (const plugin of container.plugins.values())plugin.update?.(delta);
        const resizeFactor = this._resizeFactor;
        for (const particle of this._array){
            if (resizeFactor && !particle.ignoresResizeRatio) {
                particle.position.x *= resizeFactor.width;
                particle.position.y *= resizeFactor.height;
                particle.initialPosition.x *= resizeFactor.width;
                particle.initialPosition.y *= resizeFactor.height;
            }
            particle.ignoresResizeRatio = false;
            this._interactionManager.reset(particle);
            for (const plugin of this._container.plugins.values()){
                if (particle.destroyed) break;
                plugin.particleUpdate?.(particle, delta);
            }
            for (const mover of this.movers)if (mover.isEnabled(particle)) mover.move(particle, delta);
            if (particle.destroyed) {
                particlesToDelete.add(particle);
                continue;
            }
            this.quadTree.insert(new (0, $akNkp.Point)(particle.getPosition(), particle));
        }
        if (particlesToDelete.size) {
            const checkDelete = (p)=>!particlesToDelete.has(p);
            this._array = this.filter(checkDelete);
            this._zArray = this._zArray.filter(checkDelete);
            for (const particle of particlesToDelete)this._engine.dispatchEvent((0, $3ikOd.EventType).particleRemoved, {
                container: this._container,
                data: {
                    particle: particle
                }
            });
            this._addToPool(...particlesToDelete);
        }
        this._interactionManager.externalInteract(delta);
        for (const particle of this._array){
            for (const updater of this.updaters)updater.update(particle, delta);
            if (!particle.destroyed && !particle.spawning) this._interactionManager.particlesInteract(particle, delta);
        }
        delete this._resizeFactor;
        if (this._needsSort) {
            const zArray = this._zArray;
            zArray.sort((a, b)=>b.position.z - a.position.z || a.id - b.id);
            this._lastZIndex = zArray[zArray.length - (0, $eywbI.lengthOffset)].position.z;
            this._needsSort = false;
        }
    }
}

});
parcelRegister("iUhfk", function(module, exports) {

$parcel$export(module.exports, "InteractionManager", () => $dc3ad5b80b68da24$export$aaa80641d584351c);

var $1Lc98 = parcelRequire("1Lc98");
class $dc3ad5b80b68da24$export$aaa80641d584351c {
    constructor(engine, container){
        this.container = container;
        this._engine = engine;
        this._interactors = [];
        this._externalInteractors = [];
        this._particleInteractors = [];
    }
    externalInteract(delta) {
        for (const interactor of this._externalInteractors)if (interactor.isEnabled()) interactor.interact(delta);
    }
    handleClickMode(mode) {
        for (const interactor of this._externalInteractors)interactor.handleClickMode?.(mode);
    }
    async init() {
        this._interactors = await this._engine.getInteractors(this.container, true);
        this._externalInteractors = [];
        this._particleInteractors = [];
        for (const interactor of this._interactors){
            switch(interactor.type){
                case (0, $1Lc98.InteractorType).external:
                    this._externalInteractors.push(interactor);
                    break;
                case (0, $1Lc98.InteractorType).particles:
                    this._particleInteractors.push(interactor);
                    break;
            }
            interactor.init();
        }
    }
    particlesInteract(particle, delta) {
        for (const interactor of this._externalInteractors)interactor.clear(particle, delta);
        for (const interactor of this._particleInteractors)if (interactor.isEnabled(particle)) interactor.interact(particle, delta);
    }
    reset(particle) {
        for (const interactor of this._externalInteractors)if (interactor.isEnabled()) interactor.reset(particle);
        for (const interactor of this._particleInteractors)if (interactor.isEnabled(particle)) interactor.reset(particle);
    }
}

});
parcelRegister("1Lc98", function(module, exports) {

$parcel$export(module.exports, "InteractorType", () => $14839a39a5fd44af$export$143a800d561d28fd);
var $14839a39a5fd44af$export$143a800d561d28fd;
(function(InteractorType) {
    InteractorType["external"] = "external";
    InteractorType["particles"] = "particles";
})($14839a39a5fd44af$export$143a800d561d28fd || ($14839a39a5fd44af$export$143a800d561d28fd = {}));

});


parcelRegister("4PBzI", function(module, exports) {

$parcel$export(module.exports, "Particle", () => $38491278008ab2e6$export$c36c68baa13912a5);

var $aocC0 = parcelRequire("aocC0");

var $yZzCW = parcelRequire("yZzCW");

var $eywbI = parcelRequire("eywbI");

var $eDm3t = parcelRequire("eDm3t");

var $6nx5m = parcelRequire("6nx5m");

var $3ikOd = parcelRequire("3ikOd");

var $gMg5z = parcelRequire("gMg5z");

var $hlFRq = parcelRequire("hlFRq");

var $eBPJQ = parcelRequire("eBPJQ");

var $3SKQC = parcelRequire("3SKQC");

var $5r4A4 = parcelRequire("5r4A4");

var $izu9S = parcelRequire("izu9S");

var $43Hl2 = parcelRequire("43Hl2");
function $38491278008ab2e6$var$loadEffectData(effect, effectOptions, id, reduceDuplicates) {
    const effectData = effectOptions.options[effect];
    if (!effectData) return;
    return (0, $eDm3t.deepExtend)({
        close: effectOptions.close,
        fill: effectOptions.fill
    }, (0, $eDm3t.itemFromSingleOrMultiple)(effectData, id, reduceDuplicates));
}
function $38491278008ab2e6$var$loadShapeData(shape, shapeOptions, id, reduceDuplicates) {
    const shapeData = shapeOptions.options[shape];
    if (!shapeData) return;
    return (0, $eDm3t.deepExtend)({
        close: shapeOptions.close,
        fill: shapeOptions.fill
    }, (0, $eDm3t.itemFromSingleOrMultiple)(shapeData, id, reduceDuplicates));
}
function $38491278008ab2e6$var$fixOutMode(data) {
    if (!(0, $eDm3t.isInArray)(data.outMode, data.checkModes)) return;
    const diameter = data.radius * (0, $eywbI.double);
    if (data.coord > data.maxCoord - diameter) data.setCb(-data.radius);
    else if (data.coord < diameter) data.setCb(data.radius);
}
class $38491278008ab2e6$export$c36c68baa13912a5 {
    constructor(engine, container){
        this.container = container;
        this._calcPosition = (container, position, zIndex, tryCount = (0, $eywbI.defaultRetryCount))=>{
            for (const plugin of container.plugins.values()){
                const pluginPos = plugin.particlePosition !== undefined ? plugin.particlePosition(position, this) : undefined;
                if (pluginPos) return (0, $aocC0.Vector3d).create(pluginPos.x, pluginPos.y, zIndex);
            }
            const canvasSize = container.canvas.size, exactPosition = (0, $yZzCW.calcExactPositionOrRandomFromSize)({
                size: canvasSize,
                position: position
            }), pos = (0, $aocC0.Vector3d).create(exactPosition.x, exactPosition.y, zIndex), radius = this.getRadius(), outModes = this.options.move.outModes, fixHorizontal = (outMode)=>{
                $38491278008ab2e6$var$fixOutMode({
                    outMode: outMode,
                    checkModes: [
                        (0, $eBPJQ.OutMode).bounce
                    ],
                    coord: pos.x,
                    maxCoord: container.canvas.size.width,
                    setCb: (value)=>pos.x += value,
                    radius: radius
                });
            }, fixVertical = (outMode)=>{
                $38491278008ab2e6$var$fixOutMode({
                    outMode: outMode,
                    checkModes: [
                        (0, $eBPJQ.OutMode).bounce
                    ],
                    coord: pos.y,
                    maxCoord: container.canvas.size.height,
                    setCb: (value)=>pos.y += value,
                    radius: radius
                });
            };
            fixHorizontal(outModes.left ?? outModes.default);
            fixHorizontal(outModes.right ?? outModes.default);
            fixVertical(outModes.top ?? outModes.default);
            fixVertical(outModes.bottom ?? outModes.default);
            if (this._checkOverlap(pos, tryCount)) return this._calcPosition(container, undefined, zIndex, tryCount + (0, $eywbI.tryCountIncrement));
            return pos;
        };
        this._calculateVelocity = ()=>{
            const baseVelocity = (0, $yZzCW.getParticleBaseVelocity)(this.direction), res = baseVelocity.copy(), moveOptions = this.options.move;
            if (moveOptions.direction === (0, $hlFRq.MoveDirection).inside || moveOptions.direction === (0, $hlFRq.MoveDirection).outside) return res;
            const rad = (0, $yZzCW.degToRad)((0, $yZzCW.getRangeValue)(moveOptions.angle.value)), radOffset = (0, $yZzCW.degToRad)((0, $yZzCW.getRangeValue)(moveOptions.angle.offset)), range = {
                left: radOffset - rad * (0, $eywbI.half),
                right: radOffset + rad * (0, $eywbI.half)
            };
            if (!moveOptions.straight) res.angle += (0, $yZzCW.randomInRange)((0, $yZzCW.setRangeValue)(range.left, range.right));
            if (moveOptions.random && typeof moveOptions.speed === "number") res.length *= (0, $yZzCW.getRandom)();
            return res;
        };
        this._checkOverlap = (pos, tryCount = (0, $eywbI.defaultRetryCount))=>{
            const collisionsOptions = this.options.collisions, radius = this.getRadius();
            if (!collisionsOptions.enable) return false;
            const overlapOptions = collisionsOptions.overlap;
            if (overlapOptions.enable) return false;
            const retries = overlapOptions.retries;
            if (retries >= (0, $eywbI.minRetries) && tryCount > retries) throw new Error(`${(0, $eywbI.errorPrefix)} particle is overlapping and can't be placed`);
            return !!this.container.particles.find((particle)=>(0, $yZzCW.getDistance)(pos, particle.position) < radius + particle.getRadius());
        };
        this._getRollColor = (color)=>{
            if (!color || !this.roll || !this.backColor && !this.roll.alter) return color;
            const backFactor = this.roll.horizontal && this.roll.vertical ? (0, $eywbI.double) * (0, $eywbI.rollFactor) : (0, $eywbI.rollFactor), backSum = this.roll.horizontal ? Math.PI * (0, $eywbI.half) : (0, $eywbI.none), rolled = Math.floor(((this.roll.angle ?? (0, $eywbI.none)) + backSum) / (Math.PI / backFactor)) % (0, $eywbI.double);
            if (!rolled) return color;
            if (this.backColor) return this.backColor;
            if (this.roll.alter) return (0, $izu9S.alterHsl)(color, this.roll.alter.type, this.roll.alter.value);
            return color;
        };
        this._initPosition = (position)=>{
            const container = this.container, zIndexValue = (0, $yZzCW.getRangeValue)(this.options.zIndex.value);
            this.position = this._calcPosition(container, position, (0, $yZzCW.clamp)(zIndexValue, (0, $eywbI.minZ), container.zLayers));
            this.initialPosition = this.position.copy();
            const canvasSize = container.canvas.size;
            this.moveCenter = {
                ...(0, $eDm3t.getPosition)(this.options.move.center, canvasSize),
                radius: this.options.move.center.radius ?? (0, $eywbI.defaultRadius),
                mode: this.options.move.center.mode ?? (0, $5r4A4.PixelMode).percent
            };
            this.direction = (0, $yZzCW.getParticleDirectionAngle)(this.options.move.direction, this.position, this.moveCenter);
            switch(this.options.move.direction){
                case (0, $hlFRq.MoveDirection).inside:
                    this.outType = (0, $3SKQC.ParticleOutType).inside;
                    break;
                case (0, $hlFRq.MoveDirection).outside:
                    this.outType = (0, $3SKQC.ParticleOutType).outside;
                    break;
            }
            this.offset = (0, $aocC0.Vector).origin;
        };
        this._engine = engine;
    }
    destroy(override) {
        if (this.unbreakable || this.destroyed) return;
        this.destroyed = true;
        this.bubble.inRange = false;
        this.slow.inRange = false;
        const container = this.container, pathGenerator = this.pathGenerator, shapeDrawer = container.shapeDrawers.get(this.shape);
        shapeDrawer?.particleDestroy?.(this);
        for (const plugin of container.plugins.values())plugin.particleDestroyed?.(this, override);
        for (const updater of container.particles.updaters)updater.particleDestroyed?.(this, override);
        pathGenerator?.reset(this);
        this._engine.dispatchEvent((0, $3ikOd.EventType).particleDestroyed, {
            container: this.container,
            data: {
                particle: this
            }
        });
    }
    draw(delta) {
        const container = this.container, canvas = container.canvas;
        for (const plugin of container.plugins.values())canvas.drawParticlePlugin(plugin, this, delta);
        canvas.drawParticle(this, delta);
    }
    getFillColor() {
        return this._getRollColor(this.bubble.color ?? (0, $6nx5m.getHslFromAnimation)(this.color));
    }
    getMass() {
        return this.getRadius() ** (0, $eywbI.squareExp) * Math.PI * (0, $eywbI.half);
    }
    getPosition() {
        return {
            x: this.position.x + this.offset.x,
            y: this.position.y + this.offset.y,
            z: this.position.z
        };
    }
    getRadius() {
        return this.bubble.radius ?? this.size.value;
    }
    getStrokeColor() {
        return this._getRollColor(this.bubble.color ?? (0, $6nx5m.getHslFromAnimation)(this.strokeColor));
    }
    init(id, position, overrideOptions, group) {
        const container = this.container, engine = this._engine;
        this.id = id;
        this.group = group;
        this.effectClose = true;
        this.effectFill = true;
        this.shapeClose = true;
        this.shapeFill = true;
        this.pathRotation = false;
        this.lastPathTime = 0;
        this.destroyed = false;
        this.unbreakable = false;
        this.isRotating = false;
        this.rotation = 0;
        this.misplaced = false;
        this.retina = {
            maxDistance: {}
        };
        this.outType = (0, $3SKQC.ParticleOutType).normal;
        this.ignoresResizeRatio = true;
        const pxRatio = container.retina.pixelRatio, mainOptions = container.actualOptions, particlesOptions = (0, $43Hl2.loadParticlesOptions)(this._engine, container, mainOptions.particles), { reduceDuplicates: reduceDuplicates } = particlesOptions, effectType = particlesOptions.effect.type, shapeType = particlesOptions.shape.type;
        this.effect = (0, $eDm3t.itemFromSingleOrMultiple)(effectType, this.id, reduceDuplicates);
        this.shape = (0, $eDm3t.itemFromSingleOrMultiple)(shapeType, this.id, reduceDuplicates);
        const effectOptions = particlesOptions.effect, shapeOptions = particlesOptions.shape;
        if (overrideOptions) {
            if (overrideOptions.effect?.type) {
                const overrideEffectType = overrideOptions.effect.type, effect = (0, $eDm3t.itemFromSingleOrMultiple)(overrideEffectType, this.id, reduceDuplicates);
                if (effect) {
                    this.effect = effect;
                    effectOptions.load(overrideOptions.effect);
                }
            }
            if (overrideOptions.shape?.type) {
                const overrideShapeType = overrideOptions.shape.type, shape = (0, $eDm3t.itemFromSingleOrMultiple)(overrideShapeType, this.id, reduceDuplicates);
                if (shape) {
                    this.shape = shape;
                    shapeOptions.load(overrideOptions.shape);
                }
            }
        }
        if (this.effect === (0, $eywbI.randomColorValue)) {
            const availableEffects = [
                ...this.container.effectDrawers.keys()
            ];
            this.effect = availableEffects[Math.floor(Math.random() * availableEffects.length)];
        }
        if (this.shape === (0, $eywbI.randomColorValue)) {
            const availableShapes = [
                ...this.container.shapeDrawers.keys()
            ];
            this.shape = availableShapes[Math.floor(Math.random() * availableShapes.length)];
        }
        this.effectData = $38491278008ab2e6$var$loadEffectData(this.effect, effectOptions, this.id, reduceDuplicates);
        this.shapeData = $38491278008ab2e6$var$loadShapeData(this.shape, shapeOptions, this.id, reduceDuplicates);
        particlesOptions.load(overrideOptions);
        const effectData = this.effectData;
        if (effectData) particlesOptions.load(effectData.particles);
        const shapeData = this.shapeData;
        if (shapeData) particlesOptions.load(shapeData.particles);
        const interactivity = new (0, $gMg5z.Interactivity)(engine, container);
        interactivity.load(container.actualOptions.interactivity);
        interactivity.load(particlesOptions.interactivity);
        this.interactivity = interactivity;
        this.effectFill = effectData?.fill ?? particlesOptions.effect.fill;
        this.effectClose = effectData?.close ?? particlesOptions.effect.close;
        this.shapeFill = shapeData?.fill ?? particlesOptions.shape.fill;
        this.shapeClose = shapeData?.close ?? particlesOptions.shape.close;
        this.options = particlesOptions;
        const pathOptions = this.options.move.path;
        this.pathDelay = (0, $yZzCW.getRangeValue)(pathOptions.delay.value) * (0, $eywbI.millisecondsToSeconds);
        if (pathOptions.generator) {
            this.pathGenerator = this._engine.getPathGenerator(pathOptions.generator);
            if (this.pathGenerator && container.addPath(pathOptions.generator, this.pathGenerator)) this.pathGenerator.init(container);
        }
        container.retina.initParticle(this);
        this.size = (0, $eDm3t.initParticleNumericAnimationValue)(this.options.size, pxRatio);
        this.bubble = {
            inRange: false
        };
        this.slow = {
            inRange: false,
            factor: 1
        };
        this._initPosition(position);
        this.initialVelocity = this._calculateVelocity();
        this.velocity = this.initialVelocity.copy();
        this.moveDecay = (0, $eywbI.decayOffset) - (0, $yZzCW.getRangeValue)(this.options.move.decay);
        const particles = container.particles;
        particles.setLastZIndex(this.position.z);
        this.zIndexFactor = this.position.z / container.zLayers;
        this.sides = 24;
        let effectDrawer = container.effectDrawers.get(this.effect);
        if (!effectDrawer) {
            effectDrawer = this._engine.getEffectDrawer(this.effect);
            if (effectDrawer) container.effectDrawers.set(this.effect, effectDrawer);
        }
        if (effectDrawer?.loadEffect) effectDrawer.loadEffect(this);
        let shapeDrawer = container.shapeDrawers.get(this.shape);
        if (!shapeDrawer) {
            shapeDrawer = this._engine.getShapeDrawer(this.shape);
            if (shapeDrawer) container.shapeDrawers.set(this.shape, shapeDrawer);
        }
        if (shapeDrawer?.loadShape) shapeDrawer.loadShape(this);
        const sideCountFunc = shapeDrawer?.getSidesCount;
        if (sideCountFunc) this.sides = sideCountFunc(this);
        this.spawning = false;
        this.shadowColor = (0, $6nx5m.rangeColorToRgb)(this._engine, this.options.shadow.color);
        for (const updater of particles.updaters)updater.init(this);
        for (const mover of particles.movers)mover.init?.(this);
        effectDrawer?.particleInit?.(container, this);
        shapeDrawer?.particleInit?.(container, this);
        for (const plugin of container.plugins.values())plugin.particleCreated?.(this);
    }
    isInsideCanvas() {
        const radius = this.getRadius(), canvasSize = this.container.canvas.size, position = this.position;
        return position.x >= -radius && position.y >= -radius && position.y <= canvasSize.height + radius && position.x <= canvasSize.width + radius;
    }
    isVisible() {
        return !this.destroyed && !this.spawning && this.isInsideCanvas();
    }
    reset() {
        for (const updater of this.container.particles.updaters)updater.reset?.(this);
    }
}

});
parcelRegister("3SKQC", function(module, exports) {

$parcel$export(module.exports, "ParticleOutType", () => $2d3ac13ae149ad39$export$2e559b10bdb6bb80);
var $2d3ac13ae149ad39$export$2e559b10bdb6bb80;
(function(ParticleOutType) {
    ParticleOutType["normal"] = "normal";
    ParticleOutType["inside"] = "inside";
    ParticleOutType["outside"] = "outside";
})($2d3ac13ae149ad39$export$2e559b10bdb6bb80 || ($2d3ac13ae149ad39$export$2e559b10bdb6bb80 = {}));

});


parcelRegister("akNkp", function(module, exports) {

$parcel$export(module.exports, "Point", () => $786209302c14324d$export$baf26146a414f24a);
class $786209302c14324d$export$baf26146a414f24a {
    constructor(position, particle){
        this.position = position;
        this.particle = particle;
    }
}

});

parcelRegister("jTJrx", function(module, exports) {

$parcel$export(module.exports, "QuadTree", () => $e7c66770ecc5c059$export$b82688eb02220411);

var $lpuyt = parcelRequire("lpuyt");

var $eywbI = parcelRequire("eywbI");

var $yZzCW = parcelRequire("yZzCW");
class $e7c66770ecc5c059$export$b82688eb02220411 {
    constructor(rectangle, capacity){
        this.rectangle = rectangle;
        this.capacity = capacity;
        this._subdivide = ()=>{
            const { x: x, y: y } = this.rectangle.position, { width: width, height: height } = this.rectangle.size, { capacity: capacity } = this;
            for(let i = 0; i < (0, $eywbI.subdivideCount); i++){
                const fixedIndex = i % (0, $eywbI.double);
                this._subs.push(new $e7c66770ecc5c059$export$b82688eb02220411(new (0, $lpuyt.Rectangle)(x + width * (0, $eywbI.half) * fixedIndex, y + height * (0, $eywbI.half) * (Math.round(i * (0, $eywbI.half)) - fixedIndex), width * (0, $eywbI.half), height * (0, $eywbI.half)), capacity));
            }
            this._divided = true;
        };
        this._points = [];
        this._divided = false;
        this._subs = [];
    }
    insert(point) {
        if (!this.rectangle.contains(point.position)) return false;
        if (this._points.length < this.capacity) {
            this._points.push(point);
            return true;
        }
        if (!this._divided) this._subdivide();
        return this._subs.some((sub)=>sub.insert(point));
    }
    query(range, check) {
        const res = [];
        if (!range.intersects(this.rectangle)) return [];
        for (const p of this._points){
            if (!range.contains(p.position) && (0, $yZzCW.getDistance)(range.position, p.position) > p.particle.getRadius() && (!check || check(p.particle))) continue;
            res.push(p.particle);
        }
        if (this._divided) for (const sub of this._subs)res.push(...sub.query(range, check));
        return res;
    }
    queryCircle(position, radius, check) {
        return this.query(new (0, $lpuyt.Circle)(position.x, position.y, radius), check);
    }
    queryRectangle(position, size, check) {
        return this.query(new (0, $lpuyt.Rectangle)(position.x, position.y, size.width, size.height), check);
    }
}

});
parcelRegister("lpuyt", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $f963a2634cce209b$export$c89a927ffc67e6fa);
$parcel$export(module.exports, "Rectangle", () => $f963a2634cce209b$export$4617fb02663045ef);

var $e0T0t = parcelRequire("e0T0t");

var $yZzCW = parcelRequire("yZzCW");

var $eywbI = parcelRequire("eywbI");
class $f963a2634cce209b$export$f237afe0deab98f9 {
    constructor(x, y, type){
        this.position = {
            x: x,
            y: y
        };
        this.type = type;
    }
}
class $f963a2634cce209b$export$c89a927ffc67e6fa extends $f963a2634cce209b$export$f237afe0deab98f9 {
    constructor(x, y, radius){
        super(x, y, (0, $e0T0t.RangeType).circle);
        this.radius = radius;
    }
    contains(point) {
        return (0, $yZzCW.getDistance)(point, this.position) <= this.radius;
    }
    intersects(range) {
        const pos1 = this.position, pos2 = range.position, distPos = {
            x: Math.abs(pos2.x - pos1.x),
            y: Math.abs(pos2.y - pos1.y)
        }, r = this.radius;
        if (range instanceof $f963a2634cce209b$export$c89a927ffc67e6fa || range.type === (0, $e0T0t.RangeType).circle) {
            const circleRange = range, rSum = r + circleRange.radius, dist = Math.sqrt(distPos.x ** (0, $eywbI.squareExp) + distPos.y ** (0, $eywbI.squareExp));
            return rSum > dist;
        } else if (range instanceof $f963a2634cce209b$export$4617fb02663045ef || range.type === (0, $e0T0t.RangeType).rectangle) {
            const rectRange = range, { width: width, height: height } = rectRange.size, edges = Math.pow(distPos.x - width, (0, $eywbI.squareExp)) + Math.pow(distPos.y - height, (0, $eywbI.squareExp));
            return edges <= r ** (0, $eywbI.squareExp) || distPos.x <= r + width && distPos.y <= r + height || distPos.x <= width || distPos.y <= height;
        }
        return false;
    }
}
class $f963a2634cce209b$export$4617fb02663045ef extends $f963a2634cce209b$export$f237afe0deab98f9 {
    constructor(x, y, width, height){
        super(x, y, (0, $e0T0t.RangeType).rectangle);
        this.size = {
            height: height,
            width: width
        };
    }
    contains(point) {
        const w = this.size.width, h = this.size.height, pos = this.position;
        return point.x >= pos.x && point.x <= pos.x + w && point.y >= pos.y && point.y <= pos.y + h;
    }
    intersects(range) {
        if (range instanceof $f963a2634cce209b$export$c89a927ffc67e6fa) return range.intersects(this);
        const w = this.size.width, h = this.size.height, pos1 = this.position, pos2 = range.position, size2 = range instanceof $f963a2634cce209b$export$4617fb02663045ef ? range.size : {
            width: 0,
            height: 0
        }, w2 = size2.width, h2 = size2.height;
        return pos2.x < pos1.x + w && pos2.x + w2 > pos1.x && pos2.y < pos1.y + h && pos2.y + h2 > pos1.y;
    }
}

});
parcelRegister("e0T0t", function(module, exports) {

$parcel$export(module.exports, "RangeType", () => $a33bbbee6fa3d784$export$2ede450fbdbb4e4c);
var $a33bbbee6fa3d784$export$2ede450fbdbb4e4c;
(function(RangeType) {
    RangeType["circle"] = "circle";
    RangeType["rectangle"] = "rectangle";
})($a33bbbee6fa3d784$export$2ede450fbdbb4e4c || ($a33bbbee6fa3d784$export$2ede450fbdbb4e4c = {}));

});




parcelRegister("eL0X5", function(module, exports) {

$parcel$export(module.exports, "Retina", () => $abe63184812842c9$export$b7a992a6d33e9eff);

var $eywbI = parcelRequire("eywbI");

var $yZzCW = parcelRequire("yZzCW");

var $eDm3t = parcelRequire("eDm3t");
class $abe63184812842c9$export$b7a992a6d33e9eff {
    constructor(container){
        this.container = container;
        this.pixelRatio = (0, $eywbI.defaultRatio);
        this.reduceFactor = (0, $eywbI.defaultReduceFactor);
    }
    init() {
        const container = this.container, options = container.actualOptions;
        this.pixelRatio = !options.detectRetina || (0, $eDm3t.isSsr)() ? (0, $eywbI.defaultRatio) : window.devicePixelRatio;
        this.reduceFactor = (0, $eywbI.defaultReduceFactor);
        const ratio = this.pixelRatio, canvas = container.canvas;
        if (canvas.element) {
            const element = canvas.element;
            canvas.size.width = element.offsetWidth * ratio;
            canvas.size.height = element.offsetHeight * ratio;
        }
        const particles = options.particles, moveOptions = particles.move;
        this.maxSpeed = (0, $yZzCW.getRangeValue)(moveOptions.gravity.maxSpeed) * ratio;
        this.sizeAnimationSpeed = (0, $yZzCW.getRangeValue)(particles.size.animation.speed) * ratio;
    }
    initParticle(particle) {
        const options = particle.options, ratio = this.pixelRatio, moveOptions = options.move, moveDistance = moveOptions.distance, props = particle.retina;
        props.moveDrift = (0, $yZzCW.getRangeValue)(moveOptions.drift) * ratio;
        props.moveSpeed = (0, $yZzCW.getRangeValue)(moveOptions.speed) * ratio;
        props.sizeAnimationSpeed = (0, $yZzCW.getRangeValue)(options.size.animation.speed) * ratio;
        const maxDistance = props.maxDistance;
        maxDistance.horizontal = moveDistance.horizontal !== undefined ? moveDistance.horizontal * ratio : undefined;
        maxDistance.vertical = moveDistance.vertical !== undefined ? moveDistance.vertical * ratio : undefined;
        props.maxSpeed = (0, $yZzCW.getRangeValue)(moveOptions.gravity.maxSpeed) * ratio;
    }
}

});


parcelRegister("63ULI", function(module, exports) {

$parcel$export(module.exports, "EventDispatcher", () => $469f0ef658e31fe8$export$ec8b666c5fe2c75a);

var $eywbI = parcelRequire("eywbI");
class $469f0ef658e31fe8$export$ec8b666c5fe2c75a {
    constructor(){
        this._listeners = new Map();
    }
    addEventListener(type, listener) {
        this.removeEventListener(type, listener);
        let arr = this._listeners.get(type);
        if (!arr) {
            arr = [];
            this._listeners.set(type, arr);
        }
        arr.push(listener);
    }
    dispatchEvent(type, args) {
        const listeners = this._listeners.get(type);
        listeners?.forEach((handler)=>handler(args));
    }
    hasEventListener(type) {
        return !!this._listeners.get(type);
    }
    removeAllEventListeners(type) {
        if (!type) this._listeners = new Map();
        else this._listeners.delete(type);
    }
    removeEventListener(type, listener) {
        const arr = this._listeners.get(type);
        if (!arr) return;
        const length = arr.length, idx = arr.indexOf(listener);
        if (idx < (0, $eywbI.minIndex)) return;
        if (length === (0, $eywbI.deleteCount)) this._listeners.delete(type);
        else arr.splice(idx, (0, $eywbI.deleteCount));
    }
}

});



parcelRegister("3ZPxj", function(module, exports) {
$parcel$export(module.exports, "half", () => (parcelRequire("eywbI")).half);
$parcel$export(module.exports, "millisecondsToSeconds", () => (parcelRequire("eywbI")).millisecondsToSeconds);
$parcel$export(module.exports, "percentDenominator", () => (parcelRequire("eywbI")).percentDenominator);
$parcel$export(module.exports, "Vector", () => (parcelRequire("aocC0")).Vector);
$parcel$export(module.exports, "RotateDirection", () => (parcelRequire("WiXRo")).RotateDirection);
$parcel$export(module.exports, "OutModeDirection", () => (parcelRequire("6VMPk")).OutModeDirection);
$parcel$export(module.exports, "OutMode", () => (parcelRequire("eBPJQ")).OutMode);
$parcel$export(module.exports, "PixelMode", () => (parcelRequire("5r4A4")).PixelMode);
$parcel$export(module.exports, "AlterType", () => (parcelRequire("1ruWN")).AlterType);
$parcel$export(module.exports, "DestroyType", () => (parcelRequire("7ecaf")).DestroyType);
$parcel$export(module.exports, "ParticleOutType", () => (parcelRequire("3SKQC")).ParticleOutType);
$parcel$export(module.exports, "AnimationStatus", () => (parcelRequire("d8kOl")).AnimationStatus);
$parcel$export(module.exports, "AnimatableColor", () => (parcelRequire("jXSVo")).AnimatableColor);
$parcel$export(module.exports, "OptionsColor", () => (parcelRequire("hzwm7")).OptionsColor);
$parcel$export(module.exports, "ValueWithRandom", () => (parcelRequire("hAZRJ")).ValueWithRandom);
$parcel$export(module.exports, "getHslAnimationFromHsl", () => (parcelRequire("6nx5m")).getHslAnimationFromHsl);
$parcel$export(module.exports, "hslaToRgba", () => (parcelRequire("6nx5m")).hslaToRgba);
$parcel$export(module.exports, "hslToRgb", () => (parcelRequire("6nx5m")).hslToRgb);
$parcel$export(module.exports, "rangeColorToHsl", () => (parcelRequire("6nx5m")).rangeColorToHsl);
$parcel$export(module.exports, "updateColor", () => (parcelRequire("6nx5m")).updateColor);
$parcel$export(module.exports, "calcPositionOrRandomFromSizeRanged", () => (parcelRequire("yZzCW")).calcPositionOrRandomFromSizeRanged);
$parcel$export(module.exports, "clamp", () => (parcelRequire("yZzCW")).clamp);
$parcel$export(module.exports, "degToRad", () => (parcelRequire("yZzCW")).degToRad);
$parcel$export(module.exports, "getDistance", () => (parcelRequire("yZzCW")).getDistance);
$parcel$export(module.exports, "getDistances", () => (parcelRequire("yZzCW")).getDistances);
$parcel$export(module.exports, "getRandom", () => (parcelRequire("yZzCW")).getRandom);
$parcel$export(module.exports, "getRangeMax", () => (parcelRequire("yZzCW")).getRangeMax);
$parcel$export(module.exports, "getRangeValue", () => (parcelRequire("yZzCW")).getRangeValue);
$parcel$export(module.exports, "parseAlpha", () => (parcelRequire("yZzCW")).parseAlpha);
$parcel$export(module.exports, "randomInRange", () => (parcelRequire("yZzCW")).randomInRange);
$parcel$export(module.exports, "setRangeValue", () => (parcelRequire("yZzCW")).setRangeValue);
$parcel$export(module.exports, "arrayRandomIndex", () => (parcelRequire("eDm3t")).arrayRandomIndex);
$parcel$export(module.exports, "calculateBounds", () => (parcelRequire("eDm3t")).calculateBounds);
$parcel$export(module.exports, "deepExtend", () => (parcelRequire("eDm3t")).deepExtend);
$parcel$export(module.exports, "executeOnSingleOrMultiple", () => (parcelRequire("eDm3t")).executeOnSingleOrMultiple);
$parcel$export(module.exports, "getSize", () => (parcelRequire("eDm3t")).getSize);
$parcel$export(module.exports, "initParticleNumericAnimationValue", () => (parcelRequire("eDm3t")).initParticleNumericAnimationValue);
$parcel$export(module.exports, "isInArray", () => (parcelRequire("eDm3t")).isInArray);
$parcel$export(module.exports, "isPointInside", () => (parcelRequire("eDm3t")).isPointInside);
$parcel$export(module.exports, "itemFromArray", () => (parcelRequire("eDm3t")).itemFromArray);
$parcel$export(module.exports, "itemFromSingleOrMultiple", () => (parcelRequire("eDm3t")).itemFromSingleOrMultiple);
$parcel$export(module.exports, "safeMatchMedia", () => (parcelRequire("eDm3t")).safeMatchMedia);
$parcel$export(module.exports, "updateAnimation", () => (parcelRequire("eDm3t")).updateAnimation);
$parcel$export(module.exports, "isArray", () => (parcelRequire("62pjT")).isArray);
$parcel$export(module.exports, "isNull", () => (parcelRequire("62pjT")).isNull);
$parcel$export(module.exports, "isNumber", () => (parcelRequire("62pjT")).isNumber);
$parcel$export(module.exports, "isObject", () => (parcelRequire("62pjT")).isObject);
parcelRequire("eywbI");
parcelRequire("heZZY");
parcelRequire("8gTaT");
parcelRequire("akNkp");
parcelRequire("lpuyt");
parcelRequire("aocC0");
parcelRequire("hlFRq");
parcelRequire("WiXRo");
parcelRequire("6VMPk");
parcelRequire("bTldy");
parcelRequire("jU7Kv");
parcelRequire("bsv3r");
parcelRequire("eBPJQ");
parcelRequire("5r4A4");
parcelRequire("kxwqM");
parcelRequire("72ET5");
parcelRequire("1ruWN");
parcelRequire("7ecaf");
parcelRequire("8o8uf");
parcelRequire("1Lc98");
parcelRequire("3SKQC");
parcelRequire("84ZEL");
parcelRequire("5mVMY");
parcelRequire("9UsJp");
parcelRequire("3ikOd");
parcelRequire("d8kOl");
parcelRequire("3F4oU");
parcelRequire("jXSVo");
parcelRequire("48bX3");
parcelRequire("5wxu6");
parcelRequire("lyXAK");
parcelRequire("fYrAK");
parcelRequire("chQdy");
parcelRequire("6VU1S");
parcelRequire("87NqF");
parcelRequire("lT0qX");
parcelRequire("5ZZwW");
parcelRequire("dzvnt");
parcelRequire("ebFKi");
parcelRequire("a4yiY");
parcelRequire("1OU8M");
parcelRequire("gMg5z");
parcelRequire("eRvp4");
parcelRequire("3OW6C");
parcelRequire("ndmgJ");
parcelRequire("hzwm7");
parcelRequire("34mxm");
parcelRequire("2jyiK");
parcelRequire("iunVO");
parcelRequire("kfYsq");
parcelRequire("lcKDZ");
parcelRequire("dV7y4");
parcelRequire("gGCJV");
parcelRequire("jMQW5");
parcelRequire("15G8Z");
parcelRequire("eZpg9");
parcelRequire("aZ64x");
parcelRequire("lCbic");
parcelRequire("9iy6g");
parcelRequire("4r7Vr");
parcelRequire("jpnpW");
parcelRequire("gjqYa");
parcelRequire("k78he");
parcelRequire("ezm0L");
parcelRequire("dExOX");
parcelRequire("gUwDN");
parcelRequire("vwqkG");
parcelRequire("9RRUY");
parcelRequire("7alxg");
parcelRequire("inCyF");
parcelRequire("7fCIN");
parcelRequire("2pHgR");
parcelRequire("lSoxJ");
parcelRequire("dLBd8");
parcelRequire("iTZAY");
parcelRequire("hAZRJ");
parcelRequire("izu9S");
parcelRequire("6nx5m");
parcelRequire("yZzCW");
parcelRequire("43Hl2");
parcelRequire("eDm3t");
parcelRequire("62pjT");

});
parcelRegister("heZZY", function(module, exports) {

var $1Lc98 = parcelRequire("1Lc98");
class $c8d3d61e718357e7$export$6e252256471acc61 {
    constructor(container){
        this.type = (0, $1Lc98.InteractorType).external;
        this.container = container;
    }
}

});

parcelRegister("8gTaT", function(module, exports) {

var $1Lc98 = parcelRequire("1Lc98");
class $605a9de04266c0f9$export$becdaab2d9289dc4 {
    constructor(container){
        this.type = (0, $1Lc98.InteractorType).particles;
        this.container = container;
    }
}

});

parcelRegister("WiXRo", function(module, exports) {

$parcel$export(module.exports, "RotateDirection", () => $0af420d8aee786a5$export$9506977ce2a96a5b);
var $0af420d8aee786a5$export$9506977ce2a96a5b;
(function(RotateDirection) {
    RotateDirection["clockwise"] = "clockwise";
    RotateDirection["counterClockwise"] = "counter-clockwise";
    RotateDirection["random"] = "random";
})($0af420d8aee786a5$export$9506977ce2a96a5b || ($0af420d8aee786a5$export$9506977ce2a96a5b = {}));

});

parcelRegister("8o8uf", function(module, exports) {
var $61b725f5488e882e$export$20d70ee9873a8ba;
(function(GradientType) {
    GradientType["linear"] = "linear";
    GradientType["radial"] = "radial";
    GradientType["random"] = "random";
})($61b725f5488e882e$export$20d70ee9873a8ba || ($61b725f5488e882e$export$20d70ee9873a8ba = {}));

});

parcelRegister("9UsJp", function(module, exports) {
var $736fa17f2361286e$export$483bfb5d033dec0c;
(function(EasingType) {
    EasingType["easeInBack"] = "ease-in-back";
    EasingType["easeInCirc"] = "ease-in-circ";
    EasingType["easeInCubic"] = "ease-in-cubic";
    EasingType["easeInLinear"] = "ease-in-linear";
    EasingType["easeInQuad"] = "ease-in-quad";
    EasingType["easeInQuart"] = "ease-in-quart";
    EasingType["easeInQuint"] = "ease-in-quint";
    EasingType["easeInExpo"] = "ease-in-expo";
    EasingType["easeInSine"] = "ease-in-sine";
    EasingType["easeOutBack"] = "ease-out-back";
    EasingType["easeOutCirc"] = "ease-out-circ";
    EasingType["easeOutCubic"] = "ease-out-cubic";
    EasingType["easeOutLinear"] = "ease-out-linear";
    EasingType["easeOutQuad"] = "ease-out-quad";
    EasingType["easeOutQuart"] = "ease-out-quart";
    EasingType["easeOutQuint"] = "ease-out-quint";
    EasingType["easeOutExpo"] = "ease-out-expo";
    EasingType["easeOutSine"] = "ease-out-sine";
    EasingType["easeInOutBack"] = "ease-in-out-back";
    EasingType["easeInOutCirc"] = "ease-in-out-circ";
    EasingType["easeInOutCubic"] = "ease-in-out-cubic";
    EasingType["easeInOutLinear"] = "ease-in-out-linear";
    EasingType["easeInOutQuad"] = "ease-in-out-quad";
    EasingType["easeInOutQuart"] = "ease-in-out-quart";
    EasingType["easeInOutQuint"] = "ease-in-out-quint";
    EasingType["easeInOutExpo"] = "ease-in-out-expo";
    EasingType["easeInOutSine"] = "ease-in-out-sine";
})($736fa17f2361286e$export$483bfb5d033dec0c || ($736fa17f2361286e$export$483bfb5d033dec0c = {}));

});


parcelRegister("bfrqN", function(module, exports) {
parcelRequire("791gi");
parcelRequire("gvsTn");
parcelRequire("k6A53");
parcelRequire("fEPBG");
parcelRequire("1wemO");
parcelRequire("11amS");
parcelRequire("btKi4");
parcelRequire("g8SUB");
parcelRequire("lpdHR");
parcelRequire("3SAmM");
parcelRequire("hp1VP");
parcelRequire("hfsUj");
parcelRequire("6VTbg");
parcelRequire("96mBs");
parcelRequire("kaoiR");
parcelRequire("f0IXO");
parcelRequire("jCPgy");
parcelRequire("eX3oG");
parcelRequire("j9dmG");
parcelRequire("a0Hx4");
parcelRequire("61ZHN");
parcelRequire("impIQ");
parcelRequire("lfrwz");
parcelRequire("br94n");
parcelRequire("grpxv");
parcelRequire("2nAFm");
parcelRequire("g7KlD");
parcelRequire("kl62H");
parcelRequire("j3Qs2");
parcelRequire("jDMaU");
parcelRequire("cNRKE");
parcelRequire("6efuq");
parcelRequire("c7Jof");
parcelRequire("9iWCF");
parcelRequire("8Og6p");
parcelRequire("lBLkV");
parcelRequire("9DpSp");
parcelRequire("aCADn");
parcelRequire("6ESi7");
parcelRequire("d6v7B");
parcelRequire("8plOH");
parcelRequire("iooVr");
parcelRequire("8dSK8");
parcelRequire("d65ZP");
parcelRequire("fAZWm");
parcelRequire("jplrx");
parcelRequire("8ZL0K");
parcelRequire("l4sdt");
parcelRequire("3YqXA");
parcelRequire("jqJoL");
parcelRequire("7iYPP");
parcelRequire("h9xcq");
parcelRequire("1u70n");
parcelRequire("27UOe");
parcelRequire("aQauT");
parcelRequire("9ko3Q");
parcelRequire("3Y2vd");
parcelRequire("bi4Yr");
parcelRequire("kw3Ag");
parcelRequire("8wwkl");
parcelRequire("iC8PD");
parcelRequire("gOnrP");
parcelRequire("fTO4M");
parcelRequire("jzXT0");
parcelRequire("jJnJz");
parcelRequire("7kEJg");
parcelRequire("fnMol");
parcelRequire("fqwuE");
parcelRequire("jFCzi");
parcelRequire("khuL4");
parcelRequire("bK2y5");
parcelRequire("7MFFc");
parcelRequire("9L2XS");
parcelRequire("29ndf");
parcelRequire("aLh2n");
parcelRequire("6NgSV");
parcelRequire("bvUbr");
parcelRequire("aJlfI");
parcelRequire("5Ix9X");
parcelRequire("lfHxi");
parcelRequire("cq7hn");
parcelRequire("g3GaX");
parcelRequire("6Sq6s");
parcelRequire("bkYLR");
parcelRequire("kCiUu");
parcelRequire("83G8P");
parcelRequire("bTmaS");
parcelRequire("6WnKf");
parcelRequire("aoHZx");
parcelRequire("aLav0");
parcelRequire("7kGdk");
parcelRequire("gprCo");
parcelRequire("10upo");
parcelRequire("9YI0X");
parcelRequire("j8t3m");
parcelRequire("iX2KY");
parcelRequire("5ebva");
parcelRequire("eAYuN");
parcelRequire("dDK00");

});
parcelRegister("791gi", function(module, exports) {

});

parcelRegister("gvsTn", function(module, exports) {

});

parcelRegister("k6A53", function(module, exports) {

});

parcelRegister("fEPBG", function(module, exports) {

});

parcelRegister("1wemO", function(module, exports) {

});

parcelRegister("11amS", function(module, exports) {

});

parcelRegister("btKi4", function(module, exports) {

});

parcelRegister("g8SUB", function(module, exports) {

});

parcelRegister("lpdHR", function(module, exports) {

});

parcelRegister("3SAmM", function(module, exports) {

});

parcelRegister("hp1VP", function(module, exports) {

});

parcelRegister("hfsUj", function(module, exports) {

});

parcelRegister("6VTbg", function(module, exports) {

});

parcelRegister("96mBs", function(module, exports) {

});

parcelRegister("kaoiR", function(module, exports) {

});

parcelRegister("f0IXO", function(module, exports) {

});

parcelRegister("jCPgy", function(module, exports) {

});

parcelRegister("eX3oG", function(module, exports) {

});

parcelRegister("j9dmG", function(module, exports) {

});

parcelRegister("a0Hx4", function(module, exports) {

});

parcelRegister("61ZHN", function(module, exports) {

});

parcelRegister("impIQ", function(module, exports) {

});

parcelRegister("lfrwz", function(module, exports) {

});

parcelRegister("br94n", function(module, exports) {

});

parcelRegister("grpxv", function(module, exports) {

});

parcelRegister("2nAFm", function(module, exports) {

});

parcelRegister("g7KlD", function(module, exports) {

});

parcelRegister("kl62H", function(module, exports) {

});

parcelRegister("j3Qs2", function(module, exports) {

});

parcelRegister("jDMaU", function(module, exports) {

});

parcelRegister("cNRKE", function(module, exports) {

});

parcelRegister("6efuq", function(module, exports) {

});

parcelRegister("c7Jof", function(module, exports) {

});

parcelRegister("9iWCF", function(module, exports) {

});

parcelRegister("8Og6p", function(module, exports) {

});

parcelRegister("lBLkV", function(module, exports) {

});

parcelRegister("9DpSp", function(module, exports) {

});

parcelRegister("aCADn", function(module, exports) {

});

parcelRegister("6ESi7", function(module, exports) {

});

parcelRegister("d6v7B", function(module, exports) {

});

parcelRegister("8plOH", function(module, exports) {

});

parcelRegister("iooVr", function(module, exports) {

});

parcelRegister("8dSK8", function(module, exports) {

});

parcelRegister("d65ZP", function(module, exports) {

});

parcelRegister("fAZWm", function(module, exports) {

});

parcelRegister("jplrx", function(module, exports) {

});

parcelRegister("8ZL0K", function(module, exports) {

});

parcelRegister("l4sdt", function(module, exports) {

});

parcelRegister("3YqXA", function(module, exports) {

});

parcelRegister("jqJoL", function(module, exports) {

});

parcelRegister("7iYPP", function(module, exports) {

});

parcelRegister("h9xcq", function(module, exports) {

});

parcelRegister("1u70n", function(module, exports) {

});

parcelRegister("27UOe", function(module, exports) {

});

parcelRegister("aQauT", function(module, exports) {

});

parcelRegister("9ko3Q", function(module, exports) {

});

parcelRegister("3Y2vd", function(module, exports) {

});

parcelRegister("bi4Yr", function(module, exports) {

});

parcelRegister("kw3Ag", function(module, exports) {

});

parcelRegister("8wwkl", function(module, exports) {

});

parcelRegister("iC8PD", function(module, exports) {

});

parcelRegister("gOnrP", function(module, exports) {

});

parcelRegister("fTO4M", function(module, exports) {

});

parcelRegister("jzXT0", function(module, exports) {

});

parcelRegister("jJnJz", function(module, exports) {

});

parcelRegister("7kEJg", function(module, exports) {

});

parcelRegister("fnMol", function(module, exports) {

});

parcelRegister("fqwuE", function(module, exports) {

});

parcelRegister("jFCzi", function(module, exports) {

});

parcelRegister("khuL4", function(module, exports) {

});

parcelRegister("bK2y5", function(module, exports) {

});

parcelRegister("7MFFc", function(module, exports) {

});

parcelRegister("9L2XS", function(module, exports) {

});

parcelRegister("29ndf", function(module, exports) {

});

parcelRegister("aLh2n", function(module, exports) {

});

parcelRegister("6NgSV", function(module, exports) {

});

parcelRegister("bvUbr", function(module, exports) {

});

parcelRegister("aJlfI", function(module, exports) {

});

parcelRegister("5Ix9X", function(module, exports) {

});

parcelRegister("lfHxi", function(module, exports) {

});

parcelRegister("cq7hn", function(module, exports) {

});

parcelRegister("g3GaX", function(module, exports) {

});

parcelRegister("6Sq6s", function(module, exports) {

});

parcelRegister("bkYLR", function(module, exports) {

});

parcelRegister("kCiUu", function(module, exports) {

});

parcelRegister("83G8P", function(module, exports) {

});

parcelRegister("bTmaS", function(module, exports) {

});

parcelRegister("6WnKf", function(module, exports) {

});

parcelRegister("aoHZx", function(module, exports) {

});

parcelRegister("aLav0", function(module, exports) {

});

parcelRegister("7kGdk", function(module, exports) {

});

parcelRegister("gprCo", function(module, exports) {

});

parcelRegister("10upo", function(module, exports) {

});

parcelRegister("9YI0X", function(module, exports) {

});

parcelRegister("j8t3m", function(module, exports) {

});

parcelRegister("iX2KY", function(module, exports) {

});

parcelRegister("5ebva", function(module, exports) {

});

parcelRegister("eAYuN", function(module, exports) {

});

parcelRegister("dDK00", function(module, exports) {

});



parcelRegister("9ucXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e80f854843f9878$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $2gXdT = parcelRequire("2gXdT");
const $6e80f854843f9878$export$2e2bcd8739ae039 = (t)=>{
    const i = t.id ?? "tsparticles";
    return (0, $8NFma.useEffect)(()=>{
        let e;
        return (0, $2gXdT.tsParticles).load({
            id: i,
            url: t.url,
            options: t.options
        }).then((l)=>{
            var a;
            e = l, (a = t.particlesLoaded) == null || a.call(t, l);
        }), ()=>{
            e == null || e.destroy();
        };
    }, [
        i,
        t,
        t.url,
        t.options
    ]), /* @__PURE__ */ (0, $1IdZj.jsx)("div", {
        id: i,
        className: t.className
    });
};

});


parcelRegister("87IXO", function(module, exports) {

$parcel$export(module.exports, "CountdownButton", () => $5ea1db0ca4e8357e$export$9102eb354f72d4f2);
$parcel$export(module.exports, "default", () => $5ea1db0ca4e8357e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PrimaryButton", () => $5ea1db0ca4e8357e$export$ac16a6a04d9b7c84);
$parcel$export(module.exports, "TertiaryButton", () => $5ea1db0ca4e8357e$export$3a30621a8b0c1490);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");
function $5ea1db0ca4e8357e$export$9102eb354f72d4f2(props) {
    const durationInMilliseconds = props.duration * 1000; // Convert seconds to milliseconds
    const interval = 50; // Update every 50ms
    const [remainingTime, setRemainingTime] = (0, $8NFma.useState)(durationInMilliseconds);
    const degree = Math.round(360 / durationInMilliseconds * remainingTime);
    const remainingTimeInSeconds = Math.ceil(remainingTime / 1000);
    (0, $8NFma.useEffect)(()=>{
        let timer;
        if (remainingTime > 0) timer = setInterval(()=>{
            setRemainingTime((prevTime)=>{
                if (prevTime <= 0) {
                    clearInterval(timer);
                    return 0;
                }
                return prevTime - interval;
            });
        }, interval);
        return ()=>clearInterval(timer);
    }, []);
    (0, $8NFma.useEffect)(()=>{
        if (remainingTime <= 0) props.onClick?.();
    }, [
        remainingTime
    ]);
    const onCountdownButtonClick = ()=>setRemainingTime(0);
    return remainingTime > 0 ? /*#__PURE__*/ (0, $1IdZj.jsxs)($5ea1db0ca4e8357e$export$2e2bcd8739ae039, {
        ...props,
        primary: true,
        hasCountdown: true,
        onClick: onCountdownButtonClick,
        children: [
            props.children,
            /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                style: {
                    '--progress': `${degree}deg`
                },
                children: [
                    remainingTimeInSeconds,
                    "s"
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $1IdZj.jsx)($5ea1db0ca4e8357e$export$4ec83e90d030b2f3, {
        ...props,
        primary: true,
        loading: true
    });
}
function $5ea1db0ca4e8357e$export$4ec83e90d030b2f3(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)($5ea1db0ca4e8357e$export$2e2bcd8739ae039, {
        ...props,
        hasLoader: true
    });
}
function $5ea1db0ca4e8357e$export$ac16a6a04d9b7c84(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)($5ea1db0ca4e8357e$export$2e2bcd8739ae039, {
        ...props,
        primary: true
    });
}
function $5ea1db0ca4e8357e$export$3a30621a8b0c1490(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)($5ea1db0ca4e8357e$export$2e2bcd8739ae039, {
        ...props,
        tertiary: true
    });
}
function $5ea1db0ca4e8357e$export$2e2bcd8739ae039({ children: children, disabled: disabled = false, hasCountdown: hasCountdown = false, hasLoader: hasLoader = false, id: id = '', loading: loading = false, onClick: onClick, primary: primary = false, specifier: specifier = '', sso: sso = false, ssoId: ssoId = '', tertiary: tertiary = false, testId: testId = '' }) {
    const props = {
        disabled: disabled,
        onClick: onClick
    };
    const classes = [
        'btn'
    ];
    primary && classes.push('btn--primary');
    tertiary && classes.push('btn--tertiary');
    specifier && classes.push(`btn--${specifier}`);
    hasCountdown && classes.push('btn--countdown');
    hasLoader && classes.push('btn--loader');
    loading && classes.push('btn--loading');
    // Handle SSO-specific classes
    if (sso) {
        classes.push('btn--sso');
        if (ssoId) classes.push(`btn--sso--${ssoId}`);
    }
    props.className = classes.join(' ');
    if (id) props.id = id;
    if (testId) props['data-testid'] = testId;
    return /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
        ...props,
        children: hasLoader ? /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
            children: children
        }) : children
    });
}
$5ea1db0ca4e8357e$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node.isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    hasCountdown: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    hasLoader: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    primary: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    specifier: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    sso: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    ssoId: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    tertiary: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    testId: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};
$5ea1db0ca4e8357e$export$9102eb354f72d4f2.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node.isRequired,
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};

});

parcelRegister("geZyD", function(module, exports) {

$parcel$export(module.exports, "useCustomization", () => $bd2db43c315cee86$export$79de36986ccf0c81);

var $8NFma = parcelRequire("8NFma");
const $bd2db43c315cee86$export$79de36986ccf0c81 = ({ data: data, onCompleteCustomization: onCompleteCustomization })=>{
    const totalSteps = 3;
    const [skipped, setSkipped] = (0, $8NFma.useState)(false);
    const [step, setStep] = (0, $8NFma.useState)(0);
    const [selection, setSelection] = (0, $8NFma.useState)(()=>{
        return [
            {
                value: data.options[0].goal_id,
                label: data.options[0].goal_name
            },
            {
                value: data.options[0].roles[0].role_id,
                label: data.options[0].roles[0].role_name
            }
        ];
    });
    const [customizationOptions, setCustomizationOptions] = (0, $8NFma.useState)([]);
    // Initialize customization options based on the current step
    (0, $8NFma.useEffect)(()=>{
        if (0 === step) setCustomizationOptions(()=>data.options.reduce((acc, option)=>{
                acc.push({
                    id: option.goal_id,
                    name: option.goal_name
                });
                return acc;
            }, []));
        else setCustomizationOptions(()=>{
            const goalData = data.options.find((option)=>option.goal_id === selection[0].value);
            return goalData.roles.reduce((acc, role)=>{
                acc.push({
                    id: role.role_id,
                    name: role.role_name
                });
                return acc;
            }, []);
        });
    }, [
        step
    ]);
    const onChangeOption = (e)=>{
        const { value: value } = e.target;
        const newSelection = [
            ...selection
        ];
        let selectionLabel = '';
        if (value !== 'custom') selectionLabel = customizationOptions.find((option)=>option.id === value)?.name || '';
        newSelection[step] = {
            value: value,
            label: selectionLabel
        };
        // If on the first step, reset the second step selection
        if (step === 0) {
            const goal = data.options.find((option)=>option.goal_id === value);
            newSelection[1] = {
                value: goal.roles[0].role_id,
                label: goal.roles[0].role_name
            };
        }
        setSelection(newSelection);
    };
    const onCustomInputChange = (e)=>{
        const { value: value } = e.target;
        const newSelection = [
            ...selection
        ];
        newSelection[step].label = value;
        setSelection(newSelection);
    };
    const goToNextStep = ()=>{
        setStep((prevStep)=>prevStep + 1);
    };
    const goToPreviousStep = ()=>{
        setSkipped(false);
        setStep((prevStep)=>Math.max(prevStep - 1, 0));
    };
    const goToFirstStep = ()=>{
        setSkipped(false);
        setStep(0);
    };
    const finishCustomization = ()=>{
        let trialTemplate = data.default_trial_template;
        if (!skipped) trialTemplate = data.options.find((option)=>option.goal_id === selection[0].value).trial_template;
        onCompleteCustomization({
            selection: selection,
            skipped: skipped,
            trialTemplate: trialTemplate
        });
    };
    const skipCustomization = ()=>{
        setStep(totalSteps - 1);
        setSkipped(true);
    };
    return {
        customizationOptions: customizationOptions,
        finishCustomization: finishCustomization,
        goToFirstStep: goToFirstStep,
        goToNextStep: goToNextStep,
        goToPreviousStep: goToPreviousStep,
        onChangeOption: onChangeOption,
        onCustomInputChange: onCustomInputChange,
        selection: selection,
        skipCustomization: skipCustomization,
        step: step,
        totalSteps: totalSteps
    };
};

});

parcelRegister("f8BWH", function(module, exports) {

$parcel$export(module.exports, "useParticles", () => $b055099841ab7275$export$81073d529bbe4dc7);

var $3SKVR = parcelRequire("3SKVR");

var $20KBz = parcelRequire("20KBz");

var $8NFma = parcelRequire("8NFma");
const $b055099841ab7275$export$81073d529bbe4dc7 = (step)=>{
    const [showParticles, setShowParticles] = (0, $8NFma.useState)(false);
    const particlesContainerRef = (0, $8NFma.useRef)();
    const particlesLoaded = async (container)=>{
        particlesContainerRef.current = container;
        // Create a new interval to check the particles count
        // If there are no particles left, stop the interval and hide the particles
        const interval = setInterval(()=>{
            if (container._lifeTime > 0 && container.particles.count === 0) {
                clearInterval(interval);
                setShowParticles(false);
            }
        }, 100);
    };
    (0, $8NFma.useEffect)(()=>{
        if (step < 2) return;
        (0, $20KBz.initParticlesEngine)(async (engine)=>{
            await (0, $3SKVR.loadConfettiPreset)(engine);
        }).then(()=>{
            setShowParticles(true);
        });
    }, [
        step
    ]);
    const emitterOptions = {
        life: {
            count: 1,
            duration: 0.1
        },
        rate: {
            quantity: 80
        },
        particles: {
            color: [
                '#5053c4',
                '#B749D1',
                '#FFD662',
                '#4FF2D1'
            ],
            shape: {
                type: 'edge'
            },
            move: {
                direction: 'top'
            },
            size: {
                value: {
                    min: 5,
                    max: 10
                }
            },
            life: {
                count: 1,
                duration: {
                    value: 10
                }
            }
        }
    };
    const particleOptions = {
        emitters: [
            {
                ...emitterOptions,
                position: {
                    x: 25,
                    y: 50
                }
            },
            {
                ...emitterOptions,
                position: {
                    x: 50,
                    y: 50
                }
            },
            {
                ...emitterOptions,
                position: {
                    x: 75,
                    y: 50
                }
            }
        ],
        style: {
            position: 'absolute',
            inset: 0
        },
        preset: 'confetti'
    };
    return {
        showParticles: showParticles,
        particleOptions: particleOptions,
        particlesLoaded: particlesLoaded
    };
};

});
parcelRegister("3SKVR", function(module, exports) {

$parcel$export(module.exports, "loadConfettiPreset", () => $2d3ad200032462c9$export$28df3cd222379ac9);

var $6m9XL = parcelRequire("6m9XL");

var $6aHhL = parcelRequire("6aHhL");

var $cDQR8 = parcelRequire("cDQR8");

var $e3Q5c = parcelRequire("e3Q5c");

var $hPJ5x = parcelRequire("hPJ5x");

var $ajosq = parcelRequire("ajosq");

var $iAcwt = parcelRequire("iAcwt");

var $2BVbp = parcelRequire("2BVbp");

var $l9m4Q = parcelRequire("l9m4Q");

var $d1DI1 = parcelRequire("d1DI1");
async function $2d3ad200032462c9$var$loadPreset(engine, refresh = true) {
    await (0, $6m9XL.loadBasic)(engine, false);
    await (0, $iAcwt.loadSquareShape)(engine, false);
    await (0, $6aHhL.loadEmittersPlugin)(engine, false);
    await (0, $e3Q5c.loadMotionPlugin)(engine, false);
    await (0, $l9m4Q.loadWobbleUpdater)(engine, false);
    await (0, $hPJ5x.loadRollUpdater)(engine, false);
    await (0, $ajosq.loadRotateUpdater)(engine, false);
    await (0, $2BVbp.loadTiltUpdater)(engine, false);
    await (0, $cDQR8.loadLifeUpdater)(engine, false);
    await engine.addPreset("confetti", (0, $d1DI1.options), false);
    await engine.refresh(refresh);
}
async function $2d3ad200032462c9$export$28df3cd222379ac9(engine) {
    await $2d3ad200032462c9$var$loadPreset(engine);
}

});
parcelRegister("6m9XL", function(module, exports) {

$parcel$export(module.exports, "loadBasic", () => $4a0c869742107a43$export$244419993531723b);

var $kUNIo = parcelRequire("kUNIo");

var $9fMHg = parcelRequire("9fMHg");

var $dZMtR = parcelRequire("dZMtR");

var $5TiSq = parcelRequire("5TiSq");

var $b32Er = parcelRequire("b32Er");

var $9AkCf = parcelRequire("9AkCf");

var $f6e2Q = parcelRequire("f6e2Q");

var $17V36 = parcelRequire("17V36");

var $7F0uX = parcelRequire("7F0uX");
async function $4a0c869742107a43$export$244419993531723b(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await (0, $5TiSq.loadHexColorPlugin)(engine, false);
    await (0, $b32Er.loadHslColorPlugin)(engine, false);
    await (0, $17V36.loadRgbColorPlugin)(engine, false);
    await (0, $kUNIo.loadBaseMover)(engine, false);
    await (0, $9fMHg.loadCircleShape)(engine, false);
    await (0, $dZMtR.loadColorUpdater)(engine, false);
    await (0, $9AkCf.loadOpacityUpdater)(engine, false);
    await (0, $f6e2Q.loadOutModesUpdater)(engine, false);
    await (0, $7F0uX.loadSizeUpdater)(engine, false);
    await engine.refresh(refresh);
}

});
parcelRegister("kUNIo", function(module, exports) {

$parcel$export(module.exports, "loadBaseMover", () => $f39f99ff16125405$export$8949951fd9df9397);

var $2TyCE = parcelRequire("2TyCE");
async function $f39f99ff16125405$export$8949951fd9df9397(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addMover("base", ()=>{
        return Promise.resolve(new (0, $2TyCE.BaseMover)());
    }, refresh);
}

});
parcelRegister("2TyCE", function(module, exports) {

$parcel$export(module.exports, "BaseMover", () => $21bb9321886278d9$export$c506fa331d75adff);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");

var $iMZve = parcelRequire("iMZve");
const $21bb9321886278d9$var$diffFactor = 2, $21bb9321886278d9$var$defaultSizeFactor = 1, $21bb9321886278d9$var$defaultDeltaFactor = 1;
class $21bb9321886278d9$export$c506fa331d75adff {
    init(particle) {
        const options = particle.options, gravityOptions = options.move.gravity;
        particle.gravity = {
            enable: gravityOptions.enable,
            acceleration: (0, $yZzCW.getRangeValue)(gravityOptions.acceleration),
            inverse: gravityOptions.inverse
        };
        (0, $iMZve.initSpin)(particle);
    }
    isEnabled(particle) {
        return !particle.destroyed && particle.options.move.enable;
    }
    move(particle, delta) {
        const particleOptions = particle.options, moveOptions = particleOptions.move;
        if (!moveOptions.enable) return;
        const container = particle.container, pxRatio = container.retina.pixelRatio;
        particle.retina.moveSpeed ??= (0, $yZzCW.getRangeValue)(moveOptions.speed) * pxRatio;
        particle.retina.moveDrift ??= (0, $yZzCW.getRangeValue)(particle.options.move.drift) * pxRatio;
        const slowFactor = (0, $iMZve.getProximitySpeedFactor)(particle), baseSpeed = particle.retina.moveSpeed * container.retina.reduceFactor, moveDrift = particle.retina.moveDrift, maxSize = (0, $yZzCW.getRangeMax)(particleOptions.size.value) * pxRatio, sizeFactor = moveOptions.size ? particle.getRadius() / maxSize : $21bb9321886278d9$var$defaultSizeFactor, deltaFactor = delta.factor || $21bb9321886278d9$var$defaultDeltaFactor, moveSpeed = baseSpeed * sizeFactor * slowFactor * deltaFactor / $21bb9321886278d9$var$diffFactor, maxSpeed = particle.retina.maxSpeed ?? container.retina.maxSpeed;
        if (moveOptions.spin.enable) (0, $iMZve.spin)(particle, moveSpeed);
        else (0, $iMZve.move)(particle, moveOptions, moveSpeed, maxSpeed, moveDrift, delta);
        (0, $iMZve.applyDistance)(particle);
    }
}

});
parcelRegister("iMZve", function(module, exports) {

$parcel$export(module.exports, "applyDistance", () => $dadc6ad8e87be9ed$export$21d7e305c937fbb2);
$parcel$export(module.exports, "move", () => $dadc6ad8e87be9ed$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "spin", () => $dadc6ad8e87be9ed$export$c82e186cf428d56d);
$parcel$export(module.exports, "getProximitySpeedFactor", () => $dadc6ad8e87be9ed$export$7f3cc12c83994316);
$parcel$export(module.exports, "initSpin", () => $dadc6ad8e87be9ed$export$2d310d1fc5fad1a1);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $WiXRo = parcelRequire("WiXRo");
const $dadc6ad8e87be9ed$var$half = 0.5, $dadc6ad8e87be9ed$var$double = 2, $dadc6ad8e87be9ed$var$minVelocity = 0, $dadc6ad8e87be9ed$var$identity = 1, $dadc6ad8e87be9ed$var$moveSpeedFactor = 60, $dadc6ad8e87be9ed$var$minSpinRadius = 0, $dadc6ad8e87be9ed$var$spinFactor = 0.01, $dadc6ad8e87be9ed$var$doublePI = Math.PI * $dadc6ad8e87be9ed$var$double;
function $dadc6ad8e87be9ed$export$21d7e305c937fbb2(particle) {
    const initialPosition = particle.initialPosition, { dx: dx, dy: dy } = (0, $yZzCW.getDistances)(initialPosition, particle.position), dxFixed = Math.abs(dx), dyFixed = Math.abs(dy), { maxDistance: maxDistance } = particle.retina, hDistance = maxDistance.horizontal, vDistance = maxDistance.vertical;
    if (!hDistance && !vDistance) return;
    const hasHDistance = (hDistance && dxFixed >= hDistance) ?? false, hasVDistance = (vDistance && dyFixed >= vDistance) ?? false;
    if ((hasHDistance || hasVDistance) && !particle.misplaced) {
        particle.misplaced = !!hDistance && dxFixed > hDistance || !!vDistance && dyFixed > vDistance;
        if (hDistance) particle.velocity.x = particle.velocity.y * $dadc6ad8e87be9ed$var$half - particle.velocity.x;
        if (vDistance) particle.velocity.y = particle.velocity.x * $dadc6ad8e87be9ed$var$half - particle.velocity.y;
    } else if ((!hDistance || dxFixed < hDistance) && (!vDistance || dyFixed < vDistance) && particle.misplaced) particle.misplaced = false;
    else if (particle.misplaced) {
        const pos = particle.position, vel = particle.velocity;
        if (hDistance && (pos.x < initialPosition.x && vel.x < $dadc6ad8e87be9ed$var$minVelocity || pos.x > initialPosition.x && vel.x > $dadc6ad8e87be9ed$var$minVelocity)) vel.x *= -(0, $yZzCW.getRandom)();
        if (vDistance && (pos.y < initialPosition.y && vel.y < $dadc6ad8e87be9ed$var$minVelocity || pos.y > initialPosition.y && vel.y > $dadc6ad8e87be9ed$var$minVelocity)) vel.y *= -(0, $yZzCW.getRandom)();
    }
}
function $dadc6ad8e87be9ed$export$d947e5f4f4c48d48(particle, moveOptions, moveSpeed, maxSpeed, moveDrift, delta) {
    $dadc6ad8e87be9ed$export$2d1dd1364a451835(particle, delta);
    const gravityOptions = particle.gravity, gravityFactor = gravityOptions?.enable && gravityOptions.inverse ? -$dadc6ad8e87be9ed$var$identity : $dadc6ad8e87be9ed$var$identity;
    if (moveDrift && moveSpeed) particle.velocity.x += moveDrift * delta.factor / ($dadc6ad8e87be9ed$var$moveSpeedFactor * moveSpeed);
    if (gravityOptions?.enable && moveSpeed) particle.velocity.y += gravityFactor * (gravityOptions.acceleration * delta.factor) / ($dadc6ad8e87be9ed$var$moveSpeedFactor * moveSpeed);
    const decay = particle.moveDecay;
    particle.velocity.multTo(decay);
    const velocity = particle.velocity.mult(moveSpeed);
    if (gravityOptions?.enable && maxSpeed > $dadc6ad8e87be9ed$var$minVelocity && (!gravityOptions.inverse && velocity.y >= $dadc6ad8e87be9ed$var$minVelocity && velocity.y >= maxSpeed || gravityOptions.inverse && velocity.y <= $dadc6ad8e87be9ed$var$minVelocity && velocity.y <= -maxSpeed)) {
        velocity.y = gravityFactor * maxSpeed;
        if (moveSpeed) particle.velocity.y = velocity.y / moveSpeed;
    }
    const zIndexOptions = particle.options.zIndex, zVelocityFactor = ($dadc6ad8e87be9ed$var$identity - particle.zIndexFactor) ** zIndexOptions.velocityRate;
    velocity.multTo(zVelocityFactor);
    const { position: position } = particle;
    position.addTo(velocity);
    if (moveOptions.vibrate) {
        position.x += Math.sin(position.x * Math.cos(position.y));
        position.y += Math.cos(position.y * Math.sin(position.x));
    }
}
function $dadc6ad8e87be9ed$export$c82e186cf428d56d(particle, moveSpeed) {
    const container = particle.container;
    if (!particle.spin) return;
    const spinClockwise = particle.spin.direction === (0, $WiXRo.RotateDirection).clockwise, updateFunc = {
        x: spinClockwise ? Math.cos : Math.sin,
        y: spinClockwise ? Math.sin : Math.cos
    };
    particle.position.x = particle.spin.center.x + particle.spin.radius * updateFunc.x(particle.spin.angle);
    particle.position.y = particle.spin.center.y + particle.spin.radius * updateFunc.y(particle.spin.angle);
    particle.spin.radius += particle.spin.acceleration;
    const maxCanvasSize = Math.max(container.canvas.size.width, container.canvas.size.height), halfMaxSize = maxCanvasSize * $dadc6ad8e87be9ed$var$half;
    if (particle.spin.radius > halfMaxSize) {
        particle.spin.radius = halfMaxSize;
        particle.spin.acceleration *= -$dadc6ad8e87be9ed$var$identity;
    } else if (particle.spin.radius < $dadc6ad8e87be9ed$var$minSpinRadius) {
        particle.spin.radius = $dadc6ad8e87be9ed$var$minSpinRadius;
        particle.spin.acceleration *= -$dadc6ad8e87be9ed$var$identity;
    }
    particle.spin.angle += moveSpeed * $dadc6ad8e87be9ed$var$spinFactor * ($dadc6ad8e87be9ed$var$identity - particle.spin.radius / maxCanvasSize);
}
function $dadc6ad8e87be9ed$export$2d1dd1364a451835(particle, delta) {
    const particlesOptions = particle.options, pathOptions = particlesOptions.move.path, pathEnabled = pathOptions.enable;
    if (!pathEnabled) return;
    if (particle.lastPathTime <= particle.pathDelay) {
        particle.lastPathTime += delta.value;
        return;
    }
    const path = particle.pathGenerator?.generate(particle, delta);
    if (path) particle.velocity.addTo(path);
    if (pathOptions.clamp) {
        particle.velocity.x = (0, $yZzCW.clamp)(particle.velocity.x, -$dadc6ad8e87be9ed$var$identity, $dadc6ad8e87be9ed$var$identity);
        particle.velocity.y = (0, $yZzCW.clamp)(particle.velocity.y, -$dadc6ad8e87be9ed$var$identity, $dadc6ad8e87be9ed$var$identity);
    }
    particle.lastPathTime -= particle.pathDelay;
}
function $dadc6ad8e87be9ed$export$7f3cc12c83994316(particle) {
    return particle.slow.inRange ? particle.slow.factor : $dadc6ad8e87be9ed$var$identity;
}
function $dadc6ad8e87be9ed$export$2d310d1fc5fad1a1(particle) {
    const container = particle.container, options = particle.options, spinOptions = options.move.spin;
    if (!spinOptions.enable) return;
    const spinPos = spinOptions.position ?? {
        x: 50,
        y: 50
    }, spinFactor = 0.01, spinCenter = {
        x: spinPos.x * spinFactor * container.canvas.size.width,
        y: spinPos.y * spinFactor * container.canvas.size.height
    }, pos = particle.getPosition(), distance = (0, $yZzCW.getDistance)(pos, spinCenter), spinAcceleration = (0, $yZzCW.getRangeValue)(spinOptions.acceleration);
    particle.retina.spinAcceleration = spinAcceleration * container.retina.pixelRatio;
    particle.spin = {
        center: spinCenter,
        direction: particle.velocity.x >= $dadc6ad8e87be9ed$var$minVelocity ? (0, $WiXRo.RotateDirection).clockwise : (0, $WiXRo.RotateDirection).counterClockwise,
        angle: (0, $yZzCW.getRandom)() * $dadc6ad8e87be9ed$var$doublePI,
        radius: distance,
        acceleration: particle.retina.spinAcceleration
    };
}

});



parcelRegister("9fMHg", function(module, exports) {

$parcel$export(module.exports, "loadCircleShape", () => $6bcb49f41b02d257$export$66237f65cef19277);

var $3wtTw = parcelRequire("3wtTw");
async function $6bcb49f41b02d257$export$66237f65cef19277(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addShape(new (0, $3wtTw.CircleDrawer)(), refresh);
}

});
parcelRegister("3wtTw", function(module, exports) {

$parcel$export(module.exports, "CircleDrawer", () => $290b8cac2f434aba$export$b29a4fa100f54972);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $62pjT = parcelRequire("62pjT");

var $kXQJQ = parcelRequire("kXQJQ");
const $290b8cac2f434aba$var$sides = 12, $290b8cac2f434aba$var$maxAngle = 360, $290b8cac2f434aba$var$minAngle = 0;
class $290b8cac2f434aba$export$b29a4fa100f54972 {
    constructor(){
        this.validTypes = [
            "circle"
        ];
    }
    draw(data) {
        (0, $kXQJQ.drawCircle)(data);
    }
    getSidesCount() {
        return $290b8cac2f434aba$var$sides;
    }
    particleInit(container, particle) {
        const shapeData = particle.shapeData, angle = shapeData?.angle ?? {
            max: $290b8cac2f434aba$var$maxAngle,
            min: $290b8cac2f434aba$var$minAngle
        };
        particle.circleRange = !(0, $62pjT.isObject)(angle) ? {
            min: $290b8cac2f434aba$var$minAngle,
            max: (0, $yZzCW.degToRad)(angle)
        } : {
            min: (0, $yZzCW.degToRad)(angle.min),
            max: (0, $yZzCW.degToRad)(angle.max)
        };
    }
}

});
parcelRegister("kXQJQ", function(module, exports) {

$parcel$export(module.exports, "drawCircle", () => $f4323a13a75e7d2a$export$8daab6f91f7ff730);
const $f4323a13a75e7d2a$var$double = 2, $f4323a13a75e7d2a$var$doublePI = Math.PI * $f4323a13a75e7d2a$var$double, $f4323a13a75e7d2a$var$minAngle = 0, $f4323a13a75e7d2a$var$origin = {
    x: 0,
    y: 0
};
function $f4323a13a75e7d2a$export$8daab6f91f7ff730(data) {
    const { context: context, particle: particle, radius: radius } = data;
    if (!particle.circleRange) particle.circleRange = {
        min: $f4323a13a75e7d2a$var$minAngle,
        max: $f4323a13a75e7d2a$var$doublePI
    };
    const circleRange = particle.circleRange;
    context.arc($f4323a13a75e7d2a$var$origin.x, $f4323a13a75e7d2a$var$origin.y, radius, circleRange.min, circleRange.max, false);
}

});



parcelRegister("dZMtR", function(module, exports) {

$parcel$export(module.exports, "loadColorUpdater", () => $a306941cea6277d4$export$bfdad36561fbf902);

var $4GgOB = parcelRequire("4GgOB");
async function $a306941cea6277d4$export$bfdad36561fbf902(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("color", (container)=>{
        return Promise.resolve(new (0, $4GgOB.ColorUpdater)(container, engine));
    }, refresh);
}

});
parcelRegister("4GgOB", function(module, exports) {

$parcel$export(module.exports, "ColorUpdater", () => $368820d31e0c29b9$export$c36bb5e4d505f205);
parcelRequire("2gXdT");
var $6nx5m = parcelRequire("6nx5m");
class $368820d31e0c29b9$export$c36bb5e4d505f205 {
    constructor(container, engine){
        this._container = container;
        this._engine = engine;
    }
    init(particle) {
        const hslColor = (0, $6nx5m.rangeColorToHsl)(this._engine, particle.options.color, particle.id, particle.options.reduceDuplicates);
        if (hslColor) particle.color = (0, $6nx5m.getHslAnimationFromHsl)(hslColor, particle.options.color.animation, this._container.retina.reduceFactor);
    }
    isEnabled(particle) {
        const { h: hAnimation, s: sAnimation, l: lAnimation } = particle.options.color.animation, { color: color } = particle;
        return !particle.destroyed && !particle.spawning && (color?.h.value !== undefined && hAnimation.enable || color?.s.value !== undefined && sAnimation.enable || color?.l.value !== undefined && lAnimation.enable);
    }
    update(particle, delta) {
        (0, $6nx5m.updateColor)(particle.color, delta);
    }
}

});


parcelRegister("5TiSq", function(module, exports) {

$parcel$export(module.exports, "loadHexColorPlugin", () => $44a0bb5bfad4a1bf$export$4e9944983d13c81);

var $4gqMj = parcelRequire("4gqMj");
async function $44a0bb5bfad4a1bf$export$4e9944983d13c81(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addColorManager(new (0, $4gqMj.HexColorManager)(), refresh);
}

});
parcelRegister("4gqMj", function(module, exports) {

$parcel$export(module.exports, "HexColorManager", () => $31ad6da8a059b017$export$c206b24acb5772ee);
var $31ad6da8a059b017$var$RgbIndexes;
(function(RgbIndexes) {
    RgbIndexes[RgbIndexes["r"] = 1] = "r";
    RgbIndexes[RgbIndexes["g"] = 2] = "g";
    RgbIndexes[RgbIndexes["b"] = 3] = "b";
    RgbIndexes[RgbIndexes["a"] = 4] = "a";
})($31ad6da8a059b017$var$RgbIndexes || ($31ad6da8a059b017$var$RgbIndexes = {}));
const $31ad6da8a059b017$var$shorthandHexRegex = /^#?([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, $31ad6da8a059b017$var$hexRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, $31ad6da8a059b017$var$hexRadix = 16, $31ad6da8a059b017$var$defaultAlpha = 1, $31ad6da8a059b017$var$alphaFactor = 0xff;
class $31ad6da8a059b017$export$c206b24acb5772ee {
    constructor(){
        this.key = "hex";
        this.stringPrefix = "#";
    }
    handleColor(color) {
        return this._parseString(color.value);
    }
    handleRangeColor(color) {
        return this._parseString(color.value);
    }
    parseString(input) {
        return this._parseString(input);
    }
    _parseString(hexColor) {
        if (typeof hexColor !== "string") return;
        if (!hexColor?.startsWith(this.stringPrefix)) return;
        const hexFixed = hexColor.replace($31ad6da8a059b017$var$shorthandHexRegex, (_, r, g, b, a)=>{
            return r + r + g + g + b + b + (a !== undefined ? a + a : "");
        }), result = $31ad6da8a059b017$var$hexRegex.exec(hexFixed);
        return result ? {
            a: result[$31ad6da8a059b017$var$RgbIndexes.a] !== undefined ? parseInt(result[$31ad6da8a059b017$var$RgbIndexes.a], $31ad6da8a059b017$var$hexRadix) / $31ad6da8a059b017$var$alphaFactor : $31ad6da8a059b017$var$defaultAlpha,
            b: parseInt(result[$31ad6da8a059b017$var$RgbIndexes.b], $31ad6da8a059b017$var$hexRadix),
            g: parseInt(result[$31ad6da8a059b017$var$RgbIndexes.g], $31ad6da8a059b017$var$hexRadix),
            r: parseInt(result[$31ad6da8a059b017$var$RgbIndexes.r], $31ad6da8a059b017$var$hexRadix)
        } : undefined;
    }
}

});


parcelRegister("b32Er", function(module, exports) {

$parcel$export(module.exports, "loadHslColorPlugin", () => $80b20801b77e6267$export$5f46fff9284a5478);

var $d2GbN = parcelRequire("d2GbN");
async function $80b20801b77e6267$export$5f46fff9284a5478(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addColorManager(new (0, $d2GbN.HslColorManager)(), refresh);
}

});
parcelRegister("d2GbN", function(module, exports) {

$parcel$export(module.exports, "HslColorManager", () => $97ec30277838c556$export$a0d665b8e8138206);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $6nx5m = parcelRequire("6nx5m");
var $97ec30277838c556$var$HslIndexes;
(function(HslIndexes) {
    HslIndexes[HslIndexes["h"] = 1] = "h";
    HslIndexes[HslIndexes["s"] = 2] = "s";
    HslIndexes[HslIndexes["l"] = 3] = "l";
    HslIndexes[HslIndexes["a"] = 5] = "a";
})($97ec30277838c556$var$HslIndexes || ($97ec30277838c556$var$HslIndexes = {}));
class $97ec30277838c556$export$a0d665b8e8138206 {
    constructor(){
        this.key = "hsl";
        this.stringPrefix = "hsl";
    }
    handleColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.s !== undefined && hslColor.l !== undefined) return (0, $6nx5m.hslToRgb)(hslColor);
    }
    handleRangeColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.l !== undefined) return (0, $6nx5m.hslToRgb)({
            h: (0, $yZzCW.getRangeValue)(hslColor.h),
            l: (0, $yZzCW.getRangeValue)(hslColor.l),
            s: (0, $yZzCW.getRangeValue)(hslColor.s)
        });
    }
    parseString(input) {
        if (!input.startsWith("hsl")) return;
        const regex = /hsla?\(\s*(\d+)\s*[\s,]\s*(\d+)%\s*[\s,]\s*(\d+)%\s*([\s,]\s*(0|1|0?\.\d+|(\d{1,3})%)\s*)?\)/i, result = regex.exec(input), minLength = 4, defaultAlpha = 1, radix = 10;
        return result ? (0, $6nx5m.hslaToRgba)({
            a: result.length > minLength ? (0, $yZzCW.parseAlpha)(result[$97ec30277838c556$var$HslIndexes.a]) : defaultAlpha,
            h: parseInt(result[$97ec30277838c556$var$HslIndexes.h], radix),
            l: parseInt(result[$97ec30277838c556$var$HslIndexes.l], radix),
            s: parseInt(result[$97ec30277838c556$var$HslIndexes.s], radix)
        }) : undefined;
    }
}

});


parcelRegister("9AkCf", function(module, exports) {

$parcel$export(module.exports, "loadOpacityUpdater", () => $6fa777bc91505037$export$8322e3b69c08b6eb);

var $crBjj = parcelRequire("crBjj");
async function $6fa777bc91505037$export$8322e3b69c08b6eb(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("opacity", (container)=>{
        return Promise.resolve(new (0, $crBjj.OpacityUpdater)(container));
    }, refresh);
}

});
parcelRegister("crBjj", function(module, exports) {

$parcel$export(module.exports, "OpacityUpdater", () => $90f4f2b67cfbdd3e$export$99f6686a87b9ec6f);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $eDm3t = parcelRequire("eDm3t");
var $eywbI = parcelRequire("eywbI");
class $90f4f2b67cfbdd3e$export$99f6686a87b9ec6f {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const opacityOptions = particle.options.opacity, pxRatio = 1;
        particle.opacity = (0, $eDm3t.initParticleNumericAnimationValue)(opacityOptions, pxRatio);
        const opacityAnimation = opacityOptions.animation;
        if (opacityAnimation.enable) {
            particle.opacity.velocity = (0, $yZzCW.getRangeValue)(opacityAnimation.speed) / (0, $eywbI.percentDenominator) * this.container.retina.reduceFactor;
            if (!opacityAnimation.sync) particle.opacity.velocity *= (0, $yZzCW.getRandom)();
        }
    }
    isEnabled(particle) {
        const none = 0;
        return !particle.destroyed && !particle.spawning && !!particle.opacity && particle.opacity.enable && ((particle.opacity.maxLoops ?? none) <= none || (particle.opacity.maxLoops ?? none) > none && (particle.opacity.loops ?? none) < (particle.opacity.maxLoops ?? none));
    }
    reset(particle) {
        if (particle.opacity) {
            particle.opacity.time = 0;
            particle.opacity.loops = 0;
        }
    }
    update(particle, delta) {
        if (!this.isEnabled(particle) || !particle.opacity) return;
        (0, $eDm3t.updateAnimation)(particle, particle.opacity, true, particle.options.opacity.animation.destroy, delta);
    }
}

});


parcelRegister("f6e2Q", function(module, exports) {

$parcel$export(module.exports, "loadOutModesUpdater", () => $afe24f916347211b$export$4cf4cb6464fcf0a1);

var $9siyG = parcelRequire("9siyG");
async function $afe24f916347211b$export$4cf4cb6464fcf0a1(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("outModes", (container)=>{
        return Promise.resolve(new (0, $9siyG.OutOfCanvasUpdater)(container));
    }, refresh);
}

});
parcelRegister("9siyG", function(module, exports) {

$parcel$export(module.exports, "OutOfCanvasUpdater", () => $6e251fe027054f36$export$cb0990f1117a9f95);
parcelRequire("2gXdT");
var $eBPJQ = parcelRequire("eBPJQ");
var $6VMPk = parcelRequire("6VMPk");

var $7kNLC = parcelRequire("7kNLC");

var $jSmxD = parcelRequire("jSmxD");

var $51YKe = parcelRequire("51YKe");

var $bm45C = parcelRequire("bm45C");
const $6e251fe027054f36$var$checkOutMode = (outModes, outMode)=>{
    return outModes.default === outMode || outModes.bottom === outMode || outModes.left === outMode || outModes.right === outMode || outModes.top === outMode;
};
class $6e251fe027054f36$export$cb0990f1117a9f95 {
    constructor(container){
        this._addUpdaterIfMissing = (particle, outMode, getUpdater)=>{
            const outModes = particle.options.move.outModes;
            if (!this.updaters.has(outMode) && $6e251fe027054f36$var$checkOutMode(outModes, outMode)) this.updaters.set(outMode, getUpdater(this.container));
        };
        this._updateOutMode = (particle, delta, outMode, direction)=>{
            for (const updater of this.updaters.values())updater.update(particle, direction, delta, outMode);
        };
        this.container = container;
        this.updaters = new Map();
    }
    init(particle) {
        this._addUpdaterIfMissing(particle, (0, $eBPJQ.OutMode).bounce, (container)=>new (0, $7kNLC.BounceOutMode)(container));
        this._addUpdaterIfMissing(particle, (0, $eBPJQ.OutMode).out, (container)=>new (0, $bm45C.OutOutMode)(container));
        this._addUpdaterIfMissing(particle, (0, $eBPJQ.OutMode).destroy, (container)=>new (0, $jSmxD.DestroyOutMode)(container));
        this._addUpdaterIfMissing(particle, (0, $eBPJQ.OutMode).none, (container)=>new (0, $51YKe.NoneOutMode)(container));
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning;
    }
    update(particle, delta) {
        const outModes = particle.options.move.outModes;
        this._updateOutMode(particle, delta, outModes.bottom ?? outModes.default, (0, $6VMPk.OutModeDirection).bottom);
        this._updateOutMode(particle, delta, outModes.left ?? outModes.default, (0, $6VMPk.OutModeDirection).left);
        this._updateOutMode(particle, delta, outModes.right ?? outModes.default, (0, $6VMPk.OutModeDirection).right);
        this._updateOutMode(particle, delta, outModes.top ?? outModes.default, (0, $6VMPk.OutModeDirection).top);
    }
}

});
parcelRegister("7kNLC", function(module, exports) {

$parcel$export(module.exports, "BounceOutMode", () => $5571015ccd3ce7f5$export$7a10ae135b551126);
parcelRequire("2gXdT");
var $eDm3t = parcelRequire("eDm3t");
var $eBPJQ = parcelRequire("eBPJQ");

var $anjG5 = parcelRequire("anjG5");
class $5571015ccd3ce7f5$export$7a10ae135b551126 {
    constructor(container){
        this.container = container;
        this.modes = [
            (0, $eBPJQ.OutMode).bounce,
            (0, $eBPJQ.OutMode).split
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        let handled = false;
        for (const plugin of container.plugins.values()){
            if (plugin.particleBounce !== undefined) handled = plugin.particleBounce(particle, delta, direction);
            if (handled) break;
        }
        if (handled) return;
        const pos = particle.getPosition(), offset = particle.offset, size = particle.getRadius(), bounds = (0, $eDm3t.calculateBounds)(pos, size), canvasSize = container.canvas.size;
        (0, $anjG5.bounceHorizontal)({
            particle: particle,
            outMode: outMode,
            direction: direction,
            bounds: bounds,
            canvasSize: canvasSize,
            offset: offset,
            size: size
        });
        (0, $anjG5.bounceVertical)({
            particle: particle,
            outMode: outMode,
            direction: direction,
            bounds: bounds,
            canvasSize: canvasSize,
            offset: offset,
            size: size
        });
    }
}

});
parcelRegister("anjG5", function(module, exports) {

$parcel$export(module.exports, "bounceHorizontal", () => $78db50f486aa7ca3$export$1def114a7da042cf);
$parcel$export(module.exports, "bounceVertical", () => $78db50f486aa7ca3$export$46000c44e0211bc6);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $eBPJQ = parcelRequire("eBPJQ");
var $6VMPk = parcelRequire("6VMPk");
const $78db50f486aa7ca3$var$minVelocity = 0, $78db50f486aa7ca3$var$boundsMin = 0;
function $78db50f486aa7ca3$export$1def114a7da042cf(data) {
    if (data.outMode !== (0, $eBPJQ.OutMode).bounce && data.outMode !== (0, $eBPJQ.OutMode).split || data.direction !== (0, $6VMPk.OutModeDirection).left && data.direction !== (0, $6VMPk.OutModeDirection).right) return;
    if (data.bounds.right < $78db50f486aa7ca3$var$boundsMin && data.direction === (0, $6VMPk.OutModeDirection).left) data.particle.position.x = data.size + data.offset.x;
    else if (data.bounds.left > data.canvasSize.width && data.direction === (0, $6VMPk.OutModeDirection).right) data.particle.position.x = data.canvasSize.width - data.size - data.offset.x;
    const velocity = data.particle.velocity.x;
    let bounced = false;
    if (data.direction === (0, $6VMPk.OutModeDirection).right && data.bounds.right >= data.canvasSize.width && velocity > $78db50f486aa7ca3$var$minVelocity || data.direction === (0, $6VMPk.OutModeDirection).left && data.bounds.left <= $78db50f486aa7ca3$var$boundsMin && velocity < $78db50f486aa7ca3$var$minVelocity) {
        const newVelocity = (0, $yZzCW.getRangeValue)(data.particle.options.bounce.horizontal.value);
        data.particle.velocity.x *= -newVelocity;
        bounced = true;
    }
    if (!bounced) return;
    const minPos = data.offset.x + data.size;
    if (data.bounds.right >= data.canvasSize.width && data.direction === (0, $6VMPk.OutModeDirection).right) data.particle.position.x = data.canvasSize.width - minPos;
    else if (data.bounds.left <= $78db50f486aa7ca3$var$boundsMin && data.direction === (0, $6VMPk.OutModeDirection).left) data.particle.position.x = minPos;
    if (data.outMode === (0, $eBPJQ.OutMode).split) data.particle.destroy();
}
function $78db50f486aa7ca3$export$46000c44e0211bc6(data) {
    if (data.outMode !== (0, $eBPJQ.OutMode).bounce && data.outMode !== (0, $eBPJQ.OutMode).split || data.direction !== (0, $6VMPk.OutModeDirection).bottom && data.direction !== (0, $6VMPk.OutModeDirection).top) return;
    if (data.bounds.bottom < $78db50f486aa7ca3$var$boundsMin && data.direction === (0, $6VMPk.OutModeDirection).top) data.particle.position.y = data.size + data.offset.y;
    else if (data.bounds.top > data.canvasSize.height && data.direction === (0, $6VMPk.OutModeDirection).bottom) data.particle.position.y = data.canvasSize.height - data.size - data.offset.y;
    const velocity = data.particle.velocity.y;
    let bounced = false;
    if (data.direction === (0, $6VMPk.OutModeDirection).bottom && data.bounds.bottom >= data.canvasSize.height && velocity > $78db50f486aa7ca3$var$minVelocity || data.direction === (0, $6VMPk.OutModeDirection).top && data.bounds.top <= $78db50f486aa7ca3$var$boundsMin && velocity < $78db50f486aa7ca3$var$minVelocity) {
        const newVelocity = (0, $yZzCW.getRangeValue)(data.particle.options.bounce.vertical.value);
        data.particle.velocity.y *= -newVelocity;
        bounced = true;
    }
    if (!bounced) return;
    const minPos = data.offset.y + data.size;
    if (data.bounds.bottom >= data.canvasSize.height && data.direction === (0, $6VMPk.OutModeDirection).bottom) data.particle.position.y = data.canvasSize.height - minPos;
    else if (data.bounds.top <= $78db50f486aa7ca3$var$boundsMin && data.direction === (0, $6VMPk.OutModeDirection).top) data.particle.position.y = minPos;
    if (data.outMode === (0, $eBPJQ.OutMode).split) data.particle.destroy();
}

});


parcelRegister("jSmxD", function(module, exports) {

$parcel$export(module.exports, "DestroyOutMode", () => $e7848bb8220e202e$export$4c86fe322e2200a);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $eDm3t = parcelRequire("eDm3t");
var $eBPJQ = parcelRequire("eBPJQ");
var $3SKQC = parcelRequire("3SKQC");
var $aocC0 = parcelRequire("aocC0");
const $e7848bb8220e202e$var$minVelocity = 0;
class $e7848bb8220e202e$export$4c86fe322e2200a {
    constructor(container){
        this.container = container;
        this.modes = [
            (0, $eBPJQ.OutMode).destroy
        ];
    }
    update(particle, direction, _delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        switch(particle.outType){
            case (0, $3SKQC.ParticleOutType).normal:
            case (0, $3SKQC.ParticleOutType).outside:
                if ((0, $eDm3t.isPointInside)(particle.position, container.canvas.size, (0, $aocC0.Vector).origin, particle.getRadius(), direction)) return;
                break;
            case (0, $3SKQC.ParticleOutType).inside:
                {
                    const { dx: dx, dy: dy } = (0, $yZzCW.getDistances)(particle.position, particle.moveCenter), { x: vx, y: vy } = particle.velocity;
                    if (vx < $e7848bb8220e202e$var$minVelocity && dx > particle.moveCenter.radius || vy < $e7848bb8220e202e$var$minVelocity && dy > particle.moveCenter.radius || vx >= $e7848bb8220e202e$var$minVelocity && dx < -particle.moveCenter.radius || vy >= $e7848bb8220e202e$var$minVelocity && dy < -particle.moveCenter.radius) return;
                    break;
                }
        }
        container.particles.remove(particle, particle.group, true);
    }
}

});

parcelRegister("51YKe", function(module, exports) {

$parcel$export(module.exports, "NoneOutMode", () => $3a9c2a58e79240f7$export$a026dc73727d2f19);
parcelRequire("2gXdT");
var $eDm3t = parcelRequire("eDm3t");
var $eBPJQ = parcelRequire("eBPJQ");
var $6VMPk = parcelRequire("6VMPk");
var $aocC0 = parcelRequire("aocC0");
const $3a9c2a58e79240f7$var$minVelocity = 0;
class $3a9c2a58e79240f7$export$a026dc73727d2f19 {
    constructor(container){
        this.container = container;
        this.modes = [
            (0, $eBPJQ.OutMode).none
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        if ((particle.options.move.distance.horizontal && (direction === (0, $6VMPk.OutModeDirection).left || direction === (0, $6VMPk.OutModeDirection).right)) ?? (particle.options.move.distance.vertical && (direction === (0, $6VMPk.OutModeDirection).top || direction === (0, $6VMPk.OutModeDirection).bottom))) return;
        const gravityOptions = particle.options.move.gravity, container = this.container, canvasSize = container.canvas.size, pRadius = particle.getRadius();
        if (!gravityOptions.enable) {
            if (particle.velocity.y > $3a9c2a58e79240f7$var$minVelocity && particle.position.y <= canvasSize.height + pRadius || particle.velocity.y < $3a9c2a58e79240f7$var$minVelocity && particle.position.y >= -pRadius || particle.velocity.x > $3a9c2a58e79240f7$var$minVelocity && particle.position.x <= canvasSize.width + pRadius || particle.velocity.x < $3a9c2a58e79240f7$var$minVelocity && particle.position.x >= -pRadius) return;
            if (!(0, $eDm3t.isPointInside)(particle.position, container.canvas.size, (0, $aocC0.Vector).origin, pRadius, direction)) container.particles.remove(particle);
        } else {
            const position = particle.position;
            if (!gravityOptions.inverse && position.y > canvasSize.height + pRadius && direction === (0, $6VMPk.OutModeDirection).bottom || gravityOptions.inverse && position.y < -pRadius && direction === (0, $6VMPk.OutModeDirection).top) container.particles.remove(particle);
        }
    }
}

});

parcelRegister("bm45C", function(module, exports) {

$parcel$export(module.exports, "OutOutMode", () => $8444ebe5a587cfe5$export$7300b77892783c0e);
parcelRequire("2gXdT");
var $eDm3t = parcelRequire("eDm3t");
var $yZzCW = parcelRequire("yZzCW");
var $eBPJQ = parcelRequire("eBPJQ");
var $6VMPk = parcelRequire("6VMPk");
var $3SKQC = parcelRequire("3SKQC");
var $aocC0 = parcelRequire("aocC0");
const $8444ebe5a587cfe5$var$minVelocity = 0, $8444ebe5a587cfe5$var$minDistance = 0;
class $8444ebe5a587cfe5$export$7300b77892783c0e {
    constructor(container){
        this.container = container;
        this.modes = [
            (0, $eBPJQ.OutMode).out
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        switch(particle.outType){
            case (0, $3SKQC.ParticleOutType).inside:
                {
                    const { x: vx, y: vy } = particle.velocity;
                    const circVec = (0, $aocC0.Vector).origin;
                    circVec.length = particle.moveCenter.radius;
                    circVec.angle = particle.velocity.angle + Math.PI;
                    circVec.addTo((0, $aocC0.Vector).create(particle.moveCenter));
                    const { dx: dx, dy: dy } = (0, $yZzCW.getDistances)(particle.position, circVec);
                    if (vx <= $8444ebe5a587cfe5$var$minVelocity && dx >= $8444ebe5a587cfe5$var$minDistance || vy <= $8444ebe5a587cfe5$var$minVelocity && dy >= $8444ebe5a587cfe5$var$minDistance || vx >= $8444ebe5a587cfe5$var$minVelocity && dx <= $8444ebe5a587cfe5$var$minDistance || vy >= $8444ebe5a587cfe5$var$minVelocity && dy <= $8444ebe5a587cfe5$var$minDistance) return;
                    particle.position.x = Math.floor((0, $yZzCW.randomInRange)({
                        min: 0,
                        max: container.canvas.size.width
                    }));
                    particle.position.y = Math.floor((0, $yZzCW.randomInRange)({
                        min: 0,
                        max: container.canvas.size.height
                    }));
                    const { dx: newDx, dy: newDy } = (0, $yZzCW.getDistances)(particle.position, particle.moveCenter);
                    particle.direction = Math.atan2(-newDy, -newDx);
                    particle.velocity.angle = particle.direction;
                    break;
                }
            default:
                if ((0, $eDm3t.isPointInside)(particle.position, container.canvas.size, (0, $aocC0.Vector).origin, particle.getRadius(), direction)) return;
                switch(particle.outType){
                    case (0, $3SKQC.ParticleOutType).outside:
                        {
                            particle.position.x = Math.floor((0, $yZzCW.randomInRange)({
                                min: -particle.moveCenter.radius,
                                max: particle.moveCenter.radius
                            })) + particle.moveCenter.x;
                            particle.position.y = Math.floor((0, $yZzCW.randomInRange)({
                                min: -particle.moveCenter.radius,
                                max: particle.moveCenter.radius
                            })) + particle.moveCenter.y;
                            const { dx: dx, dy: dy } = (0, $yZzCW.getDistances)(particle.position, particle.moveCenter);
                            if (particle.moveCenter.radius) {
                                particle.direction = Math.atan2(dy, dx);
                                particle.velocity.angle = particle.direction;
                            }
                            break;
                        }
                    case (0, $3SKQC.ParticleOutType).normal:
                        {
                            const warp = particle.options.move.warp, canvasSize = container.canvas.size, newPos = {
                                bottom: canvasSize.height + particle.getRadius() + particle.offset.y,
                                left: -particle.getRadius() - particle.offset.x,
                                right: canvasSize.width + particle.getRadius() + particle.offset.x,
                                top: -particle.getRadius() - particle.offset.y
                            }, sizeValue = particle.getRadius(), nextBounds = (0, $eDm3t.calculateBounds)(particle.position, sizeValue);
                            if (direction === (0, $6VMPk.OutModeDirection).right && nextBounds.left > canvasSize.width + particle.offset.x) {
                                particle.position.x = newPos.left;
                                particle.initialPosition.x = particle.position.x;
                                if (!warp) {
                                    particle.position.y = (0, $yZzCW.getRandom)() * canvasSize.height;
                                    particle.initialPosition.y = particle.position.y;
                                }
                            } else if (direction === (0, $6VMPk.OutModeDirection).left && nextBounds.right < -particle.offset.x) {
                                particle.position.x = newPos.right;
                                particle.initialPosition.x = particle.position.x;
                                if (!warp) {
                                    particle.position.y = (0, $yZzCW.getRandom)() * canvasSize.height;
                                    particle.initialPosition.y = particle.position.y;
                                }
                            }
                            if (direction === (0, $6VMPk.OutModeDirection).bottom && nextBounds.top > canvasSize.height + particle.offset.y) {
                                if (!warp) {
                                    particle.position.x = (0, $yZzCW.getRandom)() * canvasSize.width;
                                    particle.initialPosition.x = particle.position.x;
                                }
                                particle.position.y = newPos.top;
                                particle.initialPosition.y = particle.position.y;
                            } else if (direction === (0, $6VMPk.OutModeDirection).top && nextBounds.bottom < -particle.offset.y) {
                                if (!warp) {
                                    particle.position.x = (0, $yZzCW.getRandom)() * canvasSize.width;
                                    particle.initialPosition.x = particle.position.x;
                                }
                                particle.position.y = newPos.bottom;
                                particle.initialPosition.y = particle.position.y;
                            }
                            break;
                        }
                }
                break;
        }
    }
}

});



parcelRegister("17V36", function(module, exports) {

$parcel$export(module.exports, "loadRgbColorPlugin", () => $0d22b2a8682e8da5$export$62d47f1daf28137b);

var $6Kbe8 = parcelRequire("6Kbe8");
async function $0d22b2a8682e8da5$export$62d47f1daf28137b(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addColorManager(new (0, $6Kbe8.RgbColorManager)(), refresh);
}

});
parcelRegister("6Kbe8", function(module, exports) {

$parcel$export(module.exports, "RgbColorManager", () => $4e8fbf6328013f1b$export$24da4f0c4702c17e);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $4e8fbf6328013f1b$var$RgbIndexes;
(function(RgbIndexes) {
    RgbIndexes[RgbIndexes["r"] = 1] = "r";
    RgbIndexes[RgbIndexes["g"] = 2] = "g";
    RgbIndexes[RgbIndexes["b"] = 3] = "b";
    RgbIndexes[RgbIndexes["a"] = 5] = "a";
})($4e8fbf6328013f1b$var$RgbIndexes || ($4e8fbf6328013f1b$var$RgbIndexes = {}));
class $4e8fbf6328013f1b$export$24da4f0c4702c17e {
    constructor(){
        this.key = "rgb";
        this.stringPrefix = "rgb";
    }
    handleColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) return rgbColor;
    }
    handleRangeColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) return {
            r: (0, $yZzCW.getRangeValue)(rgbColor.r),
            g: (0, $yZzCW.getRangeValue)(rgbColor.g),
            b: (0, $yZzCW.getRangeValue)(rgbColor.b)
        };
    }
    parseString(input) {
        if (!input.startsWith(this.stringPrefix)) return;
        const regex = /rgba?\(\s*(\d{1,3})\s*[\s,]\s*(\d{1,3})\s*[\s,]\s*(\d{1,3})\s*([\s,]\s*(0|1|0?\.\d+|(\d{1,3})%)\s*)?\)/i, result = regex.exec(input), radix = 10, minLength = 4, defaultAlpha = 1;
        return result ? {
            a: result.length > minLength ? (0, $yZzCW.parseAlpha)(result[$4e8fbf6328013f1b$var$RgbIndexes.a]) : defaultAlpha,
            b: parseInt(result[$4e8fbf6328013f1b$var$RgbIndexes.b], radix),
            g: parseInt(result[$4e8fbf6328013f1b$var$RgbIndexes.g], radix),
            r: parseInt(result[$4e8fbf6328013f1b$var$RgbIndexes.r], radix)
        } : undefined;
    }
}

});


parcelRegister("7F0uX", function(module, exports) {

$parcel$export(module.exports, "loadSizeUpdater", () => $593cbfb65635a3da$export$ca8bd803ddf2ea7e);

var $ew0CS = parcelRequire("ew0CS");
async function $593cbfb65635a3da$export$ca8bd803ddf2ea7e(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("size", ()=>{
        return Promise.resolve(new (0, $ew0CS.SizeUpdater)());
    }, refresh);
}

});
parcelRegister("ew0CS", function(module, exports) {

$parcel$export(module.exports, "SizeUpdater", () => $a9148a2f3c8ae26c$export$545f3be57f54ffb6);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $eywbI = parcelRequire("eywbI");
var $eDm3t = parcelRequire("eDm3t");
const $a9148a2f3c8ae26c$var$minLoops = 0;
class $a9148a2f3c8ae26c$export$545f3be57f54ffb6 {
    init(particle) {
        const container = particle.container, sizeOptions = particle.options.size, sizeAnimation = sizeOptions.animation;
        if (sizeAnimation.enable) {
            particle.size.velocity = (particle.retina.sizeAnimationSpeed ?? container.retina.sizeAnimationSpeed) / (0, $eywbI.percentDenominator) * container.retina.reduceFactor;
            if (!sizeAnimation.sync) particle.size.velocity *= (0, $yZzCW.getRandom)();
        }
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning && particle.size.enable && ((particle.size.maxLoops ?? $a9148a2f3c8ae26c$var$minLoops) <= $a9148a2f3c8ae26c$var$minLoops || (particle.size.maxLoops ?? $a9148a2f3c8ae26c$var$minLoops) > $a9148a2f3c8ae26c$var$minLoops && (particle.size.loops ?? $a9148a2f3c8ae26c$var$minLoops) < (particle.size.maxLoops ?? $a9148a2f3c8ae26c$var$minLoops));
    }
    reset(particle) {
        particle.size.loops = $a9148a2f3c8ae26c$var$minLoops;
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $eDm3t.updateAnimation)(particle, particle.size, true, particle.options.size.animation.destroy, delta);
    }
}

});



parcelRegister("6aHhL", function(module, exports) {

$parcel$export(module.exports, "loadEmittersPlugin", () => $47e540db90475013$export$e4e45ab97167d364);

var $jOeK5 = parcelRequire("jOeK5");

var $75PTo = parcelRequire("75PTo");
parcelRequire("6TXqc");
parcelRequire("8vabP");
parcelRequire("lRYwb");
parcelRequire("e9ccs");
parcelRequire("glSyI");
parcelRequire("9MVNy");
parcelRequire("arNoV");
async function $47e540db90475013$export$e4e45ab97167d364(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    if (!engine.emitterShapeManager) engine.emitterShapeManager = new (0, $75PTo.ShapeManager)(engine);
    if (!engine.addEmitterShapeGenerator) engine.addEmitterShapeGenerator = (name, generator)=>{
        engine.emitterShapeManager?.addShapeGenerator(name, generator);
    };
    const plugin = new (0, $jOeK5.EmittersPlugin)(engine);
    await engine.addPlugin(plugin, refresh);
}

});
parcelRegister("jOeK5", function(module, exports) {

$parcel$export(module.exports, "EmittersPlugin", () => $e6be1f53d2bfd498$export$e445717c82398c28);
parcelRequire("2gXdT");
var $eDm3t = parcelRequire("eDm3t");
var $62pjT = parcelRequire("62pjT");

var $aaT7G = parcelRequire("aaT7G");

var $9MVNy = parcelRequire("9MVNy");

var $2wnvz = parcelRequire("2wnvz");
class $e6be1f53d2bfd498$export$e445717c82398c28 {
    constructor(engine){
        this._engine = engine;
        this.id = "emitters";
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $2wnvz.Emitters)(this._engine, container));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        if (source?.emitters) options.emitters = (0, $eDm3t.executeOnSingleOrMultiple)(source.emitters, (emitter)=>{
            const tmp = new (0, $aaT7G.Emitter)();
            tmp.load(emitter);
            return tmp;
        });
        const interactivityEmitters = source?.interactivity?.modes?.emitters;
        if (interactivityEmitters) {
            if ((0, $62pjT.isArray)(interactivityEmitters)) options.interactivity.modes.emitters = {
                random: {
                    count: 1,
                    enable: true
                },
                value: interactivityEmitters.map((s)=>{
                    const tmp = new (0, $aaT7G.Emitter)();
                    tmp.load(s);
                    return tmp;
                })
            };
            else {
                const emitterMode = interactivityEmitters;
                if (emitterMode.value !== undefined) {
                    const defaultCount = 1;
                    if ((0, $62pjT.isArray)(emitterMode.value)) options.interactivity.modes.emitters = {
                        random: {
                            count: emitterMode.random.count ?? defaultCount,
                            enable: emitterMode.random.enable ?? false
                        },
                        value: emitterMode.value.map((s)=>{
                            const tmp = new (0, $aaT7G.Emitter)();
                            tmp.load(s);
                            return tmp;
                        })
                    };
                    else {
                        const tmp = new (0, $aaT7G.Emitter)();
                        tmp.load(emitterMode.value);
                        options.interactivity.modes.emitters = {
                            random: {
                                count: emitterMode.random.count ?? defaultCount,
                                enable: emitterMode.random.enable ?? false
                            },
                            value: tmp
                        };
                    }
                } else {
                    const emitterOptions = options.interactivity.modes.emitters = {
                        random: {
                            count: 1,
                            enable: false
                        },
                        value: new (0, $aaT7G.Emitter)()
                    };
                    emitterOptions.value.load(interactivityEmitters);
                }
            }
        }
    }
    needsPlugin(options) {
        if (!options) return false;
        const emitters = options.emitters;
        return (0, $62pjT.isArray)(emitters) && !!emitters.length || emitters !== undefined || !!options.interactivity?.events?.onClick?.mode && (0, $eDm3t.isInArray)((0, $9MVNy.EmitterClickMode).emitter, options.interactivity.events.onClick.mode);
    }
}

});
parcelRegister("aaT7G", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $768598d277b7ad3f$export$4293555f241ae35a);
parcelRequire("2gXdT");
var $jXSVo = parcelRequire("jXSVo");
var $eDm3t = parcelRequire("eDm3t");
var $62pjT = parcelRequire("62pjT");
var $yZzCW = parcelRequire("yZzCW");

var $jBjP3 = parcelRequire("jBjP3");

var $1IcxM = parcelRequire("1IcxM");

var $90RUe = parcelRequire("90RUe");

var $aQiIE = parcelRequire("aQiIE");
class $768598d277b7ad3f$export$4293555f241ae35a {
    constructor(){
        this.autoPlay = true;
        this.fill = true;
        this.life = new (0, $jBjP3.EmitterLife)();
        this.rate = new (0, $1IcxM.EmitterRate)();
        this.shape = new (0, $90RUe.EmitterShape)();
        this.startCount = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.autoPlay !== undefined) this.autoPlay = data.autoPlay;
        if (data.size !== undefined) {
            if (!this.size) this.size = new (0, $aQiIE.EmitterSize)();
            this.size.load(data.size);
        }
        if (data.direction !== undefined) this.direction = data.direction;
        this.domId = data.domId;
        if (data.fill !== undefined) this.fill = data.fill;
        this.life.load(data.life);
        this.name = data.name;
        this.particles = (0, $eDm3t.executeOnSingleOrMultiple)(data.particles, (particles)=>{
            return (0, $eDm3t.deepExtend)({}, particles);
        });
        this.rate.load(data.rate);
        this.shape.load(data.shape);
        if (data.position !== undefined) {
            this.position = {};
            if (data.position.x !== undefined) this.position.x = (0, $yZzCW.setRangeValue)(data.position.x);
            if (data.position.y !== undefined) this.position.y = (0, $yZzCW.setRangeValue)(data.position.y);
        }
        if (data.spawnColor !== undefined) {
            if (this.spawnColor === undefined) this.spawnColor = new (0, $jXSVo.AnimatableColor)();
            this.spawnColor.load(data.spawnColor);
        }
        if (data.startCount !== undefined) this.startCount = data.startCount;
    }
}

});
parcelRegister("jBjP3", function(module, exports) {

$parcel$export(module.exports, "EmitterLife", () => $e450d95df8f505d1$export$99c2b8efc08054b);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $yZzCW = parcelRequire("yZzCW");
class $e450d95df8f505d1$export$99c2b8efc08054b {
    constructor(){
        this.wait = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.count !== undefined) this.count = data.count;
        if (data.delay !== undefined) this.delay = (0, $yZzCW.setRangeValue)(data.delay);
        if (data.duration !== undefined) this.duration = (0, $yZzCW.setRangeValue)(data.duration);
        if (data.wait !== undefined) this.wait = data.wait;
    }
}

});

parcelRegister("1IcxM", function(module, exports) {

$parcel$export(module.exports, "EmitterRate", () => $13f3a1765155a2c8$export$c3191dc230acef25);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $yZzCW = parcelRequire("yZzCW");
class $13f3a1765155a2c8$export$c3191dc230acef25 {
    constructor(){
        this.quantity = 1;
        this.delay = 0.1;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.quantity !== undefined) this.quantity = (0, $yZzCW.setRangeValue)(data.quantity);
        if (data.delay !== undefined) this.delay = (0, $yZzCW.setRangeValue)(data.delay);
    }
}

});

parcelRegister("90RUe", function(module, exports) {

$parcel$export(module.exports, "EmitterShape", () => $68fdedbfcc9b677d$export$e0f47148d50f3ef);
parcelRequire("2gXdT");
var $eDm3t = parcelRequire("eDm3t");
var $62pjT = parcelRequire("62pjT");

var $jpz0F = parcelRequire("jpz0F");
class $68fdedbfcc9b677d$export$e0f47148d50f3ef {
    constructor(){
        this.options = {};
        this.replace = new (0, $jpz0F.EmitterShapeReplace)();
        this.type = "square";
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.options !== undefined) this.options = (0, $eDm3t.deepExtend)({}, data.options ?? {});
        this.replace.load(data.replace);
        if (data.type !== undefined) this.type = data.type;
    }
}

});
parcelRegister("jpz0F", function(module, exports) {

$parcel$export(module.exports, "EmitterShapeReplace", () => $e21b82531ca0fe4d$export$2c0f13eebb2527f7);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
class $e21b82531ca0fe4d$export$2c0f13eebb2527f7 {
    constructor(){
        this.color = false;
        this.opacity = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.color !== undefined) this.color = data.color;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}

});


parcelRegister("aQiIE", function(module, exports) {

$parcel$export(module.exports, "EmitterSize", () => $7e4d47f6ae5bb437$export$a8f8ab30882c6cf0);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $5r4A4 = parcelRequire("5r4A4");
class $7e4d47f6ae5bb437$export$a8f8ab30882c6cf0 {
    constructor(){
        this.mode = (0, $5r4A4.PixelMode).percent;
        this.height = 0;
        this.width = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.height !== undefined) this.height = data.height;
        if (data.width !== undefined) this.width = data.width;
    }
}

});


parcelRegister("9MVNy", function(module, exports) {

$parcel$export(module.exports, "EmitterClickMode", () => $72056e4211f2a345$export$482a07636b9d56d5);
var $72056e4211f2a345$export$482a07636b9d56d5;
(function(EmitterClickMode) {
    EmitterClickMode["emitter"] = "emitter";
})($72056e4211f2a345$export$482a07636b9d56d5 || ($72056e4211f2a345$export$482a07636b9d56d5 = {}));

});

parcelRegister("2wnvz", function(module, exports) {

$parcel$export(module.exports, "Emitters", () => $1d60ce268ec12f81$export$774a0fdf08f5f4fd);
parcelRequire("2gXdT");
var $eDm3t = parcelRequire("eDm3t");
var $62pjT = parcelRequire("62pjT");

var $aaT7G = parcelRequire("aaT7G");

var $9MVNy = parcelRequire("9MVNy");

var $luzsd = parcelRequire("luzsd");
class $1d60ce268ec12f81$export$774a0fdf08f5f4fd {
    constructor(engine, container){
        this.container = container;
        this._engine = engine;
        this.array = [];
        this.emitters = [];
        this.interactivityEmitters = {
            random: {
                count: 1,
                enable: false
            },
            value: []
        };
        const defaultIndex = 0;
        container.getEmitter = (idxOrName)=>idxOrName === undefined || (0, $62pjT.isNumber)(idxOrName) ? this.array[idxOrName ?? defaultIndex] : this.array.find((t)=>t.name === idxOrName);
        container.addEmitter = async (options, position)=>this.addEmitter(options, position);
        container.removeEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) this.removeEmitter(emitter);
        };
        container.playEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) emitter.externalPlay();
        };
        container.pauseEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) emitter.externalPause();
        };
    }
    async addEmitter(options, position) {
        const emitterOptions = new (0, $aaT7G.Emitter)();
        emitterOptions.load(options);
        const emitter = new (0, $luzsd.EmitterInstance)(this._engine, this, this.container, emitterOptions, position);
        await emitter.init();
        this.array.push(emitter);
        return emitter;
    }
    handleClickMode(mode) {
        const emitterOptions = this.emitters, modeEmitters = this.interactivityEmitters;
        if (mode !== (0, $9MVNy.EmitterClickMode).emitter) return;
        let emittersModeOptions;
        if (modeEmitters && (0, $62pjT.isArray)(modeEmitters.value)) {
            const minLength = 0;
            if (modeEmitters.value.length > minLength && modeEmitters.random.enable) {
                emittersModeOptions = [];
                const usedIndexes = [];
                for(let i = 0; i < modeEmitters.random.count; i++){
                    const idx = (0, $eDm3t.arrayRandomIndex)(modeEmitters.value);
                    if (usedIndexes.includes(idx) && usedIndexes.length < modeEmitters.value.length) {
                        i--;
                        continue;
                    }
                    usedIndexes.push(idx);
                    emittersModeOptions.push((0, $eDm3t.itemFromArray)(modeEmitters.value, idx));
                }
            } else emittersModeOptions = modeEmitters.value;
        } else emittersModeOptions = modeEmitters?.value;
        const emittersOptions = emittersModeOptions ?? emitterOptions, ePosition = this.container.interactivity.mouse.clickPosition;
        (0, $eDm3t.executeOnSingleOrMultiple)(emittersOptions, async (emitter)=>{
            await this.addEmitter(emitter, ePosition);
        });
    }
    async init() {
        this.emitters = this.container.actualOptions.emitters;
        this.interactivityEmitters = this.container.actualOptions.interactivity.modes.emitters;
        if (!this.emitters) return;
        if ((0, $62pjT.isArray)(this.emitters)) for (const emitterOptions of this.emitters)await this.addEmitter(emitterOptions);
        else await this.addEmitter(this.emitters);
    }
    pause() {
        for (const emitter of this.array)emitter.pause();
    }
    play() {
        for (const emitter of this.array)emitter.play();
    }
    removeEmitter(emitter) {
        const index = this.array.indexOf(emitter), minIndex = 0, deleteCount = 1;
        if (index >= minIndex) this.array.splice(index, deleteCount);
    }
    resize() {
        for (const emitter of this.array)emitter.resize();
    }
    stop() {
        this.array = [];
    }
    update(delta) {
        for (const emitter of this.array)emitter.update(delta);
    }
}

});
parcelRegister("luzsd", function(module, exports) {

$parcel$export(module.exports, "EmitterInstance", () => $fa57e6c03b88f6ab$export$834c246832f0a6df);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $eDm3t = parcelRequire("eDm3t");
var $eywbI = parcelRequire("eywbI");
var $5r4A4 = parcelRequire("5r4A4");
var $6nx5m = parcelRequire("6nx5m");
var $aocC0 = parcelRequire("aocC0");

var $aaT7G = parcelRequire("aaT7G");

var $aQiIE = parcelRequire("aQiIE");
const $fa57e6c03b88f6ab$var$half = 0.5, $fa57e6c03b88f6ab$var$defaultLifeDelay = 0, $fa57e6c03b88f6ab$var$minLifeCount = 0, $fa57e6c03b88f6ab$var$defaultSpawnDelay = 0, $fa57e6c03b88f6ab$var$defaultEmitDelay = 0, $fa57e6c03b88f6ab$var$defaultLifeCount = -1, $fa57e6c03b88f6ab$var$defaultColorAnimationFactor = 1;
function $fa57e6c03b88f6ab$var$setParticlesOptionsColor(particlesOptions, color) {
    if (particlesOptions.color) particlesOptions.color.value = color;
    else particlesOptions.color = {
        value: color
    };
}
class $fa57e6c03b88f6ab$export$834c246832f0a6df {
    constructor(engine, emitters, container, options, position){
        this.emitters = emitters;
        this.container = container;
        this._destroy = ()=>{
            this._mutationObserver?.disconnect();
            this._mutationObserver = undefined;
            this._resizeObserver?.disconnect();
            this._resizeObserver = undefined;
            this.emitters.removeEmitter(this);
            this._engine.dispatchEvent("emitterDestroyed", {
                container: this.container,
                data: {
                    emitter: this
                }
            });
        };
        this._prepareToDie = ()=>{
            if (this._paused) return;
            const duration = this.options.life?.duration !== undefined ? (0, $yZzCW.getRangeValue)(this.options.life.duration) : undefined, minDuration = 0, minLifeCount = 0;
            if (this.container.retina.reduceFactor && (this._lifeCount > minLifeCount || this._immortal) && duration !== undefined && duration > minDuration) this._duration = duration * (0, $eywbI.millisecondsToSeconds);
        };
        this._setColorAnimation = (animation, initValue, maxValue, factor = $fa57e6c03b88f6ab$var$defaultColorAnimationFactor)=>{
            const container = this.container;
            if (!animation.enable) return initValue;
            const colorOffset = (0, $yZzCW.randomInRange)(animation.offset), delay = (0, $yZzCW.getRangeValue)(this.options.rate.delay), emitFactor = delay * (0, $eywbI.millisecondsToSeconds) / container.retina.reduceFactor, defaultColorSpeed = 0, colorSpeed = (0, $yZzCW.getRangeValue)(animation.speed ?? defaultColorSpeed);
            return (initValue + colorSpeed * container.fpsLimit / emitFactor + colorOffset * factor) % maxValue;
        };
        this._engine = engine;
        this._currentDuration = 0;
        this._currentEmitDelay = 0;
        this._currentSpawnDelay = 0;
        this._initialPosition = position;
        if (options instanceof (0, $aaT7G.Emitter)) this.options = options;
        else {
            this.options = new (0, $aaT7G.Emitter)();
            this.options.load(options);
        }
        this._spawnDelay = (0, $yZzCW.getRangeValue)(this.options.life.delay ?? $fa57e6c03b88f6ab$var$defaultLifeDelay) * (0, $eywbI.millisecondsToSeconds) / this.container.retina.reduceFactor;
        this.position = this._initialPosition ?? this._calcPosition();
        this.name = this.options.name;
        this.fill = this.options.fill;
        this._firstSpawn = !this.options.life.wait;
        this._startParticlesAdded = false;
        let particlesOptions = (0, $eDm3t.deepExtend)({}, this.options.particles);
        particlesOptions ??= {};
        particlesOptions.move ??= {};
        particlesOptions.move.direction ??= this.options.direction;
        if (this.options.spawnColor) this.spawnColor = (0, $6nx5m.rangeColorToHsl)(this._engine, this.options.spawnColor);
        this._paused = !this.options.autoPlay;
        this._particlesOptions = particlesOptions;
        this._size = this._calcSize();
        this.size = (0, $eDm3t.getSize)(this._size, this.container.canvas.size);
        this._lifeCount = this.options.life.count ?? $fa57e6c03b88f6ab$var$defaultLifeCount;
        this._immortal = this._lifeCount <= $fa57e6c03b88f6ab$var$minLifeCount;
        if (this.options.domId) {
            const element = document.getElementById(this.options.domId);
            if (element) {
                this._mutationObserver = new MutationObserver(()=>{
                    this.resize();
                });
                this._resizeObserver = new ResizeObserver(()=>{
                    this.resize();
                });
                this._mutationObserver.observe(element, {
                    attributes: true,
                    attributeFilter: [
                        "style",
                        "width",
                        "height"
                    ]
                });
                this._resizeObserver.observe(element);
            }
        }
        const shapeOptions = this.options.shape, shapeGenerator = this._engine.emitterShapeManager?.getShapeGenerator(shapeOptions.type);
        if (shapeGenerator) this._shape = shapeGenerator.generate(this.position, this.size, this.fill, shapeOptions.options);
        this._engine.dispatchEvent("emitterCreated", {
            container: container,
            data: {
                emitter: this
            }
        });
        this.play();
    }
    externalPause() {
        this._paused = true;
        this.pause();
    }
    externalPlay() {
        this._paused = false;
        this.play();
    }
    async init() {
        await this._shape?.init();
    }
    pause() {
        if (this._paused) return;
        delete this._emitDelay;
    }
    play() {
        if (this._paused) return;
        if (!(this.container.retina.reduceFactor && (this._lifeCount > $fa57e6c03b88f6ab$var$minLifeCount || this._immortal || !this.options.life.count) && (this._firstSpawn || this._currentSpawnDelay >= (this._spawnDelay ?? $fa57e6c03b88f6ab$var$defaultSpawnDelay)))) return;
        if (this._emitDelay === undefined) {
            const delay = (0, $yZzCW.getRangeValue)(this.options.rate.delay);
            this._emitDelay = delay * (0, $eywbI.millisecondsToSeconds) / this.container.retina.reduceFactor;
        }
        if (this._lifeCount > $fa57e6c03b88f6ab$var$minLifeCount || this._immortal) this._prepareToDie();
    }
    resize() {
        const initialPosition = this._initialPosition;
        this.position = initialPosition && (0, $eDm3t.isPointInside)(initialPosition, this.container.canvas.size, (0, $aocC0.Vector).origin) ? initialPosition : this._calcPosition();
        this._size = this._calcSize();
        this.size = (0, $eDm3t.getSize)(this._size, this.container.canvas.size);
        this._shape?.resize(this.position, this.size);
    }
    update(delta) {
        if (this._paused) return;
        if (this._firstSpawn) {
            this._firstSpawn = false;
            this._currentSpawnDelay = this._spawnDelay ?? $fa57e6c03b88f6ab$var$defaultSpawnDelay;
            this._currentEmitDelay = this._emitDelay ?? $fa57e6c03b88f6ab$var$defaultEmitDelay;
        }
        if (!this._startParticlesAdded) {
            this._startParticlesAdded = true;
            this._emitParticles(this.options.startCount);
        }
        if (this._duration !== undefined) {
            this._currentDuration += delta.value;
            if (this._currentDuration >= this._duration) {
                this.pause();
                if (this._spawnDelay !== undefined) delete this._spawnDelay;
                if (!this._immortal) this._lifeCount--;
                if (this._lifeCount > $fa57e6c03b88f6ab$var$minLifeCount || this._immortal) {
                    this.position = this._calcPosition();
                    this._shape?.resize(this.position, this.size);
                    this._spawnDelay = (0, $yZzCW.getRangeValue)(this.options.life.delay ?? $fa57e6c03b88f6ab$var$defaultLifeDelay) * (0, $eywbI.millisecondsToSeconds) / this.container.retina.reduceFactor;
                } else this._destroy();
                this._currentDuration -= this._duration;
                delete this._duration;
            }
        }
        if (this._spawnDelay !== undefined) {
            this._currentSpawnDelay += delta.value;
            if (this._currentSpawnDelay >= this._spawnDelay) {
                this._engine.dispatchEvent("emitterPlay", {
                    container: this.container
                });
                this.play();
                this._currentSpawnDelay -= this._currentSpawnDelay;
                delete this._spawnDelay;
            }
        }
        if (this._emitDelay !== undefined) {
            this._currentEmitDelay += delta.value;
            if (this._currentEmitDelay >= this._emitDelay) {
                this._emit();
                this._currentEmitDelay -= this._emitDelay;
            }
        }
    }
    _calcPosition() {
        if (this.options.domId) {
            const element = document.getElementById(this.options.domId);
            if (element) {
                const elRect = element.getBoundingClientRect(), pxRatio = this.container.retina.pixelRatio;
                return {
                    x: (elRect.x + elRect.width * $fa57e6c03b88f6ab$var$half) * pxRatio,
                    y: (elRect.y + elRect.height * $fa57e6c03b88f6ab$var$half) * pxRatio
                };
            }
        }
        return (0, $yZzCW.calcPositionOrRandomFromSizeRanged)({
            size: this.container.canvas.size,
            position: this.options.position
        });
    }
    _calcSize() {
        const container = this.container;
        if (this.options.domId) {
            const element = document.getElementById(this.options.domId);
            if (element) {
                const elRect = element.getBoundingClientRect();
                return {
                    width: elRect.width * container.retina.pixelRatio,
                    height: elRect.height * container.retina.pixelRatio,
                    mode: (0, $5r4A4.PixelMode).precise
                };
            }
        }
        return this.options.size ?? (()=>{
            const size = new (0, $aQiIE.EmitterSize)();
            size.load({
                height: 0,
                mode: (0, $5r4A4.PixelMode).percent,
                width: 0
            });
            return size;
        })();
    }
    _emit() {
        if (this._paused) return;
        const quantity = (0, $yZzCW.getRangeValue)(this.options.rate.quantity);
        this._emitParticles(quantity);
    }
    _emitParticles(quantity) {
        const singleParticlesOptions = (0, $eDm3t.itemFromSingleOrMultiple)(this._particlesOptions);
        for(let i = 0; i < quantity; i++){
            const particlesOptions = (0, $eDm3t.deepExtend)({}, singleParticlesOptions);
            if (this.spawnColor) {
                const hslAnimation = this.options.spawnColor?.animation;
                if (hslAnimation) {
                    const maxValues = {
                        h: 360,
                        s: 100,
                        l: 100
                    }, colorFactor = 3.6;
                    this.spawnColor.h = this._setColorAnimation(hslAnimation.h, this.spawnColor.h, maxValues.h, colorFactor);
                    this.spawnColor.s = this._setColorAnimation(hslAnimation.s, this.spawnColor.s, maxValues.s);
                    this.spawnColor.l = this._setColorAnimation(hslAnimation.l, this.spawnColor.l, maxValues.l);
                }
                $fa57e6c03b88f6ab$var$setParticlesOptionsColor(particlesOptions, this.spawnColor);
            }
            const shapeOptions = this.options.shape;
            let position = this.position;
            if (this._shape) {
                const shapePosData = this._shape.randomPosition();
                if (shapePosData) {
                    position = shapePosData.position;
                    const replaceData = shapeOptions.replace;
                    if (replaceData.color && shapePosData.color) $fa57e6c03b88f6ab$var$setParticlesOptionsColor(particlesOptions, shapePosData.color);
                    if (replaceData.opacity) {
                        if (particlesOptions.opacity) particlesOptions.opacity.value = shapePosData.opacity;
                        else particlesOptions.opacity = {
                            value: shapePosData.opacity
                        };
                    }
                } else position = null;
            }
            if (position) this.container.particles.addParticle(position, particlesOptions);
        }
    }
}

});



parcelRegister("75PTo", function(module, exports) {

$parcel$export(module.exports, "ShapeManager", () => $52a140cbf444c8aa$export$29ab17701a3c76b1);
const $52a140cbf444c8aa$var$shapeGeneratorss = new Map();
class $52a140cbf444c8aa$export$29ab17701a3c76b1 {
    constructor(engine){
        this._engine = engine;
    }
    addShapeGenerator(name, generator) {
        if (!this.getShapeGenerator(name)) $52a140cbf444c8aa$var$shapeGeneratorss.set(name, generator);
    }
    getShapeGenerator(name) {
        return $52a140cbf444c8aa$var$shapeGeneratorss.get(name);
    }
    getSupportedShapeGenerators() {
        return $52a140cbf444c8aa$var$shapeGeneratorss.keys();
    }
}

});

parcelRegister("6TXqc", function(module, exports) {

});

parcelRegister("8vabP", function(module, exports) {
class $63091f741024a99c$export$16a3ea651f8843c2 {
    constructor(position, size, fill, options){
        this.position = position;
        this.size = size;
        this.fill = fill;
        this.options = options;
    }
    resize(position, size) {
        this.position = position;
        this.size = size;
    }
}

});

parcelRegister("lRYwb", function(module, exports) {

});

parcelRegister("e9ccs", function(module, exports) {

});

parcelRegister("glSyI", function(module, exports) {

});

parcelRegister("arNoV", function(module, exports) {

});


parcelRegister("cDQR8", function(module, exports) {

$parcel$export(module.exports, "loadLifeUpdater", () => $934220ad844a6d09$export$11010788d59cefed);

var $hQmYT = parcelRequire("hQmYT");
async function $934220ad844a6d09$export$11010788d59cefed(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("life", async (container)=>{
        return Promise.resolve(new (0, $hQmYT.LifeUpdater)(container));
    }, refresh);
}

});
parcelRegister("hQmYT", function(module, exports) {

$parcel$export(module.exports, "LifeUpdater", () => $cfd91e8ca86a2490$export$ba0edc0e3650d019);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $eywbI = parcelRequire("eywbI");

var $gZzeL = parcelRequire("gZzeL");

var $2wNTu = parcelRequire("2wNTu");
const $cfd91e8ca86a2490$var$noTime = 0, $cfd91e8ca86a2490$var$identity = 1, $cfd91e8ca86a2490$var$infiniteValue = -1;
class $cfd91e8ca86a2490$export$ba0edc0e3650d019 {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const container = this.container, particlesOptions = particle.options, lifeOptions = particlesOptions.life;
        if (!lifeOptions) return;
        particle.life = {
            delay: container.retina.reduceFactor ? (0, $yZzCW.getRangeValue)(lifeOptions.delay.value) * (lifeOptions.delay.sync ? $cfd91e8ca86a2490$var$identity : (0, $yZzCW.getRandom)()) / container.retina.reduceFactor * (0, $eywbI.millisecondsToSeconds) : $cfd91e8ca86a2490$var$noTime,
            delayTime: $cfd91e8ca86a2490$var$noTime,
            duration: container.retina.reduceFactor ? (0, $yZzCW.getRangeValue)(lifeOptions.duration.value) * (lifeOptions.duration.sync ? $cfd91e8ca86a2490$var$identity : (0, $yZzCW.getRandom)()) / container.retina.reduceFactor * (0, $eywbI.millisecondsToSeconds) : $cfd91e8ca86a2490$var$noTime,
            time: $cfd91e8ca86a2490$var$noTime,
            count: lifeOptions.count
        };
        if (particle.life.duration <= $cfd91e8ca86a2490$var$noTime) particle.life.duration = $cfd91e8ca86a2490$var$infiniteValue;
        if (particle.life.count <= $cfd91e8ca86a2490$var$noTime) particle.life.count = $cfd91e8ca86a2490$var$infiniteValue;
        if (particle.life) particle.spawning = particle.life.delay > $cfd91e8ca86a2490$var$noTime;
    }
    isEnabled(particle) {
        return !particle.destroyed;
    }
    loadOptions(options, ...sources) {
        if (!options.life) options.life = new (0, $gZzeL.Life)();
        for (const source of sources)options.life.load(source?.life);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle) || !particle.life) return;
        (0, $2wNTu.updateLife)(particle, delta, this.container.canvas.size);
    }
}

});
parcelRegister("gZzeL", function(module, exports) {

$parcel$export(module.exports, "Life", () => $c5edad310d010f2d$export$305b21c541a8d65b);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");

var $7LWSp = parcelRequire("7LWSp");

var $ayXnQ = parcelRequire("ayXnQ");
class $c5edad310d010f2d$export$305b21c541a8d65b {
    constructor(){
        this.count = 0;
        this.delay = new (0, $7LWSp.LifeDelay)();
        this.duration = new (0, $ayXnQ.LifeDuration)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.count !== undefined) this.count = data.count;
        this.delay.load(data.delay);
        this.duration.load(data.duration);
    }
}

});
parcelRegister("7LWSp", function(module, exports) {

$parcel$export(module.exports, "LifeDelay", () => $5a8a97db67e1e32b$export$cfeee7551c31115e);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $hAZRJ = parcelRequire("hAZRJ");
class $5a8a97db67e1e32b$export$cfeee7551c31115e extends (0, $hAZRJ.ValueWithRandom) {
    constructor(){
        super();
        this.sync = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        super.load(data);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}

});

parcelRegister("ayXnQ", function(module, exports) {

$parcel$export(module.exports, "LifeDuration", () => $7b0b24afc561acde$export$c09f84979931ae91);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $hAZRJ = parcelRequire("hAZRJ");
class $7b0b24afc561acde$export$c09f84979931ae91 extends (0, $hAZRJ.ValueWithRandom) {
    constructor(){
        super();
        this.sync = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        super.load(data);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}

});


parcelRegister("2wNTu", function(module, exports) {

$parcel$export(module.exports, "updateLife", () => $1d7545d8d0becd73$export$eabc7277fffd179d);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");
var $eywbI = parcelRequire("eywbI");
const $1d7545d8d0becd73$var$noTime = 0, $1d7545d8d0becd73$var$infiniteValue = -1, $1d7545d8d0becd73$var$noLife = 0, $1d7545d8d0becd73$var$minCanvasSize = 0;
function $1d7545d8d0becd73$export$eabc7277fffd179d(particle, delta, canvasSize) {
    if (!particle.life) return;
    const life = particle.life;
    let justSpawned = false;
    if (particle.spawning) {
        life.delayTime += delta.value;
        if (life.delayTime >= particle.life.delay) {
            justSpawned = true;
            particle.spawning = false;
            life.delayTime = $1d7545d8d0becd73$var$noTime;
            life.time = $1d7545d8d0becd73$var$noTime;
        } else return;
    }
    if (life.duration === $1d7545d8d0becd73$var$infiniteValue) return;
    if (particle.spawning) return;
    if (justSpawned) life.time = $1d7545d8d0becd73$var$noTime;
    else life.time += delta.value;
    if (life.time < life.duration) return;
    life.time = $1d7545d8d0becd73$var$noTime;
    if (particle.life.count > $1d7545d8d0becd73$var$noLife) particle.life.count--;
    if (particle.life.count === $1d7545d8d0becd73$var$noLife) {
        particle.destroy();
        return;
    }
    const widthRange = (0, $yZzCW.setRangeValue)($1d7545d8d0becd73$var$minCanvasSize, canvasSize.width), heightRange = (0, $yZzCW.setRangeValue)($1d7545d8d0becd73$var$minCanvasSize, canvasSize.width);
    particle.position.x = (0, $yZzCW.randomInRange)(widthRange);
    particle.position.y = (0, $yZzCW.randomInRange)(heightRange);
    particle.spawning = true;
    life.delayTime = $1d7545d8d0becd73$var$noTime;
    life.time = $1d7545d8d0becd73$var$noTime;
    particle.reset();
    const lifeOptions = particle.options.life;
    if (lifeOptions) {
        life.delay = (0, $yZzCW.getRangeValue)(lifeOptions.delay.value) * (0, $eywbI.millisecondsToSeconds);
        life.duration = (0, $yZzCW.getRangeValue)(lifeOptions.duration.value) * (0, $eywbI.millisecondsToSeconds);
    }
}

});



parcelRegister("e3Q5c", function(module, exports) {

$parcel$export(module.exports, "loadMotionPlugin", () => $a3c9bf1676ee201b$export$67d9c97c602a4291);

var $kDLQT = parcelRequire("kDLQT");
async function $a3c9bf1676ee201b$export$67d9c97c602a4291(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addPlugin(new (0, $kDLQT.MotionPlugin)(engine), refresh);
}

});
parcelRegister("kDLQT", function(module, exports) {

$parcel$export(module.exports, "MotionPlugin", () => $f06c919372ec4aff$export$d4bb0e2a4a84a7d7);

var $d6D7n = parcelRequire("d6D7n");

var $jyocY = parcelRequire("jyocY");
class $f06c919372ec4aff$export$d4bb0e2a4a84a7d7 {
    constructor(engine){
        this.id = "motion";
        this._engine = engine;
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $jyocY.MotionInstance)(container, this._engine));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin()) return;
        let motionOptions = options.motion;
        if (!motionOptions?.load) options.motion = motionOptions = new (0, $d6D7n.Motion)();
        motionOptions.load(source?.motion);
    }
    needsPlugin() {
        return true;
    }
}

});
parcelRegister("d6D7n", function(module, exports) {

$parcel$export(module.exports, "Motion", () => $98aa2de427562a9d$export$ab7b018719e111db);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");

var $gRz8w = parcelRequire("gRz8w");
class $98aa2de427562a9d$export$ab7b018719e111db {
    constructor(){
        this.disable = false;
        this.reduce = new (0, $gRz8w.MotionReduce)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.disable !== undefined) this.disable = data.disable;
        this.reduce.load(data.reduce);
    }
}

});
parcelRegister("gRz8w", function(module, exports) {

$parcel$export(module.exports, "MotionReduce", () => $c46cd9f6a0ac458f$export$e7b9aef79182aa62);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
class $c46cd9f6a0ac458f$export$e7b9aef79182aa62 {
    constructor(){
        this.factor = 4;
        this.value = true;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.factor !== undefined) this.factor = data.factor;
        if (data.value !== undefined) this.value = data.value;
    }
}

});


parcelRegister("jyocY", function(module, exports) {

$parcel$export(module.exports, "MotionInstance", () => $e3c3f88814bd2247$export$206f4a527d524eec);
parcelRequire("2gXdT");
var $eDm3t = parcelRequire("eDm3t");
const $e3c3f88814bd2247$var$defaultFactor = 1, $e3c3f88814bd2247$var$defaultReduce = 0, $e3c3f88814bd2247$var$identity = 1;
class $e3c3f88814bd2247$export$206f4a527d524eec {
    constructor(container, engine){
        this._handleMotionChange = (mediaQuery)=>{
            const container = this._container, motion = container.actualOptions.motion;
            if (!motion) return;
            if (mediaQuery.matches) {
                if (motion.disable) container.retina.reduceFactor = $e3c3f88814bd2247$var$defaultReduce;
                else container.retina.reduceFactor = motion.reduce.value ? $e3c3f88814bd2247$var$identity / motion.reduce.factor : $e3c3f88814bd2247$var$defaultFactor;
            } else container.retina.reduceFactor = 1;
        };
        this._container = container;
        this._engine = engine;
    }
    async init() {
        const container = this._container, options = container.actualOptions.motion;
        if (!(options && (options.disable || options.reduce.value))) {
            container.retina.reduceFactor = 1;
            return;
        }
        const mediaQuery = (0, $eDm3t.safeMatchMedia)("(prefers-reduced-motion: reduce)");
        if (!mediaQuery) {
            container.retina.reduceFactor = $e3c3f88814bd2247$var$defaultFactor;
            return;
        }
        this._handleMotionChange(mediaQuery);
        const handleChange = ()=>{
            (async ()=>{
                this._handleMotionChange(mediaQuery);
                try {
                    await container.refresh();
                } catch  {}
            })();
        };
        if (mediaQuery.addEventListener !== undefined) mediaQuery.addEventListener("change", handleChange);
        else if (mediaQuery.addListener !== undefined) mediaQuery.addListener(handleChange);
        await Promise.resolve();
    }
}

});



parcelRegister("hPJ5x", function(module, exports) {

$parcel$export(module.exports, "loadRollUpdater", () => $0359b6660977d733$export$9a3fb111b9c845ed);

var $7V4um = parcelRequire("7V4um");
async function $0359b6660977d733$export$9a3fb111b9c845ed(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("roll", ()=>{
        return Promise.resolve(new (0, $7V4um.RollUpdater)(engine));
    }, refresh);
}

});
parcelRegister("7V4um", function(module, exports) {

$parcel$export(module.exports, "RollUpdater", () => $5c4156a7d1e3d2af$export$b21adf6f4d6d0a6a);

var $6XvKm = parcelRequire("6XvKm");

var $93BGQ = parcelRequire("93BGQ");
class $5c4156a7d1e3d2af$export$b21adf6f4d6d0a6a {
    constructor(engine){
        this._engine = engine;
    }
    getTransformValues(particle) {
        const roll = particle.roll?.enable && particle.roll, rollHorizontal = roll && roll.horizontal, rollVertical = roll && roll.vertical;
        return {
            a: rollHorizontal ? Math.cos(roll.angle) : undefined,
            d: rollVertical ? Math.sin(roll.angle) : undefined
        };
    }
    init(particle) {
        (0, $6XvKm.initParticle)(this._engine, particle);
    }
    isEnabled(particle) {
        const roll = particle.options.roll;
        return !particle.destroyed && !particle.spawning && !!roll?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.roll) options.roll = new (0, $93BGQ.Roll)();
        for (const source of sources)options.roll.load(source?.roll);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $6XvKm.updateRoll)(particle, delta);
    }
}

});
parcelRegister("6XvKm", function(module, exports) {

$parcel$export(module.exports, "initParticle", () => $5110e106227b1615$export$5f19b033575b4930);
$parcel$export(module.exports, "updateRoll", () => $5110e106227b1615$export$449a3d30f609ff1a);
parcelRequire("2gXdT");
var $1ruWN = parcelRequire("1ruWN");
var $yZzCW = parcelRequire("yZzCW");
var $eywbI = parcelRequire("eywbI");
var $6nx5m = parcelRequire("6nx5m");

var $eLEe0 = parcelRequire("eLEe0");
const $5110e106227b1615$var$double = 2, $5110e106227b1615$var$doublePI = Math.PI * $5110e106227b1615$var$double, $5110e106227b1615$var$maxAngle = 360;
function $5110e106227b1615$export$5f19b033575b4930(engine, particle) {
    const rollOpt = particle.options.roll;
    if (!rollOpt?.enable) {
        particle.roll = {
            enable: false,
            horizontal: false,
            vertical: false,
            angle: 0,
            speed: 0
        };
        return;
    }
    particle.roll = {
        enable: rollOpt.enable,
        horizontal: rollOpt.mode === (0, $eLEe0.RollMode).horizontal || rollOpt.mode === (0, $eLEe0.RollMode).both,
        vertical: rollOpt.mode === (0, $eLEe0.RollMode).vertical || rollOpt.mode === (0, $eLEe0.RollMode).both,
        angle: (0, $yZzCW.getRandom)() * $5110e106227b1615$var$doublePI,
        speed: (0, $yZzCW.getRangeValue)(rollOpt.speed) / $5110e106227b1615$var$maxAngle
    };
    if (rollOpt.backColor) particle.backColor = (0, $6nx5m.rangeColorToHsl)(engine, rollOpt.backColor);
    else if (rollOpt.darken.enable && rollOpt.enlighten.enable) {
        const alterType = (0, $yZzCW.getRandom)() >= (0, $eywbI.half) ? (0, $1ruWN.AlterType).darken : (0, $1ruWN.AlterType).enlighten;
        particle.roll.alter = {
            type: alterType,
            value: (0, $yZzCW.getRangeValue)(alterType === (0, $1ruWN.AlterType).darken ? rollOpt.darken.value : rollOpt.enlighten.value)
        };
    } else if (rollOpt.darken.enable) particle.roll.alter = {
        type: (0, $1ruWN.AlterType).darken,
        value: (0, $yZzCW.getRangeValue)(rollOpt.darken.value)
    };
    else if (rollOpt.enlighten.enable) particle.roll.alter = {
        type: (0, $1ruWN.AlterType).enlighten,
        value: (0, $yZzCW.getRangeValue)(rollOpt.enlighten.value)
    };
}
function $5110e106227b1615$export$449a3d30f609ff1a(particle, delta) {
    const roll = particle.options.roll, data = particle.roll;
    if (!data || !roll?.enable) return;
    const speed = data.speed * delta.factor, max = $5110e106227b1615$var$doublePI;
    data.angle += speed;
    if (data.angle > max) data.angle -= max;
}

});
parcelRegister("eLEe0", function(module, exports) {

$parcel$export(module.exports, "RollMode", () => $ac04a8479a1373b2$export$f39dbbfc5e88eacd);
var $ac04a8479a1373b2$export$f39dbbfc5e88eacd;
(function(RollMode) {
    RollMode["both"] = "both";
    RollMode["horizontal"] = "horizontal";
    RollMode["vertical"] = "vertical";
})($ac04a8479a1373b2$export$f39dbbfc5e88eacd || ($ac04a8479a1373b2$export$f39dbbfc5e88eacd = {}));

});


parcelRegister("93BGQ", function(module, exports) {

$parcel$export(module.exports, "Roll", () => $6981a1500f95e789$export$aa11096b70371f74);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $hzwm7 = parcelRequire("hzwm7");
var $yZzCW = parcelRequire("yZzCW");

var $9hXp5 = parcelRequire("9hXp5");

var $eLEe0 = parcelRequire("eLEe0");
class $6981a1500f95e789$export$aa11096b70371f74 {
    constructor(){
        this.darken = new (0, $9hXp5.RollLight)();
        this.enable = false;
        this.enlighten = new (0, $9hXp5.RollLight)();
        this.mode = (0, $eLEe0.RollMode).vertical;
        this.speed = 25;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.backColor !== undefined) this.backColor = (0, $hzwm7.OptionsColor).create(this.backColor, data.backColor);
        this.darken.load(data.darken);
        if (data.enable !== undefined) this.enable = data.enable;
        this.enlighten.load(data.enlighten);
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.speed !== undefined) this.speed = (0, $yZzCW.setRangeValue)(data.speed);
    }
}

});
parcelRegister("9hXp5", function(module, exports) {

$parcel$export(module.exports, "RollLight", () => $6c33c7e409a48a20$export$16e8cbb26bb35e82);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $yZzCW = parcelRequire("yZzCW");
class $6c33c7e409a48a20$export$16e8cbb26bb35e82 {
    constructor(){
        this.enable = false;
        this.value = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.value !== undefined) this.value = (0, $yZzCW.setRangeValue)(data.value);
    }
}

});




parcelRegister("ajosq", function(module, exports) {

$parcel$export(module.exports, "loadRotateUpdater", () => $781ea680152f0893$export$4e45f5f68451ed59);

var $bE2tU = parcelRequire("bE2tU");
async function $781ea680152f0893$export$4e45f5f68451ed59(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("rotate", (container)=>{
        return Promise.resolve(new (0, $bE2tU.RotateUpdater)(container));
    }, refresh);
}

});
parcelRegister("bE2tU", function(module, exports) {

$parcel$export(module.exports, "RotateUpdater", () => $87a55ae2bf1f9ada$export$3b9356b2fa15ee9f);
parcelRequire("2gXdT");
var $d8kOl = parcelRequire("d8kOl");
var $yZzCW = parcelRequire("yZzCW");
var $7ecaf = parcelRequire("7ecaf");
var $WiXRo = parcelRequire("WiXRo");
var $eDm3t = parcelRequire("eDm3t");

var $eK3Eu = parcelRequire("eK3Eu");
const $87a55ae2bf1f9ada$var$double = 2, $87a55ae2bf1f9ada$var$doublePI = Math.PI * $87a55ae2bf1f9ada$var$double, $87a55ae2bf1f9ada$var$identity = 1, $87a55ae2bf1f9ada$var$doublePIDeg = 360;
class $87a55ae2bf1f9ada$export$3b9356b2fa15ee9f {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const rotateOptions = particle.options.rotate;
        if (!rotateOptions) return;
        particle.rotate = {
            enable: rotateOptions.animation.enable,
            value: (0, $yZzCW.degToRad)((0, $yZzCW.getRangeValue)(rotateOptions.value)),
            min: 0,
            max: $87a55ae2bf1f9ada$var$doublePI
        };
        particle.pathRotation = rotateOptions.path;
        let rotateDirection = rotateOptions.direction;
        if (rotateDirection === (0, $WiXRo.RotateDirection).random) {
            const index = Math.floor((0, $yZzCW.getRandom)() * $87a55ae2bf1f9ada$var$double), minIndex = 0;
            rotateDirection = index > minIndex ? (0, $WiXRo.RotateDirection).counterClockwise : (0, $WiXRo.RotateDirection).clockwise;
        }
        switch(rotateDirection){
            case (0, $WiXRo.RotateDirection).counterClockwise:
            case "counterClockwise":
                particle.rotate.status = (0, $d8kOl.AnimationStatus).decreasing;
                break;
            case (0, $WiXRo.RotateDirection).clockwise:
                particle.rotate.status = (0, $d8kOl.AnimationStatus).increasing;
                break;
        }
        const rotateAnimation = rotateOptions.animation;
        if (rotateAnimation.enable) {
            particle.rotate.decay = $87a55ae2bf1f9ada$var$identity - (0, $yZzCW.getRangeValue)(rotateAnimation.decay);
            particle.rotate.velocity = (0, $yZzCW.getRangeValue)(rotateAnimation.speed) / $87a55ae2bf1f9ada$var$doublePIDeg * this.container.retina.reduceFactor;
            if (!rotateAnimation.sync) particle.rotate.velocity *= (0, $yZzCW.getRandom)();
        }
        particle.rotation = particle.rotate.value;
    }
    isEnabled(particle) {
        const rotate = particle.options.rotate;
        if (!rotate) return false;
        return !particle.destroyed && !particle.spawning && (!!rotate.value || rotate.animation.enable || rotate.path);
    }
    loadOptions(options, ...sources) {
        if (!options.rotate) options.rotate = new (0, $eK3Eu.Rotate)();
        for (const source of sources)options.rotate.load(source?.rotate);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        particle.isRotating = !!particle.rotate;
        if (!particle.rotate) return;
        (0, $eDm3t.updateAnimation)(particle, particle.rotate, false, (0, $7ecaf.DestroyType).none, delta);
        particle.rotation = particle.rotate.value;
    }
}

});
parcelRegister("eK3Eu", function(module, exports) {

$parcel$export(module.exports, "Rotate", () => $abb831c86eb81964$export$152db69a76b6b79e);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $WiXRo = parcelRequire("WiXRo");
var $hAZRJ = parcelRequire("hAZRJ");

var $7vFjP = parcelRequire("7vFjP");
class $abb831c86eb81964$export$152db69a76b6b79e extends (0, $hAZRJ.ValueWithRandom) {
    constructor(){
        super();
        this.animation = new (0, $7vFjP.RotateAnimation)();
        this.direction = (0, $WiXRo.RotateDirection).clockwise;
        this.path = false;
        this.value = 0;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        super.load(data);
        if (data.direction !== undefined) this.direction = data.direction;
        this.animation.load(data.animation);
        if (data.path !== undefined) this.path = data.path;
    }
}

});
parcelRegister("7vFjP", function(module, exports) {

$parcel$export(module.exports, "RotateAnimation", () => $577b7aba63bb0b04$export$cdf8682ab8a5e20a);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $yZzCW = parcelRequire("yZzCW");
class $577b7aba63bb0b04$export$cdf8682ab8a5e20a {
    constructor(){
        this.enable = false;
        this.speed = 0;
        this.decay = 0;
        this.sync = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $yZzCW.setRangeValue)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $yZzCW.setRangeValue)(data.decay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}

});




parcelRegister("iAcwt", function(module, exports) {

$parcel$export(module.exports, "loadSquareShape", () => $d8754d87d579cb32$export$43ae275f06aaeea);

var $ayV5K = parcelRequire("ayV5K");
async function $d8754d87d579cb32$export$43ae275f06aaeea(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addShape(new (0, $ayV5K.SquareDrawer)(), refresh);
}

});
parcelRegister("ayV5K", function(module, exports) {

$parcel$export(module.exports, "SquareDrawer", () => $7b095d92e0c35d50$export$e0bf05a057b4a28b);

var $5ns9v = parcelRequire("5ns9v");
const $7b095d92e0c35d50$var$sides = 4;
class $7b095d92e0c35d50$export$e0bf05a057b4a28b {
    constructor(){
        this.validTypes = [
            "edge",
            "square"
        ];
    }
    draw(data) {
        (0, $5ns9v.drawSquare)(data);
    }
    getSidesCount() {
        return $7b095d92e0c35d50$var$sides;
    }
}

});
parcelRegister("5ns9v", function(module, exports) {

$parcel$export(module.exports, "drawSquare", () => $3ea4f035ca5eda2a$export$9340b6a85ea854b9);
const $3ea4f035ca5eda2a$var$fixFactorSquared = 2, $3ea4f035ca5eda2a$var$fixFactor = Math.sqrt($3ea4f035ca5eda2a$var$fixFactorSquared), $3ea4f035ca5eda2a$var$double = 2;
function $3ea4f035ca5eda2a$export$9340b6a85ea854b9(data) {
    const { context: context, radius: radius } = data, fixedRadius = radius / $3ea4f035ca5eda2a$var$fixFactor, fixedDiameter = fixedRadius * $3ea4f035ca5eda2a$var$double;
    context.rect(-fixedRadius, -fixedRadius, fixedDiameter, fixedDiameter);
}

});



parcelRegister("2BVbp", function(module, exports) {

$parcel$export(module.exports, "loadTiltUpdater", () => $1e6b64d0caa302ff$export$ad7cd7f1bf42858c);

var $akwT1 = parcelRequire("akwT1");
async function $1e6b64d0caa302ff$export$ad7cd7f1bf42858c(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("tilt", (container)=>{
        return Promise.resolve(new (0, $akwT1.TiltUpdater)(container));
    }, refresh);
}

});
parcelRegister("akwT1", function(module, exports) {

$parcel$export(module.exports, "TiltUpdater", () => $78554833df5b223d$export$bf10918add78aca9);
parcelRequire("2gXdT");
var $d8kOl = parcelRequire("d8kOl");
var $yZzCW = parcelRequire("yZzCW");
var $7ecaf = parcelRequire("7ecaf");
var $eywbI = parcelRequire("eywbI");
var $eDm3t = parcelRequire("eDm3t");

var $lBcQB = parcelRequire("lBcQB");

var $lPSvW = parcelRequire("lPSvW");
const $78554833df5b223d$var$identity = 1, $78554833df5b223d$var$double = 2, $78554833df5b223d$var$doublePI = Math.PI * $78554833df5b223d$var$double, $78554833df5b223d$var$maxAngle = 360;
class $78554833df5b223d$export$bf10918add78aca9 {
    constructor(container){
        this.container = container;
    }
    getTransformValues(particle) {
        const tilt = particle.tilt?.enable && particle.tilt;
        return {
            b: tilt ? Math.cos(tilt.value) * tilt.cosDirection : undefined,
            c: tilt ? Math.sin(tilt.value) * tilt.sinDirection : undefined
        };
    }
    init(particle) {
        const tiltOptions = particle.options.tilt;
        if (!tiltOptions) return;
        particle.tilt = {
            enable: tiltOptions.enable,
            value: (0, $yZzCW.degToRad)((0, $yZzCW.getRangeValue)(tiltOptions.value)),
            sinDirection: (0, $yZzCW.getRandom)() >= (0, $eywbI.half) ? $78554833df5b223d$var$identity : -$78554833df5b223d$var$identity,
            cosDirection: (0, $yZzCW.getRandom)() >= (0, $eywbI.half) ? $78554833df5b223d$var$identity : -$78554833df5b223d$var$identity,
            min: 0,
            max: $78554833df5b223d$var$doublePI
        };
        let tiltDirection = tiltOptions.direction;
        if (tiltDirection === (0, $lPSvW.TiltDirection).random) {
            const index = Math.floor((0, $yZzCW.getRandom)() * $78554833df5b223d$var$double), minIndex = 0;
            tiltDirection = index > minIndex ? (0, $lPSvW.TiltDirection).counterClockwise : (0, $lPSvW.TiltDirection).clockwise;
        }
        switch(tiltDirection){
            case (0, $lPSvW.TiltDirection).counterClockwise:
            case "counterClockwise":
                particle.tilt.status = (0, $d8kOl.AnimationStatus).decreasing;
                break;
            case (0, $lPSvW.TiltDirection).clockwise:
                particle.tilt.status = (0, $d8kOl.AnimationStatus).increasing;
                break;
        }
        const tiltAnimation = particle.options.tilt?.animation;
        if (tiltAnimation?.enable) {
            particle.tilt.decay = $78554833df5b223d$var$identity - (0, $yZzCW.getRangeValue)(tiltAnimation.decay);
            particle.tilt.velocity = (0, $yZzCW.getRangeValue)(tiltAnimation.speed) / $78554833df5b223d$var$maxAngle * this.container.retina.reduceFactor;
            if (!tiltAnimation.sync) particle.tilt.velocity *= (0, $yZzCW.getRandom)();
        }
    }
    isEnabled(particle) {
        const tiltAnimation = particle.options.tilt?.animation;
        return !particle.destroyed && !particle.spawning && !!tiltAnimation?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.tilt) options.tilt = new (0, $lBcQB.Tilt)();
        for (const source of sources)options.tilt.load(source?.tilt);
    }
    async update(particle, delta) {
        if (!this.isEnabled(particle) || !particle.tilt) return;
        (0, $eDm3t.updateAnimation)(particle, particle.tilt, false, (0, $7ecaf.DestroyType).none, delta);
        await Promise.resolve();
    }
}

});
parcelRegister("lBcQB", function(module, exports) {

$parcel$export(module.exports, "Tilt", () => $fb9704e497fa3aa7$export$7f9fd97e8e8ffd03);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $hAZRJ = parcelRequire("hAZRJ");

var $lPSvW = parcelRequire("lPSvW");

var $6ILA7 = parcelRequire("6ILA7");
class $fb9704e497fa3aa7$export$7f9fd97e8e8ffd03 extends (0, $hAZRJ.ValueWithRandom) {
    constructor(){
        super();
        this.animation = new (0, $6ILA7.TiltAnimation)();
        this.direction = (0, $lPSvW.TiltDirection).clockwise;
        this.enable = false;
        this.value = 0;
    }
    load(data) {
        super.load(data);
        if ((0, $62pjT.isNull)(data)) return;
        this.animation.load(data.animation);
        if (data.direction !== undefined) this.direction = data.direction;
        if (data.enable !== undefined) this.enable = data.enable;
    }
}

});
parcelRegister("lPSvW", function(module, exports) {

$parcel$export(module.exports, "TiltDirection", () => $fe58a5c4f7f1094a$export$d4ab2ae1fdddffe);
var $fe58a5c4f7f1094a$export$d4ab2ae1fdddffe;
(function(TiltDirection) {
    TiltDirection["clockwise"] = "clockwise";
    TiltDirection["counterClockwise"] = "counter-clockwise";
    TiltDirection["random"] = "random";
})($fe58a5c4f7f1094a$export$d4ab2ae1fdddffe || ($fe58a5c4f7f1094a$export$d4ab2ae1fdddffe = {}));

});

parcelRegister("6ILA7", function(module, exports) {

$parcel$export(module.exports, "TiltAnimation", () => $4e4bc2de8d1e5daf$export$e573f4ca73db5908);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $yZzCW = parcelRequire("yZzCW");
class $4e4bc2de8d1e5daf$export$e573f4ca73db5908 {
    constructor(){
        this.enable = false;
        this.speed = 0;
        this.decay = 0;
        this.sync = false;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $yZzCW.setRangeValue)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $yZzCW.setRangeValue)(data.decay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}

});




parcelRegister("l9m4Q", function(module, exports) {

$parcel$export(module.exports, "loadWobbleUpdater", () => $f65b904dd52e679b$export$b74f9b6304f50c00);

var $iTqCT = parcelRequire("iTqCT");
async function $f65b904dd52e679b$export$b74f9b6304f50c00(engine, refresh = true) {
    engine.checkVersion("3.8.1");
    await engine.addParticleUpdater("wobble", (container)=>{
        return Promise.resolve(new (0, $iTqCT.WobbleUpdater)(container));
    }, refresh);
}

});
parcelRegister("iTqCT", function(module, exports) {

$parcel$export(module.exports, "WobbleUpdater", () => $dc12047c667441b4$export$40b8dfc901f79b9a);
parcelRequire("2gXdT");
var $yZzCW = parcelRequire("yZzCW");

var $7fpkD = parcelRequire("7fpkD");

var $b41Cl = parcelRequire("b41Cl");
const $dc12047c667441b4$var$double = 2, $dc12047c667441b4$var$doublePI = Math.PI * $dc12047c667441b4$var$double, $dc12047c667441b4$var$maxAngle = 360, $dc12047c667441b4$var$moveSpeedFactor = 10, $dc12047c667441b4$var$defaultDistance = 0;
class $dc12047c667441b4$export$40b8dfc901f79b9a {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const wobbleOpt = particle.options.wobble;
        if (wobbleOpt?.enable) particle.wobble = {
            angle: (0, $yZzCW.getRandom)() * $dc12047c667441b4$var$doublePI,
            angleSpeed: (0, $yZzCW.getRangeValue)(wobbleOpt.speed.angle) / $dc12047c667441b4$var$maxAngle,
            moveSpeed: (0, $yZzCW.getRangeValue)(wobbleOpt.speed.move) / $dc12047c667441b4$var$moveSpeedFactor
        };
        else particle.wobble = {
            angle: 0,
            angleSpeed: 0,
            moveSpeed: 0
        };
        particle.retina.wobbleDistance = (0, $yZzCW.getRangeValue)(wobbleOpt?.distance ?? $dc12047c667441b4$var$defaultDistance) * this.container.retina.pixelRatio;
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning && !!particle.options.wobble?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.wobble) options.wobble = new (0, $7fpkD.Wobble)();
        for (const source of sources)options.wobble.load(source?.wobble);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $b41Cl.updateWobble)(particle, delta);
    }
}

});
parcelRegister("7fpkD", function(module, exports) {

$parcel$export(module.exports, "Wobble", () => $546d957966d0ec35$export$e3332f9062c9ef49);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $yZzCW = parcelRequire("yZzCW");

var $fFxrZ = parcelRequire("fFxrZ");
class $546d957966d0ec35$export$e3332f9062c9ef49 {
    constructor(){
        this.distance = 5;
        this.enable = false;
        this.speed = new (0, $fFxrZ.WobbleSpeed)();
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.distance !== undefined) this.distance = (0, $yZzCW.setRangeValue)(data.distance);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) {
            if ((0, $62pjT.isNumber)(data.speed)) this.speed.load({
                angle: data.speed
            });
            else {
                const rangeSpeed = data.speed;
                if (rangeSpeed.min !== undefined) this.speed.load({
                    angle: rangeSpeed
                });
                else this.speed.load(data.speed);
            }
        }
    }
}

});
parcelRegister("fFxrZ", function(module, exports) {

$parcel$export(module.exports, "WobbleSpeed", () => $b684a1ee704fecde$export$9d1564e235810926);
parcelRequire("2gXdT");
var $62pjT = parcelRequire("62pjT");
var $yZzCW = parcelRequire("yZzCW");
class $b684a1ee704fecde$export$9d1564e235810926 {
    constructor(){
        this.angle = 50;
        this.move = 10;
    }
    load(data) {
        if ((0, $62pjT.isNull)(data)) return;
        if (data.angle !== undefined) this.angle = (0, $yZzCW.setRangeValue)(data.angle);
        if (data.move !== undefined) this.move = (0, $yZzCW.setRangeValue)(data.move);
    }
}

});


parcelRegister("b41Cl", function(module, exports) {

$parcel$export(module.exports, "updateWobble", () => $80e1529e288f29fd$export$c35033201341f652);
parcelRequire("2gXdT");
var $eywbI = parcelRequire("eywbI");
const $80e1529e288f29fd$var$defaultDistance = 0, $80e1529e288f29fd$var$double = 2, $80e1529e288f29fd$var$doublePI = Math.PI * $80e1529e288f29fd$var$double, $80e1529e288f29fd$var$distanceFactor = 60;
function $80e1529e288f29fd$export$c35033201341f652(particle, delta) {
    const { wobble: wobbleOptions } = particle.options, { wobble: wobble } = particle;
    if (!wobbleOptions?.enable || !wobble) return;
    const angleSpeed = wobble.angleSpeed * delta.factor, moveSpeed = wobble.moveSpeed * delta.factor, distance = moveSpeed * ((particle.retina.wobbleDistance ?? $80e1529e288f29fd$var$defaultDistance) * delta.factor) / ((0, $eywbI.millisecondsToSeconds) / $80e1529e288f29fd$var$distanceFactor), max = $80e1529e288f29fd$var$doublePI, { position: position } = particle;
    wobble.angle += angleSpeed;
    if (wobble.angle > max) wobble.angle -= max;
    position.x += distance * Math.cos(wobble.angle);
    position.y += distance * Math.abs(Math.sin(wobble.angle));
}

});



parcelRegister("d1DI1", function(module, exports) {

$parcel$export(module.exports, "options", () => $97ba2bba1503ae04$export$41c562ebe57d11e2);
const $97ba2bba1503ae04$var$lifeDurationNum = 20, $97ba2bba1503ae04$var$lifeDurationFactor = 6, $97ba2bba1503ae04$var$lifeDuration = $97ba2bba1503ae04$var$lifeDurationNum / $97ba2bba1503ae04$var$lifeDurationFactor;
const $97ba2bba1503ae04$export$41c562ebe57d11e2 = {
    fullScreen: {
        enable: true,
        zIndex: 100
    },
    fpsLimit: 120,
    particles: {
        number: {
            value: 0
        },
        color: {
            value: [
                "#26ccff",
                "#a25afd",
                "#ff5e7e",
                "#88ff5a",
                "#fcff42",
                "#ffa62d",
                "#ff36ff"
            ]
        },
        shape: {
            type: [
                "square",
                "circle"
            ]
        },
        opacity: {
            value: {
                min: 0,
                max: 1
            },
            animation: {
                enable: true,
                speed: 0.5,
                startValue: "max",
                destroy: "min"
            }
        },
        size: {
            value: 5
        },
        links: {
            enable: false
        },
        life: {
            duration: {
                sync: true,
                value: $97ba2bba1503ae04$var$lifeDuration
            },
            count: 1
        },
        move: {
            angle: {
                value: 45,
                offset: 0
            },
            drift: 0,
            enable: true,
            gravity: {
                enable: true,
                acceleration: 9.81
            },
            speed: 45,
            decay: 0.1,
            direction: -90,
            random: true,
            straight: false,
            outModes: {
                default: "none",
                bottom: "destroy"
            }
        },
        rotate: {
            value: {
                min: 0,
                max: 360
            },
            direction: "random",
            animation: {
                enable: true,
                speed: 60
            }
        },
        tilt: {
            direction: "random",
            enable: true,
            value: {
                min: 0,
                max: 360
            },
            animation: {
                enable: true,
                speed: 60
            }
        },
        roll: {
            darken: {
                enable: true,
                value: 25
            },
            enable: true,
            speed: {
                min: 15,
                max: 25
            }
        },
        wobble: {
            distance: 30,
            enable: true,
            speed: {
                min: -15,
                max: 15
            }
        }
    },
    detectRetina: true,
    motion: {
        disable: true
    },
    emitters: {
        name: "confetti",
        startCount: 50,
        position: {
            x: 50,
            y: 50
        },
        size: {
            width: 0,
            height: 0
        },
        rate: {
            delay: 0,
            quantity: 0
        },
        life: {
            duration: 0.1,
            count: 1
        }
    }
};

});



parcelRegister("kUEQf", function(module, exports) {

$parcel$export(module.exports, "useScene", () => $f398b7f24e564c22$export$bd3f04bb373be7fd);

var $8NFma = parcelRequire("8NFma");
const $f398b7f24e564c22$export$bd3f04bb373be7fd = (id, { data: data, setSceneData: setSceneData })=>{
    (0, $8NFma.useEffect)(()=>{
        const { sceneData: sceneData } = data.levelUp;
        if (!Object.keys(sceneData).length) return;
        if (sceneData.steps[id]) setSceneData({
            text: sceneData.steps[id].message,
            content: sceneData.steps[id].content ?? '',
            author: sceneData.steps[id].hideContact ? '' : sceneData.contact_about,
            authorImage: sceneData.steps[id].contact_image || sceneData.contact_image,
            illustration: sceneData.steps[id].scene_illustration || sceneData.scene_illustration
        });
    }, [
        id
    ]);
};

});

parcelRegister("3GPK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2afd6e3e35cdb976$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $2EsUM = parcelRequire("2EsUM");

var $fb0st = parcelRequire("fb0st");

var $bws69 = parcelRequire("bws69");
function $2afd6e3e35cdb976$export$2e2bcd8739ae039({ data: data, selection: selection, step: step }) {
    const { animationData: animationData, subtitle: subtitle } = (0, $bws69.useDotLottie)({
        data: data,
        selection: selection,
        step: step
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "visual__animation",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2EsUM.DotLottieReact), {
                    autoplay: true,
                    loop: true,
                    data: animationData
                }, `${JSON.stringify(animationData)}`)
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "visual__text",
                children: subtitle
            })
        ]
    });
}
$2afd6e3e35cdb976$export$2e2bcd8739ae039.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    selection: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array.isRequired,
    step: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired
};

});
parcelRegister("2EsUM", function(module, exports) {

$parcel$export(module.exports, "DotLottieReact", () => $1ee5bf1527ec861d$export$5502e10bdc22dfb3);

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
var $1ee5bf1527ec861d$var$q3 = Object.defineProperty, $1ee5bf1527ec861d$var$J3 = (d, i, r)=>i in d ? $1ee5bf1527ec861d$var$q3(d, i, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: r
    }) : d[i] = r, $1ee5bf1527ec861d$var$v = (d, i, r)=>$1ee5bf1527ec861d$var$J3(d, typeof i != "symbol" ? i + "" : i, r), $1ee5bf1527ec861d$var$Y3 = class {
    requestAnimationFrame(d) {
        return requestAnimationFrame(d);
    }
    cancelAnimationFrame(d) {
        cancelAnimationFrame(d);
    }
}, $1ee5bf1527ec861d$var$Z3 = class {
    constructor(){
        $1ee5bf1527ec861d$var$v(this, "_lastHandleId", 0), $1ee5bf1527ec861d$var$v(this, "_lastImmediate", null);
    }
    requestAnimationFrame(d) {
        return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(()=>{
            d(Date.now());
        }), this._lastHandleId;
    }
    cancelAnimationFrame(d) {
        this._lastImmediate && clearImmediate(this._lastImmediate);
    }
}, $1ee5bf1527ec861d$var$G3 = class {
    constructor(){
        $1ee5bf1527ec861d$var$v(this, "_strategy"), this._strategy = typeof requestAnimationFrame == "function" ? new $1ee5bf1527ec861d$var$Y3 : new $1ee5bf1527ec861d$var$Z3;
    }
    requestAnimationFrame(d) {
        return this._strategy.requestAnimationFrame(d);
    }
    cancelAnimationFrame(d) {
        this._strategy.cancelAnimationFrame(d);
    }
}, $1ee5bf1527ec861d$var$A = typeof window < "u" && typeof window.document < "u", $1ee5bf1527ec861d$var$c2 = new Uint8Array([
    80,
    75,
    3,
    4
]), $1ee5bf1527ec861d$var$K3 = [
    "v",
    "ip",
    "op",
    "layers",
    "fr",
    "w",
    "h"
], $1ee5bf1527ec861d$var$X2 = "0.47.0", $1ee5bf1527ec861d$var$q2 = "@lottiefiles/dotlottie-web", $1ee5bf1527ec861d$var$t0 = .75, $1ee5bf1527ec861d$var$e0 = 4, $1ee5bf1527ec861d$var$i0 = (()=>{
    var d = typeof document < "u" ? document.currentScript?.src : void 0;
    return function(i = {}) {
        var r, s = i, p, P, z = new Promise((t, e)=>{
            p = t, P = e;
        }), F = Object.assign({}, s), G = "./this.program", E = "", l1;
        typeof document < "u" && document.currentScript && (E = document.currentScript.src), d && (E = d), E.startsWith("blob:") ? E = "" : E = E.substr(0, E.replace(/[?#].*/, "").lastIndexOf("/") + 1), l1 = async (t)=>{
            if (t = await fetch(t, {
                credentials: "same-origin"
            }), t.ok) return t.arrayBuffer();
            throw Error(t.status + " : " + t.url);
        };
        var u1 = s.print || console.log.bind(console), $ = s.printErr || console.error.bind(console);
        Object.assign(s, F), F = null, s.thisProgram && (G = s.thisProgram);
        var K = s.wasmBinary, q, s1 = false, h1, B, M, t1, J, L, w, f1, _1;
        function i1() {
            var t = q.buffer;
            s.HEAP8 = B = new Int8Array(t), s.HEAP16 = t1 = new Int16Array(t), s.HEAPU8 = M = new Uint8Array(t), s.HEAPU16 = J = new Uint16Array(t), s.HEAP32 = L = new Int32Array(t), s.HEAPU32 = w = new Uint32Array(t), s.HEAPF32 = f1 = new Float32Array(t), s.HEAPF64 = _1 = new Float64Array(t);
        }
        var E1 = [], H = [], v1 = [];
        function K2() {
            var t = s.preRun.shift();
            E1.unshift(t);
        }
        var a1 = 0, m1 = null;
        function D1(t) {
            throw s.onAbort?.(t), t = "Aborted(" + t + ")", $(t), s1 = true, t = new WebAssembly.RuntimeError(t + ". Build with -sASSERTIONS for more info."), P(t), t;
        }
        var v2 = (t)=>t.startsWith("data:application/octet-stream;base64,"), F1;
        async function t3(t) {
            if (!K) try {
                var e = await l1(t);
                return new Uint8Array(e);
            } catch  {}
            if (t == F1 && K) t = new Uint8Array(K);
            else throw "both async and sync fetching of the wasm failed";
            return t;
        }
        async function e3(t, e) {
            try {
                var a = await t3(t);
                return await WebAssembly.instantiate(a, e);
            } catch (n) {
                $(`failed to asynchronously prepare wasm: ${n}`), D1(n);
            }
        }
        async function i3(t) {
            var e = F1;
            if (!K && typeof WebAssembly.instantiateStreaming == "function" && !v2(e) && typeof fetch == "function") try {
                var a = fetch(e, {
                    credentials: "same-origin"
                });
                return await WebAssembly.instantiateStreaming(a, t);
            } catch (n) {
                $(`wasm streaming compile failed: ${n}`), $("falling back to ArrayBuffer instantiation");
            }
            return e3(e, t);
        }
        class m2 {
            constructor(e){
                $1ee5bf1527ec861d$var$v(this, "name", "ExitStatus"), this.message = `Program terminated with exit(${e})`, this.status = e;
            }
        }
        var N1 = (t)=>{
            for(; 0 < t.length;)t.shift()(s);
        }, X1 = s.noExitRuntime || true, p2 = typeof TextDecoder < "u" ? new TextDecoder : void 0, p1 = (t, e = 0, a = NaN)=>{
            var n = e + a;
            for(a = e; t[a] && !(a >= n);)++a;
            if (16 < a - e && t.buffer && p2) return p2.decode(t.subarray(e, a));
            for(n = ""; e < a;){
                var o = t[e++];
                if (o & 128) {
                    var h = t[e++] & 63;
                    if ((o & 224) == 192) n += String.fromCharCode((o & 31) << 6 | h);
                    else {
                        var l = t[e++] & 63;
                        o = (o & 240) == 224 ? (o & 15) << 12 | h << 6 | l : (o & 7) << 18 | h << 12 | l << 6 | t[e++] & 63, 65536 > o ? n += String.fromCharCode(o) : (o -= 65536, n += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023));
                    }
                } else n += String.fromCharCode(o);
            }
            return n;
        }, d1 = 0;
        class g2 {
            constructor(e){
                this.Pa = e - 24;
            }
        }
        var a3 = ()=>{
            var t = [], e = d1;
            if (!e) return I1(0), 0;
            var a = new g2(e);
            w[a.Pa + 16 >> 2] = e;
            var n = w[a.Pa + 4 >> 2];
            if (!n) return I1(0), e;
            for (var o of t){
                if (o === 0 || o === n) break;
                if ($2(o, n, a.Pa + 16)) return I1(o), e;
            }
            return I1(n), e;
        }, g1 = (t, e, a)=>{
            var n = M;
            if (0 < a) {
                a = e + a - 1;
                for(var o = 0; o < t.length; ++o){
                    var h = t.charCodeAt(o);
                    if (55296 <= h && 57343 >= h) {
                        var l = t.charCodeAt(++o);
                        h = 65536 + ((h & 1023) << 10) | l & 1023;
                    }
                    if (127 >= h) {
                        if (e >= a) break;
                        n[e++] = h;
                    } else {
                        if (2047 >= h) {
                            if (e + 1 >= a) break;
                            n[e++] = 192 | h >> 6;
                        } else {
                            if (65535 >= h) {
                                if (e + 2 >= a) break;
                                n[e++] = 224 | h >> 12;
                            } else {
                                if (e + 3 >= a) break;
                                n[e++] = 240 | h >> 18, n[e++] = 128 | h >> 12 & 63;
                            }
                            n[e++] = 128 | h >> 6 & 63;
                        }
                        n[e++] = 128 | h & 63;
                    }
                }
                n[e] = 0;
            }
        }, O1 = {}, q1 = (t)=>{
            for(; t.length;){
                var e = t.pop();
                t.pop()(e);
            }
        };
        function w1(t) {
            return this.fromWireType(w[t >> 2]);
        }
        var c1 = {}, n1 = {}, k1 = {}, y1, e1 = (t, e, a)=>{
            function n(c) {
                if (c = a(c), c.length !== t.length) throw new y1("Mismatched type converter count");
                for(var u = 0; u < t.length; ++u)V(t[u], c[u]);
            }
            t.forEach((c)=>k1[c] = e);
            var o = Array(e.length), h = [], l = 0;
            e.forEach((c, u)=>{
                n1.hasOwnProperty(c) ? o[u] = n1[c] : (h.push(c), c1.hasOwnProperty(c) || (c1[c] = []), c1[c].push(()=>{
                    o[u] = n1[c], ++l, l === h.length && n(o);
                }));
            }), h.length === 0 && n(o);
        }, w2, O = (t)=>{
            for(var e = ""; M[t];)e += w2[M[t++]];
            return e;
        }, g;
        function n3(t, e, a = {}) {
            var n = e.name;
            if (!t) throw new g(`type "${n}" must have a positive integer typeid pointer`);
            if (n1.hasOwnProperty(t)) {
                if (a.vb) return;
                throw new g(`Cannot register type '${n}' twice`);
            }
            n1[t] = e, delete k1[t], c1.hasOwnProperty(t) && (e = c1[t], delete c1[t], e.forEach((o)=>o()));
        }
        function V(t, e, a = {}) {
            return n3(t, e, a);
        }
        var J1 = (t)=>{
            throw new g(t.Oa.Ra.Qa.name + " instance already deleted");
        }, Y1 = false, y2 = ()=>{}, L2 = (t, e, a)=>e === a ? t : a.Ua === void 0 ? null : (t = L2(t, e, a.Ua), t === null ? null : a.ob(t)), C2 = {}, r3 = {}, o3 = (t, e)=>{
            if (e === void 0) throw new g("ptr should not be undefined");
            for(; t.Ua;)e = t.eb(e), t = t.Ua;
            return r3[e];
        }, T1 = (t, e)=>{
            if (!e.Ra || !e.Pa) throw new y1("makeClassHandle requires ptr and ptrType");
            if (!!e.Va != !!e.Ta) throw new y1("Both smartPtrType and smartPtr must be specified");
            return e.count = {
                value: 1
            }, L1(Object.create(t, {
                Oa: {
                    value: e,
                    writable: true
                }
            }));
        }, L1 = (t)=>typeof FinalizationRegistry > "u" ? (L1 = (e)=>e, t) : (Y1 = new FinalizationRegistry((e)=>{
                e = e.Oa, --e.count.value, e.count.value === 0 && (e.Ta ? e.Va.Ya(e.Ta) : e.Ra.Qa.Ya(e.Pa));
            }), L1 = (e)=>{
                var a = e.Oa;
                return a.Ta && Y1.register(e, {
                    Oa: a
                }, e), e;
            }, y2 = (e)=>{
                Y1.unregister(e);
            }, L1(t));
        function R1() {}
        var C1 = (t, e)=>Object.defineProperty(e, "name", {
                value: t
            }), b2 = (t, e, a)=>{
            if (t[e].Sa === void 0) {
                var n = t[e];
                t[e] = function(...o) {
                    if (!t[e].Sa.hasOwnProperty(o.length)) throw new g(`Function '${a}' called with an invalid number of arguments (${o.length}) - expects one of (${t[e].Sa})!`);
                    return t[e].Sa[o.length].apply(this, o);
                }, t[e].Sa = [], t[e].Sa[n.ab] = n;
            }
        }, Z1 = (t, e, a)=>{
            if (s.hasOwnProperty(t)) {
                if (a === void 0 || s[t].Sa !== void 0 && s[t].Sa[a] !== void 0) throw new g(`Cannot register public name '${t}' twice`);
                if (b2(s, t, t), s[t].Sa.hasOwnProperty(a)) throw new g(`Cannot register multiple overloads of a function with the same number of arguments (${a})!`);
                s[t].Sa[a] = e;
            } else s[t] = e, s[t].ab = a;
        }, s3 = (t)=>{
            t = t.replace(/[^a-zA-Z0-9_]/g, "$");
            var e = t.charCodeAt(0);
            return 48 <= e && 57 >= e ? `_${t}` : t;
        };
        function h3(t, e, a, n, o, h, l, c) {
            this.name = t, this.constructor = e, this.$a = a, this.Ya = n, this.Ua = o, this.qb = h, this.eb = l, this.ob = c, this.xb = [];
        }
        var G1 = (t, e, a)=>{
            for(; e !== a;){
                if (!e.eb) throw new g(`Expected null or instance of ${a.name}, got an instance of ${e.name}`);
                t = e.eb(t), e = e.Ua;
            }
            return t;
        };
        function d3(t, e) {
            if (e === null) {
                if (this.hb) throw new g(`null is not a valid ${this.name}`);
                return 0;
            }
            if (!e.Oa) throw new g(`Cannot pass "${a2(e)}" as a ${this.name}`);
            if (!e.Oa.Pa) throw new g(`Cannot pass deleted object as a pointer of type ${this.name}`);
            return G1(e.Oa.Pa, e.Oa.Ra.Qa, this.Qa);
        }
        function c3(t, e) {
            if (e === null) {
                if (this.hb) throw new g(`null is not a valid ${this.name}`);
                if (this.gb) {
                    var a = this.ib();
                    return t !== null && t.push(this.Ya, a), a;
                }
                return 0;
            }
            if (!e || !e.Oa) throw new g(`Cannot pass "${a2(e)}" as a ${this.name}`);
            if (!e.Oa.Pa) throw new g(`Cannot pass deleted object as a pointer of type ${this.name}`);
            if (!this.fb && e.Oa.Ra.fb) throw new g(`Cannot convert argument of type ${e.Oa.Va ? e.Oa.Va.name : e.Oa.Ra.name} to parameter type ${this.name}`);
            if (a = G1(e.Oa.Pa, e.Oa.Ra.Qa, this.Qa), this.gb) {
                if (e.Oa.Ta === void 0) throw new g("Passing raw pointer to smart pointer is illegal");
                switch(this.Cb){
                    case 0:
                        if (e.Oa.Va === this) a = e.Oa.Ta;
                        else throw new g(`Cannot convert argument of type ${e.Oa.Va ? e.Oa.Va.name : e.Oa.Ra.name} to parameter type ${this.name}`);
                        break;
                    case 1:
                        a = e.Oa.Ta;
                        break;
                    case 2:
                        if (e.Oa.Va === this) a = e.Oa.Ta;
                        else {
                            var n = e.clone();
                            a = this.yb(a, x1(()=>n.delete())), t !== null && t.push(this.Ya, a);
                        }
                        break;
                    default:
                        throw new g("Unsupporting sharing policy");
                }
            }
            return a;
        }
        function l3(t, e) {
            if (e === null) {
                if (this.hb) throw new g(`null is not a valid ${this.name}`);
                return 0;
            }
            if (!e.Oa) throw new g(`Cannot pass "${a2(e)}" as a ${this.name}`);
            if (!e.Oa.Pa) throw new g(`Cannot pass deleted object as a pointer of type ${this.name}`);
            if (e.Oa.Ra.fb) throw new g(`Cannot convert argument of type ${e.Oa.Ra.name} to parameter type ${this.name}`);
            return G1(e.Oa.Pa, e.Oa.Ra.Qa, this.Qa);
        }
        function b1(t, e, a, n, o, h, l, c, u, f, _) {
            this.name = t, this.Qa = e, this.hb = a, this.fb = n, this.gb = o, this.wb = h, this.Cb = l, this.mb = c, this.ib = u, this.yb = f, this.Ya = _, o || e.Ua !== void 0 ? this.toWireType = c3 : (this.toWireType = n ? d3 : l3, this.Xa = null);
        }
        var M2 = (t, e, a)=>{
            if (!s.hasOwnProperty(t)) throw new y1("Replacing nonexistent public symbol");
            s[t].Sa !== void 0 && a !== void 0 ? s[t].Sa[a] = e : (s[t] = e, s[t].ab = a);
        }, D, u3 = (t, e, a = [])=>(t.includes("j") ? (t = t.replace(/p/g, "i"), e = (0, s["dynCall_" + t])(e, ...a)) : e = D.get(e)(...a), e), f3 = (t, e)=>(...a)=>u3(t, e, a), W = (t, e)=>{
            t = O(t);
            var a = t.includes("j") ? f3(t, e) : D.get(e);
            if (typeof a != "function") throw new g(`unknown function pointer with signature ${t}: ${e}`);
            return a;
        }, I2, P2 = (t)=>{
            t = W2(t);
            var e = O(t);
            return Z(t), e;
        }, A1 = (t, e)=>{
            function a(h) {
                o[h] || n1[h] || (k1[h] ? k1[h].forEach(a) : (n.push(h), o[h] = true));
            }
            var n = [], o = {};
            throw e.forEach(a), new I2(`${t}: ` + n.map(P2).join([
                ", "
            ]));
        }, K1 = (t, e)=>{
            for(var a = [], n = 0; n < t; n++)a.push(w[e + 4 * n >> 2]);
            return a;
        };
        function _3(t) {
            for(var e = 1; e < t.length; ++e)if (t[e] !== null && t[e].Xa === void 0) return true;
            return false;
        }
        function t2(t, e, a, n, o) {
            var h = e.length;
            if (2 > h) throw new g("argTypes array size mismatch! Must at least get return value and 'this' types!");
            var l = e[1] !== null && a !== null, c = _3(e), u = e[0].name !== "void", f = h - 2, _ = Array(f), m = [], C = [];
            return C1(t, function(...U) {
                if (C.length = 0, m.length = l ? 2 : 1, m[0] = o, l) {
                    var I = e[1].toWireType(C, this);
                    m[1] = I;
                }
                for(var S = 0; S < f; ++S)_[S] = e[S + 2].toWireType(C, U[S]), m.push(_[S]);
                if (U = n(...m), c) q1(C);
                else for(S = l ? 1 : 2; S < e.length; S++){
                    var Q = S === 1 ? I : _[S - 2];
                    e[S].Xa !== null && e[S].Xa(Q);
                }
                return I = u ? e[0].fromWireType(U) : void 0, I;
            });
        }
        var S2 = (t)=>{
            t = t.trim();
            let e = t.indexOf("(");
            return e !== -1 ? t.substr(0, e) : t;
        }, e2 = [], Y = [], i2 = (t)=>{
            9 < t && --Y[t + 1] === 0 && (Y[t] = void 0, e2.push(t));
        }, W1 = (t)=>{
            if (!t) throw new g("Cannot use deleted val. handle = " + t);
            return Y[t];
        }, x1 = (t)=>{
            switch(t){
                case void 0:
                    return 2;
                case null:
                    return 4;
                case true:
                    return 6;
                case false:
                    return 8;
                default:
                    let e = e2.pop() || Y.length;
                    return Y[e] = t, Y[e + 1] = 1, e;
            }
        }, E2 = {
            name: "emscripten::val",
            fromWireType: (t)=>{
                var e = W1(t);
                return i2(t), e;
            },
            toWireType: (t, e)=>x1(e),
            Wa: 8,
            readValueFromPointer: w1,
            Xa: null
        }, v3 = (t, e, a)=>{
            switch(e){
                case 1:
                    return a ? function(n) {
                        return this.fromWireType(B[n]);
                    } : function(n) {
                        return this.fromWireType(M[n]);
                    };
                case 2:
                    return a ? function(n) {
                        return this.fromWireType(t1[n >> 1]);
                    } : function(n) {
                        return this.fromWireType(J[n >> 1]);
                    };
                case 4:
                    return a ? function(n) {
                        return this.fromWireType(L[n >> 2]);
                    } : function(n) {
                        return this.fromWireType(w[n >> 2]);
                    };
                default:
                    throw new TypeError(`invalid integer width (${e}): ${t}`);
            }
        }, $1 = (t, e)=>{
            var a = n1[t];
            if (a === void 0) throw t = `${e} has unknown type ${P2(t)}`, new g(t);
            return a;
        }, a2 = (t)=>{
            if (t === null) return "null";
            var e = typeof t;
            return e === "object" || e === "array" || e === "function" ? t.toString() : "" + t;
        }, m3 = (t, e)=>{
            switch(e){
                case 4:
                    return function(a) {
                        return this.fromWireType(f1[a >> 2]);
                    };
                case 8:
                    return function(a) {
                        return this.fromWireType(_1[a >> 3]);
                    };
                default:
                    throw new TypeError(`invalid float width (${e}): ${t}`);
            }
        }, p3 = (t, e, a)=>{
            switch(e){
                case 1:
                    return a ? (n)=>B[n] : (n)=>M[n];
                case 2:
                    return a ? (n)=>t1[n >> 1] : (n)=>J[n >> 1];
                case 4:
                    return a ? (n)=>L[n >> 2] : (n)=>w[n >> 2];
                default:
                    throw new TypeError(`invalid integer width (${e}): ${t}`);
            }
        }, g3 = Object.assign({
            optional: true
        }, E2), D2 = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, w3 = (t, e)=>{
            for(var a = t >> 1, n = a + e / 2; !(a >= n) && J[a];)++a;
            if (a <<= 1, 32 < a - t && D2) return D2.decode(M.subarray(t, a));
            for(a = "", n = 0; !(n >= e / 2); ++n){
                var o = t1[t + 2 * n >> 1];
                if (o == 0) break;
                a += String.fromCharCode(o);
            }
            return a;
        }, y3 = (t, e, a)=>{
            if (a ?? (a = 2147483647), 2 > a) return 0;
            a -= 2;
            var n = e;
            a = a < 2 * t.length ? a / 2 : t.length;
            for(var o = 0; o < a; ++o)t1[e >> 1] = t.charCodeAt(o), e += 2;
            return t1[e >> 1] = 0, e - n;
        }, L3 = (t)=>2 * t.length, C3 = (t, e)=>{
            for(var a = 0, n = ""; !(a >= e / 4);){
                var o = L[t + 4 * a >> 2];
                if (o == 0) break;
                ++a, 65536 <= o ? (o -= 65536, n += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023)) : n += String.fromCharCode(o);
            }
            return n;
        }, b3 = (t, e, a)=>{
            if (a ?? (a = 2147483647), 4 > a) return 0;
            var n = e;
            a = n + a - 4;
            for(var o = 0; o < t.length; ++o){
                var h = t.charCodeAt(o);
                if (55296 <= h && 57343 >= h) {
                    var l = t.charCodeAt(++o);
                    h = 65536 + ((h & 1023) << 10) | l & 1023;
                }
                if (L[e >> 2] = h, e += 4, e + 4 > a) break;
            }
            return L[e >> 2] = 0, e - n;
        }, M3 = (t)=>{
            for(var e = 0, a = 0; a < t.length; ++a){
                var n = t.charCodeAt(a);
                55296 <= n && 57343 >= n && ++a, e += 4;
            }
            return e;
        }, n2 = 0, F2 = (t, e, a)=>{
            var n = [];
            return t = t.toWireType(n, a), n.length && (w[e >> 2] = x1(n)), t;
        }, r2 = [], I3 = (t)=>{
            var e = r2.length;
            return r2.push(t), e;
        }, P3 = (t, e)=>{
            for(var a = Array(t), n = 0; n < t; ++n)a[n] = $1(w[e + 4 * n >> 2], "parameter " + n);
            return a;
        }, S3 = Reflect.construct, M1 = {}, O2 = (t)=>{
            if (!(t instanceof m2 || t == "unwind")) throw t;
        }, k2 = (t)=>{
            throw h1 = t, X1 || 0 < n2 || (s.onExit?.(t), s1 = true), new m2(t);
        }, E3 = (t)=>{
            if (!s1) try {
                if (t(), !(X1 || 0 < n2)) try {
                    h1 = t = h1, k2(t);
                } catch (e) {
                    O2(e);
                }
            } catch (e) {
                O2(e);
            }
        }, o2 = {}, T2 = ()=>{
            if (!s2) {
                var t = {
                    USER: "web_user",
                    LOGNAME: "web_user",
                    PATH: "/",
                    PWD: "/",
                    HOME: "/home/web_user",
                    LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                    _: G || "./this.program"
                }, e;
                for(e in o2)o2[e] === void 0 ? delete t[e] : t[e] = o2[e];
                var a = [];
                for(e in t)a.push(`${e}=${t[e]}`);
                s2 = a;
            }
            return s2;
        }, s2, D3 = [
            null,
            [],
            []
        ], F3 = ()=>{
            if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return (t)=>crypto.getRandomValues(t);
            D1("initRandomDevice");
        }, R2 = (t)=>(R2 = F3())(t);
        y1 = s.InternalError = class extends Error {
            constructor(t){
                super(t), this.name = "InternalError";
            }
        };
        for(var A2 = Array(256), U1 = 0; 256 > U1; ++U1)A2[U1] = String.fromCharCode(U1);
        w2 = A2, g = s.BindingError = class extends Error {
            constructor(t){
                super(t), this.name = "BindingError";
            }
        }, Object.assign(R1.prototype, {
            isAliasOf: function(t) {
                if (!(this instanceof R1 && t instanceof R1)) return false;
                var e = this.Oa.Ra.Qa, a = this.Oa.Pa;
                t.Oa = t.Oa;
                var n = t.Oa.Ra.Qa;
                for(t = t.Oa.Pa; e.Ua;)a = e.eb(a), e = e.Ua;
                for(; n.Ua;)t = n.eb(t), n = n.Ua;
                return e === n && a === t;
            },
            clone: function() {
                if (this.Oa.Pa || J1(this), this.Oa.cb) return this.Oa.count.value += 1, this;
                var t = L1, e = Object, a = e.create, n = Object.getPrototypeOf(this), o = this.Oa;
                return t = t(a.call(e, n, {
                    Oa: {
                        value: {
                            count: o.count,
                            bb: o.bb,
                            cb: o.cb,
                            Pa: o.Pa,
                            Ra: o.Ra,
                            Ta: o.Ta,
                            Va: o.Va
                        }
                    }
                })), t.Oa.count.value += 1, t.Oa.bb = false, t;
            },
            delete () {
                if (this.Oa.Pa || J1(this), this.Oa.bb && !this.Oa.cb) throw new g("Object already scheduled for deletion");
                y2(this);
                var t = this.Oa;
                --t.count.value, t.count.value === 0 && (t.Ta ? t.Va.Ya(t.Ta) : t.Ra.Qa.Ya(t.Pa)), this.Oa.cb || (this.Oa.Ta = void 0, this.Oa.Pa = void 0);
            },
            isDeleted: function() {
                return !this.Oa.Pa;
            },
            deleteLater: function() {
                if (this.Oa.Pa || J1(this), this.Oa.bb && !this.Oa.cb) throw new g("Object already scheduled for deletion");
                return this.Oa.bb = true, this;
            }
        }), Object.assign(b1.prototype, {
            rb (t) {
                return this.mb && (t = this.mb(t)), t;
            },
            kb (t) {
                this.Ya?.(t);
            },
            Wa: 8,
            readValueFromPointer: w1,
            fromWireType: function(t) {
                function e() {
                    return this.gb ? T1(this.Qa.$a, {
                        Ra: this.wb,
                        Pa: a,
                        Va: this,
                        Ta: t
                    }) : T1(this.Qa.$a, {
                        Ra: this,
                        Pa: t
                    });
                }
                var a = this.rb(t);
                if (!a) return this.kb(t), null;
                var n = o3(this.Qa, a);
                if (n !== void 0) return n.Oa.count.value === 0 ? (n.Oa.Pa = a, n.Oa.Ta = t, n.clone()) : (n = n.clone(), this.kb(t), n);
                if (n = this.Qa.qb(a), n = C2[n], !n) return e.call(this);
                n = this.fb ? n.nb : n.pointerType;
                var o = L2(a, this.Qa, n.Qa);
                return o === null ? e.call(this) : this.gb ? T1(n.Qa.$a, {
                    Ra: n,
                    Pa: o,
                    Va: this,
                    Ta: t
                }) : T1(n.Qa.$a, {
                    Ra: n,
                    Pa: o
                });
            }
        }), I2 = s.UnboundTypeError = ((t, e)=>{
            var a = C1(e, function(n) {
                this.name = e, this.message = n, n = Error(n).stack, n !== void 0 && (this.stack = this.toString() + `
` + n.replace(/^Error(:[^\n]*)?\n/, ""));
            });
            return a.prototype = Object.create(t.prototype), a.prototype.constructor = a, a.prototype.toString = function() {
                return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
            }, a;
        })(Error, "UnboundTypeError"), Y.push(0, 1, void 0, 1, null, 1, true, 1, false, 1), s.count_emval_handles = ()=>Y.length / 2 - 5 - e2.length;
        var O3 = {
            d: (t, e, a, n)=>D1(`Assertion failed: ${t ? p1(M, t) : ""}, at: ` + [
                    e ? e ? p1(M, e) : "" : "unknown filename",
                    a,
                    n ? n ? p1(M, n) : "" : "unknown function"
                ]),
            c: ()=>a3(),
            n: (t, e, a)=>{
                var n = new g2(t);
                throw w[n.Pa + 16 >> 2] = 0, w[n.Pa + 4 >> 2] = e, w[n.Pa + 8 >> 2] = a, d1 = t, d1;
            },
            e: (t)=>{
                throw d1 || (d1 = t), d1;
            },
            T: ()=>{},
            Q: ()=>{},
            R: ()=>{},
            V: function() {},
            S: ()=>{},
            X: ()=>D1(""),
            w: (t)=>{
                var e = O1[t];
                delete O1[t];
                var a = e.ib, n = e.Ya, o = e.lb, h = o.map((l)=>l.ub).concat(o.map((l)=>l.Ab));
                e1([
                    t
                ], h, (l)=>{
                    var c = {};
                    return o.forEach((u, f)=>{
                        var _ = l[f], m = u.sb, C = u.tb, U = l[f + o.length], I = u.zb, S = u.Bb;
                        c[u.pb] = {
                            read: (Q)=>_.fromWireType(m(C, Q)),
                            write: (Q, P1)=>{
                                var j = [];
                                I(S, Q, U.toWireType(j, P1)), q1(j);
                            }
                        };
                    }), [
                        {
                            name: e.name,
                            fromWireType: (u)=>{
                                var f = {}, _;
                                for(_ in c)f[_] = c[_].read(u);
                                return n(u), f;
                            },
                            toWireType: (u, f)=>{
                                for(var _ in c)if (!(_ in f)) throw new TypeError(`Missing field: "${_}"`);
                                var m = a();
                                for(_ in c)c[_].write(m, f[_]);
                                return u !== null && u.push(n, m), m;
                            },
                            Wa: 8,
                            readValueFromPointer: w1,
                            Xa: n
                        }
                    ];
                });
            },
            H: ()=>{},
            fa: (t, e, a, n)=>{
                e = O(e), V(t, {
                    name: e,
                    fromWireType: function(o) {
                        return !!o;
                    },
                    toWireType: function(o, h) {
                        return h ? a : n;
                    },
                    Wa: 8,
                    readValueFromPointer: function(o) {
                        return this.fromWireType(M[o]);
                    },
                    Xa: null
                });
            },
            u: (t, e, a, n, o, h, l, c, u, f, _, m, C)=>{
                _ = O(_), h = W(o, h), c && (c = W(l, c)), f && (f = W(u, f)), C = W(m, C);
                var U = s3(_);
                Z1(U, function() {
                    A1(`Cannot construct ${_} due to unbound types`, [
                        n
                    ]);
                }), e1([
                    t,
                    e,
                    a
                ], n ? [
                    n
                ] : [], (I)=>{
                    if (I = I[0], n) var S = I.Qa, Q = S.$a;
                    else Q = R1.prototype;
                    I = C1(_, function(...d2) {
                        if (Object.getPrototypeOf(this) !== P1) throw new g("Use 'new' to construct " + _);
                        if (j.Za === void 0) throw new g(_ + " has no accessible constructor");
                        var z2 = j.Za[d2.length];
                        if (z2 === void 0) throw new g(`Tried to invoke ctor of ${_} with invalid number of parameters (${d2.length}) - expected (${Object.keys(j.Za).toString()}) parameters instead!`);
                        return z2.apply(this, d2);
                    });
                    var P1 = Object.create(Q, {
                        constructor: {
                            value: I
                        }
                    });
                    I.prototype = P1;
                    var j = new h3(_, I, P1, C, S, h, c, f);
                    if (j.Ua) {
                        var S1;
                        (S1 = j.Ua).jb ?? (S1.jb = []), j.Ua.jb.push(j);
                    }
                    return S = new b1(_, j, true, false, false), S1 = new b1(_ + "*", j, false, false, false), Q = new b1(_ + " const*", j, false, true, false), C2[t] = {
                        pointerType: S1,
                        nb: Q
                    }, M2(U, I), [
                        S,
                        S1,
                        Q
                    ];
                });
            },
            t: (t, e, a, n, o, h)=>{
                var l = K1(e, a);
                o = W(n, o), e1([], [
                    t
                ], (c)=>{
                    c = c[0];
                    var u = `constructor ${c.name}`;
                    if (c.Qa.Za === void 0 && (c.Qa.Za = []), c.Qa.Za[e - 1] !== void 0) throw new g(`Cannot register multiple constructors with identical number of parameters (${e - 1}) for class '${c.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                    return c.Qa.Za[e - 1] = ()=>{
                        A1(`Cannot construct ${c.name} due to unbound types`, l);
                    }, e1([], l, (f)=>(f.splice(1, 0, null), c.Qa.Za[e - 1] = t2(u, f, null, o, h), [])), [];
                });
            },
            h: (t, e, a, n, o, h, l, c)=>{
                var u = K1(a, n);
                e = O(e), e = S2(e), h = W(o, h), e1([], [
                    t
                ], (f)=>{
                    function _() {
                        A1(`Cannot call ${m} due to unbound types`, u);
                    }
                    f = f[0];
                    var m = `${f.name}.${e}`;
                    e.startsWith("@@") && (e = Symbol[e.substring(2)]), c && f.Qa.xb.push(e);
                    var C = f.Qa.$a, U = C[e];
                    return U === void 0 || U.Sa === void 0 && U.className !== f.name && U.ab === a - 2 ? (_.ab = a - 2, _.className = f.name, C[e] = _) : (b2(C, e, m), C[e].Sa[a - 2] = _), e1([], u, (I)=>(I = t2(m, I, f, h, l), C[e].Sa === void 0 ? (I.ab = a - 2, C[e] = I) : C[e].Sa[a - 2] = I, [])), [];
                });
            },
            da: (t)=>V(t, E2),
            y: (t, e, a, n)=>{
                function o() {}
                e = O(e), o.values = {}, V(t, {
                    name: e,
                    constructor: o,
                    fromWireType: function(h) {
                        return this.constructor.values[h];
                    },
                    toWireType: (h, l)=>l.value,
                    Wa: 8,
                    readValueFromPointer: v3(e, a, n),
                    Xa: null
                }), Z1(e, o);
            },
            l: (t, e, a)=>{
                var n = $1(t, "enum");
                e = O(e), t = n.constructor, n = Object.create(n.constructor.prototype, {
                    value: {
                        value: a
                    },
                    constructor: {
                        value: C1(`${n.name}_${e}`, function() {})
                    }
                }), t.values[a] = n, t[e] = n;
            },
            E: (t, e, a)=>{
                e = O(e), V(t, {
                    name: e,
                    fromWireType: (n)=>n,
                    toWireType: (n, o)=>o,
                    Wa: 8,
                    readValueFromPointer: m3(e, a),
                    Xa: null
                });
            },
            v: (t, e, a, n, o, h)=>{
                var l = K1(e, a);
                t = O(t), t = S2(t), o = W(n, o), Z1(t, function() {
                    A1(`Cannot call ${t} due to unbound types`, l);
                }, e - 1), e1([], l, (c)=>(M2(t, t2(t, [
                        c[0],
                        null
                    ].concat(c.slice(1)), null, o, h), e - 1), []));
            },
            p: (t, e, a, n, o)=>{
                if (e = O(e), o === -1 && (o = 4294967295), o = (c)=>c, n === 0) {
                    var h = 32 - 8 * a;
                    o = (c)=>c << h >>> h;
                }
                var l = e.includes("unsigned") ? function(c, u) {
                    return u >>> 0;
                } : function(c, u) {
                    return u;
                };
                V(t, {
                    name: e,
                    fromWireType: o,
                    toWireType: l,
                    Wa: 8,
                    readValueFromPointer: p3(e, a, n !== 0),
                    Xa: null
                });
            },
            k: (t, e, a)=>{
                function n(h) {
                    return new o(B.buffer, w[h + 4 >> 2], w[h >> 2]);
                }
                var o = [
                    Int8Array,
                    Uint8Array,
                    Int16Array,
                    Uint16Array,
                    Int32Array,
                    Uint32Array,
                    Float32Array,
                    Float64Array
                ][e];
                a = O(a), V(t, {
                    name: a,
                    fromWireType: n,
                    Wa: 8,
                    readValueFromPointer: n
                }, {
                    vb: true
                });
            },
            x: (t)=>{
                V(t, g3);
            },
            la: (t, e, a, n, o, h, l, c, u, f, _, m)=>{
                a = O(a), h = W(o, h), c = W(l, c), f = W(u, f), m = W(_, m), e1([
                    t
                ], [
                    e
                ], (C)=>(C = C[0], [
                        new b1(a, C.Qa, false, false, true, C, n, h, c, f, m)
                    ]));
            },
            ea: (t, e)=>{
                e = O(e), V(t, {
                    name: e,
                    fromWireType: function(a) {
                        for(var n = w[a >> 2], o = a + 4, h, l = o, c = 0; c <= n; ++c){
                            var u = o + c;
                            (c == n || M[u] == 0) && (l = l ? p1(M, l, u - l) : "", h === void 0 ? h = l : (h += "\0", h += l), l = u + 1);
                        }
                        return Z(a), h;
                    },
                    toWireType: function(a, n) {
                        n instanceof ArrayBuffer && (n = new Uint8Array(n));
                        var o, h = typeof n == "string";
                        if (!(h || n instanceof Uint8Array || n instanceof Uint8ClampedArray || n instanceof Int8Array)) throw new g("Cannot pass non-string to std::string");
                        if (h) for(var l = o = 0; l < n.length; ++l){
                            var c = n.charCodeAt(l);
                            127 >= c ? o++ : 2047 >= c ? o += 2 : 55296 <= c && 57343 >= c ? (o += 4, ++l) : o += 3;
                        }
                        else o = n.length;
                        if (l = h2(4 + o + 1), c = l + 4, w[l >> 2] = o, h) g1(n, c, o + 1);
                        else if (h) for(h = 0; h < o; ++h){
                            var u = n.charCodeAt(h);
                            if (255 < u) throw Z(c), new g("String has UTF-16 code units that do not fit in 8 bits");
                            M[c + h] = u;
                        }
                        else for(h = 0; h < o; ++h)M[c + h] = n[h];
                        return a !== null && a.push(Z, l), l;
                    },
                    Wa: 8,
                    readValueFromPointer: w1,
                    Xa (a) {
                        Z(a);
                    }
                });
            },
            A: (t, e, a)=>{
                if (a = O(a), e === 2) var n = w3, o = y3, h = L3, l = (c)=>J[c >> 1];
                else e === 4 && (n = C3, o = b3, h = M3, l = (c)=>w[c >> 2]);
                V(t, {
                    name: a,
                    fromWireType: (c)=>{
                        for(var u = w[c >> 2], f, _ = c + 4, m = 0; m <= u; ++m){
                            var C = c + 4 + m * e;
                            (m == u || l(C) == 0) && (_ = n(_, C - _), f === void 0 ? f = _ : (f += "\0", f += _), _ = C + e);
                        }
                        return Z(c), f;
                    },
                    toWireType: (c, u)=>{
                        if (typeof u != "string") throw new g(`Cannot pass non-string to C++ string type ${a}`);
                        var f = h(u), _ = h2(4 + f + e);
                        return w[_ >> 2] = f / e, o(u, _ + 4, f + e), c !== null && c.push(Z, _), _;
                    },
                    Wa: 8,
                    readValueFromPointer: w1,
                    Xa (c) {
                        Z(c);
                    }
                });
            },
            s: (t, e, a, n, o, h)=>{
                O1[t] = {
                    name: O(e),
                    ib: W(a, n),
                    Ya: W(o, h),
                    lb: []
                };
            },
            m: (t, e, a, n, o, h, l, c, u, f)=>{
                O1[t].lb.push({
                    pb: O(e),
                    ub: a,
                    sb: W(n, o),
                    tb: h,
                    Ab: l,
                    zb: W(c, u),
                    Bb: f
                });
            },
            ga: (t, e)=>{
                e = O(e), V(t, {
                    Db: true,
                    name: e,
                    Wa: 0,
                    fromWireType: ()=>{},
                    toWireType: ()=>{}
                });
            },
            O: ()=>{
                X1 = false, n2 = 0;
            },
            I: ()=>{
                throw 1 / 0;
            },
            F: (t, e, a)=>(t = W1(t), e = $1(e, "emval::as"), F2(e, a, t)),
            ja: (t, e, a, n)=>(t = r2[t], e = W1(e), t(null, e, a, n)),
            M: i2,
            ia: (t, e, a)=>{
                var n = P3(t, e), o = n.shift();
                t--;
                var h = Array(t);
                return e = `methodCaller<(${n.map((l)=>l.name).join(", ")}) => ${o.name}>`, I3(C1(e, (l, c, u, f)=>{
                    for(var _ = 0, m = 0; m < t; ++m)h[m] = n[m].readValueFromPointer(f + _), _ += n[m].Wa;
                    return l = a === 1 ? S3(c, h) : c.apply(l, h), F2(o, u, l);
                }));
            },
            ka: (t)=>{
                9 < t && (Y[t + 1] += 1);
            },
            ha: (t)=>{
                var e = W1(t);
                q1(e), i2(t);
            },
            r: (t, e)=>(t = $1(t, "_emval_take_value"), t = t.readValueFromPointer(e), x1(t)),
            K: (t, e)=>{
                if (M1[t] && (clearTimeout(M1[t].id), delete M1[t]), !e) return 0;
                var a = setTimeout(()=>{
                    delete M1[t], E3(()=>x2(t, performance.now()));
                }, e);
                return M1[t] = {
                    id: a,
                    Eb: e
                }, 0;
            },
            L: (t, e, a, n)=>{
                var o = new Date().getFullYear(), h = new Date(o, 0, 1).getTimezoneOffset();
                o = new Date(o, 6, 1).getTimezoneOffset(), w[t >> 2] = 60 * Math.max(h, o), L[e >> 2] = +(h != o), e = (l)=>{
                    var c = Math.abs(l);
                    return `UTC${0 <= l ? "-" : "+"}${String(Math.floor(c / 60)).padStart(2, "0")}${String(c % 60).padStart(2, "0")}`;
                }, t = e(h), e = e(o), o < h ? (g1(t, a, 17), g1(e, n, 17)) : (g1(t, n, 17), g1(e, a, 17));
            },
            ca: ()=>performance.now(),
            N: (t)=>{
                var e = M.length;
                if (t >>>= 0, 2147483648 < t) return false;
                for(var a = 1; 4 >= a; a *= 2){
                    var n = e * (1 + .2 / a);
                    n = Math.min(n, t + 100663296);
                    t: {
                        n = (Math.min(2147483648, 65536 * Math.ceil(Math.max(t, n) / 65536)) - q.buffer.byteLength + 65535) / 65536 | 0;
                        try {
                            q.grow(n), i1();
                            var o = 1;
                            break t;
                        } catch  {}
                        o = void 0;
                    }
                    if (o) return true;
                }
                return false;
            },
            Z: (t, e)=>{
                var a = 0;
                return T2().forEach((n, o)=>{
                    var h = e + a;
                    for(o = w[t + 4 * o >> 2] = h, h = 0; h < n.length; ++h)B[o++] = n.charCodeAt(h);
                    B[o] = 0, a += n.length + 1;
                }), 0;
            },
            _: (t, e)=>{
                var a = T2();
                w[t >> 2] = a.length;
                var n = 0;
                return a.forEach((o)=>n += o.length + 1), w[e >> 2] = n, 0;
            },
            W: ()=>52,
            U: ()=>52,
            B: (t, e, a, n)=>{
                for(var o = 0, h = 0; h < a; h++){
                    var l = w[e >> 2], c = w[e + 4 >> 2];
                    e += 8;
                    for(var u = 0; u < c; u++){
                        var f = t, _ = M[l + u], m = D3[f];
                        _ === 0 || _ === 10 ? ((f === 1 ? u1 : $)(p1(m)), m.length = 0) : m.push(_);
                    }
                    o += c;
                }
                return w[n >> 2] = o, 0;
            },
            $: Q3,
            aa: V3,
            J: N3,
            j: W3,
            i: B3,
            g: z3,
            ba: T3,
            z: H3,
            C: j3,
            D: $3,
            a: k3,
            b: R3,
            f: A3,
            o: U3,
            q: x3,
            G: X3,
            Y: k2,
            P: (t, e)=>(R2(M.subarray(t, t + e)), 0)
        }, y;
        (async function() {
            function t(n) {
                return y = n.exports, q = y.ma, i1(), D = y.ra, H.unshift(y.na), a1--, s.monitorRunDependencies?.(a1), a1 == 0 && m1 && (n = m1, m1 = null, n()), y;
            }
            a1++, s.monitorRunDependencies?.(a1);
            var e = {
                a: O3
            };
            if (s.instantiateWasm) try {
                return s.instantiateWasm(e, t);
            } catch (n) {
                $(`Module.instantiateWasm callback failed with error: ${n}`), P(n);
            }
            F1 ?? (F1 = v2("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : s.locateFile ? s.locateFile("DotLottiePlayer.wasm", E) : E + "DotLottiePlayer.wasm");
            try {
                var a = await i3(e);
                return t(a.instance), a;
            } catch (n) {
                P(n);
            }
        })();
        var h2 = (t)=>(h2 = y.oa)(t), W2 = (t)=>(W2 = y.pa)(t), Z = (t)=>(Z = y.qa)(t), x2 = (t, e)=>(x2 = y.sa)(t, e), k = (t, e)=>(k = y.ta)(t, e), I1 = (t)=>(I1 = y.ua)(t), T = (t)=>(T = y.va)(t), R = ()=>(R = y.wa)(), $2 = (t, e, a)=>($2 = y.xa)(t, e, a);
        s.dynCall_iijj = (t, e, a, n, o, h)=>(s.dynCall_iijj = y.ya)(t, e, a, n, o, h), s.dynCall_vijj = (t, e, a, n, o, h)=>(s.dynCall_vijj = y.za)(t, e, a, n, o, h), s.dynCall_jiii = (t, e, a, n)=>(s.dynCall_jiii = y.Aa)(t, e, a, n);
        var U2 = s.dynCall_vijjjj = (t, e, a, n, o, h, l, c, u, f)=>(U2 = s.dynCall_vijjjj = y.Ba)(t, e, a, n, o, h, l, c, u, f);
        s.dynCall_jii = (t, e, a)=>(s.dynCall_jii = y.Ca)(t, e, a), s.dynCall_vjii = (t, e, a, n, o)=>(s.dynCall_vjii = y.Da)(t, e, a, n, o), s.dynCall_vjfii = (t, e, a, n, o, h)=>(s.dynCall_vjfii = y.Ea)(t, e, a, n, o, h), s.dynCall_vjiii = (t, e, a, n, o, h)=>(s.dynCall_vjiii = y.Fa)(t, e, a, n, o, h), s.dynCall_vj = (t, e, a)=>(s.dynCall_vj = y.Ga)(t, e, a), s.dynCall_vjiiiii = (t, e, a, n, o, h, l, c)=>(s.dynCall_vjiiiii = y.Ha)(t, e, a, n, o, h, l, c), s.dynCall_vjiffii = (t, e, a, n, o, h, l, c)=>(s.dynCall_vjiffii = y.Ia)(t, e, a, n, o, h, l, c), s.dynCall_vjiiii = (t, e, a, n, o, h, l)=>(s.dynCall_vjiiii = y.Ja)(t, e, a, n, o, h, l), s.dynCall_viijii = (t, e, a, n, o, h, l)=>(s.dynCall_viijii = y.Ka)(t, e, a, n, o, h, l), s.dynCall_iiiiij = (t, e, a, n, o, h, l)=>(s.dynCall_iiiiij = y.La)(t, e, a, n, o, h, l), s.dynCall_iiiiijj = (t, e, a, n, o, h, l, c, u)=>(s.dynCall_iiiiijj = y.Ma)(t, e, a, n, o, h, l, c, u), s.dynCall_iiiiiijj = (t, e, a, n, o, h, l, c, u, f)=>(s.dynCall_iiiiiijj = y.Na)(t, e, a, n, o, h, l, c, u, f);
        function k3(t, e) {
            var a = R();
            try {
                D.get(t)(e);
            } catch (n) {
                if (T(a), n !== n + 0) throw n;
                k(1, 0);
            }
        }
        function T3(t, e, a, n, o) {
            var h = R();
            try {
                return D.get(t)(e, a, n, o);
            } catch (l) {
                if (T(h), l !== l + 0) throw l;
                k(1, 0);
            }
        }
        function R3(t, e, a) {
            var n = R();
            try {
                D.get(t)(e, a);
            } catch (o) {
                if (T(n), o !== o + 0) throw o;
                k(1, 0);
            }
        }
        function A3(t, e, a, n) {
            var o = R();
            try {
                D.get(t)(e, a, n);
            } catch (h) {
                if (T(o), h !== h + 0) throw h;
                k(1, 0);
            }
        }
        function W3(t, e) {
            var a = R();
            try {
                return D.get(t)(e);
            } catch (n) {
                if (T(a), n !== n + 0) throw n;
                k(1, 0);
            }
        }
        function x3(t, e, a, n, o, h) {
            var l = R();
            try {
                D.get(t)(e, a, n, o, h);
            } catch (c) {
                if (T(l), c !== c + 0) throw c;
                k(1, 0);
            }
        }
        function $3(t) {
            var e = R();
            try {
                D.get(t)();
            } catch (a) {
                if (T(e), a !== a + 0) throw a;
                k(1, 0);
            }
        }
        function U3(t, e, a, n, o) {
            var h = R();
            try {
                D.get(t)(e, a, n, o);
            } catch (l) {
                if (T(h), l !== l + 0) throw l;
                k(1, 0);
            }
        }
        function j3(t, e, a, n, o, h, l, c) {
            var u = R();
            try {
                return D.get(t)(e, a, n, o, h, l, c);
            } catch (f) {
                if (T(u), f !== f + 0) throw f;
                k(1, 0);
            }
        }
        function z3(t, e, a, n) {
            var o = R();
            try {
                return D.get(t)(e, a, n);
            } catch (h) {
                if (T(o), h !== h + 0) throw h;
                k(1, 0);
            }
        }
        function B3(t, e, a) {
            var n = R();
            try {
                return D.get(t)(e, a);
            } catch (o) {
                if (T(n), o !== o + 0) throw o;
                k(1, 0);
            }
        }
        function H3(t, e, a, n, o, h) {
            var l = R();
            try {
                return D.get(t)(e, a, n, o, h);
            } catch (c) {
                if (T(l), c !== c + 0) throw c;
                k(1, 0);
            }
        }
        function V3(t, e, a, n) {
            var o = R();
            try {
                return D.get(t)(e, a, n);
            } catch (h) {
                if (T(o), h !== h + 0) throw h;
                k(1, 0);
            }
        }
        function Q3(t, e) {
            var a = R();
            try {
                return D.get(t)(e);
            } catch (n) {
                if (T(a), n !== n + 0) throw n;
                k(1, 0);
            }
        }
        function N3(t, e, a) {
            var n = R();
            try {
                return D.get(t)(e, a);
            } catch (o) {
                if (T(n), o !== o + 0) throw o;
                k(1, 0);
            }
        }
        function X3(t, e, a, n, o, h, l, c, u, f) {
            var _ = R();
            try {
                U2(t, e, a, n, o, h, l, c, u, f);
            } catch (m) {
                if (T(_), m !== m + 0) throw m;
                k(1, 0);
            }
        }
        var j1;
        m1 = function t() {
            j1 || j2(), j1 || (m1 = t);
        };
        function j2() {
            function t() {
                if (!j1 && (j1 = true, s.calledRun = true, !s1)) {
                    if (N1(H), p(s), s.onRuntimeInitialized?.(), s.postRun) for(typeof s.postRun == "function" && (s.postRun = [
                        s.postRun
                    ]); s.postRun.length;){
                        var e = s.postRun.shift();
                        v1.unshift(e);
                    }
                    N1(v1);
                }
            }
            if (!(0 < a1)) {
                if (s.preRun) for(typeof s.preRun == "function" && (s.preRun = [
                    s.preRun
                ]); s.preRun.length;)K2();
                N1(E1), 0 < a1 || (s.setStatus ? (s.setStatus("Running..."), setTimeout(()=>{
                    setTimeout(()=>s.setStatus(""), 1), t();
                }, 1)) : t());
            }
        }
        if (s.preInit) for(typeof s.preInit == "function" && (s.preInit = [
            s.preInit
        ]); 0 < s.preInit.length;)s.preInit.pop()();
        return j2(), r = z, r;
    };
})(), $1ee5bf1527ec861d$var$a0 = $1ee5bf1527ec861d$var$i0, $1ee5bf1527ec861d$var$z1 = class {
    constructor(){
        throw new Error("RendererLoader is a static class and cannot be instantiated.");
    }
    static async _tryLoad(d) {
        return await $1ee5bf1527ec861d$var$a0({
            locateFile: ()=>d
        });
    }
    static async _loadWithBackup() {
        return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch(async (d)=>{
            let i = `https://unpkg.com/${$1ee5bf1527ec861d$var$q2}@${$1ee5bf1527ec861d$var$X2}/dist/dotlottie-player.wasm`;
            console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${d.message}`), console.warn(`Attempting to load WASM from backup URL: ${i}`);
            try {
                return await this._tryLoad(i);
            } catch (r) {
                throw console.error(`Primary WASM URL failed: ${d.message}`), console.error(`Backup WASM URL failed: ${r.message}`), new Error("WASM loading failed from all sources.");
            }
        })), this._ModulePromise;
    }
    static async load() {
        return this._loadWithBackup();
    }
    static setWasmUrl(d) {
        d !== this._wasmURL && (this._wasmURL = d, this._ModulePromise = null);
    }
};
$1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$z1, "_ModulePromise", null), $1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$z1, "_wasmURL", `https://cdn.jsdelivr.net/npm/${$1ee5bf1527ec861d$var$q2}@${$1ee5bf1527ec861d$var$X2}/dist/dotlottie-player.wasm`);
var $1ee5bf1527ec861d$var$J2 = class {
    constructor(){
        $1ee5bf1527ec861d$var$v(this, "_eventListeners", new Map);
    }
    addEventListener(d, i) {
        let r = this._eventListeners.get(d);
        r || (r = new Set, this._eventListeners.set(d, r)), r.add(i);
    }
    removeEventListener(d, i) {
        let r = this._eventListeners.get(d);
        r && (i ? (r.delete(i), r.size === 0 && this._eventListeners.delete(d)) : this._eventListeners.delete(d));
    }
    dispatch(d) {
        this._eventListeners.get(d.type)?.forEach((i)=>i(d));
    }
    removeAllEventListeners() {
        this._eventListeners.clear();
    }
}, $1ee5bf1527ec861d$var$N = class {
    static _initializeObserver() {
        if (this._observer) return;
        let d = (i)=>{
            i.forEach((r)=>{
                let s = this._observedCanvases.get(r.target);
                s && (r.isIntersecting ? s.unfreeze() : s.freeze());
            });
        };
        this._observer = new IntersectionObserver(d, {
            threshold: 0
        });
    }
    static observe(d, i) {
        this._initializeObserver(), !this._observedCanvases.has(d) && (this._observedCanvases.set(d, i), this._observer?.observe(d));
    }
    static unobserve(d) {
        this._observer?.unobserve(d), this._observedCanvases.delete(d), this._observedCanvases.size === 0 && (this._observer?.disconnect(), this._observer = null);
    }
};
$1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$N, "_observer", null), $1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$N, "_observedCanvases", new Map);
var $1ee5bf1527ec861d$var$X = class {
    static _initializeObserver() {
        if (this._observer) return;
        let d = (i)=>{
            i.forEach((r)=>{
                let s = this._observedCanvases.get(r.target);
                if (!s) return;
                let [p, P] = s;
                clearTimeout(P);
                let z = setTimeout(()=>{
                    p.resize();
                }, 100);
                this._observedCanvases.set(r.target, [
                    p,
                    z
                ]);
            });
        };
        this._observer = new ResizeObserver(d);
    }
    static observe(d, i) {
        this._initializeObserver(), !this._observedCanvases.has(d) && (this._observedCanvases.set(d, [
            i,
            0
        ]), this._observer?.observe(d));
    }
    static unobserve(d) {
        let i = this._observedCanvases.get(d);
        if (i) {
            let r = i[1];
            r && clearTimeout(r);
        }
        this._observer?.unobserve(d), this._observedCanvases.delete(d), !this._observedCanvases.size && this._observer && (this._observer.disconnect(), this._observer = null);
    }
};
$1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$X, "_observer", null), $1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$X, "_observedCanvases", new Map);
function $1ee5bf1527ec861d$var$n0(d) {
    return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(d);
}
function $1ee5bf1527ec861d$var$r0(d) {
    if (!$1ee5bf1527ec861d$var$n0(d)) return 0;
    let i = d.replace("#", "");
    return i = i.length === 6 ? `${i}ff` : i, parseInt(i, 16);
}
function $1ee5bf1527ec861d$var$B2(d) {
    if (d.byteLength < 4) return false;
    let i = new Uint8Array(d.slice(0, $1ee5bf1527ec861d$var$c2.byteLength));
    for(let r = 0; r < $1ee5bf1527ec861d$var$c2.length; r += 1)if ($1ee5bf1527ec861d$var$c2[r] !== i[r]) return false;
    return true;
}
function $1ee5bf1527ec861d$var$H2(d) {
    return $1ee5bf1527ec861d$var$K3.every((i)=>Object.prototype.hasOwnProperty.call(d, i));
}
function $1ee5bf1527ec861d$var$V2(d) {
    if (typeof d == "string") try {
        return $1ee5bf1527ec861d$var$H2(JSON.parse(d));
    } catch  {
        return false;
    }
    else return $1ee5bf1527ec861d$var$H2(d);
}
function $1ee5bf1527ec861d$var$o1() {
    return 1 + (($1ee5bf1527ec861d$var$A ? window.devicePixelRatio : 1) - 1) * $1ee5bf1527ec861d$var$t0;
}
function $1ee5bf1527ec861d$var$Y2(d) {
    let i = d.getBoundingClientRect();
    return i.top >= 0 && i.left >= 0 && i.bottom <= (window.innerHeight || document.documentElement.clientHeight) && i.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var $1ee5bf1527ec861d$var$l2 = (d, i)=>d === "reverse" ? i.Mode.Reverse : d === "bounce" ? i.Mode.Bounce : d === "reverse-bounce" ? i.Mode.ReverseBounce : i.Mode.Forward, $1ee5bf1527ec861d$var$o0 = (d, i)=>d === "contain" ? i.Fit.Contain : d === "cover" ? i.Fit.Cover : d === "fill" ? i.Fit.Fill : d === "fit-height" ? i.Fit.FitHeight : d === "fit-width" ? i.Fit.FitWidth : i.Fit.None, $1ee5bf1527ec861d$var$s0 = (d, i)=>{
    let r = new i.VectorFloat;
    return r.push_back(d[0]), r.push_back(d[1]), r;
}, $1ee5bf1527ec861d$var$u2 = (d, i)=>{
    let r = new i.VectorFloat;
    return d.length !== 2 || (r.push_back(d[0]), r.push_back(d[1])), r;
}, $1ee5bf1527ec861d$var$f2 = (d, i)=>d ? {
        align: $1ee5bf1527ec861d$var$s0(d.align ?? [
            .5,
            .5
        ], i),
        fit: $1ee5bf1527ec861d$var$o0(d.fit ?? "contain", i)
    } : i.createDefaultLayout(), $1ee5bf1527ec861d$var$Z2 = class b {
    constructor(i){
        $1ee5bf1527ec861d$var$v(this, "_canvas"), $1ee5bf1527ec861d$var$v(this, "_context", null), $1ee5bf1527ec861d$var$v(this, "_eventManager"), $1ee5bf1527ec861d$var$v(this, "_animationFrameId", null), $1ee5bf1527ec861d$var$v(this, "_frameManager"), $1ee5bf1527ec861d$var$v(this, "_dotLottieCore", null), $1ee5bf1527ec861d$var$v(this, "_renderConfig", {}), $1ee5bf1527ec861d$var$v(this, "_isFrozen", false), $1ee5bf1527ec861d$var$v(this, "_backgroundColor", null), $1ee5bf1527ec861d$var$v(this, "_pointerUpMethod"), $1ee5bf1527ec861d$var$v(this, "_pointerDownMethod"), $1ee5bf1527ec861d$var$v(this, "_pointerMoveMethod"), $1ee5bf1527ec861d$var$v(this, "_pointerEnterMethod"), $1ee5bf1527ec861d$var$v(this, "_pointerExitMethod"), this._canvas = i.canvas, this._eventManager = new $1ee5bf1527ec861d$var$J2, this._frameManager = new $1ee5bf1527ec861d$var$G3, this._renderConfig = {
            ...i.renderConfig,
            devicePixelRatio: i.renderConfig?.devicePixelRatio || $1ee5bf1527ec861d$var$o1(),
            freezeOnOffscreen: i.renderConfig?.freezeOnOffscreen ?? true
        }, $1ee5bf1527ec861d$var$z1.load().then((r)=>{
            b._wasmModule = r, this._dotLottieCore = new r.DotLottiePlayer({
                animationId: i.animationId ?? "",
                themeId: i.themeId ?? "",
                stateMachineId: "",
                autoplay: i.autoplay ?? false,
                backgroundColor: 0,
                loopAnimation: i.loop ?? false,
                mode: $1ee5bf1527ec861d$var$l2(i.mode ?? "forward", r),
                segment: $1ee5bf1527ec861d$var$u2(i.segment ?? [], r),
                speed: i.speed ?? 1,
                useFrameInterpolation: i.useFrameInterpolation ?? true,
                marker: i.marker ?? "",
                layout: $1ee5bf1527ec861d$var$f2(i.layout, r)
            }), this._eventManager.dispatch({
                type: "ready"
            }), i.data ? this._loadFromData(i.data) : i.src && this._loadFromSrc(i.src), i.backgroundColor && this.setBackgroundColor(i.backgroundColor);
        }).catch((r)=>{
            this._eventManager.dispatch({
                type: "loadError",
                error: new Error(`Failed to load wasm module: ${r}`)
            });
        }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
    }
    _dispatchError(i) {
        console.error(i), this._eventManager.dispatch({
            type: "loadError",
            error: new Error(i)
        });
    }
    async _fetchData(i) {
        let r = await fetch(i);
        if (!r.ok) throw new Error(`Failed to fetch animation data from URL: ${i}. ${r.status}: ${r.statusText}`);
        let s = await r.arrayBuffer();
        return $1ee5bf1527ec861d$var$B2(s) ? s : new TextDecoder().decode(s);
    }
    _loadFromData(i) {
        if (this._dotLottieCore === null) return;
        let r = this._canvas.width, s = this._canvas.height, p = false;
        if (typeof i == "string") {
            if (!$1ee5bf1527ec861d$var$V2(i)) {
                this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
                return;
            }
            p = this._dotLottieCore.loadAnimationData(i, r, s);
        } else if (i instanceof ArrayBuffer) {
            if (!$1ee5bf1527ec861d$var$B2(i)) {
                this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
                return;
            }
            p = this._dotLottieCore.loadDotLottieData(i, r, s);
        } else if (typeof i == "object") {
            if (!$1ee5bf1527ec861d$var$V2(i)) {
                this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
                return;
            }
            p = this._dotLottieCore.loadAnimationData(JSON.stringify(i), r, s);
        } else {
            this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof i}`);
            return;
        }
        p ? (this._eventManager.dispatch({
            type: "load"
        }), $1ee5bf1527ec861d$var$A && this.resize(), this._eventManager.dispatch({
            type: "frame",
            currentFrame: this.currentFrame
        }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({
            type: "play"
        }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && $1ee5bf1527ec861d$var$N.observe(this._canvas, this), this._renderConfig.autoResize && $1ee5bf1527ec861d$var$X.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
    }
    _loadFromSrc(i) {
        this._fetchData(i).then((r)=>this._loadFromData(r)).catch((r)=>this._dispatchError(`Failed to load animation data from URL: ${i}. ${r}`));
    }
    get buffer() {
        return this._dotLottieCore ? this._dotLottieCore.buffer() : null;
    }
    get activeAnimationId() {
        return this._dotLottieCore?.activeAnimationId();
    }
    get activeThemeId() {
        return this._dotLottieCore?.activeThemeId();
    }
    get layout() {
        let i = this._dotLottieCore?.config().layout;
        if (i) return {
            align: [
                i.align.get(0),
                i.align.get(1)
            ],
            fit: (()=>{
                switch(i.fit){
                    case b._wasmModule?.Fit.Contain:
                        return "contain";
                    case b._wasmModule?.Fit.Cover:
                        return "cover";
                    case b._wasmModule?.Fit.Fill:
                        return "fill";
                    case b._wasmModule?.Fit.FitHeight:
                        return "fit-height";
                    case b._wasmModule?.Fit.FitWidth:
                        return "fit-width";
                    case b._wasmModule?.Fit.None:
                        return "none";
                    default:
                        return "contain";
                }
            })()
        };
    }
    get marker() {
        return this._dotLottieCore?.config().marker;
    }
    get manifest() {
        try {
            let i = this._dotLottieCore?.manifestString();
            if (this._dotLottieCore === null || !i) return null;
            let r = JSON.parse(i);
            return Object.keys(r).length === 0 ? null : r;
        } catch  {
            return null;
        }
    }
    get renderConfig() {
        return this._renderConfig;
    }
    get segment() {
        let i = this._dotLottieCore?.config().segment;
        if (i && i.size() === 2) return [
            i.get(0),
            i.get(1)
        ];
    }
    get loop() {
        return this._dotLottieCore?.config().loopAnimation ?? false;
    }
    get mode() {
        let i = this._dotLottieCore?.config().mode;
        return i === b._wasmModule?.Mode.Reverse ? "reverse" : i === b._wasmModule?.Mode.Bounce ? "bounce" : i === b._wasmModule?.Mode.ReverseBounce ? "reverse-bounce" : "forward";
    }
    get isFrozen() {
        return this._isFrozen;
    }
    get backgroundColor() {
        return this._backgroundColor ?? "";
    }
    get autoplay() {
        return this._dotLottieCore?.config().autoplay ?? false;
    }
    get useFrameInterpolation() {
        return this._dotLottieCore?.config().useFrameInterpolation ?? false;
    }
    get speed() {
        return this._dotLottieCore?.config().speed ?? 0;
    }
    get isReady() {
        return this._dotLottieCore !== null;
    }
    get isLoaded() {
        return this._dotLottieCore?.isLoaded() ?? false;
    }
    get isPlaying() {
        return this._dotLottieCore?.isPlaying() ?? false;
    }
    get isPaused() {
        return this._dotLottieCore?.isPaused() ?? false;
    }
    get isStopped() {
        return this._dotLottieCore?.isStopped() ?? false;
    }
    get currentFrame() {
        return this._dotLottieCore ? Math.round(this._dotLottieCore.currentFrame() * 100) / 100 : 0;
    }
    get loopCount() {
        return this._dotLottieCore?.loopCount() ?? 0;
    }
    get totalFrames() {
        return this._dotLottieCore?.totalFrames() ?? 0;
    }
    get duration() {
        return this._dotLottieCore?.duration() ?? 0;
    }
    get segmentDuration() {
        return this._dotLottieCore?.segmentDuration() ?? 0;
    }
    get canvas() {
        return this._canvas;
    }
    load(i) {
        this._dotLottieCore === null || b._wasmModule === null || (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), this._isFrozen = false, this._dotLottieCore.setConfig({
            animationId: i.animationId ?? "",
            themeId: i.themeId ?? "",
            stateMachineId: "",
            autoplay: i.autoplay ?? false,
            backgroundColor: 0,
            loopAnimation: i.loop ?? false,
            mode: $1ee5bf1527ec861d$var$l2(i.mode ?? "forward", b._wasmModule),
            segment: $1ee5bf1527ec861d$var$u2(i.segment ?? [], b._wasmModule),
            speed: i.speed ?? 1,
            useFrameInterpolation: i.useFrameInterpolation ?? true,
            marker: i.marker ?? "",
            layout: $1ee5bf1527ec861d$var$f2(i.layout, b._wasmModule)
        }), i.data ? this._loadFromData(i.data) : i.src && this._loadFromSrc(i.src), this.setBackgroundColor(i.backgroundColor ?? ""));
    }
    _render() {
        if (this._dotLottieCore === null) return false;
        if (!this._context && "getContext" in this._canvas && typeof this._canvas.getContext == "function" && (this._context = this._canvas.getContext("2d")), this._dotLottieCore.render()) {
            if (this._context) {
                let i = this._dotLottieCore.buffer(), r = this._canvas.width * this._canvas.height * $1ee5bf1527ec861d$var$e0;
                if (i.byteLength !== r) return console.warn(`Buffer size mismatch: got ${i.byteLength}, expected ${r}`), false;
                let s = null, p = new Uint8ClampedArray(i, 0, i.byteLength);
                typeof ImageData > "u" ? (s = this._context.createImageData(this._canvas.width, this._canvas.height), s.data.set(p)) : s = new ImageData(p, this._canvas.width, this._canvas.height), this._context.putImageData(s, 0, 0);
            }
            return this._eventManager.dispatch({
                type: "render",
                currentFrame: this.currentFrame
            }), true;
        }
        return false;
    }
    _draw() {
        if (!(this._dotLottieCore === null || !this._dotLottieCore.isPlaying())) try {
            let i = Math.round(this._dotLottieCore.requestFrame() * 1e3) / 1e3;
            if (this._dotLottieCore.setFrame(i) && (this._eventManager.dispatch({
                type: "frame",
                currentFrame: this.currentFrame
            }), this._render() && this._dotLottieCore.isComplete())) {
                if (this._dotLottieCore.config().loopAnimation) this._eventManager.dispatch({
                    type: "loop",
                    loopCount: this._dotLottieCore.loopCount()
                });
                else {
                    this._eventManager.dispatch({
                        type: "complete"
                    });
                    return;
                }
            }
            this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
        } catch (i) {
            console.error("Error in animation frame:", i), this._eventManager.dispatch({
                type: "renderError",
                error: i
            }), i instanceof WebAssembly.RuntimeError && this.destroy();
        }
    }
    play() {
        this._dotLottieCore !== null && (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), (this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = false, this._eventManager.dispatch({
            type: "play"
        }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !$1ee5bf1527ec861d$var$Y2(this._canvas) && this.freeze());
    }
    pause() {
        this._dotLottieCore !== null && (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({
            type: "pause"
        });
    }
    stop() {
        this._dotLottieCore !== null && this._dotLottieCore.stop() && (this._eventManager.dispatch({
            type: "frame",
            currentFrame: this.currentFrame
        }), this._render(), this._eventManager.dispatch({
            type: "stop"
        }));
    }
    setFrame(i) {
        this._dotLottieCore === null || i < 0 || i > this._dotLottieCore.totalFrames() || this._dotLottieCore.seek(i) && (this._eventManager.dispatch({
            type: "frame",
            currentFrame: this.currentFrame
        }), this._render());
    }
    setSpeed(i) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            speed: i
        });
    }
    setBackgroundColor(i) {
        this._dotLottieCore !== null && ($1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = i : this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            backgroundColor: $1ee5bf1527ec861d$var$r0(i)
        }), this._backgroundColor = i);
    }
    setLoop(i) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            loopAnimation: i
        });
    }
    setUseFrameInterpolation(i) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            useFrameInterpolation: i
        });
    }
    addEventListener(i, r) {
        this._eventManager.addEventListener(i, r);
    }
    removeEventListener(i, r) {
        this._eventManager.removeEventListener(i, r);
    }
    destroy() {
        this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && ($1ee5bf1527ec861d$var$N.unobserve(this._canvas), $1ee5bf1527ec861d$var$X.unobserve(this._canvas)), this._dotLottieCore?.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({
            type: "destroy"
        }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
    }
    freeze() {
        this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = true, this._eventManager.dispatch({
            type: "freeze"
        }));
    }
    unfreeze() {
        this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = false, this._eventManager.dispatch({
            type: "unfreeze"
        }));
    }
    resize() {
        if (!(!this._dotLottieCore || !this.isLoaded)) {
            if ($1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement) {
                let i = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: r, width: s } = this._canvas.getBoundingClientRect();
                r !== 0 && s !== 0 && (this._canvas.width = s * i, this._canvas.height = r * i);
            }
            this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
        }
    }
    setSegment(i, r) {
        this._dotLottieCore === null || b._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            segment: $1ee5bf1527ec861d$var$u2([
                i,
                r
            ], b._wasmModule)
        });
    }
    setMode(i) {
        this._dotLottieCore === null || b._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            mode: $1ee5bf1527ec861d$var$l2(i, b._wasmModule)
        });
    }
    setRenderConfig(i) {
        let { devicePixelRatio: r, freezeOnOffscreen: s, ...p } = i;
        this._renderConfig = {
            ...this._renderConfig,
            ...p,
            devicePixelRatio: r || $1ee5bf1527ec861d$var$o1(),
            freezeOnOffscreen: s ?? true
        }, $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? $1ee5bf1527ec861d$var$X.observe(this._canvas, this) : $1ee5bf1527ec861d$var$X.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? $1ee5bf1527ec861d$var$N.observe(this._canvas, this) : ($1ee5bf1527ec861d$var$N.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
    }
    loadAnimation(i) {
        this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === i || (this._dotLottieCore.loadAnimation(i, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({
            type: "load"
        }), this.resize()) : this._eventManager.dispatch({
            type: "loadError",
            error: new Error(`Failed to animation :${i}`)
        }));
    }
    setMarker(i) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            marker: i
        });
    }
    markers() {
        let i = this._dotLottieCore?.markers();
        if (i) {
            let r = [];
            for(let s = 0; s < i.size(); s += 1){
                let p = i.get(s);
                r.push({
                    name: p.name,
                    time: p.time,
                    duration: p.duration
                });
            }
            return r;
        }
        return [];
    }
    setTheme(i) {
        if (this._dotLottieCore === null) return false;
        let r = this._dotLottieCore.setTheme(i);
        return this._render(), r;
    }
    resetTheme() {
        return this._dotLottieCore === null ? false : this._dotLottieCore.resetTheme();
    }
    setThemeData(i) {
        if (this._dotLottieCore === null) return false;
        let r = this._dotLottieCore.setThemeData(i);
        return this._render(), r;
    }
    setSlots(i) {
        this._dotLottieCore !== null && this._dotLottieCore.setSlots(i);
    }
    setLayout(i) {
        this._dotLottieCore === null || b._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            layout: $1ee5bf1527ec861d$var$f2(i, b._wasmModule)
        });
    }
    setViewport(i, r, s, p) {
        return this._dotLottieCore === null ? false : this._dotLottieCore.setViewport(i, r, s, p);
    }
    static setWasmUrl(i) {
        $1ee5bf1527ec861d$var$z1.setWasmUrl(i);
    }
    loadStateMachine(i) {
        return this._dotLottieCore?.stateMachineLoad(i) ?? false;
    }
    startStateMachine() {
        if (b._wasmModule === null || this._dotLottieCore === null) return false;
        let i = b._wasmModule.createDefaultOpenURL(), r = this._dotLottieCore.stateMachineStart(i);
        return r && this._setupStateMachineListeners(), r;
    }
    stopStateMachine() {
        let i = this._dotLottieCore?.stateMachineStop() ?? false;
        return i && this._cleanupStateMachineListeners(), i;
    }
    _getPointerPosition(i) {
        let r = this._canvas.getBoundingClientRect(), s = this._canvas.width / r.width, p = this._canvas.height / r.height, P = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, z = (i.clientX - r.left) * s / P, F = (i.clientY - r.top) * p / P;
        return {
            x: z,
            y: F
        };
    }
    _onPointerUp(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this.postPointerUpEvent(r, s);
    }
    _onPointerDown(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this.postPointerDownEvent(r, s);
    }
    _onPointerMove(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this.postPointerMoveEvent(r, s);
    }
    _onPointerEnter(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this.postPointerEnterEvent(r, s);
    }
    _onPointerLeave(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this.postPointerExitEvent(r, s);
    }
    postPointerUpEvent(i, r) {
        return this._dotLottieCore?.stateMachinePostPointerUpEvent(i, r);
    }
    postPointerDownEvent(i, r) {
        return this._dotLottieCore?.stateMachinePostPointerDownEvent(i, r);
    }
    postPointerMoveEvent(i, r) {
        return this._dotLottieCore?.stateMachinePostPointerMoveEvent(i, r);
    }
    postPointerEnterEvent(i, r) {
        return this._dotLottieCore?.stateMachinePostPointerEnterEvent(i, r);
    }
    postPointerExitEvent(i, r) {
        return this._dotLottieCore?.stateMachinePostPointerExitEvent(i, r);
    }
    getStateMachineListeners() {
        if (!this._dotLottieCore) return [];
        let i = this._dotLottieCore.stateMachineFrameworkSetup(), r = [];
        for(let s = 0; s < i.size(); s += 1)r.push(i.get(s));
        return r;
    }
    _setupStateMachineListeners() {
        if ($1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
            let i = this.getStateMachineListeners();
            i.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), i.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), i.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), i.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), i.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
        }
    }
    _cleanupStateMachineListeners() {
        $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
    }
    loadStateMachineData(i) {
        return this._dotLottieCore?.stateMachineLoadData(i) ?? false;
    }
    animationSize() {
        let i = this._dotLottieCore?.animationSize().get(0) ?? 0, r = this._dotLottieCore?.animationSize().get(1) ?? 0;
        return {
            width: i,
            height: r
        };
    }
    setStateMachineBooleanContext(i, r) {
        return this._dotLottieCore?.stateMachineSetBooleanInput(i, r) ?? false;
    }
    setStateMachineNumericContext(i, r) {
        return this._dotLottieCore?.stateMachineSetNumericInput(i, r) ?? false;
    }
    setStateMachineStringContext(i, r) {
        return this._dotLottieCore?.stateMachineSetStringInput(i, r) ?? false;
    }
    getLayerBoundingBox(i) {
        let r = this._dotLottieCore?.getLayerBounds(i);
        if (!r || r.size() !== 8) return;
        let s = [];
        for(let p = 0; p < 8; p += 1)s.push(r.get(p));
        return s;
    }
    static transformThemeToLottieSlots(i, r) {
        return b._wasmModule?.transformThemeToLottieSlots(i, r) ?? "";
    }
};
$1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$Z2, "_wasmModule", null);
var $1ee5bf1527ec861d$var$B1 = $1ee5bf1527ec861d$var$Z2, $1ee5bf1527ec861d$var$h0 = class {
    constructor(){
        if (typeof Worker > "u") throw new Error("Worker is not supported in this environment.");
        let d = new Blob([
            new Uint8Array([
                34,
                117,
                115,
                101,
                32,
                115,
                116,
                114,
                105,
                99,
                116,
                34,
                59,
                10,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                107,
                101,
                121,
                32,
                105,
                110,
                32,
                111,
                98,
                106,
                32,
                63,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                123,
                32,
                101,
                110,
                117,
                109,
                101,
                114,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                117,
                114,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                119,
                114,
                105,
                116,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                125,
                41,
                32,
                58,
                32,
                111,
                98,
                106,
                91,
                107,
                101,
                121,
                93,
                32,
                61,
                32,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                32,
                61,
                32,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                40,
                111,
                98,
                106,
                44,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                101,
                121,
                32,
                33,
                61,
                61,
                32,
                34,
                115,
                121,
                109,
                98,
                111,
                108,
                34,
                32,
                63,
                32,
                107,
                101,
                121,
                32,
                43,
                32,
                34,
                34,
                32,
                58,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                45,
                102,
                114,
                97,
                109,
                101,
                45,
                109,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                87,
                101,
                98,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                78,
                111,
                100,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                34,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                62,
                61,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                46,
                77,
                65,
                88,
                95,
                83,
                65,
                70,
                69,
                95,
                73,
                78,
                84,
                69,
                71,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                43,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                32,
                61,
                32,
                115,
                101,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                40,
                68,
                97,
                116,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                95,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                101,
                97,
                114,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                87,
                101,
                98,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                40,
                41,
                32,
                58,
                32,
                110,
                101,
                119,
                32,
                78,
                111,
                100,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                110,
                115,
                116,
                97,
                110,
                116,
                115,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                32,
                33,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                38,
                38,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                33,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                91,
                56,
                48,
                44,
                32,
                55,
                53,
                44,
                32,
                51,
                44,
                32,
                52,
                93,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                76,
                79,
                84,
                84,
                73,
                69,
                95,
                74,
                83,
                79,
                78,
                95,
                77,
                65,
                78,
                68,
                65,
                84,
                79,
                82,
                89,
                95,
                70,
                73,
                69,
                76,
                68,
                83,
                32,
                61,
                32,
                91,
                34,
                118,
                34,
                44,
                32,
                34,
                105,
                112,
                34,
                44,
                32,
                34,
                111,
                112,
                34,
                44,
                32,
                34,
                108,
                97,
                121,
                101,
                114,
                115,
                34,
                44,
                32,
                34,
                102,
                114,
                34,
                44,
                32,
                34,
                119,
                34,
                44,
                32,
                34,
                104,
                34,
                93,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                32,
                61,
                32,
                34,
                48,
                46,
                52,
                55,
                46,
                48,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                32,
                61,
                32,
                34,
                64,
                108,
                111,
                116,
                116,
                105,
                101,
                102,
                105,
                108,
                101,
                115,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                119,
                101,
                98,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                69,
                70,
                65,
                85,
                76,
                84,
                95,
                68,
                80,
                82,
                95,
                70,
                65,
                67,
                84,
                79,
                82,
                32,
                61,
                32,
                48,
                46,
                55,
                53,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                66,
                89,
                84,
                69,
                83,
                95,
                80,
                69,
                82,
                95,
                80,
                73,
                88,
                69,
                76,
                32,
                61,
                32,
                52,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                114,
                101,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                106,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                33,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                63,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                63,
                46,
                115,
                114,
                99,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                109,
                111,
                100,
                117,
                108,
                101,
                65,
                114,
                103,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                65,
                114,
                103,
                44,
                32,
                97,
                97,
                44,
                32,
                98,
                97,
                44,
                32,
                99,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                40,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                44,
                32,
                100,
                97,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                123,
                125,
                44,
                32,
                107,
                41,
                44,
                32,
                101,
                97,
                32,
                61,
                32,
                34,
                46,
                47,
                116,
                104,
                105,
                115,
                46,
                112,
                114,
                111,
                103,
                114,
                97,
                109,
                34,
                44,
                32,
                113,
                32,
                61,
                32,
                34,
                34,
                44,
                32,
                105,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                32,
                38,
                38,
                32,
                40,
                113,
                32,
                61,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                32,
                38,
                38,
                32,
                40,
                113,
                32,
                61,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                98,
                108,
                111,
                98,
                58,
                34,
                41,
                32,
                63,
                32,
                113,
                32,
                61,
                32,
                34,
                34,
                32,
                58,
                32,
                113,
                32,
                61,
                32,
                113,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                40,
                48,
                44,
                32,
                113,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                91,
                63,
                35,
                93,
                46,
                42,
                47,
                44,
                32,
                34,
                34,
                41,
                46,
                108,
                97,
                115,
                116,
                73,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                47,
                34,
                41,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                97,
                32,
                61,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                97,
                44,
                32,
                123,
                32,
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                115,
                58,
                32,
                34,
                115,
                97,
                109,
                101,
                45,
                111,
                114,
                105,
                103,
                105,
                110,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                46,
                111,
                107,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                46,
                97,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                97,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                43,
                32,
                34,
                32,
                58,
                32,
                34,
                32,
                43,
                32,
                97,
                46,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                106,
                97,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                105,
                110,
                116,
                32,
                124,
                124,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                108,
                111,
                103,
                46,
                98,
                105,
                110,
                100,
                40,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                41,
                44,
                32,
                114,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                105,
                110,
                116,
                69,
                114,
                114,
                32,
                124,
                124,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                46,
                98,
                105,
                110,
                100,
                40,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                107,
                44,
                32,
                100,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                116,
                104,
                105,
                115,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                32,
                38,
                38,
                32,
                40,
                101,
                97,
                32,
                61,
                32,
                107,
                46,
                116,
                104,
                105,
                115,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                97,
                32,
                61,
                32,
                107,
                46,
                119,
                97,
                115,
                109,
                66,
                105,
                110,
                97,
                114,
                121,
                44,
                32,
                108,
                97,
                44,
                32,
                109,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                110,
                97,
                44,
                32,
                117,
                44,
                32,
                120,
                44,
                32,
                121,
                44,
                32,
                122,
                44,
                32,
                65,
                44,
                32,
                66,
                44,
                32,
                111,
                97,
                44,
                32,
                112,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                113,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                108,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                56,
                32,
                61,
                32,
                117,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                49,
                54,
                32,
                61,
                32,
                121,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                56,
                32,
                61,
                32,
                120,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                49,
                54,
                32,
                61,
                32,
                122,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                51,
                50,
                32,
                61,
                32,
                65,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                51,
                50,
                32,
                61,
                32,
                66,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                70,
                51,
                50,
                32,
                61,
                32,
                111,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                108,
                111,
                97,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                70,
                54,
                52,
                32,
                61,
                32,
                112,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                108,
                111,
                97,
                116,
                54,
                52,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                114,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                115,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                116,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                67,
                32,
                61,
                32,
                48,
                44,
                32,
                68,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                118,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                111,
                110,
                65,
                98,
                111,
                114,
                116,
                63,
                46,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                34,
                65,
                98,
                111,
                114,
                116,
                101,
                100,
                40,
                34,
                32,
                43,
                32,
                97,
                32,
                43,
                32,
                34,
                41,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                97,
                32,
                43,
                32,
                34,
                46,
                32,
                66,
                117,
                105,
                108,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                45,
                115,
                65,
                83,
                83,
                69,
                82,
                84,
                73,
                79,
                78,
                83,
                32,
                102,
                111,
                114,
                32,
                109,
                111,
                114,
                101,
                32,
                105,
                110,
                102,
                111,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                119,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                97,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                100,
                97,
                116,
                97,
                58,
                97,
                112,
                112,
                108,
                105,
                99,
                97,
                116,
                105,
                111,
                110,
                47,
                111,
                99,
                116,
                101,
                116,
                45,
                115,
                116,
                114,
                101,
                97,
                109,
                59,
                98,
                97,
                115,
                101,
                54,
                52,
                44,
                34,
                41,
                44,
                32,
                120,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                121,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                107,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                105,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                32,
                61,
                61,
                32,
                120,
                97,
                32,
                38,
                38,
                32,
                107,
                97,
                41,
                32,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                107,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                34,
                98,
                111,
                116,
                104,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                97,
                110,
                100,
                32,
                115,
                121,
                110,
                99,
                32,
                102,
                101,
                116,
                99,
                104,
                105,
                110,
                103,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                119,
                97,
                115,
                109,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                122,
                97,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                121,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                40,
                99,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                40,
                96,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                97,
                115,
                121,
                110,
                99,
                104,
                114,
                111,
                110,
                111,
                117,
                115,
                108,
                121,
                32,
                112,
                114,
                101,
                112,
                97,
                114,
                101,
                32,
                119,
                97,
                115,
                109,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                118,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                65,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                120,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                107,
                97,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                83,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                32,
                38,
                38,
                32,
                33,
                119,
                97,
                40,
                98,
                41,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                102,
                101,
                116,
                99,
                104,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                98,
                44,
                32,
                123,
                32,
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                115,
                58,
                32,
                34,
                115,
                97,
                109,
                101,
                45,
                111,
                114,
                105,
                103,
                105,
                110,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                83,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                40,
                99,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                40,
                96,
                119,
                97,
                115,
                109,
                32,
                115,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                32,
                99,
                111,
                109,
                112,
                105,
                108,
                101,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                114,
                40,
                34,
                102,
                97,
                108,
                108,
                105,
                110,
                103,
                32,
                98,
                97,
                99,
                107,
                32,
                116,
                111,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                122,
                97,
                40,
                98,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                66,
                97,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                34,
                69,
                120,
                105,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                96,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                32,
                116,
                101,
                114,
                109,
                105,
                110,
                97,
                116,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                101,
                120,
                105,
                116,
                40,
                36,
                123,
                97,
                125,
                41,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                67,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                48,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                97,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                68,
                97,
                32,
                61,
                32,
                107,
                46,
                110,
                111,
                69,
                120,
                105,
                116,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                32,
                124,
                124,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                69,
                97,
                32,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                71,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                99,
                32,
                61,
                32,
                78,
                97,
                78,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                99,
                32,
                61,
                32,
                98,
                59,
                32,
                97,
                91,
                99,
                93,
                32,
                38,
                38,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                100,
                41,
                59,
                32,
                41,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                54,
                32,
                60,
                32,
                99,
                32,
                45,
                32,
                98,
                32,
                38,
                38,
                32,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                32,
                38,
                38,
                32,
                69,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                69,
                97,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                97,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                98,
                44,
                32,
                99,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                100,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                98,
                32,
                60,
                32,
                99,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                38,
                32,
                49,
                50,
                56,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                57,
                50,
                32,
                61,
                61,
                32,
                40,
                101,
                32,
                38,
                32,
                50,
                50,
                52,
                41,
                41,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                40,
                101,
                32,
                38,
                32,
                51,
                49,
                41,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                50,
                50,
                52,
                32,
                61,
                61,
                32,
                40,
                101,
                32,
                38,
                32,
                50,
                52,
                48,
                41,
                32,
                63,
                32,
                40,
                101,
                32,
                38,
                32,
                49,
                53,
                41,
                32,
                60,
                60,
                32,
                49,
                50,
                32,
                124,
                32,
                102,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                104,
                32,
                58,
                32,
                40,
                101,
                32,
                38,
                32,
                55,
                41,
                32,
                60,
                60,
                32,
                49,
                56,
                32,
                124,
                32,
                102,
                32,
                60,
                60,
                32,
                49,
                50,
                32,
                124,
                32,
                104,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                62,
                32,
                101,
                32,
                63,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                32,
                58,
                32,
                40,
                101,
                32,
                45,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                44,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                124,
                32,
                101,
                32,
                62,
                62,
                32,
                49,
                48,
                44,
                32,
                53,
                54,
                51,
                50,
                48,
                32,
                124,
                32,
                101,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                73,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                70,
                97,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                80,
                97,
                32,
                61,
                32,
                97,
                32,
                45,
                32,
                50,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                72,
                97,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                98,
                32,
                61,
                32,
                73,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                74,
                40,
                48,
                41,
                44,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                99,
                46,
                80,
                97,
                32,
                43,
                32,
                49,
                54,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                66,
                91,
                99,
                46,
                80,
                97,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                74,
                40,
                48,
                41,
                44,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                111,
                102,
                32,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                124,
                124,
                32,
                101,
                32,
                61,
                61,
                61,
                32,
                100,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                71,
                97,
                40,
                101,
                44,
                32,
                100,
                44,
                32,
                99,
                46,
                80,
                97,
                32,
                43,
                32,
                49,
                54,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                74,
                40,
                101,
                41,
                44,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                73,
                97,
                32,
                61,
                32,
                48,
                44,
                32,
                75,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                60,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                32,
                45,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                102,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                43,
                43,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                43,
                32,
                40,
                40,
                102,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                32,
                60,
                60,
                32,
                49,
                48,
                41,
                32,
                124,
                32,
                104,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                50,
                55,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                48,
                52,
                55,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                49,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                57,
                50,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                54,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                54,
                53,
                53,
                51,
                53,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                50,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                50,
                50,
                52,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                51,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                50,
                52,
                48,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                50,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                54,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                74,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                75,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                112,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                112,
                111,
                112,
                40,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                76,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                66,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                77,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                78,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                76,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                77,
                97,
                44,
                32,
                80,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                99,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                40,
                34,
                77,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                101,
                100,
                32,
                116,
                121,
                112,
                101,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                101,
                114,
                32,
                99,
                111,
                117,
                110,
                116,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                48,
                59,
                32,
                108,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                108,
                41,
                32,
                79,
                40,
                97,
                91,
                108,
                93,
                44,
                32,
                103,
                91,
                108,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                76,
                97,
                91,
                103,
                93,
                32,
                61,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                44,
                32,
                102,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                104,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                103,
                41,
                32,
                63,
                32,
                101,
                91,
                108,
                93,
                32,
                61,
                32,
                78,
                91,
                103,
                93,
                32,
                58,
                32,
                40,
                102,
                46,
                112,
                117,
                115,
                104,
                40,
                103,
                41,
                44,
                32,
                77,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                103,
                41,
                32,
                124,
                124,
                32,
                40,
                77,
                91,
                103,
                93,
                32,
                61,
                32,
                91,
                93,
                41,
                44,
                32,
                77,
                91,
                103,
                93,
                46,
                112,
                117,
                115,
                104,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                91,
                108,
                93,
                32,
                61,
                32,
                78,
                91,
                103,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                43,
                43,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                61,
                61,
                32,
                102,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                100,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                102,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                100,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                78,
                97,
                44,
                32,
                81,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                120,
                91,
                97,
                93,
                59,
                32,
                41,
                32,
                98,
                32,
                43,
                61,
                32,
                78,
                97,
                91,
                120,
                91,
                97,
                43,
                43,
                93,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                79,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                116,
                121,
                112,
                101,
                32,
                34,
                36,
                123,
                100,
                125,
                34,
                32,
                109,
                117,
                115,
                116,
                32,
                104,
                97,
                118,
                101,
                32,
                97,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                118,
                101,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                105,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                78,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                46,
                118,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                39,
                36,
                123,
                100,
                125,
                39,
                32,
                116,
                119,
                105,
                99,
                101,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                76,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                32,
                38,
                38,
                32,
                40,
                98,
                32,
                61,
                32,
                77,
                91,
                97,
                93,
                44,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                77,
                91,
                97,
                93,
                44,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                41,
                32,
                61,
                62,
                32,
                101,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                79,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                79,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                81,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                97,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                43,
                32,
                34,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                83,
                97,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                84,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                61,
                61,
                61,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                46,
                85,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                84,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                46,
                85,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                97,
                32,
                63,
                32,
                110,
                117,
                108,
                108,
                32,
                58,
                32,
                99,
                46,
                111,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                85,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                86,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                87,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                112,
                116,
                114,
                32,
                115,
                104,
                111,
                117,
                108,
                100,
                32,
                110,
                111,
                116,
                32,
                98,
                101,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                97,
                46,
                85,
                97,
                59,
                32,
                41,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                101,
                98,
                40,
                98,
                41,
                44,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                85,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                86,
                97,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                89,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                82,
                97,
                32,
                124,
                124,
                32,
                33,
                98,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                40,
                34,
                109,
                97,
                107,
                101,
                67,
                108,
                97,
                115,
                115,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                114,
                101,
                113,
                117,
                105,
                114,
                101,
                115,
                32,
                112,
                116,
                114,
                32,
                97,
                110,
                100,
                32,
                112,
                116,
                114,
                84,
                121,
                112,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                33,
                98,
                46,
                86,
                97,
                32,
                33,
                61,
                61,
                32,
                33,
                33,
                98,
                46,
                84,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                40,
                34,
                66,
                111,
                116,
                104,
                32,
                115,
                109,
                97,
                114,
                116,
                80,
                116,
                114,
                84,
                121,
                112,
                101,
                32,
                97,
                110,
                100,
                32,
                115,
                109,
                97,
                114,
                116,
                80,
                116,
                114,
                32,
                109,
                117,
                115,
                116,
                32,
                98,
                101,
                32,
                115,
                112,
                101,
                99,
                105,
                102,
                105,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                32,
                61,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                49,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                88,
                97,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                97,
                44,
                32,
                123,
                32,
                79,
                97,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                98,
                44,
                32,
                119,
                114,
                105,
                116,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                88,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                61,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                70,
                105,
                110,
                97,
                108,
                105,
                122,
                97,
                116,
                105,
                111,
                110,
                82,
                101,
                103,
                105,
                115,
                116,
                114,
                121,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                88,
                97,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                98,
                44,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                105,
                110,
                97,
                108,
                105,
                122,
                97,
                116,
                105,
                111,
                110,
                82,
                101,
                103,
                105,
                115,
                116,
                114,
                121,
                40,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                45,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                38,
                38,
                32,
                40,
                98,
                46,
                84,
                97,
                32,
                63,
                32,
                98,
                46,
                86,
                97,
                46,
                89,
                97,
                40,
                98,
                46,
                84,
                97,
                41,
                32,
                58,
                32,
                98,
                46,
                82,
                97,
                46,
                81,
                97,
                46,
                89,
                97,
                40,
                98,
                46,
                80,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                84,
                97,
                32,
                38,
                38,
                32,
                82,
                97,
                46,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                40,
                98,
                44,
                32,
                123,
                32,
                79,
                97,
                58,
                32,
                99,
                32,
                125,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                97,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                97,
                46,
                117,
                110,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                88,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                90,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                36,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                98,
                44,
                32,
                34,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                97,
                32,
                125,
                41,
                44,
                32,
                98,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                70,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                39,
                36,
                123,
                99,
                125,
                39,
                32,
                99,
                97,
                108,
                108,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                97,
                110,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                32,
                40,
                36,
                123,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                125,
                41,
                32,
                45,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                115,
                32,
                111,
                110,
                101,
                32,
                111,
                102,
                32,
                40,
                36,
                123,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                125,
                41,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                91,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                91,
                100,
                46,
                97,
                98,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                99,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                91,
                99,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                112,
                117,
                98,
                108,
                105,
                99,
                32,
                110,
                97,
                109,
                101,
                32,
                39,
                36,
                123,
                97,
                125,
                39,
                32,
                116,
                119,
                105,
                99,
                101,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                98,
                40,
                107,
                44,
                32,
                97,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                99,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                109,
                117,
                108,
                116,
                105,
                112,
                108,
                101,
                32,
                111,
                118,
                101,
                114,
                108,
                111,
                97,
                100,
                115,
                32,
                111,
                102,
                32,
                97,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                119,
                105,
                116,
                104,
                32,
                116,
                104,
                101,
                32,
                115,
                97,
                109,
                101,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                32,
                40,
                36,
                123,
                99,
                125,
                41,
                33,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                91,
                99,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                107,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                44,
                32,
                107,
                91,
                97,
                93,
                46,
                97,
                98,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                100,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                91,
                94,
                97,
                45,
                122,
                65,
                45,
                90,
                48,
                45,
                57,
                95,
                93,
                47,
                103,
                44,
                32,
                34,
                36,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                52,
                56,
                32,
                60,
                61,
                32,
                98,
                32,
                38,
                38,
                32,
                53,
                55,
                32,
                62,
                61,
                32,
                98,
                32,
                63,
                32,
                96,
                95,
                36,
                123,
                97,
                125,
                96,
                32,
                58,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                36,
                97,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                85,
                97,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                113,
                98,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                101,
                98,
                32,
                61,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                111,
                98,
                32,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                120,
                98,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                98,
                32,
                33,
                61,
                61,
                32,
                99,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                101,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                69,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                110,
                117,
                108,
                108,
                32,
                111,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                111,
                102,
                32,
                36,
                123,
                99,
                46,
                110,
                97,
                109,
                101,
                125,
                44,
                32,
                103,
                111,
                116,
                32,
                97,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                111,
                102,
                32,
                36,
                123,
                98,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                98,
                46,
                101,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                85,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                104,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                104,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                98,
                40,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                44,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                104,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                98,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                32,
                38,
                38,
                32,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                32,
                124,
                124,
                32,
                33,
                98,
                46,
                79,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                104,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                102,
                98,
                32,
                38,
                38,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                102,
                98,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                32,
                63,
                32,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                102,
                98,
                40,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                44,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                46,
                79,
                97,
                46,
                84,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                80,
                97,
                115,
                115,
                105,
                110,
                103,
                32,
                114,
                97,
                119,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                116,
                111,
                32,
                115,
                109,
                97,
                114,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                105,
                115,
                32,
                105,
                108,
                108,
                101,
                103,
                97,
                108,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                67,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                48,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                46,
                84,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                32,
                63,
                32,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                46,
                84,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                46,
                84,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                121,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                98,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                100,
                91,
                34,
                100,
                101,
                108,
                101,
                116,
                101,
                34,
                93,
                40,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                32,
                38,
                38,
                32,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                85,
                110,
                115,
                117,
                112,
                112,
                111,
                114,
                116,
                105,
                110,
                103,
                32,
                115,
                104,
                97,
                114,
                105,
                110,
                103,
                32,
                112,
                111,
                108,
                105,
                99,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                107,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                104,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                104,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                102,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                98,
                40,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                44,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                108,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                104,
                98,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                98,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                119,
                98,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                67,
                98,
                32,
                61,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                98,
                32,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                98,
                32,
                61,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                121,
                98,
                32,
                61,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                32,
                61,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                98,
                46,
                85,
                97,
                32,
                63,
                32,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                32,
                61,
                32,
                105,
                98,
                32,
                58,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                32,
                61,
                32,
                100,
                32,
                63,
                32,
                103,
                98,
                32,
                58,
                32,
                107,
                98,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                88,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                107,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                40,
                34,
                82,
                101,
                112,
                108,
                97,
                99,
                105,
                110,
                103,
                32,
                110,
                111,
                110,
                101,
                120,
                105,
                115,
                116,
                101,
                110,
                116,
                32,
                112,
                117,
                98,
                108,
                105,
                99,
                32,
                115,
                121,
                109,
                98,
                111,
                108,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                63,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                91,
                99,
                93,
                32,
                61,
                32,
                98,
                32,
                58,
                32,
                40,
                107,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                44,
                32,
                107,
                91,
                97,
                93,
                46,
                97,
                98,
                32,
                61,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                83,
                44,
                32,
                110,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                106,
                34,
                41,
                32,
                63,
                32,
                40,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                112,
                47,
                103,
                44,
                32,
                34,
                105,
                34,
                41,
                44,
                32,
                98,
                32,
                61,
                32,
                40,
                48,
                44,
                32,
                107,
                91,
                34,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                34,
                32,
                43,
                32,
                97,
                93,
                41,
                40,
                98,
                44,
                32,
                46,
                46,
                46,
                99,
                41,
                41,
                32,
                58,
                32,
                98,
                32,
                61,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                98,
                41,
                40,
                46,
                46,
                46,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                111,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                46,
                46,
                46,
                99,
                41,
                32,
                61,
                62,
                32,
                110,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                44,
                32,
                84,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                81,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                106,
                34,
                41,
                32,
                63,
                32,
                111,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                119,
                105,
                116,
                104,
                32,
                115,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                32,
                36,
                123,
                97,
                125,
                58,
                32,
                36,
                123,
                98,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                112,
                98,
                44,
                32,
                114,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                113,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                115,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                99,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                91,
                102,
                93,
                32,
                124,
                124,
                32,
                78,
                91,
                102,
                93,
                32,
                124,
                124,
                32,
                40,
                76,
                97,
                91,
                102,
                93,
                32,
                63,
                32,
                76,
                97,
                91,
                102,
                93,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                99,
                41,
                32,
                58,
                32,
                40,
                100,
                46,
                112,
                117,
                115,
                104,
                40,
                102,
                41,
                44,
                32,
                101,
                91,
                102,
                93,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                101,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                112,
                98,
                40,
                96,
                36,
                123,
                97,
                125,
                58,
                32,
                96,
                32,
                43,
                32,
                100,
                46,
                109,
                97,
                112,
                40,
                114,
                98,
                41,
                46,
                106,
                111,
                105,
                110,
                40,
                91,
                34,
                44,
                32,
                34,
                93,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                116,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                100,
                32,
                60,
                32,
                97,
                59,
                32,
                100,
                43,
                43,
                41,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                66,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                49,
                59,
                32,
                98,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                98,
                41,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                46,
                88,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                118,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                62,
                32,
                102,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                97,
                114,
                103,
                84,
                121,
                112,
                101,
                115,
                32,
                97,
                114,
                114,
                97,
                121,
                32,
                115,
                105,
                122,
                101,
                32,
                109,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                33,
                32,
                77,
                117,
                115,
                116,
                32,
                97,
                116,
                32,
                108,
                101,
                97,
                115,
                116,
                32,
                103,
                101,
                116,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                97,
                110,
                100,
                32,
                39,
                116,
                104,
                105,
                115,
                39,
                32,
                116,
                121,
                112,
                101,
                115,
                33,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                49,
                93,
                32,
                38,
                38,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                99,
                44,
                32,
                103,
                32,
                61,
                32,
                117,
                98,
                40,
                98,
                41,
                44,
                32,
                108,
                32,
                61,
                32,
                34,
                118,
                111,
                105,
                100,
                34,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                48,
                93,
                46,
                110,
                97,
                109,
                101,
                44,
                32,
                109,
                32,
                61,
                32,
                102,
                32,
                45,
                32,
                50,
                44,
                32,
                110,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                109,
                41,
                44,
                32,
                112,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                116,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                98,
                40,
                97,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                69,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                50,
                32,
                58,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                91,
                48,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                118,
                32,
                61,
                32,
                98,
                91,
                49,
                93,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                116,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                91,
                49,
                93,
                32,
                61,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                119,
                32,
                61,
                32,
                48,
                59,
                32,
                119,
                32,
                60,
                32,
                109,
                59,
                32,
                43,
                43,
                119,
                41,
                32,
                110,
                91,
                119,
                93,
                32,
                61,
                32,
                98,
                91,
                119,
                32,
                43,
                32,
                50,
                93,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                116,
                44,
                32,
                69,
                91,
                119,
                93,
                41,
                44,
                32,
                112,
                46,
                112,
                117,
                115,
                104,
                40,
                110,
                91,
                119,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                32,
                61,
                32,
                100,
                40,
                46,
                46,
                46,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                41,
                32,
                75,
                97,
                40,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                119,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                49,
                32,
                58,
                32,
                50,
                59,
                32,
                119,
                32,
                60,
                32,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                119,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                72,
                32,
                61,
                32,
                49,
                32,
                61,
                61,
                61,
                32,
                119,
                32,
                63,
                32,
                118,
                32,
                58,
                32,
                110,
                91,
                119,
                32,
                45,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                119,
                93,
                46,
                88,
                97,
                32,
                38,
                38,
                32,
                98,
                91,
                119,
                93,
                46,
                88,
                97,
                40,
                72,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                108,
                32,
                63,
                32,
                98,
                91,
                48,
                93,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                69,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                119,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                116,
                114,
                105,
                109,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                105,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                40,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                45,
                49,
                32,
                33,
                61,
                61,
                32,
                98,
                32,
                63,
                32,
                97,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                40,
                48,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                121,
                98,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                86,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                122,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                57,
                32,
                60,
                32,
                97,
                32,
                38,
                38,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                45,
                45,
                86,
                91,
                97,
                32,
                43,
                32,
                49,
                93,
                32,
                38,
                38,
                32,
                40,
                86,
                91,
                97,
                93,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                121,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                65,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                117,
                115,
                101,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                118,
                97,
                108,
                46,
                32,
                104,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                34,
                32,
                43,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                86,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                106,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                110,
                117,
                108,
                108,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                116,
                114,
                117,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                54,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                102,
                97,
                108,
                115,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                32,
                61,
                32,
                121,
                98,
                46,
                112,
                111,
                112,
                40,
                41,
                32,
                124,
                124,
                32,
                86,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                91,
                98,
                93,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                91,
                98,
                32,
                43,
                32,
                49,
                93,
                32,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                66,
                98,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                34,
                101,
                109,
                115,
                99,
                114,
                105,
                112,
                116,
                101,
                110,
                58,
                58,
                118,
                97,
                108,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                65,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                106,
                98,
                40,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                67,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                117,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                120,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                121,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                122,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                65,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                66,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                68,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                78,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                32,
                61,
                32,
                96,
                36,
                123,
                98,
                125,
                32,
                104,
                97,
                115,
                32,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                114,
                98,
                40,
                97,
                41,
                125,
                96,
                44,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                104,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                110,
                117,
                108,
                108,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                124,
                124,
                32,
                34,
                97,
                114,
                114,
                97,
                121,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                124,
                124,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                63,
                32,
                97,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                43,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                69,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                111,
                97,
                91,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                56,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                112,
                97,
                91,
                99,
                32,
                62,
                62,
                32,
                51,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                102,
                108,
                111,
                97,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                70,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                117,
                91,
                100,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                120,
                91,
                100,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                121,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                122,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                65,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                66,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                71,
                98,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                123,
                32,
                111,
                112,
                116,
                105,
                111,
                110,
                97,
                108,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                44,
                32,
                66,
                98,
                41,
                44,
                32,
                72,
                98,
                32,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                34,
                117,
                116,
                102,
                45,
                49,
                54,
                108,
                101,
                34,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                73,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                32,
                62,
                62,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                99,
                32,
                43,
                32,
                98,
                32,
                47,
                32,
                50,
                59,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                100,
                41,
                32,
                38,
                38,
                32,
                122,
                91,
                99,
                93,
                59,
                32,
                41,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                60,
                60,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                51,
                50,
                32,
                60,
                32,
                99,
                32,
                45,
                32,
                97,
                32,
                38,
                38,
                32,
                72,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                72,
                98,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                120,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                99,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                33,
                40,
                100,
                32,
                62,
                61,
                32,
                98,
                32,
                47,
                32,
                50,
                41,
                59,
                32,
                43,
                43,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                121,
                91,
                97,
                32,
                43,
                32,
                50,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                32,
                101,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                74,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                63,
                63,
                32,
                40,
                99,
                32,
                61,
                32,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                55,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                62,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                45,
                61,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                99,
                32,
                60,
                32,
                50,
                32,
                42,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                63,
                32,
                99,
                32,
                47,
                32,
                50,
                32,
                58,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                99,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                121,
                91,
                98,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                44,
                32,
                98,
                32,
                43,
                61,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                91,
                98,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                45,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                75,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                50,
                32,
                42,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                44,
                32,
                76,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                48,
                44,
                32,
                100,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                98,
                32,
                47,
                32,
                52,
                41,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                65,
                91,
                97,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                32,
                101,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                60,
                61,
                32,
                101,
                32,
                63,
                32,
                40,
                101,
                32,
                45,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                44,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                124,
                32,
                101,
                32,
                62,
                62,
                32,
                49,
                48,
                44,
                32,
                53,
                54,
                51,
                50,
                48,
                32,
                124,
                32,
                101,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                41,
                32,
                58,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                77,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                63,
                63,
                32,
                40,
                99,
                32,
                61,
                32,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                55,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                52,
                32,
                62,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                100,
                32,
                43,
                32,
                99,
                32,
                45,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                102,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                43,
                43,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                43,
                32,
                40,
                40,
                102,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                32,
                60,
                60,
                32,
                49,
                48,
                41,
                32,
                124,
                32,
                104,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                52,
                32,
                62,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                45,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                78,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                99,
                32,
                61,
                32,
                48,
                59,
                32,
                99,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                79,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                80,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                100,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                40,
                66,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                106,
                98,
                40,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                81,
                98,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                82,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                81,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                83,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                44,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                100,
                32,
                60,
                32,
                97,
                59,
                32,
                43,
                43,
                100,
                41,
                32,
                99,
                91,
                100,
                93,
                32,
                61,
                32,
                68,
                98,
                40,
                66,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                34,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                34,
                32,
                43,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                84,
                98,
                32,
                61,
                32,
                82,
                101,
                102,
                108,
                101,
                99,
                116,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                44,
                32,
                85,
                98,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                86,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                66,
                97,
                32,
                124,
                124,
                32,
                34,
                117,
                110,
                119,
                105,
                110,
                100,
                34,
                32,
                61,
                61,
                32,
                97,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                87,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                32,
                124,
                124,
                32,
                48,
                32,
                60,
                32,
                79,
                98,
                32,
                124,
                124,
                32,
                40,
                107,
                46,
                111,
                110,
                69,
                120,
                105,
                116,
                63,
                46,
                40,
                97,
                41,
                44,
                32,
                109,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                66,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                88,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                109,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                40,
                41,
                44,
                32,
                33,
                40,
                68,
                97,
                32,
                124,
                124,
                32,
                48,
                32,
                60,
                32,
                79,
                98,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                32,
                61,
                32,
                97,
                32,
                61,
                32,
                110,
                97,
                44,
                32,
                87,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                89,
                98,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                36,
                98,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                90,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                83,
                69,
                82,
                58,
                32,
                34,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                79,
                71,
                78,
                65,
                77,
                69,
                58,
                32,
                34,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                65,
                84,
                72,
                58,
                32,
                34,
                47,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                87,
                68,
                58,
                32,
                34,
                47,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                79,
                77,
                69,
                58,
                32,
                34,
                47,
                104,
                111,
                109,
                101,
                47,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                65,
                78,
                71,
                58,
                32,
                40,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                32,
                38,
                38,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                46,
                108,
                97,
                110,
                103,
                117,
                97,
                103,
                101,
                115,
                32,
                38,
                38,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                46,
                108,
                97,
                110,
                103,
                117,
                97,
                103,
                101,
                115,
                91,
                48,
                93,
                32,
                124,
                124,
                32,
                34,
                67,
                34,
                41,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                45,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                95,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                32,
                43,
                32,
                34,
                46,
                85,
                84,
                70,
                45,
                56,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                58,
                32,
                101,
                97,
                32,
                124,
                124,
                32,
                34,
                46,
                47,
                116,
                104,
                105,
                115,
                46,
                112,
                114,
                111,
                103,
                114,
                97,
                109,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                105,
                110,
                32,
                89,
                98,
                41,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                89,
                98,
                91,
                98,
                93,
                32,
                63,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                97,
                91,
                98,
                93,
                32,
                58,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                89,
                98,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                105,
                110,
                32,
                97,
                41,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                96,
                36,
                123,
                98,
                125,
                61,
                36,
                123,
                97,
                91,
                98,
                93,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                98,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                90,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                90,
                98,
                44,
                32,
                97,
                99,
                32,
                61,
                32,
                91,
                110,
                117,
                108,
                108,
                44,
                32,
                91,
                93,
                44,
                32,
                91,
                93,
                93,
                44,
                32,
                98,
                99,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                46,
                103,
                101,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                86,
                97,
                108,
                117,
                101,
                115,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                46,
                103,
                101,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                40,
                34,
                105,
                110,
                105,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                68,
                101,
                118,
                105,
                99,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                99,
                99,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                99,
                99,
                32,
                61,
                32,
                98,
                99,
                40,
                41,
                41,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                97,
                32,
                61,
                32,
                107,
                46,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                101,
                120,
                116,
                101,
                110,
                100,
                115,
                32,
                69,
                114,
                114,
                111,
                114,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                112,
                101,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                34,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                99,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                50,
                53,
                54,
                41,
                44,
                32,
                101,
                99,
                32,
                61,
                32,
                48,
                59,
                32,
                50,
                53,
                54,
                32,
                62,
                32,
                101,
                99,
                59,
                32,
                43,
                43,
                101,
                99,
                41,
                32,
                100,
                99,
                91,
                101,
                99,
                93,
                32,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                97,
                32,
                61,
                32,
                100,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                32,
                61,
                32,
                107,
                46,
                66,
                105,
                110,
                100,
                105,
                110,
                103,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                101,
                120,
                116,
                101,
                110,
                100,
                115,
                32,
                69,
                114,
                114,
                111,
                114,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                112,
                101,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                34,
                66,
                105,
                110,
                100,
                105,
                110,
                103,
                69,
                114,
                114,
                111,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                36,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                65,
                108,
                105,
                97,
                115,
                79,
                102,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                116,
                104,
                105,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                36,
                97,
                32,
                38,
                38,
                32,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                36,
                97,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                44,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                79,
                97,
                32,
                61,
                32,
                97,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                97,
                32,
                61,
                32,
                97,
                46,
                79,
                97,
                46,
                80,
                97,
                59,
                32,
                98,
                46,
                85,
                97,
                59,
                32,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                101,
                98,
                40,
                99,
                41,
                44,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                85,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                100,
                46,
                85,
                97,
                59,
                32,
                41,
                32,
                97,
                32,
                61,
                32,
                100,
                46,
                101,
                98,
                40,
                97,
                41,
                44,
                32,
                100,
                32,
                61,
                32,
                100,
                46,
                85,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                61,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                99,
                32,
                61,
                61,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                111,
                110,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                43,
                61,
                32,
                49,
                44,
                32,
                116,
                104,
                105,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                88,
                97,
                44,
                32,
                98,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                44,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                44,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                80,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                79,
                102,
                40,
                116,
                104,
                105,
                115,
                41,
                44,
                32,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                99,
                97,
                108,
                108,
                40,
                98,
                44,
                32,
                100,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                97,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                123,
                32,
                99,
                111,
                117,
                110,
                116,
                58,
                32,
                101,
                46,
                99,
                111,
                117,
                110,
                116,
                44,
                32,
                98,
                98,
                58,
                32,
                101,
                46,
                98,
                98,
                44,
                32,
                99,
                98,
                58,
                32,
                101,
                46,
                99,
                98,
                44,
                32,
                80,
                97,
                58,
                32,
                101,
                46,
                80,
                97,
                44,
                32,
                82,
                97,
                58,
                32,
                101,
                46,
                82,
                97,
                44,
                32,
                84,
                97,
                58,
                32,
                101,
                46,
                84,
                97,
                44,
                32,
                86,
                97,
                58,
                32,
                101,
                46,
                86,
                97,
                32,
                125,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                79,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                43,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                79,
                97,
                46,
                98,
                98,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                91,
                34,
                100,
                101,
                108,
                101,
                116,
                101,
                34,
                93,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                98,
                98,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                79,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                115,
                99,
                104,
                101,
                100,
                117,
                108,
                101,
                100,
                32,
                102,
                111,
                114,
                32,
                100,
                101,
                108,
                101,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                45,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                38,
                38,
                32,
                40,
                97,
                46,
                84,
                97,
                32,
                63,
                32,
                97,
                46,
                86,
                97,
                46,
                89,
                97,
                40,
                97,
                46,
                84,
                97,
                41,
                32,
                58,
                32,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                46,
                89,
                97,
                40,
                97,
                46,
                80,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                98,
                32,
                124,
                124,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                84,
                97,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                68,
                101,
                108,
                101,
                116,
                101,
                100,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                76,
                97,
                116,
                101,
                114,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                98,
                98,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                79,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                115,
                99,
                104,
                101,
                100,
                117,
                108,
                101,
                100,
                32,
                102,
                111,
                114,
                32,
                100,
                101,
                108,
                101,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                98,
                98,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                108,
                98,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                98,
                32,
                38,
                38,
                32,
                40,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                98,
                40,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                63,
                46,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                98,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                32,
                63,
                32,
                89,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                123,
                32,
                82,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                119,
                98,
                44,
                32,
                80,
                97,
                58,
                32,
                99,
                44,
                32,
                86,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                84,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                32,
                58,
                32,
                89,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                123,
                32,
                82,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                80,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                107,
                98,
                40,
                97,
                41,
                44,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                87,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                100,
                46,
                79,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                61,
                32,
                99,
                44,
                32,
                100,
                46,
                79,
                97,
                46,
                84,
                97,
                32,
                61,
                32,
                97,
                44,
                32,
                100,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                100,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                107,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                46,
                113,
                98,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                85,
                97,
                91,
                100,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                98,
                32,
                63,
                32,
                100,
                46,
                110,
                98,
                32,
                58,
                32,
                100,
                46,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                84,
                121,
                112,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                84,
                97,
                40,
                99,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                44,
                32,
                100,
                46,
                81,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                63,
                32,
                98,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                41,
                32,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                32,
                63,
                32,
                89,
                97,
                40,
                100,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                123,
                32,
                82,
                97,
                58,
                32,
                100,
                44,
                32,
                80,
                97,
                58,
                32,
                101,
                44,
                32,
                86,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                84,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                32,
                58,
                32,
                89,
                97,
                40,
                100,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                123,
                32,
                82,
                97,
                58,
                32,
                100,
                44,
                32,
                80,
                97,
                58,
                32,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                98,
                32,
                61,
                32,
                107,
                46,
                85,
                110,
                98,
                111,
                117,
                110,
                100,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                40,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                98,
                40,
                98,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                100,
                41,
                46,
                115,
                116,
                97,
                99,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                99,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                32,
                43,
                32,
                34,
                92,
                110,
                34,
                32,
                43,
                32,
                100,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                94,
                69,
                114,
                114,
                111,
                114,
                40,
                58,
                91,
                94,
                92,
                110,
                93,
                42,
                41,
                63,
                92,
                110,
                47,
                44,
                32,
                34,
                34,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                63,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                96,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                58,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                69,
                114,
                114,
                111,
                114,
                44,
                32,
                34,
                85,
                110,
                98,
                111,
                117,
                110,
                100,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                46,
                112,
                117,
                115,
                104,
                40,
                48,
                44,
                32,
                49,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                49,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                49,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                49,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                99,
                111,
                117,
                110,
                116,
                95,
                101,
                109,
                118,
                97,
                108,
                95,
                104,
                97,
                110,
                100,
                108,
                101,
                115,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                86,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                47,
                32,
                50,
                32,
                45,
                32,
                53,
                32,
                45,
                32,
                121,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                120,
                99,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                118,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                65,
                115,
                115,
                101,
                114,
                116,
                105,
                111,
                110,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                97,
                32,
                63,
                32,
                71,
                40,
                120,
                44,
                32,
                97,
                41,
                32,
                58,
                32,
                34,
                34,
                125,
                44,
                32,
                97,
                116,
                58,
                32,
                96,
                32,
                43,
                32,
                91,
                98,
                32,
                63,
                32,
                98,
                32,
                63,
                32,
                71,
                40,
                120,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                58,
                32,
                34,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                105,
                108,
                101,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                44,
                32,
                100,
                32,
                63,
                32,
                100,
                32,
                63,
                32,
                71,
                40,
                120,
                44,
                32,
                100,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                58,
                32,
                34,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                93,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                72,
                97,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                100,
                46,
                80,
                97,
                32,
                43,
                32,
                49,
                54,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                100,
                46,
                80,
                97,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                100,
                46,
                80,
                97,
                32,
                43,
                32,
                56,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                43,
                43,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                32,
                124,
                124,
                32,
                40,
                73,
                32,
                61,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                118,
                97,
                40,
                34,
                34,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                74,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                74,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                105,
                98,
                44,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                89,
                97,
                44,
                32,
                101,
                32,
                61,
                32,
                98,
                46,
                108,
                98,
                44,
                32,
                102,
                32,
                61,
                32,
                101,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                117,
                98,
                41,
                46,
                99,
                111,
                110,
                99,
                97,
                116,
                40,
                101,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                65,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                97,
                93,
                44,
                32,
                102,
                44,
                32,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                104,
                91,
                109,
                93,
                44,
                32,
                112,
                32,
                61,
                32,
                108,
                46,
                115,
                98,
                44,
                32,
                116,
                32,
                61,
                32,
                108,
                46,
                116,
                98,
                44,
                32,
                69,
                32,
                61,
                32,
                104,
                91,
                109,
                32,
                43,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                44,
                32,
                118,
                32,
                61,
                32,
                108,
                46,
                122,
                98,
                44,
                32,
                119,
                32,
                61,
                32,
                108,
                46,
                66,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                91,
                108,
                46,
                112,
                98,
                93,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                58,
                32,
                40,
                72,
                41,
                32,
                61,
                62,
                32,
                110,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                112,
                40,
                116,
                44,
                32,
                72,
                41,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                114,
                105,
                116,
                101,
                58,
                32,
                40,
                72,
                44,
                32,
                102,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                70,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                40,
                119,
                44,
                32,
                72,
                44,
                32,
                69,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                70,
                44,
                32,
                102,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                97,
                40,
                70,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                46,
                110,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                109,
                91,
                110,
                93,
                32,
                61,
                32,
                103,
                91,
                110,
                93,
                46,
                114,
                101,
                97,
                100,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                110,
                32,
                105,
                110,
                32,
                109,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                77,
                105,
                115,
                115,
                105,
                110,
                103,
                32,
                102,
                105,
                101,
                108,
                100,
                58,
                32,
                34,
                36,
                123,
                110,
                125,
                34,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                112,
                32,
                61,
                32,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                103,
                91,
                110,
                93,
                46,
                119,
                114,
                105,
                116,
                101,
                40,
                112,
                44,
                32,
                109,
                91,
                110,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                108,
                32,
                38,
                38,
                32,
                108,
                46,
                112,
                117,
                115,
                104,
                40,
                100,
                44,
                32,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                33,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                32,
                63,
                32,
                99,
                32,
                58,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                120,
                91,
                101,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                44,
                32,
                112,
                44,
                32,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                61,
                32,
                81,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                38,
                38,
                32,
                40,
                103,
                32,
                61,
                32,
                84,
                40,
                104,
                44,
                32,
                103,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                38,
                38,
                32,
                40,
                109,
                32,
                61,
                32,
                84,
                40,
                108,
                44,
                32,
                109,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                32,
                61,
                32,
                84,
                40,
                112,
                44,
                32,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                32,
                61,
                32,
                100,
                98,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                98,
                40,
                69,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                36,
                123,
                110,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                93,
                44,
                32,
                100,
                32,
                63,
                32,
                91,
                100,
                93,
                32,
                58,
                32,
                91,
                93,
                44,
                32,
                40,
                118,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                118,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                119,
                32,
                61,
                32,
                118,
                46,
                81,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                72,
                32,
                61,
                32,
                119,
                46,
                36,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                72,
                32,
                61,
                32,
                36,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                97,
                98,
                40,
                110,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                80,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                80,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                79,
                102,
                40,
                116,
                104,
                105,
                115,
                41,
                32,
                33,
                61,
                61,
                32,
                102,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                85,
                115,
                101,
                32,
                39,
                110,
                101,
                119,
                39,
                32,
                116,
                111,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                34,
                32,
                43,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                70,
                46,
                90,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                110,
                32,
                43,
                32,
                34,
                32,
                104,
                97,
                115,
                32,
                110,
                111,
                32,
                97,
                99,
                99,
                101,
                115,
                115,
                105,
                98,
                108,
                101,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                120,
                98,
                32,
                61,
                32,
                70,
                46,
                90,
                97,
                91,
                80,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                120,
                98,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                84,
                114,
                105,
                101,
                100,
                32,
                116,
                111,
                32,
                105,
                110,
                118,
                111,
                107,
                101,
                32,
                99,
                116,
                111,
                114,
                32,
                111,
                102,
                32,
                36,
                123,
                110,
                125,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                40,
                36,
                123,
                80,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                125,
                41,
                32,
                45,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                40,
                36,
                123,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                107,
                101,
                121,
                115,
                40,
                70,
                46,
                90,
                97,
                41,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                125,
                41,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                105,
                110,
                115,
                116,
                101,
                97,
                100,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                120,
                98,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                80,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                97,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                72,
                44,
                32,
                123,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                118,
                32,
                125,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                32,
                61,
                32,
                102,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                70,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                101,
                98,
                40,
                110,
                44,
                32,
                118,
                44,
                32,
                102,
                97,
                44,
                32,
                116,
                44,
                32,
                119,
                44,
                32,
                102,
                44,
                32,
                103,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                70,
                46,
                85,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                104,
                97,
                32,
                61,
                32,
                70,
                46,
                85,
                97,
                41,
                46,
                106,
                98,
                32,
                63,
                63,
                32,
                40,
                104,
                97,
                46,
                106,
                98,
                32,
                61,
                32,
                91,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                46,
                85,
                97,
                46,
                106,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                70,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                108,
                98,
                40,
                110,
                44,
                32,
                70,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                108,
                98,
                40,
                110,
                32,
                43,
                32,
                34,
                42,
                34,
                44,
                32,
                70,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                108,
                98,
                40,
                110,
                32,
                43,
                32,
                34,
                32,
                99,
                111,
                110,
                115,
                116,
                42,
                34,
                44,
                32,
                70,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                97,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                84,
                121,
                112,
                101,
                58,
                32,
                104,
                97,
                44,
                32,
                110,
                98,
                58,
                32,
                72,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                98,
                40,
                69,
                44,
                32,
                118,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                119,
                44,
                32,
                104,
                97,
                44,
                32,
                72,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                116,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                91,
                97,
                93,
                44,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                103,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                96,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                32,
                38,
                38,
                32,
                40,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                32,
                61,
                32,
                91,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                109,
                117,
                108,
                116,
                105,
                112,
                108,
                101,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                115,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                101,
                110,
                116,
                105,
                99,
                97,
                108,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                40,
                36,
                123,
                98,
                32,
                45,
                32,
                49,
                125,
                41,
                32,
                102,
                111,
                114,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                39,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                39,
                33,
                32,
                79,
                118,
                101,
                114,
                108,
                111,
                97,
                100,
                32,
                114,
                101,
                115,
                111,
                108,
                117,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                108,
                121,
                32,
                111,
                110,
                108,
                121,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                101,
                100,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                116,
                104,
                101,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                99,
                111,
                117,
                110,
                116,
                44,
                32,
                110,
                111,
                116,
                32,
                97,
                99,
                116,
                117,
                97,
                108,
                32,
                116,
                121,
                112,
                101,
                32,
                105,
                110,
                102,
                111,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                104,
                44,
                32,
                40,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                46,
                115,
                112,
                108,
                105,
                99,
                101,
                40,
                49,
                44,
                32,
                48,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                32,
                61,
                32,
                118,
                98,
                40,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                116,
                98,
                40,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                119,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                91,
                97,
                93,
                44,
                32,
                40,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                97,
                108,
                108,
                32,
                36,
                123,
                112,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                109,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                112,
                32,
                61,
                32,
                96,
                36,
                123,
                109,
                46,
                110,
                97,
                109,
                101,
                125,
                46,
                36,
                123,
                98,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                64,
                64,
                34,
                41,
                32,
                38,
                38,
                32,
                40,
                98,
                32,
                61,
                32,
                83,
                121,
                109,
                98,
                111,
                108,
                91,
                98,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                105,
                110,
                103,
                40,
                50,
                41,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                38,
                38,
                32,
                109,
                46,
                81,
                97,
                46,
                120,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                116,
                32,
                61,
                32,
                109,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                69,
                32,
                61,
                32,
                116,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                69,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                69,
                46,
                83,
                97,
                32,
                38,
                38,
                32,
                69,
                46,
                99,
                108,
                97,
                115,
                115,
                78,
                97,
                109,
                101,
                32,
                33,
                61,
                61,
                32,
                109,
                46,
                110,
                97,
                109,
                101,
                32,
                38,
                38,
                32,
                69,
                46,
                97,
                98,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                32,
                63,
                32,
                40,
                110,
                46,
                97,
                98,
                32,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                44,
                32,
                110,
                46,
                99,
                108,
                97,
                115,
                115,
                78,
                97,
                109,
                101,
                32,
                61,
                32,
                109,
                46,
                110,
                97,
                109,
                101,
                44,
                32,
                116,
                91,
                98,
                93,
                32,
                61,
                32,
                110,
                41,
                32,
                58,
                32,
                40,
                98,
                98,
                40,
                116,
                44,
                32,
                98,
                44,
                32,
                112,
                41,
                44,
                32,
                116,
                91,
                98,
                93,
                46,
                83,
                97,
                91,
                99,
                32,
                45,
                32,
                50,
                93,
                32,
                61,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                108,
                44,
                32,
                40,
                118,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                118,
                98,
                40,
                112,
                44,
                32,
                118,
                44,
                32,
                109,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                116,
                91,
                98,
                93,
                46,
                83,
                97,
                32,
                63,
                32,
                40,
                118,
                46,
                97,
                98,
                32,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                44,
                32,
                116,
                91,
                98,
                93,
                32,
                61,
                32,
                118,
                41,
                32,
                58,
                32,
                116,
                91,
                98,
                93,
                46,
                83,
                97,
                91,
                99,
                32,
                45,
                32,
                50,
                93,
                32,
                61,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                97,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                79,
                40,
                97,
                44,
                32,
                66,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                91,
                102,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                118,
                97,
                108,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                67,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                98,
                40,
                98,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                68,
                98,
                40,
                97,
                44,
                32,
                34,
                101,
                110,
                117,
                109,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                100,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                100,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                99,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                97,
                98,
                40,
                96,
                36,
                123,
                100,
                46,
                110,
                97,
                109,
                101,
                125,
                95,
                36,
                123,
                98,
                125,
                96,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                91,
                99,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                69,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                116,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                81,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                119,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                97,
                108,
                108,
                32,
                36,
                123,
                97,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                45,
                32,
                49,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                104,
                44,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                98,
                40,
                97,
                44,
                32,
                118,
                98,
                40,
                97,
                44,
                32,
                91,
                103,
                91,
                48,
                93,
                44,
                32,
                110,
                117,
                108,
                108,
                93,
                46,
                99,
                111,
                110,
                99,
                97,
                116,
                40,
                103,
                46,
                115,
                108,
                105,
                99,
                101,
                40,
                49,
                41,
                41,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                44,
                32,
                98,
                32,
                45,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                49,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                38,
                38,
                32,
                40,
                101,
                32,
                61,
                32,
                52,
                50,
                57,
                52,
                57,
                54,
                55,
                50,
                57,
                53,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                51,
                50,
                32,
                45,
                32,
                56,
                32,
                42,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                103,
                32,
                60,
                60,
                32,
                102,
                32,
                62,
                62,
                62,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                98,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                117,
                110,
                115,
                105,
                103,
                110,
                101,
                100,
                34,
                41,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                32,
                62,
                62,
                62,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                101,
                44,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                104,
                44,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                70,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                41,
                44,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                101,
                40,
                117,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                66,
                91,
                102,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                66,
                91,
                102,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                91,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                73,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                73,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                70,
                108,
                111,
                97,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                70,
                108,
                111,
                97,
                116,
                54,
                52,
                65,
                114,
                114,
                97,
                121,
                93,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                81,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                99,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                100,
                44,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                100,
                32,
                125,
                44,
                32,
                123,
                32,
                118,
                98,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                71,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                44,
                32,
                112,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                81,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                84,
                40,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                84,
                40,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                32,
                61,
                32,
                84,
                40,
                110,
                44,
                32,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                97,
                93,
                44,
                32,
                91,
                98,
                93,
                44,
                32,
                40,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                32,
                61,
                32,
                116,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                110,
                101,
                119,
                32,
                108,
                98,
                40,
                99,
                44,
                32,
                116,
                46,
                81,
                97,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                116,
                44,
                32,
                100,
                44,
                32,
                102,
                44,
                32,
                103,
                44,
                32,
                109,
                44,
                32,
                112,
                41,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                66,
                91,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                101,
                32,
                61,
                32,
                99,
                32,
                43,
                32,
                52,
                44,
                32,
                102,
                44,
                32,
                104,
                32,
                61,
                32,
                101,
                44,
                32,
                103,
                32,
                61,
                32,
                48,
                59,
                32,
                103,
                32,
                60,
                61,
                32,
                100,
                59,
                32,
                43,
                43,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                101,
                32,
                43,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                61,
                61,
                32,
                100,
                32,
                124,
                124,
                32,
                48,
                32,
                61,
                61,
                32,
                120,
                91,
                108,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                71,
                40,
                120,
                44,
                32,
                104,
                44,
                32,
                108,
                32,
                45,
                32,
                104,
                41,
                32,
                58,
                32,
                34,
                34,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                102,
                32,
                63,
                32,
                102,
                32,
                61,
                32,
                104,
                32,
                58,
                32,
                40,
                102,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                48,
                41,
                44,
                32,
                102,
                32,
                43,
                61,
                32,
                104,
                41,
                44,
                32,
                104,
                32,
                61,
                32,
                108,
                32,
                43,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                44,
                32,
                102,
                32,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                102,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                85,
                105,
                110,
                116,
                56,
                67,
                108,
                97,
                109,
                112,
                101,
                100,
                65,
                114,
                114,
                97,
                121,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                110,
                111,
                110,
                45,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                115,
                116,
                100,
                58,
                58,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                104,
                32,
                60,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                49,
                50,
                55,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                101,
                43,
                43,
                32,
                58,
                32,
                50,
                48,
                52,
                55,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                101,
                32,
                43,
                61,
                32,
                50,
                32,
                58,
                32,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                103,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                40,
                101,
                32,
                43,
                61,
                32,
                52,
                44,
                32,
                43,
                43,
                104,
                41,
                32,
                58,
                32,
                101,
                32,
                43,
                61,
                32,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                101,
                32,
                61,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                102,
                99,
                40,
                52,
                32,
                43,
                32,
                101,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                104,
                32,
                43,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                104,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                32,
                75,
                40,
                100,
                44,
                32,
                103,
                44,
                32,
                101,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                101,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                53,
                53,
                32,
                60,
                32,
                108,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                85,
                40,
                103,
                41,
                44,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                83,
                116,
                114,
                105,
                110,
                103,
                32,
                104,
                97,
                115,
                32,
                85,
                84,
                70,
                45,
                49,
                54,
                32,
                99,
                111,
                100,
                101,
                32,
                117,
                110,
                105,
                116,
                115,
                32,
                116,
                104,
                97,
                116,
                32,
                100,
                111,
                32,
                110,
                111,
                116,
                32,
                102,
                105,
                116,
                32,
                105,
                110,
                32,
                56,
                32,
                98,
                105,
                116,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                91,
                103,
                32,
                43,
                32,
                102,
                93,
                32,
                61,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                101,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                120,
                91,
                103,
                32,
                43,
                32,
                102,
                93,
                32,
                61,
                32,
                100,
                91,
                102,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                38,
                38,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                85,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                81,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                73,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                74,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                75,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                122,
                91,
                103,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                52,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                76,
                98,
                44,
                32,
                101,
                32,
                61,
                32,
                77,
                98,
                44,
                32,
                102,
                32,
                61,
                32,
                78,
                98,
                44,
                32,
                104,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                66,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                66,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                109,
                44,
                32,
                110,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                44,
                32,
                112,
                32,
                61,
                32,
                48,
                59,
                32,
                112,
                32,
                60,
                61,
                32,
                108,
                59,
                32,
                43,
                43,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                116,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                32,
                43,
                32,
                112,
                32,
                42,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                32,
                61,
                61,
                32,
                108,
                32,
                124,
                124,
                32,
                48,
                32,
                61,
                61,
                32,
                104,
                40,
                116,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                61,
                32,
                100,
                40,
                110,
                44,
                32,
                116,
                32,
                45,
                32,
                110,
                41,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                109,
                32,
                63,
                32,
                109,
                32,
                61,
                32,
                110,
                32,
                58,
                32,
                40,
                109,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                48,
                41,
                44,
                32,
                109,
                32,
                43,
                61,
                32,
                110,
                41,
                44,
                32,
                110,
                32,
                61,
                32,
                116,
                32,
                43,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                108,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                110,
                111,
                110,
                45,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                67,
                43,
                43,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                99,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                102,
                40,
                108,
                41,
                44,
                32,
                110,
                32,
                61,
                32,
                102,
                99,
                40,
                52,
                32,
                43,
                32,
                109,
                32,
                43,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                110,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                109,
                32,
                47,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                40,
                108,
                44,
                32,
                110,
                32,
                43,
                32,
                52,
                44,
                32,
                109,
                32,
                43,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                38,
                38,
                32,
                103,
                46,
                112,
                117,
                115,
                104,
                40,
                85,
                44,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                81,
                40,
                98,
                41,
                44,
                32,
                105,
                98,
                58,
                32,
                84,
                40,
                99,
                44,
                32,
                100,
                41,
                44,
                32,
                89,
                97,
                58,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                44,
                32,
                108,
                98,
                58,
                32,
                91,
                93,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                91,
                97,
                93,
                46,
                108,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                123,
                32,
                112,
                98,
                58,
                32,
                81,
                40,
                98,
                41,
                44,
                32,
                117,
                98,
                58,
                32,
                99,
                44,
                32,
                115,
                98,
                58,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                44,
                32,
                116,
                98,
                58,
                32,
                102,
                44,
                32,
                65,
                98,
                58,
                32,
                104,
                44,
                32,
                122,
                98,
                58,
                32,
                84,
                40,
                103,
                44,
                32,
                108,
                41,
                44,
                32,
                66,
                98,
                58,
                32,
                109,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                32,
                68,
                98,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                32,
                87,
                97,
                58,
                32,
                48,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                110,
                102,
                105,
                110,
                105,
                116,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                65,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                68,
                98,
                40,
                98,
                44,
                32,
                34,
                101,
                109,
                118,
                97,
                108,
                58,
                58,
                97,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                80,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                81,
                98,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                65,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                40,
                110,
                117,
                108,
                108,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                58,
                32,
                122,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                83,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                101,
                32,
                61,
                32,
                100,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                45,
                45,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                96,
                109,
                101,
                116,
                104,
                111,
                100,
                67,
                97,
                108,
                108,
                101,
                114,
                60,
                40,
                36,
                123,
                100,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                110,
                97,
                109,
                101,
                41,
                46,
                106,
                111,
                105,
                110,
                40,
                34,
                44,
                32,
                34,
                41,
                125,
                41,
                32,
                61,
                62,
                32,
                36,
                123,
                101,
                46,
                110,
                97,
                109,
                101,
                125,
                62,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                98,
                40,
                98,
                44,
                32,
                40,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                48,
                44,
                32,
                112,
                32,
                61,
                32,
                48,
                59,
                32,
                112,
                32,
                60,
                32,
                97,
                59,
                32,
                43,
                43,
                112,
                41,
                32,
                102,
                91,
                112,
                93,
                32,
                61,
                32,
                100,
                91,
                112,
                93,
                46,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                40,
                109,
                32,
                43,
                32,
                110,
                41,
                44,
                32,
                110,
                32,
                43,
                61,
                32,
                100,
                91,
                112,
                93,
                46,
                87,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                49,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                63,
                32,
                84,
                98,
                40,
                103,
                44,
                32,
                102,
                41,
                32,
                58,
                32,
                103,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                104,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                80,
                98,
                40,
                101,
                44,
                32,
                108,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                97,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                57,
                32,
                60,
                32,
                97,
                32,
                38,
                38,
                32,
                40,
                86,
                91,
                97,
                32,
                43,
                32,
                49,
                93,
                32,
                43,
                61,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                97,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                65,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                68,
                98,
                40,
                97,
                44,
                32,
                34,
                95,
                101,
                109,
                118,
                97,
                108,
                95,
                116,
                97,
                107,
                101,
                95,
                118,
                97,
                108,
                117,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                106,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                98,
                91,
                97,
                93,
                32,
                38,
                38,
                32,
                40,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                85,
                98,
                91,
                97,
                93,
                46,
                105,
                100,
                41,
                44,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                85,
                98,
                91,
                97,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                85,
                98,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                98,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                103,
                99,
                40,
                97,
                44,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                97,
                110,
                99,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                98,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                105,
                100,
                58,
                32,
                99,
                44,
                32,
                69,
                98,
                58,
                32,
                98,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                40,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                41,
                41,
                46,
                103,
                101,
                116,
                70,
                117,
                108,
                108,
                89,
                101,
                97,
                114,
                40,
                41,
                44,
                32,
                102,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                101,
                44,
                32,
                48,
                44,
                32,
                49,
                41,
                46,
                103,
                101,
                116,
                84,
                105,
                109,
                101,
                122,
                111,
                110,
                101,
                79,
                102,
                102,
                115,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                101,
                44,
                32,
                54,
                44,
                32,
                49,
                41,
                46,
                103,
                101,
                116,
                84,
                105,
                109,
                101,
                122,
                111,
                110,
                101,
                79,
                102,
                102,
                115,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                54,
                48,
                32,
                42,
                32,
                77,
                97,
                116,
                104,
                46,
                109,
                97,
                120,
                40,
                102,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                40,
                102,
                32,
                33,
                61,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                97,
                98,
                115,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                96,
                85,
                84,
                67,
                36,
                123,
                48,
                32,
                60,
                61,
                32,
                104,
                32,
                63,
                32,
                34,
                45,
                34,
                32,
                58,
                32,
                34,
                43,
                34,
                125,
                36,
                123,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                77,
                97,
                116,
                104,
                46,
                102,
                108,
                111,
                111,
                114,
                40,
                103,
                32,
                47,
                32,
                54,
                48,
                41,
                41,
                46,
                112,
                97,
                100,
                83,
                116,
                97,
                114,
                116,
                40,
                50,
                44,
                32,
                34,
                48,
                34,
                41,
                125,
                36,
                123,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                103,
                32,
                37,
                32,
                54,
                48,
                41,
                46,
                112,
                97,
                100,
                83,
                116,
                97,
                114,
                116,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                48,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                98,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                60,
                32,
                102,
                32,
                63,
                32,
                40,
                75,
                40,
                97,
                44,
                32,
                99,
                44,
                32,
                49,
                55,
                41,
                44,
                32,
                75,
                40,
                98,
                44,
                32,
                100,
                44,
                32,
                49,
                55,
                41,
                41,
                32,
                58,
                32,
                40,
                75,
                40,
                97,
                44,
                32,
                100,
                44,
                32,
                49,
                55,
                41,
                44,
                32,
                75,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                49,
                55,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                97,
                110,
                99,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                120,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                62,
                62,
                62,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                56,
                32,
                60,
                32,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                49,
                59,
                32,
                52,
                32,
                62,
                61,
                32,
                99,
                59,
                32,
                99,
                32,
                42,
                61,
                32,
                50,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                32,
                42,
                32,
                40,
                49,
                32,
                43,
                32,
                48,
                46,
                50,
                32,
                47,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                109,
                105,
                110,
                40,
                100,
                44,
                32,
                97,
                32,
                43,
                32,
                49,
                48,
                48,
                54,
                54,
                51,
                50,
                57,
                54,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                40,
                77,
                97,
                116,
                104,
                46,
                109,
                105,
                110,
                40,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                56,
                44,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                42,
                32,
                77,
                97,
                116,
                104,
                46,
                99,
                101,
                105,
                108,
                40,
                77,
                97,
                116,
                104,
                46,
                109,
                97,
                120,
                40,
                97,
                44,
                32,
                100,
                41,
                32,
                47,
                32,
                54,
                53,
                53,
                51,
                54,
                41,
                41,
                32,
                45,
                32,
                108,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                54,
                53,
                53,
                51,
                53,
                41,
                32,
                47,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                124,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                46,
                103,
                114,
                111,
                119,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                98,
                40,
                41,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                66,
                91,
                97,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                101,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                117,
                91,
                101,
                43,
                43,
                93,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                91,
                101,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                43,
                61,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                36,
                98,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                99,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                41,
                32,
                61,
                62,
                32,
                100,
                32,
                43,
                61,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                53,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                53,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                44,
                32,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                99,
                59,
                32,
                102,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                66,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                103,
                32,
                61,
                32,
                66,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                48,
                59,
                32,
                108,
                32,
                60,
                32,
                103,
                59,
                32,
                108,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                97,
                44,
                32,
                110,
                32,
                61,
                32,
                120,
                91,
                104,
                32,
                43,
                32,
                108,
                93,
                44,
                32,
                112,
                32,
                61,
                32,
                97,
                99,
                91,
                109,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                110,
                32,
                124,
                124,
                32,
                49,
                48,
                32,
                61,
                61,
                61,
                32,
                110,
                32,
                63,
                32,
                40,
                40,
                49,
                32,
                61,
                61,
                61,
                32,
                109,
                32,
                63,
                32,
                106,
                97,
                32,
                58,
                32,
                114,
                41,
                40,
                71,
                40,
                112,
                41,
                41,
                44,
                32,
                112,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                48,
                41,
                32,
                58,
                32,
                112,
                46,
                112,
                117,
                115,
                104,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                43,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                58,
                32,
                104,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                58,
                32,
                105,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                58,
                32,
                106,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                58,
                32,
                107,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                58,
                32,
                108,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                58,
                32,
                109,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                58,
                32,
                110,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                58,
                32,
                111,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                58,
                32,
                112,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                58,
                32,
                113,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                58,
                32,
                114,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                58,
                32,
                115,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                58,
                32,
                116,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                111,
                58,
                32,
                117,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                58,
                32,
                118,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                71,
                58,
                32,
                119,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                58,
                32,
                87,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                99,
                40,
                120,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                97,
                32,
                43,
                32,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                87,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                97,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                32,
                61,
                32,
                100,
                46,
                101,
                120,
                112,
                111,
                114,
                116,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                32,
                61,
                32,
                87,
                46,
                109,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                32,
                61,
                32,
                87,
                46,
                114,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                87,
                46,
                110,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                45,
                45,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                109,
                111,
                110,
                105,
                116,
                111,
                114,
                82,
                117,
                110,
                68,
                101,
                112,
                101,
                110,
                100,
                101,
                110,
                99,
                105,
                101,
                115,
                63,
                46,
                40,
                67,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                32,
                67,
                32,
                38,
                38,
                32,
                68,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                68,
                44,
                32,
                68,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                100,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                87,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                43,
                43,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                109,
                111,
                110,
                105,
                116,
                111,
                114,
                82,
                117,
                110,
                68,
                101,
                112,
                101,
                110,
                100,
                101,
                110,
                99,
                105,
                101,
                115,
                63,
                46,
                40,
                67,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                123,
                32,
                97,
                58,
                32,
                120,
                99,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                107,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                40,
                98,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                40,
                96,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                98,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                97,
                32,
                63,
                63,
                32,
                40,
                120,
                97,
                32,
                61,
                32,
                119,
                97,
                40,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                41,
                32,
                63,
                32,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                32,
                58,
                32,
                107,
                46,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                32,
                63,
                32,
                107,
                46,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                40,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                44,
                32,
                113,
                41,
                32,
                58,
                32,
                113,
                32,
                43,
                32,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                65,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                40,
                99,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                99,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                102,
                99,
                32,
                61,
                32,
                87,
                46,
                111,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                113,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                113,
                98,
                32,
                61,
                32,
                87,
                46,
                112,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                85,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                85,
                32,
                61,
                32,
                87,
                46,
                113,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                103,
                99,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                103,
                99,
                32,
                61,
                32,
                87,
                46,
                115,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                88,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                88,
                32,
                61,
                32,
                87,
                46,
                116,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                74,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                74,
                32,
                61,
                32,
                87,
                46,
                117,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                89,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                89,
                32,
                61,
                32,
                87,
                46,
                118,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                90,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                40,
                90,
                32,
                61,
                32,
                87,
                46,
                119,
                97,
                41,
                40,
                41,
                44,
                32,
                71,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                71,
                97,
                32,
                61,
                32,
                87,
                46,
                120,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                121,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                122,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                65,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                121,
                99,
                32,
                61,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                40,
                121,
                99,
                32,
                61,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                66,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                67,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                68,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                102,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                102,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                69,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                70,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                32,
                61,
                32,
                87,
                46,
                71,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                72,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                102,
                102,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                102,
                102,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                73,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                74,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                105,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                105,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                75,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                32,
                61,
                32,
                87,
                46,
                76,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                77,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                78,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                114,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                110,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                32,
                33,
                61,
                61,
                32,
                104,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                115,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                116,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                107,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                118,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                113,
                99,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                32,
                33,
                61,
                61,
                32,
                104,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                112,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                109,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                32,
                33,
                61,
                61,
                32,
                109,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                109,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                108,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                111,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                106,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                119,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                32,
                33,
                61,
                61,
                32,
                112,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                112,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                122,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                65,
                99,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                99,
                32,
                124,
                124,
                32,
                66,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                99,
                32,
                124,
                124,
                32,
                40,
                68,
                32,
                61,
                32,
                65,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                66,
                99,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                122,
                99,
                32,
                38,
                38,
                32,
                40,
                122,
                99,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                107,
                46,
                99,
                97,
                108,
                108,
                101,
                100,
                82,
                117,
                110,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                33,
                109,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                40,
                115,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                111,
                110,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                73,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                100,
                63,
                46,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                93,
                41,
                59,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                40,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                48,
                32,
                60,
                32,
                67,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                41,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                93,
                41,
                59,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                117,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                40,
                114,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                60,
                32,
                67,
                32,
                124,
                124,
                32,
                40,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                32,
                63,
                32,
                40,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                34,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                46,
                46,
                46,
                34,
                41,
                44,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                34,
                34,
                41,
                44,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                49,
                41,
                41,
                32,
                58,
                32,
                97,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                93,
                41,
                59,
                32,
                48,
                32,
                60,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                46,
                112,
                111,
                112,
                40,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                32,
                61,
                32,
                99,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                125,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                112,
                108,
                97,
                121,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                61,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                77,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                114,
                101,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                119,
                97,
                115,
                109,
                45,
                108,
                111,
                97,
                100,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                82,
                101,
                110,
                100,
                101,
                114,
                101,
                114,
                76,
                111,
                97,
                100,
                101,
                114,
                32,
                105,
                115,
                32,
                97,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                97,
                110,
                100,
                32,
                99,
                97,
                110,
                110,
                111,
                116,
                32,
                98,
                101,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                100,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                112,
                108,
                97,
                121,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                40,
                123,
                32,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                117,
                114,
                108,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                84,
                114,
                105,
                101,
                115,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                104,
                101,
                32,
                112,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                85,
                82,
                76,
                44,
                32,
                102,
                97,
                108,
                108,
                105,
                110,
                103,
                32,
                98,
                97,
                99,
                107,
                32,
                116,
                111,
                32,
                97,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                32,
                105,
                102,
                32,
                110,
                101,
                99,
                101,
                115,
                115,
                97,
                114,
                121,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                84,
                104,
                114,
                111,
                119,
                115,
                32,
                97,
                110,
                32,
                101,
                114,
                114,
                111,
                114,
                32,
                105,
                102,
                32,
                98,
                111,
                116,
                104,
                32,
                85,
                82,
                76,
                115,
                32,
                102,
                97,
                105,
                108,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                60,
                77,
                111,
                100,
                117,
                108,
                101,
                62,
                32,
                45,
                32,
                65,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                116,
                104,
                97,
                116,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                115,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                108,
                111,
                97,
                100,
                87,
                105,
                116,
                104,
                66,
                97,
                99,
                107,
                117,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                97,
                115,
                121,
                110,
                99,
                32,
                40,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                32,
                61,
                32,
                96,
                104,
                116,
                116,
                112,
                115,
                58,
                47,
                47,
                117,
                110,
                112,
                107,
                103,
                46,
                99,
                111,
                109,
                47,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                125,
                64,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                125,
                47,
                100,
                105,
                115,
                116,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                80,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                87,
                65,
                83,
                77,
                32,
                108,
                111,
                97,
                100,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                125,
                46,
                32,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                36,
                123,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                65,
                116,
                116,
                101,
                109,
                112,
                116,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                114,
                111,
                109,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                97,
                99,
                107,
                117,
                112,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                96,
                80,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                87,
                65,
                83,
                77,
                32,
                85,
                82,
                76,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                96,
                66,
                97,
                99,
                107,
                117,
                112,
                32,
                87,
                65,
                83,
                77,
                32,
                85,
                82,
                76,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                98,
                97,
                99,
                107,
                117,
                112,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                87,
                65,
                83,
                77,
                32,
                108,
                111,
                97,
                100,
                105,
                110,
                103,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                97,
                108,
                108,
                32,
                115,
                111,
                117,
                114,
                99,
                101,
                115,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                117,
                98,
                108,
                105,
                99,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                85,
                116,
                105,
                108,
                105,
                122,
                101,
                115,
                32,
                97,
                32,
                112,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                97,
                110,
                100,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                114,
                111,
                98,
                117,
                115,
                116,
                110,
                101,
                115,
                115,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                60,
                77,
                111,
                100,
                117,
                108,
                101,
                62,
                32,
                45,
                32,
                65,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                116,
                104,
                97,
                116,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                115,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                108,
                111,
                97,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                87,
                105,
                116,
                104,
                66,
                97,
                99,
                107,
                117,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                101,
                116,
                115,
                32,
                97,
                32,
                110,
                101,
                119,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                32,
                97,
                110,
                100,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                97,
                116,
                101,
                115,
                32,
                116,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                45,
                32,
                32,
                84,
                104,
                101,
                32,
                110,
                101,
                119,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                117,
                114,
                108,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                32,
                61,
                32,
                117,
                114,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                47,
                47,
                32,
                101,
                115,
                108,
                105,
                110,
                116,
                45,
                100,
                105,
                115,
                97,
                98,
                108,
                101,
                45,
                110,
                101,
                120,
                116,
                45,
                108,
                105,
                110,
                101,
                32,
                64,
                116,
                121,
                112,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                45,
                101,
                115,
                108,
                105,
                110,
                116,
                47,
                110,
                97,
                109,
                105,
                110,
                103,
                45,
                99,
                111,
                110,
                118,
                101,
                110,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                44,
                32,
                34,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                47,
                47,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                44,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                101,
                100,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                112,
                97,
                99,
                107,
                97,
                103,
                101,
                32,
                105,
                110,
                102,
                111,
                114,
                109,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                44,
                32,
                34,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                34,
                44,
                32,
                96,
                104,
                116,
                116,
                112,
                115,
                58,
                47,
                47,
                99,
                100,
                110,
                46,
                106,
                115,
                100,
                101,
                108,
                105,
                118,
                114,
                46,
                110,
                101,
                116,
                47,
                110,
                112,
                109,
                47,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                125,
                64,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                125,
                47,
                100,
                105,
                115,
                116,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                96,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                101,
                118,
                101,
                110,
                116,
                45,
                109,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                83,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                115,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                97,
                100,
                100,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                63,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                61,
                62,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                65,
                108,
                108,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                99,
                108,
                101,
                97,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                111,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                45,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                32,
                61,
                32,
                40,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                110,
                116,
                114,
                121,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                105,
                115,
                73,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                110,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                105,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                101,
                115,
                104,
                111,
                108,
                100,
                58,
                32,
                48,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                104,
                97,
                115,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                100,
                105,
                115,
                99,
                111,
                110,
                110,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                114,
                101,
                115,
                105,
                122,
                101,
                45,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                82,
                69,
                83,
                73,
                90,
                69,
                95,
                68,
                69,
                66,
                79,
                85,
                78,
                67,
                69,
                95,
                84,
                73,
                77,
                69,
                32,
                61,
                32,
                49,
                48,
                48,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                32,
                61,
                32,
                40,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                110,
                116,
                114,
                121,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                93,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                101,
                119,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                32,
                61,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                69,
                83,
                73,
                90,
                69,
                95,
                68,
                69,
                66,
                79,
                85,
                78,
                67,
                69,
                95,
                84,
                73,
                77,
                69,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                44,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                110,
                101,
                119,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                114,
                101,
                115,
                105,
                122,
                101,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                104,
                97,
                115,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                41,
                32,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                100,
                105,
                115,
                99,
                111,
                110,
                110,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                117,
                116,
                105,
                108,
                115,
                46,
                116,
                115,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                72,
                101,
                120,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                47,
                94,
                35,
                40,
                91,
                92,
                100,
                97,
                45,
                102,
                93,
                123,
                54,
                125,
                124,
                91,
                92,
                100,
                97,
                45,
                102,
                93,
                123,
                56,
                125,
                41,
                36,
                47,
                105,
                117,
                46,
                116,
                101,
                115,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                101,
                120,
                83,
                116,
                114,
                105,
                110,
                103,
                84,
                111,
                82,
                71,
                66,
                65,
                73,
                110,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                72,
                101,
                120,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                104,
                101,
                120,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                34,
                35,
                34,
                44,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                104,
                101,
                120,
                32,
                61,
                32,
                104,
                101,
                120,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                54,
                32,
                63,
                32,
                96,
                36,
                123,
                104,
                101,
                120,
                125,
                102,
                102,
                96,
                32,
                58,
                32,
                104,
                101,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                97,
                114,
                115,
                101,
                73,
                110,
                116,
                40,
                104,
                101,
                120,
                44,
                32,
                49,
                54,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                60,
                32,
                52,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                105,
                108,
                101,
                83,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                46,
                115,
                108,
                105,
                99,
                101,
                40,
                48,
                44,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                91,
                105,
                93,
                32,
                33,
                61,
                61,
                32,
                102,
                105,
                108,
                101,
                83,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                91,
                105,
                93,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                106,
                115,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                76,
                79,
                84,
                84,
                73,
                69,
                95,
                74,
                83,
                79,
                78,
                95,
                77,
                65,
                78,
                68,
                65,
                84,
                79,
                82,
                89,
                95,
                70,
                73,
                69,
                76,
                68,
                83,
                46,
                101,
                118,
                101,
                114,
                121,
                40,
                40,
                102,
                105,
                101,
                108,
                100,
                41,
                32,
                61,
                62,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                46,
                99,
                97,
                108,
                108,
                40,
                106,
                115,
                111,
                110,
                44,
                32,
                102,
                105,
                101,
                108,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                74,
                83,
                79,
                78,
                46,
                112,
                97,
                114,
                115,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                95,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                112,
                114,
                32,
                61,
                32,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                63,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                58,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                49,
                32,
                43,
                32,
                40,
                100,
                112,
                114,
                32,
                45,
                32,
                49,
                41,
                32,
                42,
                32,
                68,
                69,
                70,
                65,
                85,
                76,
                84,
                95,
                68,
                80,
                82,
                95,
                70,
                65,
                67,
                84,
                79,
                82,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                99,
                116,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                99,
                116,
                46,
                116,
                111,
                112,
                32,
                62,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                108,
                101,
                102,
                116,
                32,
                62,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                98,
                111,
                116,
                116,
                111,
                109,
                32,
                60,
                61,
                32,
                40,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                105,
                110,
                110,
                101,
                114,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                124,
                124,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                41,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                114,
                105,
                103,
                104,
                116,
                32,
                60,
                61,
                32,
                40,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                105,
                110,
                110,
                101,
                114,
                87,
                105,
                100,
                116,
                104,
                32,
                124,
                124,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                32,
                61,
                32,
                40,
                109,
                111,
                100,
                101,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                66,
                111,
                117,
                110,
                99,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                45,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                66,
                111,
                117,
                110,
                99,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                70,
                111,
                114,
                119,
                97,
                114,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                32,
                61,
                32,
                40,
                102,
                105,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                110,
                116,
                97,
                105,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                99,
                111,
                118,
                101,
                114,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                118,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                108,
                108,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                116,
                45,
                104,
                101,
                105,
                103,
                104,
                116,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                116,
                45,
                119,
                105,
                100,
                116,
                104,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                87,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                78,
                111,
                110,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                32,
                61,
                32,
                40,
                97,
                108,
                105,
                103,
                110,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                97,
                108,
                105,
                103,
                110,
                91,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                97,
                108,
                105,
                103,
                110,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                50,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                32,
                63,
                63,
                32,
                91,
                48,
                46,
                53,
                44,
                32,
                48,
                46,
                53,
                93,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                32,
                63,
                63,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                34,
                44,
                32,
                123,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                34,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                69,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                63,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                105,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                98,
                121,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                116,
                111,
                32,
                112,
                114,
                101,
                118,
                101,
                110,
                116,
                32,
                117,
                110,
                110,
                101,
                99,
                101,
                115,
                115,
                97,
                114,
                121,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                105,
                110,
                103,
                32,
                119,
                104,
                101,
                110,
                32,
                116,
                104,
                101,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                115,
                32,
                111,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                63,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                46,
                108,
                111,
                97,
                100,
                40,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                48,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                111,
                111,
                112,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                111,
                100,
                101,
                32,
                63,
                63,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                63,
                63,
                32,
                91,
                93,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                49,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                97,
                100,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                119,
                97,
                115,
                109,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                58,
                32,
                36,
                123,
                101,
                114,
                114,
                111,
                114,
                125,
                96,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                102,
                101,
                116,
                99,
                104,
                68,
                97,
                116,
                97,
                40,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                102,
                101,
                116,
                99,
                104,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                32,
                102,
                114,
                111,
                109,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                115,
                114,
                99,
                125,
                46,
                32,
                36,
                123,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                125,
                58,
                32,
                36,
                123,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                84,
                101,
                120,
                116,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                97,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                41,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                100,
                97,
                116,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                68,
                97,
                116,
                97,
                40,
                74,
                83,
                79,
                78,
                46,
                115,
                116,
                114,
                105,
                110,
                103,
                105,
                102,
                121,
                40,
                100,
                97,
                116,
                97,
                41,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                85,
                110,
                115,
                117,
                112,
                112,
                111,
                114,
                116,
                101,
                100,
                32,
                100,
                97,
                116,
                97,
                32,
                116,
                121,
                112,
                101,
                32,
                102,
                111,
                114,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                46,
                32,
                69,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                58,
                32,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                40,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                40,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                40,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                41,
                46,
                32,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                101,
                99,
                101,
                105,
                118,
                101,
                100,
                58,
                32,
                36,
                123,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                34,
                115,
                111,
                109,
                101,
                116,
                104,
                105,
                110,
                103,
                32,
                119,
                101,
                110,
                116,
                32,
                119,
                114,
                111,
                110,
                103,
                44,
                32,
                116,
                104,
                101,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                119,
                97,
                115,
                32,
                115,
                117,
                112,
                112,
                111,
                115,
                101,
                32,
                116,
                111,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                82,
                101,
                115,
                105,
                122,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                101,
                116,
                99,
                104,
                68,
                97,
                116,
                97,
                40,
                115,
                114,
                99,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                100,
                97,
                116,
                97,
                41,
                32,
                61,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                32,
                102,
                114,
                111,
                109,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                115,
                114,
                99,
                125,
                46,
                32,
                36,
                123,
                101,
                114,
                114,
                111,
                114,
                125,
                96,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                91,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                44,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                93,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                110,
                116,
                97,
                105,
                110,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                118,
                101,
                114,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                118,
                101,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                108,
                108,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                108,
                108,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                116,
                45,
                104,
                101,
                105,
                103,
                104,
                116,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                87,
                105,
                100,
                116,
                104,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                116,
                45,
                119,
                105,
                100,
                116,
                104,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                78,
                111,
                110,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                110,
                111,
                110,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                33,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                32,
                61,
                32,
                74,
                83,
                79,
                78,
                46,
                112,
                97,
                114,
                115,
                101,
                40,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                107,
                101,
                121,
                115,
                40,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                41,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                95,
                101,
                114,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                61,
                61,
                61,
                32,
                50,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                44,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                111,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                111,
                100,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                109,
                111,
                100,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                66,
                111,
                117,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                66,
                111,
                117,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                45,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                112,
                101,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                77,
                97,
                116,
                104,
                46,
                114,
                111,
                117,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                42,
                32,
                49,
                48,
                48,
                41,
                32,
                47,
                32,
                49,
                48,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                48,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                111,
                111,
                112,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                111,
                100,
                101,
                32,
                63,
                63,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                63,
                63,
                32,
                91,
                93,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                49,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                38,
                38,
                32,
                34,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                34,
                32,
                105,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                38,
                38,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                34,
                50,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                42,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                42,
                32,
                66,
                89,
                84,
                69,
                83,
                95,
                80,
                69,
                82,
                95,
                80,
                73,
                88,
                69,
                76,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                115,
                105,
                122,
                101,
                32,
                109,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                58,
                32,
                103,
                111,
                116,
                32,
                36,
                123,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                125,
                44,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                36,
                123,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                67,
                108,
                97,
                109,
                112,
                101,
                100,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                48,
                44,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                46,
                100,
                97,
                116,
                97,
                46,
                115,
                101,
                116,
                40,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                112,
                117,
                116,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                44,
                32,
                48,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                101,
                120,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                114,
                111,
                117,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                42,
                32,
                49,
                101,
                51,
                41,
                32,
                47,
                32,
                49,
                101,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                112,
                100,
                97,
                116,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                110,
                101,
                120,
                116,
                70,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                117,
                112,
                100,
                97,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                67,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                34,
                69,
                114,
                114,
                111,
                114,
                32,
                105,
                110,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                102,
                114,
                97,
                109,
                101,
                58,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                38,
                38,
                32,
                33,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                97,
                117,
                115,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                111,
                112,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                114,
                97,
                109,
                101,
                32,
                60,
                32,
                48,
                32,
                124,
                124,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                101,
                107,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                40,
                115,
                112,
                101,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                115,
                116,
                121,
                108,
                101,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                104,
                101,
                120,
                83,
                116,
                114,
                105,
                110,
                103,
                84,
                111,
                82,
                71,
                66,
                65,
                73,
                110,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                108,
                111,
                111,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                108,
                111,
                111,
                112,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                65,
                108,
                108,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                124,
                124,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                112,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                58,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                58,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                33,
                61,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                42,
                32,
                100,
                112,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                42,
                32,
                100,
                112,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                115,
                116,
                97,
                114,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                32,
                101,
                110,
                100,
                70,
                114,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                91,
                115,
                116,
                97,
                114,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                32,
                101,
                110,
                100,
                70,
                114,
                97,
                109,
                101,
                93,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                44,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                44,
                32,
                46,
                46,
                46,
                114,
                101,
                115,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                125,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                114,
                101,
                115,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                105,
                115,
                32,
                97,
                32,
                115,
                112,
                101,
                99,
                105,
                97,
                108,
                32,
                99,
                97,
                115,
                101,
                44,
                32,
                105,
                116,
                32,
                115,
                104,
                111,
                117,
                108,
                100,
                32,
                98,
                101,
                32,
                115,
                101,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                105,
                102,
                32,
                105,
                116,
                39,
                115,
                32,
                110,
                111,
                116,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                58,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                58,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                82,
                101,
                115,
                105,
                122,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                32,
                61,
                61,
                61,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                58,
                36,
                123,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                125,
                96,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                46,
                112,
                117,
                115,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                110,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                105,
                109,
                101,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                116,
                105,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                108,
                111,
                116,
                115,
                40,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                83,
                108,
                111,
                116,
                115,
                40,
                115,
                108,
                111,
                116,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                46,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                79,
                112,
                101,
                110,
                85,
                82,
                76,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                40,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                99,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                99,
                97,
                108,
                101,
                88,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                47,
                32,
                114,
                101,
                99,
                116,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                99,
                97,
                108,
                101,
                89,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                47,
                32,
                114,
                101,
                99,
                116,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                88,
                32,
                45,
                32,
                114,
                101,
                99,
                116,
                46,
                108,
                101,
                102,
                116,
                41,
                32,
                42,
                32,
                115,
                99,
                97,
                108,
                101,
                88,
                32,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                89,
                32,
                45,
                32,
                114,
                101,
                99,
                116,
                46,
                116,
                111,
                112,
                41,
                32,
                42,
                32,
                115,
                99,
                97,
                108,
                101,
                89,
                32,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                70,
                114,
                97,
                109,
                101,
                119,
                111,
                114,
                107,
                83,
                101,
                116,
                117,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                112,
                117,
                115,
                104,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                117,
                112,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                100,
                111,
                119,
                110,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                109,
                111,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                101,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                108,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                117,
                112,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                100,
                111,
                119,
                110,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                109,
                111,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                101,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                108,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                79,
                114,
                105,
                101,
                110,
                116,
                101,
                100,
                32,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                32,
                66,
                111,
                120,
                32,
                40,
                79,
                66,
                66,
                41,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                111,
                102,
                32,
                97,
                32,
                108,
                97,
                121,
                101,
                114,
                32,
                98,
                121,
                32,
                105,
                116,
                115,
                32,
                110,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                65,
                110,
                32,
                97,
                114,
                114,
                97,
                121,
                32,
                111,
                102,
                32,
                56,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                115,
                32,
                114,
                101,
                112,
                114,
                101,
                115,
                101,
                110,
                116,
                105,
                110,
                103,
                32,
                52,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                40,
                120,
                44,
                121,
                41,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                79,
                66,
                66,
                32,
                105,
                110,
                32,
                99,
                108,
                111,
                99,
                107,
                119,
                105,
                115,
                101,
                32,
                111,
                114,
                100,
                101,
                114,
                32,
                115,
                116,
                97,
                114,
                116,
                105,
                110,
                103,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                111,
                112,
                45,
                108,
                101,
                102,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                91,
                120,
                48,
                44,
                32,
                121,
                48,
                44,
                32,
                120,
                49,
                44,
                32,
                121,
                49,
                44,
                32,
                120,
                50,
                44,
                32,
                121,
                50,
                44,
                32,
                120,
                51,
                44,
                32,
                121,
                51,
                93,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                97,
                109,
                112,
                108,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                96,
                96,
                96,
                116,
                121,
                112,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                47,
                47,
                32,
                68,
                114,
                97,
                119,
                32,
                97,
                32,
                112,
                111,
                108,
                121,
                103,
                111,
                110,
                32,
                97,
                114,
                111,
                117,
                110,
                100,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                32,
                39,
                76,
                97,
                121,
                101,
                114,
                32,
                49,
                39,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                39,
                114,
                101,
                110,
                100,
                101,
                114,
                39,
                44,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                32,
                61,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                40,
                39,
                76,
                97,
                121,
                101,
                114,
                32,
                49,
                39,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                98,
                101,
                103,
                105,
                110,
                80,
                97,
                116,
                104,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                109,
                111,
                118,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                48,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                49,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                70,
                105,
                114,
                115,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                50,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                51,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                83,
                101,
                99,
                111,
                110,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                52,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                53,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                84,
                104,
                105,
                114,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                54,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                55,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                70,
                111,
                117,
                114,
                116,
                104,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                99,
                108,
                111,
                115,
                101,
                80,
                97,
                116,
                104,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                115,
                116,
                114,
                111,
                107,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                96,
                96,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                40,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                115,
                40,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                111,
                117,
                110,
                100,
                115,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                33,
                61,
                61,
                32,
                56,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                56,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                46,
                112,
                117,
                115,
                104,
                40,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                116,
                114,
                97,
                110,
                115,
                102,
                111,
                114,
                109,
                84,
                104,
                101,
                109,
                101,
                84,
                111,
                76,
                111,
                116,
                116,
                105,
                101,
                83,
                108,
                111,
                116,
                115,
                40,
                116,
                104,
                101,
                109,
                101,
                44,
                32,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                116,
                114,
                97,
                110,
                115,
                102,
                111,
                114,
                109,
                84,
                104,
                101,
                109,
                101,
                84,
                111,
                76,
                111,
                116,
                116,
                105,
                101,
                83,
                108,
                111,
                116,
                115,
                40,
                116,
                104,
                101,
                109,
                101,
                44,
                32,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                44,
                32,
                34,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                119,
                111,
                114,
                107,
                101,
                114,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                46,
                119,
                111,
                114,
                107,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                32,
                61,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                118,
                101,
                110,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                77,
                97,
                112,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                97,
                100,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                67,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                97,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                97,
                100,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                108,
                97,
                121,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                80,
                108,
                97,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                112,
                108,
                97,
                121,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                97,
                117,
                115,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                80,
                97,
                117,
                115,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                112,
                97,
                117,
                115,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                97,
                109,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                102,
                114,
                97,
                109,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                70,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                85,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                68,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                83,
                116,
                97,
                116,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                111,
                112,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                111,
                100,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                112,
                101,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                104,
                97,
                115,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                101,
                120,
                105,
                115,
                116,
                115,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                115,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                118,
                101,
                110,
                116,
                115,
                32,
                61,
                32,
                91,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                112,
                97,
                117,
                115,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                97,
                100,
                121,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                44,
                32,
                101,
                118,
                101,
                110,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                77,
                97,
                112,
                91,
                101,
                118,
                101,
                110,
                116,
                93,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                102,
                114,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                111,
                100,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                48,
                93,
                44,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                112,
                101,
                101,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                112,
                101,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                40,
                115,
                112,
                101,
                101,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                125,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                105,
                100,
                116,
                104,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                111,
                112,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                108,
                111,
                111,
                112,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                108,
                111,
                111,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                120,
                101,
                99,
                117,
                116,
                101,
                67,
                111,
                109,
                109,
                97,
                110,
                100,
                40,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                91,
                109,
                101,
                116,
                104,
                111,
                100,
                93,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                91,
                109,
                101,
                116,
                104,
                111,
                100,
                93,
                40,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                36,
                123,
                109,
                101,
                116,
                104,
                111,
                100,
                125,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                105,
                109,
                112,
                108,
                101,
                109,
                101,
                110,
                116,
                101,
                100,
                32,
                105,
                110,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                111,
                110,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                61,
                32,
                101,
                120,
                101,
                99,
                117,
                116,
                101,
                67,
                111,
                109,
                109,
                97,
                110,
                100,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                105,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                114,
                114,
                111,
                114,
                82,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                105,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                101,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                101,
                114,
                114,
                111,
                114,
                82,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                117,
                109,
                109,
                121,
                32,
                61,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                119,
                111,
                114,
                107,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                61,
                32,
                100,
                117,
                109,
                109,
                121,
                59,
                10,
                125,
                41,
                40,
                41,
                59,
                10
            ])
        ], {
            type: "application/javascript"
        }), i = URL.createObjectURL(d), r = new Worker(i);
        return URL.revokeObjectURL(i), r;
    }
}, $1ee5bf1527ec861d$var$d0 = $1ee5bf1527ec861d$var$h0, $1ee5bf1527ec861d$var$c0 = class {
    constructor(){
        $1ee5bf1527ec861d$var$v(this, "_workers", new Map), $1ee5bf1527ec861d$var$v(this, "_animationWorkerMap", new Map);
    }
    getWorker(d) {
        return this._workers.has(d) || this._workers.set(d, new $1ee5bf1527ec861d$var$d0), this._workers.get(d);
    }
    assignAnimationToWorker(d, i) {
        this._animationWorkerMap.set(d, i);
    }
    unassignAnimationFromWorker(d) {
        this._animationWorkerMap.delete(d);
    }
    sendMessage(d, i, r) {
        this.getWorker(d).postMessage(i, r || []);
    }
    terminateWorker(d) {
        let i = this._workers.get(d);
        i && (i.terminate(), this._workers.delete(d));
    }
};
function $1ee5bf1527ec861d$var$Q2(d, i) {
    if (d instanceof HTMLCanvasElement) {
        let { height: r, width: s } = d.getBoundingClientRect();
        if (r !== 0 && s !== 0) return {
            width: s * i,
            height: r * i
        };
    }
    return {
        width: d.width,
        height: d.height
    };
}
function $1ee5bf1527ec861d$var$N2() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var $1ee5bf1527ec861d$var$_2 = class r1 {
    constructor(i){
        $1ee5bf1527ec861d$var$v(this, "_eventManager", new $1ee5bf1527ec861d$var$J2), $1ee5bf1527ec861d$var$v(this, "_id"), $1ee5bf1527ec861d$var$v(this, "_worker"), $1ee5bf1527ec861d$var$v(this, "_canvas"), $1ee5bf1527ec861d$var$v(this, "_dotLottieInstanceState", {
            loopCount: 0,
            markers: [],
            autoplay: false,
            backgroundColor: "",
            currentFrame: 0,
            duration: 0,
            loop: false,
            mode: "forward",
            segment: [
                0,
                0
            ],
            segmentDuration: 0,
            speed: 1,
            totalFrames: 0,
            isLoaded: false,
            isPlaying: false,
            isPaused: false,
            isStopped: true,
            isFrozen: false,
            useFrameInterpolation: false,
            renderConfig: {
                devicePixelRatio: $1ee5bf1527ec861d$var$o1()
            },
            activeAnimationId: "",
            activeThemeId: "",
            layout: void 0,
            marker: void 0,
            isReady: false,
            manifest: null
        }), $1ee5bf1527ec861d$var$v(this, "_created", false), $1ee5bf1527ec861d$var$v(this, "_pointerUpMethod"), $1ee5bf1527ec861d$var$v(this, "_pointerDownMethod"), $1ee5bf1527ec861d$var$v(this, "_pointerMoveMethod"), $1ee5bf1527ec861d$var$v(this, "_pointerEnterMethod"), $1ee5bf1527ec861d$var$v(this, "_pointerExitMethod"), this._canvas = i.canvas, this._id = `dotlottie-${$1ee5bf1527ec861d$var$N2()}`;
        let r = i.workerId || "defaultWorker";
        this._worker = r1._workerManager.getWorker(r), r1._workerManager.assignAnimationToWorker(this._id, r), r1._wasmUrl && this._sendMessage("setWasmUrl", {
            url: r1._wasmUrl
        }), this._create({
            ...i,
            renderConfig: {
                ...i.renderConfig,
                devicePixelRatio: i.renderConfig?.devicePixelRatio || $1ee5bf1527ec861d$var$o1(),
                freezeOnOffscreen: i.renderConfig?.freezeOnOffscreen ?? true
            }
        }), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
    }
    async _handleWorkerEvent(i) {
        let r = i.data;
        r.id || (r.method === "onLoad" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event), $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && $1ee5bf1527ec861d$var$N.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && $1ee5bf1527ec861d$var$X.observe(this._canvas, this))), r.method === "onComplete" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event)), r.method === "onDestroy" && r.result.instanceId === this._id && this._eventManager.dispatch(r.result.event), r.method === "onUnfreeze" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = false, this._eventManager.dispatch(r.result.event)), r.method === "onFrame" && r.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = r.result.event.currentFrame, this._eventManager.dispatch(r.result.event)), r.method === "onRender" && r.result.instanceId === this._id && this._eventManager.dispatch(r.result.event), r.method === "onFreeze" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event)), r.method === "onPause" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event)), r.method === "onPlay" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event)), r.method === "onStop" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event)), r.method === "onLoadError" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event)), r.method === "onRenderError" && r.result.instanceId === this._id && this._eventManager.dispatch(r.result.event), r.method === "onReady" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event)), r.method === "onLoop" && r.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(r.result.event)));
    }
    async _create(i) {
        let r;
        this._canvas instanceof HTMLCanvasElement ? r = this._canvas.transferControlToOffscreen() : r = this._canvas;
        let { instanceId: s } = await this._sendMessage("create", {
            instanceId: this._id,
            config: {
                ...i,
                canvas: r
            },
            ...$1ee5bf1527ec861d$var$Q2(this._canvas, i.renderConfig?.devicePixelRatio || $1ee5bf1527ec861d$var$o1())
        }, [
            r
        ]);
        if (s !== this._id) throw new Error("Instance ID mismatch");
        this._created = true, await this._updateDotLottieInstanceState();
    }
    get loopCount() {
        return this._dotLottieInstanceState.loopCount;
    }
    get isLoaded() {
        return this._dotLottieInstanceState.isLoaded;
    }
    get isPlaying() {
        return this._dotLottieInstanceState.isPlaying;
    }
    get isPaused() {
        return this._dotLottieInstanceState.isPaused;
    }
    get isStopped() {
        return this._dotLottieInstanceState.isStopped;
    }
    get currentFrame() {
        return this._dotLottieInstanceState.currentFrame;
    }
    get isFrozen() {
        return this._dotLottieInstanceState.isFrozen;
    }
    get segmentDuration() {
        return this._dotLottieInstanceState.segmentDuration;
    }
    get totalFrames() {
        return this._dotLottieInstanceState.totalFrames;
    }
    get segment() {
        return this._dotLottieInstanceState.segment;
    }
    get speed() {
        return this._dotLottieInstanceState.speed;
    }
    get duration() {
        return this._dotLottieInstanceState.duration;
    }
    get isReady() {
        return this._dotLottieInstanceState.isReady;
    }
    get mode() {
        return this._dotLottieInstanceState.mode;
    }
    get canvas() {
        return this._canvas;
    }
    get autoplay() {
        return this._dotLottieInstanceState.autoplay;
    }
    get backgroundColor() {
        return this._dotLottieInstanceState.backgroundColor;
    }
    get loop() {
        return this._dotLottieInstanceState.loop;
    }
    get useFrameInterpolation() {
        return this._dotLottieInstanceState.useFrameInterpolation;
    }
    get renderConfig() {
        return this._dotLottieInstanceState.renderConfig;
    }
    get manifest() {
        return this._dotLottieInstanceState.manifest;
    }
    get activeAnimationId() {
        return this._dotLottieInstanceState.activeAnimationId;
    }
    get marker() {
        return this._dotLottieInstanceState.marker;
    }
    get activeThemeId() {
        return this._dotLottieInstanceState.activeThemeId;
    }
    get layout() {
        return this._dotLottieInstanceState.layout;
    }
    async play() {
        this._created && (await this._sendMessage("play", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState(), $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !$1ee5bf1527ec861d$var$Y2(this._canvas) && await this.freeze());
    }
    async pause() {
        this._created && (await this._sendMessage("pause", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async stop() {
        this._created && (await this._sendMessage("stop", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setSpeed(i) {
        this._created && (await this._sendMessage("setSpeed", {
            instanceId: this._id,
            speed: i
        }), await this._updateDotLottieInstanceState());
    }
    async setMode(i) {
        this._created && (await this._sendMessage("setMode", {
            instanceId: this._id,
            mode: i
        }), await this._updateDotLottieInstanceState());
    }
    async setFrame(i) {
        this._created && (await this._sendMessage("setFrame", {
            frame: i,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setSegment(i, r) {
        this._created && (await this._sendMessage("setSegment", {
            instanceId: this._id,
            segment: [
                i,
                r
            ]
        }), await this._updateDotLottieInstanceState());
    }
    async setRenderConfig(i) {
        if (!this._created) return;
        let { devicePixelRatio: r, freezeOnOffscreen: s, ...p } = i;
        await this._sendMessage("setRenderConfig", {
            instanceId: this._id,
            renderConfig: {
                ...this._dotLottieInstanceState.renderConfig,
                ...p,
                devicePixelRatio: r || $1ee5bf1527ec861d$var$o1(),
                freezeOnOffscreen: s ?? true
            }
        }), await this._updateDotLottieInstanceState(), $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? $1ee5bf1527ec861d$var$X.observe(this._canvas, this) : $1ee5bf1527ec861d$var$X.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? $1ee5bf1527ec861d$var$N.observe(this._canvas, this) : ($1ee5bf1527ec861d$var$N.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && await this.unfreeze()));
    }
    async setUseFrameInterpolation(i) {
        this._created && (await this._sendMessage("setUseFrameInterpolation", {
            instanceId: this._id,
            useFrameInterpolation: i
        }), await this._updateDotLottieInstanceState());
    }
    async setTheme(i) {
        if (!this._created) return false;
        let r = this._sendMessage("setTheme", {
            instanceId: this._id,
            themeId: i
        });
        return await this._updateDotLottieInstanceState(), r;
    }
    async load(i) {
        this._created && (await this._sendMessage("load", {
            config: i,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setLoop(i) {
        this._created && (await this._sendMessage("setLoop", {
            instanceId: this._id,
            loop: i
        }), await this._updateDotLottieInstanceState());
    }
    async resize() {
        if (!this._created) return;
        let { height: i, width: r } = $1ee5bf1527ec861d$var$Q2(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || $1ee5bf1527ec861d$var$o1());
        await this._sendMessage("resize", {
            height: i,
            instanceId: this._id,
            width: r
        }), await this._updateDotLottieInstanceState();
    }
    async destroy() {
        this._created && (this._created = false, await this._sendMessage("destroy", {
            instanceId: this._id
        }), this._cleanupStateMachineListeners(), r1._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && ($1ee5bf1527ec861d$var$N.unobserve(this._canvas), $1ee5bf1527ec861d$var$X.unobserve(this._canvas)));
    }
    async freeze() {
        this._created && (await this._sendMessage("freeze", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async unfreeze() {
        this._created && (await this._sendMessage("unfreeze", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setBackgroundColor(i) {
        this._created && (await this._sendMessage("setBackgroundColor", {
            instanceId: this._id,
            backgroundColor: i
        }), await this._updateDotLottieInstanceState());
    }
    async loadAnimation(i) {
        this._created && (await this._sendMessage("loadAnimation", {
            animationId: i,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setLayout(i) {
        this._created && (await this._sendMessage("setLayout", {
            instanceId: this._id,
            layout: i
        }), await this._updateDotLottieInstanceState());
    }
    async _updateDotLottieInstanceState() {
        if (!this._created) return;
        let i = await this._sendMessage("getDotLottieInstanceState", {
            instanceId: this._id
        });
        this._dotLottieInstanceState = i.state;
    }
    markers() {
        return this._dotLottieInstanceState.markers;
    }
    async setMarker(i) {
        this._created && (await this._sendMessage("setMarker", {
            instanceId: this._id,
            marker: i
        }), await this._updateDotLottieInstanceState());
    }
    async setThemeData(i) {
        if (!this._created) return false;
        let r = await this._sendMessage("setThemeData", {
            instanceId: this._id,
            themeData: i
        });
        return await this._updateDotLottieInstanceState(), r;
    }
    async setViewport(i, r, s, p) {
        return this._created ? this._sendMessage("setViewport", {
            x: i,
            y: r,
            width: s,
            height: p,
            instanceId: this._id
        }) : false;
    }
    async animationSize() {
        return this._created ? this._sendMessage("animationSize", {
            instanceId: this._id
        }) : {
            height: 0,
            width: 0
        };
    }
    async _sendMessage(i, r, s) {
        let p = {
            id: `dotlottie-request-${$1ee5bf1527ec861d$var$N2()}`,
            method: i,
            params: r
        };
        return this._worker.postMessage(p, s || []), new Promise((P, z)=>{
            let F = (G)=>{
                let E = G.data;
                E.id === p.id && (this._worker.removeEventListener("message", F), E.error ? z(new Error(`Failed to execute method ${i}: ${E.error}`)) : P(E.result));
            };
            this._worker.addEventListener("message", F);
        });
    }
    addEventListener(i, r) {
        this._eventManager.addEventListener(i, r);
    }
    removeEventListener(i, r) {
        this._eventManager.removeEventListener(i, r);
    }
    static setWasmUrl(i) {
        r1._wasmUrl = i;
    }
    async loadStateMachine(i) {
        if (!this._created) return false;
        let r = await this._sendMessage("loadStateMachine", {
            instanceId: this._id,
            stateMachineId: i
        });
        return await this._updateDotLottieInstanceState(), r;
    }
    async loadStateMachineData(i) {
        if (!this._created) return false;
        let r = await this._sendMessage("loadStateMachineData", {
            instanceId: this._id,
            stateMachineData: i
        });
        return await this._updateDotLottieInstanceState(), r;
    }
    async startStateMachine() {
        if (!this._created) return false;
        this._setupStateMachineListeners();
        let i = await this._sendMessage("startStateMachine", {
            instanceId: this._id
        });
        return await this._updateDotLottieInstanceState(), i;
    }
    async stopStateMachine() {
        return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", {
            instanceId: this._id
        })) : false;
    }
    async getStateMachineListeners() {
        return this._created ? this._sendMessage("getStateMachineListeners", {
            instanceId: this._id
        }) : [];
    }
    _getPointerPosition(i) {
        let r = this._canvas.getBoundingClientRect(), s = this._canvas.width / r.width, p = this._canvas.height / r.height, P = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, z = (i.clientX - r.left) * s / P, F = (i.clientY - r.top) * p / P;
        return {
            x: z,
            y: F
        };
    }
    _onPointerUp(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this._sendMessage("postPointerUpEvent", {
            instanceId: this._id,
            x: r,
            y: s
        });
    }
    _onPointerDown(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this._sendMessage("postPointerDownEvent", {
            instanceId: this._id,
            x: r,
            y: s
        });
    }
    _onPointerMove(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this._sendMessage("postPointerMoveEvent", {
            instanceId: this._id,
            x: r,
            y: s
        });
    }
    _onPointerEnter(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this._sendMessage("postPointerEnterEvent", {
            instanceId: this._id,
            x: r,
            y: s
        });
    }
    _onPointerLeave(i) {
        let { x: r, y: s } = this._getPointerPosition(i);
        this._sendMessage("postPointerExitEvent", {
            instanceId: this._id,
            x: r,
            y: s
        });
    }
    async _setupStateMachineListeners() {
        if ($1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
            let i = await this._sendMessage("getStateMachineListeners", {
                instanceId: this._id
            });
            i.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), i.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), i.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), i.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), i.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
        }
    }
    _cleanupStateMachineListeners() {
        $1ee5bf1527ec861d$var$A && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
    }
};
$1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$_2, "_workerManager", new $1ee5bf1527ec861d$var$c0), $1ee5bf1527ec861d$var$v($1ee5bf1527ec861d$var$_2, "_wasmUrl", "");
var $1ee5bf1527ec861d$var$H1 = $1ee5bf1527ec861d$var$_2;
var $1ee5bf1527ec861d$var$Q1 = ({ animationId: d, autoplay: i, backgroundColor: r, className: s, createDotLottie: p, data: P, dotLottieRefCallback: z, layout: F, loop: G, mode: E, playOnHover: l1, renderConfig: u1, segment: $, speed: K, src: q, style: s1, themeData: h1, themeId: B, useFrameInterpolation: M, workerId: t1, ...J })=>{
    let L = (0, $8NFma.useRef)(null), w = (0, $8NFma.useRef)(null), f1 = (0, $8NFma.useRef)(z), _1 = {
        speed: K,
        mode: E,
        loop: G,
        useFrameInterpolation: M,
        segment: $,
        backgroundColor: r,
        autoplay: i,
        themeId: B,
        workerId: t1,
        src: q,
        data: P,
        layout: F,
        renderConfig: u1,
        animationId: d
    }, i1 = (0, $8NFma.useRef)(_1);
    f1.current = z, i1.current = _1;
    let E1 = (0, $8NFma.useCallback)((H)=>{
        w.current = H, H ? L.current = p({
            ...i1.current,
            canvas: H
        }) : (L.current?.destroy(), L.current = null), f1.current?.(L.current);
    }, []);
    return (0, $8NFma.useEffect)(()=>{
        let H = (v1)=>{
            l1 && (v1.type === "mouseenter" && L.current?.play(), v1.type === "mouseleave" && L.current?.pause());
        };
        return w.current?.addEventListener("mouseenter", H), w.current?.addEventListener("mouseleave", H), ()=>{
            w.current?.removeEventListener("mouseenter", H), w.current?.removeEventListener("mouseleave", H);
        };
    }, [
        l1
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setSpeed(K ?? 1);
    }, [
        K
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setMode(E ?? "forward");
    }, [
        E
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setLoop(G ?? false);
    }, [
        G
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setUseFrameInterpolation(M ?? true);
    }, [
        M
    ]), (0, $8NFma.useEffect)(()=>{
        typeof $?.[0] == "number" && typeof $[1] == "number" && L.current?.setSegment($[0], $[1]);
    }, [
        $
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setBackgroundColor(r ?? "");
    }, [
        r
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setRenderConfig(u1 ?? {});
    }, [
        JSON.stringify(u1)
    ]), (0, $8NFma.useEffect)(()=>{
        typeof P != "string" && typeof P != "object" || L.current?.load({
            data: P,
            ...i1.current
        });
    }, [
        P
    ]), (0, $8NFma.useEffect)(()=>{
        typeof q == "string" && L.current?.load({
            src: q,
            ...i1.current
        });
    }, [
        q
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setMarker(J.marker ?? "");
    }, [
        J.marker
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.loadAnimation(d ?? "");
    }, [
        d
    ]), (0, $8NFma.useEffect)(()=>{
        typeof B == "string" && L.current?.setTheme(B);
    }, [
        B
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setThemeData(h1 ?? "");
    }, [
        h1
    ]), (0, $8NFma.useEffect)(()=>{
        L.current?.setLayout(F ?? {});
    }, [
        F?.fit,
        F?.align && F.align[0],
        F?.align && F.align[1]
    ]), (0, $1IdZj.jsx)("div", {
        className: s,
        ...!s && {
            style: {
                width: "100%",
                height: "100%",
                lineHeight: 0,
                ...s1
            }
        },
        children: (0, $1IdZj.jsx)("canvas", {
            ref: E1,
            style: {
                width: "100%",
                height: "100%"
            },
            ...J
        })
    });
};
var $1ee5bf1527ec861d$var$u0 = (d)=>new $1ee5bf1527ec861d$var$B1(d), $1ee5bf1527ec861d$export$5502e10bdc22dfb3 = (d)=>(0, $1IdZj.jsx)($1ee5bf1527ec861d$var$Q1, {
        ...d,
        createDotLottie: $1ee5bf1527ec861d$var$u0
    });
var $1ee5bf1527ec861d$var$_0 = (d)=>new $1ee5bf1527ec861d$var$H1(d), $1ee5bf1527ec861d$export$bfcb0a2f556afa6b = (d)=>(0, $1IdZj.jsx)($1ee5bf1527ec861d$var$Q1, {
        ...d,
        createDotLottie: $1ee5bf1527ec861d$var$_0
    });
var $1ee5bf1527ec861d$export$878e2eb5c33b978f = (d)=>{
    $1ee5bf1527ec861d$var$H1.setWasmUrl(d), $1ee5bf1527ec861d$var$B1.setWasmUrl(d);
};
 //# sourceMappingURL=index.js.map

});

parcelRegister("bws69", function(module, exports) {

$parcel$export(module.exports, "useDotLottie", () => $86387a9978ffe5e0$export$bc8b8ec26ea46445);

var $k9W3x = parcelRequire("k9W3x");

var $8NFma = parcelRequire("8NFma");
const $86387a9978ffe5e0$var$getAnimationData = async (url)=>{
    try {
        const hash = (0, (/*@__PURE__*/$parcel$interopDefault($k9W3x)))(url);
        // Check if animation data already exists in browser storage
        const storageKey = `trial_animation_data_${hash}`;
        const storageItem = sessionStorage.getItem(storageKey);
        let animationData;
        if (storageItem) animationData = storageItem;
        else {
            const response = await fetch(url);
            const json = await response.json();
            if (json?.data) {
                animationData = json.data;
                try {
                    sessionStorage.setItem(storageKey, animationData);
                } catch (e) {
                    console.warn(e);
                }
            }
        }
        // Store animation data in component state
        if (animationData) return JSON.parse(animationData);
    } catch (e) {
        console.error(e);
    }
};
const $86387a9978ffe5e0$export$bc8b8ec26ea46445 = ({ data: data, selection: selection, step: step })=>{
    const { url: url, subtitle: subtitle } = (0, $8NFma.useMemo)(()=>{
        const currentGoal = data.options.find((option)=>option.goal_id === selection[0].value);
        if (step === 0) return {
            url: currentGoal.goal_animation,
            subtitle: currentGoal.goal_description
        };
        else {
            const role = currentGoal.roles.find((role)=>role.role_id === selection[step].value);
            return {
                url: role.role_animation,
                subtitle: role.role_description
            };
        }
    }, [
        selection,
        step
    ]);
    const [animationData, setAnimationData] = (0, $8NFma.useState)();
    (0, $8NFma.useEffect)(()=>{
        if (!url) return;
        (async ()=>{
            setAnimationData(await $86387a9978ffe5e0$var$getAnimationData(url));
        })();
    }, [
        url
    ]);
    return {
        animationData: animationData,
        subtitle: subtitle
    };
};

});


parcelRegister("jGN5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $e55804d825e1f516$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $ezc60 = parcelRequire("ezc60");
var $a6jOw = parcelRequire("a6jOw");

var $fb0st = parcelRequire("fb0st");
function $e55804d825e1f516$export$2e2bcd8739ae039({ keyProp: keyProp = '', title: title, subtitle: subtitle = '' }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ezc60.AnimatePresence), {
        mode: "wait",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("hgroup", {
            className: "trial__heading",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("h1", {
                    className: "h3",
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a6jOw.motion).p, {
                    className: "text-subline text-subline--sm",
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1,
                        transition: {
                            delay: 0.1875
                        }
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.5
                    },
                    children: subtitle
                }, keyProp)
            ]
        })
    });
}
$e55804d825e1f516$export$2e2bcd8739ae039.propTypes = {
    keyProp: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    subtitle: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};

});
parcelRegister("ezc60", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", () => $9b0ae67beb2269f5$export$3ae376d12526dd6f);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $6YAnm = parcelRequire("6YAnm");

var $3PZo3 = parcelRequire("3PZo3");

var $8bI58 = parcelRequire("8bI58");

var $4CM6h = parcelRequire("4CM6h");

var $ibOmE = parcelRequire("ibOmE");

var $cx3Dg = parcelRequire("cx3Dg");
"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $9b0ae67beb2269f5$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false, anchorX: anchorX = "left" })=>{
    const [isParentPresent, safeToRemove] = (0, $ibOmE.usePresence)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $8NFma.useMemo)(()=>(0, $cx3Dg.onlyElements)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $cx3Dg.getChildKey));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $8NFma.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $8NFma.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $3PZo3.useConstant)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $8NFma.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $8NFma.useState)(presentChildren);
    (0, $8bI58.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $cx3Dg.getChildKey)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $cx3Dg.getChildKey)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $cx3Dg.onlyElements)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $8NFma.useContext)((0, $6YAnm.LayoutGroupContext));
    return (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $cx3Dg.getChildKey)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender?.();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && safeToRemove?.();
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $1IdZj.jsx)((0, $4CM6h.PresenceChild), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                children: child
            }, key);
        })
    });
};

});
parcelRegister("6YAnm", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", () => $1af765e09ca06198$export$a3579ca508007a95);

var $8NFma = parcelRequire("8NFma");
"use client";
const $1af765e09ca06198$export$a3579ca508007a95 = (0, $8NFma.createContext)({});

});

parcelRegister("3PZo3", function(module, exports) {

$parcel$export(module.exports, "useConstant", () => $d40915b962da1eaf$export$fe4300aa8eebea86);

var $8NFma = parcelRequire("8NFma");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $d40915b962da1eaf$export$fe4300aa8eebea86(init) {
    const ref = (0, $8NFma.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("8bI58", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $ba41941b3a1a751e$export$700979bc83e7db82);

var $8NFma = parcelRequire("8NFma");

var $7w33i = parcelRequire("7w33i");
const $ba41941b3a1a751e$export$700979bc83e7db82 = (0, $7w33i.isBrowser) ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);

});
parcelRegister("7w33i", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $4e6fb092a41bfb82$export$4e09c449d6c407f7);
const $4e6fb092a41bfb82$export$4e09c449d6c407f7 = typeof window !== "undefined";

});


parcelRegister("4CM6h", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", () => $289f4baefd8e1643$export$979daf65881a382a);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $9aVsA = parcelRequire("9aVsA");

var $3PZo3 = parcelRequire("3PZo3");

var $bMtFH = parcelRequire("bMtFH");
"use client";
const $289f4baefd8e1643$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, anchorX: anchorX })=>{
    const presenceChildren = (0, $3PZo3.useConstant)($289f4baefd8e1643$var$newChildrenMap);
    const id = (0, $8NFma.useId)();
    let isReusedContext = true;
    let context = (0, $8NFma.useMemo)(()=>{
        isReusedContext = false;
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = {
        ...context
    };
    (0, $8NFma.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $8NFma.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $1IdZj.jsx)((0, $bMtFH.PopChild), {
        isPresent: isPresent,
        anchorX: anchorX,
        children: children
    });
    return (0, $1IdZj.jsx)((0, $9aVsA.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $289f4baefd8e1643$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("9aVsA", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", () => $7a24fabcbe07cfd9$export$f224e4635b6f8ce2);

var $8NFma = parcelRequire("8NFma");
"use client";
/**
 * @public
 */ const $7a24fabcbe07cfd9$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $8NFma.createContext)(null);

});

parcelRegister("bMtFH", function(module, exports) {

$parcel$export(module.exports, "PopChild", () => $eec08e6c3a0b9bac$export$1d6cdde0c6816c6d);

var $1IdZj = parcelRequire("1IdZj");

var $6tfTi = parcelRequire("6tfTi");

var $8NFma = parcelRequire("8NFma");

var $7FsYG = parcelRequire("7FsYG");
"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $eec08e6c3a0b9bac$var$PopChildMeasure extends $8NFma.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = (0, $6tfTi.isHTMLElement)(parent) ? parent.offsetWidth || 0 : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $eec08e6c3a0b9bac$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent, anchorX: anchorX }) {
    const id = (0, $8NFma.useId)();
    const ref = (0, $8NFma.useRef)(null);
    const size = (0, $8NFma.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0
    });
    const { nonce: nonce } = (0, $8NFma.useContext)((0, $7FsYG.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $8NFma.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left, right: right } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        return ()=>{
            if (document.head.contains(style)) document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $1IdZj.jsx)($eec08e6c3a0b9bac$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $8NFma.cloneElement(children, {
            ref: ref
        })
    });
}

});
parcelRegister("6tfTi", function(module, exports) {

$parcel$export(module.exports, "isHTMLElement", () => $3bab47fdff45bafc$export$1b3bfaa9684536aa);

var $kulCl = parcelRequire("kulCl");
/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $3bab47fdff45bafc$export$1b3bfaa9684536aa(element) {
    return (0, $kulCl.isObject)(element) && "offsetHeight" in element;
}

});
parcelRegister("kulCl", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $62554135731a499e$export$a6cdc56e425d0d0a);
function $62554135731a499e$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}

});


parcelRegister("7FsYG", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", () => $c6897e5fa3e365aa$export$22a697fb29aac98d);

var $8NFma = parcelRequire("8NFma");
"use client";
/**
 * @public
 */ const $c6897e5fa3e365aa$export$22a697fb29aac98d = (0, $8NFma.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});



parcelRegister("ibOmE", function(module, exports) {

$parcel$export(module.exports, "usePresence", () => $72a6fd105f9d64db$export$2a8c16d82a0a0e26);

var $8NFma = parcelRequire("8NFma");

var $9aVsA = parcelRequire("9aVsA");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $72a6fd105f9d64db$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $8NFma.useContext)((0, $9aVsA.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $8NFma.useId)();
    (0, $8NFma.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $8NFma.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $72a6fd105f9d64db$export$8249053f690ea39a() {
    return $72a6fd105f9d64db$export$ee27c052bca048fb((0, $8NFma.useContext)((0, $9aVsA.PresenceContext)));
}
function $72a6fd105f9d64db$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("cx3Dg", function(module, exports) {

$parcel$export(module.exports, "getChildKey", () => $6f58e141f0229916$export$10e61aed958678dd);
$parcel$export(module.exports, "onlyElements", () => $6f58e141f0229916$export$872a3a1281f4b357);

var $8NFma = parcelRequire("8NFma");
const $6f58e141f0229916$export$10e61aed958678dd = (child)=>child.key || "";
function $6f58e141f0229916$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $8NFma.Children).forEach(children, (child)=>{
        if ((0, $8NFma.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}

});


parcelRegister("a6jOw", function(module, exports) {

$parcel$export(module.exports, "motion", () => $bda99f47daf4c0f0$export$e25e478948902b8b);

var $jxVID = parcelRequire("jxVID");

var $5JDjE = parcelRequire("5JDjE");
const $bda99f47daf4c0f0$export$e25e478948902b8b = /*@__PURE__*/ (0, $jxVID.createDOMMotionComponentProxy)((0, $5JDjE.createMotionComponent));

});
parcelRegister("jxVID", function(module, exports) {

$parcel$export(module.exports, "createDOMMotionComponentProxy", () => $7cf3f1a00e033df6$export$3af29c0efb268f04);

function $7cf3f1a00e033df6$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("5JDjE", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", () => $e0437aef86f3ae69$export$46b7e4b9dc6110c3);

var $3oFqF = parcelRequire("3oFqF");

var $2om4u = parcelRequire("2om4u");

var $5tJOb = parcelRequire("5tJOb");

var $4IlWL = parcelRequire("4IlWL");

var $awPQy = parcelRequire("awPQy");

var $51CsC = parcelRequire("51CsC");
const $e0437aef86f3ae69$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $awPQy.createMotionComponentFactory)({
    ...(0, $3oFqF.animations),
    ...(0, $5tJOb.gestureAnimations),
    ...(0, $2om4u.drag),
    ...(0, $4IlWL.layout)
}, (0, $51CsC.createDomVisualElement));

});
parcelRegister("3oFqF", function(module, exports) {

$parcel$export(module.exports, "animations", () => $e2d1ec617b1ce2aa$export$7f9953c70dacfd7f);

var $bwwmd = parcelRequire("bwwmd");

var $jKpin = parcelRequire("jKpin");
const $e2d1ec617b1ce2aa$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bwwmd.AnimationFeature)
    },
    exit: {
        Feature: (0, $jKpin.ExitAnimationFeature)
    }
};

});
parcelRegister("bwwmd", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", () => $bdfce0176f2f6e54$export$b45b3fe5caabdca);

var $2SKYt = parcelRequire("2SKYt");

var $4BoX8 = parcelRequire("4BoX8");

var $gxL8Z = parcelRequire("gxL8Z");
class $bdfce0176f2f6e54$export$b45b3fe5caabdca extends (0, $gxL8Z.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $4BoX8.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $2SKYt.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}

});
parcelRegister("2SKYt", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", () => $8941743539d0f878$export$aa71198ceeaf53ce);
function $8941743539d0f878$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("4BoX8", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", () => $b079947979d34971$export$bb53502b7a672aa8);

var $5gie9 = parcelRequire("5gie9");

var $2SKYt = parcelRequire("2SKYt");

var $8lOP3 = parcelRequire("8lOP3");

var $2cIOK = parcelRequire("2cIOK");

var $fFBPw = parcelRequire("fFBPw");

var $cMzxg = parcelRequire("cMzxg");

var $cJR9n = parcelRequire("cJR9n");

var $jtjtW = parcelRequire("jtjtW");
const $b079947979d34971$var$reversePriorityOrder = [
    ...(0, $jtjtW.variantPriorityOrder)
].reverse();
const $b079947979d34971$var$numAnimationTypes = (0, $jtjtW.variantPriorityOrder).length;
function $b079947979d34971$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $5gie9.animateVisualElement)(visualElement, animation, options)));
}
function $b079947979d34971$export$bb53502b7a672aa8(visualElement) {
    let animate = $b079947979d34971$var$animateList(visualElement);
    let state = $b079947979d34971$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $cJR9n.resolveVariant)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $fFBPw.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $b079947979d34971$var$numAnimationTypes; i++){
            const type = $b079947979d34971$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $cMzxg.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $2SKYt.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $b079947979d34971$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $8lOP3.isKeyframesTarget)(next) && (0, $8lOP3.isKeyframesTarget)(prev)) valueHasChanged = !(0, $2cIOK.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $cJR9n.resolveVariant)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $b079947979d34971$var$createState();
            isInitialRender = true;
        }
    };
}
function $b079947979d34971$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $2cIOK.shallowCompare)(next, prev);
    return false;
}
function $b079947979d34971$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $b079947979d34971$var$createState() {
    return {
        animate: $b079947979d34971$var$createTypeState(true),
        whileInView: $b079947979d34971$var$createTypeState(),
        whileHover: $b079947979d34971$var$createTypeState(),
        whileTap: $b079947979d34971$var$createTypeState(),
        whileDrag: $b079947979d34971$var$createTypeState(),
        whileFocus: $b079947979d34971$var$createTypeState(),
        exit: $b079947979d34971$var$createTypeState()
    };
}

});
parcelRegister("5gie9", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", () => $044d89b145201204$export$ff62cf473653f109);

var $cJR9n = parcelRequire("cJR9n");

var $cKuWX = parcelRequire("cKuWX");

var $1KEO5 = parcelRequire("1KEO5");
function $044d89b145201204$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $1KEO5.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $1KEO5.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $cJR9n.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $cKuWX.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}

});
parcelRegister("cJR9n", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", () => $7efa14736b19fa31$export$7b1b1c981f4f0558);

var $6ZXou = parcelRequire("6ZXou");
function $7efa14736b19fa31$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $6ZXou.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});
parcelRegister("6ZXou", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", () => $318b02a1e1f48ccb$export$d68f140c4d9b48bc);
function $318b02a1e1f48ccb$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $318b02a1e1f48ccb$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $318b02a1e1f48ccb$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $318b02a1e1f48ccb$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});


parcelRegister("cKuWX", function(module, exports) {

$parcel$export(module.exports, "animateTarget", () => $cf1b1579b00c1362$export$68cacfeee78d98d2);

var $bzAli = parcelRequire("bzAli");
var $1TVwi = parcelRequire("1TVwi");
var $dkBwo = parcelRequire("dkBwo");

var $8i3Xq = parcelRequire("8i3Xq");

var $6bVZB = parcelRequire("6bVZB");

var $iJ9xe = parcelRequire("iJ9xe");

var $iuk8z = parcelRequire("iuk8z");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cf1b1579b00c1362$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cf1b1579b00c1362$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $cf1b1579b00c1362$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $1TVwi.getValueTransition)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) continue;
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $iJ9xe.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $bzAli.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $6bVZB.addValueToWillChange)(visualElement, key);
        value.start((0, $iuk8z.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $dkBwo.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $bzAli.frame).update(()=>{
            transitionEnd && (0, $8i3Xq.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("bzAli", function(module, exports) {

$parcel$export(module.exports, "frame", () => $452a27f205731b9b$export$2cef06c20297c17d);
$parcel$export(module.exports, "cancelFrame", () => $452a27f205731b9b$export$ec99c0ef4978dccb);
$parcel$export(module.exports, "frameData", () => $452a27f205731b9b$export$fff89137e9e818ce);
$parcel$export(module.exports, "frameSteps", () => $452a27f205731b9b$export$1811c3a7e3af92f0);

var $gfeF6 = parcelRequire("gfeF6");

var $hFBk0 = parcelRequire("hFBk0");
const { schedule: $452a27f205731b9b$export$2cef06c20297c17d, cancel: $452a27f205731b9b$export$ec99c0ef4978dccb, state: $452a27f205731b9b$export$fff89137e9e818ce, steps: $452a27f205731b9b$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $hFBk0.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $gfeF6.noop), true);

});
parcelRegister("gfeF6", function(module, exports) {

$parcel$export(module.exports, "noop", () => $af50e3abd548b900$export$8793edee2d425525);
/*#__NO_SIDE_EFFECTS__*/ const $af50e3abd548b900$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("hFBk0", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", () => $7fc8676e57f42e4d$export$510b0596a933801a);

var $5gGDR = parcelRequire("5gGDR");

var $iUT3u = parcelRequire("iUT3u");

var $3f2uH = parcelRequire("3f2uH");
const $7fc8676e57f42e4d$var$maxElapsed = 40;
function $7fc8676e57f42e4d$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $iUT3u.stepsOrder).reduce((acc, key)=>{
        acc[key] = (0, $3f2uH.createRenderStep)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $5gGDR.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $5gGDR.MotionGlobalConfig).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $7fc8676e57f42e4d$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $iUT3u.stepsOrder).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $iUT3u.stepsOrder).length; i++)steps[(0, $iUT3u.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("5gGDR", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", () => $04848fffbb1f601a$export$dd826089e3c5e502);
const $04848fffbb1f601a$export$dd826089e3c5e502 = {};

});

parcelRegister("iUT3u", function(module, exports) {

$parcel$export(module.exports, "stepsOrder", () => $9d08dd1d10a90d5f$export$71ecace0a033b35a);
const $9d08dd1d10a90d5f$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];

});

parcelRegister("3f2uH", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", () => $174cca3cc806b313$export$b995e5e85f5c8289);

var $8D0Pz = parcelRequire("8D0Pz");
function $174cca3cc806b313$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $8D0Pz.statsBuffer).value) (0, $8D0Pz.statsBuffer).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});
parcelRegister("8D0Pz", function(module, exports) {

$parcel$export(module.exports, "statsBuffer", () => $b02a950bd34c9914$export$84ce9a476f53d110);
const $b02a950bd34c9914$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};

});




parcelRegister("1TVwi", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", () => $65521d3e26bfdec3$export$7c1391340308742e);
function $65521d3e26bfdec3$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}

});

parcelRegister("dkBwo", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", () => $dff719dbf9fb0a0c$export$c66c0d5db2a205d);

var $eMYQu = parcelRequire("eMYQu");
const $dff719dbf9fb0a0c$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $eMYQu.transformPropOrder)
]);

});
parcelRegister("eMYQu", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", () => $dc4de32bedbac8b4$export$280dc01950909d86);
$parcel$export(module.exports, "transformProps", () => $dc4de32bedbac8b4$export$7b42a0094fb00b6e);
/**
 * Generate a list of every possible transform key.
 */ const $dc4de32bedbac8b4$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $dc4de32bedbac8b4$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($dc4de32bedbac8b4$export$280dc01950909d86))();

});


parcelRegister("8i3Xq", function(module, exports) {

$parcel$export(module.exports, "setTarget", () => $ce7c85a117778f2d$export$1f61c53461aff4a5);

var $9YfCx = parcelRequire("9YfCx");

var $8lOP3 = parcelRequire("8lOP3");

var $cJR9n = parcelRequire("cJR9n");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ce7c85a117778f2d$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $9YfCx.motionValue)(value));
}
function $ce7c85a117778f2d$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $8lOP3.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
}
function $ce7c85a117778f2d$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $cJR9n.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $ce7c85a117778f2d$var$resolveFinalValueInKeyframes(target[key]);
        $ce7c85a117778f2d$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("9YfCx", function(module, exports) {

$parcel$export(module.exports, "motionValue", () => $a09e78eb59465735$export$ce8bdc721e76545f);

var $7RKvH = parcelRequire("7RKvH");
var $iIllo = parcelRequire("iIllo");

var $aNJ8y = parcelRequire("aNJ8y");

var $bzAli = parcelRequire("bzAli");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $a09e78eb59465735$var$MAX_VELOCITY_DELTA = 30;
const $a09e78eb59465735$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $a09e78eb59465735$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $a09e78eb59465735$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $aNJ8y.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
            // Update render subscribers
            if (render) this.events.renderRequest?.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $aNJ8y.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $a09e78eb59465735$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $7RKvH.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $bzAli.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($a09e78eb59465735$export$67fcd818a264039d.current) $a09e78eb59465735$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $aNJ8y.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $a09e78eb59465735$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $a09e78eb59465735$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $iIllo.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $a09e78eb59465735$export$ce8bdc721e76545f(init, options) {
    return new $a09e78eb59465735$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("7RKvH", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", () => $d7f971110140ed72$export$e7dff9482a5fd23c);

var $iGMOO = parcelRequire("iGMOO");
class $d7f971110140ed72$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $iGMOO.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $iGMOO.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});
parcelRegister("iGMOO", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", () => $717cc7fd941f7985$export$20e507e47fae79fd);
$parcel$export(module.exports, "removeItem", () => $717cc7fd941f7985$export$fe2d9b4e03920b4c);
function $717cc7fd941f7985$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $717cc7fd941f7985$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $717cc7fd941f7985$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});


parcelRegister("iIllo", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", () => $daa69d1c09c7a4f6$export$eab0632f7ad4f9d7);
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $daa69d1c09c7a4f6$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});

parcelRegister("aNJ8y", function(module, exports) {

$parcel$export(module.exports, "time", () => $843474e841ef95ab$export$2da9be4cfdb689b1);

var $5gGDR = parcelRequire("5gGDR");

var $bzAli = parcelRequire("bzAli");
let $843474e841ef95ab$var$now;
function $843474e841ef95ab$var$clearTime() {
    $843474e841ef95ab$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $843474e841ef95ab$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($843474e841ef95ab$var$now === undefined) $843474e841ef95ab$export$2da9be4cfdb689b1.set((0, $bzAli.frameData).isProcessing || (0, $5gGDR.MotionGlobalConfig).useManualTiming ? (0, $bzAli.frameData).timestamp : performance.now());
        return $843474e841ef95ab$var$now;
    },
    set: (newTime)=>{
        $843474e841ef95ab$var$now = newTime;
        queueMicrotask($843474e841ef95ab$var$clearTime);
    }
};

});


parcelRegister("8lOP3", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", () => $0d0309bb748c55b8$export$9153ad4c4999f4a0);
const $0d0309bb748c55b8$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});


parcelRegister("6bVZB", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", () => $7351d114afad4060$export$3ac5aed310be0bee);

var $5gGDR = parcelRequire("5gGDR");

var $fD5Ne = parcelRequire("fD5Ne");
function $7351d114afad4060$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $fD5Ne.isWillChangeMotionValue)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $5gGDR.MotionGlobalConfig).WillChange) {
        const newWillChange = new (0, $5gGDR.MotionGlobalConfig).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

});
parcelRegister("fD5Ne", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", () => $2d5ab3a3cea3faff$export$98397f3adbf6259f);

var $6CK3q = parcelRequire("6CK3q");
function $2d5ab3a3cea3faff$export$98397f3adbf6259f(value) {
    return Boolean((0, $6CK3q.isMotionValue)(value) && value.add);
}

});
parcelRegister("6CK3q", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", () => $15caef55d4a68446$export$605d60a2578142d3);
const $15caef55d4a68446$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});



parcelRegister("iJ9xe", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", () => $8d9fbf198c83f4e5$export$5f8d21e84d1d84fc);

var $8BQBc = parcelRequire("8BQBc");
function $8d9fbf198c83f4e5$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $8BQBc.optimizedAppearDataAttribute];
}

});
parcelRegister("8BQBc", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", () => $56d7ce45107a9e18$export$8592e1c077c890a6);

var $cifjo = parcelRequire("cifjo");
const $56d7ce45107a9e18$export$ed7b8fa9dbf0105d = "framerAppearId";
const $56d7ce45107a9e18$export$8592e1c077c890a6 = "data-" + (0, $cifjo.camelToDash)($56d7ce45107a9e18$export$ed7b8fa9dbf0105d);

});
parcelRegister("cifjo", function(module, exports) {

$parcel$export(module.exports, "camelToDash", () => $64d13cd8bd24d1b3$export$9fd24a634729c672);
/**
 * Convert camelCase to dash-case properties.
 */ const $64d13cd8bd24d1b3$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});



parcelRegister("iuk8z", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", () => $567a733505d98c06$export$90b3dfc33ff3548);

var $dk8Cr = parcelRequire("dk8Cr");
var $bzAli = parcelRequire("bzAli");
var $1TVwi = parcelRequire("1TVwi");
var $4UTnX = parcelRequire("4UTnX");

var $5gGDR = parcelRequire("5gGDR");
var $9rDgO = parcelRequire("9rDgO");

var $eh651 = parcelRequire("eh651");

var $akeMP = parcelRequire("akeMP");

var $1E2Ro = parcelRequire("1E2Ro");
const $567a733505d98c06$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $1TVwi.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $9rDgO.secondsToMilliseconds)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $1E2Ro.isTransitionDefined)(valueTransition)) Object.assign(options, (0, $akeMP.getDefaultTransition)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $9rDgO.secondsToMilliseconds)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $9rDgO.secondsToMilliseconds)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $5gGDR.MotionGlobalConfig).instantAnimations || (0, $5gGDR.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $eh651.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $bzAli.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $4UTnX.JSAnimation)(options) : new (0, $dk8Cr.AsyncMotionValueAnimation)(options);
    };

});
parcelRegister("dk8Cr", function(module, exports) {

$parcel$export(module.exports, "AsyncMotionValueAnimation", () => $cc0e2a7e01cca586$export$b9855e2a7dee3dd2);

var $5gGDR = parcelRequire("5gGDR");
var $gfeF6 = parcelRequire("gfeF6");

var $aNJ8y = parcelRequire("aNJ8y");

var $4UTnX = parcelRequire("4UTnX");

var $9IDQl = parcelRequire("9IDQl");

var $2Skvh = parcelRequire("2Skvh");

var $8J1fo = parcelRequire("8J1fo");

var $asTno = parcelRequire("asTno");

var $lfBGq = parcelRequire("lfBGq");

var $4Bgq4 = parcelRequire("4Bgq4");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $cc0e2a7e01cca586$var$MAX_RESOLVE_DELAY = 40;
class $cc0e2a7e01cca586$export$b9855e2a7dee3dd2 extends (0, $lfBGq.WithPromise) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $aNJ8y.time).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $2Skvh.KeyframeResolver);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $aNJ8y.time).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $asTno.canAnimate)(keyframes, name, type, velocity)) {
            if ((0, $5gGDR.MotionGlobalConfig).instantAnimations || !delay) onUpdate?.((0, $9IDQl.getFinalKeyframe)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            options.duration = 0;
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $cc0e2a7e01cca586$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $4Bgq4.supportsBrowserAnimation)(resolvedOptions) ? new (0, $8J1fo.NativeAnimationExtended)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $4UTnX.JSAnimation)(resolvedOptions);
        animation.finished.then(()=>this.notifyFinished()).catch((0, $gfeF6.noop));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $2Skvh.flushKeyframeResolvers)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}

});
parcelRegister("4UTnX", function(module, exports) {

$parcel$export(module.exports, "JSAnimation", () => $7708d5af414361f8$export$3394f837405475c7);

var $YLpUN = parcelRequire("YLpUN");
var $9rDgO = parcelRequire("9rDgO");
var $2JuHM = parcelRequire("2JuHM");

var $aNJ8y = parcelRequire("aNJ8y");

var $3miKP = parcelRequire("3miKP");

var $bsFKm = parcelRequire("bsFKm");

var $iOq9s = parcelRequire("iOq9s");

var $g6r1B = parcelRequire("g6r1B");

var $brsyv = parcelRequire("brsyv");

var $2r6tM = parcelRequire("2r6tM");

var $9IDQl = parcelRequire("9IDQl");

var $fFrB8 = parcelRequire("fFrB8");

var $lfBGq = parcelRequire("lfBGq");
const $7708d5af414361f8$var$percentToProgress = (percent)=>percent / 100;
class $7708d5af414361f8$export$3394f837405475c7 extends (0, $lfBGq.WithPromise) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $aNJ8y.time).now()) this.tick((0, $aNJ8y.time).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $3miKP.activeAnimations).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $fFrB8.replaceTransitionType)(options);
        const { type: type = (0, $brsyv.keyframes), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $brsyv.keyframes);
        if (generatorFactory !== (0, $brsyv.keyframes) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $2JuHM.pipe)($7708d5af414361f8$var$percentToProgress, (0, $bsFKm.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $2r6tM.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $YLpUN.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $g6r1B.inertia)) state.value = (0, $9IDQl.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $9rDgO.millisecondsToSeconds)(this.calculatedDuration);
    }
    get time() {
        return (0, $9rDgO.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $9rDgO.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        this.driver?.start(false);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $aNJ8y.time).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $9rDgO.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $iOq9s.frameloopDriver), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $aNJ8y.time).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $3miKP.activeAnimations).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $7708d5af414361f8$export$ee9b76de7353d815(options) {
    return new $7708d5af414361f8$export$3394f837405475c7(options);
}

});
parcelRegister("YLpUN", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $61f63dda88612c61$export$7d15b64cf5a3a4c4);
const $61f63dda88612c61$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});

parcelRegister("9rDgO", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", () => $a0dc888a7dbb4058$export$fc3e7e8557f8c8c7);
$parcel$export(module.exports, "millisecondsToSeconds", () => $a0dc888a7dbb4058$export$f64c3bfbc58eec0f);
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $a0dc888a7dbb4058$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $a0dc888a7dbb4058$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("2JuHM", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $d059c71f4da64117$export$a4627e546088548d);
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $d059c71f4da64117$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $d059c71f4da64117$export$a4627e546088548d = (...transformers)=>transformers.reduce($d059c71f4da64117$var$combineFunctions);

});

parcelRegister("3miKP", function(module, exports) {

$parcel$export(module.exports, "activeAnimations", () => $c5519128b165702a$export$d921fb2475e2900c);
const $c5519128b165702a$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};

});

parcelRegister("bsFKm", function(module, exports) {

$parcel$export(module.exports, "mix", () => $49d1a04146e01a29$export$2c9e8a9632a706b2);

var $cZegH = parcelRequire("cZegH");

var $1rqJ7 = parcelRequire("1rqJ7");
function $49d1a04146e01a29$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $1rqJ7.mixNumber)(from, to, p);
    const mixer = (0, $cZegH.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("cZegH", function(module, exports) {

$parcel$export(module.exports, "getMixer", () => $17920d606a322aa8$export$36ec24672cd098e0);

var $2JuHM = parcelRequire("2JuHM");
var $4S7XB = parcelRequire("4S7XB");

var $kNVWS = parcelRequire("kNVWS");

var $37kkY = parcelRequire("37kkY");

var $1bx7b = parcelRequire("1bx7b");

var $kf13X = parcelRequire("kf13X");

var $5Pc3H = parcelRequire("5Pc3H");

var $1rqJ7 = parcelRequire("1rqJ7");

var $2sUOi = parcelRequire("2sUOi");
function $17920d606a322aa8$var$mixNumber(a, b) {
    return (p)=>(0, $1rqJ7.mixNumber)(a, b, p);
}
function $17920d606a322aa8$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $17920d606a322aa8$var$mixNumber;
    else if (typeof a === "string") return (0, $kNVWS.isCSSVariableToken)(a) ? (0, $5Pc3H.mixImmediate) : (0, $37kkY.color).test(a) ? (0, $kf13X.mixColor) : $17920d606a322aa8$export$65516310a87d8205;
    else if (Array.isArray(a)) return $17920d606a322aa8$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $37kkY.color).test(a) ? (0, $kf13X.mixColor) : $17920d606a322aa8$export$ebc23b6840c51ba1;
    return 0, $5Pc3H.mixImmediate;
}
function $17920d606a322aa8$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$17920d606a322aa8$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $17920d606a322aa8$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $17920d606a322aa8$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $17920d606a322aa8$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $17920d606a322aa8$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $1bx7b.complex).createTransformer(target);
    const originStats = (0, $1bx7b.analyseComplexValue)(origin);
    const targetStats = (0, $1bx7b.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $2sUOi.invisibleValues).has(origin) && !targetStats.values.length || (0, $2sUOi.invisibleValues).has(target) && !originStats.values.length) return (0, $2sUOi.mixVisibility)(origin, target);
        return (0, $2JuHM.pipe)($17920d606a322aa8$export$3bbefa2f402845c4($17920d606a322aa8$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $4S7XB.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $5Pc3H.mixImmediate)(origin, target);
    }
};

});
parcelRegister("4S7XB", function(module, exports) {

$parcel$export(module.exports, "warning", () => $cdc1f658f0acf916$export$491112666e282270);
$parcel$export(module.exports, "invariant", () => $cdc1f658f0acf916$export$f5708dca728d7177);
let $cdc1f658f0acf916$export$491112666e282270 = ()=>{};
let $cdc1f658f0acf916$export$f5708dca728d7177 = ()=>{};
var $cdc1f658f0acf916$var$check, $cdc1f658f0acf916$var$message, $cdc1f658f0acf916$var$check1, $cdc1f658f0acf916$var$message1;

});

parcelRegister("kNVWS", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", () => $872b72cab7986bdf$export$9de1236619d9e756);
$parcel$export(module.exports, "isCSSVariableToken", () => $872b72cab7986bdf$export$31f9caa2600b5723);
const $872b72cab7986bdf$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $872b72cab7986bdf$export$9de1236619d9e756 = /*@__PURE__*/ $872b72cab7986bdf$var$checkStringStartsWith("--");
const $872b72cab7986bdf$var$startsAsVariableToken = /*@__PURE__*/ $872b72cab7986bdf$var$checkStringStartsWith("var(--");
const $872b72cab7986bdf$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $872b72cab7986bdf$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $872b72cab7986bdf$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $872b72cab7986bdf$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});

parcelRegister("37kkY", function(module, exports) {

$parcel$export(module.exports, "color", () => $a8d614433a8e7726$export$35e9368ef982300f);

var $9jkgf = parcelRequire("9jkgf");

var $6X7lF = parcelRequire("6X7lF");

var $f0hmT = parcelRequire("f0hmT");
const $a8d614433a8e7726$export$35e9368ef982300f = {
    test: (v)=>(0, $f0hmT.rgba).test(v) || (0, $9jkgf.hex).test(v) || (0, $6X7lF.hsla).test(v),
    parse: (v)=>{
        if ((0, $f0hmT.rgba).test(v)) return (0, $f0hmT.rgba).parse(v);
        else if ((0, $6X7lF.hsla).test(v)) return (0, $6X7lF.hsla).parse(v);
        else return (0, $9jkgf.hex).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $f0hmT.rgba).transform(v) : (0, $6X7lF.hsla).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $a8d614433a8e7726$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $a8d614433a8e7726$export$35e9368ef982300f.transform(parsed);
    }
};

});
parcelRegister("9jkgf", function(module, exports) {

$parcel$export(module.exports, "hex", () => $36ec303f1a9ebbb4$export$834dfc94dde4b3d8);

var $f0hmT = parcelRequire("f0hmT");

var $hHkVK = parcelRequire("hHkVK");
function $36ec303f1a9ebbb4$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $36ec303f1a9ebbb4$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $hHkVK.isColorString)("#"),
    parse: $36ec303f1a9ebbb4$var$parseHex,
    transform: (0, $f0hmT.rgba).transform
};

});
parcelRegister("f0hmT", function(module, exports) {

$parcel$export(module.exports, "rgba", () => $d105fd699fe20454$export$4e46ac54fc82cf3b);

var $YLpUN = parcelRequire("YLpUN");

var $6WRjq = parcelRequire("6WRjq");

var $2mwFe = parcelRequire("2mwFe");

var $hHkVK = parcelRequire("hHkVK");
const $d105fd699fe20454$var$clampRgbUnit = (v)=>(0, $YLpUN.clamp)(0, 255, v);
const $d105fd699fe20454$export$7a99c86b5b1f4c9e = {
    ...(0, $6WRjq.number),
    transform: (v)=>Math.round($d105fd699fe20454$var$clampRgbUnit(v))
};
const $d105fd699fe20454$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $hHkVK.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $hHkVK.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $d105fd699fe20454$export$7a99c86b5b1f4c9e.transform(red) + ", " + $d105fd699fe20454$export$7a99c86b5b1f4c9e.transform(green) + ", " + $d105fd699fe20454$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $2mwFe.sanitize)((0, $6WRjq.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("6WRjq", function(module, exports) {

$parcel$export(module.exports, "number", () => $a434c0e607e43464$export$98e628dec113755e);
$parcel$export(module.exports, "alpha", () => $a434c0e607e43464$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "scale", () => $a434c0e607e43464$export$dcdf75081b88279d);

var $YLpUN = parcelRequire("YLpUN");
const $a434c0e607e43464$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $a434c0e607e43464$export$58f0f39f63f3cf42 = {
    ...$a434c0e607e43464$export$98e628dec113755e,
    transform: (v)=>(0, $YLpUN.clamp)(0, 1, v)
};
const $a434c0e607e43464$export$dcdf75081b88279d = {
    ...$a434c0e607e43464$export$98e628dec113755e,
    default: 1
};

});

parcelRegister("2mwFe", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $f3b72b825a6afa3c$export$83d2e9e3e4ee39ed);
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $f3b72b825a6afa3c$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;

});

parcelRegister("hHkVK", function(module, exports) {

$parcel$export(module.exports, "isColorString", () => $83eb4eea650515b6$export$2c8400d58aca05e);
$parcel$export(module.exports, "splitColor", () => $83eb4eea650515b6$export$73d6f35be992df24);

var $68wnR = parcelRequire("68wnR");

var $kovZB = parcelRequire("kovZB");

var $ilhSM = parcelRequire("ilhSM");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $83eb4eea650515b6$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $ilhSM.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $kovZB.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $83eb4eea650515b6$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $68wnR.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});
parcelRegister("68wnR", function(module, exports) {

$parcel$export(module.exports, "floatRegex", () => $095ef987df389da3$export$2444ca58c08448e4);
const $095ef987df389da3$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

});

parcelRegister("kovZB", function(module, exports) {

$parcel$export(module.exports, "isNullish", () => $b26b46d2393d32e6$export$b931b78cbb3caf86);
function $b26b46d2393d32e6$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("ilhSM", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", () => $b73be91f7c7a8d12$export$ed808ff6ecd39e8d);
const $b73be91f7c7a8d12$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

});




parcelRegister("6X7lF", function(module, exports) {

$parcel$export(module.exports, "hsla", () => $7995d3abbcf06786$export$810b04175080204c);

var $6WRjq = parcelRequire("6WRjq");

var $aNIli = parcelRequire("aNIli");

var $2mwFe = parcelRequire("2mwFe");

var $hHkVK = parcelRequire("hHkVK");
const $7995d3abbcf06786$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $hHkVK.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $hHkVK.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $aNIli.percent).transform((0, $2mwFe.sanitize)(saturation)) + ", " + (0, $aNIli.percent).transform((0, $2mwFe.sanitize)(lightness)) + ", " + (0, $2mwFe.sanitize)((0, $6WRjq.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("aNIli", function(module, exports) {

$parcel$export(module.exports, "degrees", () => $522173a25354325c$export$41fc368e1a942b97);
$parcel$export(module.exports, "percent", () => $522173a25354325c$export$626336c2cd4b14de);
$parcel$export(module.exports, "px", () => $522173a25354325c$export$91c0eda1d06bf008);
$parcel$export(module.exports, "vh", () => $522173a25354325c$export$f91e8c45a95a32f2);
$parcel$export(module.exports, "vw", () => $522173a25354325c$export$aed3d7b7d206c196);
$parcel$export(module.exports, "progressPercentage", () => $522173a25354325c$export$44e2e1705876d7ed);
/*#__NO_SIDE_EFFECTS__*/ const $522173a25354325c$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $522173a25354325c$export$41fc368e1a942b97 = /*@__PURE__*/ $522173a25354325c$var$createUnitType("deg");
const $522173a25354325c$export$626336c2cd4b14de = /*@__PURE__*/ $522173a25354325c$var$createUnitType("%");
const $522173a25354325c$export$91c0eda1d06bf008 = /*@__PURE__*/ $522173a25354325c$var$createUnitType("px");
const $522173a25354325c$export$f91e8c45a95a32f2 = /*@__PURE__*/ $522173a25354325c$var$createUnitType("vh");
const $522173a25354325c$export$aed3d7b7d206c196 = /*@__PURE__*/ $522173a25354325c$var$createUnitType("vw");
const $522173a25354325c$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$522173a25354325c$export$626336c2cd4b14de,
        parse: (v)=>$522173a25354325c$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$522173a25354325c$export$626336c2cd4b14de.transform(v * 100)
    }))();

});



parcelRegister("1bx7b", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", () => $fa7b812846502b40$export$b61fc7c44bf646d5);
$parcel$export(module.exports, "complex", () => $fa7b812846502b40$export$83a0e34f1302825b);

var $37kkY = parcelRequire("37kkY");

var $ipgUr = parcelRequire("ipgUr");

var $68wnR = parcelRequire("68wnR");

var $2mwFe = parcelRequire("2mwFe");
function $fa7b812846502b40$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $68wnR.floatRegex))?.length || 0) + (v.match((0, $ipgUr.colorRegex))?.length || 0) > 0;
}
const $fa7b812846502b40$var$NUMBER_TOKEN = "number";
const $fa7b812846502b40$var$COLOR_TOKEN = "color";
const $fa7b812846502b40$var$VAR_TOKEN = "var";
const $fa7b812846502b40$var$VAR_FUNCTION_TOKEN = "var(";
const $fa7b812846502b40$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $fa7b812846502b40$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $fa7b812846502b40$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($fa7b812846502b40$var$complexRegex, (parsedValue)=>{
        if ((0, $37kkY.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($fa7b812846502b40$var$COLOR_TOKEN);
            values.push((0, $37kkY.color).parse(parsedValue));
        } else if (parsedValue.startsWith($fa7b812846502b40$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($fa7b812846502b40$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($fa7b812846502b40$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $fa7b812846502b40$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($fa7b812846502b40$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $fa7b812846502b40$var$parseComplexValue(v) {
    return $fa7b812846502b40$export$b61fc7c44bf646d5(v).values;
}
function $fa7b812846502b40$var$createTransformer(source) {
    const { split: split, types: types } = $fa7b812846502b40$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $fa7b812846502b40$var$NUMBER_TOKEN) output += (0, $2mwFe.sanitize)(v[i]);
                else if (type === $fa7b812846502b40$var$COLOR_TOKEN) output += (0, $37kkY.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $fa7b812846502b40$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $37kkY.color).test(v) ? (0, $37kkY.color).getAnimatableNone(v) : v;
function $fa7b812846502b40$var$getAnimatableNone(v) {
    const parsed = $fa7b812846502b40$var$parseComplexValue(v);
    const transformer = $fa7b812846502b40$var$createTransformer(v);
    return transformer(parsed.map($fa7b812846502b40$var$convertNumbersToZero));
}
const $fa7b812846502b40$export$83a0e34f1302825b = {
    test: $fa7b812846502b40$var$test,
    parse: $fa7b812846502b40$var$parseComplexValue,
    createTransformer: $fa7b812846502b40$var$createTransformer,
    getAnimatableNone: $fa7b812846502b40$var$getAnimatableNone
};

});
parcelRegister("ipgUr", function(module, exports) {

$parcel$export(module.exports, "colorRegex", () => $65def32e69fb12d9$export$740b69c5fad25dba);
const $65def32e69fb12d9$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

});


parcelRegister("kf13X", function(module, exports) {

$parcel$export(module.exports, "mixColor", () => $c471e0ad6336ec9a$export$51e568cf5c039bac);

var $4S7XB = parcelRequire("4S7XB");

var $9jkgf = parcelRequire("9jkgf");

var $6X7lF = parcelRequire("6X7lF");

var $3cmGv = parcelRequire("3cmGv");

var $f0hmT = parcelRequire("f0hmT");

var $5Pc3H = parcelRequire("5Pc3H");

var $1rqJ7 = parcelRequire("1rqJ7");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $c471e0ad6336ec9a$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $c471e0ad6336ec9a$var$colorTypes = [
    (0, $9jkgf.hex),
    (0, $f0hmT.rgba),
    (0, $6X7lF.hsla)
];
const $c471e0ad6336ec9a$var$getColorType = (v)=>$c471e0ad6336ec9a$var$colorTypes.find((type)=>type.test(v));
function $c471e0ad6336ec9a$var$asRGBA(color) {
    const type = $c471e0ad6336ec9a$var$getColorType(color);
    (0, $4S7XB.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $6X7lF.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $3cmGv.hslaToRgba)(model);
    return model;
}
const $c471e0ad6336ec9a$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $c471e0ad6336ec9a$var$asRGBA(from);
    const toRGBA = $c471e0ad6336ec9a$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $5Pc3H.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $c471e0ad6336ec9a$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $c471e0ad6336ec9a$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $c471e0ad6336ec9a$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $1rqJ7.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $f0hmT.rgba).transform(blended);
    };
};

});
parcelRegister("3cmGv", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", () => $3863e1899f2dde49$export$6ae64dbcd6bfc33e);
// Adapted from https://gist.github.com/mjackson/5311256
function $3863e1899f2dde49$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $3863e1899f2dde49$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $3863e1899f2dde49$var$hueToRgb(p, q, hue + 1 / 3);
        green = $3863e1899f2dde49$var$hueToRgb(p, q, hue);
        blue = $3863e1899f2dde49$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("5Pc3H", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", () => $f2ac6e5d31d2872f$export$a6f92d4bae65c0f1);
function $f2ac6e5d31d2872f$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});

parcelRegister("1rqJ7", function(module, exports) {

$parcel$export(module.exports, "mixNumber", () => $6462f138eb96cbaa$export$3bb0b4ff1037b8dd);
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $6462f138eb96cbaa$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});


parcelRegister("2sUOi", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", () => $eee19ee195cfca39$export$e5a55ae567dd4ac7);
$parcel$export(module.exports, "mixVisibility", () => $eee19ee195cfca39$export$fed62ccc3fb1a568);
const $eee19ee195cfca39$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $eee19ee195cfca39$export$fed62ccc3fb1a568(origin, target) {
    if ($eee19ee195cfca39$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});



parcelRegister("iOq9s", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", () => $5d27d410161b8786$export$c1033964b5ad7fef);

var $aNJ8y = parcelRequire("aNJ8y");

var $bzAli = parcelRequire("bzAli");
const $5d27d410161b8786$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $bzAli.frame).update(passTimestamp, keepAlive),
        stop: ()=>(0, $bzAli.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $bzAli.frameData).isProcessing ? (0, $bzAli.frameData).timestamp : (0, $aNJ8y.time).now()
    };
};

});

parcelRegister("g6r1B", function(module, exports) {

$parcel$export(module.exports, "inertia", () => $0e81f0f60a6a0c99$export$ee3ff3a17106998);

var $i6FLG = parcelRequire("i6FLG");

var $6mQpX = parcelRequire("6mQpX");
function $0e81f0f60a6a0c99$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $i6FLG.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $6mQpX.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});
parcelRegister("i6FLG", function(module, exports) {

$parcel$export(module.exports, "spring", () => $75e19e3ddb5650af$export$b36281d89752ae66);

var $YLpUN = parcelRequire("YLpUN");
var $9rDgO = parcelRequire("9rDgO");

var $7yarN = parcelRequire("7yarN");

var $2r6tM = parcelRequire("2r6tM");

var $68dqZ = parcelRequire("68dqZ");

var $6mQpX = parcelRequire("6mQpX");

var $1Zzur = parcelRequire("1Zzur");

var $eKCeZ = parcelRequire("eKCeZ");
const $75e19e3ddb5650af$var$durationKeys = [
    "duration",
    "bounce"
];
const $75e19e3ddb5650af$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $75e19e3ddb5650af$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $75e19e3ddb5650af$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $1Zzur.springDefaults).velocity,
        stiffness: (0, $1Zzur.springDefaults).stiffness,
        damping: (0, $1Zzur.springDefaults).damping,
        mass: (0, $1Zzur.springDefaults).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$75e19e3ddb5650af$var$isSpringType(options, $75e19e3ddb5650af$var$physicsKeys) && $75e19e3ddb5650af$var$isSpringType(options, $75e19e3ddb5650af$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $YLpUN.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $1Zzur.springDefaults).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $eKCeZ.findSpring)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $1Zzur.springDefaults).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $75e19e3ddb5650af$export$b36281d89752ae66(optionsOrVisualDuration = (0, $1Zzur.springDefaults).visualDuration, bounce = (0, $1Zzur.springDefaults).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $75e19e3ddb5650af$var$getSpringOptions({
        ...options,
        velocity: -(0, $9rDgO.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $9rDgO.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $1Zzur.springDefaults).restSpeed.granular : (0, $1Zzur.springDefaults).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $1Zzur.springDefaults).restDelta.granular : (0, $1Zzur.springDefaults).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $eKCeZ.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $9rDgO.secondsToMilliseconds)(initialVelocity) : (0, $6mQpX.calcGeneratorVelocity)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $2r6tM.calcGeneratorDuration)(generator), (0, $2r6tM.maxGeneratorDuration));
            const easing = (0, $7yarN.generateLinearEasing)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$75e19e3ddb5650af$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $68dqZ.createGeneratorEasing)(options, 100, $75e19e3ddb5650af$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $9rDgO.secondsToMilliseconds)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};

});
parcelRegister("7yarN", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", () => $fbceb776acbf6f85$export$66d3851e2b1ec912);
const $fbceb776acbf6f85$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};

});

parcelRegister("2r6tM", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", () => $048d40bc395ec3a5$export$f4ff70a5b4808fd8);
$parcel$export(module.exports, "calcGeneratorDuration", () => $048d40bc395ec3a5$export$cbdd6b3d40ea54e2);
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $048d40bc395ec3a5$export$f4ff70a5b4808fd8 = 20000;
function $048d40bc395ec3a5$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $048d40bc395ec3a5$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $048d40bc395ec3a5$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("68dqZ", function(module, exports) {

$parcel$export(module.exports, "createGeneratorEasing", () => $6bbc1fa6175a84ae$export$7f1511d09ee75a99);

var $9rDgO = parcelRequire("9rDgO");

var $2r6tM = parcelRequire("2r6tM");
/**
 * Create a progress => progress easing function from a generator.
 */ function $6bbc1fa6175a84ae$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $2r6tM.calcGeneratorDuration)(generator), (0, $2r6tM.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $9rDgO.millisecondsToSeconds)(duration)
    };
}

});

parcelRegister("6mQpX", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", () => $6a4f1288812bd34c$export$854187271d233eb5);

var $iIllo = parcelRequire("iIllo");
const $6a4f1288812bd34c$var$velocitySampleDuration = 5; // ms
function $6a4f1288812bd34c$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $6a4f1288812bd34c$var$velocitySampleDuration, 0);
    return (0, $iIllo.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});

parcelRegister("1Zzur", function(module, exports) {

$parcel$export(module.exports, "springDefaults", () => $5737f6b36d02bc45$export$86436497e7b05d16);
const $5737f6b36d02bc45$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};

});

parcelRegister("eKCeZ", function(module, exports) {

$parcel$export(module.exports, "findSpring", () => $82cace49a4ebdb53$export$b15f158dc6d6f458);
$parcel$export(module.exports, "calcAngularFreq", () => $82cace49a4ebdb53$export$5f679887c3a78b15);

var $YLpUN = parcelRequire("YLpUN");
var $9rDgO = parcelRequire("9rDgO");
var $4S7XB = parcelRequire("4S7XB");

var $1Zzur = parcelRequire("1Zzur");
const $82cace49a4ebdb53$var$safeMin = 0.001;
function $82cace49a4ebdb53$export$b15f158dc6d6f458({ duration: duration = (0, $1Zzur.springDefaults).duration, bounce: bounce = (0, $1Zzur.springDefaults).bounce, velocity: velocity = (0, $1Zzur.springDefaults).velocity, mass: mass = (0, $1Zzur.springDefaults).mass }) {
    let envelope;
    let derivative;
    (0, $4S7XB.warning)(duration <= (0, $9rDgO.secondsToMilliseconds)((0, $1Zzur.springDefaults).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $YLpUN.clamp)((0, $1Zzur.springDefaults).minDamping, (0, $1Zzur.springDefaults).maxDamping, dampingRatio);
    duration = (0, $YLpUN.clamp)((0, $1Zzur.springDefaults).minDuration, (0, $1Zzur.springDefaults).maxDuration, (0, $9rDgO.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $82cace49a4ebdb53$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $82cace49a4ebdb53$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $82cace49a4ebdb53$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $82cace49a4ebdb53$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$82cace49a4ebdb53$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $82cace49a4ebdb53$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $9rDgO.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $1Zzur.springDefaults).stiffness,
        damping: (0, $1Zzur.springDefaults).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $82cace49a4ebdb53$var$rootIterations = 12;
function $82cace49a4ebdb53$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $82cace49a4ebdb53$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $82cace49a4ebdb53$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});



parcelRegister("brsyv", function(module, exports) {

$parcel$export(module.exports, "keyframes", () => $aae2d0665939afc9$export$d25ddfdf17c3ad3e);

var $9mWyj = parcelRequire("9mWyj");
var $7u5bx = parcelRequire("7u5bx");
var $deCC6 = parcelRequire("deCC6");

var $kLnDT = parcelRequire("kLnDT");

var $6dgvU = parcelRequire("6dgvU");

var $d3egN = parcelRequire("d3egN");
function $aae2d0665939afc9$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $9mWyj.easeInOut)).splice(0, values.length - 1);
}
function $aae2d0665939afc9$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $deCC6.isEasingArray)(ease) ? ease.map((0, $7u5bx.easingDefinitionToFunction)) : (0, $7u5bx.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d3egN.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $6dgvU.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $kLnDT.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $aae2d0665939afc9$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("9mWyj", function(module, exports) {

$parcel$export(module.exports, "easeIn", () => $48d4981ca2772c9f$export$929e5a82286172a6);
$parcel$export(module.exports, "easeOut", () => $48d4981ca2772c9f$export$57636bb43b1ccbb0);
$parcel$export(module.exports, "easeInOut", () => $48d4981ca2772c9f$export$c07234257a03d5e9);

var $5nfx0 = parcelRequire("5nfx0");
const $48d4981ca2772c9f$export$929e5a82286172a6 = /*@__PURE__*/ (0, $5nfx0.cubicBezier)(0.42, 0, 1, 1);
const $48d4981ca2772c9f$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $5nfx0.cubicBezier)(0, 0, 0.58, 1);
const $48d4981ca2772c9f$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $5nfx0.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("5nfx0", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", () => $8b79c27ef7695ece$export$2c575fa1d20488bd);

var $gfeF6 = parcelRequire("gfeF6");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $8b79c27ef7695ece$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $8b79c27ef7695ece$var$subdivisionPrecision = 0.0000001;
const $8b79c27ef7695ece$var$subdivisionMaxIterations = 12;
function $8b79c27ef7695ece$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $8b79c27ef7695ece$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $8b79c27ef7695ece$var$subdivisionPrecision && ++i < $8b79c27ef7695ece$var$subdivisionMaxIterations);
    return currentT;
}
function $8b79c27ef7695ece$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $gfeF6.noop;
    const getTForX = (aX)=>$8b79c27ef7695ece$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $8b79c27ef7695ece$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("7u5bx", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", () => $acf4b2c4ab92b472$export$ef97fe084f156ca4);

var $4S7XB = parcelRequire("4S7XB");

var $gfeF6 = parcelRequire("gfeF6");

var $jBzbW = parcelRequire("jBzbW");

var $illnH = parcelRequire("illnH");

var $8pMo2 = parcelRequire("8pMo2");

var $5nfx0 = parcelRequire("5nfx0");

var $9mWyj = parcelRequire("9mWyj");

var $lavOo = parcelRequire("lavOo");
const $acf4b2c4ab92b472$var$easingLookup = {
    linear: (0, $gfeF6.noop),
    easeIn: $9mWyj.easeIn,
    easeInOut: $9mWyj.easeInOut,
    easeOut: $9mWyj.easeOut,
    circIn: $8pMo2.circIn,
    circInOut: $8pMo2.circInOut,
    circOut: $8pMo2.circOut,
    backIn: $illnH.backIn,
    backInOut: $illnH.backInOut,
    backOut: $illnH.backOut,
    anticipate: $jBzbW.anticipate
};
const $acf4b2c4ab92b472$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $acf4b2c4ab92b472$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $lavOo.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $4S7XB.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $5nfx0.cubicBezier)(x1, y1, x2, y2);
    } else if ($acf4b2c4ab92b472$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $4S7XB.invariant)($acf4b2c4ab92b472$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $acf4b2c4ab92b472$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("jBzbW", function(module, exports) {

$parcel$export(module.exports, "anticipate", () => $fbe14194068f10a7$export$6b0af63b873d419e);

var $illnH = parcelRequire("illnH");
const $fbe14194068f10a7$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $illnH.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});
parcelRegister("illnH", function(module, exports) {

$parcel$export(module.exports, "backOut", () => $a2275c895c249549$export$77edfce482316a60);
$parcel$export(module.exports, "backIn", () => $a2275c895c249549$export$b01116c84cdfe1a2);
$parcel$export(module.exports, "backInOut", () => $a2275c895c249549$export$ddc5fd596f6c71b2);

var $5nfx0 = parcelRequire("5nfx0");

var $e9egJ = parcelRequire("e9egJ");

var $j3k8w = parcelRequire("j3k8w");
const $a2275c895c249549$export$77edfce482316a60 = /*@__PURE__*/ (0, $5nfx0.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $a2275c895c249549$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $j3k8w.reverseEasing)($a2275c895c249549$export$77edfce482316a60);
const $a2275c895c249549$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $e9egJ.mirrorEasing)($a2275c895c249549$export$b01116c84cdfe1a2);

});
parcelRegister("e9egJ", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", () => $c90f4a19c999c2e1$export$f946554fb8aeaf0d);
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $c90f4a19c999c2e1$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("j3k8w", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", () => $0982f6fbae06e0d3$export$2c07eeff45156d4d);
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $0982f6fbae06e0d3$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});



parcelRegister("8pMo2", function(module, exports) {

$parcel$export(module.exports, "circIn", () => $3d1235d273010742$export$e444123e42d03385);
$parcel$export(module.exports, "circOut", () => $3d1235d273010742$export$c8d67a19199d1a50);
$parcel$export(module.exports, "circInOut", () => $3d1235d273010742$export$30d3455eee55bed5);

var $e9egJ = parcelRequire("e9egJ");

var $j3k8w = parcelRequire("j3k8w");
const $3d1235d273010742$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $3d1235d273010742$export$c8d67a19199d1a50 = (0, $j3k8w.reverseEasing)($3d1235d273010742$export$e444123e42d03385);
const $3d1235d273010742$export$30d3455eee55bed5 = (0, $e9egJ.mirrorEasing)($3d1235d273010742$export$e444123e42d03385);

});

parcelRegister("lavOo", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", () => $de3e514f2f4176dc$export$ff43f99925d7366b);
const $de3e514f2f4176dc$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});


parcelRegister("deCC6", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", () => $8e0ce25e9a91204c$export$216948827bbdc797);
const $8e0ce25e9a91204c$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("kLnDT", function(module, exports) {

$parcel$export(module.exports, "interpolate", () => $5f1c53229828f7b7$export$89e29e4ab65e70a9);

var $YLpUN = parcelRequire("YLpUN");
var $4S7XB = parcelRequire("4S7XB");
var $5gGDR = parcelRequire("5gGDR");
var $gfeF6 = parcelRequire("gfeF6");
var $2JuHM = parcelRequire("2JuHM");
var $4vBeI = parcelRequire("4vBeI");

var $bsFKm = parcelRequire("bsFKm");
function $5f1c53229828f7b7$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $5gGDR.MotionGlobalConfig).mix || (0, $bsFKm.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $gfeF6.noop) : ease;
            mixer = (0, $2JuHM.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $5f1c53229828f7b7$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $4S7XB.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $5f1c53229828f7b7$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $4vBeI.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $YLpUN.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("4vBeI", function(module, exports) {

$parcel$export(module.exports, "progress", () => $739eff344823afe9$export$504d7abb21fa8c9);
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $739eff344823afe9$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});


parcelRegister("6dgvU", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", () => $facbffd3fe08aef4$export$24dbcec0b26e6d9d);

var $8iEX4 = parcelRequire("8iEX4");
function $facbffd3fe08aef4$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $8iEX4.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("8iEX4", function(module, exports) {

$parcel$export(module.exports, "fillOffset", () => $c015fab9ebb38e3d$export$dafee61230cf05c6);

var $4vBeI = parcelRequire("4vBeI");

var $1rqJ7 = parcelRequire("1rqJ7");
function $c015fab9ebb38e3d$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $4vBeI.progress)(0, remaining, i);
        offset.push((0, $1rqJ7.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("d3egN", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", () => $b0d4ebf22824a03d$export$2a91b4e3a4539316);
function $b0d4ebf22824a03d$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("9IDQl", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", () => $cdf2297d0a1f9272$export$14de59408fad90b);
const $cdf2297d0a1f9272$var$isNotNull = (value)=>value !== null;
function $cdf2297d0a1f9272$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($cdf2297d0a1f9272$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("fFrB8", function(module, exports) {

$parcel$export(module.exports, "replaceTransitionType", () => $56dadec06fd4fb31$export$98db6ef1242dfa2);

var $g6r1B = parcelRequire("g6r1B");

var $brsyv = parcelRequire("brsyv");

var $i6FLG = parcelRequire("i6FLG");
const $56dadec06fd4fb31$var$transitionTypeMap = {
    decay: (0, $g6r1B.inertia),
    inertia: $g6r1B.inertia,
    tween: (0, $brsyv.keyframes),
    keyframes: (0, $brsyv.keyframes),
    spring: $i6FLG.spring
};
function $56dadec06fd4fb31$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $56dadec06fd4fb31$var$transitionTypeMap[transition.type];
}

});

parcelRegister("lfBGq", function(module, exports) {

$parcel$export(module.exports, "WithPromise", () => $975904e1d5b3b5fb$export$655db786091c33e0);
class $975904e1d5b3b5fb$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}

});


parcelRegister("2Skvh", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", () => $0318fbd6a8021df6$export$78b96d2a12593b05);
$parcel$export(module.exports, "KeyframeResolver", () => $0318fbd6a8021df6$export$74d34ca3182f1750);

var $d8vcs = parcelRequire("d8vcs");

var $342FB = parcelRequire("342FB");

var $bzAli = parcelRequire("bzAli");
const $0318fbd6a8021df6$var$toResolve = new Set();
let $0318fbd6a8021df6$var$isScheduled = false;
let $0318fbd6a8021df6$var$anyNeedsMeasurement = false;
let $0318fbd6a8021df6$var$isForced = false;
function $0318fbd6a8021df6$var$measureAllKeyframes() {
    if ($0318fbd6a8021df6$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($0318fbd6a8021df6$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $342FB.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $0318fbd6a8021df6$var$anyNeedsMeasurement = false;
    $0318fbd6a8021df6$var$isScheduled = false;
    $0318fbd6a8021df6$var$toResolve.forEach((resolver)=>resolver.complete($0318fbd6a8021df6$var$isForced));
    $0318fbd6a8021df6$var$toResolve.clear();
}
function $0318fbd6a8021df6$var$readAllKeyframes() {
    $0318fbd6a8021df6$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $0318fbd6a8021df6$var$anyNeedsMeasurement = true;
    });
}
function $0318fbd6a8021df6$export$78b96d2a12593b05() {
    $0318fbd6a8021df6$var$isForced = true;
    $0318fbd6a8021df6$var$readAllKeyframes();
    $0318fbd6a8021df6$var$measureAllKeyframes();
    $0318fbd6a8021df6$var$isForced = false;
}
class $0318fbd6a8021df6$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $0318fbd6a8021df6$var$toResolve.add(this);
            if (!$0318fbd6a8021df6$var$isScheduled) {
                $0318fbd6a8021df6$var$isScheduled = true;
                (0, $bzAli.frame).read($0318fbd6a8021df6$var$readAllKeyframes);
                (0, $bzAli.frame).resolveKeyframes($0318fbd6a8021df6$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $d8vcs.fillWildcards)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $0318fbd6a8021df6$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $0318fbd6a8021df6$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}

});
parcelRegister("d8vcs", function(module, exports) {

$parcel$export(module.exports, "fillWildcards", () => $5e8ca15773c32ea9$export$5a98a90409277f5a);
function $5e8ca15773c32ea9$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}

});

parcelRegister("342FB", function(module, exports) {

$parcel$export(module.exports, "isNumOrPxType", () => $34c19a244b949754$export$8e5250d1aa9bf370);
$parcel$export(module.exports, "removeNonTranslationalTransform", () => $34c19a244b949754$export$39d4bc9655f3f632);
$parcel$export(module.exports, "positionalValues", () => $34c19a244b949754$export$781d46a8aa670d52);

var $2YzSk = parcelRequire("2YzSk");

var $eMYQu = parcelRequire("eMYQu");

var $6WRjq = parcelRequire("6WRjq");

var $aNIli = parcelRequire("aNIli");
const $34c19a244b949754$export$8e5250d1aa9bf370 = (v)=>v === (0, $6WRjq.number) || v === (0, $aNIli.px);
const $34c19a244b949754$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $34c19a244b949754$var$nonTranslationalTransformKeys = (0, $eMYQu.transformPropOrder).filter((key)=>!$34c19a244b949754$var$transformKeys.has(key));
function $34c19a244b949754$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $34c19a244b949754$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $34c19a244b949754$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $2YzSk.parseValueFromTransform)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $2YzSk.parseValueFromTransform)(transform, "y")
};
// Alias translate longform names
$34c19a244b949754$export$781d46a8aa670d52.translateX = $34c19a244b949754$export$781d46a8aa670d52.x;
$34c19a244b949754$export$781d46a8aa670d52.translateY = $34c19a244b949754$export$781d46a8aa670d52.y;

});
parcelRegister("2YzSk", function(module, exports) {

$parcel$export(module.exports, "defaultTransformValue", () => $0be2b10cca6208af$export$1f10c01143b9f089);
$parcel$export(module.exports, "parseValueFromTransform", () => $0be2b10cca6208af$export$f9111f9e16b73a26);
$parcel$export(module.exports, "readTransformValue", () => $0be2b10cca6208af$export$bcd97e0e03ba17f6);
const $0be2b10cca6208af$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $0be2b10cca6208af$var$rotate = (v)=>{
    const angle = $0be2b10cca6208af$var$radToDeg(Math.atan2(v[1], v[0]));
    return $0be2b10cca6208af$var$rebaseAngle(angle);
};
const $0be2b10cca6208af$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $0be2b10cca6208af$var$rotate,
    rotateZ: $0be2b10cca6208af$var$rotate,
    skewX: (v)=>$0be2b10cca6208af$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$0be2b10cca6208af$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $0be2b10cca6208af$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $0be2b10cca6208af$var$rotateZ = $0be2b10cca6208af$var$rotate;
const $0be2b10cca6208af$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $0be2b10cca6208af$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $0be2b10cca6208af$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $0be2b10cca6208af$var$scaleX,
    scaleY: $0be2b10cca6208af$var$scaleY,
    scale: (v)=>($0be2b10cca6208af$var$scaleX(v) + $0be2b10cca6208af$var$scaleY(v)) / 2,
    rotateX: (v)=>$0be2b10cca6208af$var$rebaseAngle($0be2b10cca6208af$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$0be2b10cca6208af$var$rebaseAngle($0be2b10cca6208af$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $0be2b10cca6208af$var$rotateZ,
    rotate: $0be2b10cca6208af$var$rotateZ,
    skewX: (v)=>$0be2b10cca6208af$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$0be2b10cca6208af$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $0be2b10cca6208af$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $0be2b10cca6208af$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $0be2b10cca6208af$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $0be2b10cca6208af$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $0be2b10cca6208af$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $0be2b10cca6208af$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($0be2b10cca6208af$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $0be2b10cca6208af$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $0be2b10cca6208af$export$f9111f9e16b73a26(transform, name);
};
function $0be2b10cca6208af$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

});



parcelRegister("8J1fo", function(module, exports) {

$parcel$export(module.exports, "NativeAnimationExtended", () => $817d2323c1c42559$export$bd2cd6a048093d96);

var $9rDgO = parcelRequire("9rDgO");

var $4UTnX = parcelRequire("4UTnX");

var $gspdA = parcelRequire("gspdA");

var $fFrB8 = parcelRequire("fFrB8");

var $kLCmd = parcelRequire("kLCmd");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $817d2323c1c42559$var$sampleDelta = 10; //ms
class $817d2323c1c42559$export$bd2cd6a048093d96 extends (0, $gspdA.NativeAnimation) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $kLCmd.replaceStringEasing)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $fFrB8.replaceTransitionType)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $4UTnX.JSAnimation)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $9rDgO.secondsToMilliseconds)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $817d2323c1c42559$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $817d2323c1c42559$var$sampleDelta);
        sampleAnimation.stop();
    }
}

});
parcelRegister("gspdA", function(module, exports) {

$parcel$export(module.exports, "NativeAnimation", () => $6382b771e38cded0$export$6c0f9803d8aa7219);

var $4S7XB = parcelRequire("4S7XB");
var $9rDgO = parcelRequire("9rDgO");
var $gfeF6 = parcelRequire("gfeF6");

var $hsUI8 = parcelRequire("hsUI8");

var $f5umD = parcelRequire("f5umD");

var $9IDQl = parcelRequire("9IDQl");

var $lfBGq = parcelRequire("lfBGq");

var $cvBmz = parcelRequire("cvBmz");

var $9Go7H = parcelRequire("9Go7H");
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $6382b771e38cded0$export$6c0f9803d8aa7219 extends (0, $lfBGq.WithPromise) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $4S7XB.invariant)(typeof options.type !== "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "motion"?`);
        const transition = (0, $9Go7H.applyGeneratorOptions)(options);
        this.animation = (0, $cvBmz.startWaapiAnimation)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $9IDQl.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $hsUI8.setStyle)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $9rDgO.millisecondsToSeconds)(Number(duration));
    }
    get time() {
        return (0, $9rDgO.millisecondsToSeconds)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $9rDgO.secondsToMilliseconds)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $f5umD.supportsScrollTimeline)()) {
            this.animation.timeline = timeline;
            return 0, $gfeF6.noop;
        } else return observe(this);
    }
}

});
parcelRegister("hsUI8", function(module, exports) {

$parcel$export(module.exports, "setStyle", () => $8f5b49bf46d054ba$export$37a5fde709c1db82);

var $gQCV4 = parcelRequire("gQCV4");
function $8f5b49bf46d054ba$export$37a5fde709c1db82(element, name, value) {
    (0, $gQCV4.isCSSVar)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

});
parcelRegister("gQCV4", function(module, exports) {

$parcel$export(module.exports, "isCSSVar", () => $01fe2360573a202f$export$c9f584638d388483);
const $01fe2360573a202f$export$c9f584638d388483 = (name)=>name.startsWith("--");

});


parcelRegister("f5umD", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", () => $3984308b761e78e6$export$20d68f04f30763a5);

var $hxLWs = parcelRequire("hxLWs");
const $3984308b761e78e6$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $hxLWs.memo)(()=>window.ScrollTimeline !== undefined);

});
parcelRegister("hxLWs", function(module, exports) {

$parcel$export(module.exports, "memo", () => $d55c3337cffb16b1$export$7c73462e0d25e514);
/*#__NO_SIDE_EFFECTS__*/ function $d55c3337cffb16b1$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});


parcelRegister("cvBmz", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", () => $597fc7323aab6681$export$d896de52f97cb615);

var $3miKP = parcelRequire("3miKP");

var $8D0Pz = parcelRequire("8D0Pz");

var $eYQZm = parcelRequire("eYQZm");
function $597fc7323aab6681$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $eYQZm.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $8D0Pz.statsBuffer).value) (0, $3miKP.activeAnimations).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $8D0Pz.statsBuffer).value) animation.finished.finally(()=>{
        (0, $3miKP.activeAnimations).waapi--;
    });
    return animation;
}

});
parcelRegister("eYQZm", function(module, exports) {

$parcel$export(module.exports, "mapEasingToNativeEasing", () => $9283a2c6b2ba3057$export$916ea73bcd3a6030);

var $lavOo = parcelRequire("lavOo");

var $cHOTM = parcelRequire("cHOTM");

var $7yarN = parcelRequire("7yarN");

var $lrozJ = parcelRequire("lrozJ");

var $1KR9V = parcelRequire("1KR9V");
function $9283a2c6b2ba3057$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $cHOTM.supportsLinearEasing)() ? (0, $7yarN.generateLinearEasing)(easing, duration) : "ease-out";
    else if ((0, $lavOo.isBezierDefinition)(easing)) return (0, $lrozJ.cubicBezierAsString)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$9283a2c6b2ba3057$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $1KR9V.supportedWaapiEasing).easeOut);
    else return (0, $1KR9V.supportedWaapiEasing)[easing];
}

});
parcelRegister("cHOTM", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", () => $2ecbc1714e32db60$export$866c1d07a1ac2ab);

var $hQPzc = parcelRequire("hQPzc");
const $2ecbc1714e32db60$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $hQPzc.memoSupports)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});
parcelRegister("hQPzc", function(module, exports) {

$parcel$export(module.exports, "memoSupports", () => $cc2d80529cd5829a$export$1964673d5ec13c3a);

var $hxLWs = parcelRequire("hxLWs");

var $lkQtD = parcelRequire("lkQtD");
function $cc2d80529cd5829a$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $hxLWs.memo)(callback);
    return ()=>(0, $lkQtD.supportsFlags)[supportsFlag] ?? memoized();
}

});
parcelRegister("lkQtD", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", () => $a5c6f8339d19f2ec$export$e3ad02c335474dee);
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $a5c6f8339d19f2ec$export$e3ad02c335474dee = {};

});



parcelRegister("lrozJ", function(module, exports) {

$parcel$export(module.exports, "cubicBezierAsString", () => $3eb21b81b06ba8b5$export$2523b8f0bd8f44cb);
const $3eb21b81b06ba8b5$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;

});

parcelRegister("1KR9V", function(module, exports) {

$parcel$export(module.exports, "supportedWaapiEasing", () => $c99c8f6567bbc6fa$export$2cf569f5e2221176);

var $lrozJ = parcelRequire("lrozJ");
const $c99c8f6567bbc6fa$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $lrozJ.cubicBezierAsString)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $lrozJ.cubicBezierAsString)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $lrozJ.cubicBezierAsString)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $lrozJ.cubicBezierAsString)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};

});



parcelRegister("9Go7H", function(module, exports) {

$parcel$export(module.exports, "applyGeneratorOptions", () => $d9ada3d35919c7b8$export$a31269144d66b4a);

var $cHOTM = parcelRequire("cHOTM");

var $htmJN = parcelRequire("htmJN");
function $d9ada3d35919c7b8$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $htmJN.isGenerator)(type) && (0, $cHOTM.supportsLinearEasing)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}

});
parcelRegister("htmJN", function(module, exports) {

$parcel$export(module.exports, "isGenerator", () => $46df8fc5e906774a$export$6ab7812f1bac68be);
function $46df8fc5e906774a$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

});



parcelRegister("kLCmd", function(module, exports) {

$parcel$export(module.exports, "replaceStringEasing", () => $b2049657f6c01b72$export$5195f232c29d1f82);

var $jBzbW = parcelRequire("jBzbW");
var $illnH = parcelRequire("illnH");
var $8pMo2 = parcelRequire("8pMo2");
const $b2049657f6c01b72$var$unsupportedEasingFunctions = {
    anticipate: $jBzbW.anticipate,
    backInOut: $illnH.backInOut,
    circInOut: $8pMo2.circInOut
};
function $b2049657f6c01b72$var$isUnsupportedEase(key) {
    return key in $b2049657f6c01b72$var$unsupportedEasingFunctions;
}
function $b2049657f6c01b72$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $b2049657f6c01b72$var$isUnsupportedEase(transition.ease)) transition.ease = $b2049657f6c01b72$var$unsupportedEasingFunctions[transition.ease];
}

});


parcelRegister("asTno", function(module, exports) {

$parcel$export(module.exports, "canAnimate", () => $64b23bcdfcb80fb0$export$1b109e6c9968df4f);

var $4S7XB = parcelRequire("4S7XB");

var $htmJN = parcelRequire("htmJN");

var $hNJKy = parcelRequire("hNJKy");
function $64b23bcdfcb80fb0$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $64b23bcdfcb80fb0$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $hNJKy.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $hNJKy.isAnimatable)(targetKeyframe, name);
    (0, $4S7XB.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $64b23bcdfcb80fb0$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $htmJN.isGenerator)(type)) && velocity;
}

});
parcelRegister("hNJKy", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", () => $481c2d1731f6df0e$export$65676b58b122bc38);

var $1bx7b = parcelRequire("1bx7b");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $481c2d1731f6df0e$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $1bx7b.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});


parcelRegister("4Bgq4", function(module, exports) {

$parcel$export(module.exports, "supportsBrowserAnimation", () => $3f34927a30798489$export$ea92bde116fda821);

var $hxLWs = parcelRequire("hxLWs");

var $6tfTi = parcelRequire("6tfTi");
/**
 * A list of values that can be hardware-accelerated.
 */ const $3f34927a30798489$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $3f34927a30798489$var$supportsWaapi = /*@__PURE__*/ (0, $hxLWs.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $3f34927a30798489$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
    if (!(0, $6tfTi.isHTMLElement)(motionValue?.owner?.current)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $3f34927a30798489$var$supportsWaapi() && name && $3f34927a30798489$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

});


parcelRegister("eh651", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", () => $6f6e1d21e3fd7e09$export$14de59408fad90b);
const $6f6e1d21e3fd7e09$var$isNotNull = (value)=>value !== null;
function $6f6e1d21e3fd7e09$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($6f6e1d21e3fd7e09$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("akeMP", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", () => $1807772d6913a56f$export$262124b154b9f1c0);

var $eMYQu = parcelRequire("eMYQu");
const $1807772d6913a56f$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $1807772d6913a56f$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $1807772d6913a56f$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $1807772d6913a56f$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $1807772d6913a56f$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $1807772d6913a56f$var$keyframesTransition;
    else if ((0, $eMYQu.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $1807772d6913a56f$var$criticallyDampedSpring(keyframes[1]) : $1807772d6913a56f$var$underDampedSpring;
    return $1807772d6913a56f$var$ease;
};

});

parcelRegister("1E2Ro", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", () => $6292875a68964442$export$ca8e47dc8ed5a9d7);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $6292875a68964442$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}

});



parcelRegister("1KEO5", function(module, exports) {

$parcel$export(module.exports, "animateVariant", () => $b2ec6cfe8850d01a$export$4709dc300705b2af);

var $cJR9n = parcelRequire("cJR9n");

var $cKuWX = parcelRequire("cKuWX");
function $b2ec6cfe8850d01a$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $cJR9n.resolveVariant)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $cKuWX.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $b2ec6cfe8850d01a$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $b2ec6cfe8850d01a$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($b2ec6cfe8850d01a$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($b2ec6cfe8850d01a$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $b2ec6cfe8850d01a$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});


parcelRegister("2cIOK", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", () => $265fdbc950bad8ff$export$90e866afbd6b9f1a);
function $265fdbc950bad8ff$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("fFBPw", function(module, exports) {

$parcel$export(module.exports, "getVariantContext", () => $c04a78b38b16f42f$export$6669f52f7ffa343b);

var $cMzxg = parcelRequire("cMzxg");

var $jtjtW = parcelRequire("jtjtW");
const $c04a78b38b16f42f$var$numVariantProps = (0, $jtjtW.variantProps).length;
function $c04a78b38b16f42f$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $c04a78b38b16f42f$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $c04a78b38b16f42f$var$numVariantProps; i++){
        const name = (0, $jtjtW.variantProps)[i];
        const prop = visualElement.props[name];
        if ((0, $cMzxg.isVariantLabel)(prop) || prop === false) context[name] = prop;
    }
    return context;
}

});
parcelRegister("cMzxg", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", () => $33e95f2e5351c1c0$export$720b90e312cea233);
/**
 * Decides if the supplied variable is variant label
 */ function $33e95f2e5351c1c0$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("jtjtW", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", () => $db4213190228bc95$export$16e45afcc206d3a8);
$parcel$export(module.exports, "variantProps", () => $db4213190228bc95$export$1405a65085f40b9);
const $db4213190228bc95$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $db4213190228bc95$export$1405a65085f40b9 = [
    "initial",
    ...$db4213190228bc95$export$16e45afcc206d3a8
];

});



parcelRegister("gxL8Z", function(module, exports) {

$parcel$export(module.exports, "Feature", () => $2bff128c5f01d94e$export$6e91cf7616333d5);
class $2bff128c5f01d94e$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("jKpin", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", () => $b0455ce46319afbf$export$4989d1eb6104cc6c);

var $gxL8Z = parcelRequire("gxL8Z");
let $b0455ce46319afbf$var$id = 0;
class $b0455ce46319afbf$export$4989d1eb6104cc6c extends (0, $gxL8Z.Feature) {
    constructor(){
        super(...arguments);
        this.id = $b0455ce46319afbf$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("2om4u", function(module, exports) {

$parcel$export(module.exports, "drag", () => $548a9e48e4e01a07$export$d7d5d435647ed5a0);

var $jTUvW = parcelRequire("jTUvW");

var $a7HlN = parcelRequire("a7HlN");

var $5wiiV = parcelRequire("5wiiV");

var $hbSpb = parcelRequire("hbSpb");
const $548a9e48e4e01a07$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $a7HlN.PanGesture)
    },
    drag: {
        Feature: (0, $jTUvW.DragGesture),
        ProjectionNode: (0, $hbSpb.HTMLProjectionNode),
        MeasureLayout: $5wiiV.MeasureLayout
    }
};

});
parcelRegister("jTUvW", function(module, exports) {

$parcel$export(module.exports, "DragGesture", () => $5a76b16e61ca02d1$export$5d97dc2872682820);

var $gxL8Z = parcelRequire("gxL8Z");

var $gfeF6 = parcelRequire("gfeF6");

var $4VucO = parcelRequire("4VucO");
class $5a76b16e61ca02d1$export$5d97dc2872682820 extends (0, $gxL8Z.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $gfeF6.noop);
        this.removeListeners = (0, $gfeF6.noop);
        this.controls = new (0, $4VucO.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $gfeF6.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

});
parcelRegister("4VucO", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", () => $6938cb4e7db70676$export$86bff71f18910307);

var $bzAli = parcelRequire("bzAli");
var $1rqJ7 = parcelRequire("1rqJ7");
var $aNIli = parcelRequire("aNIli");
var $hvmdk = parcelRequire("hvmdk");

var $4S7XB = parcelRequire("4S7XB");

var $iuk8z = parcelRequire("iuk8z");

var $60rvG = parcelRequire("60rvG");

var $8pjtH = parcelRequire("8pjtH");

var $37KA2 = parcelRequire("37KA2");

var $6gJeY = parcelRequire("6gJeY");

var $gvNIB = parcelRequire("gvNIB");

var $dTuEZ = parcelRequire("dTuEZ");

var $5KFVJ = parcelRequire("5KFVJ");

var $a0L4N = parcelRequire("a0L4N");

var $dtPXk = parcelRequire("dtPXk");

var $bIQoU = parcelRequire("bIQoU");

var $6bVZB = parcelRequire("6bVZB");

var $dZCB5 = parcelRequire("dZCB5");

var $hSCyr = parcelRequire("hSCyr");
const $6938cb4e7db70676$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $6938cb4e7db70676$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $dTuEZ.createBox)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $37KA2.extractEventInfo)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $hvmdk.setDragLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $5KFVJ.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $aNIli.percent).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $gvNIB.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $bzAli.frame).postRender(()=>onDragStart(event, info));
            (0, $6bVZB.addValueToWillChange)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $6938cb4e7db70676$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $5KFVJ.eachAxis)((axis)=>this.getAnimationState(axis) === "paused" && this.getAxisMotionValue(axis).animation?.play());
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $dZCB5.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $dtPXk.getContextWindow)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $bzAli.frame).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$6938cb4e7db70676$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $hSCyr.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $bIQoU.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $hSCyr.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $hSCyr.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $5KFVJ.eachAxis)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $hSCyr.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $bIQoU.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $4S7XB.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $a0L4N.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $hSCyr.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $6gJeY.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $6gJeY.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $5KFVJ.eachAxis)((axis)=>{
            if (!$6938cb4e7db70676$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $6bVZB.addValueToWillChange)(this.visualElement, axis);
        return axisValue.start((0, $iuk8z.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $5KFVJ.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $5KFVJ.eachAxis)((axis)=>this.getAxisMotionValue(axis).animation?.pause());
    }
    getAnimationState(axis) {
        return this.getAxisMotionValue(axis).animation?.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $5KFVJ.eachAxis)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$6938cb4e7db70676$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $1rqJ7.mixNumber)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $bIQoU.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $5KFVJ.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $hSCyr.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $5KFVJ.eachAxis)((axis)=>{
            if (!$6938cb4e7db70676$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $1rqJ7.mixNumber)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $6938cb4e7db70676$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $8pjtH.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $bIQoU.isRefObject)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $bzAli.frame).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $60rvG.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $5KFVJ.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $hSCyr.defaultElastic), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $6938cb4e7db70676$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $6938cb4e7db70676$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("hvmdk", function(module, exports) {

$parcel$export(module.exports, "setDragLock", () => $348851e7e7c7193c$export$64d8a3fd7eb621d5);

var $18DnX = parcelRequire("18DnX");
function $348851e7e7c7193c$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $18DnX.isDragging)[axis]) return null;
        else {
            (0, $18DnX.isDragging)[axis] = true;
            return ()=>{
                (0, $18DnX.isDragging)[axis] = false;
            };
        }
    } else {
        if ((0, $18DnX.isDragging).x || (0, $18DnX.isDragging).y) return null;
        else {
            (0, $18DnX.isDragging).x = (0, $18DnX.isDragging).y = true;
            return ()=>{
                (0, $18DnX.isDragging).x = (0, $18DnX.isDragging).y = false;
            };
        }
    }
}

});
parcelRegister("18DnX", function(module, exports) {

$parcel$export(module.exports, "isDragging", () => $82e463f155e64753$export$9e9bc3c487fccc00);
$parcel$export(module.exports, "isDragActive", () => $82e463f155e64753$export$1b3dd616664938e4);
const $82e463f155e64753$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $82e463f155e64753$export$1b3dd616664938e4() {
    return $82e463f155e64753$export$9e9bc3c487fccc00.x || $82e463f155e64753$export$9e9bc3c487fccc00.y;
}

});


parcelRegister("60rvG", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", () => $105610e7777eba77$export$b1d829ddf82884aa);
function $105610e7777eba77$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});

parcelRegister("8pjtH", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", () => $ab731bc0caef970f$export$fcff2e64e6676b81);

var $60rvG = parcelRequire("60rvG");

var $37KA2 = parcelRequire("37KA2");
function $ab731bc0caef970f$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $60rvG.addDomEvent)(target, eventName, (0, $37KA2.addPointerInfo)(handler), options);
}

});
parcelRegister("37KA2", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", () => $24dec86077a8e170$export$12f84bb882d06e1a);
$parcel$export(module.exports, "addPointerInfo", () => $24dec86077a8e170$export$c404e80f92c98d29);

var $ciW7E = parcelRequire("ciW7E");
function $24dec86077a8e170$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $24dec86077a8e170$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $ciW7E.isPrimaryPointer)(event) && handler(event, $24dec86077a8e170$export$12f84bb882d06e1a(event));
};

});
parcelRegister("ciW7E", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", () => $a053f04d86c5ab8b$export$a4cf9c8a4b063a6e);
const $a053f04d86c5ab8b$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("6gJeY", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", () => $58f6fb935053526e$export$d3955c6a8f65a36b);
$parcel$export(module.exports, "convertBoxToBoundingBox", () => $58f6fb935053526e$export$b6b9cd4198191a47);
$parcel$export(module.exports, "transformBoxPoints", () => $58f6fb935053526e$export$21543fb75483a50);
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $58f6fb935053526e$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $58f6fb935053526e$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $58f6fb935053526e$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("gvNIB", function(module, exports) {

$parcel$export(module.exports, "calcLength", () => $fb864feed65dd055$export$c1c127004b72a37);
$parcel$export(module.exports, "isNear", () => $fb864feed65dd055$export$28d0384c4b79bde2);
$parcel$export(module.exports, "calcBoxDelta", () => $fb864feed65dd055$export$c0d25e96fc67d310);
$parcel$export(module.exports, "calcRelativeBox", () => $fb864feed65dd055$export$426154f9d100f99);
$parcel$export(module.exports, "calcRelativePosition", () => $fb864feed65dd055$export$2785bfcc929c5650);

var $1rqJ7 = parcelRequire("1rqJ7");
const $fb864feed65dd055$var$SCALE_PRECISION = 0.0001;
const $fb864feed65dd055$var$SCALE_MIN = 1 - $fb864feed65dd055$var$SCALE_PRECISION;
const $fb864feed65dd055$var$SCALE_MAX = 1 + $fb864feed65dd055$var$SCALE_PRECISION;
const $fb864feed65dd055$var$TRANSLATE_PRECISION = 0.01;
const $fb864feed65dd055$var$TRANSLATE_MIN = 0 - $fb864feed65dd055$var$TRANSLATE_PRECISION;
const $fb864feed65dd055$var$TRANSLATE_MAX = 0 + $fb864feed65dd055$var$TRANSLATE_PRECISION;
function $fb864feed65dd055$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $fb864feed65dd055$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $fb864feed65dd055$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $1rqJ7.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = $fb864feed65dd055$export$c1c127004b72a37(target) / $fb864feed65dd055$export$c1c127004b72a37(source);
    delta.translate = (0, $1rqJ7.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $fb864feed65dd055$var$SCALE_MIN && delta.scale <= $fb864feed65dd055$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $fb864feed65dd055$var$TRANSLATE_MIN && delta.translate <= $fb864feed65dd055$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $fb864feed65dd055$export$c0d25e96fc67d310(delta, source, target, origin) {
    $fb864feed65dd055$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $fb864feed65dd055$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $fb864feed65dd055$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $fb864feed65dd055$export$c1c127004b72a37(relative);
}
function $fb864feed65dd055$export$426154f9d100f99(target, relative, parent) {
    $fb864feed65dd055$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $fb864feed65dd055$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $fb864feed65dd055$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $fb864feed65dd055$export$c1c127004b72a37(layout);
}
function $fb864feed65dd055$export$2785bfcc929c5650(target, layout, parent) {
    $fb864feed65dd055$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $fb864feed65dd055$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});

parcelRegister("dTuEZ", function(module, exports) {

$parcel$export(module.exports, "createDelta", () => $200bf4b8ec180084$export$3d227df54007d73a);
$parcel$export(module.exports, "createBox", () => $200bf4b8ec180084$export$6459fc9e86be362e);
const $200bf4b8ec180084$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $200bf4b8ec180084$export$3d227df54007d73a = ()=>({
        x: $200bf4b8ec180084$export$ff25708b37f72782(),
        y: $200bf4b8ec180084$export$ff25708b37f72782()
    });
const $200bf4b8ec180084$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $200bf4b8ec180084$export$6459fc9e86be362e = ()=>({
        x: $200bf4b8ec180084$export$6db76765312617ac(),
        y: $200bf4b8ec180084$export$6db76765312617ac()
    });

});

parcelRegister("5KFVJ", function(module, exports) {

$parcel$export(module.exports, "eachAxis", () => $5821f44b6b7dbf7a$export$b789de563eb43b1);
function $5821f44b6b7dbf7a$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("a0L4N", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", () => $809eff0c312625c3$export$d8718b6a7e5c624e);
$parcel$export(module.exports, "measurePageBox", () => $809eff0c312625c3$export$6a597be7a7940a96);

var $6gJeY = parcelRequire("6gJeY");

var $bACZL = parcelRequire("bACZL");
function $809eff0c312625c3$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $6gJeY.convertBoundingBoxToBox)((0, $6gJeY.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $809eff0c312625c3$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $809eff0c312625c3$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $bACZL.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $bACZL.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("bACZL", function(module, exports) {

$parcel$export(module.exports, "scalePoint", () => $f3e92f72e92b4bea$export$2290ec7febe36dd6);
$parcel$export(module.exports, "applyBoxDelta", () => $f3e92f72e92b4bea$export$d80074982803af5c);
$parcel$export(module.exports, "applyTreeDeltas", () => $f3e92f72e92b4bea$export$e2a980535c55eabb);
$parcel$export(module.exports, "transformBox", () => $f3e92f72e92b4bea$export$58b16271041fbfb);
$parcel$export(module.exports, "translateAxis", () => $f3e92f72e92b4bea$export$a807a5ce5ebb3895);

var $1rqJ7 = parcelRequire("1rqJ7");

var $bNAh8 = parcelRequire("bNAh8");
/**
 * Scales a point based on a factor and an originPoint
 */ function $f3e92f72e92b4bea$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $f3e92f72e92b4bea$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $f3e92f72e92b4bea$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $f3e92f72e92b4bea$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $f3e92f72e92b4bea$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $f3e92f72e92b4bea$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $f3e92f72e92b4bea$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $f3e92f72e92b4bea$export$d80074982803af5c(box, { x: x, y: y }) {
    $f3e92f72e92b4bea$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $f3e92f72e92b4bea$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $f3e92f72e92b4bea$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $f3e92f72e92b4bea$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $f3e92f72e92b4bea$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $f3e92f72e92b4bea$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $f3e92f72e92b4bea$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $bNAh8.hasTransform)(node.latestValues)) $f3e92f72e92b4bea$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $f3e92f72e92b4bea$var$TREE_SCALE_SNAP_MAX && treeScale.x > $f3e92f72e92b4bea$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $f3e92f72e92b4bea$var$TREE_SCALE_SNAP_MAX && treeScale.y > $f3e92f72e92b4bea$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $f3e92f72e92b4bea$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $f3e92f72e92b4bea$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $1rqJ7.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $f3e92f72e92b4bea$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $f3e92f72e92b4bea$export$58b16271041fbfb(box, transform) {
    $f3e92f72e92b4bea$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $f3e92f72e92b4bea$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("bNAh8", function(module, exports) {

$parcel$export(module.exports, "hasScale", () => $9a0da4f30a85b12c$export$bdf30dca883ea463);
$parcel$export(module.exports, "hasTransform", () => $9a0da4f30a85b12c$export$a545127cf1fbb600);
$parcel$export(module.exports, "has2DTranslate", () => $9a0da4f30a85b12c$export$bf80f5f8f4dc327f);
function $9a0da4f30a85b12c$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $9a0da4f30a85b12c$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$9a0da4f30a85b12c$var$isIdentityScale(scale) || !$9a0da4f30a85b12c$var$isIdentityScale(scaleX) || !$9a0da4f30a85b12c$var$isIdentityScale(scaleY);
}
function $9a0da4f30a85b12c$export$a545127cf1fbb600(values) {
    return $9a0da4f30a85b12c$export$bdf30dca883ea463(values) || $9a0da4f30a85b12c$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $9a0da4f30a85b12c$export$bf80f5f8f4dc327f(values) {
    return $9a0da4f30a85b12c$var$is2DTranslate(values.x) || $9a0da4f30a85b12c$var$is2DTranslate(values.y);
}
function $9a0da4f30a85b12c$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("dtPXk", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", () => $ec73700037923a39$export$d533d84f9871c879);
// Fixes https://github.com/motiondivision/motion/issues/2270
const $ec73700037923a39$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

});

parcelRegister("bIQoU", function(module, exports) {

$parcel$export(module.exports, "isRefObject", () => $8bac730267ed8b61$export$dedd81df7bc1307);
function $8bac730267ed8b61$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});

parcelRegister("dZCB5", function(module, exports) {

$parcel$export(module.exports, "PanSession", () => $cbf74c09179d2213$export$d9c66232c9c4689c);

var $bzAli = parcelRequire("bzAli");
var $ciW7E = parcelRequire("ciW7E");

var $9rDgO = parcelRequire("9rDgO");
var $2JuHM = parcelRequire("2JuHM");

var $8pjtH = parcelRequire("8pjtH");

var $37KA2 = parcelRequire("37KA2");

var $hhvxn = parcelRequire("hhvxn");
/**
 * @internal
 */ class $cbf74c09179d2213$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $cbf74c09179d2213$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $hhvxn.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $bzAli.frameData);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $cbf74c09179d2213$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $bzAli.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $cbf74c09179d2213$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $cbf74c09179d2213$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $ciW7E.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $37KA2.extractEventInfo)(event);
        const initialInfo = $cbf74c09179d2213$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $bzAli.frameData);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $cbf74c09179d2213$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $2JuHM.pipe)((0, $8pjtH.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $8pjtH.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $8pjtH.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $bzAli.cancelFrame)(this.updatePoint);
    }
}
function $cbf74c09179d2213$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $cbf74c09179d2213$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $cbf74c09179d2213$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $cbf74c09179d2213$var$subtractPoint(point, $cbf74c09179d2213$var$lastDevicePoint(history)),
        offset: $cbf74c09179d2213$var$subtractPoint(point, $cbf74c09179d2213$var$startDevicePoint(history)),
        velocity: $cbf74c09179d2213$var$getVelocity(history, 0.1)
    };
}
function $cbf74c09179d2213$var$startDevicePoint(history) {
    return history[0];
}
function $cbf74c09179d2213$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $cbf74c09179d2213$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $cbf74c09179d2213$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $9rDgO.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $9rDgO.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("hhvxn", function(module, exports) {

$parcel$export(module.exports, "distance2D", () => $7876cfdf9a80cd24$export$503a1d513f12e38b);
const $7876cfdf9a80cd24$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $7876cfdf9a80cd24$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $7876cfdf9a80cd24$export$9f17032d917177de(a.x, b.x);
    const yDelta = $7876cfdf9a80cd24$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

});


parcelRegister("hSCyr", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", () => $d33855b3a8b91f10$export$b3c764d3fca3ffe3);
$parcel$export(module.exports, "calcRelativeConstraints", () => $d33855b3a8b91f10$export$4e9195bf7793bc78);
$parcel$export(module.exports, "calcViewportConstraints", () => $d33855b3a8b91f10$export$4228500f19d4cdf7);
$parcel$export(module.exports, "calcOrigin", () => $d33855b3a8b91f10$export$13abbfca044ca46d);
$parcel$export(module.exports, "rebaseAxisConstraints", () => $d33855b3a8b91f10$export$e9672cc4c36a8b87);
$parcel$export(module.exports, "defaultElastic", () => $d33855b3a8b91f10$export$a3366d3bac43a742);
$parcel$export(module.exports, "resolveDragElastic", () => $d33855b3a8b91f10$export$7c5eaef8f4723d22);

var $1rqJ7 = parcelRequire("1rqJ7");

var $YLpUN = parcelRequire("YLpUN");
var $4vBeI = parcelRequire("4vBeI");

var $gvNIB = parcelRequire("gvNIB");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $d33855b3a8b91f10$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $1rqJ7.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $1rqJ7.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $d33855b3a8b91f10$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $d33855b3a8b91f10$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $d33855b3a8b91f10$export$690c180aa5775042(layoutBox.x, left, right),
        y: $d33855b3a8b91f10$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $d33855b3a8b91f10$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $d33855b3a8b91f10$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $d33855b3a8b91f10$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $d33855b3a8b91f10$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $d33855b3a8b91f10$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $gvNIB.calcLength)(source);
    const targetLength = (0, $gvNIB.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $4vBeI.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $4vBeI.progress)(source.min, source.max - targetLength, target.min);
    return (0, $YLpUN.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $d33855b3a8b91f10$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $d33855b3a8b91f10$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $d33855b3a8b91f10$export$7c5eaef8f4723d22(dragElastic = $d33855b3a8b91f10$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $d33855b3a8b91f10$export$a3366d3bac43a742;
    return {
        x: $d33855b3a8b91f10$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $d33855b3a8b91f10$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $d33855b3a8b91f10$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $d33855b3a8b91f10$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $d33855b3a8b91f10$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $d33855b3a8b91f10$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});



parcelRegister("a7HlN", function(module, exports) {

$parcel$export(module.exports, "PanGesture", () => $01cacad67cb03fed$export$b4f8f1ee75ce5859);

var $bzAli = parcelRequire("bzAli");

var $gfeF6 = parcelRequire("gfeF6");

var $8pjtH = parcelRequire("8pjtH");

var $gxL8Z = parcelRequire("gxL8Z");

var $dtPXk = parcelRequire("dtPXk");

var $dZCB5 = parcelRequire("dZCB5");
const $01cacad67cb03fed$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $bzAli.frame).postRender(()=>handler(event, info));
    };
class $01cacad67cb03fed$export$b4f8f1ee75ce5859 extends (0, $gxL8Z.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $gfeF6.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $dZCB5.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $dtPXk.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $01cacad67cb03fed$var$asyncHandler(onPanSessionStart),
            onStart: $01cacad67cb03fed$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $bzAli.frame).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $8pjtH.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

});

parcelRegister("5wiiV", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", () => $bd8b833bea6eb6cd$export$779f5fb01ad751cd);

var $1IdZj = parcelRequire("1IdZj");

var $bzAli = parcelRequire("bzAli");
var $bCXOT = parcelRequire("bCXOT");

var $8NFma = parcelRequire("8NFma");

var $ibOmE = parcelRequire("ibOmE");

var $6YAnm = parcelRequire("6YAnm");

var $7reOm = parcelRequire("7reOm");

var $lhad4 = parcelRequire("lhad4");

var $axwER = parcelRequire("axwER");

var $gX5hk = parcelRequire("gX5hk");

var $hBDfc = parcelRequire("hBDfc");
"use client";
class $bd8b833bea6eb6cd$var$MeasureLayoutWithContext extends (0, $8NFma.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $hBDfc.addScaleCorrector)($bd8b833bea6eb6cd$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $lhad4.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $bzAli.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $bCXOT.microtask).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $bd8b833bea6eb6cd$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $ibOmE.usePresence)();
    const layoutGroup = (0, $8NFma.useContext)((0, $6YAnm.LayoutGroupContext));
    return (0, $1IdZj.jsx)($bd8b833bea6eb6cd$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $8NFma.useContext)((0, $7reOm.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $bd8b833bea6eb6cd$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $axwER.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $axwER.correctBorderRadius),
    borderTopRightRadius: (0, $axwER.correctBorderRadius),
    borderBottomLeftRadius: (0, $axwER.correctBorderRadius),
    borderBottomRightRadius: (0, $axwER.correctBorderRadius),
    boxShadow: (0, $gX5hk.correctBoxShadow)
};

});
parcelRegister("bCXOT", function(module, exports) {

$parcel$export(module.exports, "microtask", () => $068211520ece06ae$export$bb76eed83315504c);

var $hFBk0 = parcelRequire("hFBk0");
const { schedule: $068211520ece06ae$export$bb76eed83315504c, cancel: $068211520ece06ae$export$3252729004b8456e } = /* @__PURE__ */ (0, $hFBk0.createRenderBatcher)(queueMicrotask, false);

});

parcelRegister("7reOm", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", () => $db7280e5d3034edc$export$da5f7b802957459a);

var $8NFma = parcelRequire("8NFma");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $db7280e5d3034edc$export$da5f7b802957459a = (0, $8NFma.createContext)({});

});

parcelRegister("lhad4", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", () => $d0b38a53f0c16f11$export$97db156a3ed1593b);
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $d0b38a53f0c16f11$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});

parcelRegister("axwER", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", () => $219d0b4f61267bfe$export$5eafb6257a5844c);

var $aNIli = parcelRequire("aNIli");
function $219d0b4f61267bfe$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $219d0b4f61267bfe$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $aNIli.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $219d0b4f61267bfe$export$fafff692be55225d(latest, node.target.x);
        const y = $219d0b4f61267bfe$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

});

parcelRegister("gX5hk", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", () => $45e8e283fc0f518c$export$eb0bc629e74dcf8);

var $1bx7b = parcelRequire("1bx7b");
var $1rqJ7 = parcelRequire("1rqJ7");
const $45e8e283fc0f518c$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $1bx7b.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $1bx7b.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $1rqJ7.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});

parcelRegister("hBDfc", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", () => $4fdff83f42bd104a$export$91ddd985b97788d1);
$parcel$export(module.exports, "addScaleCorrector", () => $4fdff83f42bd104a$export$de9e7791c71225fd);

var $kNVWS = parcelRequire("kNVWS");
const $4fdff83f42bd104a$export$91ddd985b97788d1 = {};
function $4fdff83f42bd104a$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $4fdff83f42bd104a$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $kNVWS.isCSSVariableName)(key)) $4fdff83f42bd104a$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}

});


parcelRegister("hbSpb", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", () => $59500a1af4e1a156$export$b61a9eb3dbde8858);

var $dzeJN = parcelRequire("dzeJN");

var $iH6ed = parcelRequire("iH6ed");
const $59500a1af4e1a156$export$b91509fcf893b648 = {
    current: undefined
};
const $59500a1af4e1a156$export$b61a9eb3dbde8858 = (0, $dzeJN.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$59500a1af4e1a156$export$b91509fcf893b648.current) {
            const documentNode = new (0, $iH6ed.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $59500a1af4e1a156$export$b91509fcf893b648.current = documentNode;
        }
        return $59500a1af4e1a156$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

});
parcelRegister("dzeJN", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", () => $164a4e28765da53e$export$a84b61f69daa9da0);

var $3miKP = parcelRequire("3miKP");
var $bzAli = parcelRequire("bzAli");
var $1TVwi = parcelRequire("1TVwi");
var $aulFR = parcelRequire("aulFR");
var $Fnf0Z = parcelRequire("Fnf0Z");
var $bCXOT = parcelRequire("bCXOT");
var $1rqJ7 = parcelRequire("1rqJ7");
var $9YfCx = parcelRequire("9YfCx");
var $8D0Pz = parcelRequire("8D0Pz");
var $aNJ8y = parcelRequire("aNJ8y");

var $YLpUN = parcelRequire("YLpUN");
var $gfeF6 = parcelRequire("gfeF6");
var $7RKvH = parcelRequire("7RKvH");

var $2t8rZ = parcelRequire("2t8rZ");

var $iJ9xe = parcelRequire("iJ9xe");

var $fvHTs = parcelRequire("fvHTs");

var $9yfxl = parcelRequire("9yfxl");

var $PGdMd = parcelRequire("PGdMd");

var $aYrIm = parcelRequire("aYrIm");

var $b9KRN = parcelRequire("b9KRN");

var $bACZL = parcelRequire("bACZL");

var $gvNIB = parcelRequire("gvNIB");

var $fnz1V = parcelRequire("fnz1V");

var $dTuEZ = parcelRequire("dTuEZ");

var $J0bNj = parcelRequire("J0bNj");

var $69OXs = parcelRequire("69OXs");

var $hBDfc = parcelRequire("hBDfc");

var $cIn0q = parcelRequire("cIn0q");

var $5KFVJ = parcelRequire("5KFVJ");

var $bNAh8 = parcelRequire("bNAh8");

var $lhad4 = parcelRequire("lhad4");
const $164a4e28765da53e$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $164a4e28765da53e$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $164a4e28765da53e$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $164a4e28765da53e$var$animationTarget = 1000;
let $164a4e28765da53e$var$id = 0;
function $164a4e28765da53e$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $164a4e28765da53e$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $iJ9xe.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $bzAli.frame), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $164a4e28765da53e$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $164a4e28765da53e$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $164a4e28765da53e$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $8D0Pz.statsBuffer).value) $164a4e28765da53e$var$metrics.nodes = $164a4e28765da53e$var$metrics.calculatedTargetDeltas = $164a4e28765da53e$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($164a4e28765da53e$export$131f2f0cc5fe9609);
                this.nodes.forEach($164a4e28765da53e$var$resolveTargetDelta);
                this.nodes.forEach($164a4e28765da53e$var$calcProjection);
                this.nodes.forEach($164a4e28765da53e$export$c2664f37bc951031);
                if ((0, $8D0Pz.statsBuffer).addProjectionMetrics) (0, $8D0Pz.statsBuffer).addProjectionMetrics($164a4e28765da53e$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $fvHTs.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $7RKvH.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $aulFR.isSVGElement)(instance) && !(0, $Fnf0Z.isSVGSVGElement)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $9yfxl.delay)(resizeUnblockUpdate, 250);
                    if ((0, $lhad4.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $lhad4.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach($164a4e28765da53e$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $164a4e28765da53e$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $J0bNj.boxEqualsRounded)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, $1TVwi.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $164a4e28765da53e$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $bzAli.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($164a4e28765da53e$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $164a4e28765da53e$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($164a4e28765da53e$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($164a4e28765da53e$var$clearIsLayoutDirty);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($164a4e28765da53e$var$clearIsLayoutDirty);
            this.animationCommitId = this.animationId;
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($164a4e28765da53e$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($164a4e28765da53e$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($164a4e28765da53e$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $aNJ8y.time).now();
            (0, $bzAli.frameData).delta = (0, $YLpUN.clamp)(0, 1000 / 60, now - (0, $bzAli.frameData).timestamp);
            (0, $bzAli.frameData).timestamp = now;
            (0, $bzAli.frameData).isProcessing = true;
            (0, $bzAli.frameSteps).update.process((0, $bzAli.frameData));
            (0, $bzAli.frameSteps).preRender.process((0, $bzAli.frameData));
            (0, $bzAli.frameSteps).render.process((0, $bzAli.frameData));
            (0, $bzAli.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $bCXOT.microtask).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($164a4e28765da53e$var$clearSnapshot);
            this.sharedNodes.forEach($164a4e28765da53e$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $bzAli.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $bzAli.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $gvNIB.calcLength)(this.snapshot.measuredBox.x) && !(0, $gvNIB.calcLength)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $dTuEZ.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $J0bNj.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $bNAh8.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $164a4e28765da53e$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $dTuEZ.createBox)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($164a4e28765da53e$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $bACZL.translateAxis)(box.x, scroll.offset.x);
                    (0, $bACZL.translateAxis)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $dTuEZ.createBox)();
            (0, $b9KRN.copyBoxInto)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $b9KRN.copyBoxInto)(boxWithoutScroll, box);
                    (0, $bACZL.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $bACZL.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $dTuEZ.createBox)();
            (0, $b9KRN.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $bACZL.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $bNAh8.hasTransform)(node.latestValues)) continue;
                (0, $bACZL.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $bNAh8.hasTransform)(this.latestValues)) (0, $bACZL.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $dTuEZ.createBox)();
            (0, $b9KRN.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $bNAh8.hasTransform)(node.latestValues)) continue;
                (0, $bNAh8.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $dTuEZ.createBox)();
                const nodeBox = node.measurePageBox();
                (0, $b9KRN.copyBoxInto)(sourceBox, nodeBox);
                (0, $fnz1V.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $bNAh8.hasTransform)(this.latestValues)) (0, $fnz1V.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $bzAli.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $bzAli.frameData).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $dTuEZ.createBox)();
                    this.relativeTargetOrigin = (0, $dTuEZ.createBox)();
                    (0, $gvNIB.calcRelativePosition)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $b9KRN.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $dTuEZ.createBox)();
                this.targetWithTransforms = (0, $dTuEZ.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $gvNIB.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $b9KRN.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, $bACZL.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $b9KRN.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $dTuEZ.createBox)();
                    this.relativeTargetOrigin = (0, $dTuEZ.createBox)();
                    (0, $gvNIB.calcRelativePosition)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $b9KRN.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $8D0Pz.statsBuffer).value) $164a4e28765da53e$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $bNAh8.hasScale)(this.parent.latestValues) || (0, $bNAh8.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $bzAli.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $b9KRN.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $bACZL.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $dTuEZ.createBox)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $b9KRN.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $b9KRN.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $gvNIB.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $J0bNj.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $J0bNj.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $8D0Pz.statsBuffer).value) $164a4e28765da53e$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $dTuEZ.createDelta)();
            this.projectionDelta = (0, $dTuEZ.createDelta)();
            this.projectionDeltaWithTransform = (0, $dTuEZ.createDelta)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $dTuEZ.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $dTuEZ.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($164a4e28765da53e$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $164a4e28765da53e$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $164a4e28765da53e$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $gvNIB.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $164a4e28765da53e$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $J0bNj.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $dTuEZ.createBox)();
                    (0, $b9KRN.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $aYrIm.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, $bzAli.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $bzAli.frame).update(()=>{
                (0, $lhad4.globalProjectionState).hasAnimatedSinceResize = true;
                (0, $3miKP.activeAnimations).layout++;
                this.motionValue || (this.motionValue = (0, $9YfCx.motionValue)(0));
                this.currentAnimation = (0, $2t8rZ.animateSingleValue)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $3miKP.activeAnimations).layout--;
                    },
                    onComplete: ()=>{
                        (0, $3miKP.activeAnimations).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($164a4e28765da53e$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $164a4e28765da53e$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $dTuEZ.createBox)();
                const xLength = (0, $gvNIB.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $gvNIB.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $b9KRN.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $bACZL.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $gvNIB.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $69OXs.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $164a4e28765da53e$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $164a4e28765da53e$var$transformAxes.length; i++){
                $164a4e28765da53e$var$resetDistortingTransform(`rotate${$164a4e28765da53e$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $164a4e28765da53e$var$resetDistortingTransform(`skew${$164a4e28765da53e$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $164a4e28765da53e$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $PGdMd.resolveMotionValue)(styleProp?.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $PGdMd.resolveMotionValue)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $bNAh8.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $cIn0q.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $hBDfc.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $hBDfc.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $PGdMd.resolveMotionValue)(styleProp?.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($164a4e28765da53e$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $164a4e28765da53e$var$updateLayout(node) {
    node.updateLayout();
}
function $164a4e28765da53e$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $5KFVJ.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $gvNIB.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($164a4e28765da53e$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $5KFVJ.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $gvNIB.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $dTuEZ.createDelta)();
        (0, $gvNIB.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $dTuEZ.createDelta)();
        if (isShared) (0, $gvNIB.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $gvNIB.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $J0bNj.isDeltaZero)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $dTuEZ.createBox)();
                    (0, $gvNIB.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $dTuEZ.createBox)();
                    (0, $gvNIB.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $J0bNj.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $164a4e28765da53e$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $8D0Pz.statsBuffer).value) $164a4e28765da53e$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $164a4e28765da53e$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $164a4e28765da53e$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $164a4e28765da53e$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $164a4e28765da53e$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $164a4e28765da53e$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $164a4e28765da53e$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $164a4e28765da53e$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $164a4e28765da53e$var$calcProjection(node) {
    node.calcProjection();
}
function $164a4e28765da53e$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $164a4e28765da53e$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $164a4e28765da53e$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $1rqJ7.mixNumber)(delta.translate, 0, p);
    output.scale = (0, $1rqJ7.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $164a4e28765da53e$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $1rqJ7.mixNumber)(from.min, to.min, p);
    output.max = (0, $1rqJ7.mixNumber)(from.max, to.max, p);
}
function $164a4e28765da53e$export$6ffd3e6ae339a132(output, from, to, p) {
    $164a4e28765da53e$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $164a4e28765da53e$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $164a4e28765da53e$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $164a4e28765da53e$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $164a4e28765da53e$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $164a4e28765da53e$var$roundPoint = $164a4e28765da53e$var$userAgentContains("applewebkit/") && !$164a4e28765da53e$var$userAgentContains("chrome/") ? Math.round : (0, $gfeF6.noop);
function $164a4e28765da53e$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $164a4e28765da53e$var$roundPoint(axis.min);
    axis.max = $164a4e28765da53e$var$roundPoint(axis.max);
}
function $164a4e28765da53e$var$roundBox(box) {
    $164a4e28765da53e$var$roundAxis(box.x);
    $164a4e28765da53e$var$roundAxis(box.y);
}
function $164a4e28765da53e$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $gvNIB.isNear)((0, $J0bNj.aspectRatio)(snapshot), (0, $J0bNj.aspectRatio)(layout), 0.2);
}
function $164a4e28765da53e$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}

});
parcelRegister("aulFR", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", () => $2d9ed148ca883180$export$17eda790a720ec57);

var $kulCl = parcelRequire("kulCl");
/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $2d9ed148ca883180$export$17eda790a720ec57(element) {
    return (0, $kulCl.isObject)(element) && "ownerSVGElement" in element;
}

});

parcelRegister("Fnf0Z", function(module, exports) {

$parcel$export(module.exports, "isSVGSVGElement", () => $d12d852c8302ed2a$export$66957ea77182581d);

var $aulFR = parcelRequire("aulFR");
/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $d12d852c8302ed2a$export$66957ea77182581d(element) {
    return (0, $aulFR.isSVGElement)(element) && element.tagName === "svg";
}

});

parcelRegister("2t8rZ", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", () => $f55ce9c35235372f$export$335a17c977067b99);

var $6CK3q = parcelRequire("6CK3q");
var $9YfCx = parcelRequire("9YfCx");

var $iuk8z = parcelRequire("iuk8z");
function $f55ce9c35235372f$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $6CK3q.isMotionValue)(value) ? value : (0, $9YfCx.motionValue)(value);
    motionValue$1.start((0, $iuk8z.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});

parcelRegister("fvHTs", function(module, exports) {

$parcel$export(module.exports, "FlatTree", () => $6703cd7d45a47598$export$1465d17e3de78a96);

var $iGMOO = parcelRequire("iGMOO");

var $9WDNT = parcelRequire("9WDNT");
class $6703cd7d45a47598$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $iGMOO.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $iGMOO.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $9WDNT.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

});
parcelRegister("9WDNT", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", () => $ed8079a6941d6d1c$export$d689d9dec5ad338);
const $ed8079a6941d6d1c$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;

});


parcelRegister("9yfxl", function(module, exports) {

$parcel$export(module.exports, "delay", () => $0c206a7020ff0297$export$1391212d75b2ee65);

var $bzAli = parcelRequire("bzAli");
var $aNJ8y = parcelRequire("aNJ8y");

var $9rDgO = parcelRequire("9rDgO");
/**
 * Timeout defined in ms
 */ function $0c206a7020ff0297$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $aNJ8y.time).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $bzAli.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $bzAli.frame).setup(checkElapsed, true);
    return ()=>(0, $bzAli.cancelFrame)(checkElapsed);
}
function $0c206a7020ff0297$export$fcd451ca460f8a2a(callback, timeout) {
    return $0c206a7020ff0297$export$1391212d75b2ee65(callback, (0, $9rDgO.secondsToMilliseconds)(timeout));
}

});

parcelRegister("PGdMd", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", () => $69a92c324366a6b4$export$fcc2206ecb6d74b);

var $6CK3q = parcelRequire("6CK3q");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $69a92c324366a6b4$export$fcc2206ecb6d74b(value) {
    return (0, $6CK3q.isMotionValue)(value) ? value.get() : value;
}

});

parcelRegister("aYrIm", function(module, exports) {

$parcel$export(module.exports, "mixValues", () => $e613c751604bfffd$export$739e279c17d51c3d);

var $1rqJ7 = parcelRequire("1rqJ7");
var $aNIli = parcelRequire("aNIli");

var $8pMo2 = parcelRequire("8pMo2");
var $gfeF6 = parcelRequire("gfeF6");
var $4vBeI = parcelRequire("4vBeI");
const $e613c751604bfffd$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $e613c751604bfffd$var$numBorders = $e613c751604bfffd$var$borders.length;
const $e613c751604bfffd$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $e613c751604bfffd$var$isPx = (value)=>typeof value === "number" || (0, $aNIli.px).test(value);
function $e613c751604bfffd$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $1rqJ7.mixNumber)(0, lead.opacity ?? 1, $e613c751604bfffd$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $1rqJ7.mixNumber)(follow.opacity ?? 1, 0, $e613c751604bfffd$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $1rqJ7.mixNumber)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $e613c751604bfffd$var$numBorders; i++){
        const borderLabel = `border${$e613c751604bfffd$var$borders[i]}Radius`;
        let followRadius = $e613c751604bfffd$var$getRadius(follow, borderLabel);
        let leadRadius = $e613c751604bfffd$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $e613c751604bfffd$var$isPx(followRadius) === $e613c751604bfffd$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $1rqJ7.mixNumber)($e613c751604bfffd$var$asNumber(followRadius), $e613c751604bfffd$var$asNumber(leadRadius), progress), 0);
            if ((0, $aNIli.percent).test(leadRadius) || (0, $aNIli.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $1rqJ7.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $e613c751604bfffd$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $e613c751604bfffd$var$easeCrossfadeIn = /*@__PURE__*/ $e613c751604bfffd$var$compress(0, 0.5, (0, $8pMo2.circOut));
const $e613c751604bfffd$var$easeCrossfadeOut = /*@__PURE__*/ $e613c751604bfffd$var$compress(0.5, 0.95, (0, $gfeF6.noop));
function $e613c751604bfffd$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $4vBeI.progress)(min, max, p));
    };
}

});

parcelRegister("b9KRN", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", () => $038af85914793979$export$c53fd88f45d77e4b);
$parcel$export(module.exports, "copyAxisDeltaInto", () => $038af85914793979$export$8ead6a7d6b225ef);
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $038af85914793979$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $038af85914793979$export$c53fd88f45d77e4b(box, originBox) {
    $038af85914793979$export$a0230ae482601ae8(box.x, originBox.x);
    $038af85914793979$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $038af85914793979$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

});

parcelRegister("fnz1V", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", () => $4180e5c54cbe587b$export$73e1ad0a9694e25c);

var $1rqJ7 = parcelRequire("1rqJ7");
var $aNIli = parcelRequire("aNIli");

var $bACZL = parcelRequire("bACZL");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $4180e5c54cbe587b$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $bACZL.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $bACZL.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $4180e5c54cbe587b$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $aNIli.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $1rqJ7.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $1rqJ7.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $4180e5c54cbe587b$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $4180e5c54cbe587b$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $4180e5c54cbe587b$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $4180e5c54cbe587b$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $4180e5c54cbe587b$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $4180e5c54cbe587b$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $4180e5c54cbe587b$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $4180e5c54cbe587b$export$42b76f1d0d16d5b(box.x, transforms, $4180e5c54cbe587b$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $4180e5c54cbe587b$export$42b76f1d0d16d5b(box.y, transforms, $4180e5c54cbe587b$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("J0bNj", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", () => $da079738137e5883$export$a7ec7642fe550fb6);
$parcel$export(module.exports, "boxEquals", () => $da079738137e5883$export$8d5cf76bb7daff09);
$parcel$export(module.exports, "boxEqualsRounded", () => $da079738137e5883$export$ef641b782d85522);
$parcel$export(module.exports, "aspectRatio", () => $da079738137e5883$export$c5706146bc63213);
$parcel$export(module.exports, "axisDeltaEquals", () => $da079738137e5883$export$444620505e28fe92);

var $gvNIB = parcelRequire("gvNIB");
function $da079738137e5883$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $da079738137e5883$export$a7ec7642fe550fb6(delta) {
    return $da079738137e5883$var$isAxisDeltaZero(delta.x) && $da079738137e5883$var$isAxisDeltaZero(delta.y);
}
function $da079738137e5883$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $da079738137e5883$export$8d5cf76bb7daff09(a, b) {
    return $da079738137e5883$export$7a9a6f114ddd0fdb(a.x, b.x) && $da079738137e5883$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $da079738137e5883$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $da079738137e5883$export$ef641b782d85522(a, b) {
    return $da079738137e5883$export$22adf28bfca1c186(a.x, b.x) && $da079738137e5883$export$22adf28bfca1c186(a.y, b.y);
}
function $da079738137e5883$export$c5706146bc63213(box) {
    return (0, $gvNIB.calcLength)(box.x) / (0, $gvNIB.calcLength)(box.y);
}
function $da079738137e5883$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

});

parcelRegister("69OXs", function(module, exports) {

$parcel$export(module.exports, "NodeStack", () => $24f866b0150d9faa$export$39be5b2d82fc9dc7);

var $iGMOO = parcelRequire("iGMOO");
class $24f866b0150d9faa$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $iGMOO.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $iGMOO.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}

});

parcelRegister("cIn0q", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", () => $fcfd35f3fe9c231e$export$d33653b270fe725c);
function $fcfd35f3fe9c231e$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

});


parcelRegister("iH6ed", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", () => $9f18e43ac04b1a2f$export$2d029a49a09b6177);

var $dzeJN = parcelRequire("dzeJN");

var $60rvG = parcelRequire("60rvG");
const $9f18e43ac04b1a2f$export$2d029a49a09b6177 = (0, $dzeJN.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, $60rvG.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

});



parcelRegister("5tJOb", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", () => $78bbaacfde380b3d$export$e5b72898e5a201f1);

var $kewxi = parcelRequire("kewxi");

var $9kTJW = parcelRequire("9kTJW");

var $joD7v = parcelRequire("joD7v");

var $044xt = parcelRequire("044xt");
const $78bbaacfde380b3d$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $044xt.InViewFeature)
    },
    tap: {
        Feature: (0, $joD7v.PressGesture)
    },
    focus: {
        Feature: (0, $9kTJW.FocusGesture)
    },
    hover: {
        Feature: (0, $kewxi.HoverGesture)
    }
};

});
parcelRegister("kewxi", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", () => $1d003e4aad7511b1$export$93a81ea037eac456);

var $bzAli = parcelRequire("bzAli");
var $4L3H1 = parcelRequire("4L3H1");

var $37KA2 = parcelRequire("37KA2");

var $gxL8Z = parcelRequire("gxL8Z");
function $1d003e4aad7511b1$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $bzAli.frame).postRender(()=>callback(event, (0, $37KA2.extractEventInfo)(event)));
}
class $1d003e4aad7511b1$export$93a81ea037eac456 extends (0, $gxL8Z.Feature) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $4L3H1.hover)(current, (_element, startEvent)=>{
            $1d003e4aad7511b1$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$1d003e4aad7511b1$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}

});
parcelRegister("4L3H1", function(module, exports) {

$parcel$export(module.exports, "hover", () => $ee66dfeb1c1d96bc$export$3f60957f5dbf3876);

var $18DnX = parcelRequire("18DnX");

var $aR8ut = parcelRequire("aR8ut");
function $ee66dfeb1c1d96bc$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $18DnX.isDragActive)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $ee66dfeb1c1d96bc$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $aR8ut.setupGesture)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$ee66dfeb1c1d96bc$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$ee66dfeb1c1d96bc$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}

});
parcelRegister("aR8ut", function(module, exports) {

$parcel$export(module.exports, "setupGesture", () => $fb396dd33f030464$export$edc0ace9d5e7e842);

var $hNHcZ = parcelRequire("hNHcZ");
function $fb396dd33f030464$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $hNHcZ.resolveElements)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}

});
parcelRegister("hNHcZ", function(module, exports) {

$parcel$export(module.exports, "resolveElements", () => $293260ad85968f9a$export$90ceba2564a894f8);
function $293260ad85968f9a$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}

});




parcelRegister("9kTJW", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", () => $5caa8f0c73d9801e$export$d4826db40d47595b);

var $2JuHM = parcelRequire("2JuHM");

var $60rvG = parcelRequire("60rvG");

var $gxL8Z = parcelRequire("gxL8Z");
class $5caa8f0c73d9801e$export$d4826db40d47595b extends (0, $gxL8Z.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $2JuHM.pipe)((0, $60rvG.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $60rvG.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});

parcelRegister("joD7v", function(module, exports) {

$parcel$export(module.exports, "PressGesture", () => $5556f974238648c2$export$f026abdbba7f0c9e);

var $bzAli = parcelRequire("bzAli");
var $kDvN3 = parcelRequire("kDvN3");

var $37KA2 = parcelRequire("37KA2");

var $gxL8Z = parcelRequire("gxL8Z");
function $5556f974238648c2$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $bzAli.frame).postRender(()=>callback(event, (0, $37KA2.extractEventInfo)(event)));
}
class $5556f974238648c2$export$f026abdbba7f0c9e extends (0, $gxL8Z.Feature) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $kDvN3.press)(current, (_element, startEvent)=>{
            $5556f974238648c2$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$5556f974238648c2$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}

});
parcelRegister("kDvN3", function(module, exports) {

$parcel$export(module.exports, "press", () => $187468505c7970dc$export$dbe9198142dace0c);

var $6tfTi = parcelRequire("6tfTi");

var $18DnX = parcelRequire("18DnX");

var $lugEG = parcelRequire("lugEG");

var $ciW7E = parcelRequire("ciW7E");

var $aR8ut = parcelRequire("aR8ut");

var $dvuUo = parcelRequire("dvuUo");

var $1AsgN = parcelRequire("1AsgN");

var $1Bzpt = parcelRequire("1Bzpt");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $187468505c7970dc$var$isValidPressEvent(event) {
    return (0, $ciW7E.isPrimaryPointer)(event) && !(0, $18DnX.isDragActive)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $187468505c7970dc$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $aR8ut.setupGesture)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$187468505c7970dc$var$isValidPressEvent(startEvent)) return;
        (0, $1Bzpt.isPressing).add(target);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $1Bzpt.isPressing).has(target)) (0, $1Bzpt.isPressing).delete(target);
            if (!$187468505c7970dc$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $lugEG.isNodeOrChild)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $6tfTi.isHTMLElement)(target)) {
            target.addEventListener("focus", (event)=>(0, $1AsgN.enableKeyboardPress)(event, eventOptions));
            if (!(0, $dvuUo.isElementKeyboardAccessible)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}

});
parcelRegister("lugEG", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", () => $95c884471a1aa926$export$e841ada32ff745b);
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $95c884471a1aa926$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $95c884471a1aa926$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("dvuUo", function(module, exports) {

$parcel$export(module.exports, "isElementKeyboardAccessible", () => $78418ac292381082$export$5f6976e2f961e8b7);
const $78418ac292381082$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $78418ac292381082$export$5f6976e2f961e8b7(element) {
    return $78418ac292381082$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}

});

parcelRegister("1AsgN", function(module, exports) {

$parcel$export(module.exports, "enableKeyboardPress", () => $4b5cba50c68c84db$export$4b5790288fe12a79);

var $1Bzpt = parcelRequire("1Bzpt");
/**
 * Filter out events that are not "Enter" keys.
 */ function $4b5cba50c68c84db$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $4b5cba50c68c84db$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $4b5cba50c68c84db$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $4b5cba50c68c84db$var$filterEvents(()=>{
        if ((0, $1Bzpt.isPressing).has(element)) return;
        $4b5cba50c68c84db$var$firePointerEvent(element, "down");
        const handleKeyup = $4b5cba50c68c84db$var$filterEvents(()=>{
            $4b5cba50c68c84db$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$4b5cba50c68c84db$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};

});
parcelRegister("1Bzpt", function(module, exports) {

$parcel$export(module.exports, "isPressing", () => $61df5cd19ca35739$export$7987404a4e35b84b);
const $61df5cd19ca35739$export$7987404a4e35b84b = new WeakSet();

});




parcelRegister("044xt", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", () => $9790f53ad8321f10$export$150851c8cc2f0c72);

var $gxL8Z = parcelRequire("gxL8Z");

var $92kCA = parcelRequire("92kCA");
const $9790f53ad8321f10$var$thresholdNames = {
    some: 0,
    all: 1
};
class $9790f53ad8321f10$export$150851c8cc2f0c72 extends (0, $gxL8Z.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $9790f53ad8321f10$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $92kCA.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($9790f53ad8321f10$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $9790f53ad8321f10$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("92kCA", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", () => $99912f3e5aab1a69$export$b2bcd62fb7925aa5);
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $99912f3e5aab1a69$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $99912f3e5aab1a69$var$observers = new WeakMap();
const $99912f3e5aab1a69$var$fireObserverCallback = (entry)=>{
    const callback = $99912f3e5aab1a69$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $99912f3e5aab1a69$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($99912f3e5aab1a69$var$fireObserverCallback);
};
function $99912f3e5aab1a69$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$99912f3e5aab1a69$var$observers.has(lookupRoot)) $99912f3e5aab1a69$var$observers.set(lookupRoot, {});
    const rootObservers = $99912f3e5aab1a69$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($99912f3e5aab1a69$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $99912f3e5aab1a69$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $99912f3e5aab1a69$var$initIntersectionObserver(options);
    $99912f3e5aab1a69$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $99912f3e5aab1a69$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("4IlWL", function(module, exports) {

$parcel$export(module.exports, "layout", () => $c7aa46a04edf1ac2$export$b3219800bda33a1f);

var $hbSpb = parcelRequire("hbSpb");

var $5wiiV = parcelRequire("5wiiV");
const $c7aa46a04edf1ac2$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $hbSpb.HTMLProjectionNode),
        MeasureLayout: $5wiiV.MeasureLayout
    }
};

});

parcelRegister("awPQy", function(module, exports) {

$parcel$export(module.exports, "createMotionComponentFactory", () => $29ca0d22bdf0d6dd$export$d86feac869a7f0d5);

var $c1Iuf = parcelRequire("c1Iuf");

var $luc8y = parcelRequire("luc8y");

var $wRZvN = parcelRequire("wRZvN");

var $gweoJ = parcelRequire("gweoJ");

var $dSpNY = parcelRequire("dSpNY");
function $29ca0d22bdf0d6dd$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $wRZvN.isSVGComponent)(Component) ? (0, $dSpNY.svgMotionConfig) : (0, $gweoJ.htmlMotionConfig);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $luc8y.createUseRender)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $c1Iuf.createRendererMotionComponent)(config);
    };
}

});
parcelRegister("c1Iuf", function(module, exports) {

$parcel$export(module.exports, "createRendererMotionComponent", () => $b030745d33f27814$export$c3ad4a902bccc2d8);

var $1IdZj = parcelRequire("1IdZj");


var $8NFma = parcelRequire("8NFma");

var $6YAnm = parcelRequire("6YAnm");

var $aLg4x = parcelRequire("aLg4x");

var $7FsYG = parcelRequire("7FsYG");

var $j3A1f = parcelRequire("j3A1f");

var $66cqe = parcelRequire("66cqe");

var $7w33i = parcelRequire("7w33i");

var $5Pl1y = parcelRequire("5Pl1y");

var $bK6hP = parcelRequire("bK6hP");

var $d1BBv = parcelRequire("d1BBv");

var $7Qe4k = parcelRequire("7Qe4k");

var $23EE4 = parcelRequire("23EE4");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b030745d33f27814$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $bK6hP.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $8NFma.useContext)((0, $7FsYG.MotionConfigContext)),
            ...props,
            layoutId: $b030745d33f27814$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $66cqe.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $7w33i.isBrowser)) {
            $b030745d33f27814$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $b030745d33f27814$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $23EE4.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $1IdZj.jsxs)((0, $j3A1f.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $1IdZj.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $7Qe4k.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $8NFma.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $d1BBv.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function $b030745d33f27814$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $8NFma.useContext)((0, $6YAnm.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $b030745d33f27814$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $8NFma.useContext)((0, $aLg4x.LazyContext)).strict;
}
function $b030745d33f27814$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $5Pl1y.featureDefinitions);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("aLg4x", function(module, exports) {

$parcel$export(module.exports, "LazyContext", () => $2daff1e8821a69a8$export$40f10139ecf1f171);

var $8NFma = parcelRequire("8NFma");
"use client";
const $2daff1e8821a69a8$export$40f10139ecf1f171 = (0, $8NFma.createContext)({
    strict: false
});

});

parcelRegister("j3A1f", function(module, exports) {

$parcel$export(module.exports, "MotionContext", () => $20f5839e8a8fdec7$export$2285bbca2c666415);

var $8NFma = parcelRequire("8NFma");
"use client";
const $20f5839e8a8fdec7$export$2285bbca2c666415 = /* @__PURE__ */ (0, $8NFma.createContext)({});

});

parcelRegister("66cqe", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", () => $ea51fe08d092c5c0$export$c5638d843b37a176);

var $8NFma = parcelRequire("8NFma");

var $j3A1f = parcelRequire("j3A1f");

var $7k8LX = parcelRequire("7k8LX");
function $ea51fe08d092c5c0$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $7k8LX.getCurrentTreeVariants)(props, (0, $8NFma.useContext)((0, $j3A1f.MotionContext)));
    return (0, $8NFma.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $ea51fe08d092c5c0$var$variantLabelsAsDependency(initial),
        $ea51fe08d092c5c0$var$variantLabelsAsDependency(animate)
    ]);
}
function $ea51fe08d092c5c0$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("7k8LX", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", () => $f03cfc3290c8ceca$export$12fc32fc096a04a3);

var $kXVxi = parcelRequire("kXVxi");

var $cMzxg = parcelRequire("cMzxg");
function $f03cfc3290c8ceca$export$12fc32fc096a04a3(props, context) {
    if ((0, $kXVxi.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $cMzxg.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $cMzxg.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("kXVxi", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", () => $c4d8b2907c7e2211$export$4b3c3bd8d910d78d);
$parcel$export(module.exports, "isVariantNode", () => $c4d8b2907c7e2211$export$ce46fa4165cdec40);

var $2SKYt = parcelRequire("2SKYt");

var $cMzxg = parcelRequire("cMzxg");

var $jtjtW = parcelRequire("jtjtW");
function $c4d8b2907c7e2211$export$4b3c3bd8d910d78d(props) {
    return (0, $2SKYt.isAnimationControls)(props.animate) || (0, $jtjtW.variantProps).some((name)=>(0, $cMzxg.isVariantLabel)(props[name]));
}
function $c4d8b2907c7e2211$export$ce46fa4165cdec40(props) {
    return Boolean($c4d8b2907c7e2211$export$4b3c3bd8d910d78d(props) || props.variants);
}

});



parcelRegister("5Pl1y", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", () => $1de64697b9c13d22$export$65570e08d843624d);
const $1de64697b9c13d22$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $1de64697b9c13d22$export$65570e08d843624d = {};
for(const key in $1de64697b9c13d22$var$featureProps)$1de64697b9c13d22$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$1de64697b9c13d22$var$featureProps[key].some((name)=>!!props[name])
};

});

parcelRegister("bK6hP", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", () => $e5f1eff7aac7b1de$export$449561ec5703cdc8);

var $5Pl1y = parcelRequire("5Pl1y");
function $e5f1eff7aac7b1de$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $5Pl1y.featureDefinitions)[key] = {
        ...(0, $5Pl1y.featureDefinitions)[key],
        ...features[key]
    };
}

});

parcelRegister("d1BBv", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", () => $cf3232b9adf9ae28$export$28e2e4cce424ae23);
const $cf3232b9adf9ae28$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});

parcelRegister("7Qe4k", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", () => $b1d7322931054921$export$c684914703d321fd);

var $8NFma = parcelRequire("8NFma");

var $bIQoU = parcelRequire("bIQoU");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $b1d7322931054921$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $8NFma.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $bIQoU.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});

parcelRegister("23EE4", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", () => $adc9e136d997800d$export$dc0335d73ab0b115);

var $bCXOT = parcelRequire("bCXOT");

var $8NFma = parcelRequire("8NFma");

var $8BQBc = parcelRequire("8BQBc");

var $aLg4x = parcelRequire("aLg4x");

var $7FsYG = parcelRequire("7FsYG");

var $j3A1f = parcelRequire("j3A1f");

var $9aVsA = parcelRequire("9aVsA");

var $7reOm = parcelRequire("7reOm");

var $bIQoU = parcelRequire("bIQoU");

var $8bI58 = parcelRequire("8bI58");
function $adc9e136d997800d$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $8NFma.useContext)((0, $j3A1f.MotionContext));
    const lazyContext = (0, $8NFma.useContext)((0, $aLg4x.LazyContext));
    const presenceContext = (0, $8NFma.useContext)((0, $9aVsA.PresenceContext));
    const reducedMotionConfig = (0, $8NFma.useContext)((0, $7FsYG.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $8NFma.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $8NFma.useContext)((0, $7reOm.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $adc9e136d997800d$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $8NFma.useRef)(false);
    (0, $8NFma.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $8BQBc.optimizedAppearDataAttribute];
    const wantsHandoff = (0, $8NFma.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $8bI58.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $bCXOT.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $8NFma.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $adc9e136d997800d$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $adc9e136d997800d$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $bIQoU.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $adc9e136d997800d$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $adc9e136d997800d$var$getClosestProjectingNode(visualElement.parent);
}

});


parcelRegister("luc8y", function(module, exports) {

$parcel$export(module.exports, "createUseRender", () => $c0267186899211ef$export$5d29104eefd89cc8);

var $6CK3q = parcelRequire("6CK3q");

var $8NFma = parcelRequire("8NFma");

var $dUsK4 = parcelRequire("dUsK4");

var $2Vnkx = parcelRequire("2Vnkx");

var $1byLT = parcelRequire("1byLT");

var $wRZvN = parcelRequire("wRZvN");
function $c0267186899211ef$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $wRZvN.isSVGComponent)(Component) ? (0, $2Vnkx.useSVGProps) : (0, $dUsK4.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $1byLT.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $8NFma.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $8NFma.useMemo)(()=>(0, $6CK3q.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $8NFma.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("dUsK4", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", () => $e15a7ed64fbc9390$export$40dafdb8630c956b);
$parcel$export(module.exports, "useHTMLProps", () => $e15a7ed64fbc9390$export$57be0a314572d87d);

var $6CK3q = parcelRequire("6CK3q");

var $8NFma = parcelRequire("8NFma");

var $26jxu = parcelRequire("26jxu");

var $5h20I = parcelRequire("5h20I");

var $lpGZ1 = parcelRequire("lpGZ1");
function $e15a7ed64fbc9390$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $6CK3q.isMotionValue)(source[key]) && !(0, $26jxu.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $e15a7ed64fbc9390$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $8NFma.useMemo)(()=>{
        const state = (0, $lpGZ1.createHtmlRenderState)();
        (0, $5h20I.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $e15a7ed64fbc9390$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $e15a7ed64fbc9390$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $e15a7ed64fbc9390$var$useInitialMotionValues(props, visualState));
    return style;
}
function $e15a7ed64fbc9390$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $e15a7ed64fbc9390$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("26jxu", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", () => $74fcf1b780d3e5e5$export$6d27ce8e3de1c3cf);

var $eMYQu = parcelRequire("eMYQu");

var $hBDfc = parcelRequire("hBDfc");
function $74fcf1b780d3e5e5$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $eMYQu.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $hBDfc.scaleCorrectors)[key] || key === "opacity");
}

});

parcelRegister("5h20I", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", () => $6bc0775b95155db5$export$bb517f8b40f8e99d);

var $eZeLY = parcelRequire("eZeLY");
var $kNVWS = parcelRequire("kNVWS");
var $2ceRz = parcelRequire("2ceRz");
var $eMYQu = parcelRequire("eMYQu");

var $dBSrE = parcelRequire("dBSrE");
function $6bc0775b95155db5$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $eMYQu.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $kNVWS.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $eZeLY.getValueAsType)(value, (0, $2ceRz.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $dBSrE.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("eZeLY", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", () => $552ec46be89a16e3$export$453ef540a9a1bd6b);
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $552ec46be89a16e3$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("2ceRz", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", () => $59cd075feec63394$export$eec14432cd1cb67b);

var $cyWfL = parcelRequire("cyWfL");

var $6WRjq = parcelRequire("6WRjq");

var $aNIli = parcelRequire("aNIli");

var $by3Hj = parcelRequire("by3Hj");
const $59cd075feec63394$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $aNIli.px),
    borderTopWidth: (0, $aNIli.px),
    borderRightWidth: (0, $aNIli.px),
    borderBottomWidth: (0, $aNIli.px),
    borderLeftWidth: (0, $aNIli.px),
    borderRadius: (0, $aNIli.px),
    radius: (0, $aNIli.px),
    borderTopLeftRadius: (0, $aNIli.px),
    borderTopRightRadius: (0, $aNIli.px),
    borderBottomRightRadius: (0, $aNIli.px),
    borderBottomLeftRadius: (0, $aNIli.px),
    // Positioning props
    width: (0, $aNIli.px),
    maxWidth: (0, $aNIli.px),
    height: (0, $aNIli.px),
    maxHeight: (0, $aNIli.px),
    top: (0, $aNIli.px),
    right: (0, $aNIli.px),
    bottom: (0, $aNIli.px),
    left: (0, $aNIli.px),
    // Spacing props
    padding: (0, $aNIli.px),
    paddingTop: (0, $aNIli.px),
    paddingRight: (0, $aNIli.px),
    paddingBottom: (0, $aNIli.px),
    paddingLeft: (0, $aNIli.px),
    margin: (0, $aNIli.px),
    marginTop: (0, $aNIli.px),
    marginRight: (0, $aNIli.px),
    marginBottom: (0, $aNIli.px),
    marginLeft: (0, $aNIli.px),
    // Misc
    backgroundPositionX: (0, $aNIli.px),
    backgroundPositionY: (0, $aNIli.px),
    ...(0, $by3Hj.transformValueTypes),
    zIndex: (0, $cyWfL.int),
    // SVG
    fillOpacity: (0, $6WRjq.alpha),
    strokeOpacity: (0, $6WRjq.alpha),
    numOctaves: (0, $cyWfL.int)
};

});
parcelRegister("cyWfL", function(module, exports) {

$parcel$export(module.exports, "int", () => $df5430cde83fbc1e$export$7d260a2a5f8bc19e);

var $6WRjq = parcelRequire("6WRjq");
const $df5430cde83fbc1e$export$7d260a2a5f8bc19e = {
    ...(0, $6WRjq.number),
    transform: Math.round
};

});

parcelRegister("by3Hj", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", () => $0c954a5d6bca9a88$export$f2e4285fee37e26);

var $6WRjq = parcelRequire("6WRjq");

var $aNIli = parcelRequire("aNIli");
const $0c954a5d6bca9a88$export$f2e4285fee37e26 = {
    rotate: (0, $aNIli.degrees),
    rotateX: (0, $aNIli.degrees),
    rotateY: (0, $aNIli.degrees),
    rotateZ: (0, $aNIli.degrees),
    scale: $6WRjq.scale,
    scaleX: (0, $6WRjq.scale),
    scaleY: (0, $6WRjq.scale),
    scaleZ: (0, $6WRjq.scale),
    skew: (0, $aNIli.degrees),
    skewX: (0, $aNIli.degrees),
    skewY: (0, $aNIli.degrees),
    distance: (0, $aNIli.px),
    translateX: (0, $aNIli.px),
    translateY: (0, $aNIli.px),
    translateZ: (0, $aNIli.px),
    x: (0, $aNIli.px),
    y: (0, $aNIli.px),
    z: (0, $aNIli.px),
    perspective: (0, $aNIli.px),
    transformPerspective: (0, $aNIli.px),
    opacity: (0, $6WRjq.alpha),
    originX: (0, $aNIli.progressPercentage),
    originY: (0, $aNIli.progressPercentage),
    originZ: (0, $aNIli.px)
};

});


parcelRegister("dBSrE", function(module, exports) {

$parcel$export(module.exports, "buildTransform", () => $59c1bcec37ba2c70$export$bdc96e0d5c8f914);

var $eZeLY = parcelRequire("eZeLY");
var $2ceRz = parcelRequire("2ceRz");
var $eMYQu = parcelRequire("eMYQu");
const $59c1bcec37ba2c70$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $59c1bcec37ba2c70$var$numTransforms = (0, $eMYQu.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $59c1bcec37ba2c70$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $59c1bcec37ba2c70$var$numTransforms; i++){
        const key = (0, $eMYQu.transformPropOrder)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $eZeLY.getValueAsType)(value, (0, $2ceRz.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $59c1bcec37ba2c70$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});


parcelRegister("lpGZ1", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", () => $b45a42e9d7efaf7b$export$8940b483cf52eeda);
const $b45a42e9d7efaf7b$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("2Vnkx", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", () => $baa01a4f8aa0844b$export$84309c4f53cb1bd5);

var $8NFma = parcelRequire("8NFma");

var $dUsK4 = parcelRequire("dUsK4");

var $i89HX = parcelRequire("i89HX");

var $a34fI = parcelRequire("a34fI");

var $7zCsv = parcelRequire("7zCsv");
function $baa01a4f8aa0844b$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $8NFma.useMemo)(()=>{
        const state = (0, $a34fI.createSvgRenderState)();
        (0, $i89HX.buildSVGAttrs)(state, visualState, (0, $7zCsv.isSVGTag)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $dUsK4.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});
parcelRegister("i89HX", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", () => $77100f389af05a7f$export$5475d24f125d7053);

var $5h20I = parcelRequire("5h20I");

var $U4315 = parcelRequire("U4315");
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $77100f389af05a7f$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $5h20I.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $U4315.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("U4315", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", () => $357af48cffdf5537$export$311b43f666da1d82);

var $aNIli = parcelRequire("aNIli");
const $357af48cffdf5537$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $357af48cffdf5537$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $357af48cffdf5537$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $357af48cffdf5537$var$dashKeys : $357af48cffdf5537$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $aNIli.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $aNIli.px).transform(length);
    const pathSpacing = (0, $aNIli.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});


parcelRegister("a34fI", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", () => $69b21dad9904e665$export$41be8b43e1c4d4f9);

var $lpGZ1 = parcelRequire("lpGZ1");
const $69b21dad9904e665$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $lpGZ1.createHtmlRenderState)(),
        attrs: {}
    });

});

parcelRegister("7zCsv", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", () => $8009848b0f810604$export$6328ce7565ea1049);
const $8009848b0f810604$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});


parcelRegister("1byLT", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $29f44e7c8bd84b95$export$d697c39a2985a4c);

var $Knp2Y = parcelRequire("Knp2Y");
let $29f44e7c8bd84b95$var$shouldForward = (key)=>!(0, $Knp2Y.isValidMotionProp)(key);
function $29f44e7c8bd84b95$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $29f44e7c8bd84b95$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $Knp2Y.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $29f44e7c8bd84b95$export$59d6962c470509a5($29f44e7c8bd84b95$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $29f44e7c8bd84b95$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($29f44e7c8bd84b95$var$shouldForward(key) || forwardMotionProps === true && (0, $Knp2Y.isValidMotionProp)(key) || !isDom && !(0, $Knp2Y.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("Knp2Y", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", () => $0c69aec9fa176b7f$export$2f9c46555243bf04);
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $0c69aec9fa176b7f$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $0c69aec9fa176b7f$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $0c69aec9fa176b7f$var$validMotionProps.has(key);
}

});


parcelRegister("wRZvN", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", () => $b4d5c6204542c379$export$88f3fc2fd3766989);

var $9Xkn9 = parcelRequire("9Xkn9");
function $b4d5c6204542c379$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $9Xkn9.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("9Xkn9", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", () => $621959f3cde31010$export$40209c4c512158e6);
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $621959f3cde31010$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});



parcelRegister("gweoJ", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", () => $d73a5be063e18faa$export$e13ea21d87ea57c8);

var $9HJjb = parcelRequire("9HJjb");

var $5mvrY = parcelRequire("5mvrY");

var $lpGZ1 = parcelRequire("lpGZ1");
const $d73a5be063e18faa$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $9HJjb.makeUseVisualState)({
        scrapeMotionValuesFromProps: $5mvrY.scrapeMotionValuesFromProps,
        createRenderState: (0, $lpGZ1.createHtmlRenderState)
    })
};

});
parcelRegister("9HJjb", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", () => $e6af9f64d654eb7a$export$e91e107bc6d03a8e);

var $8NFma = parcelRequire("8NFma");

var $2SKYt = parcelRequire("2SKYt");

var $j3A1f = parcelRequire("j3A1f");

var $9aVsA = parcelRequire("9aVsA");

var $kXVxi = parcelRequire("kXVxi");

var $6ZXou = parcelRequire("6ZXou");

var $3PZo3 = parcelRequire("3PZo3");

var $PGdMd = parcelRequire("PGdMd");
function $e6af9f64d654eb7a$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $e6af9f64d654eb7a$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
const $e6af9f64d654eb7a$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $8NFma.useContext)((0, $j3A1f.MotionContext));
        const presenceContext = (0, $8NFma.useContext)((0, $9aVsA.PresenceContext));
        const make = ()=>$e6af9f64d654eb7a$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $3PZo3.useConstant)(make);
    };
function $e6af9f64d654eb7a$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $PGdMd.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $kXVxi.isControllingVariants)(props);
    const isVariantNode$1 = (0, $kXVxi.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $2SKYt.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $6ZXou.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}

});

parcelRegister("5mvrY", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $37e7cb925f50d74f$export$16da615486abaa45);

var $6CK3q = parcelRequire("6CK3q");

var $26jxu = parcelRequire("26jxu");
function $37e7cb925f50d74f$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $6CK3q.isMotionValue)(style[key]) || prevProps.style && (0, $6CK3q.isMotionValue)(prevProps.style[key]) || (0, $26jxu.isForcedMotionValue)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}

});


parcelRegister("dSpNY", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", () => $32ca9efa885ee4b2$export$44dabd3fae512e85);

var $9HJjb = parcelRequire("9HJjb");

var $a34fI = parcelRequire("a34fI");

var $9X0yy = parcelRequire("9X0yy");
const $32ca9efa885ee4b2$export$44dabd3fae512e85 = {
    useVisualState: (0, $9HJjb.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $9X0yy.scrapeMotionValuesFromProps),
        createRenderState: (0, $a34fI.createSvgRenderState)
    })
};

});
parcelRegister("9X0yy", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $f15ca6b0d702ad3b$export$16da615486abaa45);

var $6CK3q = parcelRequire("6CK3q");
var $eMYQu = parcelRequire("eMYQu");

var $5mvrY = parcelRequire("5mvrY");
function $f15ca6b0d702ad3b$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $5mvrY.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $6CK3q.isMotionValue)(props[key]) || (0, $6CK3q.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $eMYQu.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});



parcelRegister("51CsC", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", () => $8768dd14613ace7f$export$56ba0183203348f5);

var $8NFma = parcelRequire("8NFma");

var $1WlXn = parcelRequire("1WlXn");

var $6sWxI = parcelRequire("6sWxI");

var $wRZvN = parcelRequire("wRZvN");
const $8768dd14613ace7f$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $wRZvN.isSVGComponent)(Component) ? new (0, $6sWxI.SVGVisualElement)(options) : new (0, $1WlXn.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $8NFma.Fragment)
    });
};

});
parcelRegister("1WlXn", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", () => $af8cdffc0038eea1$export$23fea75b03ac16b3);

var $2YzSk = parcelRequire("2YzSk");
var $kNVWS = parcelRequire("kNVWS");
var $eMYQu = parcelRequire("eMYQu");

var $a0L4N = parcelRequire("a0L4N");

var $cN4oi = parcelRequire("cN4oi");

var $5h20I = parcelRequire("5h20I");

var $d39Z6 = parcelRequire("d39Z6");

var $5mvrY = parcelRequire("5mvrY");
function $af8cdffc0038eea1$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $af8cdffc0038eea1$export$23fea75b03ac16b3 extends (0, $cN4oi.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $d39Z6.renderHTML);
    }
    readValueFromInstance(instance, key) {
        if ((0, $eMYQu.transformProps).has(key)) return this.projection?.isProjecting ? (0, $2YzSk.defaultTransformValue)(key) : (0, $2YzSk.readTransformValue)(instance, key);
        else {
            const computedStyle = $af8cdffc0038eea1$export$3735103072e4a80(instance);
            const value = ((0, $kNVWS.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $a0L4N.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $5h20I.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $5mvrY.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
}

});
parcelRegister("cN4oi", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", () => $8d813535283727b2$export$e49735c2a366bdc7);

var $dsxPZ = parcelRequire("dsxPZ");
var $6CK3q = parcelRequire("6CK3q");

var $kHDRH = parcelRequire("kHDRH");
class $8d813535283727b2$export$e49735c2a366bdc7 extends (0, $kHDRH.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $dsxPZ.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $6CK3q.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}

});
parcelRegister("dsxPZ", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", () => $b4404ca67d022b4a$export$4983792d11b61017);

var $dkBwo = parcelRequire("dkBwo");

var $b8quH = parcelRequire("b8quH");

var $aQw6x = parcelRequire("aQw6x");

var $kNVWS = parcelRequire("kNVWS");

var $2Skvh = parcelRequire("2Skvh");

var $cFv4P = parcelRequire("cFv4P");

var $cTJ64 = parcelRequire("cTJ64");

var $342FB = parcelRequire("342FB");
class $b4404ca67d022b4a$export$4983792d11b61017 extends (0, $2Skvh.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $kNVWS.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $aQw6x.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $dkBwo.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $b8quH.findDimensionValueType)(origin);
        const targetType = (0, $b8quH.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $342FB.isNumOrPxType)(originType) && (0, $342FB.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $342FB.positionalValues)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $cFv4P.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $cTJ64.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $342FB.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $342FB.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("b8quH", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", () => $c515664ffd709e59$export$d176691c1998a1f5);
$parcel$export(module.exports, "findDimensionValueType", () => $c515664ffd709e59$export$eefdd52e3ccae428);

var $3lm78 = parcelRequire("3lm78");

var $6WRjq = parcelRequire("6WRjq");

var $aNIli = parcelRequire("aNIli");

var $2yIuQ = parcelRequire("2yIuQ");
/**
 * A list of value types commonly used for dimensions
 */ const $c515664ffd709e59$export$d176691c1998a1f5 = [
    (0, $6WRjq.number),
    (0, $aNIli.px),
    (0, $aNIli.percent),
    (0, $aNIli.degrees),
    (0, $aNIli.vw),
    (0, $aNIli.vh),
    (0, $3lm78.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $c515664ffd709e59$export$eefdd52e3ccae428 = (v)=>$c515664ffd709e59$export$d176691c1998a1f5.find((0, $2yIuQ.testValueType)(v));

});
parcelRegister("3lm78", function(module, exports) {

$parcel$export(module.exports, "auto", () => $e4c2f4e48c31b465$export$dfb5619354ba860);
/**
 * ValueType for "auto"
 */ const $e4c2f4e48c31b465$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});

parcelRegister("2yIuQ", function(module, exports) {

$parcel$export(module.exports, "testValueType", () => $1084a6e29f4f7596$export$6eae4d0a6a7ca7cd);
/**
 * Tests a provided value against a ValueType
 */ const $1084a6e29f4f7596$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});


parcelRegister("aQw6x", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", () => $b52c76e1f919f8f6$export$289398774300c991);

var $4S7XB = parcelRequire("4S7XB");
var $8oXEF = parcelRequire("8oXEF");

var $kNVWS = parcelRequire("kNVWS");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $b52c76e1f919f8f6$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $b52c76e1f919f8f6$export$b9f0c1f373aee2b0(current) {
    const match = $b52c76e1f919f8f6$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $b52c76e1f919f8f6$var$maxDepth = 4;
function $b52c76e1f919f8f6$export$289398774300c991(current, element, depth = 1) {
    (0, $4S7XB.invariant)(depth <= $b52c76e1f919f8f6$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $b52c76e1f919f8f6$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $8oXEF.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $kNVWS.isCSSVariableToken)(fallback) ? $b52c76e1f919f8f6$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("8oXEF", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", () => $b533f6b963f6e7a6$export$65583ed5a868f2d9);
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $b533f6b963f6e7a6$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});


parcelRegister("cFv4P", function(module, exports) {

$parcel$export(module.exports, "isNone", () => $24c2b699d131e87c$export$e56af863d5645d5f);

var $lTcaa = parcelRequire("lTcaa");
function $24c2b699d131e87c$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $lTcaa.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("lTcaa", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", () => $0cba81213d9f2142$export$ade84c85e44a6cb1);
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $0cba81213d9f2142$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("cTJ64", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", () => $a424f545076d11c6$export$8cc4958f8e540f37);

var $1bx7b = parcelRequire("1bx7b");

var $8g9fn = parcelRequire("8g9fn");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $a424f545076d11c6$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $a424f545076d11c6$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$a424f545076d11c6$var$invalidTemplates.has(keyframe) && (0, $1bx7b.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $8g9fn.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("8g9fn", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", () => $069152206af72b8f$export$cea0cedcb94873b5);

var $1bx7b = parcelRequire("1bx7b");

var $awUNJ = parcelRequire("awUNJ");

var $7jYua = parcelRequire("7jYua");
function $069152206af72b8f$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $7jYua.getDefaultValueType)(key);
    if (defaultValueType !== (0, $awUNJ.filter)) defaultValueType = (0, $1bx7b.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("awUNJ", function(module, exports) {

$parcel$export(module.exports, "filter", () => $06cf3fa8422ba3d8$export$3dea766d36a8935f);

var $1bx7b = parcelRequire("1bx7b");

var $68wnR = parcelRequire("68wnR");
/**
 * Properties that should default to 1 or 100%
 */ const $06cf3fa8422ba3d8$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $06cf3fa8422ba3d8$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $68wnR.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $06cf3fa8422ba3d8$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $06cf3fa8422ba3d8$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $06cf3fa8422ba3d8$export$3dea766d36a8935f = {
    ...(0, $1bx7b.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($06cf3fa8422ba3d8$var$functionRegex);
        return functions ? functions.map($06cf3fa8422ba3d8$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("7jYua", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", () => $7501c776faa8a8e6$export$67d1babe0338d23b);

var $37kkY = parcelRequire("37kkY");

var $awUNJ = parcelRequire("awUNJ");

var $2ceRz = parcelRequire("2ceRz");
/**
 * A map of default value types for common values
 */ const $7501c776faa8a8e6$export$98cd7c72c5a731fb = {
    ...(0, $2ceRz.numberValueTypes),
    color: // Color props
    $37kkY.color,
    backgroundColor: (0, $37kkY.color),
    outlineColor: (0, $37kkY.color),
    fill: (0, $37kkY.color),
    stroke: (0, $37kkY.color),
    // Border props
    borderColor: (0, $37kkY.color),
    borderTopColor: (0, $37kkY.color),
    borderRightColor: (0, $37kkY.color),
    borderBottomColor: (0, $37kkY.color),
    borderLeftColor: (0, $37kkY.color),
    filter: $awUNJ.filter,
    WebkitFilter: (0, $awUNJ.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $7501c776faa8a8e6$export$67d1babe0338d23b = (key)=>$7501c776faa8a8e6$export$98cd7c72c5a731fb[key];

});




parcelRegister("kHDRH", function(module, exports) {

$parcel$export(module.exports, "VisualElement", () => $3384b7423e0343f2$export$fa8b653c0f3714e5);

var $bzAli = parcelRequire("bzAli");
var $1bx7b = parcelRequire("1bx7b");
var $gfouB = parcelRequire("gfouB");
var $8g9fn = parcelRequire("8g9fn");
var $6CK3q = parcelRequire("6CK3q");
var $2Skvh = parcelRequire("2Skvh");
var $9YfCx = parcelRequire("9YfCx");
var $aNJ8y = parcelRequire("aNJ8y");
var $eMYQu = parcelRequire("eMYQu");

var $8oXEF = parcelRequire("8oXEF");
var $lTcaa = parcelRequire("lTcaa");
var $7RKvH = parcelRequire("7RKvH");

var $5Pl1y = parcelRequire("5Pl1y");

var $dTuEZ = parcelRequire("dTuEZ");

var $bakxJ = parcelRequire("bakxJ");

var $3wTp2 = parcelRequire("3wTp2");

var $2CogQ = parcelRequire("2CogQ");

var $kXVxi = parcelRequire("kXVxi");

var $1NOez = parcelRequire("1NOez");

var $6ZXou = parcelRequire("6ZXou");
const $3384b7423e0343f2$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $3384b7423e0343f2$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $2Skvh.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $aNJ8y.time).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $bzAli.frame).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $kXVxi.isControllingVariants)(props);
        this.isVariantNode = (0, $kXVxi.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $6CK3q.isMotionValue)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $2CogQ.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $3wTp2.hasReducedMotionListener).current) (0, $bakxJ.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $3wTp2.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $bzAli.cancelFrame)(this.notifyUpdate);
        (0, $bzAli.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $eMYQu.transformProps).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $bzAli.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $5Pl1y.featureDefinitions){
            const featureDefinition = (0, $5Pl1y.featureDefinitions)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $dTuEZ.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $3384b7423e0343f2$var$propEventHandlers.length; i++){
            const key = $3384b7423e0343f2$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $1NOez.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $9YfCx.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $8oXEF.isNumericalString)(value) || (0, $lTcaa.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $gfouB.findValueType)(value) && (0, $1bx7b.complex).test(target)) value = (0, $8g9fn.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $6CK3q.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $6CK3q.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $6ZXou.resolveVariantFromProps)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $6CK3q.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $7RKvH.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

});
parcelRegister("gfouB", function(module, exports) {

$parcel$export(module.exports, "findValueType", () => $1b20b38e5ec4701a$export$950e7e59ea1ffed7);

var $37kkY = parcelRequire("37kkY");

var $1bx7b = parcelRequire("1bx7b");

var $b8quH = parcelRequire("b8quH");

var $2yIuQ = parcelRequire("2yIuQ");
/**
 * A list of all ValueTypes
 */ const $1b20b38e5ec4701a$var$valueTypes = [
    ...(0, $b8quH.dimensionValueTypes),
    (0, $37kkY.color),
    (0, $1bx7b.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $1b20b38e5ec4701a$export$950e7e59ea1ffed7 = (v)=>$1b20b38e5ec4701a$var$valueTypes.find((0, $2yIuQ.testValueType)(v));

});

parcelRegister("bakxJ", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", () => $9024eedbc479bf66$export$ca9f41fb23dded3d);

var $7w33i = parcelRequire("7w33i");

var $3wTp2 = parcelRequire("3wTp2");
function $9024eedbc479bf66$export$ca9f41fb23dded3d() {
    (0, $3wTp2.hasReducedMotionListener).current = true;
    if (!(0, $7w33i.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $3wTp2.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $3wTp2.prefersReducedMotion).current = false;
}

});
parcelRegister("3wTp2", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", () => $104f8e5b741c829f$export$ff7706047246b98b);
$parcel$export(module.exports, "hasReducedMotionListener", () => $104f8e5b741c829f$export$6476d16e2fd2d0db);
// Does this device prefer reduced motion? Returns `null` server-side.
const $104f8e5b741c829f$export$ff7706047246b98b = {
    current: null
};
const $104f8e5b741c829f$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("2CogQ", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", () => $c688d272006ace14$export$bc2a978a17abfdde);
const $c688d272006ace14$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("1NOez", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", () => $4723f7fe466525d9$export$9a552858d5197f6e);

var $6CK3q = parcelRequire("6CK3q");
var $9YfCx = parcelRequire("9YfCx");
function $4723f7fe466525d9$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $6CK3q.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $6CK3q.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $9YfCx.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $9YfCx.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});



parcelRegister("d39Z6", function(module, exports) {

$parcel$export(module.exports, "renderHTML", () => $4897080e77be3535$export$1a32bf6229c258c0);
function $4897080e77be3535$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});


parcelRegister("6sWxI", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", () => $ae5e3340965ae4ee$export$86bcdffbaf733d84);

var $7jYua = parcelRequire("7jYua");
var $eMYQu = parcelRequire("eMYQu");

var $dTuEZ = parcelRequire("dTuEZ");

var $cN4oi = parcelRequire("cN4oi");

var $cifjo = parcelRequire("cifjo");

var $i89HX = parcelRequire("i89HX");

var $foeWD = parcelRequire("foeWD");

var $7zCsv = parcelRequire("7zCsv");

var $itbGk = parcelRequire("itbGk");

var $9X0yy = parcelRequire("9X0yy");
class $ae5e3340965ae4ee$export$86bcdffbaf733d84 extends (0, $cN4oi.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $dTuEZ.createBox);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $eMYQu.transformProps).has(key)) {
            const defaultType = (0, $7jYua.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $foeWD.camelCaseAttributes).has(key) ? (0, $cifjo.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $9X0yy.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $i89HX.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $itbGk.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $7zCsv.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});
parcelRegister("foeWD", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", () => $03996e6affc7ae07$export$28931db5d57958e5);
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $03996e6affc7ae07$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("itbGk", function(module, exports) {

$parcel$export(module.exports, "renderSVG", () => $f4c34eeabc0a0368$export$c5f8399d19a7394b);

var $cifjo = parcelRequire("cifjo");

var $d39Z6 = parcelRequire("d39Z6");

var $foeWD = parcelRequire("foeWD");
function $f4c34eeabc0a0368$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $d39Z6.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $foeWD.camelCaseAttributes).has(key) ? (0, $cifjo.camelToDash)(key) : key, renderState.attrs[key]);
}

});






parcelRegister("3ZMdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e8c77798d05d31e$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $hcccs = parcelRequire("hcccs");
function $2e8c77798d05d31e$export$2e2bcd8739ae039({ children: children, fieldIsValid: fieldIsValid = ()=>true, getFieldErrorMessages: getFieldErrorMessages = ()=>[], label: label, name: name, onChange: onChange, required: required, type: type = 'text', value: value, visibleErrors: visibleErrors = false }) {
    const inputRef = (0, $8NFma.useRef)();
    (0, $8NFma.useEffect)(()=>{
        const input = inputRef.current;
        if (!input) return;
        const handleNativeInput = (e)=>onChange(e);
        input.addEventListener('change', handleNativeInput);
        return ()=>{
            input.removeEventListener('change', handleNativeInput);
        };
    }, []);
    const inputAttributes = {
        id: name,
        name: name,
        onChange: onChange,
        type: type,
        value: value,
        ref: inputRef
    };
    required && (inputAttributes.required = 'required');
    const formFieldClasses = [
        'form-field'
    ];
    if (value && fieldIsValid(name)) formFieldClasses.push('form-field--valid');
    else if (!fieldIsValid(name) && visibleErrors) formFieldClasses.push('form-field--error');
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "form-field-wrapper",
        "data-field-name": name,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: formFieldClasses.join(' '),
                "data-field-type": type,
                "data-field-name": name,
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        ...inputAttributes
                    }),
                    children
                ]
            }),
            visibleErrors && !fieldIsValid(name) && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $hcccs.default), {
                messages: getFieldErrorMessages(name)
            })
        ]
    });
}
$2e8c77798d05d31e$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node,
    fieldIsValid: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    getFieldErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    required: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    visibleErrors: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool
};

});
parcelRegister("hcccs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c84d05507ee67736$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $c84d05507ee67736$export$2e2bcd8739ae039({ messages: messages }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "form-field-errors",
        children: messages.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
            className: "form-field-error",
            children: messages[0]
        })
    });
}
$c84d05507ee67736$export$2e2bcd8739ae039.propTypes = {
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string).isRequired
};

});


parcelRegister("5xIc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $409250eee734b324$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $409250eee734b324$export$2e2bcd8739ae039({ callback: callback, checked: checked = false, id: id, label: label, name: name, testId: testId = '', value: value }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "form-field",
        "data-field-type": "radio",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "form-binary-input",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                    type: "radio",
                    name: name,
                    id: id,
                    value: value,
                    onChange: callback,
                    checked: checked,
                    "data-testid": testId
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                    htmlFor: id,
                    children: label
                })
            ]
        })
    });
}
$409250eee734b324$export$2e2bcd8739ae039.propTypes = {
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    testId: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired
};

});

parcelRegister("b3BVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $80cd657e60100099$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $80cd657e60100099$export$2e2bcd8739ae039({ label: label, onChange: onChange, options: options, testId: testId = '', value: value }) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "form-field",
        "data-field-type": "select",
        children: [
            label ? /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                children: label
            }) : null,
            /*#__PURE__*/ (0, $1IdZj.jsx)("select", {
                value: value,
                onChange: onChange,
                "data-testid": testId,
                children: options.map((option, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                        value: option.value,
                        children: option.label
                    }, index))
            })
        ]
    });
}
$80cd657e60100099$export$2e2bcd8739ae039.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array.isRequired,
    testId: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired
};

});


parcelRegister("hXnYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d12a8c92b47c6679$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $87IXO = parcelRequire("87IXO");

var $fb0st = parcelRequire("fb0st");

var $kUEQf = parcelRequire("kUEQf");

var $jGN5E = parcelRequire("jGN5E");
function $d12a8c92b47c6679$export$2e2bcd8739ae039({ data: data, getLabel: getLabel, message: message, reload: reload, setSceneData: setSceneData }) {
    (0, $kUEQf.useScene)('error', {
        data: data,
        setSceneData: setSceneData
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "trial__error",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jGN5E.default), {
                title: getLabel('error_heading'),
                subtitle: message
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                className: "error__image",
                src: data.visuals.error.full_url,
                alt: data.visuals.error.alt
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "error__message",
                dangerouslySetInnerHTML: {
                    __html: getLabel('error_content')
                }
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.PrimaryButton), {
                onClick: reload,
                testId: "nav-restart",
                children: getLabel('nav_btn_reset')
            })
        ]
    });
}
$d12a8c92b47c6679$export$2e2bcd8739ae039.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    message: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    reload: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    setSceneData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};

});

parcelRegister("eSSxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad6069524ee75ef1$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $87IXO = parcelRequire("87IXO");

var $fb0st = parcelRequire("fb0st");

var $jGN5E = parcelRequire("jGN5E");

var $7HGH5 = parcelRequire("7HGH5");
function $ad6069524ee75ef1$export$2e2bcd8739ae039({ apiRoutes: apiRoutes, forgetTrialSystem: forgetTrialSystem, getLabel: getLabel, reload: reload }) {
    const onCreateNewClick = ()=>{
        forgetTrialSystem();
        reload();
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "trial__existing-notification",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jGN5E.default), {
                title: getLabel('existing_trial_heading'),
                subtitle: getLabel('existing_trial_subtitle')
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "existing-notification__actions",
                children: [
                    apiRoutes.appLogin && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7HGH5.default), {
                        classes: [
                            'btn',
                            'btn--primary'
                        ],
                        href: apiRoutes.appLogin,
                        testId: "nav-continue",
                        children: getLabel('nav_btn_login')
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.default), {
                        onClick: onCreateNewClick,
                        testId: "nav-restart",
                        children: getLabel('nav_btn_create_new')
                    })
                ]
            })
        ]
    });
}
$ad6069524ee75ef1$export$2e2bcd8739ae039.propTypes = {
    apiRoutes: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    forgetTrialSystem: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    reload: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};

});
parcelRegister("7HGH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $59bdaab3a76d8f06$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $59bdaab3a76d8f06$export$2e2bcd8739ae039({ blank: blank = false, children: children, classes: classes = [], href: href = '', onClick: onClick = ()=>{}, small: small = false, testId: testId = '' }) {
    const props = {};
    // Classes
    const classNames = [
        'link',
        ...classes
    ];
    small && classNames.push('link--small');
    props.className = classNames.join(' ');
    if (testId) props['data-testid'] = testId;
    if (href) {
        props.href = href;
        props.target = blank ? '_blank' : '_self';
        if (blank) props.rel = 'noopener noreferrer';
    } else if (onClick) props.onClick = onClick;
    return href ? /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
        ...props,
        children: children
    }) : /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
        ...props,
        children: children
    });
}
$59bdaab3a76d8f06$export$2e2bcd8739ae039.propTypes = {
    blank: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    small: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    testId: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};

});


parcelRegister("dIr4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc4638bfaf8b4a0$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $a6jOw = parcelRequire("a6jOw");

var $fb0st = parcelRequire("fb0st");

var $Ko99d = parcelRequire("Ko99d");

var $jGN5E = parcelRequire("jGN5E");
function $9fc4638bfaf8b4a0$export$2e2bcd8739ae039({ data: data, getLabel: getLabel, predictedLoadTime: predictedLoadTime }) {
    const { message: message, transitionKey: transitionKey } = (0, $Ko99d.useLoading)(predictedLoadTime, getLabel);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "trial__loading",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jGN5E.default), {
                title: getLabel('loading_heading')
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                className: "loading__image",
                src: data.visuals.loading.full_url,
                alt: data.visuals.loading.alt
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a6jOw.motion).p, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                exit: {
                    opacity: 0
                },
                transition: {
                    duration: 1
                },
                children: message
            }, transitionKey)
        ]
    });
}
$9fc4638bfaf8b4a0$export$2e2bcd8739ae039.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    predictedLoadTime: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired
};

});
parcelRegister("Ko99d", function(module, exports) {

$parcel$export(module.exports, "useLoading", () => $08b706fe186c5bbe$export$1c72fe480f599e97);

var $8NFma = parcelRequire("8NFma");
function $08b706fe186c5bbe$export$1c72fe480f599e97(predictedLoadTime, getLabel) {
    const [, setCountdown] = (0, $8NFma.useState)(predictedLoadTime);
    const [message, setMessage] = (0, $8NFma.useState)();
    const [transitionKey, setTransitionKey] = (0, $8NFma.useState)('initial');
    const formatTime = (seconds)=>{
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };
    (0, $8NFma.useEffect)(()=>{
        let countdownInterval = setInterval(()=>{
            setCountdown((countdown)=>{
                if (countdown > 1) setMessage(`${getLabel('loading_countdown_running')} ${formatTime(countdown - 1)}s`);
                else {
                    setTransitionKey('finished');
                    setMessage(getLabel('loading_countdown_finished'));
                    clearInterval(countdownInterval);
                }
                return countdown - 1;
            });
        }, 1000);
        setMessage(`${getLabel('loading_countdown_running')} ${formatTime(predictedLoadTime)}s`);
        return ()=>clearInterval(countdownInterval);
    }, []);
    return {
        message: message,
        transitionKey: transitionKey
    };
}

});


parcelRegister("7FxWL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5956b1de3c538bfc$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $87IXO = parcelRequire("87IXO");

var $7fLF7 = parcelRequire("7fLF7");

var $fb0st = parcelRequire("fb0st");

var $lnJNM = parcelRequire("lnJNM");

var $kUEQf = parcelRequire("kUEQf");

var $d6hro = parcelRequire("d6hro");

var $6qzwS = parcelRequire("6qzwS");

var $jGN5E = parcelRequire("jGN5E");

var $lTbxr = parcelRequire("lTbxr");

var $lT1hd = parcelRequire("lT1hd");

var $3ZMdc = parcelRequire("3ZMdc");

var $h2AoD = parcelRequire("h2AoD");

var $2u0Nu = parcelRequire("2u0Nu");
function $5956b1de3c538bfc$export$2e2bcd8739ae039({ data: data, getLabel: getLabel, getRecaptchaToken: getRecaptchaToken, onFormSubmit: onFormSubmit, region: region, setSceneData: setSceneData, setError: setError, isMobile: isMobile }) {
    (0, $kUEQf.useScene)('registration', {
        data: data,
        setSceneData: setSceneData
    });
    const { registrationStep: registrationStep, formFields: formFields, fieldIsValid: fieldIsValid, getFieldErrorMessages: getFieldErrorMessages, handleFieldChange: handleFieldChange, nextStep: nextStep, previousStep: previousStep } = (0, $lnJNM.useRegistration)({
        data: data,
        getLabel: getLabel,
        onFormSubmit: onFormSubmit
    });
    const sharedFieldProps = {
        fieldIsValid: fieldIsValid,
        getFieldErrorMessages: getFieldErrorMessages,
        onChange: handleFieldChange,
        validation: undefined
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jGN5E.default), {
                keyProp: registrationStep.toString(),
                title: getLabel('registration_heading'),
                subtitle: registrationStep === 0 ? getLabel('registration_subtitle') : ''
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $d6hro.default), {
                step: registrationStep,
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $6qzwS.default), {
                    step: registrationStep,
                    children: [
                        registrationStep === 0 && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                            children: [
                                isMobile && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7fLF7.WarningInfobox), {
                                    small: true,
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                        children: getLabel('registration_mobile_previous_info')
                                    })
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $lT1hd.default), {
                                    getLabel: getLabel,
                                    getRecaptchaToken: getRecaptchaToken,
                                    locale: data.locale,
                                    region: region,
                                    setError: setError,
                                    ssoGoogleUrl: data.apiRoutes.ssoGoogle,
                                    ssoMicrosoftUrl: data.apiRoutes.ssoMicrosoft
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                    className: "form__separator h6",
                                    children: getLabel('registration_sso_spacer')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "form__fields",
                            children: formFields.filter((field)=>field.step === registrationStep).map((field)=>{
                                const props = {
                                    ...sharedFieldProps,
                                    ...field
                                };
                                switch(field.type){
                                    case 'switch':
                                        return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2u0Nu.default), {
                                            ...props
                                        }, field.name);
                                    case 'password':
                                        return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h2AoD.default), {
                                            ...props,
                                            getLabel: getLabel
                                        }, field.name);
                                    default:
                                        return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3ZMdc.default), {
                                            ...props,
                                            type: field.type
                                        }, field.name);
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $lTbxr.default), {
                keyProp: registrationStep.toString(),
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.PrimaryButton), {
                        onClick: nextStep,
                        testId: "nav-continue",
                        children: getLabel(registrationStep === 0 ? 'nav_btn_continue' : 'nav_btn_register')
                    }),
                    registrationStep > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.default), {
                        onClick: previousStep,
                        testId: "nav-back",
                        children: getLabel('nav_btn_back')
                    })
                ]
            })
        ]
    });
}
$5956b1de3c538bfc$export$2e2bcd8739ae039.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    getRecaptchaToken: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    isMobile: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired,
    onFormSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    region: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    setError: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    setSceneData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};

});
parcelRegister("7fLF7", function(module, exports) {

$parcel$export(module.exports, "WarningInfobox", () => $547ee7d8391af49b$export$d7ad1a1b05e972bd);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $547ee7d8391af49b$export$d7ad1a1b05e972bd(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)($547ee7d8391af49b$export$2e2bcd8739ae039, {
        ...props,
        warning: true
    });
}
function $547ee7d8391af49b$export$2e2bcd8739ae039({ children: children, warning: warning = false, small: small = false }) {
    const props = {};
    const classes = [
        'infobox'
    ];
    if (warning) classes.push('infobox--warning');
    if (small) classes.push('infobox--small');
    props.className = classes.join(' ');
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        ...props,
        children: children
    });
}
$547ee7d8391af49b$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node.isRequired,
    warning: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    small: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool
};

});

parcelRegister("lnJNM", function(module, exports) {

$parcel$export(module.exports, "useRegistration", () => $f90f46404ab122ec$export$2fe47346d26be56c);

var $8NFma = parcelRequire("8NFma");

var $ct3n1 = parcelRequire("ct3n1");

var $buJ37 = parcelRequire("buJ37");
const $f90f46404ab122ec$var$getDefaultFormFieldValue = (name)=>{
    if (name === 'email') {
        const url = new URL(window.location);
        if (url.searchParams.has('email')) return url.searchParams.get('email');
    }
    return '';
};
const $f90f46404ab122ec$export$2fe47346d26be56c = ({ data: data, getLabel: getLabel, onFormSubmit: onFormSubmit })=>{
    const errorMessageDelay = 1000;
    const errorMessageTimeouts = (0, $8NFma.useRef)({}); // key: field name, value: timeout id
    const [registrationStep, setRegistrationStep] = (0, $8NFma.useState)(0);
    const [formFields, setFormFields] = (0, $8NFma.useState)([
        {
            step: 0,
            label: getLabel('form_field_label_email'),
            name: 'email',
            type: 'email',
            required: true,
            value: $f90f46404ab122ec$var$getDefaultFormFieldValue('email'),
            validation: [
                {
                    callback: (0, $buJ37.isNotEmpty),
                    message: getLabel('form_field_error_empty')
                },
                {
                    callback: (0, $buJ37.isValidEmailFormat),
                    message: getLabel('form_field_error_email')
                },
                {
                    callback: (0, $buJ37.isEmailDomainAllowed),
                    message: getLabel('form_field_error_blacklisted')
                }
            ],
            visibleErrors: false,
            sendToHubspot: true
        },
        {
            step: 1,
            label: getLabel('form_field_label_first_name'),
            name: 'firstname',
            type: 'text',
            required: true,
            value: $f90f46404ab122ec$var$getDefaultFormFieldValue('firstname'),
            validation: [
                {
                    callback: (0, $buJ37.isNotEmpty),
                    message: getLabel('form_field_error_empty')
                }
            ],
            visibleErrors: false,
            sendToHubspot: true
        },
        {
            step: 1,
            label: getLabel('form_field_label_last_name'),
            name: 'lastname',
            type: 'text',
            required: true,
            value: $f90f46404ab122ec$var$getDefaultFormFieldValue('lastname'),
            validation: [
                {
                    callback: (0, $buJ37.isNotEmpty),
                    message: getLabel('form_field_error_empty')
                }
            ],
            visibleErrors: false,
            sendToHubspot: true
        },
        {
            step: 1,
            label: getLabel('form_field_label_phone'),
            name: 'phone',
            type: 'tel',
            required: false,
            value: $f90f46404ab122ec$var$getDefaultFormFieldValue('phone'),
            visibleErrors: false,
            sendToHubspot: true
        },
        {
            step: 1,
            label: getLabel('form_field_label_password'),
            name: 'password',
            type: 'password',
            required: true,
            value: $f90f46404ab122ec$var$getDefaultFormFieldValue('password'),
            validation: [
                {
                    callback: (0, $buJ37.hasMinimumPasswordLength),
                    directive: getLabel('password_need_length'),
                    message: getLabel('form_field_error_invalid')
                },
                {
                    callback: (0, $buJ37.hasLowerCaseCharacter),
                    directive: getLabel('password_need_lowercase'),
                    message: getLabel('form_field_error_invalid')
                },
                {
                    callback: (0, $buJ37.hasUpperCaseCharacter),
                    directive: getLabel('password_need_uppercase'),
                    message: getLabel('form_field_error_invalid')
                }
            ],
            visibleErrors: false,
            sendToHubspot: false
        },
        {
            step: 1,
            label: getLabel('registration_consent_text'),
            name: 'tosConsentText',
            type: 'switch',
            required: true,
            value: (0, $ct3n1.stripHtmlTags)(getLabel('registration_consent_text')),
            checked: false,
            validation: [
                {
                    callback: (0, $buJ37.isChecked),
                    message: getLabel('form_field_error_checkbox')
                }
            ],
            visibleErrors: false,
            sendToHubspot: false
        }
    ]);
    const getFormData = ()=>{
        return formFields.reduce((data, field)=>{
            data[field.name] = field.value;
            return data;
        }, {});
    };
    const getHubspotFormData = ()=>{
        return formFields.reduce((data, field)=>{
            if (field?.sendToHubspot !== true) return data;
            data.push({
                name: field.name,
                value: field.value
            });
            return data;
        }, []);
    };
    // --- Validation ---
    const getFieldErrorMessages = (0, $8NFma.useCallback)((name)=>{
        const field = formFields.find((field)=>field.name === name);
        if (!field || !field.validation) return [];
        return field.validation.reduce((messages, { callback: callback, message: message })=>{
            if (!callback({
                checked: field?.checked,
                value: field.value,
                blacklist: data.blacklist
            })) messages.push(message);
            return messages;
        }, []);
    }, [
        formFields,
        data.blacklist
    ]);
    const fieldIsValid = (0, $8NFma.useCallback)((name)=>{
        const field = formFields.find((field)=>field.name === name);
        if (!field || !field.validation) return true;
        return field.validation.every(({ callback: callback })=>callback({
                checked: field?.checked,
                value: field.value,
                blacklist: data.blacklist
            }));
    }, [
        formFields,
        data.blacklist
    ]);
    const currentStepFieldsAreValid = (0, $8NFma.useCallback)(()=>{
        const currentStepFields = formFields.filter((field)=>field.step === registrationStep);
        return currentStepFields.every((field)=>{
            if (!field.validation) return true;
            return fieldIsValid(field.name);
        });
    }, [
        formFields,
        registrationStep,
        fieldIsValid
    ]);
    // --- Navigation ---
    const stepHasFields = (0, $8NFma.useCallback)((step)=>formFields.some((field)=>field.step === step), [
        formFields
    ]);
    const nextStep = (0, $8NFma.useCallback)(()=>{
        if (currentStepFieldsAreValid()) {
            if (stepHasFields(registrationStep + 1)) // If the next step has fields, just increment the step
            setRegistrationStep((prevStep)=>prevStep + 1);
            else onFormSubmit({
                getFormData: getFormData,
                getHubspotFormData: getHubspotFormData
            });
        } else // Set visible errors for all fields in the current step
        setFormFields((prevFields)=>prevFields.map((field)=>field.step === registrationStep ? {
                    ...field,
                    visibleErrors: true
                } : field));
    }, [
        currentStepFieldsAreValid
    ]);
    const previousStep = (0, $8NFma.useCallback)(()=>{
        setRegistrationStep((prevStep)=>prevStep > 0 ? prevStep - 1 : 0);
    }, []);
    // --- Field Change Handler ---
    const handleFieldChange = (0, $8NFma.useCallback)((event)=>{
        const { name: name, value: value, type: type, checked: checked } = event.target;
        // Clear previous timeout for this field only
        if (errorMessageTimeouts.current[name]) clearTimeout(errorMessageTimeouts.current[name]);
        // Immediately hide errors when user starts typing
        setFormFields((prevFields)=>prevFields.map((field)=>field.name === name ? {
                    ...field,
                    value: value,
                    visibleErrors: false,
                    ...type === 'checkbox' ? {
                        checked: checked
                    } : {}
                } : field));
        // Start a timeout to show errors after delay (for this field only)
        errorMessageTimeouts.current[name] = setTimeout(()=>{
            setFormFields((prevFields)=>prevFields.map((field)=>field.name === name ? {
                        ...field,
                        visibleErrors: true
                    } : field));
        }, errorMessageDelay);
    }, [
        errorMessageDelay
    ]);
    // --- Cleanup: clear all timeouts on unmount ---
    (0, $8NFma.useEffect)(()=>{
        return ()=>{
            Object.values(errorMessageTimeouts.current).forEach(clearTimeout);
        };
    }, []);
    return {
        registrationStep: registrationStep,
        formFields: formFields,
        fieldIsValid: fieldIsValid,
        getFieldErrorMessages: getFieldErrorMessages,
        handleFieldChange: handleFieldChange,
        nextStep: nextStep,
        previousStep: previousStep
    };
};

});

parcelRegister("d6hro", function(module, exports) {

$parcel$export(module.exports, "default", () => $98995d44128da13b$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $98995d44128da13b$export$2e2bcd8739ae039({ children: children, step: step }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "trial__form",
        "data-step": step,
        children: children
    });
}
$98995d44128da13b$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node,
    step: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired
};

});

parcelRegister("6qzwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae0bb2622d4d89e$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $ezc60 = parcelRequire("ezc60");
var $a6jOw = parcelRequire("a6jOw");

var $fb0st = parcelRequire("fb0st");
function $4ae0bb2622d4d89e$export$2e2bcd8739ae039({ children: children, step: step }) {
    const isFirstStep = step === 0;
    const animationProps = {
        opacity: 0,
        transform: isFirstStep ? 'translateX(-100%)' : 'translateX(100%)'
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ezc60.AnimatePresence), {
        initial: false,
        mode: "popLayout",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a6jOw.motion).div, {
            className: "form__content",
            initial: animationProps,
            animate: {
                opacity: 1,
                transform: 'translateX(0%)'
            },
            exit: animationProps,
            transition: {
                duration: 0.375,
                ease: 'easeInOut'
            },
            children: children
        }, step)
    });
}
$4ae0bb2622d4d89e$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node,
    step: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number.isRequired
};

});

parcelRegister("lTbxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef7af4ca5e80e16$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $ezc60 = parcelRequire("ezc60");
var $a6jOw = parcelRequire("a6jOw");

var $fb0st = parcelRequire("fb0st");
function $fef7af4ca5e80e16$export$2e2bcd8739ae039({ children: children, keyProp: keyProp }) {
    const animationInitialProps = {
        opacity: 0
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ezc60.AnimatePresence), {
        initial: false,
        mode: "wait",
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a6jOw.motion).nav, {
            className: "trial__navigation",
            initial: animationInitialProps,
            animate: {
                opacity: 1
            },
            exit: animationInitialProps,
            transition: {
                duration: 0.1875
            },
            children: children
        }, keyProp)
    });
}
$fef7af4ca5e80e16$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).node.isRequired,
    keyProp: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired
};

});

parcelRegister("lT1hd", function(module, exports) {

$parcel$export(module.exports, "default", () => $feefb99132238cff$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $87IXO = parcelRequire("87IXO");

var $fb0st = parcelRequire("fb0st");

var $4XgkP = parcelRequire("4XgkP");

var $ct3n1 = parcelRequire("ct3n1");
function $feefb99132238cff$export$2e2bcd8739ae039({ getLabel: getLabel, getRecaptchaToken: getRecaptchaToken, locale: locale, region: region, setError: setError, ssoGoogleUrl: ssoGoogleUrl, ssoMicrosoftUrl: ssoMicrosoftUrl }) {
    const { onGoogleSsoClick: onGoogleSsoClick, onMicrosoftSsoClick: onMicrosoftSsoClick } = (0, $4XgkP.useSso)({
        consentText: (0, $ct3n1.stripHtmlTags)(getLabel('registration_consent_text')),
        getRecaptchaToken: getRecaptchaToken,
        locale: locale,
        region: region,
        setError: setError,
        ssoGoogleUrl: ssoGoogleUrl,
        ssoMicrosoftUrl: ssoMicrosoftUrl
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: "trial__sso",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.default), {
                testId: "sso-google",
                sso: true,
                ssoId: "google",
                onClick: onGoogleSsoClick,
                children: getLabel('registration_sso_button_google')
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $87IXO.default), {
                testId: "sso-microsoft",
                sso: true,
                ssoId: "microsoft",
                onClick: onMicrosoftSsoClick,
                children: getLabel('registration_sso_button_microsoft')
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                className: "sso-consent-text",
                dangerouslySetInnerHTML: {
                    __html: getLabel('registration_consent_text')
                }
            })
        ]
    });
}
$feefb99132238cff$export$2e2bcd8739ae039.propTypes = {
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    getRecaptchaToken: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    region: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    setError: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    ssoGoogleUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    ssoMicrosoftUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};

});
parcelRegister("4XgkP", function(module, exports) {

$parcel$export(module.exports, "useSso", () => $39b957e686ea603a$export$d8aa287a7329494b);

var $8NFma = parcelRequire("8NFma");

var $ch3jL = parcelRequire("ch3jL");

var $fBiHk = parcelRequire("fBiHk");

var $83l5B = parcelRequire("83l5B");
const $39b957e686ea603a$export$d8aa287a7329494b = ({ consentText: consentText, getRecaptchaToken: getRecaptchaToken, locale: locale, region: region, setError: setError, ssoGoogleUrl: ssoGoogleUrl, ssoMicrosoftUrl: ssoMicrosoftUrl })=>{
    (0, $8NFma.useEffect)(()=>{
        const errorUrlParameter = (0, $83l5B.consumeSearchParam)('error');
        if (errorUrlParameter) // Set error based on the URL parameter
        // If the error is 'email_not_verified', we set a specific error message
        setError(errorUrlParameter === 'email_not_verified' ? `sso_${errorUrlParameter}` : 'sso_general');
    }, []);
    const redirectToSsoUrl = async (url)=>{
        const params = {
            locale: locale,
            region: region,
            tosConsentText: consentText,
            systemName: (0, $ch3jL.generateSystemName)()
        };
        if ((0, $fBiHk.getGoogleAnalyticsClientId)()) params.gaClientId = (0, $fBiHk.getGoogleAnalyticsClientId)();
        try {
            params.reCaptchaCode = await getRecaptchaToken();
        } catch (error) {
            console.error(error);
        }
        const urlParams = Object.keys(params).map((key)=>`${key}=${encodeURIComponent(params[key])}`).join('&');
        window.location.assign(`${url}?${urlParams}`);
    };
    const onGoogleSsoClick = ()=>redirectToSsoUrl(ssoGoogleUrl);
    const onMicrosoftSsoClick = ()=>redirectToSsoUrl(ssoMicrosoftUrl);
    return {
        onGoogleSsoClick: onGoogleSsoClick,
        onMicrosoftSsoClick: onMicrosoftSsoClick
    };
};

});


parcelRegister("h2AoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67edb1fc79b4cbc$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $3ZMdc = parcelRequire("3ZMdc");
const $c67edb1fc79b4cbc$var$PasswordVisibilityToggle = ({ getLabel: getLabel, showPassword: showPassword, togglePassword: togglePassword })=>{
    const title = getLabel(showPassword ? 'password_toggle_hide' : 'password_toggle_show');
    return /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
        "data-testid": "showPassword",
        className: "password__visibility-toggle",
        onClick: togglePassword,
        "aria-label": title,
        title: title,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
            "aria-hidden": "true",
            children: showPassword ? 'visibility_off' : 'visibility'
        })
    });
};
const $c67edb1fc79b4cbc$var$PasswordDirective = ({ checked: checked = false, label: label })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: `password__directive${checked ? ' password__directive--checked' : ''}`,
        children: label
    });
};
function $c67edb1fc79b4cbc$export$2e2bcd8739ae039({ fieldIsValid: fieldIsValid, getFieldErrorMessages: getFieldErrorMessages, getLabel: getLabel, label: label, name: name, onChange: onChange, required: required, validation: validation, value: value, visibleErrors: visibleErrors }) {
    const [showPassword, setShowPassword] = (0, $8NFma.useState)(false);
    const togglePassword = ()=>setShowPassword(!showPassword);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("fieldset", {
        className: "password-field",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3ZMdc.default), {
                fieldIsValid: fieldIsValid,
                getFieldErrorMessages: getFieldErrorMessages,
                label: label,
                name: name,
                onChange: onChange,
                required: required,
                type: showPassword ? 'text' : 'password',
                visibleErrors: visibleErrors,
                value: value,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)($c67edb1fc79b4cbc$var$PasswordVisibilityToggle, {
                    showPassword: showPassword,
                    togglePassword: togglePassword,
                    getLabel: getLabel
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "password__directives",
                children: validation.map(({ callback: callback, directive: directive }, index)=>{
                    return /*#__PURE__*/ (0, $1IdZj.jsx)($c67edb1fc79b4cbc$var$PasswordDirective, {
                        checked: callback({
                            value: value
                        }),
                        label: directive
                    }, index);
                })
            })
        ]
    });
}
$c67edb1fc79b4cbc$export$2e2bcd8739ae039.propTypes = {
    fieldIsValid: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    getFieldErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    required: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    validation: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    visibleErrors: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired
};
$c67edb1fc79b4cbc$var$PasswordDirective.propTypes = {
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired
};
$c67edb1fc79b4cbc$var$PasswordVisibilityToggle.propTypes = {
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    showPassword: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    togglePassword: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func
};

});

parcelRegister("2u0Nu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cef006e388ef8a2$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $1cef006e388ef8a2$export$2e2bcd8739ae039({ checked: checked, fieldIsValid: fieldIsValid, label: label, name: name, onChange: onChange, required: required, value: value, visibleErrors: visibleErrors }) {
    const inputAttributes = {
        checked: checked,
        id: name,
        name: name,
        onChange: onChange,
        role: 'switch',
        type: 'checkbox',
        value: value
    };
    required && (inputAttributes.required = 'required');
    const formFieldClasses = [
        'form-field'
    ];
    if (!fieldIsValid(name) && visibleErrors) formFieldClasses.push('form-field--error');
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "form-field-wrapper",
        "data-field-name": inputAttributes.name,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: formFieldClasses.join(' '),
            "data-field-type": "switch",
            "data-field-name": inputAttributes.name,
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "form-binary-input",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        ...inputAttributes
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                        htmlFor: inputAttributes.name,
                        dangerouslySetInnerHTML: {
                            __html: label
                        }
                    })
                ]
            })
        })
    });
}
$1cef006e388ef8a2$export$2e2bcd8739ae039.propTypes = {
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired,
    fieldIsValid: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    required: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number
    ]).isRequired,
    visibleErrors: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired
};

});


parcelRegister("kQJD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2dc0f1164c82570$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $kUEQf = parcelRequire("kUEQf");

var $jGN5E = parcelRequire("jGN5E");

var $7HGH5 = parcelRequire("7HGH5");
function $f2dc0f1164c82570$var$Envelope() {
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        className: "trial__envelope",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 81 55",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("g", {
                    clipPath: "url(#trial-envelope-clip-path)",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("rect", {
                            width: "81",
                            height: "55",
                            fill: "#EEEEF9",
                            rx: "8"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("rect", {
                            width: "70.598",
                            height: "70.598",
                            fill: "#F6F6FC",
                            rx: "4",
                            transform: "scale(1.0034 .9966) rotate(-45 -16.317 6.757)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("clipPath", {
                        id: "trial-envelope-clip-path",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("rect", {
                            width: "81",
                            height: "55",
                            fill: "#fff",
                            rx: "8"
                        })
                    })
                })
            ]
        })
    });
}
function $f2dc0f1164c82570$var$SwitchToDesktop() {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("svg", {
        width: "361",
        height: "106",
        viewBox: "0 0 361 106",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                d: "M318.736 1C324.703 1.00005 329.54 5.83857 329.54 11.8076V91.043C329.54 91.4346 329.518 91.8213 329.478 92.2021H339.902C343.5 92.2023 346.417 95.1201 346.417 98.7197V98.7236C346.417 102.323 343.5 105.241 339.902 105.241H177.516C173.917 105.241 171 102.323 171 98.7236V98.7197C171 95.1201 173.917 92.2024 177.516 92.2021H187.94C187.899 91.8213 187.877 91.4346 187.877 91.043V11.8076C187.877 5.83858 192.715 1.00006 198.682 1H318.736ZM198.682 5.69434C195.307 5.6944 192.57 8.43125 192.57 11.8076V91.043C192.57 91.4394 192.61 91.8267 192.682 92.2021H324.737C324.809 91.8268 324.848 91.4394 324.848 91.043V11.8076C324.848 8.43124 322.111 5.69438 318.736 5.69434H198.682Z",
                fill: "#8487D6"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                d: "M65.3526 88.3279C66.6425 88.3279 67.6882 87.2816 67.6882 85.9913V30.9218C67.6881 29.6316 66.6425 28.5856 65.3526 28.5856H38.1549C36.865 28.5856 35.819 29.6315 35.819 30.9218V85.9913C35.819 87.2816 36.8649 88.3279 38.1549 88.3279H65.3526ZM38.1549 93.0224C34.2731 93.0224 31.126 89.8743 31.126 85.9913V30.9218C31.126 27.0389 34.2731 23.8911 38.1549 23.8911H65.3526C69.2343 23.8912 72.3811 27.0389 72.3812 30.9218V85.9913C72.3812 89.8743 69.2344 93.0223 65.3526 93.0224H38.1549Z",
                fill: "#8487D6"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                d: "M51.9448 85.6917C53.6395 85.6917 55.0133 84.3174 55.0133 82.6222C55.0133 80.927 53.6395 79.5528 51.9448 79.5528C50.2501 79.5528 48.8763 80.927 48.8763 82.6222C48.8763 84.3174 50.2501 85.6917 51.9448 85.6917Z",
                fill: "#8487D6"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
                d: "M127.751 40.9251C129.253 39.4225 131.66 39.3756 133.219 40.7845L133.367 40.9251L148.871 56.4339L133.367 71.9466C131.817 73.4981 129.302 73.4986 127.751 71.9476C126.2 70.3966 126.201 67.8818 127.751 66.3304L133.533 60.5443H108.289C106.096 60.5441 104.318 58.7653 104.318 56.5716C104.318 54.3779 106.096 52.6001 108.289 52.5999H133.806L127.751 46.5433L127.61 46.3948C126.202 44.8355 126.249 42.4279 127.751 40.9251Z",
                fill: "#5053C4"
            })
        ]
    });
}
function $f2dc0f1164c82570$export$2e2bcd8739ae039({ data: data, emailAddress: emailAddress, getLabel: getLabel, isMobile: isMobile, reload: reload, resendActivationEmail: resendActivationEmail, setSceneData: setSceneData }) {
    (0, $kUEQf.useScene)(isMobile ? 'mobile_verification' : 'verification', {
        data: data,
        setSceneData: setSceneData
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $jGN5E.default), {
                title: getLabel(isMobile ? 'verification_mobile_heading' : 'verification_heading'),
                subtitle: getLabel(isMobile ? 'verification_mobile_subtitle' : 'verification_subtitle')
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "trial__verification",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "verification__illustration",
                        children: isMobile ? /*#__PURE__*/ (0, $1IdZj.jsx)($f2dc0f1164c82570$var$SwitchToDesktop, {}) : /*#__PURE__*/ (0, $1IdZj.jsx)($f2dc0f1164c82570$var$Envelope, {})
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "verification__notice",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                className: "text-subline text-subline--sm",
                                children: getLabel('verification_email_notice')
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                className: "h5",
                                children: emailAddress
                            }),
                            !isMobile && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7HGH5.default), {
                                onClick: reload,
                                testId: "nav-restart",
                                children: getLabel('verification_link_restart')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "verification__meta",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                        children: getLabel('verification_title_request_new')
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                        children: getLabel('verification_text_request_new')
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("small", {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7HGH5.default), {
                                            small: true,
                                            onClick: resendActivationEmail,
                                            testId: "resend-activation-email",
                                            children: getLabel('verification_link_request_new')
                                        })
                                    })
                                ]
                            }),
                            data.pages.contact && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                        children: getLabel('verification_title_contact')
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                        children: getLabel('verification_text_contact')
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("small", {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7HGH5.default), {
                                            href: data.pages.contact,
                                            testId: "visit-contact-page",
                                            children: getLabel('verification_link_contact')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$f2dc0f1164c82570$export$2e2bcd8739ae039.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object.isRequired,
    emailAddress: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string.isRequired,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    isMobile: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool.isRequired,
    reload: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    resendActivationEmail: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired,
    setSceneData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func.isRequired
};

});



var $1IdZj = parcelRequire("1IdZj");

var $6T1J1 = parcelRequire("6T1J1");

var $1C3B7 = parcelRequire("1C3B7");
const $f3543fa1ea6b4f2c$var$el = document.querySelector('#trial');
if ($f3543fa1ea6b4f2c$var$el) {
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($6T1J1))).createRoot($f3543fa1ea6b4f2c$var$el);
    root.render(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $1C3B7.default), {
        dataUrl: $f3543fa1ea6b4f2c$var$el.getAttribute('data-rest-url'),
        isMobile: $f3543fa1ea6b4f2c$var$el.getAttribute('data-mobile') === '1'
    }));
}

})();
//# sourceMappingURL=trial-app.min.js.map
